{
  "app": {
    "brand": {
      "name": "घरबाटी फाइनान्स"
    },
    "starting": {
      "title": "सुरु गर्दै",
      "description": "तपाईंको सत्र सेटअप गर्दै"
    },
    "error": {
      "title": "अनुप्रयोग त्रुटि",
      "description": "अप्रत्याशित त्रुटि भयो। जारी राख्न पृष्ठ रिफ्रेस गर्नुहोस्।",
      "retryLabel": "पृष्ठ रिफ्रेस गर्नुहोस्"
    }
  },
  "admin": {
    "title": "प्रशासक",
    "organizationAccessInspector": {
      "title": "संगठन पहुँच निरीक्षक",
      "identity": "पहिचान सन्दर्भ",
      "delegation": "प्रतिनिधि पहुँच",
      "permissions": "अनुमतिहरू",
      "modules": "सक्रिय मोड्युलहरू",
      "accounts": "खाता दायरा",
      "policy": "पर्सोना नीति",
      "subject": "विषय"
    },
    "inspector": {
      "persona": "पर्सोना",
      "organizationId": "संगठन आईडी",
      "branchId": "शाखा आईडी",
      "scopeKind": "दायरा",
      "delegated": "प्रतिनिधि",
      "delegationId": "प्रतिनिधि आईडी",
      "delegationTarget": "प्रतिनिधि लक्ष्य संगठन",
      "permissions": "अनुमतिहरू",
      "enabledModules": "सक्रिय मोड्युलहरू",
      "clientAccountId": "ग्राहक खाता आईडी",
      "portfolioAccountId": "पोर्टफोलियो खाता आईडी",
      "personaPolicy": "पर्सोना नीति",
      "subjectUserId": "विषय प्रयोगकर्ता आईडी",
      "subjectEmail": "विषय इमेल",
      "subjectName": "विषय नाम",
      "subjectMfa": "MFA सक्रिय",
      "subjectRoles": "तोकिएका भूमिकाहरू"
    },
    "overview": {
      "title": "विहंग",
      "description": "प्रशासक विहंग",
      "errorTitle": "त्रुटि"
    },
    "admin-users": {
      "metrics": {
        "totalUsers": "कुल प्रयोगकर्ताहरू",
        "activeUsers": "सक्रिय प्रयोगकर्ताहरू",
        "pendingUsers": "अप्रत्याशित प्रयोगकर्ता",
        "suspendedUsers": "निलम्बित प्रयोगकर्ता"
      }
    },
    "admin-roles": {
      "metrics": {
        "totalRoles": "कुल भूमिकाहरू",
        "activeRoles": "सक्रिय भूमिकाहरू",
        "pendingRoles": "अप्रत्याशित भूमिकाहरू",
        "suspendedRoles": "निलंबित भूमिकाहरू"
      }
    },
    "governance": {
      "users": {
        "title": "प्रयोगकर्ताहरू",
        "description": "प्रयोगकर्ताहरू, खाता स्थिति, र भूमिका असाइनमेन्ट व्यवस्थापन गर्नुहोस्",
        "actions": {
          "create": "सिर्जना",
          "createDesc": "सिर्जना",
          "edit": "सम्पादन गर्नुहोस्",
          "editDesc": "सम्पादन गर्नुहोस्",
          "delete": "मेटाउनुहोस्",
          "deleteDesc": "मेटाउनुहोस्",
          "assignRole": "भूमिका दिनुहोस्",
          "assignRoleDesc": "कुनै प्रयोगकर्तालाई भूमिका दिनुहोस्",
          "assignScope": "व्यापक अधिकार प्रदान गर्नुहोस्",
          "assignScopeDesc": "कुनै प्रयोगकर्तालाई विस्तृत अधिकार दिनुहोस्"
        }
      },
      "roles": {
        "title": "भूमिकाहरू",
        "description": "असाइन गर्न मिल्ने भूमिकाहरू र अनुमति सिमाना परिभाषित गर्नुहोस्",
        "actions": {
          "create": "सिर्जना",
          "createDesc": "सिर्जना",
          "editPermissions": "अधिकार परिमार्जन गर्नुहोस्",
          "editPermissionsDesc": "अधिकार परिमार्जन गर्नुहोस्",
          "delete": "मेटाउनुहोस्",
          "deleteDesc": "मेटाउनुहोस्"
        }
      },
      "approvalsQueue": {
        "title": "कारोबार अनुमोदन शासन",
        "description": "विचाराधीन लगानी कारोबार अनुमोदनहरू, अपवाद निर्णयहरू, र एस्केलेसन नतिजाहरू समीक्षा गर्नुहोस्।"
      },
      "organization": {
        "title": "संगठन",
        "description": "संगठन सेटिङ्स र कन्फिगरेसन व्यवस्थापन गर्नुहोस्",
        "organizationSettings": {
          "loadingSettings": "सेटिङहरू लोड हुँदैछ",
          "failedToLoad": "सेटिङहरू लोड गर्न विफल",
          "orgInfo": "संगठन जानकारी",
          "modules": "मोड्युलहरू",
          "orgInformation": "संगठन जानकारी",
          "name": "नाम",
          "code": "कोड",
          "codeReadOnly": "कोड (पढ्न मात्र)",
          "panNumber": "प्यान नम्बर",
          "vatNumber": "भ्याट नम्बर",
          "email": "इमेल",
          "phone": "फोन",
          "address": "गल्ली ठेगाना",
          "fiscalYearStart": "आर्थिक वर्ष सुरु",
          "notProvided": "प्रदान गरिएको छैन",
          "notConfigured": "निर्दिष्ट गरिएको छैन",
          "saving": "सेभ गर्दैछ...",
          "saveChanges": "परिवर्तनहरू सेभ गर्नुहोस्"
        },
        "actions": {
          "save": "सेभ गर्नुहोस्",
          "saveDesc": "सेभ गर्नुहोस्"
        },
        "saveSuccess": "संगठन सफलतापूर्वक सुरक्षित गरियो"
      },
      "modules": {
        "title": "मोड्युलहरू",
        "description": "मोड्युल सदस्यता र टियर क्षमताहरू व्यवस्थापन गर्नुहोस्"
      },
      "audit": {
        "title": "अडिट",
        "description": "प्रणाली परिवर्तन इतिहास र अडिट ट्रेलहरू समीक्षा गर्नुहोस्",
        "lineageView": {
          "title": "अडिट वंशावली"
        }
      },
      "permissionBundles": {
        "title": "अनुमति बन्डलहरू",
        "description": "भूमिका असाइनमेन्टका लागि पुन:प्रयोग योग्य अनुमति बन्डलहरू व्यवस्थापन गर्नुहोस्",
        "selectPermission": "अनुमति छान्नुहोस्",
        "selectRole": "भूमिका छान्नुहोस्",
        "noAvailablePermissions": "कोई अनुमतिहरू उपलब्ध छैन छं",
        "noAvailableRoles": "कोई भूमिकाहरू उपलब्ध छैन छं",
        "addPermission": "अनुमति थप्नुहोस्",
        "assignRole": "भूमिका सौंपना",
        "noPermissionsAssigned": "कोई अनुमतिहरू सौंपी गई छैनन्",
        "noRolesAssigned": "कोई भूमिकाहरू सौंपी गई छैनन्",
        "permissionList": "सौंपी गई अनुमतिहरू",
        "roleList": "सौंपी गई भूमिकाहरू",
        "loadError": "अनुमति बंडल को लोड गर्न विफल रहा",
        "createError": "अनुमति बंडल को बनाने मा विफल रहा",
        "deleteError": "अनुमति बंडल को हटाने मा विफल रहा",
        "approveError": "अपवादी अनुमति पैक को स्वीकार करने मा विफल हुआ",
        "rejectError": "अनुमति पैक को अस्वीकार करने मा विफल हुआ",
        "addPermissionError": "अनुमति पैक मा अनुमति जोड़ने मा विफल हुआ",
        "removePermissionError": "अनुमति पैक से अनुमति हटाने मा विफल हुआ",
        "assignRoleError": "अनुमति पैक को रोल से जोड़ने मा विफल हुआ",
        "removeRoleError": "अनुमति पैक को रोल से हटाने मा विफल हुआ",
        "actions": {
          "create": "सिर्जना",
          "createDesc": "सिर्जना",
          "delete": "मेटाउनुहोस्",
          "deleteDesc": "मेटाउनुहोस्"
        }
      },
      "accessInspector": {
        "title": "पहुँच निरीक्षक",
        "description": "पहुँच नियन्त्रण नीतिहरू निरीक्षण र प्रमाणिकरण गर्नुहोस्"
      },
      "clientAccounts": {
        "title": "ग्राहक खाताहरू",
        "description": "ग्राहक खाताको स्वामित्व, पहुँच असाइनमेन्ट, र प्रतिनिधि प्रशासन व्यवस्थापन गर्नुहोस्।",
        "actions": {
          "create": "सिर्जना",
          "createDesc": "नयाँ ग्राहक खाता बनाउनुहोस्",
          "update": "अद्यावधिक गर्नुहोस्",
          "updateDesc": "ग्राहक खाताको जानकारी अद्यावधिक गर्नुहोस्",
          "activate": "खाता सक्रिय गर्नुहोस्",
          "activateDesc": "यो ग्राहक खाता सक्रिय गर्नुहोस्",
          "deactivate": "खाता निष्क्रिय गर्नुहोस्",
          "deactivateDesc": "यो ग्राहक खाता निष्क्रिय गर्नुहोस्",
          "close": "बन्द",
          "closeDesc": "यो ग्राहक खाता बन्द गर्नुहोस्",
          "kycVerify": "KYC प्रमाणित गर्नुहोस्",
          "kycVerifyDesc": "KYC सत्यापित भएको चिह्न लगाउनुहोस्",
          "kycReject": "KYC अस्वीकार गर्नुहोस्",
          "kycRejectDesc": "KYC सत्यापन अस्वीकार गर्नुहोस्",
          "kycReset": "KYC रिसेट गर्नुहोस्",
          "kycResetDesc": "KYC प्रतीक्षामा सेट गर्नुहोस्",
          "kycExpire": "KYC समाप्त गर्नुहोस्",
          "kycExpireDesc": "KYC म्याद सकिएको चिह्न लगाउनुहोस्"
        }
      },
      "clientAdministration": {
        "title": "ग्राहक प्रशासन",
        "description": "ग्राहक खाताको स्वामित्व, पहुँच असाइनमेन्ट, र प्रतिनिधि प्रशासन व्यवस्थापन गर्नुहोस्।"
      },
      "system": {
        "title": "प्रणाली",
        "description": "प्रणाली प्रशासन र डाटा सञ्चालनहरू"
      },
      "systemPosture": {
        "title": "प्रणाली अवस्था",
        "description": "शाखा स्वास्थ्य, डाटा सञ्चालन, र प्लेटफर्म सुरक्षा अवस्थाको निगरानी गर्नुहोस्"
      },
      "context": {
        "title": "शासन कार्यक्षेत्र सन्दर्भ",
        "subtitle": "पहिले अनुमोदनहरू समीक्षा गर्नुहोस्, त्यसपछि प्रयोगकर्ताहरू, भूमिकाहरू, र मोड्युलहरू समायोजन गर्नुहोस्।",
        "pendingApprovals": "{{count}} अनुमोदन(हरू) बाँकी। अडिट ट्रेसेबिलिटी कायम राख्न भूमिका वा मोड्युलहरू परिवर्तन गर्नुअघि यिनीहरू समाधान गर्नुहोस्।",
        "pendingApprovalsLoading": "अपवाद अनुमतिहरू लोड हुँदैछ...",
        "pendingApprovalsUnavailable": "अपवाद अनुमतिहरू अस्थायी रूपमा उपलब्ध छैनन्। स्थिति जाँच गर्न अनुमोदन पङ्क्तिमा जानुहोस्।",
        "sequence": "सक्रिय अनुमोदनहरू समाधान गरेपछि मात्र मोड्युल र भूमिका परिवर्तनहरू लागू गर्नुहोस्।"
      },
      "attention": {
        "title": "शासन कार्य आवश्यक",
        "pendingApprovals": "{{count}} अनुमोदन(हरू) बाँकी",
        "pendingApprovalsSingle": "१ अनुमोदन बाँकी",
        "pendingApprovalsPlural": "{{count}} अनुमोदनहरू बाँकी",
        "reviewAction": "अनुमोदनहरू समीक्षा गर्नुहोस्"
      },
      "snapshot": {
        "pendingApprovals": "विचाराधीन अनुमोदन",
        "syncState": "सिङ्क स्थिति",
        "pendingApprovalsDesc": "प्रतीक्षारत अपवाद अनुमति अनुरोधहरू"
      },
      "noAccess": "कुनै पहुँच छैन",
      "peopleAccess": {
        "title": "लोगों तक पहुंच"
      },
      "approvals": {
        "actions": {
          "approve": "अनुमोदन गर्नुहोस्",
          "approveDesc": "अनुमोदन गर्नुहोस्",
          "reject": "अस्वीकार गर्नुहोस्",
          "rejectDesc": "अस्वीकार गर्नुहोस्"
        }
      }
    },
    "system": {
      "title": "प्रणाली अवस्था",
      "description": "प्रणाली प्रशासन, अवस्था निगरानी, र डाटा सञ्चालनहरू",
      "refresh": "रिफ्रेस",
      "dataOperationsTitle": "डाटा सञ्चालनहरू",
      "dataOperationsDescription": "प्रणाली डाटा सञ्चालनहरू व्यवस्थापन गर्नुहोस्",
      "dataOperationsNote": "डाटा आयात र सञ्चालनहरूका लागि डाटा हब प्रयोग गर्नुहोस्।",
      "dataOperationsAction": "डाटा हब खोल्नुहोस्",
      "health": "प्रणाली स्वास्थ्य",
      "backendApi": "ब्याकएन्ड API",
      "unknown": "अज्ञात",
      "database": "डाटाबेस",
      "unavailable": "अनुपलब्ध",
      "connected": "जडान भयो",
      "initialization": "सुरुवात",
      "ready": "तयार",
      "bootstrapPending": "बुटस्ट्र्याप विचाराधीन",
      "currentUser": "हालको प्रयोगकर्ता",
      "operatorAccounts": "अपरेटर खाताहरू",
      "refreshStatus": "स्थिति रिफ्रेस गर्नुहोस्",
      "errorTitle": "त्रुटि",
      "errorDescription": "अपेक्षित रूपमा प्राप्त गर्न असफल भयो। पुन: प्रयास गर्नुहोस्।",
      "checks": {
        "database": {
          "label": "डाटाबेस",
          "healthy": "डेटाबेस स्वस्थ",
          "critical": "डेटाबेस कनेक्शन असफल",
          "unknown": "डेटाबेस स्थिति अनजान"
        },
        "cache": {
          "label": "कैश",
          "healthy": "कैश स्वस्थ",
          "unknown": "कैश स्थिति अनजान"
        },
        "queues": {
          "label": "क्वीन्स",
          "healthy": "क्वीन्स स्वस्थ",
          "unknown": "क्वीन स्थिति अनजान"
        },
        "apiHealth": {
          "label": "एपीआई स्वास्थ्य",
          "unknown": "एपीआई स्वास्थ्य स्थिति अनजान"
        },
        "backgroundJobs": {
          "label": "पृष्ठभूमा कार्य",
          "unknown": "पृष्ठभूमा कार्य स्थिति अनजान"
        },
        "auditWriter": {
          "label": "ऑडिट लेखक",
          "unknown": "ऑडिट लेखक स्थिति अनजान"
        },
        "marketDataFreshness": {
          "label": "बाजार डेटा नवीनता",
          "unknown": "बाजार डेटा नवीनता स्थिति अनजान"
        },
        "reportRuntime": {
          "label": "रिपोर्ट रन टाइम",
          "unknown": "रिपोर्ट रन टाइम स्थिति अनजान"
        },
        "storageExport": {
          "label": "पुनर्प्राप्ति/निकास सेवा",
          "unknown": "पुनर्प्राप्ति/निकास सेवा की स्थिति अनजान"
        },
        "databaseDesc": "डेटाबेस कनेक्टिविटी और प्रदर्शन",
        "cacheDesc": "क्याच लेयर की स्वास्थ्य स्थिति",
        "queuesDesc": "पृष्ठभूमि क्वीन प्रोसेसिंग स्थिति"
      },
      "refreshPosture": "नया स्थिति",
      "refreshPostureSuccess": "सिस्टम स्थिति नवीनीकृत हुई",
      "refreshPostureDesc": "प्रणालीको स्वास्थ्य स्थिति ताजा गर्नुहोस्"
    },
    "navigation": {
      "overview": "विहंग",
      "users": "प्रयोगकर्ताहरू",
      "roles": "भूमिकाहरू",
      "approvals": "अनुमोदनहरू",
      "organization": "संगठन",
      "modules": "मोड्युलहरू",
      "clientAccounts": "ग्राहक खाताहरू",
      "system": "प्रणाली अवस्था",
      "audit": "अडिट",
      "settings": "सेटिङ्स",
      "moreTabs": "थप ट्याबहरू",
      "ariaLabel": "प्रशासक नेभिगेसन"
    },
    "rootPowerTools": {
      "title": "पावर टुल्स",
      "description": "प्रदायक-स्तरका प्रशासनिक उपकरणहरू। सबै कार्यहरूको अडिट हुन्छ।",
      "warning": {
        "caution": "सावधानी:",
        "message": "यहाँ गरिएका कार्यहरूले वास्तविक शाखा डाटालाई असर गर्छन्। सबै कार्यका लागि औचित्य आवश्यक हुन्छ र लग गरिन्छ।"
      },
      "common": {
        "branchId": "शाखा ID",
        "branchUuidPlaceholder": "शाखा UUID...",
        "reasonRequired": "कारण (अडिटका लागि आवश्यक)"
      },
      "passwordReset": {
        "title": "शाखा एडमिन पासवर्ड रिसेट गर्नुहोस्",
        "description": "शाखा एडमिनका लागि एकपटक प्रयोग हुने अस्थायी पासवर्ड बनाउँछ। अर्को लगइनमा एडमिनले यसलाई परिवर्तन गर्नुपर्छ।",
        "reasonPlaceholder": "उदाहरण: एडमिन लक आउट, सपोर्ट टिकट #1234",
        "action": "पासवर्ड रिसेट गर्नुहोस्",
        "oneTimeNotice": "अहिले प्रतिलिपि गर्नुहोस् — एकपटक मात्र देखाइन्छ"
      },
      "statusChange": {
        "title": "शाखा स्थिति परिवर्तन गर्नुहोस्",
        "description": "शाखालाई सक्रिय, निलम्बित, वा पेन्डिङ सेटअपमा फर्काउनुहोस्। यसले उक्त शाखाका सबै प्रयोगकर्तालाई असर गर्छ।",
        "newStatus": "नयाँ स्थिति",
        "selectStatus": "स्थिति छान्नुहोस्",
        "reasonPlaceholder": "उदाहरण: भुक्तानी नहुनु, सेवा निलम्बन",
        "action": "स्थिति परिवर्तन लागू गर्नुहोस्"
      },
      "databaseReset": {
        "title": "शाखा डेटाबेस रिसेट गर्नुहोस्",
        "destructiveLabel": "विध्वंसक कार्य:",
        "description": "प्रयोगकर्ता, कारोबार, र सेटिङहरू सहित एक विशिष्ट शाखाको सबै डाटा हटाउँछ। यो कार्य फिर्ता लिन सकिँदैन।",
        "reasonPlaceholder": "उदाहरण: डाटा करप्शन, शाखा बन्द, GDPR अनुरोध",
        "action": "डेटाबेस रिसेट गर्नुहोस्"
      },
      "messages": {
        "statusChanged": "शाखा स्थिति {{status}} मा परिवर्तन गरियो"
      },
      "futureTools": {
        "title": "SQL Query Runner, Backup & Restore, र Job Retry उपकरणहरू",
        "description": "अर्को रिलिजमा आउनेछ — थप सुरक्षा नियन्त्रण र वातावरणीय जाँचहरू आवश्यक छन्।"
      }
    },
    "rootSettings": {
      "title": "प्रदायक सेटिङहरू",
      "description": "रूट सुरक्षा नीति, प्रदायक पहिचान, र सञ्चालन थ्रेसहोल्डहरू कन्फिगर गर्नुहोस्।",
      "quickCards": {
        "sessionTimeout": {
          "title": "सेसन टाइमआउट",
          "description": "रूट कन्सोल निष्क्रियता टाइमरमा प्रयोग हुन्छ।"
        },
        "whitelistedIps": {
          "title": "ह्वाइटलिस्ट गरिएका IP हरू",
          "description": "प्रत्येक प्रविष्टिले विश्वसनीय अपरेटर स्थानलाई प्रतिनिधित्व गर्नुपर्छ।"
        },
        "defaultBranchPlan": {
          "title": "पूर्वनिर्धारित शाखा योजना",
          "description": "नयाँ शाखा अनबोर्डिङ पूर्वभर्ना गर्न प्रयोग हुन्छ।"
        }
      },
      "sections": {
        "providerIdentity": "प्रदायक पहिचान",
        "securityControls": "सुरक्षा नियन्त्रणहरू",
        "operationalThresholds": "सञ्चालन थ्रेसहोल्डहरू"
      },
      "fields": {
        "providerName": "प्रदायक नाम",
        "supportEmail": "सपोर्ट इमेल",
        "supportWebsite": "सपोर्ट वेबसाइट",
        "defaultMaxUsers": "पूर्वनिर्धारित अधिकतम प्रयोगकर्ता"
      },
      "security": {
        "requireMfa": {
          "title": "MFA आवश्यक",
          "description": "MFA कन्फिगर नभएसम्म गम्भीर चेतावनी उठाउँछ।"
        },
        "view": {
          "loadingHoldingsTitle": "होल्डिङहरू लोड हुँदै",
          "loadingHoldingsDescription": "मूल्यांकन, पोजिसन, र मूल्य स्थिति ल्याउँदै।",
          "unableToLoadHoldings": "होल्डिङहरू लोड गर्न सकिएन",
          "totalInvestment": "कुल लगानी",
          "unrealizedPnL": "अनरियलाइज्ड P&L",
          "annualizedReturn": "वार्षिकीकरण गरिएको प्रतिफल",
          "allHoldings": "सबै होल्डिङहरू",
          "viewCostBasis": "लागत आधार हेर्नुहोस्",
          "viewCostBasisAriaDisabled": "लागत आधार हेर्नुहोस् निष्क्रिय: लागत-आधार डाटामा पहुँच छैन",
          "costBasisDataTitle": "लागत आधार डाटा",
          "costBasisDataDescription": "बजार मूल्य बिना कच्चा लागत-आधार डाटा। यसले मात्रा, भारित औसत लागत, र कुल लागत देखाउँछ।",
          "loadingCostBasisTitle": "लागत-आधार डाटा लोड हुँदै",
          "loadingCostBasisDescription": "बजार मूल्य बिना कच्चा होल्डिङहरू ल्याउँदै।",
          "unableToLoadCostBasisData": "लागत-आधार डाटा लोड गर्न सकिएन",
          "costBasisHoldings": "लागत आधार होल्डिङहरू",
          "noCostBasisRows": "लागत-आधार पंक्ति छैन",
          "noCostBasisRowsDescription": "हाल लागत-आधार मोडमा कुनै होल्डिङ उपलब्ध छैन।",
          "failedToLoadCostBasisData": "लागत-आधार डाटा लोड गर्न असफल"
        },
        "requireReasons": {
          "title": "कारण आवश्यक",
          "description": "निलम्बन र पासवर्ड रिसेट जस्ता रूट-संवेदनशील कार्यहरूमा लागू हुन्छ।"
        },
        "inactivityTimeoutMinutes": "निष्क्रियता टाइमआउट (मिनेट)",
        "whitelistedIps": "ह्वाइटलिस्ट गरिएका IP हरू",
        "whitelistPlaceholder": "प्रति लाइन एउटा IP वा CIDR",
        "mfaStatusTitle": "MFA स्थिति"
      }
    },
    "rootBranches": {
      "description": "रूट कन्सोलबाट शाखा संगठनहरू प्रावधान, निगरानी, र निवृत्त गर्नुहोस्।",
      "actions": {
        "createBranch": "शाखा सिर्जना गर्नुहोस्",
        "viewBranchDetails": "शाखा विवरण हेर्नुहोस्",
        "viewDetails": "विवरण हेर्नुहोस्",
        "suspendBranch": "शाखा निलम्बन गर्नुहोस्",
        "activateBranch": "शाखा सक्रिय गर्नुहोस्",
        "retireBranch": "शाखा निवृत्त गर्नुहोस्"
      },
      "filters": {
        "searchPlaceholder": "नाम वा कोडबाट शाखा खोज्नुहोस्",
        "allStatuses": "सबै स्थितिहरू",
        "pendingSetup": "पेन्डिङ सेटअप"
      },
      "table": {
        "nameCode": "नाम / कोड",
        "maxUsers": "अधिकतम प्रयोगकर्ता",
        "empty": "हालका फिल्टरसँग मेल खाने कुनै शाखा फेला परेनन्।"
      },
      "pagination": {
        "pageOfTotal": "पृष्ठ {{page}} / {{totalPages}} ({{total}} कुल)"
      },
      "form": {
        "enabledModules": "सक्षम मोड्युलहरू"
      },
      "statusChange": {
        "reasonPrompt": "कृपया यो स्थिति परिवर्तनको कारण प्रदान गर्नुहोस्। यो अडिट लगमा रेकर्ड हुनेछ।",
        "reasonPlaceholder": "कारण (आवश्यक)"
      },
      "retireDialog": {
        "archiveNoticePrefix": "यसले शाखालाई",
        "archiveNoticeEmphasis": "निलम्बन र अभिलेखीकरण",
        "archiveNoticeSuffix": "गर्छ — यसले कुनै डाटा स्थायी रूपमा मेट्दैन।",
        "branchPrefix": "शाखा",
        "branchSuffix": "लाई निलम्बन गरिनेछ र सक्रिय सञ्चालनबाट लुकाइनेछ। शाखा पुन: सक्रिय गरेर डाटा पुनःप्राप्त गर्न सकिन्छ।"
      }
    },
    "userManagement": {
      "title": "प्रयोगकर्ता व्यवस्थापन",
      "createUser": {
        "label": "नयाँ प्रयोगकर्ता बनाउनुहोस्",
        "confirmation": "यो प्रयोगकर्ता बनाउने?",
        "success": "प्रयोगकर्ता सफलतापूर्वक बनाइयो",
        "labelDesc": "नयाँ प्रयोगकर्ता खाता बनाउनुहोस्"
      },
      "editUser": "प्रयोगकर्ता सम्पादन गर्नुहोस्",
      "refresh": "रिफ्रेस गर्नुहोस्",
      "working": "काम…",
      "searchPlaceholder": "प्रयोगकर्ताहरूको खोज",
      "allStatuses": "सबै स्थितिहरू",
      "allUserTypes": "सबै प्रयोगकर्ता प्रकार",
      "summary": {
        "total": "कुल प्रयोगकर्ताहरू",
        "active": "सक्रिय प्रयोगकर्ताहरू",
        "pending": "बाँकी प्रयोगकर्ता",
        "suspended": "निलम्बित प्रयोगकर्ता"
      },
      "table": {
        "userId": "प्रयोगकर्ता आईडी",
        "name": "नाम",
        "email": "इमेल",
        "branch": "शाखा",
        "type": "प्रकार",
        "status": "स्थिति",
        "createdAt": "पश्चात्तिथि",
        "actions": "कार्यहरू"
      },
      "form": {
        "userId": "किसी प्रयोगकर्ता का ID",
        "userIdRequired": "किसी प्रयोगकर्ता का ID आवश्यक छ",
        "username": "प्रयोगकर्ता नाम",
        "usernameRequired": "प्रयोगकर्ता नाम आवश्यक छ",
        "email": "इमेल",
        "emailRequired": "ईमेल आवश्यक छ",
        "invalidEmail": "अस्थिर ईमेल",
        "firstName": "पहिलो नाम",
        "firstNameRequired": "पहिलो नाम आवश्यक छ",
        "surname": "थर",
        "surnameRequired": "थर आवश्यक छ",
        "password": "पासवर्ड",
        "passwordRequired": "पासवर्ड आवश्यक छ",
        "passwordRequirements": "पासवर्ड को कम से कम 8-128 अक्षरों और कम से कम एक अक्षर और एक संख्या होनी चाहिए",
        "passwordHint": "कम से कम 8-128 अक्षर, जिसमें अक्षर और संख्याएँ होनी चाहिए",
        "branch": "शाखा",
        "branchRequired": "शाखा *",
        "noBranch": "— कुनै शाखा छैन —",
        "userType": "प्रयोगकर्ता प्रकार",
        "userTypeRequired": "प्रयोगकर्ता प्रकार *",
        "noType": "— कुनै प्रकार छैन —",
        "roleAssignment": "भूमिका निर्धारण",
        "designation": "भूमिका",
        "designationPlaceholder": "पद भर्नुहोस्",
        "emailInvalid": "ईमेल पते अस्थिर छ",
        "emailPlaceholder": "इमेल ठेगाना भर्नुहोस्",
        "extension": "विस्तार",
        "extensionPlaceholder": "प्रारंभिक संख्या",
        "firstNamePlaceholder": "प्रथम नाम",
        "isActive": "सक्रिय",
        "mobile": "मोबाइल नं.",
        "mobilePlaceholder": "मोबाइल नं. दर्ज कर",
        "passwordPlaceholder": "लॉगिन पासवर्ड",
        "surnamePlaceholder": "पश्चिमा नाम",
        "telephone": "टेलीफोन नं.",
        "telephonePlaceholder": "टेलीफोन नं. दर्ज कर",
        "userIdPlaceholder": "व्यक्तिगत संख्या",
        "usernamePlaceholder": "लॉगिन नाम",
        "userIdDesc": "विशिष्ट व्यक्तिगत संख्या",
        "usernameDesc": "लॉगिन नाम",
        "emailDesc": "ईमेल पता",
        "passwordDesc": "कonto पासवर्ड",
        "firstNameDesc": "प्रथम नाम",
        "surnameDesc": "पश्चिमा नाम या अंतिम नाम",
        "designationDesc": "कार्य स्थिति",
        "branchDesc": "नियुक्त शाखा",
        "userTypeDesc": "व्यक्तिगत प्रकार",
        "telephoneDesc": "टेलीफोन नं.",
        "mobileDesc": "मोबाइल नं.",
        "extensionDesc": "फोन विस्तार",
        "isActiveDesc": " खाता सक्रिय स्थिति",
        "clientAccountId": "क्लाइंट खाता",
        "clientAccountIdPlaceholder": "पुराना क्लाइंट खाता चुनने के लिए",
        "clientAccountCode": "क्लाइंट खाता कोड",
        "clientAccountCodePlaceholder": "क्लाइंट खाता कोड दर्ज करने के लिए",
        "clientAccountName": "क्लाइंट खाता नाम",
        "clientAccountNamePlaceholder": "क्लाइंट खाता नाम दर्ज करने के लिए",
        "clientAccountEmail": "क्लाइंट खाता ईमेल",
        "clientAccountEmailPlaceholder": "क्लाइंट खाता ईमेल दर्ज करने के लिए",
        "clientAccountPhone": "क्लाइंट खाता फोन",
        "clientAccountPhonePlaceholder": "क्लाइंट खाता फोन दर्ज करने के लिए",
        "clientAccountPanNumber": "क्लाइंट खाता पैन",
        "clientAccountPanNumberPlaceholder": "क्लाइंट खाता प्यान नम्बर दर्ज करने के लिए",
        "organizationName": "संस्थाको नाम",
        "organizationNamePlaceholder": "संगठन नाम दर्ज करने के लिए",
        "organizationCode": "संस्थाको कोड",
        "organizationCodePlaceholder": "संगठन कोड दर्ज करने के लिए",
        "organizationPanNumber": "संगठन पैन",
        "organizationPanNumberPlaceholder": "संगठन प्यान नम्बर दर्ज करने के लिए",
        "organizationVatNumber": "संगठन वैट",
        "organizationVatNumberPlaceholder": "निर्गम व्यावसायिक VAT संख्या दर्ज कर",
        "organizationAddress": "व्यवसायिक पता",
        "organizationAddressPlaceholder": "व्यवसायिक पता दर्ज कर",
        "organizationPhone": "व्यवसायिक फोन नम्बर",
        "organizationPhonePlaceholder": "व्यवसायिक फोन नम्बर दर्ज कर",
        "organizationEmail": "व्यवसायिक ईमेल पता",
        "organizationEmailPlaceholder": "व्यवसायिक ईमेल पता दर्ज कर"
      },
      "actions": {
        "edit": "सम्पादन गर्नुहोस्",
        "approve": "अनुमोदन गर्नुहोस्",
        "reject": {
          "label": "अस्वीकार गर्नुहोस्",
          "confirmation": "यो प्रयोगकर्ताको निलंबन गर्ने कस चाह्य?",
          "labelDesc": "प्रयोगकर्ताको निलंबन गर्ने"
        },
        "suspend": {
          "label": "निलंबन गर्न",
          "confirmation": "यो प्रयोगकर्ताको निलंबन गर्न चाह्य?",
          "labelDesc": "प्रयोगकर्ताको निलंबन गर्न"
        },
        "activate": {
          "label": "खाता सक्रिय गर्नुहोस्",
          "confirmation": "यो प्रयोगकर्ताको सक्रिय गर्न चाह्य?",
          "labelDesc": "प्रयोगकर्ताको सक्रिय गर्न"
        },
        "unlock": {
          "label": "बंद गर्न",
          "confirmation": "यो प्रयोगकर्ताको बंद गर्न चाह्य?",
          "labelDesc": "प्रयोगकर्ताको बंद गर्न"
        },
        "cancel": "बाटु",
        "save": "सेवा गर्न",
        "saving": "सेवा गर्ने...",
        "creating": "पुनर्निर्माण…",
        "createUser": "प्रयोगकर्ता सिर्जना गर्नुहोस्",
        "editDesc": "सम्पादन गर्नुहोस्",
        "approveDesc": "अनुमोदन गर्नुहोस्",
        "rejectDesc": "अस्वीकार गर्नुहोस्",
        "suspendDesc": "स्थगित कर",
        "activateDesc": "यो प्रयोगकर्ता को सक्रिय कर",
        "unlockDesc": "प्रयोगकर्ता खाताको खोल",
        "saveDesc": "बचाए",
        "delete": {
          "label": "मेटाउनुहोस्",
          "labelDesc": "यो प्रयोगकर्ता हटाए"
        },
        "approveDelete": {
          "label": "हटाउने की अनुमति दिए",
          "labelDesc": "यो प्रयोगकर्ताको हटाएको अनुमति दिए"
        },
        "reapply": {
          "label": "पुनर्निर्माण कर",
          "labelDesc": "पुनर्निर्माण प्रयोगकर्ता की अनुरोध"
        }
      },
      "messages": {
        "loadingPermissions": "अनुमति लोड हुँदैछ…",
        "loadingUsers": "प्रयोगकर्ताहरू लोड हुँदैछ…",
        "accessDenied": "पहुँच अस्वीकृत",
        "accessDeniedDescription": "आपको प्रयोगकर्ता देख्ने की अनुमति नाह",
        "error": "त्रुटि",
        "failedToCreateUser": "प्रयोगकर्ताको बनाएको विफल हयो",
        "userCreatedSuccessfully": "प्रयोगकर्ता बनाएको सफल हयो",
        "failedToUpdateUser": "प्रयोगकर्ताको अद्यतनको विफल हयो",
        "userUpdatedSuccessfully": "प्रयोगकर्ता अद्यतनको सफल हयो",
        "failedToAssignRole": "रोल को नियुक्त करने मा असफल रह्यो, प्रोफाइल सेव्ह्या गयो",
        "failedToRemoveRole": "रोल को हटाने मा असफल रह्यो, प्रोफाइल सेव्ह्या गयो",
        "failedToApproveUser": "प्रयोगकर्ता को मान्यता देने मा विफल हुआ",
        "userApprovedSuccessfully": "प्रयोगकर्ता की अनुमति दी गई",
        "userRejectedSuccessfully": "प्रयोगकर्ता को अस्वीकृत कर दिया गया",
        "suspendUser": "प्रयोगकर्ता निलम्बन गर्नुहोस्",
        "suspendUserMessage": "निर्धारित गरिएका कारण के लिए प्रयोगकर्ता को स्थगित करने के लिए एक कारण भर्नुहोस्:",
        "suspendConfirm": "स्थगित",
        "suspensionReasonPlaceholder": "स्थगन कारण (आवश्यक)",
        "failedToSuspendUser": "प्रयोगकर्ता स्थगित करने मा विफल हुआ",
        "userSuspendedSuccessfully": "प्रयोगकर्ता स्थगित कर लिया गया",
        "failedToUnlockUser": "प्रयोगकर्ता को खोलने मा विफल हुआ",
        "userUnlockedSuccessfully": "प्रयोगकर्ता खोल दिया गया",
        "failedToReactivateUser": "प्रयोगकर्ता को फिर से सक्षम करने मा विफल हुआ",
        "userReactivatedSuccessfully": "प्रयोगकर्ता फिर से सक्षम कर दिया गया",
        "noUsersFound": "कुनै प्रयोगकर्ता फेला परेन।",
        "pageOf": "पृष्ठ {{page}} मा {{totalPages}}",
        "total": " ({{total}} कुल)",
        "reactivationReason": "प्रशासक पोर्टबाट पुनः सक्रिय गरियो",
        "success": "सफलता"
      },
      "fallback": {
        "administrator": "प्रशासक",
        "manager": "मैनेजर",
        "operator": "ऑपरेटर",
        "viewer": "दृशक",
        "mainBranch": "मुख्य शाखा"
      },
      "status": {
        "locked": " (ताल्चा लागेको)",
        "active": "सक्रिय",
        "pendingApproval": "प्रतीक्षा मिति",
        "suspended": "निलम्बित",
        "rejected": "KYC अस्वीकार"
      },
      "pagination": {
        "previous": "अघिल्लो",
        "next": "पछिल्लो"
      },
      "createUserDescription": "नयाँ प्रयोगकर्ता खाता बनाउनुहोस्",
      "updateUser": "प्रयोगकर्ता अद्यावधिक गर्नुहोस्",
      "updateUserDescription": "प्रयोगकर्ता खाताको विवरण अद्यावधिक गर्नुहोस्",
      "createUserDesc": "नयाँ प्रयोगकर्ता खाता बनाउनुहोस्",
      "emptyState": {
        "message": "कुनै प्रयोगकर्ता फेला परेन। सुरु गर्न एउटा प्रयोगकर्ता बनाउनुहोस्।"
      }
    },
    "roleManagement": {
      "title": "भूमिका व्यवस्थापन",
      "createRole": {
        "label": "भूमिका बनाउनुहोस्",
        "confirmation": "यह रोल बनाए?",
        "success": "रोल बनाने की सफलता"
      },
      "refresh": "रिफ्रेस गर्नुहोस्",
      "working": "काम…",
      "table": {
        "id": "आईडी",
        "roleId": "रोल आईडी",
        "name": "नाम",
        "type": "प्रकार",
        "userType": "प्रयोगकर्ता प्रकार",
        "users": "प्रयोगकर्ताहरू",
        "status": "स्थिति",
        "functions": "फंक्शन",
        "functionCount": "फंक्शन",
        "userCount": "प्रयोगकर्ता सङ्ख्या",
        "actions": "कार्यहरू"
      },
      "form": {
        "roleId": "रोल आईडी",
        "roleIdRequired": "रोल आईडी",
        "roleName": "रोल नाम",
        "roleNameRequired": "रोल नाम *",
        "description": "विस्तृत विवरण",
        "roleIdPlaceholder": "जस्तै, PORTFOLIO_MANAGER",
        "roleIdHint": "मaxes 50 चारकहरु, अङ्कीयनुमा साथै ह्येन/अंडरस्कोर",
        "roleNamePlaceholder": "e.g., पोर्टफोलियो मैनेजर",
        "descriptionPlaceholder": "विवरण...",
        "functions": "कार्य",
        "functionsRequired": "कम से कम एक कार्य चयन गरिनु",
        "functionsHint": "यो कार्य पूरा गर्न अनुमति दिने प्रकार्यहरू चयन गर्नुहोस्",
        "userType": "प्रयोगकर्ता प्रकार",
        "userTypeRequired": "प्रयोगकर्ता प्रकार आवश्यक हो",
        "functionsDesc": "नियुक्त केले गए कार्य र अनुमति",
        "roleIdDesc": "विशिष्ट नाम",
        "roleNameDesc": "विशिष्ट नाम",
        "userTypeDesc": "प्रयोगकर्ता प्रकार यो विशिष्ट नाम लागि"
      },
      "actions": {
        "edit": "सम्पादन गर्नुहोस्",
        "approve": "अनुमोदन गर्नुहोस्",
        "reject": {
          "label": "अस्वीकार गर्नुहोस्",
          "confirmation": "यसप्रियता हुनु के रोल रजिस्टर गरिनु?"
        },
        "assignFunctions": "कार्य सौंपन",
        "suspend": {
          "label": "निलंबन कर",
          "confirmation": "यसप्रियता हुनु के निलंबन गरिनु?"
        },
        "delete": {
          "label": "मेटाउनुहोस्",
          "confirmation": "यसप्रियता हुनु के रोल रजिस्टर गरिनु?"
        },
        "deleteRole": "रोल रजिस्टर गर",
        "deleteConfirm": "अपहरण करे",
        "cancel": "बाट्छु",
        "assignFunctionsButton": "विशेषाधिकार दिने",
        "creating": "रचना हो रहो…",
        "createRole": "व्यक्तिगत विभाग बनाउनुहोस्",
        "assignFunctionsDescription": "विशेषाधिकार और कार्य सौंपने",
        "editDescription": "व्यक्तिगत विभागको जानकारी समायोजन गर्नुहोस्",
        "approveDesc": "अनुमोदन गर्नुहोस्",
        "rejectDesc": "अस्वीकार गर्नुहोस्",
        "assignFunctionsDesc": "विशेषाधिकार दिने",
        "suspendDesc": "विशेषाधिकार निलम्बन गर्नुहोस्",
        "deleteDesc": "व्यक्तिगत विभाग हटाउनुहोस्",
        "assign": "नियुक्त कर्नाला",
        "assignDesc": "यस पात्र व्यक्तिहरूको नियुक्त गर्ने हो"
      },
      "messages": {
        "loadingPermissions": "अनुमति लोड हुँदैछ...",
        "loadingRoles": "पात्रहरू लोड हुँदैछ...",
        "accessDenied": "यस पात्र व्यक्तिहरूको भाग्या देख्ने अनुमति नाह",
        "failedToLoadRoles": "पात्रहरूको लोड गर्ने मा असफल रह्यो",
        "failedToLoadFunctions": "कार्यहरूको लोड गर्ने मा असफल रह्यो",
        "failedToApproveRole": "पात्र व्यक्तिहरूको स्वीकृति गर्ने मा असफल रह्यो",
        "roleApproved": "पात्र व्यक्तिहरूको स्वीकार गर्यो",
        "roleRejected": "पात्र व्यक्तिहरूको स्वीकार न कर्यो",
        "roleApprovedMessage": "पश्चात्तापित रोल कार्यसंहिता पूर्ण हो चुका छ.",
        "roleRejectedMessage": "पश्चात्तापित रोल कार्यसंहिता पूर्ण हो चुका छ।",
        "suspendRole": "भूमिका निलम्बन गर्नुहोस्",
        "suspendRoleMessage": "भूमिका निलम्बन गर्नुको कारण?",
        "suspendConfirm": "निलम्बन गर्नुहोस्",
        "suspensionReasonPlaceholder": "निर्धारण कारण (आवश्यक)",
        "failedToSuspendRole": "रोल स्थगित करने मा असफल रहा",
        "roleSuspended": "रोल स्थगित हो गया छ",
        "roleSuspendedMessage": "रोल को स्थगित करने मा सफलतापूर्वक पूरा हुआ छ।",
        "deleteRoleMessage": "यो भूमिका हटाउन चाहनुहुन्छ? यो पूर्ववत गर्न सकिँदैन।",
        "failedToDeleteRole": "रोल हटाने मा असफल रहा",
        "roleDeleted": "रोल हटा दिया गया छ",
        "roleDeletedMessage": "रोल को सफलतापूर्वक हटाया गया छ।",
        "assignFunctionsTitle": "{{roleName}} भूमिकाका लागि प्रकार्यहरू संलग्न गर्नुहोस्",
        "failedToAssignFunctions": "संलग्न करने मा असफल रहा",
        "functionsUpdated": "संलग्न गरियो",
        "functionsUpdatedMessage": "रोल संलग्न करने मा सफलतापूर्वक पूरा हुआ छ।",
        "system": "प्रणाली",
        "functionsCount": "{{count}} संलग्न",
        "failedToCreateRole": "रोल बनाने मा असफल रहा"
      },
      "summary": {
        "total": "कुल",
        "active": "सक्रिय",
        "pending": "KYC विचाराधीन",
        "suspended": "निलम्बित"
      },
      "status": {
        "unknown": "अज्ञात"
      },
      "createRoleDescription": "नया भूमिका बनाउनुहोस् जिसमें अनुमतिहरू",
      "createRoleDesc": "नया कार्यभूमि बनाएर प्रवर्तन",
      "emptyState": {
        "message": "कार्यभूमि नपाहुने हो । कार्यभूमि बनाउने लाग्यै"
      }
    },
    "audit": {
      "title": "अडिट",
      "description": "प्रणाली डायग्नोस्टिक्स, शासन घटनाहरू, र ट्रेस प्रमाण समीक्षा गर्नुहोस्।",
      "loadingEvents": "अडिट घटनाहरू लोड हुँदै...",
      "noEvents": "कुनै अडिट घटना फेला परेन।",
      "views": {
        "diagnostics": {
          "title": "अडिट डायग्नोस्टिक्स",
          "description": "प्रणाली अडिट डायग्नोस्टिक्स, हालको गतिविधि, र शासन घटनाहरू समीक्षा गर्नुहोस्।",
          "tab": "डायग्नोस्टिक्स"
        },
        "traces": {
          "title": "अडिट ट्रेसहरू",
          "description": "अनुसन्धान वर्कफ्लोका लागि घटना लाइनएज र प्रतिनिधित्व गरिएको समर्थन प्रमाण ट्रेस गर्नुहोस्।",
          "tab": "ट्रेसहरू"
        }
      },
      "columnTimestamp": "समय",
      "columnActor": "कर्ता",
      "columnAction": "कार्य",
      "columnEntity": "इकाई",
      "columnEntityId": "संस्थान ID",
      "columnComment": "टिप्पणी",
      "emptyMessage": "संदेश",
      "actor": "कर्ता",
      "actorPlaceholder": "कर्ता",
      "actorHelper": "कर्ता",
      "action": "ऐतिहासिक कार्य",
      "allActions": "सबस्तु कार्यहरू",
      "entityType": "इकाइ प्रकार",
      "allEntities": "सबस्तु व्यक्तिहरू",
      "fromDate": "पूर्व तिथि",
      "toDate": "पश्चिम तिथि",
      "apply": "अप्लाई गर्नु",
      "reset": "रिसेट",
      "errorTitle": "त्रुटि",
      "loadingTitle": "ग्राहक खाताहरू लोड गर्दै…",
      "loadMore": "धेरै अधिक",
      "totalLogs": "कुल अडिट लगहरू",
      "today": "आज",
      "actions": {
        "create": "सिर्जना",
        "modify": "परिमार्जन",
        "delete": "मेटाउनु",
        "approve": "अनुमोदन",
        "reject": "अस्वीकार"
      },
      "invalidViewFallback": "व्यर्थ दृश्य प्रतिस्थापन",
      "exportFormTitle": "निर्यात विवरण",
      "dateFrom": "मिति देखि",
      "dateTo": "मिति सम्म",
      "redactionPolicy": "पुनः लेखक नीति",
      "redaction": {
        "full": "सबस्तु",
        "metadataOnly": "प्रारंभिक केवल",
        "redacted": "अनुमोदित छैन"
      },
      "export": "निर्यात कर",
      "exportSuccess": "निर्यात अनुरोध सफल रहा",
      "exportDesc": "निर्यात"
    },
    "clientAccounts": {
      "title": "ग्राहक खाताहरू",
      "description": "तपाईंको संगठनद्वारा व्यवस्थापन गरिएका व्यक्तिगत ग्राहकहरू जसको लगानी पोर्टफोलियो छ",
      "aboutTitle": "ग्राहक खाताहरूको बारेमा:",
      "aboutDescription": "यी रेकर्डहरूले अन्त-ग्राहकहरू प्रतिनिधित्व गर्छन्, प्रणाली अपरेटर खाताहरू होइन। ग्राहकहरूसँग तपाईंको संगठनद्वारा व्यवस्थापन गरिएको एक वा धेरै पोर्टफोलियो हुन सक्छ। उनीहरूसँग स्पष्ट रूपमा सक्षम नगरेसम्म सिधै लगइन पहुँच छैन।",
      "form": {
        "validation": {
          "firstNameRequired": "पहिलो नाम आवश्यक छ",
          "lastNameRequired": "थर आवश्यक छ",
          "validEmail": "मान्य इमेल ठेगाना प्रविष्ट गर्नुहोस्"
        },
        "error": {
          "generic": "एउटा त्रुटि भयो। कृपया पुन: प्रयास गर्नुहोस्।",
          "unexpected": "एउटा अप्रत्याशित त्रुटि भयो।"
        },
        "editTitle": "ग्राहक खाता सम्पादन गर्नुहोस्",
        "addTitle": "ग्राहक खाता थप्नुहोस्",
        "firstName": "पहिलो नाम",
        "placeholder": {
          "firstName": "पहिलो नाम",
          "lastName": "थर",
          "email": "इमेल",
          "phone": "फोन नम्बर",
          "address": "गल्ली ठेगाना",
          "branchId": "branch-uuid (वैकल्पिक)",
          "notes": "आन्तरिक टिप्पणीहरू (ग्राहकलाई देखिँदैन)",
          "code": "कोड"
        },
        "codePlaceholder": "कोड भर्नुहोस्",
        "emailPlaceholder": "इमेल ठेगाना भर्नुहोस्",
        "fullNamePlaceholder": "पूरा नाम भर्नुहोस्",
        "notesPlaceholder": "नोट्स भर्नुहोस्",
        "panNumberPlaceholder": "प्यान नम्बर भर्नुहोस्",
        "phonePlaceholder": "फोन नम्बर भर्नुहोस्",
        "lastName": "थर",
        "branchId": "शाखा ID",
        "branchIdHelp": "बहु-शाखा इन्सुलेसनको लागि ग्राहकलाई विशिष्ट शाखामा नियुक्त गर्नुहोस्",
        "kycStatus": "KYC स्थिति",
        "accountStatus": "खाता स्थिति",
        "saving": "बचत गर्दै…",
        "saveChanges": "परिवर्तनहरू सेभ गर्नुहोस्",
        "createClient": "ग्राहक सिर्जना गर्नुहोस्",
        "accountType": " खाता प्रकार",
        "code": "खाता कोड",
        "codeRequired": "खाता कोड आवश्यक छ",
        "createDescription": "नयाँ ग्राहक खाता बनाउनुहोस्",
        "email": "ईमेल पता",
        "emailInvalid": "इमेल ठेगाना वैध छैन",
        "fullName": "पूर्ण नाम",
        "fullNameRequired": "पूर्ण नाम आवश्यक छ",
        "isActive": "सक्रिय",
        "notes": "आन्तरिक टिप्पणीहरू (ग्राहकलाई देखिँदैन)",
        "notesTooLong": "नोट्स ५०० अक्षरभन्दा कम हुनुपर्छ",
        "panNumber": "पीएन संख्या",
        "panNumberInvalid": "प्यान नम्बर सही ढाँचामा छैन",
        "phone": "फ़ोन नंबर",
        "phoneInvalid": "फोन नम्बर सही छैन",
        "updateClient": "ग्राहक खाता अद्यावधिक गर्नुहोस्",
        "updateDescription": "ग्राहक खाता विवरण अद्यावधिक गर्नुहोस्",
        "codeDesc": "खाता कोड",
        "fullNameDesc": "पूर्ण नाम",
        "emailDesc": "ईमेल पता",
        "phoneDesc": "फ़ोन नंबर",
        "panNumberDesc": "पीएन संख्या",
        "accountTypeDesc": "खाता प्रकार",
        "notesDesc": "अंतर्निहित नोट्स",
        "isActiveDesc": "खाते की सक्रिय स्थिति",
        "createClientDesc": "नयाँ ग्राहक खाता बनाउनुहोस्",
        "saveChangesDesc": "ग्राहक खाता परिवर्तनहरू सेभ गर्नुहोस्"
      },
      "kycStatus": {
        "pending": "KYC विचाराधीन",
        "verified": "KYC प्रमाणित",
        "rejected": "KYC अस्वीकार",
        "expired": "KYC समाप्त",
        "verifiedDesc": "क्यूसी सत्यापित छ",
        "pendingDesc": "क्यूसी प्रतीक्षा मा छ",
        "rejectedDesc": "क्यसप रद्द",
        "expiredDesc": "क्यस्प समाप्त"
      },
      "status": {
        "active": "सक्रिय",
        "inactive": "निष्क्रिय",
        "closed": "बन्द",
        "activeDesc": "सक्रिय खाता",
        "inactiveDesc": "निष्क्रिय खाता",
        "closedDesc": "बंद खाता"
      },
      "emptyState": {
        "title": "अहिले कुनै ग्राहक खाताहरू छैनन्",
        "description": "व्यक्तिगत पोर्टफोलियो मालिकत्व ट्र्याक गर्न ग्राहक खाताहरू सिर्जना गर्नुहोस्।",
        "message": "कुनै ग्राहक खाताहरू फेला परेन। तपाईंसँग अहिले कुनै कन्फिगर गरिएको छैन हुन सक्छ।"
      },
      "actions": {
        "addClient": "ग्राहक थप्नुहोस्",
        "activate": "खाता सक्रिय गर्नुहोस्",
        "activateAccount": "खाता सक्रिय गर्नुहोस्",
        "deactivate": "खाता निष्क्रिय गर्नुहोस्",
        "deactivateAccount": "खाता निष्क्रिय गर्नुहोस्",
        "closeAccount": "खाता बन्द गर्नुहोस्",
        "closeAccountConfirm": "खाता \"{{displayName}}\" बन्द गर्नुहुन्छ? यसलाई सजिलै उल्ट्याउन सकिँदैन।",
        "close": "खाता बन्द गर्नुहोस्",
        "verifyKyc": "KYC प्रमाणित गर्नुहोस्",
        "markKycVerified": "KYC प्रमाणित गर्नुहोस्",
        "rejectKyc": "KYC अस्वीकार गर्नुहोस्",
        "resetKyc": "KYC रिसेट गर्नुहोस्",
        "resetKycToPending": "KYC विचाराधीनमा रिसेट गर्नुहोस्",
        "expireKyc": "KYC समाप्त गर्नुहोस्",
        "markKycExpired": "KYC समाप्त गर्नुहोस्",
        "activateAccountDesc": "यो खाता सक्रिय गर्नुहोस्",
        "deactivateAccountDesc": "यो खाता निष्क्रिय गर्नुहोस्",
        "closeAccountDesc": "यो खाता बन्द गर्नुहोस्",
        "markKycVerifiedDesc": "KYC सत्यापन गर्नुहोस्",
        "rejectKycDesc": "KYC प्रमाणीकरण रद्द गर्नुहोस्",
        "resetKycToPendingDesc": "KYC प्रतीक्षा स्थितिमा फर्काउनुहोस्",
        "markKycExpiredDesc": "KYC समाप्त गर्नुहोस्",
        "create": {
          "label": "सिर्जना",
          "labelDesc": "नयाँ खाता बनाउनुहोस्"
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्",
          "labelDesc": "खाताको जानकारी अद्यावधिक गर्नुहोस्"
        }
      },
      "filters": {
        "searchPlaceholder": "नाम, इमेल, वा कोडद्वारा खोज्नुहोस्…",
        "allStatuses": "सबै स्थितिहरू",
        "allKyc": "सबै KYC",
        "allStatusesDesc": "सबै स्थितिद्वारा फिल्टर गर्नुहोस्",
        "allKycDesc": "सबै KYC द्वारा फिल्टर गर्नुहोस्"
      },
      "ariaLabels": {
        "accountActions": "खाता कार्यहरू"
      },
      "loading": "ग्राहक खाताहरू लोड गर्दै…",
      "error": {
        "notFound": "कुनै ग्राहक खाताहरू फेला परेन। तपाईंसँग अहिले कुनै कन्फिगर गरिएको छैन हुन सक्छ।",
        "forbidden": "तपाईंसँग ग्राहक खाताहरू हेर्ने अनुमति छैन।",
        "failed": "ग्राहक खाताहरू लोड गर्न असफल: {{error}}"
      },
      "table": {
        "title": "ग्राहक खाताहरू",
        "client": "ग्राहक",
        "email": "इमेल",
        "status": "स्थिति",
        "kyc": "क्यस्प",
        "portfolios": "पोर्टफोलियोहरू",
        "created": "सिर्जना गरिएको"
      },
      "pagination": {
        "showing": "{{start}}–{{end}} कुल {{total}} खाताहरू देखाउँदै",
        "previous": "अघिल्लो",
        "pageOf": "पृष्ठ {{page}} कुल {{totalPages}}",
        "next": "पछिल्लो"
      },
      "accountType": {
        "corporate": "कॉर्पोरेट",
        "individual": "व्यक्तिगत",
        "joint": "संयुक्त",
        "individualDesc": "व्यक्तिगत",
        "corporateDesc": "सामान्य",
        "jointDesc": "संयुक्त"
      },
      "surface": {
        "description": "तपाईंको संगठनद्वारा व्यवस्थापन गरिएका व्यक्तिगत ग्राहकहरू जसको लगानी पोर्टफोलियो छ"
      }
    },
    "modules": {
      "title": "मोड्युल र टियर व्यवस्थापन",
      "description": "यो संगठनको लागि मोड्युल सदस्यता र टियर क्षमताहरू व्यवस्थापन गर्नुहोस्।",
      "currentTier": "हालको टियर:",
      "managedUnder": "मोड्युल सक्षम/अक्षम सेटिङहरू यस अन्तर्गत व्यवस्थापन गरिन्छ",
      "organizationModules": "संगठन → मोड्युलहरू",
      "tab": "ट्याब।",
      "activeModules": "सक्रिय प्रोग्राम",
      "refreshModules": "पुनर्निर्माण प्रोग्राम",
      "refreshSuccess": "प्रोग्राम पुनःनिर्माण सफल हो गया छ",
      "currentTierDesc": "हालको टियर:",
      "activeModulesDesc": "सक्रिय प्रोग्राम",
      "refreshModulesDesc": "पुनर्निर्माण प्रोग्राम",
      "table": {
        "name": "नाम",
        "nameDesc": "नाम",
        "enabled": "सक्षम",
        "enabledDesc": "सक्षम",
        "tierRequired": "विवरण आवश्यक छ",
        "tierRequiredDesc": "विवरण आवश्यक छ",
        "lastUpdated": "अन्तिम अपडेट",
        "lastUpdatedDesc": "अन्तिम अपडेट",
        "activeUsers": "सक्रिय प्रयोगकर्ताहरू",
        "clientAccounts": "ग्राहक खाताहरू"
      },
      "moduleNames": {
        "investment": "लगानी",
        "accounting": "लेखापरीक्षा",
        "inventory": "इन्भेन्टरी",
        "rebalancing": "रिब्यालेन्सिङ",
        "taxCompliance": "कर अनुपालन"
      },
      "tier": {
        "basic": "आधारभूत",
        "professional": "व्यावसायिक"
      },
      "tableTitle": "मोड्युलहरू"
    },
    "operationalNotes": {
      "title": "समर्थन र रनटाइम सन्दर्भ",
      "supportContact": "समर्थन सम्पर्क",
      "currentOperator": "हालको अपरेटर",
      "note": "ग्राहक अनुरोधहरूमा सहसंबंध IDs समावेश छन्, र ब्याकएन्ड विफलताहरूले अहिल अपरेटर समर्थनको लागि उही अनुरोध ID देखाउँछन्।"
    },
    "platformSettings": {
      "title": "प्लेटफर्म सेटिङहरू",
      "description": "प्लेटफर्म सेटिङहरू विवरण",
      "noOrganization": "कुनै संगठन छैन",
      "loading": "प्लेटफर्म सेटिङहरू लोड हुँदैछ",
      "featureDisabled": "विशेषता बंद छ",
      "sessionTimeout": "सेसन टाइमआउट",
      "sessionTimeoutDesc": "सेसन टाइमआउट",
      "maxLoginAttempts": "मासिक प्रवेश की कोशिशों की सीमा",
      "maxLoginAttemptsDesc": "मासिक प्रवेश की कोशिशों की सीमा"
    },
    "recentActivity": {
      "table": {
        "time": "समय",
        "user": "प्रयोगकर्ता",
        "system": "प्रणाली",
        "action": "कार्य",
        "entity": "इकाई",
        "comment": "टिप्पणी"
      },
      "title": "हालको गतिविधि",
      "description": "नवीनतम प्रशासकिय र प्रणाली अडिट घटनाहरू।",
      "noActivity": "हालको अडिट गतिविधि रेकर्ड गरिएको छैन।"
    },
    "stats": {
      "totalUsers": "कुल प्रयोगकर्ताहरू",
      "totalUsersValue": "{{count}} दर्ता",
      "activeUsers": "सक्रिय प्रयोगकर्ताहरू",
      "activeUsersValue": "{{count}} हाल सक्रिय",
      "pendingApprovals": "विचाराधीन अनुमोदनहरू",
      "pendingApprovalsValue": "{{count}} ध्यान दिन आवश्यक",
      "totalRoles": "कुल भूमिकाहरू",
      "totalRolesValue": "{{count}} परिभाषित"
    },
    "diagnostics": {
      "title": "ब्याकएन्ड रनटाइम",
      "health": "स्वास्थ्य",
      "readiness": "तयारी",
      "initialized": "सुरुवात गरियो",
      "bootstrapPending": "बुटस्ट्र्याप विचाराधीन",
      "uptime": "अपटाइम",
      "minutes": "मिनेट",
      "startupBootstrap": "स्टार्टअप बुटस्ट्र्याप",
      "enabled": "सक्षम",
      "disabled": "अक्षम",
      "operatorAccounts": "अपरेटर खाताहरू"
    },
    "approvals": {
      "actions": {
        "create": "सिर्जना",
        "update": "अद्यावधिक गर्नुहोस्",
        "delete": "मेटाउनुहोस्",
        "reapply": "पुन: लागू गर्नुहोस्",
        "approve": "अनुमोदन गर्नुहोस्",
        "reject": {
          "label": "अस्वीकार गर्नुहोस्",
          "confirmation": "के तपाईं यो प्रक्रिया अस्वीकार गर्न चाहनुहुन्छ?"
        },
        "unknown": "अज्ञात",
        "approveDesc": "अनुमोदन गर्नुहोस्",
        "rejectDesc": "अस्वीकार गर्नुहोस्"
      },
      "entityType": {
        "user": "प्रयोगकर्ता",
        "role": "भूमिका",
        "transaction": "लेनदेन",
        "unknown": "अज्ञात"
      },
      "status": {
        "pending": "KYC विचाराधीन",
        "approved": "कार्यप्रवाह सफलतापूर्वक अनुमोदित।",
        "rejected": "KYC अस्वीकार",
        "unknown": "अज्ञात"
      },
      "error": {
        "loadApprovals": "अनुमोदनहरू लोड गर्न असफल",
        "loadStats": "अनुमोदन तथ्याङ्कहरू लोड गर्न असफल",
        "approveFailed": "कार्यप्रवाह अनुमोदन गर्न असफल",
        "rejectFailed": "कार्यप्रवाह अस्वीकार गर्न असफल",
        "forbidden": "तपाईंसँग अनुमोदनहरू हेर्ने अनुमति छैन।"
      },
      "success": {
        "approved": "कार्यप्रवाह सफलतापूर्वक अनुमोदित।",
        "rejected": "कार्यप्रवाह अस्वीकृत।"
      },
      "rejectWorkflow": "कार्यप्रवाह अस्वीकार गर्नुहोस्",
      "rejectReasonMessage": "अस्वीकारको कारण प्रदान गर्नुहोस्। यो अनुरोधकर्तालाई देखिनेछ।",
      "rejectReasonPlaceholder": "अस्वीकारको कारण प्रविष्ट गर्नुहोस्…",
      "reject": "अस्वीकार गर्नुहोस्",
      "loadingPermissions": "अनुमतिहरू लोड गर्दै…",
      "loading": "अनुमोदन ड्यासबोर्ड लोड गर्दै…",
      "title": "अनुमोदनहरू",
      "pendingApprovals": "विचाराधीन अनुमोदनहरू",
      "todayPending": "आज विचाराधीन",
      "approvedWorkflows": "अनुमोदित कार्यप्रवाहहरू",
      "rejectedWorkflows": "अस्वीकृत कार्यप्रवाहहरू",
      "activeFilter": "सक्रिय फिल्टर:",
      "approved": "अनुमोदित",
      "rejected": "अस्वीकृत",
      "allWorkflows": "सबै कार्यप्रवाहहरू",
      "workflows": "कार्यप्रवाहहरू",
      "working": "काम गर्दै…",
      "refresh": "रिफ्रेस",
      "table": {
        "comment": "टिप्पणी",
        "type": "प्रकार",
        "action": "कार्य",
        "status": "स्थिति",
        "requestedBy": "अनुरोध गरेको",
        "requestedAt": "अनुरोध समय",
        "entityLabel": "इकाई",
        "actions": "कार्यहरू"
      },
      "approve": "अनुमोदन गर्नुहोस्",
      "empty": {
        "all": "कुनै कार्यप्रवाहहरू फेला परेन",
        "filtered": "हालको फिल्टरसँग मिल्ने कुनै कार्यप्रवाहहरू छैनन्"
      },
      "description": "प्रतीक्षारत कार्यप्रवाहको स्वीकृति/अस्वीकारको समीक्षा गर्नुहोस्"
    },
    "route": {
      "users": {
        "description": "प्रयोगकर्ताहरू, खाता स्थिति, र भूमिका असाइनमेन्ट व्यवस्थापन गर्नुहोस्"
      },
      "roles": {
        "description": "असाइन गर्न मिल्ने भूमिकाहरू र अनुमति सिमाना परिभाषित गर्नुहोस्"
      },
      "approvals": {
        "description": "विचाराधीन लगानी कारोबार अनुमोदनहरू, अपवाद निर्णयहरू, र एस्केलेसन नतिजाहरू समीक्षा गर्नुहोस्।"
      },
      "organization": {
        "description": "संगठन सेटिङ्स र कन्फिगरेसन व्यवस्थापन गर्नुहोस्"
      },
      "modules": {
        "description": "मोड्युल सदस्यता र टियर क्षमताहरू व्यवस्थापन गर्नुहोस्"
      },
      "system": {
        "description": "प्रणाली प्रशासन र डाटा सञ्चालनहरू"
      }
    },
    "accessInspector": {
      "platformRootRestriction": "प्लेटफ़ॉर्म रूट रिस्ट्रिक्शन",
      "restricted": "रिस्ट्रिक्टेड",
      "notRestricted": "प्रतिबन्धित छैन",
      "clientMode": "क्लाइंट मोड",
      "moduleEnabled": "मॉड्यूल सक्षम",
      "tierSatisfied": "टियर संतुष्ट",
      "permissionsSatisfied": "अनुमतिहरू पूरा भए",
      "adminRequired": "एडमिन आवश्यक",
      "resourceIdentifierRequired": "संसाधन पहचान आवश्यक",
      "title": "पहुँच निरीक्षक",
      "description": "प्रभावकारी अनुमति, स्कोप, मोड्युल अधिकार र पहुँच निर्णयको नीति आधार निरीक्षण गर्नुहोस्।",
      "accessDenied": "पहुँच अस्वीकृत",
      "accessDeniedDescription": "तपाईंलाई यस स्रोतमा पहुँचको अनुमति छैन।",
      "inspectAccessDecision": "पहुँच अनुमति निर्णय परीक्षण गर्नुहोस्",
      "resourceType": "संसाधन प्रकार",
      "selectResourceType": "स्रोत प्रकार छान्नुहोस्",
      "resourceTypes": {
        "route": "रूट",
        "action": "संसाधन प्रकार कार्य",
        "report": "रिपोर्ट",
        "dashboardCard": "डैशबोर्ड कार्ड"
      },
      "resourceIdentifier": "संसाधन पहचान",
      "httpMethod": "एचटीटीपी तरीका",
      "explaining": "व्याख्या",
      "explainAccess": "प्रवेश विवरण देने की अनुमति",
      "requestFailed": "मागच्या प्रयास विफल हो गया",
      "decisionSummary": "निर्णय सारांश",
      "allowed": "अनुमति दिया गया",
      "decision": "निर्णय",
      "reason": "कारण",
      "message": "प्रवेश निरीक्षक संदेश",
      "subjectContext": "विषय का संदर्भ",
      "userId": "प्रयोगकर्ता आईडी",
      "role": "भूमिका",
      "tier": "टियर",
      "organization": "संस्था",
      "branch": "शाखा",
      "clientAccount": "ग्राहक खाता",
      "functions": "कार्य",
      "requiredAccess": "आवश्यक प्रवेश",
      "requiredPermissions": "आवश्यक अनुमतिहरू",
      "requiredTier": "आवश्यक स्तर",
      "requiredModule": "आवश्यक मॉड्यूल",
      "individualChecks": "व्यक्तिगत जांच",
      "runExplainAccess": "पहुँच विवरण व्याख्या चलाउनुहोस्",
      "explainSuccess": "प्रवेश विवरण देने की अनुमति पूरा हो गया",
      "formTitle": "पहुँच निरीक्षक",
      "routeId": "मार्ग आईडी",
      "runExplainAccessDesc": "पहुँच विवरण व्याख्या चलाउनुहोस्",
      "userIdDesc": "प्रयोगकर्ता आईडी",
      "routeIdDesc": "पथ ID",
      "query": {
        "title": "पहुँच निर्णय निरीक्षण",
        "description": "हालको प्रमाणीकरण सन्दर्भमा एउटा क्यानोनिकल कार्य, रुट वा स्रोत मूल्याङ्कन गर्नुहोस्। अनुरोध गरिएको दायरा परीक्षणका लागि मात्र हो र यसले सत्र परिवर्तन गर्दैन।",
        "operationId": "कार्य ID",
        "routeId": "रुट ID",
        "resourceId": "स्रोत ID",
        "subjectUserId": "विषय प्रयोगकर्ता ID",
        "organizationId": "अनुरोध गरिएको संस्था ID",
        "branchId": "अनुरोध गरिएको शाखा ID",
        "clientAccountId": "अनुरोध गरिएको ग्राहक खाता ID",
        "portfolioId": "अनुरोध गरिएको पोर्टफोलियो ID",
        "inspect": "पहुँच निरीक्षण गर्नुहोस्",
        "clear": "खाली गर्नुहोस्",
        "result": "निर्णय व्याख्या",
        "noSelection": "निर्णय निरीक्षण गर्न कार्य, रुट वा स्रोत ID प्रविष्ट गर्नुहोस्।",
        "error": "पहुँच निर्णय निरीक्षण गर्न सकिएन। पहिचानहरू जाँच गरी पुनः प्रयास गर्नुहोस्।"
      }
    },
    "permissionBundles": {
      "loadError": "लोड त्रुटि",
      "createAccessRequired": "सृजन कर्ने की आवश्यकता छ",
      "functionsRequired": "कार्य अनिवार्य",
      "createError": "सृजन त्रुटि",
      "deleteAccessRequired": "हस्तांतरण अनिवार्य",
      "deleteError": "हस्तांतरण त्रुटि",
      "approveAccessRequired": "प्रमाणन कर्ने की आवश्यकता छ",
      "approveError": "प्रमाणन त्रुटि",
      "rejectAccessRequired": "प्रत्यारोपण अनिवार्य",
      "rejectionReasonRequired": "प्रत्यारोपण कारण अनिवार्य",
      "rejectError": "प्रत्यारोपण त्रुटि",
      "addPermissionError": "अनुमति जोड़ने की त्रुटि",
      "removePermissionError": "अनुमति हटाने की त्रुटि",
      "assignRoleError": "भूमिका नियुक्त करने की त्रुटि",
      "removeRoleError": "भूमिका हटाने की त्रुटि",
      "title": "अनुमति बन्डलहरू",
      "description": "अनुमति बंडल विवरण",
      "accessDenied": "पहुँच अस्वीकृत",
      "accessDeniedDescription": "प्रवेश नियंत्रण विवरण",
      "createBundle": "बंडल बनाना",
      "createTitle": "सिर्जना",
      "moduleDescription": "मॉड्यूल विवरण",
      "modulePlaceholder": "मोड्युल",
      "functions": "कार्यहरू",
      "functionsDescription": "कार्यहरू विवरण",
      "loadingFunctions": "कार्यहरू लोड हो रहे छं",
      "noFunctionsAvailable": "कार्यहरू उपलब्ध छैनन्",
      "creating": " बनाइरह्छ",
      "system": "प्रणाली",
      "inactive": "निष्क्रिय",
      "module": "मोड्युल",
      "permissions": "अनुमतिहरू",
      "roles": "भूमिकाहरू",
      "permissionList": "अनुमति की सूची",
      "noPermissionsAssigned": "अनुमति तोकिएको छैन",
      "selectPermission": "अनुमति चुन्नु",
      "noAvailablePermissions": "उपलब्ध अनुमति छैन",
      "addPermission": "अनुमति जोड्न",
      "roleList": "भूमिका की सूची",
      "noRolesAssigned": "भूमिका तोकिएको छैन",
      "selectRole": "भूमिका चुन्नु",
      "noAvailableRoles": "उपलब्ध भूमिकाहरू छैनन्",
      "assignRole": "भूमिका निर्दिष्ट कर्न",
      "approve": {
        "label": "अनुमोदन गर्नुहोस्",
        "success": "सफल रूप से मान्यता दिया गया"
      },
      "reject": {
        "label": "अस्वीकार गर्नुहोस्",
        "success": "सफलतापूर्वक अस्वीकार गरियो"
      },
      "deleteTitle": "अनुमति बंडल हटानो",
      "deleteDescription": "पूर्ण रूप से इस अनुमति बंडल को प्रणाली से हटाना छ।",
      "deleting": "खत्जना कर्ने",
      "deleteBundle": "बन्दु खत्जना कर्न",
      "rejectTitle": "अनुमति बंडल को प्रत्यारोपण कर्ने की अनुमति देना",
      "rejectDescription": "यस्तो अनुमति बंडल की मागच्या कुर्लाई गरिन्छ भने नोटिस गर्ने होला",
      "rejectionReason": "अस्वीकृति कारण:",
      "rejectionReasonPlaceholder": "अस्वीकृति कारण:",
      "rejecting": "अनुमति बंडल को प्रत्यारोपण कर्ने होला",
      "confirmRejection": "प्रत्यारोपण कुर्लाई गरिन्छ भने सहमति देना",
      "create": {
        "success": "अनुमति बंडल बनाएको सफल रह्यो"
      },
      "formTitle": "अनुमति बंडल",
      "name": "नाम",
      "actions": {
        "create": "सिर्जना",
        "createDesc": "सिर्जना",
        "edit": "सम्पादन गर्नुहोस्",
        "editDesc": "सम्पादन गर्नुहोस्",
        "delete": "मेटाउनुहोस्",
        "deleteDesc": "मेटाउनुहोस्",
        "deleteConfirmation": "यस्तो अनुमति बंडल को खत्जना गर्ने होला भने पुष्टि गर्नु होला",
        "approve": "अनुमोदन गर्नुहोस्",
        "approveDesc": "अनुमोदन गर्नुहोस्",
        "reject": "अस्वीकार गर्नुहोस्",
        "rejectDesc": "अस्वीकार गर्नुहोस्",
        "rejectConfirmation": "यस्तो अनुमति बंडल को प्रत्यारोपण न कर्ने होला भने पुष्टि गर्नु होला",
        "activate": "खाता सक्रिय गर्नुहोस्",
        "activateDesc": "अनुमति बंडल सक्षम गर्ने",
        "deactivate": "खाता निष्क्रिय गर्नुहोस्",
        "deactivateDesc": "अनुमति बंडल असक्षम गर्ने",
        "assignFunctions": "कार्य सौंपन",
        "assignFunctionsDesc": "कार्य सौंपन"
      },
      "emptyState": {
        "message": "अनुमति बंडल नाहोस। एक बंडल बनाएको होला"
      },
      "metrics": {
        "totalBundles": "सामग्री बंडल",
        "activeBundles": "सक्षम बंडल"
      },
      "createDesc": "सिर्जना",
      "edit": {
        "label": "सम्पादन गर्नुहोस्",
        "success": "संपादन सफल रह्यो"
      },
      "editDesc": "सम्पादन गर्नुहोस्",
      "delete": {
        "label": "मेटाउनुहोस्",
        "success": "खत्जना सफल रह्यो"
      },
      "deleteDesc": "मेटाउनुहोस्",
      "activate": {
        "label": "खाता सक्रिय गर्नुहोस्",
        "success": "सक्षम गर्ने सफल रह्यो"
      },
      "activateDesc": "अनुमति बंडल को सक्रिय कर्ने प्रमाण",
      "deactivate": {
        "label": "खाता निष्क्रिय गर्नुहोस्",
        "success": "सफलतापूर्वक अनुमति बंडल को निष्क्रिय कर्ने हो"
      },
      "deactivateDesc": "अनुमति बंडल को निष्क्रिय कर्ने प्रमाण",
      "assignFunctions": {
        "label": "विधि सौंपने लेबल",
        "success": "सफलतापूर्वी विधि सौंपने हो"
      },
      "assignFunctionsDesc": "अनुमति बंडल को विधि सौंपने प्रमाण",
      "nameDesc": "अनुमति बंडल नाम",
      "descriptionDesc": "अनुमति बंडल वर्णन",
      "table": {
        "name": "नाम",
        "nameDesc": "अनुमति बंडल नाम",
        "description": "अनुमति बंडल वर्णन",
        "descriptionDesc": "अनुमति बंडल वर्णन",
        "functionCount": "विधि संख्या",
        "functionCountDesc": "तोकिएका प्रकार्यहरूको संख्या",
        "roleUsageCount": "भूमिका उपयोगिता संख्या",
        "roleUsageCountDesc": "यस बन्डल प्रयोग गरिरहेका भूमिकाहरूको संख्या",
        "status": "स्थिति",
        "statusDesc": "वर्तमान सक्रियता स्थिति"
      },
      "archive": "पुस्तकालय",
      "archiveDesc": "अनुमति बंडल को पुस्तकालय मा रख्ने प्रमाण",
      "form": {
        "create": "अनुमति बंडल बनाने फॉर्म",
        "edit": "अनुमति बंडल संपादित करने फॉर्म",
        "assignFunctions": "अनुमति बंडल को विशेषाधिकार दाने का प्रयास कर",
        "reject": "अनुमति बंडल को अस्वीकृत कर",
        "createDescription": "नाम र विवरण सहित नयाँ अनुमति बन्डल बनाउनुहोस्।",
        "editDescription": "अनुमति बन्डलको नाम र विवरण सम्पादन गर्नुहोस्।",
        "assignFunctionsDescription": "यस अनुमति बन्डलका लागि विशेषाधिकार छान्नुहोस्।",
        "rejectDescription": "यस अनुमति बन्डललाई कारण सहित अस्वीकार गर्नुहोस्।",
        "name": "नाम",
        "nameRequired": "नाम आवश्यक छ",
        "namePlaceholder": "अनुमति बंडल नाम दर्ज गर्नुहोस्",
        "description": "विवरण",
        "descriptionPlaceholder": "इस अनुमति बंडल के लिए विवरण दर्ज गर्नुहोस्",
        "functions": "विशेषाधिकार",
        "functionsRequired": "कम से कम एक विशेषाधिकार आवश्यक छ",
        "functionsHint": "यस बन्डलले प्रदान गर्ने विशेषाधिकार छान्नुहोस्।",
        "rejectReason": "अस्वीकृति कारण:",
        "rejectReasonRequired": "प्रत्याक्षान कारण आवश्यक छ",
        "rejectReasonPlaceholder": "अनुमति बंडल को अस्वीकृत करने का कारण भर्नुहोस्"
      }
    },
    "settings": {
      "title": "सेटिङ्स",
      "description": "सेटिंग विवरण",
      "changeCaution": "परिवर्तन सावधानी",
      "highSeverityException": "उच्च गंभीरता अपवाद",
      "exceptionsPlural": "अपवाद प्लुरल",
      "detected": "खोजा गया",
      "deferChanges": "प्रत्येक परिवर्तन स्थगित गर्नुहोस्",
      "systemStatus": "सिस्टम स्थिति",
      "lastCheck": "अंतिम जांच",
      "pendingApprovals": "पेन्डिङ अनुमोदनहरू",
      "today": "आज",
      "auditEvents": "ऐतिहासिक घटनाहरू",
      "exceptionLoad": "विशेष मार्गदर्शन",
      "critical": "गम्भीर",
      "high": "उच्च",
      "runtimeHealthContext": "रनटाइम स्वास्थ्य परिदृश्य",
      "healthyServices": "स्वस्थ सेवाहरू",
      "degradedServices": "अवनत सेवाहरू",
      "downServices": "बन्द सेवाहरू",
      "configChangeWarning": "निर्देशित परिवर्तन सूचना"
    },
    "labels": {
      "unknown": {
        "role": "भूमिका",
        "tier": "टियर",
        "action": "अज्ञात कार्रवाई",
        "entity": "इकाई",
        "status": "अज्ञात स्थिति",
        "decision": "निर्णय",
        "reason": "कारण",
        "module": "मोड्युल"
      },
      "entity": {
        "default": "प्राथमिक",
        "import_job": "आयात कार्य",
        "import_job_row": "आयात रोड",
        "market_price": "बाजार मूल्य",
        "transaction": "लेनदेन",
        "opening_balance": "प्रारंभिक संतुलन",
        "corporate_action": "कॉर्पोरेट कार्रवाई",
        "portfolio_holding": "पोर्टफोलियो निवेश",
        "report_run": "प्रतिक्रिया प्रक्रिया",
        "report_export": "निकासी रिपोर्ट",
        "report_definition": "रिपोर्ट परिभाषा",
        "user": "प्रयोगकर्ता",
        "organization": "संस्था",
        "instrument": "उपकरण"
      },
      "actions": {
        "import": "आयात",
        "import_completed": "अनुप्रयोग पूर्ण",
        "import_failed": "आयात असफल भयो",
        "post": "पोस्ट",
        "apply": "प्राप्त गर्नुहोस्",
        "reconcile": "मिलान गर्नुहोस्",
        "valuation": "मूल्यांकन",
        "report": "रिपोर्ट",
        "export": "निकासी",
        "certify": "विश्वसनीयता प्रमाणित",
        "create_transaction": "व्यापारसम्बन्धी कारोबार सिर्जना गरियो",
        "update_transaction": "व्यापारसम्बन्धी कारोबार अद्यावधिक गरियो",
        "delete_transaction": "व्यापार संबंधी व्यवहार हटाया गया छ",
        "create_user": "नयाँ प्रयोगकर्ता सिर्जना गरियो",
        "update_user": "प्रयोगकर्ता अद्यावधिक गरियो",
        "delete_user": "प्रयोगकर्ता हटाइयो",
        "login": "लग इन गर्नुहोस्",
        "logout": "लग आउट गर्नुहोस्",
        "approve_self": "आत्म-मान्यता दे"
      },
      "accessMessage": {
        "default": "पहुँच सन्देश"
      }
    },
    "routeUnavailable": {
      "title": "पृष्ठ उपलब्ध छैन",
      "description": "यो पृष्ठ लोड गर्न सकिएन। कृपया पुनः प्रयास गर्नुहोस्।"
    },
    "clientAccountList": {
      "organizationScopeRequired": "संगठन की व्यापक आवश्यकता",
      "selectOrganization": "नियुक्ति गर्ने व्यवसाय को देख्ने का अनुरोध गर्छु"
    },
    "organization": {
      "title": "संस्था",
      "orgName": "संस्थाको नाम",
      "orgId": "व्यवसाय ID",
      "tier": "टियर",
      "settingsFormTitle": "व्यावसायिक सेटिङहरू",
      "name": "नाम",
      "organizationCode": "संस्थाको कोड",
      "legalName": "कानूनी नाम",
      "email": "इमेल",
      "phone": "फोन",
      "website": "वेबसाइट",
      "description": "व्यवसाय विवरण",
      "orgNameDesc": "संस्थाको नाम",
      "orgIdDesc": "व्यवसाय ID",
      "tierDesc": "टियर",
      "nameDesc": "नाम",
      "address": "गल्ली ठेगाना",
      "addressDesc": "गल्ली ठेगाना",
      "country": "देश",
      "timezone": "समय जोन",
      "baseCurrency": "मूल भण्डार",
      "locale": "भाषा"
    },
    "test": {
      "columns": {
        "sensitiveData": "संवेदनशील डेटा",
        "sensitiveDataDesc": "संवेदनशील डेटा"
      }
    },
    "actionResult": {
      "entityCreated": "नया संस्थापक बनाएको",
      "entityId": "संस्थापक ID",
      "entityType": "इकाइ प्रकार",
      "entityUpdated": "संस्थापक अद्यत्त गर्यो",
      "changedFields": "परिवर्तनका क्षेत्र",
      "status": "स्थिति",
      "statusError": "स्थिति त्रुटि",
      "exportCreated": "निर्यात बनाएको",
      "exportId": "निर्यात ID",
      "recordCount": "प्रति-रिकॉर्ड की संख्या",
      "download": "डाउनलोड गर्नुहोस्",
      "entityDeleted": "व्यवसायिक व्यक्तित्व हटाए गए",
      "refreshCompleted": "नई जानकारी अपडेट हो गई",
      "refreshedAt": "अद्यावधिक गरिएको समय",
      "affectedCount": "प्रभावित रिकॉर्ड की संख्या",
      "generic": "एउटा त्रुटि भयो। कृपया पुन: प्रयास गर्नुहोस्।"
    },
    "branchList": {
      "title": "शाखाहरू",
      "newBranch": "नयाँ शाखा",
      "createBranch": "शाखा सिर्जना गर्नुहोस्",
      "editBranch": "शाखा सम्पादन गर्नुहोस्",
      "view": "हेर्नुहोस्",
      "edit": "सम्पादन गर्नुहोस्",
      "operationFailed": "ऑपरेशन असफल हो गया",
      "table": {
        "code": "कोड",
        "name": "नाम",
        "email": "इमेल",
        "status": "स्थिति",
        "kyc": "KYC",
        "portfolios": "पोर्टफोलियोहरू",
        "actions": "कार्यहरू"
      },
      "form": {
        "code": "कोड",
        "codePlaceholder": "शाखा",
        "name": "नाम",
        "namePlaceholder": "शाखा नाम",
        "type": "प्रकार",
        "defaultCurrency": "प्राथमिक मुद्रा",
        "defaultCurrencyPlaceholder": "NPR",
        "timezone": "समय जोन",
        "timezonePlaceholder": "Asia/Kathmandu"
      }
    },
    "orgList": {
      "title": "व्यवसायिक संगठन",
      "newOrganization": "नया व्यवसायिक संगठन",
      "createOrganization": "संस्था बनाउनुहोस्",
      "editOrganization": "संस्था संपादित कर",
      "view": "हेर्नुहोस्",
      "edit": "सम्पादन गर्नुहोस्",
      "operationFailed": "ऑपरेशन विफल हो गया",
      "table": {
        "code": "कोड",
        "name": "नाम",
        "plan": "योजना",
        "status": "स्थिति",
        "created": "सिर्जना गरिएको",
        "actions": "कार्यहरू"
      },
      "form": {
        "code": "कोड",
        "codePlaceholder": "ORG001",
        "name": "नाम",
        "namePlaceholder": "संस्थाको नाम",
        "plan": "योजना",
        "status": "स्थिति"
      }
    },
    "moduleEntitlements": {
      "title": "मॉड्यूल अधिकार",
      "description": "सदस्यहरूको लागि मोड्युल पहुँच व्यवस्थापन गर्नुहोस्",
      "assign": "नियुक्त कर",
      "assignModule": "मॉड्यूल नियुक्त कर",
      "enabled": "सक्षम",
      "disabled": "अक्षम",
      "cancel": "बंद कर",
      "operationFailed": "ऑपरेशन विफल हो गया",
      "table": {
        "module": "मोड्युल",
        "description": "मॉड्यूल अधिकार वर्णन",
        "version": "संस्करण",
        "status": "स्थिति",
        "features": "विशेषताहरू",
        "branchAssignments": "शाखा नियुक्तियाँ",
        "actions": "कार्यहरू"
      },
      "form": {
        "assignTitle": "{{name}} लाई तोक्नुहोस्",
        "branchId": "शाखा ID",
        "branchIdPlaceholder": "शाखा",
        "enabled": "सक्षम"
      }
    },
    "auditLog": {
      "title": "प्रतिक्रिया लागू",
      "export": "निर्यात कर",
      "refresh": "रिफ्रेस गर्नुहोस्",
      "previous": "अघिल्लो",
      "next": "पछिल्लो",
      "pageOf": "पृष्ठ {{page}} of {{totalPages}}",
      "before": "पूर्व",
      "after": "पश्चात्त",
      "all": "सबै",
      "searchPlaceholder": "खोज्नुहोस् (व्यक्ति आईडी, प्रयोगकर्ता, आदि)",
      "filters": {
        "entityType": "इकाइ प्रकार",
        "action": "कार्य",
        "from": "बाट",
        "to": "सम्म"
      },
      "table": {
        "time": "समय",
        "entity": "इकाई",
        "action": "कार्य",
        "user": "प्रयोगकर्ता",
        "ipAddress": "IP पता",
        "details": "विवरण"
      },
      "entityTypes": {
        "TRANSACTION": "लेनदेन",
        "ACCOUNT": "खाता",
        "PARTY": "संस्था",
        "CORPORATE_ACTION": "कार्पोरेट कार्य",
        "RECONCILIATION": "मेलमिलाप",
        "REPORT": "रिपोर्ट",
        "USER": "प्रयोगकर्ता",
        "ORGANIZATION": "संस्था",
        "BRANCH": "शाखा",
        "MODULE": "मोड्युल"
      },
      "actions": {
        "CREATE": "सिर्जना",
        "UPDATE": "अद्यावधिक गर्नुहोस्",
        "DELETE": "मेटाउनुहोस्",
        "APPROVE": "अनुमोदन गर्नुहोस्",
        "REJECT": "अस्वीकार गर्नुहोस्",
        "POST": "पोस्ट",
        "REVERSE": "पीछे",
        "LOGIN": "लॉगिन",
        "LOGOUT": "आउट",
        "MFA_ENROLL": "MFA जोड़",
        "MFA_VERIFY": "MFA सत्यापित कर"
      },
      "exportSuccess": "अडिट घटनाहरू निर्यात गरियो।",
      "exportError": "अडिट घटनाहरू निर्यात गर्न सकिएन। फिल्टरहरू जाँच गरी पुनः प्रयास गर्नुहोस्।"
    },
    "profile": {
      "overview": "अवलोकन",
      "overviewDescription": "संगठन पहिचान र स्थिति",
      "details": "विवरणहरू",
      "detailsDescription": "प्रणालीद्वारा व्यवस्थापन गरिएका पहिचान र समय-मोहरहरू",
      "fields": {
        "name": "नाम",
        "legalName": "कानुनी नाम",
        "baseCurrency": "आधार मुद्रा",
        "jurisdiction": "क्षेत्राधिकार",
        "locale": "लोकेल",
        "timeZone": "समय क्षेत्र",
        "status": "स्थिति",
        "id": "आईडी",
        "createdAt": "सिर्जना मिति",
        "updatedAt": "अद्यावधिक मिति",
        "calendarSystem": "पात्रो प्रणाली"
      },
      "saveError": "संगठन प्रोफाइल सुरक्षित गर्न सकिएन। मानहरू जाँच गरी पुनः प्रयास गर्नुहोस्।",
      "saveSuccess": "संगठन प्रोफाइल सुरक्षित भयो।",
      "validation": {
        "nameRequired": "संगठनको नाम आवश्यक छ।",
        "currencyInvalid": "NPR वा USD जस्तो तीन-अक्षरको मुद्रा कोड प्रयोग गर्नुहोस्।"
      }
    },
    "userDetail": {
      "title": "प्रयोगकर्ता विवरण",
      "section": {
        "identity": "पहिचान",
        "security": "सुरक्षा",
        "securityDescription": "प्रमाणीकरण र खाता सुरक्षा"
      },
      "field": {
        "id": "प्रयोगकर्ता आईडी",
        "email": "इमेल",
        "firstName": "पहिलो नाम",
        "lastName": "थर",
        "status": "स्थिति",
        "aal": "आश्वासन स्तर",
        "mfaEnabled": "MFA सक्रिय",
        "lastLoginAt": "अन्तिम लगइन",
        "createdAt": "सिर्जना मिति"
      },
      "confirm": {
        "delete": {
          "title": "प्रयोगकर्ता निष्क्रिय बनाउनुहोस्"
        }
      }
    },
    "roleDetail": {
      "title": "भूमिका विवरण",
      "section": {
        "definition": "परिभाषा",
        "permissions": "अनुमतिहरू"
      },
      "field": {
        "code": "भूमिका कोड",
        "name": "भूमिकाको नाम",
        "status": "स्थिति",
        "description": "विवरण",
        "permissionCount": "अनुमति संख्या",
        "permissionSummary": "अनुमति सारांश"
      },
      "confirm": {
        "delete": {
          "title": "भूमिका निष्क्रिय बनाउनुहोस्"
        }
      }
    },
    "platformAccessInspector": {
      "title": "प्लेटफर्म पहुँच निरीक्षक",
      "identity": "पहिचान",
      "delegation": "प्रतिनिधि पहुँच",
      "permissions": "अनुमतिहरू",
      "modules": "मोड्युलहरू",
      "policy": "नीति"
    },
    "platformHealth": {
      "title": "प्लेटफर्म स्वास्थ्य",
      "description": "प्लेटफर्म स्वास्थ्य स्थिति",
      "overview": "विहंगावलोकन",
      "overallStatus": "समग्र स्थिति",
      "errorsDetected": "त्रुटिहरू भेटिए",
      "details": "विवरण",
      "noDetails": "कुनै विवरण उपलब्ध छैन"
    },
    "platformModules": {
      "title": "प्लेटफर्म मोड्युलहरू",
      "description": "प्लेटफर्म मोड्युल लाइसेन्सहरू व्यवस्थापन गर्नुहोस्",
      "licenses": "लाइसेन्सहरू",
      "noLicenses": "कुनै लाइसेन्स कन्फिगर गरिएको छैन",
      "organization": "संगठन",
      "maxBranches": "अधिकतम शाखाहरू",
      "maxUsers": "अधिकतम प्रयोगकर्ताहरू",
      "effectiveFrom": "लागू हुने मिति देखि",
      "effectiveTo": "लागू हुने मिति सम्म"
    },
    "maintenanceDelegations": {
      "title": "मर्मतसम्भार प्रतिनिधित्व",
      "description": "हरेक अनुदानका लागि AAL2, सहयोग टिकट, स्पष्ट क्षमता, ठ्याक्कै तोकिएका कार्य र लक्षित संस्थाको दायरा आवश्यक हुन्छ।",
      "createTitle": "मर्मत प्रतिनिधित्व सिर्जना गर्नुहोस्",
      "createDescription": "सहयोग प्रयोगकर्ता, लक्षित दायरा, उद्देश्य, क्षमता र कार्य चयन गर्नुहोस्। अनुदान बढीमा २४ घण्टाका लागि मान्य हुन्छ।",
      "viewTitle": "मर्मत प्रतिनिधित्व विवरण",
      "viewDescription": "स्वीकृत दायरा, क्षमता, कार्य, नीति र सक्रिय सत्र अवस्था समीक्षा गर्नुहोस्।",
      "revokeTitle": "मर्मत प्रतिनिधित्व रद्द गर्नुहोस्",
      "revokeDescription": "रद्द गर्दा सक्रिय प्रतिनिधित्व सत्र तुरुन्त समाप्त हुन्छ।",
      "columns": {
        "supportUserIdentityId": "सहयोग प्रयोगकर्ता",
        "targetOrganizationId": "संस्था",
        "purpose": "उद्देश्य",
        "ticketReference": "टिकट",
        "status": "स्थिति",
        "effectiveFrom": "लागू हुने समय",
        "expiresAt": "समाप्त हुने समय",
        "sessionStartedAt": "सत्र सुरु",
        "sessionEndedAt": "सत्र समाप्त",
        "policyVersion": "नीति संस्करण"
      },
      "fields": {
        "supportUserIdentityId": "प्लेटफर्म सहयोग प्रयोगकर्ता",
        "targetOrganizationId": "लक्षित संस्था",
        "targetBranchId": "लक्षित शाखा",
        "targetClientAccountId": "लक्षित ग्राहक खाता",
        "targetPortfolioAccountId": "लक्षित पोर्टफोलियो खाता",
        "purpose": "मर्मतसम्भार उद्देश्य",
        "justification": "व्यावसायिक औचित्य",
        "ticketReference": "सहयोग टिकट",
        "capabilities": "प्रतिनिधित्व गरिएका क्षमता",
        "allowedOperationIds": "अनुमति प्राप्त कार्य",
        "resourceIds": "सीमित स्रोत",
        "effectiveFrom": "लागू हुने समय",
        "expiresAt": "समाप्त हुने समय",
        "reason": "रद्द गर्ने कारण",
        "requiredAal": "आवश्यक प्रमाणीकरण स्तर",
        "policyVersion": "नीति संस्करण",
        "status": "स्थिति",
        "sessionStartedAt": "सत्र सुरु",
        "sessionEndedAt": "सत्र समाप्त"
      },
      "help": {
        "supportUserIdentityId": "स्वीकृतकर्ताभन्दा फरक सक्रिय प्लेटफर्म सहयोग पहिचान चयन गर्नुहोस्।",
        "targetOrganizationId": "मर्मत गर्न सकिने डाटा र कन्फिगरेसन भएको संस्था।",
        "targetBranchId": "आवश्यक भए लक्षित संस्थाको एउटा शाखामा पहुँच सीमित गर्नुहोस्।",
        "targetClientAccountId": "आवश्यक भए एउटा ग्राहक खातामा पहुँच सीमित गर्नुहोस्।",
        "targetPortfolioAccountId": "पोर्टफोलियो दायराका लागि मिल्दो ग्राहक खाता आवश्यक हुन्छ।",
        "purpose": "मर्मत पहुँचको स्वीकृत सञ्चालन कारण चयन गर्नुहोस्।",
        "justification": "प्रतिनिधित्व पहुँच किन आवश्यक छ र के निरीक्षण वा परिवर्तन गरिनेछ भन्ने वर्णन गर्नुहोस्।",
        "ticketReference": "यो काम स्वीकृत गर्ने घटना, सहयोग वा परिवर्तन टिकट प्रविष्ट गर्नुहोस्।",
        "capabilities": "क्षमताले अनुमति प्राप्त कामको अधिकतम वर्ग निर्धारण गर्छ।",
        "allowedOperationIds": "प्रतिनिधित्व सत्रमा यिनै क्यानोनिकल कार्य मात्र चलाउन सकिन्छ।",
        "resourceIds": "आवश्यक भए अनुदानलाई विशिष्ट क्यानोनिकल स्रोतमा सीमित गर्नुहोस्।",
        "effectiveFrom": "यो समयभन्दा अघि अनुदान प्रयोग गर्न सकिँदैन।",
        "expiresAt": "अनुदान लागू भएको समयदेखि २४ घण्टाभित्र समाप्त हुनुपर्छ।",
        "reason": "अनुदान किन रद्द गरिँदैछ भन्ने वर्णन गर्नुहोस्।"
      },
      "actions": {
        "create": "प्रतिनिधित्व सिर्जना गर्नुहोस्",
        "revoke": "रद्द गर्नुहोस्",
        "confirmRevoke": "रद्द पुष्टि गर्नुहोस्"
      },
      "purpose": {
        "FAILED_IMPORT_INVESTIGATION": "असफल आयात अनुसन्धान",
        "DATA_MIGRATION": "डाटा माइग्रेसन",
        "CONFIGURATION_CORRECTION": "कन्फिगरेसन सुधार",
        "CALCULATION_DEFECT_INVESTIGATION": "गणना त्रुटि अनुसन्धान",
        "MARKET_DATA_MAPPING_REPAIR": "बजार-डाटा म्यापिङ मर्मत",
        "RECONCILIATION_SUPPORT": "मिलान सहयोग",
        "ORGANIZATION_ADMINISTRATION_ASSISTANCE": "संगठन प्रशासन सहायता",
        "PRODUCTION_REMEDIATION_VALIDATION": "उत्पादन सुधार प्रमाणीकरण",
        "AUDIT_SUPPORT": "अडिट सहयोग",
        "ACCESS_TROUBLESHOOTING": "पहुँच समस्या समाधान"
      },
      "capability": {
        "ORG_CONFIG_VIEW": "संगठन कन्फिगरेसन हेर्नुहोस्",
        "ORG_CONFIG_MANAGE": "संगठन कन्फिगरेसन व्यवस्थापन गर्नुहोस्",
        "ORG_IDENTITY_VIEW": "संगठन पहिचान हेर्नुहोस्",
        "ORG_IDENTITY_MANAGE": "संगठन पहिचान व्यवस्थापन गर्नुहोस्",
        "ORG_AUDIT_VIEW": "संगठन अडिट हेर्नुहोस्",
        "ORG_DATA_VIEW": "संगठन डाटा हेर्नुहोस्",
        "ORG_DATA_CORRECT": "संगठन डाटा सुधार गर्नुहोस्",
        "ORG_IMPORT_RETRY": "संगठन आयात पुनः प्रयास गर्नुहोस्",
        "ORG_RECONCILIATION_VIEW": "मिलान हेर्नुहोस्",
        "ORG_RECONCILIATION_MANAGE": "मिलान व्यवस्थापन गर्नुहोस्",
        "ORG_REPORT_VIEW": "प्रतिवेदन हेर्नुहोस्",
        "ORG_REPORT_RUN": "प्रतिवेदन चलाउनुहोस्",
        "ORG_FINANCIAL_EXPORT": "वित्तीय डाटा निर्यात गर्नुहोस्",
        "ORG_ACCESS_INSPECT": "पहुँच निर्णय निरीक्षण गर्नुहोस्"
      }
    },
    "marketCalendar": {
      "cardTitle": "बजार पात्रो",
      "cardDescription": "मूल्याङ्कन र बजार डेटा ताजगी जाँचमा प्रयोग हुने नियमित एक्सचेन्ज बन्द दिन र बिदा/विशेष खुला मितिहरू सेट गर्नुहोस्।",
      "title": "बजार पात्रो",
      "subtitle": "यस संस्करणको एकल एक्सचेन्जका लागि हालको वा पुरानो बजार मूल्य निर्धारण गर्दा प्रयोग हुने कारोबार तालिका कन्फिगर गर्नुहोस्।",
      "currentStatus": "हालको सेटअप",
      "statusConfigured": "कन्फिगर गरिएको",
      "statusNeedsSetup": "सेटअप आवश्यक",
      "version": "पात्रो संस्करण {{version}}",
      "noVersion": "अहिलेसम्म स्वीकृत पात्रो संस्करण छैन",
      "exchangeNotDetected": "एक्सचेन्ज पहिचान भएन",
      "scheduleTitle": "नियमित कारोबार तालिका",
      "exchange": "एक्सचेन्ज",
      "exchangeDetectedHelp": "सक्रिय इन्स्ट्रुमेन्टबाट स्वतः पहिचान गरिएको।",
      "exchangeManualHelp": "इन्स्ट्रुमेन्ट लोड हुनुअघि पात्रो कन्फिगर गर्दा एक्सचेन्ज कोड प्रविष्ट गर्नुहोस्।",
      "timeZone": "बजार समय क्षेत्र",
      "timeZoneHelp": "Asia/Kathmandu जस्तो IANA समय क्षेत्र प्रयोग गर्नुहोस्।",
      "closedWeekdays": "नियमित बन्द दिन",
      "closedWeekdaysHelp": "एक्सचेन्ज सामान्यतया बन्द हुने हप्ताका दिनहरू छान्नुहोस्।",
      "closedWeekdaysRequired": "कम्तीमा एउटा नियमित बन्द दिन छान्नुहोस्।",
      "exceptionsTitle": "विशेष कारोबार दिन",
      "closedDates": "बिदा / बन्द मितिहरू",
      "closedDatesHelp": "YYYY-MM-DD मितिहरू प्रति लाइन एउटा वा अल्पविरामले छुट्याएर राख्नुहोस्।",
      "openDates": "विशेष खुला मितिहरू",
      "openDatesHelp": "नियमित तालिका अनुसार बन्द भए पनि एक्सचेन्ज खुला हुने मितिहरू राख्नुहोस्।",
      "stopgapNotice": "यो V1 एकल-एक्सचेन्ज सेटअप हो। सेभ गर्दा मूल्याङ्कन, रिपोर्टिङ र प्रि-ट्रेड बजार-मूल्य ताजगी जाँचले प्रयोग गर्ने स्वीकृत, संस्करणयुक्त पात्रो सिर्जना हुन्छ।",
      "readOnlyNotice": "तपाईं स्वीकृत पात्रो हेर्न सक्नुहुन्छ, तर परिवर्तन गर्न बजार डेटा व्यवस्थापन अनुमति आवश्यक छ।",
      "saving": "सेभ हुँदैछ…",
      "saveSuccess": "बजार पात्रो सेभ भयो।",
      "saveError": "बजार पात्रो सेभ गर्न सकिएन।",
      "loadError": "बजार पात्रो लोड गर्न सकिएन।",
      "closedDatesPlaceholder": "YYYY-MM-DD",
      "openDatesPlaceholder": "YYYY-MM-DD",
      "weekdays": {
        "short": {
          "0": "आइत",
          "1": "सोम",
          "2": "मंगल",
          "3": "बुध",
          "4": "बिही",
          "5": "शुक्र",
          "6": "शनि"
        }
      }
    }
  },
  "accounting": {
    "code": "कोड",
    "name": "नाम",
    "type": "प्रकार",
    "group": "समूह",
    "balance": "व्यय",
    "status": "स्थिति",
    "noGroup": "कुनै समूह छैन",
    "bankReconciliation": {
      "title": "बैंक मेलमिलाप",
      "refreshAccounts": " खाता पुनर्प्राप्ति",
      "startReconciliation": "पुनर्प्राप्ति शुरू कर",
      "newReconciliation": "नया सुधार",
      "bankAccount": "बैंक खाता",
      "select": "चयन करो",
      "statementDate": "वृत्तांत तिथि",
      "statementBalance": "वृत्तांत संतुलन",
      "bookBalance": "बुक संतुलन",
      "difference": "फरक",
      "date": "मिति",
      "description": "बैंक सुधार विवरण",
      "amount": "मात्रा",
      "matched": "सहमति",
      "matching": "मिलान गर्नु",
      "autoMatch": "ऑटो सहमति",
      "completing": "पूर्ण होना",
      "completeReconciliation": "पूर्ण सुधार",
      "noBankAccounts": "बैंक खाताहरू छैनन्",
      "starting": "सुरु गर्दै",
      "start": "शुरू करो",
      "cancel": "रद्द करो",
      "saving": "बचत गर्दै…",
      "add": "जोड़"
    },
    "chartOfAccounts": {
      "title": "हिसाब किताब",
      "loading": "खाता लोड हुँदैछ...",
      "failedToLoadAccounts": "अकाउंट लोड गर्न विफल रहा",
      "failedToLoadGroups": "खाता समूहहरू लोड गर्न सकिएन",
      "failedToCreateAccount": "खाता बनाने मा विफल रहा",
      "failedToCreateInvestmentAccounts": "निवेश खातों को बनाने मा विफल रहा",
      "autoCreateInvestmentAccounts": "ऑटो बनाए गए निवेश खाते",
      "newAccount": "नया खाता"
    },
    "journalList": {
      "title": "जर्नल प्रविष्टिहरू",
      "loadingJournals": "जर्नलहरू लोड गर्दै…",
      "failedToLoad": "जर्नल प्रविष्टिहरू लोड गर्न असफल",
      "failedToLoadDetails": "जर्नल विवरणहरू लोड गर्न असफल",
      "failedToPost": "जर्नल प्रविष्टि पोस्ट गर्न असफल",
      "journalEntry": "जर्नल प्रविष्टि",
      "journalEntryPosted": "जर्नल प्रविष्टि पोस्ट गरियो",
      "journalEntryPostedMessage": "जर्नल प्रविष्टि सफलतापूर्वक लेजरमा पोस्ट गरियो।",
      "postFailed": "पोस्ट असफल",
      "posting": "पोस्ट गर्दै…",
      "postJournalEntry": "जर्नल प्रविष्टि पोस्ट गर्नुहोस्",
      "refresh": "रिफ्रेस गर्नुहोस्",
      "date": "मिति:",
      "ref": "सन्दर्भ:",
      "account": "खाता",
      "debit": "डेबिट",
      "credit": "क्रेडिट",
      "description": "विवरण",
      "entryNumber": "प्रविष्टि #",
      "reference": "सन्दर्भ",
      "status": "स्थिति",
      "draft": "ड्राफ्ट",
      "posted": "पोस्ट गरियो",
      "reversed": "उल्टाइयो",
      "post": "पोस्ट",
      "noJournalEntries": "अहिले कुनै जर्नल प्रविष्टिहरू छैन।"
    }
  },
  "ui": {
    "pageContractNotFound": "पृष्ठ सम्झौता फेला परेन",
    "pageNotAccessible": "पेज असंगत छ",
    "accessibleButton": {
      "loading": "लोड हुँदै..."
    },
    "dashboardClientSelector": {
      "selectClientAccount": "क्लाइन्ट खाता चयन गर्नुहोस्",
      "allClientAccounts": "सबै क्लाइन्ट खाताहरू"
    },
    "monthlyPnl": {
      "realizedOnly": "केवल साकारिकृत P&L — असाकारिकृत लाभ/हानि बाहेक।",
      "realizedAmount": "साकारिकृत रकम",
      "ariaLabel": "मासिक नाफा/नोक्सान",
      "title": "मासिक नाफा/नोक्सान",
      "dataWillAppearAfterRealized": "कारोबारहरू realized भएपछि डाटा देखिनेछ",
      "dataSourceRecovering": "डाटा स्रोत पुनःस्थापित हुँदै हुन सक्छ। कृपया केही समयपछि फेरि प्रयास गर्नुहोस्।",
      "viewReportAriaLabel": "मासिक realized नाफा/नोक्सान रिपोर्ट हेर्नुहोस्",
      "chartAriaLabel": "मासिक realized नाफा/नोक्सान चार्ट",
      "subtitle": "realized नाफा/नोक्सान · पछिल्ला ६ महिना",
      "netRealized": "कुल realized",
      "barChartAriaLabel": "मासिक realized नाफा/नोक्सान बार चार्ट"
    },
    "nfrsPortfolio": {
      "portfolioValueMtm": "पोर्टफोलियो मूल्य (MTM)",
      "unrealizedGainPnL": "अप्राप्त नाफा / नोक्सान",
      "totalInvestment": "कुल लगानी",
      "realizedGainPnL": "प्राप्त नाफा / नोक्सान (NFRS)",
      "loadingAria": "NFRS अनुसार पोर्टफोलियो लोड हुँदै",
      "unavailableAria": "NFRS अनुसार पोर्टफोलियो उपलब्ध छैन",
      "reportNotAvailableTitle": "NFRS रिपोर्ट उपलब्ध छैन"
    },
    "recentActivity": {
      "ariaLabel": "हालको गतिविधि",
      "title": "हालको गतिविधि",
      "viewAllAuditActivityAria": "सबै अडिट गतिविधि हेर्नुहोस्",
      "viewAll": "सबै हेर्नुहोस्",
      "noRecentActivityYet": "हालसम्म कुनै गतिविधि छैन।",
      "eventsWillAppearHere": "सञ्चालन र अडिट घटनाहरू यहाँ देखिनेछन्।"
    },
    "transactionExport": {
      "permissionRequired": "निर्यात अनुमति आवश्यक छ",
      "exportFilteredTransactions": "फिल्टर गरिएका कारोबार निर्यात गर्नुहोस्"
    },
    "transactionTable": {
      "requestReversal": "उल्ट्याउने अनुरोध गर्नुहोस्"
    },
    "portfolioOwnershipSettings": {
      "title": "पोर्टफोलियो स्वामित्व मोडेल",
      "description": "नयाँ पोर्टफोलियोका लागि पूर्वनिर्धारित स्वामित्व प्रकार कन्फिगर गर्नुहोस्।",
      "organizationPortfolios": "संस्थागत पोर्टफोलियोहरू",
      "organizationPortfoliosDescription": "संस्थाकै लागि व्यवस्थापन गरिने स्वामित्व वा ट्रेजरी खाताहरू हुन्।",
      "clientPortfolios": "ग्राहक पोर्टफोलियोहरू",
      "clientPortfoliosDescription": "व्यक्तिगत ग्राहकहरूको तर्फबाट व्यवस्थापन गरिन्छ।"
    },
    "portfolioView": {
      "loadingHoldingsTitle": "होल्डिङहरू लोड हुँदै",
      "loadingHoldingsDescription": "मूल्यांकन, पोजिसन, र मूल्य स्थिति ल्याउँदै।",
      "pricingSource": {
        "quoted": "कोट गरिएको",
        "mixed": "मिश्रित",
        "costBasis": "लागत आधार"
      },
      "costBasisLabel": "कुल लगानी / लागत आधार",
      "totalUnitsLabel": "{{units}} एकाइ",
      "currentMarketValueLabel": "वर्तमान बाजार मूल्य लेबल",
      "pricesAsOf": "कीमतें तिथि से",
      "officialSnapshotValueLine": "ऑफिशियल स्नैपशॉट मूल्य रेखा",
      "dashboardPortfolioValueMatches": "ड्यासबोर्ड पोर्टफोलियो मूल्य यो कुलसँग मेल खान्छ।",
      "unrealizedPnL": "अप्राप्त नाफा/नोक्सान",
      "unrealizedLossLabel": "नोक्सान",
      "unrealizedFromCanonicalCurrentMarketValuation": "सामान्य वर्तमान बाजार मूल्य से अनजान हुआ",
      "xirrLabel": "XIRR लेबल",
      "annualizedReturn": "वार्षिकीकरण गरिएको प्रतिफल",
      "allHoldings": "सबै होल्डिङहरू",
      "positionsInPortfolio": "पोर्टफोलियोमा {{count}} पोजिसन{{plural}}",
      "viewCostBasis": "लागत आधार हेर्नुहोस्",
      "recalculatePortfolio": "पोर्टफोलियो पुनर्गणना गर्नुहोस्",
      "costBasisDataTitle": "लागत आधार डाटा",
      "costBasisDataDescription": "बजार मूल्य बिना कच्चा लागत-आधार डाटा। यसले मात्रा, भारित औसत लागत, र कुल लागत देखाउँछ।",
      "failedToLoadCostBasisData": "लागत-आधार डाटा लोड गर्न असफल",
      "recalculationScopeUnsupported": "पुनर्मूल्यांकन क्षेत्र असमर्थ",
      "valueUnavailable": "मूल्य उपलब्ध छैन",
      "valuationDiagnosticsDelta": "मूल्य विश्लेषण डेल्टा",
      "visibleRowTotal": "दृश्यमान रो व्यय कुल",
      "canonicalCurrentMarketValue": "सामान्य वर्तमान बाजार मूल्य",
      "deltaValue": "डेल्टा मूल्य",
      "scopeClientAccount": "ग्राहक खाता: {{clientAccountId}}",
      "scopePortfolio": "पोर्टफोलियो: {{portfolioId}}",
      "scopeAsOfDate": "मिति अनुसार: {{asOfDate}}",
      "recalculationFailed": "पोर्टफोलियो पुनर्गणना असफल भयो",
      "recalculationUnexpectedError": "पुनर्गणनाका क्रममा अप्रत्याशित त्रुटि भयो",
      "costBasisLoadFailed": "लागत-आधार डाटा लोड गर्न असफल",
      "unableToLoadHoldings": "होल्डिङहरू लोड गर्न सकिएन",
      "currentMarketValueUnavailable": "वर्तमान बाजार मूल्य उपलब्ध छैन",
      "dashboardPortfolioValueDelta": "ड्यासबोर्ड पोर्टफोलियो मूल्य: {{dashboardValue}} (फरक {{delta}})",
      "unrealizedGainLabel": "नाफा",
      "zeroUntilQuotesConfigured": "कोट कन्फिगर नभएसम्म शून्य",
      "noCostBasisAccess": "लागत-आधार डाटामा पहुँच छैन",
      "viewCostBasisAriaDisabled": "लागत आधार हेर्नुहोस् निष्क्रिय: लागत-आधार डाटामा पहुँच छैन",
      "noRecalculationAccess": "पोर्टफोलियो पुनर्गणनामा पहुँच छैन",
      "recalculatePortfolioAriaDisabled": "पोर्टफोलियो पुनर्गणना निष्क्रिय: पुनर्गणनामा पहुँच छैन",
      "recalculating": "पुनर्गणना हुँदै...",
      "loadingCostBasisTitle": "लागत-आधार डाटा लोड हुँदै",
      "loadingCostBasisDescription": "बजार मूल्य बिना कच्चा होल्डिङहरू ल्याउँदै।",
      "unableToLoadCostBasisData": "लागत-आधार डाटा लोड गर्न सकिएन",
      "costBasisHoldings": "लागत आधार होल्डिङहरू",
      "costBasisOnlyDescription": "{{count}} पोजिसन{{plural}} - लागत आधार मात्र",
      "noCostBasisRows": "लागत-आधार पंक्ति छैन",
      "noCostBasisRowsDescription": "हाल लागत-आधार मोडमा कुनै होल्डिङ उपलब्ध छैन।"
    },
    "backend": {
      "factOrchestrator": {
        "importFactTransactionNotFound": "फैक्ट ट्रांजेक्शन को आयात करने मा विफल रहा",
        "missingClientOrInstrumentScope": "अपूर्ण क्लाइंट या साधन की व्याख्या",
        "saleNoDisposalEvidence": "बिक्रीमा निष्कासन प्रमाण छैन"
      }
    },
    "setupWizard": {
      "selectExcelFile": "Excel फाइल छान्नुहोस् (.xlsx / .xls)",
      "errorLabel": "त्रुटि:",
      "startWithoutImport": "आयात बिना सुरु गर्नुहोस्"
    },
    "dataMatrixTable": {
      "noDataToDisplay": "देखाउन कुनै डाटा छैन"
    },
    "companySettings": {
      "moduleAccess": "मोड्युल पहुँच"
    },
    "profitLossLineChart": {
      "realizedLabelSuffix": "- वास्तविक:",
      "unrealizedLabelSuffix": "- अवास्तविक:"
    },
    "settingsFormShell": {
      "unsupportedFieldType": "असमर्थित फिल्ड प्रकार:"
    },
    "approvalWorkQueue": {
      "title": "स्वीकृति कार्य क्यु",
      "pendingDescriptionPrefix": "पेन्डिङ कारोबारहरू समीक्षा र स्वीकृत गर्नुहोस्",
      "pendingSuffix": "पेन्डिङ)",
      "unableToLoadApprovals": "स्वीकृति सूची लोड गर्न सकिएन",
      "noPendingTransactions": "समीक्षा गर्न कुनै पेन्डिङ कारोबार छैन",
      "transactionIdLabel": "कारोबार ID:",
      "statusLabel": "स्थिति:",
      "rejectionReasonLabel": "अस्वीकृति कारण:"
    },
    "transactionGrid": {
      "title": "बल्क कारोबार प्रविष्टि",
      "description": "स्प्रेडसिट-जस्तो इन्टरफेसमा धेरै कारोबार प्रविष्ट गर्नुहोस्। फिल्डहरू बीच जान Tab प्रयोग गर्नुहोस्।",
      "clientAccountRequired": "ग्राहक खाता *",
      "selectClientAccount": "ग्राहक खाता छान्नुहोस्...",
      "columns": {
        "billNo": "बिल नं",
        "pricePerUnit": "मूल्य/युनिट",
        "totalAmount": "कुल रकम"
      },
      "selectCompany": "कम्पनी छान्नुहोस्",
      "billNumberPlaceholder": "बिल #",
      "autoCalculated": "स्वतः गणना",
      "addRow": "पंक्ति थप्नुहोस्",
      "quickEntryTipsTitle": "छिटो प्रविष्टि सुझावहरू:",
      "quickTips": {
        "useTab": "- फिल्डहरू बीच जान Tab कुञ्जी प्रयोग गर्नुहोस्",
        "useArrows": "- माथि/तल नेभिगेट गर्न एरो कुञ्जीहरू प्रयोग गर्नुहोस्",
        "autoTotal": "- कुल रकम स्वतः गणना हुन्छ",
        "validateOnSave": "- सुरक्षित गर्दा फिल्डहरू प्रमाणीकरण हुन्छन्",
        "emptyRowsIgnored": "- सुरक्षित गर्दा खाली पंक्तिहरू बेवास्ता हुन्छन्"
      }
    },
    "transactionListController": {
      "retryTransactions": "कारोबार पुनः प्रयास गर्नुहोस्"
    },
    "errorState": {
      "requestIdLabel": "अनुरोध आईडी:"
    },
    "dashboardHeader": {
      "pricesSynced": "मूल्य समक्रमण",
      "instruments": "इन्स्ट्रुमेन्ट",
      "failedImports": "असफल आयात"
    },
    "dataQualityBadge": {
      "dataQualityIssues": "डाटा गुणस्तर समस्याहरू"
    },
    "pageShell": {
      "errorTitle": "त्रुटि",
      "nothingToShowYet": "अहिलेसम्म देखाउन केही छैन"
    },
    "pageRouteRenderer": {
      "errorLoadingPage": "पृष्ठ लोड गर्दा त्रुटि भयो"
    },
    "holdingsReportRuntime": {
      "title": "होल्डिङ प्रतिवेदन",
      "description": "बजार मूल्य र लागत आधार सहितका हालका पोर्टफोलियो स्थितिहरू"
    },
    "taxPage": {
      "title": "कर रिपोर्टहरू",
      "description": "कर अनुपालन रिपोर्टहरू, VAT फाइलिङ, IRD निर्यात, र पूँजीगत लाभ विश्लेषण हेर्नुहोस्।",
      "attentionRequired": "ध्यान आवश्यक",
      "attentionDescription": "कर निर्यात प्रमाणित गर्नु अघि डाटा गुणस्तर र अनुपालन कार्यप्रवाह समीक्षा गर्नुहोस्।",
      "filingStatus": "फाइलिङ स्थिति",
      "attentionNeeded": "ध्यान आवश्यक",
      "ready": "तयार",
      "checkTaxCalendarForDeadlines": "अन्तिम मितिका लागि कर पात्रो जाँच गर्नुहोस्",
      "upcomingDeadline": "आगामी अन्तिम मिति",
      "notAvailable": "उपलब्ध छैन",
      "checkTaxCalendar": "कर पात्रो जाँच गर्नुहोस्",
      "estimatedTax": "अनुमानित कर",
      "unrealizedLabel": "अप्राप्त:",
      "complianceBreakdown": "अनुपालन ब्रेकडाउन",
      "concentrationBreaches": "एकाग्रता उल्लङ्घनहरू",
      "criticalExceptions": "गम्भीर अपवादहरू",
      "highExceptions": "उच्च अपवादहरू",
      "recentTaxActivity": "हालको कर गतिविधि",
      "noRecentTaxAuditEvents": "हालको गतिविधिमा कर-विशिष्ट अडिट घटनाहरू फेला परेनन्।"
    },
    "settingsHub": {
      "tierLabel": "टियर",
      "configureLink": "सेटअप लिङ्क स्थापना गर्नुहोस्",
      "description": "आफ्नो संस्था, मोड्युल, र एकीकरणहरू कन्फिगर गर्नुहोस्",
      "governanceAlert": "शासन चेतावनी",
      "detectedSuffix": "पत्ता लाग्यो।",
      "validateModuleChanges": "मोड्युल-सम्बन्धित परिवर्तनहरू हालको सञ्चालन जोखिमसँग मिलाएर प्रमाणीकरण गर्नुहोस्।",
      "modulesAndOfferings": "मोड्युल र अफरिङहरू",
      "dangerZone": "जोखिम क्षेत्र",
      "permanentDeleteWarning": "संस्थासम्बन्धी सबै डाटा स्थायी रूपमा मेटिन्छ। यो फिर्ता गर्न सकिँदैन।"
    }
  },
  "cgt": {
    "title": "धन की लाभ मूल्य व्याख्या",
    "description": "पुँजी लाभ मूल्य गणना र दायित्व रिपोर्ट हेर्नुहोस्।"
  },
  "portfolio": {
    "positive": "सकारात्मक",
    "negative": "नकारात्मक",
    "holdingsTable": {
      "missingFacts": "विवरण छोड़ दिए गए छं",
      "dataIssue": "डेटा समस्या",
      "missingPrices": "मूल्य छुटेका छन्",
      "stalePrices": "पुराने मूल्य",
      "instrument": "उपकरण",
      "groupingRequiresContext": "होल्डिङहरू समूहबद्ध गर्न क्वेरी सन्दर्भ आवश्यक छ।",
      "transactions": "कारोबारहरू",
      "qty": "मात्रा",
      "price": "मूल्य",
      "value": "मान",
      "pl": "नाफा/नोक्सान",
      "return": "फिर्ती",
      "avgCost": "औसत लागत",
      "actions": "कार्यहरू",
      "none": "कुनै पनि",
      "sector": "क्षेत्र",
      "instrumentType": "उपकरण प्रकार",
      "unassigned": "निर्धारित गरिएको छैन",
      "portfolioHoldings": "पोर्टफोलियो होल्डिङहरू",
      "detailedHoldings": "लागत आधार र हालको मूल्यांकनसहित विस्तृत होल्डिङहरू",
      "groupedHoldingsRequireContext": "समूहबद्ध होल्डिङहरूलाई स्कोप गरिएको क्वेरी सन्दर्भ आवश्यक छ। समूहबद्ध गर्न खाली गर्नुहोस् वा स्कोप गरिएको रिपोर्ट दृश्यबाट यो तालिका खोल्नुहोस्।"
    },
    "excellent": "उत्कृष्ट",
    "ge15PercentReturn": "≥ १५% रिटर्न",
    "good": "राम्रो",
    "tenTo15PercentReturn": "१०–१५% रिटर्न",
    "fiveTo10PercentReturn": "५–१०% रिटर्न",
    "fair": "सही",
    "zeroTo5PercentReturn": "०–५% रिटर्न",
    "lt0PercentReturn": "<०% रिटर्न",
    "performanceRating": "प्रदर्शन मूल्यांकन",
    "noOrganization": "कुनै संगठन छैन",
    "failedToLoadClientAccounts": "ग्राहक खाताहरू लोड गर्न असफल",
    "clientAccountLabel": "खाता खाता",
    "noActiveClientAccounts": "सक्रिय खाता खाता नही छ",
    "couldNotLoadClientAccounts": "खाता खाता लोड नही किया जा सका",
    "selectClientAccount": "क्लाइन्ट खाता चयन गर्नुहोस्",
    "portfolioOwnershipLabel": "पोर्टफोलियो मालिकी",
    "portfolioOwnershipDesc": "पोर्टफोलियो मालिकी विवरण",
    "organizationPortfolio": "संगठन पोर्टफोलियो",
    "organizationPortfolioDesc": "संगठन पोर्टफोलियो विवरण",
    "clientPortfolio": "खाता पोर्टफोलियो",
    "clientPortfolioDesc": "खाता पोर्टफोलियो विवरण",
    "benchmarks": "बेञ्चमार्कहरू",
    "goodBenchmark": "उचित मानक",
    "fairBenchmark": "सामान्य मानक",
    "poorBenchmark": "कम मानक",
    "portfolioHoldings": "पोर्टफोलियो होल्डिङहरू",
    "detailedViewSortingFiltering": "विस्तृत दृश्य सॉर्टिंग फिल्टरिंग",
    "allHoldings": "सबै होल्डिङहरू",
    "positiveReturns": " सकारात्मक रिटर्न",
    "negativeReturns": "नकारात्मक फिर्तीहरू",
    "symbol": "प्रतीक",
    "avgCost": "सामान्य लागत",
    "price": "मूल्य",
    "value": "मान",
    "returnPct": "प्रतिफल %",
    "portfolioPct": "पोर्टफोलियो %",
    "transactions": "कारोबारहरू",
    "shares": "हिस्से",
    "viewTransactions": "वित्तीय विवरण देखना",
    "noHoldingsMatchFilter": "चुनी गई फिल्टर के अनुसार हिस्सेदारी नही मिली",
    "actionableInsights": {
      "excellentPerformance": "उत्कृष्ट प्रदर्शन",
      "portfolioPerformingWell": "तपाईंको पोर्टफोलियो उत्कृष्ट फिर्तीहरूसँकै असाधारण रूपमा प्रदर्शन गर्दै छ।",
      "totalReturn": "कुल फिर्ती",
      "highConcentrationRisk": "उच्च एकाग्रता जोखिम",
      "topHoldingRepresents": "तपाईंको शीर्ष होल्डिङ ({{symbol}}) ले तपाईंको पोर्टफोलियोको {{percent}}% प्रतिनिधित्व गर्दछ। जोखिम घटाउन विविधता बढाउनुहोस्।",
      "representsPercent": "प्रतिनिधित्व गर्दछ ",
      "ofPortfolio": "तपाईंको पोर्टफोलियोको। जोखिम घटाउन विविधता बढाउनुहोस्।",
      "topHoldingPercent": "शीर्ष होल्डिङ %",
      "viewHoldings": "होल्डिङहरू हेर्नुहोस् →",
      "lowDiversification": "कम विविधता",
      "portfolioHighlyConcentrated": "तपाईंको पोर्टफोलियो अत्यधिक एकाग्र छ। विभिन्न क्षेत्रहरूमा थप स्थानहरू थप्ने विचार गर्नुहोस्।",
      "diversificationScore": "विविधता स्कोर",
      "exploreDiversification": "विविधता अन्वेषण गर्नुहोस् →",
      "xirrBelowTarget": "XIRR लक्ष्य भन्दा कम",
      "xirrBelowTargetDesc": "तपाईंको XIRR 15% लक्ष्य भन्दा कम छ। लगानी रणनीति र समय समीक्षा गर्नुहोस्।",
      "highVolatility": "उच्च अस्थिरता",
      "portfolioVolatilityHigh": "तपाईंको पोर्टफोलियो अस्थिरताले उच्च मूल्य उतारचढाव देखाउँछ। जोखिम व्यवस्थापन रणनीतिहरू विचार गर्नुहोस्।",
      "volatility": "अस्थिरता",
      "lowRiskAdjustedReturns": "कम जोखिम-समायोजित फिर्तीहरू",
      "sharpeRatioLow": "तपाईंको शार्प अनुपातले संकेत गर्दछ कि फिर्तीहरूले लिएको जोखिम औचित्य गर्दैनन्।",
      "sharpeRatio": "शार्प अनुपात",
      "significantDrawdown": "महत्त्वपूर्ण ड्रअडाउन",
      "portfolioExperiencedDrawdown": "तपाईंको पोर्टफोलियोले महत्त्वपूर्ण ड्रअडाउन अनुभव गर्यो। जोखिम व्यवस्थापन दृष्टिकोण समीक्षा गर्नुहोस्।",
      "maxDrawdown": "अधिकतम ड्रअडाउन",
      "positivePerformance": "सकारात्मक प्रदर्शन",
      "portfolioPositiveReturns": "तपाईंको पोर्टफोलियोले सकारात्मक फिर्तीहरू देखाउँदै छ। अवसरहरूको लागि निरन्तर निगरानी गर्नुहोस्।",
      "negativeReturns": "नकारात्मक फिर्तीहरू",
      "portfolioShowingLosses": "तपाईंको पोर्टफोलियो हाल नोक्सानहरू देखाउँदै छ। कम प्रदर्शन गर्ने होल्डिङहरू समीक्षा गर्नुहोस्।",
      "moderateConcentration": "मध्यम एकाग्रता",
      "topHoldingRepresentsMonitor": "तपाईंको शीर्ष होल्डिङ ({{symbol}}) ले तपाईंको पोर्टफोलियोको {{percent}}% प्रतिनिधित्व गर्दछ। एकाग्रता स्तरहरू निगरानी गर्नुहोस्।",
      "wellDiversified": "राम्रोसँग विविध",
      "portfolioGoodDiversification": "तपाईंको पोर्टफोलियोले होल्डिङहरू भरि राम्रो विविधता देखाउँछ।",
      "portfolioOverview": "पोर्टफोलियो अवलोकन",
      "portfolioNormalParameters": "तपाईंको पोर्टफोलियो सामान्य मापदण्ड भित्र प्रदर्शन गर्दै छ। नियमित निगरानी जारी राख्नुहोस्।",
      "actionableInsights": "कार्ययोग्य अन्तर्दृष्टिहरू",
      "personalizedRecommendations": "तपाईंको पोर्टफोलियो मेट्रिकहरैमा आधारित व्यक्तिगत सिफारिसहरू",
      "target": "लक्ष्य: "
    },
    "companyStatement": {
      "failedLoadTransactions": "कम्पनी कारोबारहरू लोड गर्न असफल",
      "lastAvailableQuote": "नयाँ उद्धरण उपलब्ध नभएकोले अन्तिम उपलब्ध बजार उद्धरण लागू गरिएको।",
      "loadingStatement": "कम्पनी विवरण लोड गर्दै...",
      "noStatementRows": "को लागि कुनै विवरण पंक्तिहरू छैनन् ",
      "portfolioStatementFY": "पोर्टफोलियो विवरण आर्थिक वर्ष ",
      "marketInformation": "बजार जानकारी",
      "currentMarketQuote": "हालको बजार उद्धरण",
      "currentValuationBasis": "हालको मूल्यांकन आधार",
      "currentPrice": "हालको मूल्य",
      "basis": "आधार",
      "quoted": "उद्धृत",
      "costBasis": "लागत आधार",
      "lastUpdated": "अन्तिम अपडेट",
      "coverage": "कभरेज",
      "currentHoldings": "हालको होल्डिङहरू",
      "units": "यूनिटहरू",
      "totalInvestment": "कुल लगानी",
      "avgCost": "औसत लागत: ",
      "perUnit": "/यूनिट",
      "currentValue": "हालको मान",
      "currentPriceLabel": "हालको मूल्य: ",
      "totalPL": "कुल नाफा/नोक्सान",
      "realized": "रियलाइज्ड:",
      "unrealized": "अनरियलाइज्ड:",
      "xirr": "व्यावसायिक पोर्टफोलियो की राशि",
      "avgHoldingPeriod": "औसत होल्डिङ अवधि",
      "days": "दिन",
      "returnOnInvestment": "लगानीमा फिर्ती",
      "transactionHistory": "कारोबार इतिहास",
      "transactionHistoryDesc": "यो कम्पनीको लागि पूर्ण कारोबार इतिहास",
      "date": "मिति",
      "type": "प्रकार",
      "billNo": "बिल नम्बर",
      "quantity": "मात्रा",
      "pricePerUnit": "मूल्य/यूनिट",
      "totalAmount": "कुल रकम",
      "commission": "कमिशन",
      "tax": "कर",
      "netAmount": "नेट रकम"
    },
    "charts": {
      "sectorDistributionDescription": "पोर्टफोलियो के विभिन्न क्षेत्रों का वितरण वर्णन",
      "noSectorDataAvailable": "क्षेत्रहरूको डेटा उपलब्ध छैन",
      "topHoldingsDescription": "मूल्य आधार पर पोर्टफोलियो मा शीर्ष स्थान",
      "noHoldingsDataAvailable": "पोर्टफोलियोमा डेटा उपलब्ध छैन",
      "transactionActivityDescription": "समय के साथ व्यापार गतिविधि",
      "concentrationMonitor": "स्थिति निगरानी",
      "concentrationDescription": "स्थिति विश्लेषण",
      "severity": {
        "critical": "गम्भीर",
        "high": "उच्च"
      }
    }
  },
  "data-quality": {
    "title": "डाटा गुणस्तर",
    "description": "पोर्टफोलियो डेटाको दृश्यता मेट्रिक्स र प्रमाणीकरण स्थिति हेर्नुहोस्"
  },
  "holdings": {
    "title": "पोर्टफोलियो होल्डिङहरू",
    "description": "तपाईंको हालको पोर्टफोलियो होल्डिङ र आवंटन हेर्नुहोस्।"
  },
  "profit-loss": {
    "title": "नाफा र नोक्सान",
    "description": "तपाईंको पोर्टफोलियोको नाफा र नोक्सान विश्लेषण हेर्नुहोस्।"
  },
  "realized-pnl": {
    "title": "रियलाइज्ड नाफा र नोक्सान",
    "description": "बन्द स्थानहरूबाट रियलाइज्ड नाफा र नोक्सान हेर्नुहोस्।"
  },
  "nfrs-dashboard": {
    "title": "NFRS ड्यासबोर्ड",
    "description": "नेपाल वित्तीय प्रतिवेदन मानक अनुसार पोर्टफोलियो हेर्नुहोस्।"
  },
  "organizations": {
    "organizationSettings": {
      "loadingSettings": "कन्फिगरेसन सेटिङहरू लोड हुँदैछ",
      "failedToLoad": "कन्फिगरेसन सेटिङहरू लोड गर्न सकिएन",
      "orgInfo": "संगठन जानकारी",
      "modules": "मोड्युलहरू",
      "orgInformation": "संगठन जानकारी",
      "name": "नाम",
      "code": "कोड",
      "codeReadOnly": "कोड (पढ्न मात्र)",
      "panNumber": "PAN नम्बर",
      "vatNumber": "VAT नम्बर",
      "email": "इमेल",
      "phone": "फोन",
      "address": "गल्ली ठेगाना",
      "fiscalYearStart": "आर्थिक वर्ष सुरु हुने दिन",
      "notProvided": "प्रदान गरिएको छैन छ",
      "notConfigured": "निर्धारित गरिएको छैन",
      "saving": "सेभ गर्दैछ...",
      "saveChanges": "परिवर्तनहरू सेभ गर्नुहोस्",
      "failedToLoadOrg": "संगठन लोड गर्न सकिएन",
      "failedToLoadModules": "पश्चात्तपस्यना लोड हुन्छ",
      "failedToSave": "सेटिङहरू सेभ गर्न असफल",
      "networkError": "नेटवर्क त्रुटि",
      "noOrgLinked": "किसी पन्न्चय्या संग जोडिए न सक्यो",
      "pan": "पैन",
      "moduleAccess": "मोड्युल पहुँच",
      "investment": "लगानी",
      "accounting": "लेखापरीक्षा",
      "inventory": "इन्भेन्टरी"
    }
  },
  "reports": {
    "description": "विश्वसनीय पोर्टफोलियो, प्रदर्शन, कर, लेखा, र NFRS रिपोर्टहरू फेला पार्नुहोस्।",
    "planned": "रिपोर्टहरू योजनाबद्ध छन् र अहिलेसम्म उपलब्ध छैनन्।",
    "exportCsv": "CSV निर्यात गर्नुहोस्",
    "exportFailed": "रिपोर्ट निर्यात असफल भयो।",
    "holdings": "होल्डिङहरू",
    "cash": "नगद स्थितिहरू",
    "activity": "गतिविधि",
    "marketValue": "बजार मूल्य",
    "unrealizedGainLoss": "अनिर्धारित लाभ/हानि",
    "currentBalance": "हालको शेष",
    "activityCount": "अवधिमा {{count}} लेनदेन",
    "showingCount": "{{total}} मध्ये {{count}} होल्डिङ देखाउँदै",
    "dataQualityIssues": "डाटा गुणस्तर समस्याहरू",
    "missingValuations": "missing मूल्याङ्कन",
    "reconciliation": {
      "status": "मिलान अवस्था"
    },
    "clientStatement": {
      "cutoff": "कटअफ मिति",
      "performance": "प्रदर्शन सारांश",
      "openingValue": "सुरुको मूल्य",
      "closingValue": "अन्तिम मूल्य",
      "netGainLoss": "शुद्ध लाभ/हानि",
      "twr": "समय-भारित रिटर्न",
      "feesAndTax": "शुल्क र कर",
      "totalFees": "कुल शुल्क",
      "capitalGainTax": "पूँजीगत लाभ कर",
      "parametersTitle": "विवरण खोज्नुहोस्",
      "parametersDescription": "आवश्यक परे ठ्याक्कै विवरण अवधि छान्नुहोस्। मिति खाली छोड्दा पछिल्लो पूरा भएको विवरण खुल्छ।"
    },
    "types": {
      "sebonMonthly": "SEBON मासिक",
      "irdCgt": "IRD पूँजीगत लाभ",
      "nrbQuarterly": "NRB त्रैमासिक",
      "fiuAmlCtf": "FIU एमएल/सीटीएफ",
      "portfolioCustodyEvidence": "सीडीएससी कस्टडी पहिचान प्रमाण",
      "clientPortfolioCustodyEvidence": "मेरो सीडीएससी कस्टडी पहिचान प्रमाण",
      "clientStatement": "पोर्टफोलियो विवरण",
      "organizationClientStatement": "ग्राहक विवरणहरू",
      "portfolioHoldings": "पोर्टफोलियो होल्डिङ",
      "clientHoldings": "मेरो होल्डिङ",
      "accountingTrialBalance": "ट्रायल ब्यालेन्स",
      "reconciliationBreaks": "मिलान अन्तरहरू",
      "transactionActivity": "कारोबार गतिविधि र नाफा/नोक्सान",
      "accountingFinancialStatements": "वित्तीय विवरणहरू",
      "accountingProfitAndLoss": "नाफा नोक्सान खाता",
      "portfolioPerformanceNepal": "पोर्टफोलियो कार्यसम्पादन र नेपाल प्रमाण",
      "clientPortfolioPerformanceNepal": "मेरो पोर्टफोलियो कार्यसम्पादन र नेपाल प्रमाण",
      "realizedGainLoss": "प्राप्त नाफा/नोक्सानी",
      "unrealizedGainLoss": "अप्राप्त नाफा/नोक्सानी",
      "analyticalCgt": "पूँजीगत लाभकर विश्लेषण",
      "cashPosition": "नगद स्थिति",
      "cashMovement": "नगद कारोबार",
      "investmentIncome": "लगानी आम्दानी",
      "feesExpenses": "शुल्क तथा खर्च",
      "taxLots": "कर लट तथा लागत आधार",
      "corporateActions": "कर्पोरेट कार्यहरू",
      "generalLedger": "सामान्य लेजर",
      "valuationQuality": "मूल्यांकन गुणस्तर",
      "allocationExposure": "विनियोजन तथा एक्सपोजर",
      "managementSummary": "पोर्टफोलियो व्यवस्थापन सारांश"
    },
    "descriptions": {
      "sebonMonthly": "SEBON का लागि पोस्ट गरिएका कारोबारको मासिक प्रतिवेदन।",
      "irdCgt": "IRD का लागि पूँजीगत लाभ तालिका।",
      "nrbQuarterly": "NRB का लागि त्रैमासिक ठूलो कारोबार र जोखिम प्रतिवेदन।",
      "fiuAmlCtf": "FIU का लागि AML/CTF कारोबार र शंकास्पद गतिविधि प्रतिवेदन।",
      "portfolioCustodyEvidence": "बोआईडी, डीपी कोड, आन्तरिक स्थिति कभरेज र प्रमाणित सीडीएससी वा डिम्याट कागजात प्रमाण। संरचित बाह्य स्थिति नआएसम्म बाह्य मौज्दात मेलमिलाप भएको मानिँदैन।",
      "clientPortfolioCustodyEvidence": "निजी कागजात स्थान नदेखाई तपाईंको बोआईडी, डीपी कोड, आन्तरिक स्थिति कभरेज र प्रमाणित सीडीएससी वा डिम्याट प्रमाण।",
      "clientStatement": "लगानी, नगद, कार्यसम्पादन, शुल्क, कर र डाटा-गुणस्तर सन्दर्भसहित तपाईंको पछिल्लो पूरा भएको पोर्टफोलियो विवरण।",
      "organizationClientStatement": "विवरण उत्पादन प्रक्रिया नचलाइ अधिकृत ग्राहक वा पोर्टफोलियोका पूरा भएका शासित विवरणहरू समीक्षा गर्नुहोस्।",
      "portfolioHoldings": "ग्राहक, पोर्टफोलियो, उपकरण र मुद्राअनुसार पछिल्लो शासित स्थिति तथा मूल्याङ्कन स्न्यापसट।",
      "clientHoldings": "साइन इन गरिएको ग्राहकलाई तोकिएका अभिलेख मात्र समावेश भएको ग्राहक-सीमित पछिल्लो स्थिति र मूल्याङ्कन स्न्यापसट।",
      "accountingTrialBalance": "सुरुआती मौज्दात, पोस्ट गरिएका चाल, अन्तिम डेबिट तथा क्रेडिट, वित्तीय अवधि अवस्था र सटीक समानता जाँच।",
      "reconciliationBreaks": "मुद्राअनुसार कुल र खुद मिलान जोखिम, गम्भीरता, उमेर, समायोजन र स्टेटमेन्ट प्रमाण।",
      "transactionActivity": "दायराभित्रको कारोबार गतिविधि, पोस्टिङ व्यवहार, साकार नाफा वा नोक्सान र मिल्दो सबैभन्दा पछिल्लो अप्राप्त मूल्याङ्कन प्रमाण।",
      "accountingFinancialStatements": "स्पष्ट नगद-प्रवाह वर्गीकरणसहित पोस्ट गरिएका लेजर प्रविष्टिबाट तयार गरिएको वासलात, नाफा नोक्सान र प्रत्यक्ष नगद-प्रवाह विवरण।",
      "accountingProfitAndLoss": "छानिएको लेखा अवधिका पोस्ट गरिएका लेजर प्रविष्टिहरूमा आधारित नाफा तथा नोक्सान। यो लेखा-विवरण आधार हो; बजार मूल्य परिवर्तन, वास्तविक/अवास्तविक लगानी प्रतिफल र TWR पोर्टफोलियो कार्यसम्पादन रिपोर्टमा देखाइन्छ।",
      "portfolioPerformanceNepal": "शासित पोर्टफोलियो गणना प्रयोग गरी मूल्यांकन, नाफा/नोक्सानी, पूँजीगत लाभ कर, कर नियम स्रोत प्रमाण र एनएफआरएस प्रमाण।",
      "clientPortfolioPerformanceNepal": "तपाईंको दायराभित्रको पोर्टफोलियो मूल्यांकन, नाफा/नोक्सानी, पूँजीगत लाभ कर, कर नियम स्रोत प्रमाण र एनएफआरएस प्रमाण।",
      "realizedGainLoss": "छानिएको अवधिका बिक्री आम्दानी, लागत आधार, कटौतीयोग्य शुल्क, प्राप्त नाफा वा नोक्सानी र सम्बन्धित पूँजीगत लाभकर हेर्नुहोस्।",
      "unrealizedGainLoss": "छानिएको मितिसम्म प्रत्येक स्थितिको पछिल्लो शासित मूल्याङ्कन, लागत, बजार मूल्य र अप्राप्त नाफा वा नोक्सानी हेर्नुहोस्।",
      "analyticalCgt": "करयोग्य लाभ, लागू दर, होल्डिङ अवधि र कर नियम प्रमाणसहित शासित पूँजीगत लाभकर तथ्यहरू हेर्नुहोस्।",
      "cashPosition": "पोर्टफोलियो र मुद्राअनुसार हालको नगद मौज्दात हेर्नुहोस्। यो हालको अवस्थाको दृश्य हो, ऐतिहासिक नगद पुनर्निर्माण होइन।",
      "cashMovement": "छानिएको अवधिका पोस्ट गरिएका नगद जम्मा, निकासी र स्थानान्तरण हेर्नुहोस्; उल्टाइएका कारोबार वित्तीय कुलबाट हटाइन्छन्।",
      "investmentIncome": "पोस्ट गरिएका कर्पोरेट-कार्य नगद प्राप्ति र पोस्ट गरिएका कुपन वा ब्याज जीवनचक्र घटनाबाट मान्यता प्राप्त लगानी आम्दानी हेर्नुहोस्।",
      "feesExpenses": "छानिएको अवधिका जारी व्यवस्थापन तथा कार्यसम्पादन शुल्क, कर र कुल शुल्क हेर्नुहोस्।",
      "taxLots": "हालका कर-लट परिमाण र खरिद लागत प्रमाण हेर्नुहोस्। बाँकी परिमाण हालको अवस्था हो, ऐतिहासिक as-of पुनर्निर्माण होइन।",
      "corporateActions": "हकदारी, परिमाण प्रभाव र पोस्ट गरिएको नगद प्रभावसहित कर्पोरेट-कार्य घटनाहरू हेर्नुहोस्।",
      "generalLedger": "आधिकारिक लेखा लेजरबाट खाता र अवधिअनुसार पोस्ट गरिएका जर्नल लाइनहरू हेर्नुहोस्।",
      "valuationQuality": "नवीनतम मूल्यांकन कभरेज हेर्नुहोस् र मूल्य वा बजार मूल्य नभएका नियन्त्रित मूल्यांकन तथ्य भएका स्थितिहरू पहिचान गर्नुहोस्।",
      "allocationExposure": "नवीनतम मूल्यांकन तथ्य प्रयोग गरी मुद्रा, साधन, साधन प्रकार वा क्षेत्रअनुसार पोर्टफोलियो विनियोजन हेर्नुहोस्। तौल एउटै मुद्राभित्र मात्र गणना गरिन्छ र मुद्रा-पार तुलना भ्रामक हुने अवस्थामा देखाइँदैन।",
      "managementSummary": "मूल्यांकन पूर्णता सूचकसहित मुद्रा अनुसार पोर्टफोलियो र ग्राहक मूल्यांकन सारांश हेर्नुहोस्।"
    },
    "custodyParameters": {
      "title": "कस्टडी प्रमाण मापदण्ड",
      "description": "अधिकृत ग्राहक वा पोर्टफोलियो चयन गर्नुहोस्। परिणामले पहिचान तथा कागजात प्रमाणलाई बाह्य मौज्दात मेलमिलापबाट छुट्याउँछ।"
    },
    "custodyColumns": {
      "portfolio": "पोर्टफोलियो",
      "identifierType": "पहिचान प्रकार",
      "participantIdentifier": "सहभागी पहिचान",
      "primaryIdentifier": "स्वामी पहिचान",
      "ownerType": "स्वामी प्रकार",
      "positionCount": "आन्तरिक स्थिति",
      "instrumentCount": "उपकरण संख्या",
      "identityComplete": "पहिचान पूर्ण",
      "externalStatementAvailable": "बाह्य विवरण उपलब्ध",
      "externalStatementVerified": "बाह्य विवरण प्रमाणित",
      "reconciliationState": "मौज्दात मेलमिलाप",
      "evidenceAsOf": "प्रमाण मिति सम्म",
      "dpCode": "डीपी कोड",
      "boid": "बोआईडी"
    },
    "columns": {
      "id": "रन ID",
      "status": "स्थिति",
      "periodStart": "अवधि सुरु",
      "periodEnd": "अवधि अन्त्य",
      "createdAt": "सिर्जना मिति",
      "averageCostPerUnit": "औसत लागत प्रति एकाइ",
      "symbol": "प्रतीक",
      "totalCost": "कुल लागत",
      "clientAccount": "ग्राहक खाता",
      "portfolioAccount": "पोर्टफोलियो खाता",
      "instrument": "उपकरण",
      "currency": "मुद्रा",
      "quantity": "परिमाण",
      "costBasis": "लागत आधार",
      "marketPrice": "बजार मूल्य",
      "marketValue": "कुल बजार मूल्य",
      "unrealizedGainLoss": "अप्राप्त नाफा वा घाटा",
      "sourceAsOf": "प्रमाणको मिति",
      "accountCode": "खाता कोड",
      "accountName": "खाता नाम",
      "accountType": "खाता प्रकार",
      "openingBalance": "सुरुआती मौज्दात",
      "movementDebit": "चाल डेबिट",
      "movementCredit": "चाल क्रेडिट",
      "closingDebit": "अन्तिम डेबिट",
      "closingCredit": "अन्तिम क्रेडिट",
      "signedBalance": "चिन्हयुक्त मौज्दात",
      "debit": "डेबिट",
      "credit": "क्रेडिट",
      "balance": "मौज्दात",
      "runId": "चलाइ",
      "breakId": "अन्तर",
      "severity": "गम्भीरता",
      "difference": "फरक",
      "netDifference": "खुद फरक",
      "grossDifference": "कुल फरक",
      "sourceMismatch": "अमिल्दो स्रोत",
      "agingBusinessDays": "व्यावसायिक दिनमा उमेर",
      "transactionDate": "कारोबार मिति",
      "transactionType": "कारोबार प्रकार",
      "totalAmount": "कुल रकम",
      "postingStatus": "पोस्टिङ स्थिति",
      "realizedGainLoss": "साकार नाफा वा नोक्सान",
      "statement": "विवरण",
      "cashFlowClassification": "नगद-प्रवाह वर्गीकरण",
      "amount": "रकम",
      "asOfDate": "मितिसम्म",
      "saleDate": "बिक्री मिति",
      "saleProceeds": "बिक्री आम्दानी",
      "deductibleCharges": "कटौतीयोग्य शुल्क",
      "taxableGain": "करयोग्य लाभ",
      "capitalGainTax": "पूँजीगत लाभकर",
      "holdingPeriodDays": "होल्डिङ अवधि (दिन)",
      "cgtRate": "CGT दर",
      "taxRuleVersion": "कर नियम संस्करण",
      "taxRuleSourceReference": "कर नियम स्रोत",
      "currentBalance": "हालको मौज्दात",
      "businessDate": "कारोबार मिति",
      "movementType": "कारोबार प्रकार",
      "incomeDate": "आम्दानी मिति",
      "incomeType": "आम्दानी प्रकार",
      "grossAmount": "कुल रकम",
      "withholdingTaxAmount": "स्रोतमा कर कट्टी",
      "netAmount": "खुद रकम",
      "feeType": "शुल्क प्रकार",
      "taxAmount": "कर रकम",
      "acquisitionDate": "खरिद मिति",
      "originalQuantity": "मूल परिमाण",
      "remainingQuantity": "बाँकी परिमाण",
      "costPerUnit": "प्रति इकाइ लागत",
      "remainingCostBasis": "बाँकी लागत आधार",
      "recordDate": "रेकर्ड मिति",
      "actionType": "कार्य प्रकार",
      "entitlementCount": "हकदारी संख्या",
      "cashImpact": "मुद्राअनुसार नगद प्रभाव",
      "quantityImpact": "परिमाण प्रभाव",
      "postingDate": "पोस्टिङ मिति",
      "journal": "जर्नल",
      "description": "विवरण",
      "reference": "सन्दर्भ",
      "source": "स्रोत",
      "updatedAt": "अद्यावधिक गरिएको",
      "qualityState": "मूल्यांकन गुणस्तर",
      "dimension": "विनियोजन",
      "weightPct": "तौल",
      "positions": "स्थितिहरू",
      "totalGainLoss": "कुल नाफा/नोक्सानी",
      "accountGroupName": "खाता समूह"
    },
    "parameters": {
      "title": "प्रतिवेदन प्यारामिटरहरू",
      "description": "प्रतिवेदन प्रकार र अवधि छान्नुहोस्।",
      "reportType": "प्रतिवेदन प्रकार",
      "periodStart": "अवधि सुरु",
      "periodEnd": "अवधि अन्त्य",
      "fiscalYear": "आर्थिक वर्ष",
      "fiscalYearName": "आर्थिक वर्ष",
      "year": "वर्ष",
      "month": "महिना",
      "quarter": "त्रैमासिक",
      "clientAccount": "ग्राहक खाता",
      "portfolioAccount": "पोर्टफोलियो खाता",
      "accountCode": "खाता कोड",
      "currency": "मुद्रा",
      "dimension": "विनियोजन आयाम"
    },
    "definitionForm": {
      "title": "प्रतिवेदन परिभाषा",
      "description": "पुनः प्रयोग गर्न मिल्ने नियामक प्रतिवेदन परिभाषा बनाउनुहोस्।",
      "code": "प्रतिवेदन कोड",
      "name": "प्रतिवेदन नाम",
      "type": "प्रतिवेदन प्रकार",
      "body": "नियामक निकाय"
    },
    "runForm": {
      "title": "प्रतिवेदन बनाउनुहोस्",
      "description": "मान्य अवधिका लागि दायरासहितको प्रतिवेदन रन बनाउनुहोस्।",
      "definition": "प्रतिवेदन परिभाषा",
      "start": "अवधि सुरु",
      "end": "अवधि अन्त्य",
      "fiscalYear": "आर्थिक वर्ष",
      "fiscalYearHelp": "आधिकारिक नेपाली आर्थिक वर्षको नाम प्रयोग गर्नुहोस्, जस्तै 2082/83। प्रविष्ट मितिहरू उक्त आर्थिक वर्षसँग ठ्याक्कै मिल्नुपर्छ।",
      "fiscalYearInvalid": "आर्थिक वर्ष YYYY/YY ढाँचामा लेख्नुहोस्, जस्तै 2082/83।",
      "irdFiscalYear": {
        "description": "प्रमाणित अवधिको लागि IRD आर्थिक वर्ष रिपोर्ट उत्पन्न गर्नुहोस्।",
        "fiscalYear": "आर्थिक वर्ष",
        "title": "IRD आर्थिक वर्ष रिपोर्ट उत्पन्न गर्नुहोस्"
      },
      "reportType": "प्रतिवेदन प्रकार",
      "irdTitle": "IRD पूँजीगत लाभकर तालिका तयार गर्नुहोस्",
      "irdDescription": "ठ्याक्कै मिलेको, बन्द र सबै अवधि लक भएको आधिकारिक आर्थिक वर्षका लागि मात्र IRD तालिका तयार गर्नुहोस्।",
      "parametersSection": "दाखिला मापदण्ड"
    },
    "actions": {
      "saveDefinition": "परिभाषा सुरक्षित गर्नुहोस्",
      "generateRun": "प्रतिवेदन बनाउनुहोस्",
      "cancel": "रद्द गर्नुहोस्",
      "viewReport": "प्रिप्त रिपोर्ट",
      "exportReport": "रिपोर्ट निकाल्नु",
      "refreshReport": "रिपोर्ट फिर से लोड कर्नु",
      "filterReport": "रिपोर्ट को फिल्टर कर्नु",
      "view": "हेर्नुहोस्",
      "remediate": "सुधारित गर्नु",
      "reviewRequirement": "मागच्या आवश्यकता समजाउनु",
      "fixDataIssue": "डेटा समस्या ठीक गर्नु",
      "upgrade": "अपग्रेड गर्नु",
      "requestAccess": "अक्सेस मागनु",
      "backToReports": "रिपोर्टमा पुनः पर्ताउनु",
      "learnMore": "हेर्नु",
      "viewDesc": "हेर्नुहोस्",
      "runLive": "प्रतिवेदन चलाउनुहोस्"
    },
    "summary": {
      "marketValue": "बजार मूल्य",
      "costBasis": "लागत आधार",
      "realizedGainLoss": "साक्षात् लाभ/हानि",
      "unrealizedGainLoss": "अनिर्धारित लाभ/हानि",
      "totalGainLoss": "कुल लाभ/हानि",
      "totalPnl": "कुल P&L",
      "totalDebit": "कुल डेबिट",
      "totalCredit": "कुल क्रेडिट",
      "netProfit": "शुद्ध लाभ",
      "count": "गणना",
      "total": "कुल",
      "openingBalance": "सुरुको शेष",
      "closingBalance": "अन्तिम शेष",
      "transactionCount": "लेनदेन गणना",
      "valuationCoverageRatio": "मूल्याङ्कन कवरेज अनुपात",
      "breaks": "विच्छेद",
      "openBreaks": "खुला विच्छेद",
      "positions": "स्थितिहरू",
      "currency": "मुद्रा",
      "asOfDate": "मिति को अनुसार",
      "asOfDateBs": "मिति को अनुसार (BS)",
      "periodStart": "अवधि सुरु",
      "periodStartBs": "अवधि सुरु (BS)",
      "totalCost": "कुल लागत",
      "capitalGainTax": "पूँजीगत लाभ कर",
      "benchmarkId": "बेन्चमार्क ID",
      "benchmarkCurrency": "बेन्चमार्क मुद्रा",
      "benchmarkReturnPct": "बेन्चमार्क रिटर्न %",
      "benchmarkAsOf": "बेन्चमार्क मिति अनुसार",
      "benchmarkStatus": "बेन्चमार्क स्थिति",
      "missingPriceCount": "हराएको मूल्य गणना",
      "stalePriceCount": "पुरानो मूल्य गणना",
      "costBasisMissingCount": "लागत आधार हराएको गणना",
      "unrealizedGainLossMissingCount": "अनिर्धारित लाभ/हानि हराएको गणना",
      "taxDisposalCount": "कर निस्तारण गणना",
      "taxProvenanceCount": "कर उत्पत्ति गणना",
      "missingTaxProvenanceCount": "हराएको कर उत्पत्ति गणना",
      "taxProvenanceCoveragePct": "कर उत्पत्ति कवरेज %",
      "nfrsFactCount": "NFRS तथ्य गणना",
      "nfrsEvidenceAvailable": "NFRS प्रमाण उपलब्ध",
      "partialData": "आंशिक डाटा",
      "methodology": "पद्धति",
      "methodologyVersion": "पद्धति संस्करण",
      "sourceBook": "स्रोत पुस्तक",
      "jurisdictionPackage": "क्षेत्राधिकार प्यकेज",
      "sourceAsOf": "स्रोत मिति अनुसार",
      "limitations": "सीमाहरू",
      "authoritativePerformanceMethodology": "आधिकारिक प्रदर्शन पद्धति",
      "totalIncome": "कुल आम्दानी",
      "totalExpenses": "कुल खर्च",
      "portfolioValueByCurrency": "मुद्रा अनुसार पोर्टफोलियो मूल्य",
      "cashByCurrency": "मुद्राअनुसार नगद",
      "feesByCurrency": "मुद्रा अनुसार शुल्क",
      "taxByCurrency": "मुद्राअनुसार कर",
      "quality": "गुणस्तर",
      "totalAmountByCurrency": "मुद्रा अनुसार कुल रकम",
      "countByStatus": "स्थिति अनुसार गणना",
      "countByPostingStatus": "पोस्टिङ स्थिति अनुसार गणना",
      "exposureByCurrency": "मुद्रा अनुसार जोखिम",
      "adjustmentsByStatus": "स्थिति अनुसार समायोजन",
      "balanceSheet": "वासलात",
      "profitAndLoss": "नाफा तथा नोक्सानी",
      "cashFlow": "नगद प्रवाह",
      "missingValuationCount": "पूर्ण मूल्याङ्कन नभएका स्थितिहरू",
      "saleProceedsByCurrency": "मुद्राअनुसार बिक्री आम्दानी",
      "costBasisByCurrency": "मुद्राअनुसार लागत आधार",
      "deductibleChargesByCurrency": "मुद्राअनुसार कटौतीयोग्य शुल्क",
      "realizedGainLossByCurrency": "मुद्राअनुसार प्राप्त नाफा/नोक्सानी",
      "taxableGainByCurrency": "मुद्राअनुसार करयोग्य लाभ",
      "capitalGainTaxByCurrency": "मुद्राअनुसार पूँजीगत लाभकर",
      "totalCostByCurrency": "मुद्राअनुसार लागत",
      "marketValueByCurrency": "मुद्राअनुसार बजार मूल्य",
      "unrealizedGainLossByCurrency": "मुद्राअनुसार अप्राप्त नाफा/नोक्सानी",
      "depositsByCurrency": "मुद्राअनुसार जम्मा",
      "withdrawalsByCurrency": "मुद्राअनुसार निकासी",
      "transfersByCurrency": "मुद्राअनुसार स्थानान्तरण",
      "grossIncomeByCurrency": "मुद्राअनुसार कुल आम्दानी",
      "withholdingByCurrency": "मुद्राअनुसार स्रोतमा कर कट्टी",
      "netIncomeByCurrency": "मुद्राअनुसार खुद आम्दानी",
      "netFeesByCurrency": "मुद्राअनुसार खुद शुल्क",
      "grossFeesByCurrency": "मुद्राअनुसार कुल शुल्क",
      "remainingCostBasisByCurrency": "मुद्राअनुसार बाँकी लागत आधार",
      "affectedMarketValueByCurrency": "मुद्राअनुसार प्रभावित बजार मूल्य",
      "totalGainLossByCurrency": "मुद्राअनुसार कुल नाफा/नोक्सानी",
      "reversedCount": "उल्टाइएका कारोबार",
      "clientCount": "ग्राहक",
      "portfolioCount": "पोर्टफोलियो",
      "totalDebits": "कुल डेबिट",
      "totalCredits": "कुल क्रेडिट",
      "variance": "डेबिट/क्रेडिट अन्तर",
      "balanced": "सन्तुलित",
      "countBySeverity": "गम्भीरताअनुसार ब्रेक",
      "agingBuckets": "ब्रेक उमेर",
      "age0To2": "०–२ कार्य दिन",
      "age3To5": "३–५ कार्य दिन",
      "age6To10": "६–१० कार्य दिन",
      "age11Plus": "११+ कार्य दिन",
      "assets": "सम्पत्ति",
      "liabilities": "दायित्व",
      "equity": "इक्विटी",
      "netAssets": "खुद सम्पत्ति",
      "revenue": "आम्दानी",
      "expenses": "खर्च",
      "netIncome": "खुद आम्दानी",
      "netCashChange": "खुद नगद परिवर्तन",
      "unclassifiedCashMovement": "वर्गीकरण नभएको नगद कारोबार",
      "complete": "पूर्ण",
      "netDifference": "खुद अन्तर",
      "grossDifference": "कुल अन्तर",
      "positiveDifference": "सकारात्मक अन्तर",
      "negativeDifference": "नकारात्मक अन्तर",
      "INFO": "जानकारी",
      "WARNING": "चेतावनी",
      "CRITICAL": "गम्भीर",
      "DRAFT": "मस्यौदा",
      "SUBMITTED": "पेश गरिएको",
      "PENDING_APPROVAL": "स्वीकृति प्रतीक्षामा",
      "APPROVED": "स्वीकृत",
      "REJECTED": "अस्वीकृत",
      "WITHDRAWN": "फिर्ता लिइएको",
      "POSTED": "पोस्ट गरिएको",
      "REVERSED": "उल्टाइएको",
      "ROLLED_BACK": "रोलब्याक गरिएको",
      "OPEN": "खुला",
      "RESOLVED": "समाधान भएको",
      "PENDING": "प्रतीक्षामा",
      "POSTING": "पोस्ट हुँदै"
    },
    "groups": {
      "portfolio": "पोर्टफोलियो र कार्यसम्पादन",
      "client": "ग्राहक प्रतिवेदन",
      "transactions": "कारोबार",
      "tax": "कर",
      "accounting": "लेखा",
      "reconciliation": "मिलान",
      "regulatoryOperations": "नियामकीय र सञ्चालन",
      "management": "व्यवस्थापन"
    },
    "scopes": {
      "branch": "शाखा",
      "client": "ग्राहक",
      "portfolio": "पोर्टफोलियो",
      "organization": "संस्था",
      "platform": "प्लेटफर्म"
    },
    "activeFilter": {
      "clearAll": "सार्वजनिक फिल्टर्स क्लियर कर",
      "availability": "उपलब्धता",
      "search": "खोज"
    },
    "scopeBanner": {
      "scope": "विस्तार:",
      "organization": "संस्था:",
      "branch": "शाखा:",
      "client": "क्लाइंट:",
      "profile": "प्रोफाइल:"
    },
    "runtime": {
      "dash": "ड्याशबोर्ड",
      "percent": "%",
      "previous": "अघिल्लो",
      "all": "सबै",
      "noResultsMatch": "निर्दिष्ट फिल्टर अनुसार कोई परिणाम फेला परेन",
      "noRowsToDisplay": "प्रदर्शन गर्न कुनै पङ्क्ति छैन",
      "booleanYes": "हो",
      "booleanNo": "होइन",
      "optionalFilters": {
        "title": "ऐच्छिक फिल्टरहरू",
        "subtitle": "थप फिल्टरिङ नियन्त्रण आवश्यक हुँदा मात्र खोल्नुहोस्।",
        "titleWithCount": "गिनती साथ विवरण"
      },
      "additionalColumnsTitle": "अधिक स्तंभ",
      "pageShell": {
        "unavailableTitle": "रिपोर्ट अनुपलब्ध",
        "generatedAt": "उत्पन्न",
        "asOfDate": "मिति अनुसार",
        "dataQuality": "डाटा गुणस्तर",
        "viewCanonicalAria": "क्यानोनिकल रिपोर्ट हेर्नुहोस्",
        "canonicalLink": "क्यानोनिकल",
        "viewDrilldownAria": "ड्रिल-डाउन विवरण हेर्नुहोस्",
        "drilldownLink": "ड्रिल डाउन",
        "accessLockedTitle": "रिपोर्ट पहुँच बन्द",
        "lockedDescription": "तपाईंको हालको टियर वा अनुमतिमा यो रिपोर्टमा पहुँच समावेश छैन।",
        "unavailableDescription": "यो रिपोर्ट उत्पन्न गर्न थप डाटा वा कन्फिगरेशन आवश्यक छ।",
        "learnEnableAccessAria": "रिपोर्ट पहुँच सक्षम गर्ने तरिका जान्नुहोस्",
        "learnMoreLink": "थप जान्नुहोस्",
        "dataQualityError": "डाटा गुणस्तर त्रुटि",
        "dataQualityWarning": "डाटा गुणस्तर चेतावनी",
        "qualityCheckFailed": "गुणस्तर जाँच असफल",
        "reason": "कारण",
        "reconciliationUnbalanced": "मेलमिलाप असन्तुलित",
        "reconciliationPending": "मेलमिलाप विचाराधीन",
        "reconciliationCheckFailed": "मेलमिलाप जाँच असफल",
        "scope": "क्षेत्र"
      },
      "additionalColumnsDescription": "विस्तारित रिपोर्ट लागू करने के लिए प्राप्त अनुप्रयोग-निर्धारित द्वितीय स्तंभ।",
      "technicalColumnsTitle": "तकनीकी विवरण",
      "technicalColumnsDescription": "विस्तारित रिपोर्ट लागू करने के लिए प्राप्त तकनीकी स्तंभ डायग्नोस्टिक और समर्थन समीक्षा के लिए।",
      "exportNotAvailable": "निर्यात उपलब्ध छैन",
      "exportNotAvailableDescription": "{{format}} निर्यात प्राप्त गर्ने अनुमति छैन",
      "exportFailed": "निर्यात विफल हो गया",
      "exportComplete": "निर्यात पूर्ण हो गया",
      "exportCompleteDescription": "निर्यात रिपोर्ट को {{format}} मा भेज दिया गया छ",
      "errorLoading": "रिपोर्ट लोड गर्न विफल रहा",
      "unknownError": "अज्ञात त्रुटि हुई",
      "accessDenied": "पहुँच अस्वीकृत",
      "accessDeniedDescription": "तपाईंलाई यो रिपोर्ट हेर्ने अनुमति छैन।",
      "requiredTier": "निर्यात: {{tier}} टियर आवश्यक छ",
      "requiredPermissions": "निर्यातका लागि आवश्यक अनुमतिहरू: {{permissions}}",
      "retry": "पुन: प्रयास गर्नुहोस्",
      "failedToFetch": "रिपोर्ट डेटा को लोड गर्न विफल रहा",
      "exportStarted": "नप्रेक्ष्या प्रकाशन शुरू होइयो",
      "exportRequiresClientAccount": "निर्यात सक्षम गर्न ग्राहक खाता छनोट गर्नुहोस्।",
      "exportFailedFormat": "{{format}} नप्रेक्ष्या प्रकाशन लागि विफल होइयो",
      "exporting": "निर्यात गर्दै…",
      "export": "नप्रेक्ष्या प्रकाशन",
      "dataStillLoading": "रिपोर्ट डेटा अझै लोड हुँदैछ",
      "resolveErrorBeforeExport": "नप्रेक्ष्या प्रकाशन त्रुटि को सुधार्ने पूर्वक नप्रेक्ष्या प्रकाशन करावा",
      "dataQualityIssues": "नप्रेक्ष्या डेटा गुणवत्ता समस्याएँ देखी गई छं",
      "dataQualityWarnings": "नप्रेक्ष्या डेटा गुणवत्ता संकेत देखिए गए छं",
      "loadingReport": "रिपोर्ट डेटा लोड हुँदैछ...",
      "loading": "ग्राहक खाताहरू लोड गर्दै…",
      "errorLoadingReport": "रिपोर्ट डेटा लोड गर्दा त्रुटि",
      "failedToLoadReport": "नप्रेक्ष्या प्रकाशन डेटा लोड होइयो नाह",
      "noRecordsMatchFilters": "चयनित फिल्टरसँग मेल नखाने रेकर्ड छैन",
      "filterBar": {
        "organizationLabel": "संस्था:",
        "branchLabel": "शाखा:",
        "reset": "रिसेट",
        "resetAria": "रिपोर्ट फिल्टरहरू रिसेट गर्नुहोस्",
        "selectPlaceholder": "छनोट गर्नुहोस्..."
      },
      "visualization": {
        "chartType": "{{type}} चार्ट",
        "dataPoints": "{{count}} डाटा बिन्दु",
        "total": "जम्मा:"
      },
      "reconciliationFooter": {
        "totalRecords": "कुल रेकर्ड",
        "totalValue": "कुल मूल्य",
        "discrepancies": "विसंगतिहरू",
        "lastUpdated": "पछिल्लो अद्यावधिक"
      },
      "registryNotReached": "रिपोर्ट रजिस्ट्रीमा पहुँच हुन सकेन। पुन: प्रयास गर्नुहोस्।",
      "table": {
        "caption": "शीर्षक",
        "groupCaption": "समूह शीर्षक"
      },
      "missing": {
        "key": "कुंजी",
        "with": {
          "fallback": "प्रतिस्थापन"
        }
      },
      "reconciliation": {
        "unbalanced": "असंतुलित",
        "pending": "KYC विचाराधीन"
      },
      "dashboardContext": {
        "fromDashboard": "डैशबोर्ड से"
      },
      "totalsBasis": {
        "canonical": "क्यानोनिकल",
        "filtered": "हालको फिल्टरसँग मिल्ने कुनै कार्यप्रवाहहरू छैनन्"
      },
      "exportColumnValidationError": "निर्यात स्तंभ वैधीकरण त्रुटि",
      "invalidFilterQuery": "फिल्टर क्वेरी अनियमित छ",
      "unavailableTitle": "अनुपलब्ध",
      "unavailableDescription": "अस उपलब्ध वर्णन",
      "custom": {
        "dataSource": {
          "required": "डेटा स्रोत आवश्यक छ"
        }
      }
    },
    "tableHeaders": {
      "month": "महिना",
      "year": "वर्ष",
      "company": "कम्पनी",
      "purchaseQty": "खरिद मात्रा",
      "purchaseAmount": "खरिद रकम",
      "salesQty": "बिक्री मात्रा",
      "salesAmount": "बिक्री रकम",
      "closingUnits": "बन्द एकाइहरू",
      "wacc": "वेस्टेड कैपिटल एक्सपेंशन रेट",
      "realizedPL": "मूल्यांकनित पी&एल",
      "netTradeAmount": "शुद्ध व्यापार रकम",
      "date": "मिति",
      "type": "प्रकार",
      "symbol": "प्रतीक",
      "quantity": "मात्रा",
      "price": "मूल्य",
      "totalAmount": "कुल",
      "commission": "कमिशन",
      "status": "स्थिति"
    },
    "totalPurchases": "कुल खरिद",
    "months": "{{count}} महिनाहरू",
    "exporting": "निर्यात गर्दै…",
    "exportTransactions": "कारोबारहरू निर्यात गर्नुहोस्",
    "additionalIssues": "...{{count}} थप समस्याहरू",
    "triggerDataRecalculation": "डाटा पुनगणना ट्रिगर गर्नुहोस्",
    "totalSales": "कुल बिक्री",
    "allMonths": "सब से सभी महीने",
    "showingAllMonths": "सब से सभी महीनों मा दिखाई गई रिकॉर्ड की संख्या {{count}}",
    "showingForMonth": "{{month}} का लागि {{count}} रेकर्डहरू देखाउँदै",
    "monthlyPortfolioSummary": "मासिक पोर्टफोलियो सारांश",
    "portfolioSummary": {
      "clientAccount": "ग्राहक खाता",
      "clientAccountDesc": "ग्राहक खाता",
      "asOfDate": "मिति अनुसार",
      "asOfDateDesc": "मिति अनुसार",
      "includeMonthly": "पश्चात्त खाता समावेश",
      "includeMonthlyDesc": "पश्चात्त खाता समावेश",
      "includeMonthlyOption": {
        "yes": "हो",
        "yesDesc": "हो",
        "no": "होइन",
        "noDesc": "होइन"
      },
      "metric": "माप",
      "metricDesc": "माप",
      "value": "मान",
      "valueDesc": "मान",
      "valueText": "मूल्य विवरण",
      "valueTextDesc": "मूल्य विवरण",
      "unit": "एकाइ",
      "unitDesc": "एकाइ",
      "totalMarketValue": "कुल बाजार मूल्य",
      "totalMarketValueDesc": "कुल बाजार मूल्य",
      "totalInvestment": "कुल लगानी",
      "totalInvestmentDesc": "कुल लगानी",
      "totalGainLoss": "कुल लाभ हानि",
      "totalGainLossDesc": "कुल लाभ हानि"
    },
    "performanceBreakdown": "निर्वहन विवरण",
    "performanceMetricsDesc": "प्रदर्शन मेट्रिक्स {{groupBy}} द्वारा समूहीकृत, {{timeDimension}} द्वारा फिल्टर गरिएको",
    "groupBy": "समूह द्वारा",
    "january": "जनवरी",
    "february": "फरवरी",
    "march": "मार्च",
    "april": "अप्रैल",
    "may": "मई",
    "june": "जुन",
    "july": "जुलाई",
    "august": "अगस्त",
    "september": "सeptember",
    "october": "अक्टोबर",
    "november": "नवंबर",
    "december": "दिसंबर",
    "justNow": "अहिले",
    "hoursAgo": "{{hours}} घण्टा अघि",
    "daysAgo": "{{days}} दिन अघि",
    "bytes": "{{bytes}} B",
    "kilobytes": "{{kb}} KB",
    "megabytes": "{{mb}} MB",
    "recentReports": "हाल ही का रिपोर्ट",
    "empty": {
      "noMatches": "कुनै मेल फेला परेन",
      "noLockedReports": "बन्द रिपोर्ट फेला परेन",
      "noUnavailableReports": "अनुपलब्ध रिपोर्ट फेला परेन",
      "noAvailableReports": "अनुपलब्ध रिपोर्ट फेला परेन",
      "noReports": "रिपोर्ट फेला परेन",
      "filterDescription": "वर्तमान फ़िल्टर के अनुसार कोई रिपोर्ट फेला परेन। अपनी खोज या फ़िल्टर्स को समायोजित गर्नुहोस्.",
      "searchDescription": "खोज्नुहोस् वा अन्य श्रेणीहरू जाँच गर्नुहोस्",
      "lockedDescription": "इस श्रेणी मा सभी रिपोर्ट उपलब्ध या अनुपलब्ध छन्।",
      "unavailableDescription": "हाल कुनै रिपोर्ट अनुपलब्ध छैन।",
      "availableDescription": "उपलब्ध रेकर्डहरू छैनन्।",
      "categoryDescription": "यस श्रेणीका लागि कुनै रिपोर्ट निर्दिष्ट गरिएको छैन।",
      "resetCategory": "श्रेणी सेट गर्नुहोस्",
      "description": "यो खाताका लागि हाल कुनै लगानी रिपोर्ट सतहहरू उपलब्ध छैन।"
    },
    "hub": {
      "searchPlaceholder": "पोर्टफोलियो, वित्तीय परिणाम, NFRS, वा रिपोर्ट उपलब्धता खोज्नुहोस्",
      "searchAriaLabel": "रिपोर्ट खोज (परिणाम खाली गर्न टाइप गर्नुहोस्)",
      "refineFiltersTitle": "रिपोर्ट फिल्टरहरू परिमार्जन गर्नुहोस्",
      "refineFiltersSubtitle": "ठूला रिपोर्ट सेटलाई साँघुरो पार्न वैकल्पिक फिल्टरहरू प्रयोग गर्नुहोस्।",
      "secondaryDisclosureTitle": "माध्यमिक प्रकटीकरण",
      "secondaryDisclosureSubtitle": "अतिरिक्त सन्दर्भ र मेटाडाटा",
      "contextTitle": "सन्दर्भ",
      "contextSubtitle": "रिपोर्ट सन्दर्भ जानकारी",
      "totalReports": "कुल रिपोर्टहरू",
      "availableLocked": "उपलब्ध / लक",
      "dataQualityAvailability": "डाटा गुणस्तर उपलब्धता",
      "reportAvailabilityLabel": "रिपोर्ट उपलब्धता",
      "availabilityReady": "{{count}} तैयार",
      "availabilityLocked": "{{count}} बंद",
      "availabilityUnavailable": "{{count}} अनुपलब्ध",
      "context": {
        "title": "रिपोर्ट्स वर्कस्पेस कॉन्टेक्स्ट",
        "subtitle": "पोर्टफोलियो, वित्तीय परिणाम, कर, खाता प्रबंधन, और डेटा-गुणवत्ता रिपोर्टों तक पहुंचें।",
        "availableReports": "{{count}} रिपोर्ट उपलब्ध छन्।",
        "filterInfo": "व्यक्तिगत रिपोर्ट फिल्टर प्रयोग गरेर विशिष्ट डेटा श्रेणी र मापदण्डहरू साँघुरो पार्नुहोस्।"
      },
      "badges": {
        "lockedTier": "स्तर बंद",
        "lockedPermission": "प्रवेश प्रतिबंधित",
        "unavailableData": "डाटा उपलब्ध छैन",
        "unavailableRoute": "मार्ग उपलब्ध छैन",
        "trustWarning": "विश्वास चेतावनी",
        "trustError": "विश्वास त्रुटि",
        "exportReady": "निर्यात तयार",
        "issueCount": "{{count}} मुद्दाहरू",
        "exportDisabled": "निर्यात बंद"
      },
      "disabledReason": {
        "unavailableData": "रिपोर्ट डेटा हाल उपलब्ध छैन।",
        "unavailableRoute": "इस खाते के लिए रिपोर्ट रूट अनुपलब्ध छ।"
      },
      "trustStatus": {
        "title": "प्रतिष्ठा को सत्यापन आवश्यक",
        "description": "एक या अधिक रिपोर्ट वर्तमान मा डेटा गुणवत्ता या प्रमाणीकरण समस्याओं द्वारा प्रभावित छन्।"
      },
      "card": {
        "badges": {
          "exportReady": "निर्यात तयार",
          "exportDisabled": "निर्यात बंद"
        }
      },
      "groups": {
        "portfolio": {
          "title": "पोर्टफोलियो रिपोर्ट"
        },
        "performance": {
          "title": "परफॉर्मेंस रिपोर्ट"
        },
        "compliance": {
          "title": "कर, NFRS, र अनुपालन रिपोर्टहरू"
        },
        "other": {
          "title": "अन्य रिपोर्ट"
        }
      },
      "lockReasons": {
        "routeUnavailable": "रिपोर्ट रुट उपलब्ध छैन"
      },
      "remediation": {
        "enableValuationFacts": "यो रिपोर्ट सक्षम बनाउन बजार मूल्य र मूल्याङ्कन तथ्यहरू समीक्षा गर्नुहोस्",
        "upgradeTier": "यो रिपोर्ट पहुँच गर्न प्रोफेशनल टियरमा अपग्रेड गर्नुहोस्",
        "requestPermission": "आवश्यक अनुमतिका लागि प्रशासकलाई सम्पर्क गर्नुहोस्",
        "resolveNfrsDataQuality": "यो रिपोर्ट सक्षम बनाउन NFRS डाटा-गुणस्तर अन्तरहरू समाधान गर्नुहोस्",
        "importPortfolioData": "यो रिपोर्ट सक्षम बनाउन कारोबार आयात गरी पोर्टफोलियो डाटा उत्पन्न गर्नुहोस्"
      },
      "workspaceTools": {
        "title": "कार्यस्थान उपकरणहरू"
      },
      "trust": {
        "verified": "प्रमाणित",
        "warning": "चेतावनी",
        "error": "त्रुटि"
      },
      "support": {
        "title": "समर्थन उपकरणहरू",
        "recentActivity": {
          "title": "हालको रिपोर्ट गतिविधि",
          "description": "नवीनतम रिपोर्ट उत्पादन गतिविधि र रनटाइम प्रमाण समीक्षा गर्नुहोस्।"
        },
        "exportReadiness": {
          "title": "निर्यात तयारी",
          "description": "रिपोर्ट एन्डपोइन्टहरूको लागि निर्यात क्षमता र रनटाइम एडाप्टर तयारी जाँच गर्नुहोस्।"
        }
      }
    },
    "titles": {
      "sectorAllocation": "विभागीय वितरण",
      "concentration": "केंद्रीकरण",
      "performanceHub": "प्रदर्शन",
      "performanceDrivers": "परफॉर्मेंस ड्राइवर्स",
      "performanceBenchmark": "परफॉर्मेंस बेंचमार्क",
      "performanceRisk": "परफॉर्मेंस जोखिम",
      "holdingsReport": "होल्डिङ प्रतिवेदन",
      "transactionsReport": "लेनदेनहरू",
      "profitAndLoss": "नाफा र नोक्सान",
      "realizedProfitAndLoss": "रियलाइज्ड नाफा र नोक्सान",
      "nfrsDashboard": "NFRS ड्यासबोर्ड",
      "nfrsMonthly": "एनएफआरएस मासिक",
      "dataQualityReport": "डेटा गुणवत्ता रिपोर्ट",
      "pivotAnalysis": "पाइवोट विश्लेषण"
    },
    "Concentration": "एकाग्रता जोखिम",
    "trustBanner": {
      "verifiedTitle": "डेटा गुणवत्ता सत्यापित",
      "warningTitle": "डेटा गुणवत्ता चेतावनी",
      "errorTitle": "डेटा गुणवत्ता त्रुटियाँ",
      "verifiedAriaLabel": "सब कुछ डेटा गुणवत्ता जांच मा सफल हुआ",
      "verifiedMessage": "सब कुछ डेटा गुणवत्ता जांच मा सफल हुआ",
      "issue": {
        "unknown": "कुछ रिपोर्ट डेटा सत्यापन की आवश्यकता छ।",
        "dataStale": "केही रिपोर्ट डेटा अद्यावधिक नभएको हुन सक्छ र पुन: लोड गर्नु आवश्यक हुन सक्छ।",
        "dataMissing": "केही आवश्यक रिपोर्ट डेटा छुटेको हुन सक्छ।",
        "dataDelayed": "नयाँ रिपोर्ट डेटा ढिलो उपलब्ध हुन सक्छ।",
        "reconciliationPending": "एक या अधिक रिपोर्ट स्रोतों के लिए संतुलन प्रतीक्षा मा छ।",
        "reconciliationUnbalanced": "संतुलन जांच मा असंतुलन पाया गया छ।",
        "qualityCheckFailed": "यह रिपोर्ट के लिए डेटा गुणवत्ता जांच विफल हो गई छ।",
        "exportSourceUnavailable": "रिपोर्टको आवश्यक स्रोत उपलब्ध छैन।",
        "metadataMissing": "रिपोर्ट मेटाडेटा अपूर्ण छ र समीक्षा आवश्यक छ।"
      }
    },
    "filters": {
      "asOfDate": {
        "label": "मिति अनुसार"
      },
      "dateFrom": {
        "label": "मिति देखि"
      },
      "dateTo": {
        "label": "मिति सम्म"
      },
      "clientAccountId": {
        "label": "ग्राहक"
      },
      "portfolioAccountId": {
        "label": "पोर्टफोलियो खाता"
      },
      "instrument": {
        "label": "उपकरण"
      },
      "sector": {
        "label": "क्षेत्र"
      },
      "symbol": {
        "label": "प्रतीक"
      },
      "transactionType": {
        "label": "प्रकार",
        "options": {
          "purchase": "खरिद",
          "sale": "बिक्री",
          "bonus": "बोनस",
          "right": "राइट",
          "redemption": "रिडेम्सन"
        }
      },
      "certaintyLevel": {
        "label": "विश्वास स्तर",
        "options": {
          "high": "उच्च",
          "medium": "मध्यम",
          "low": "न्यून",
          "invalid": "अस्थिर"
        }
      },
      "boid": {
        "label": "बीआईडी",
        "labelDesc": "बीआईडी"
      },
      "dateFromDesc": "मिति देखि",
      "dateToDesc": "मिति सम्म",
      "sectorDesc": "क्षेत्र",
      "accountNumber": " खाता संख्या",
      "accountNumberDesc": "खाता संख्या",
      "taxId": "कर आईडी",
      "taxIdDesc": "कर आईडी",
      "internalCode": "अंतर्निहित कोड",
      "internalCodeDesc": "अंतर्निहित कोड",
      "secretKey": "सुरक्षा की गोपनीयता की चाबी",
      "secretKeyDesc": "सुरक्षा की गोपनीयता की चाबी",
      "status": {
        "open": "खुला",
        "resolved": "समाधान भएको",
        "approved": "स्वीकृत",
        "rejected": "अस्वीकृत",
        "submitted": "पेश गरियो",
        "pendingApproval": "स्वीकृति विचाराधीन",
        "posted": "पोस्ट भयो",
        "cancelled": "रद्द गरियो",
        "draft": "मस्यौदा",
        "withdrawn": "फिर्ता लिइएको",
        "reversed": "उल्टाइएको",
        "rolledBack": "रोलब्याक गरिएको"
      },
      "type": {
        "buy": "खरिद",
        "sell": "बिक्री",
        "corporateAction": "कर्पोरेट कार्य",
        "transfer": "स्थानान्तरण",
        "openingBalance": "प्रारम्भिक मौज्दात",
        "bonusShare": "बोनस शेयर",
        "rightShare": "हकप्रद शेयर",
        "split": "शेयर विभाजन",
        "consolidation": "शेयर समेकन",
        "merger": "मर्जर",
        "transferIn": "भित्र स्थानान्तरण",
        "transferOut": "बाहिर स्थानान्तरण",
        "fee": "शुल्क",
        "tax": "कर"
      },
      "severity": {
        "info": "जानकारी",
        "warning": "चेतावनी",
        "critical": "गम्भीर"
      }
    },
    "names": {
      "portfolioHoldings": "पोर्टफोलियो होल्डिङहरू",
      "transactionHistory": "कारोबार इतिहास",
      "monthlyPnL": "मासिक P&L",
      "realizedGainLoss": "प्राप्त नाफा / नोक्सान (NFRS)",
      "unrealizedGainLoss": "अप्राप्त नाफा / नोक्सान",
      "nfrsPortfolio": "एनएफआरएस पोर्टफोलियो",
      "taxSummary": "कर संक्षेप",
      "dividendReport": "विभाजन रिपोर्ट",
      "capitalGainReport": "मूल्य मा लाभ रिपोर्ट"
    },
    "status": {
      "pending": "KYC विचाराधीन",
      "pendingApproval": "स्वीकृति की प्रतीक्षा में",
      "approved": "कार्यप्रवाह सफलतापूर्वक अनुमोदित।",
      "rejected": "KYC अस्वीकार",
      "posted": "पोस्ट गरियो",
      "finalized": "पूर्ण",
      "cancelled": "रद्द",
      "failed": "असफल",
      "processing": "प्रशोधन हुँदै",
      "completed": "सम्पन्न",
      "available": "उपलब्ध",
      "unavailable": "अनुपलब्ध",
      "locked": "लक गरिएको",
      "dataUnavailable": "डेटा उपलब्ध छैन",
      "disabled": "अक्षम",
      "dataIssues": "डेटा समस्याहरू",
      "dataErrors": "डेटा त्रुटियाँ",
      "verified": "प्रमाणित",
      "locked_tier": "उच्च योजना आवश्यक",
      "locked_permission": "अनुमति आवश्यक",
      "unavailable_data": "डेटा अनुपलब्ध",
      "unavailable_route": "मार्ग अनुपलब्ध",
      "checking": "स्थिति जाँच हुँदैछ",
      "not_checked": "स्थिति जाँचिएको छैन",
      "needsReview": "समीक्षा की आवश्यकता छ",
      "dataIssue": "डेटा समस्या",
      "unknown": "अज्ञात",
      "ok": "ठीक",
      "warning": "चेतावनी",
      "error": "त्रुटि"
    },
    "ariaLabels": {
      "reportLocked": "रिपोर्ट बंद छ",
      "dataUnavailable": "रिपोर्ट डेटा उपलब्ध छैन",
      "reportRouteUnavailable": "रिपोर्ट रुट उपलब्ध छैन",
      "dataQualityWarning": "रिपोर्ट डेटा गुणवत्ता संकेत",
      "dataQualityError": "रिपोर्ट डेटा गुणवत्ता त्रुटि",
      "reportVerified": "रिपोर्ट सत्यापित छ",
      "lockedSuffix": "बंद",
      "disabledSuffix": "निष्क्रिय",
      "dataIssuesSuffix": "पुर्न-निरीक्षण",
      "reportMetadata": "रिपोर्ट का विवरण",
      "availableExportFormats": "संग्रहीत रूपांतरित स्वरूप"
    },
    "availability": {
      "OK": "उपलब्ध",
      "NO_DATA": "कुनै डेटा छैन",
      "PARTIAL": "भागीदारी डेटा",
      "UNAVAILABLE": "अनुपलब्ध",
      "ERROR": "त्रुटि",
      "LOCKED": "लक",
      "ariaLabel": "उपलब्धता अनुसार फिल्टर गर्नुहोस्",
      "all": "सबै",
      "available": "उपलब्ध",
      "unavailable": "अनुपलब्ध",
      "locked": "लक"
    },
    "availability_description": {
      "OK": "रिपोर्ट डेटा पूर्ण और उपलब्ध छ।",
      "NO_DATA": "यस रिपोर्टको लागि अहिलेसम्म कुनै डेटा छैन।",
      "PARTIAL": "रिपोर्ट डेटा भागीदारी मा उपलब्ध छ। कुछ रिकॉर्ड पूर्णतः खो दिए गए छन्।",
      "UNAVAILABLE": "रिपोर्ट वर्तमान मा असमर्थ छ क्योंकि डेटा स्रोत समस्या के कारण।",
      "ERROR": "रिपोर्ट प्राप्त करने की प्रक्रिया मा एक त्रुटि हुई छ।",
      "LOCKED": "आपके वर्तमान सदस्यता स्तर के लिए यह रिपोर्ट बंद छ।"
    },
    "locked": {
      "tier": "यो रिपोर्ट पहुँच गर्न आफ्नो सदस्यता अपग्रेड गर्नुहोस्।",
      "permission": "तपाईंसँग यो रिपोर्ट हेर्ने अनुमति छैन। आफ्नो प्रशासकलाई सम्पर्क गर्नुहोस्।",
      "tierCta": "योजना अपग्रेड गर्नुहोस्",
      "permissionCta": "पहुँचको अनुरोध गर्नुहोस्"
    },
    "unavailable": {
      "data": "रिपोर्ट डाटा हाल अनुपलब्ध छ। कृपया पछि फेरि प्रयास गर्नुहोस्।",
      "dataHelp": "यो चलिरहेको डाटा रिफ्रेस वा अस्थायी सेवा समस्याको कारण हुन सक्छ।",
      "route": "वर्तमान में, रिपोर्ट मार्ग असमर्थ छ।",
      "feature": "वर्तमान में, इस रिपोर्ट विशेषता असमर्थ छ।",
      "exportUnsupported": "यो रिपोर्टका लागि निर्यात समर्थित छैन।",
      "exportUnsupportedHelp": "यो रिपोर्टका लागि निर्यात सक्षम गर्न आफ्नो प्रशासकलाई सम्पर्क गर्नुहोस्।",
      "genericDescription": "सामान्य वर्णन",
      "reportTitle": "रिपोर्ट",
      "genericTitle": "एउटा त्रुटि भयो। कृपया पुन: प्रयास गर्नुहोस्।"
    },
    "dataQuality": {
      "error": "रिपोर्ट डेटा गंभीर गुणवत्ता समस्याओं से पीड़ित छ।",
      "warning": "रिपोर्ट डेटा गुणवत्ता चेतावनियों से पीड़ित छ।",
      "stale": "रिपोर्ट डेटा पुराना दिखाई देता छ।",
      "missing": "रिपोर्ट डेटा खो दिया गया छ।",
      "metadataMissing": "यो रिपोर्ट प्रदर्शन गर्न सकिँदैन किनकि अद्यावधिक मेटाडेटा अवस्थित छैन। रिपोर्ट पुन: हेर्नुहोस् वा डेटा गुणवत्ता समीक्षा गर्नुहोस्।े से पहले इसे उपयोग गर्नुहोस्।",
      "reconciliation": {
        "unbalanced": "रिपोर्ट संतुलन असमान छ।",
        "pending": "प्रतीक्षा मिति कार्य पूर्ण नही हो सकले छ",
        "failed": "रिपोर्ट कार्य पूर्ण नही हो सकले छ"
      },
      "missingMarketPrices": "व्यापारिक मूल्य निर्धारण लाभकारी के लिए उपलब्ध नही छ",
      "clientAccount": "ग्राहक खाता",
      "clientAccountDesc": "ग्राहक खाता",
      "asOfDate": "मिति अनुसार",
      "asOfDateDesc": "मिति अनुसार",
      "qualityCategory": "गुणवत्ता श्रेणी",
      "qualityCategoryDesc": "गुणवत्ता श्रेणी",
      "category": "श्रेणी",
      "categoryDesc": "श्रेणी",
      "checkName": "नियंत्रण नाम",
      "checkNameDesc": "नियंत्रण नाम",
      "status": "स्थिति",
      "statusDesc": "स्थिति",
      "affectedRecords": "प्रभावित रिकॉर्ड",
      "affectedRecordsDesc": "प्रभावित रिकॉर्ड",
      "severity": "गम्भीरता",
      "severityDesc": "गम्भीरता",
      "lastChecked": "अन्तिम जाँच",
      "lastCheckedDesc": "अन्तिम जाँच",
      "description": "गुणवत्ता विवरण",
      "descriptionDesc": "IRD-संगत CSV ढाँचामा कर रजिस्टरहरू डाउनलोड गर्नुहोस्।",
      "totalChecks": "कुल नियंत्रण",
      "totalChecksDesc": "कुल नियंत्रण",
      "passedChecks": "पूर्ण नियंत्रण",
      "passedChecksDesc": "पूर्ण नियंत्रण",
      "failedChecks": "विफल नियंत्रण",
      "failedChecksDesc": "विफल नियंत्रण",
      "overallQualityScore": "सामान्य गुणवत्ता स्कोर",
      "overallQualityScoreDesc": "सामान्य गुणवत्ता स्कोर"
    },
    "export": {
      "generating": "निर्यात बनाउँदैछ…",
      "ready": "निर्यात तयार",
      "downloading": "निर्यात डाउनलोड गर्नुहोस्…",
      "failed": "निर्यात विफल हो गया",
      "notAvailable": "निर्यात उपलब्ध छैन",
      "formatPdf": "PDF स्वरूपमा निर्यात बनाउनुहोस्",
      "formatExcel": "Excel स्वरूपमा निर्यात बनाउनुहोस्",
      "formatCsv": "CSV स्वरूपमा निर्यात बनाउनुहोस्",
      "error": {
        "title": "निर्यात विफल हो गया",
        "transactions": "निर्यात लेन-देनों को निकालने मा असमर्थ",
        "holdings": "निर्यात संपत्तियों को निकालने मा असमर्थ"
      }
    },
    "transactions": {
      "error": {
        "loadFailed": "निर्यात लोड करने मा असमर्थ",
        "approveFailed": "निर्यात अनुमति देने मा असमर्थ",
        "rejectFailed": "निर्यात प्रतिलंबित करने मा असमर्थ",
        "deleteFailed": "निर्यात हटाने मा असमर्थ",
        "submitFailed": "निर्यात जमा करने मा असमर्थ",
        "reversalRequestFailed": "निर्यात प्रतिलंब अनुरोध करने मा असमर्थ",
        "reversalApproveFailed": "निर्यात प्रतिलंब अनुमति देने मा असमर्थ",
        "reversalRejectFailed": "निर्यात प्रतिलंब प्रतिरोध करने मा असमर्थ",
        "repairFailed": "पुनर्निर्माण कार्य विफल हो गया",
        "reversalsLoadFailed": "विनिमय पंक्ति लोड करने मा असमर्थ",
        "exportFailed": "फाइल को निकालने मा विफल रहा",
        "saveFailed": "निवेशों को संग्रहीत करने मा विफल रहा"
      },
      "clientAccount": "ग्राहक खाता",
      "clientAccountDesc": "ग्राहक खाता",
      "instrument": "उपकरण",
      "instrumentDesc": "उपकरण",
      "transactionType": "व्यापारिक प्रकार",
      "transactionTypeDesc": "व्यापारिक प्रकार",
      "dateFrom": "मिति देखि",
      "dateFromDesc": "मिति देखि",
      "dateTo": "मिति सम्म",
      "dateToDesc": "मिति सम्म",
      "date": "मिति",
      "dateDesc": "मिति",
      "client": "ग्राहक",
      "clientDesc": "ग्राहक",
      "symbol": "प्रतीक",
      "symbolDesc": "प्रतीक",
      "type": "प्रकार",
      "typeDesc": "प्रकार",
      "quantity": "मात्रा",
      "quantityDesc": "मात्रा",
      "price": "मूल्य",
      "priceDesc": "मूल्य",
      "totalAmount": "कुल रकम",
      "totalAmountDesc": "कुल रकम",
      "commission": "कमिशन",
      "commissionDesc": "कमिशन",
      "billNo": "बिल नम्बर",
      "billNoDesc": "बिल नम्बर",
      "brokerNo": "ब्रोकर नंबर",
      "brokerNoDesc": "ब्रोकर नंबर",
      "status": "स्थिति",
      "statusDesc": "स्थिति",
      "createdBy": "निर्मित द्वारा",
      "createdByDesc": "निर्मित द्वारा",
      "importBatchId": "आयाती बैच आईडी",
      "importBatchIdDesc": "आयाती बैच आईडी",
      "importEntryId": "आयाती प्रवेश आईडी",
      "importEntryIdDesc": "आयाती प्रवेश आईडी",
      "sourceRowNumber": "स्रोत रो नंबर",
      "sourceRowNumberDesc": "स्रोत रो नंबर",
      "totalTransactions": "कुल लेनदेनहरू",
      "totalTransactionsDesc": "कुल लेनदेनहरू",
      "totalCommission": "कुल आयुक्त",
      "totalCommissionDesc": "कुल आयुक्त"
    },
    "recent": {
      "unknownReport": "ज्ञात रिपोर्ट नाही",
      "generatedByOrganization": "संगठन द्वारे बनाए गए छं",
      "generatedInternally": "अंदर से बनाए गए छं",
      "report": "रिपोर्ट",
      "completed": "सम्पन्न",
      "output": "आउटपुट",
      "actor": "कार्यकर्ता",
      "noRecentReports": "हाल ही मा रिपोर्ट नाही"
    },
    "loading": "रिपोर्ट डेटा लोड गर्ने...",
    "lastGenerated": {
      "label": "अंतिम बनाए गए",
      "justNow": "अहिले",
      "hoursAgo": "{{hours}} घण्टा अघि",
      "daysAgo": "{{days}} दिन अघि"
    },
    "rowCount": "{{count}} रिकार्ड",
    "formats": {
      "label": "प्रकार",
      "format": "निकास प्रकार"
    },
    "audit": {
      "allEntityTypes": "सबै इकाई प्रकारहरू",
      "portfolio": "पोर्टफोलियो",
      "transaction": "लेनदेन",
      "instrument": "उपकरण",
      "journal": "जर्नल",
      "user": "प्रयोगकर्ता",
      "organization": "संगठन",
      "report": "रिपोर्ट",
      "import": "आयात",
      "views": {
        "lineage": {
          "title": "लाइनएज प्रमाण",
          "description": "आयात, पोस्टिङ, मूल्याङ्कन, र रिपोर्ट जीवनचक्र घटनाहरूमा लाइनएज प्रमाण ट्रेस गर्नुहोस्।",
          "summary": "अनुसन्धान र प्रमाण वर्कफ्लोका लागि आयातदेखि रिपोर्टसम्म ट्रेसेबिलिटी।",
          "empty": "चयन गरिएका फिल्टरहरूका लागि कुनै लाइनएज प्रमाण फेला परेन।"
        }
      },
      "showingUpTo": "अधिकतम देखाइँदै",
      "entries": "प्रविष्टिहरू",
      "system": "प्रणाली",
      "title": "अडिट",
      "description": "अडिट ट्रेल र गभर्नेन्स रिपोर्टहरू",
      "unavailable": "लेखापरीक्षण रिपोर्ट अनुपलब्ध",
      "changeHistory": "परिवर्तन इतिहास",
      "governanceTrail": "व्यवसायिक मार्गदर्शिका",
      "certificationEvidence": "प्रमाणीकरण प्रमाण",
      "datasetCertifications": "डेटा सेट प्रमाणीकरण",
      "operationalAudit": "संचालन परीक्षण",
      "operationalSurfaces": "संचालन सतहें",
      "activity": "हालको गतिविधि",
      "filteredBy": "फ़िल्टर द्वारा",
      "noActivity": "कुनै रेकर्ड दर्ज गरिएको छैन",
      "time": "समय",
      "action": "कार्य",
      "entity": "इकाई",
      "page": "कारोबारहरू",
      "matchingFilter": "मेल खाने फिल्टर",
      "loadError": "संशोधन रिपोर्ट लोड गर्न विफल रहा",
      "notRegistered": {
        "title": "दर्ता भएको छैन",
        "description": "तपाईं लेखापरीक्षण रिपोर्टमा पहुँच गर्न सक्नुहुन्न।",
        "action": "ड्यासबोर्डमा फर्कनुहोस्"
      },
      "accessDenied": {
        "title": "प्रवेश नियंत्रित छ",
        "description": "तपाईं लेखापरीक्षण रिपोर्टमा पहुँच गर्न सक्नुहुन्न।",
        "action": "ड्यासबोर्डमा फर्कनुहोस्"
      },
      "scopeNotice": "आपकी पहुँच के भीतर संशोधन रिपोर्ट दिखाई गई छ।",
      "auditHubLink": "प्रारंभिक निगरानी केंद्र खोल्नु",
      "activityTrail": {
        "title": "क्रिया पथ"
      },
      "loading": "अनुगमन मूल्यांकन लोड हुँदैछ…",
      "noEvents": "अनुगमन लगमा कुनै घटना फेला परेन",
      "defaultEntityType": "सबै इकाई प्रकारहरू",
      "openAuditHub": "प्रारंभिक निगरानी केंद्र खोल्नु",
      "invalidViewFallback": "अनुचित दृश्य वापसी",
      "exportLogs": "मूल्यांकन लॉग्स निकालना",
      "exportLogsDesc": "मूल्यांकन लॉग्स निकालना",
      "viewLineage": "विवरण को देख्नु",
      "viewLineageDesc": "विवरण को देख्नु",
      "redactClientNames": "प्रतिदिनायक नाम छिपानु",
      "redactClientNamesDesc": "प्रतिदिनायक नाम छिपानु",
      "redactAmounts": "मूल्यांकन छिपानु",
      "redactAmountsDesc": "मूल्यांकन छिपानु"
    },
    "catalog": {
      "investment": "लगानी",
      "investmentDescription": "पोर्टफोलियो र लगानी व्यवस्थापन रिपोर्टहरू",
      "accounting": "हिसाब-नामा",
      "accountingDescription": "वित्तीय विवरण र हिसाब-नामा रिपोर्टहरू",
      "tax": "कर",
      "taxDescription": "कर रिपोर्ट र अनुपालन प्रलेखन",
      "organization": "संगठन",
      "organizationDescription": "संगठनात्मक र प्रशासकिय रिपोर्टहरू",
      "audit": "अडिट",
      "auditDescription": "अडिट ट्रेल र गभर्नेन्स रिपोर्टहरू",
      "dataQuality": "डाटा गुणस्तर",
      "dataQualityDescription": "डाटा प्रमाणीकरण र गुणस्तर रिपोर्टहरू",
      "highlights": {
        "investment": {
          "performanceReturnsAndRiskMetrics": "वित्तीय परिणाम और जोखिम मापदंड",
          "holdingsWithCostBasisAndGains": "वित्तीय संपत्ति के लागत आधार और लाभ",
          "transactionHistoryAndMonthlyAnalysis": "व्यापारिक इतिहास और मासिक विश्लेषण"
        },
        "accounting": {
          "generalLedgerWithOpeningClosingBalances": "सामान्य खाता साथ खुली/बंद बैलेंस",
          "journalEntriesWithApprovalHistory": "अनुमोदन इतिहास सहित लेखाङ्कन",
          "bankReconciliationStatusAndTrialBalance": "बैंक पुनर्मूल्यांकन स्थिति और ट्रायल बैलेंस"
        },
        "tax": {
          "vatAndIrdComplianceReporting": "वट आणि आईआरडी अनुपालन रिपोर्टिंग",
          "capitalGainsTaxLotAnalysis": "पुँजी लाभ प्राप्त गर्ने शेयर विश्लेषण",
          "filingDeadlineTrackingAndWorkflowStatus": "व्यावसायिक अनुपालन रिपोर्टिंग"
        },
        "organization": {
          "executiveSummaryAcrossAllModules": "संगठनात्मक नेतृत्व के लिए एक संक्षिप्त विवरण",
          "workflowApprovalStatusAndDataTrust": "नीति मंजूरी स्थिति और डेटा विश्वास",
          "moduleLevelOperationalHealthMetrics": "मॉड्यूल स्तर पर संचालन स्वास्थ्य मापदंड"
        },
        "audit": {
          "completeChangeHistoryAndGovernanceTrail": "पूर्ण बदले की इतिहास और नीति पथ",
          "datasetAndReportCertificationEvidence": "डेटा सेट और रिपोर्ट प्रमाणीकरण प्रमाण",
          "operationalAuditSurfacesAndCompliance": "संचालन पर्यवेक्षण सतहें और अनुपालन"
        },
        "dataQuality": {
          "reconciliationBreakAnalysisAndDiagnostics": "समायोजन तोड़ विश्लेषण और निदान",
          "trustScoreAndContinuityExceptionTracking": "विश्वास स्कोर और जारी होने का अप्रत्याशित घटना ट्रैकिंग",
          "dataHealthExportForAuditAndValidation": "डेटा स्वास्थ्य निर्यात लेखांकन और सत्यापन के लिए"
        }
      },
      "access-control-audit": {
        "description": "Access Control Audit रिपोर्ट हेर्नुहोस्।",
        "title": "Access Control Audit"
      },
      "accounts-payable-aging": {
        "description": "Accounts Payable Aging रिपोर्ट हेर्नुहोस्।",
        "title": "Accounts Payable Aging"
      },
      "accounts-receivable-aging": {
        "description": "Accounts Receivable Aging रिपोर्ट हेर्नुहोस्।",
        "title": "Accounts Receivable Aging"
      },
      "accrued-interest": {
        "description": "Accrued Interest रिपोर्ट हेर्नुहोस्।",
        "title": "Accrued Interest"
      },
      "ad-hoc-query-results": {
        "description": "Ad Hoc Query Results रिपोर्ट हेर्नुहोस्।",
        "title": "Ad Hoc Query Results"
      },
      "aifmd-annex-iv": {
        "description": "Aifmd Annex Iv रिपोर्ट हेर्नुहोस्।",
        "title": "Aifmd Annex Iv"
      },
      "alpha-generation": {
        "description": "Alpha Generation रिपोर्ट हेर्नुहोस्।",
        "title": "Alpha Generation"
      },
      "amortization-schedule": {
        "description": "Amortization Schedule रिपोर्ट हेर्नुहोस्।",
        "title": "Amortization Schedule"
      },
      "annual-general-meeting-materials": {
        "description": "Annual General Meeting Materials रिपोर्ट हेर्नुहोस्।",
        "title": "Annual General Meeting Materials"
      },
      "annual-investment-report": {
        "description": "Annual Investment Report रिपोर्ट हेर्नुहोस्।",
        "title": "Annual Investment Report"
      },
      "asset-allocation-current": {
        "description": "Asset Allocation Current रिपोर्ट हेर्नुहोस्।",
        "title": "Asset Allocation Current"
      },
      "asset-allocation-target": {
        "description": "Asset Allocation Target रिपोर्ट हेर्नुहोस्।",
        "title": "Asset Allocation Target"
      },
      "asset-class-exposure": {
        "description": "Asset Class Exposure रिपोर्ट हेर्नुहोस्।",
        "title": "Asset Class Exposure"
      },
      "attribution-analysis": {
        "description": "Attribution Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Attribution Analysis"
      },
      "audit-support-package": {
        "description": "Audit Support Package रिपोर्ट हेर्नुहोस्।",
        "title": "Audit Support Package"
      },
      "audit-trail": {
        "description": "Audit Trail रिपोर्ट हेर्नुहोस्।",
        "title": "Audit Trail"
      },
      "aum-flow-analysis": {
        "description": "Aum Flow Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Aum Flow Analysis"
      },
      "automation-coverage": {
        "description": "Automation Coverage रिपोर्ट हेर्नुहोस्।",
        "title": "Automation Coverage"
      },
      "backtesting-results": {
        "description": "Backtesting Results रिपोर्ट हेर्नुहोस्।",
        "title": "Backtesting Results"
      },
      "balance-sheet": {
        "description": "Balance Sheet रिपोर्ट हेर्नुहोस्।",
        "title": "Balance Sheet"
      },
      "bank-reconciliation": {
        "description": "Bank Reconciliation रिपोर्ट हेर्नुहोस्।",
        "title": "Bank Reconciliation"
      },
      "basel-iii-pillar3": {
        "description": "Basel Iii Pillar3 रिपोर्ट हेर्नुहोस्।",
        "title": "Basel Iii Pillar3"
      },
      "benchmark-comparison": {
        "description": "Benchmark Comparison रिपोर्ट हेर्नुहोस्।",
        "title": "Benchmark Comparison"
      },
      "best-execution-report": {
        "description": "Best Execution Report रिपोर्ट हेर्नुहोस्।",
        "title": "Best Execution Report"
      },
      "beta-analysis": {
        "description": "Beta Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Beta Analysis"
      },
      "billing-usage-report": {
        "description": "Billing Usage Report रिपोर्ट हेर्नुहोस्।",
        "title": "Billing Usage Report"
      },
      "board-reporting-package": {
        "description": "Board Reporting Package रिपोर्ट हेर्नुहोस्।",
        "title": "Board Reporting Package"
      },
      "bond-portfolio-valuation": {
        "description": "Bond Portfolio Valuation रिपोर्ट हेर्नुहोस्।",
        "title": "Bond Portfolio Valuation"
      },
      "branch-usage-metrics": {
        "description": "Branch Usage Metrics रिपोर्ट हेर्नुहोस्।",
        "title": "Branch Usage Metrics"
      },
      "breach-notification-log": {
        "description": "Breach Notification Log रिपोर्ट हेर्नुहोस्।",
        "title": "Breach Notification Log"
      },
      "budget-variance": {
        "description": "Budget Variance रिपोर्ट हेर्नुहोस्।",
        "title": "Budget Variance"
      },
      "budget-vs-actual": {
        "description": "Budget Vs Actual रिपोर्ट हेर्नुहोस्।",
        "title": "Budget Vs Actual"
      },
      "business-performance-overview": {
        "description": "Business Performance Overview रिपोर्ट हेर्नुहोस्।",
        "title": "Business Performance Overview"
      },
      "call-put-analysis": {
        "description": "Call Put Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Call Put Analysis"
      },
      "calmar-ratio": {
        "description": "Calmar Ratio रिपोर्ट हेर्नुहोस्।",
        "title": "Calmar Ratio"
      },
      "carbon-footprint": {
        "description": "Carbon Footprint रिपोर्ट हेर्नुहोस्।",
        "title": "Carbon Footprint"
      },
      "carried-interest-allocation": {
        "description": "Carried Interest Allocation रिपोर्ट हेर्नुहोस्।",
        "title": "Carried Interest Allocation"
      },
      "cash-flow-forecast": {
        "description": "Cash Flow Forecast रिपोर्ट हेर्नुहोस्।",
        "title": "Cash Flow Forecast"
      },
      "cash-flow-projection": {
        "description": "Cash Flow Projection रिपोर्ट हेर्नुहोस्।",
        "title": "Cash Flow Projection"
      },
      "cash-flow-statement": {
        "description": "Cash Flow Statement रिपोर्ट हेर्नुहोस्।",
        "title": "Cash Flow Statement"
      },
      "cash-position-by-currency": {
        "description": "Cash Position By Currency रिपोर्ट हेर्नुहोस्।",
        "title": "Cash Position By Currency"
      },
      "cash-projection": {
        "description": "Cash Projection रिपोर्ट हेर्नुहोस्।",
        "title": "Cash Projection"
      },
      "cdsc-account-freeze-unfreeze": {
        "description": "Cdsc Account Freeze Unfreeze रिपोर्ट हेर्नुहोस्।",
        "title": "Cdsc Account Freeze Unfreeze"
      },
      "cdsc-beneficial-ownership": {
        "description": "Cdsc Beneficial Ownership रिपोर्ट हेर्नुहोस्।",
        "title": "Cdsc Beneficial Ownership"
      },
      "cdsc-demat-remat": {
        "description": "Cdsc Demat Remat रिपोर्ट हेर्नुहोस्।",
        "title": "Cdsc Demat Remat"
      },
      "cdsc-isin-allocation": {
        "description": "Cdsc Isin Allocation रिपोर्ट हेर्नुहोस्।",
        "title": "Cdsc Isin Allocation"
      },
      "cdsc-pledge-unpledge": {
        "description": "Cdsc Pledge Unpledge रिपोर्ट हेर्नुहोस्।",
        "title": "Cdsc Pledge Unpledge"
      },
      "cdsc-transfer-transmission": {
        "description": "Cdsc Transfer Transmission रिपोर्ट हेर्नुहोस्।",
        "title": "Cdsc Transfer Transmission"
      },
      "cftc-reporting": {
        "description": "Cftc Reporting रिपोर्ट हेर्नुहोस्।",
        "title": "Cftc Reporting"
      },
      "clawback-calculation": {
        "description": "Clawback Calculation रिपोर्ट हेर्नुहोस्।",
        "title": "Clawback Calculation"
      },
      "client-acquisition-metrics": {
        "description": "Client Acquisition Metrics रिपोर्ट हेर्नुहोस्।",
        "title": "Client Acquisition Metrics"
      },
      "client-advisory-notes": {
        "description": "Client Advisory Notes रिपोर्ट हेर्नुहोस्।",
        "title": "Client Advisory Notes"
      },
      "client-asset-allocation": {
        "description": "Client Asset Allocation रिपोर्ट हेर्नुहोस्।",
        "title": "Client Asset Allocation"
      },
      "client-beneficiary-report": {
        "description": "Client Beneficiary Report रिपोर्ट हेर्नुहोस्।",
        "title": "Client Beneficiary Report"
      },
      "client-capital-gain-loss": {
        "description": "Client Capital Gain Loss रिपोर्ट हेर्नुहोस्।",
        "title": "Client Capital Gain Loss"
      },
      "client-consolidated-view": {
        "description": "Client Consolidated View रिपोर्ट हेर्नुहोस्।",
        "title": "Client Consolidated View"
      },
      "client-fee-statement": {
        "description": "Client Fee Statement रिपोर्ट हेर्नुहोस्।",
        "title": "Client Fee Statement"
      },
      "client-holdings": {
        "description": "Client Holdings रिपोर्ट हेर्नुहोस्।",
        "title": "Client Holdings"
      },
      "client-income-statement": {
        "description": "Client Income Statement रिपोर्ट हेर्नुहोस्।",
        "title": "Client Income Statement"
      },
      "client-investment-policy-compliance": {
        "description": "Client Investment Policy Compliance रिपोर्ट हेर्नुहोस्।",
        "title": "Client Investment Policy Compliance"
      },
      "client-onboarding-package": {
        "description": "Client Onboarding Package रिपोर्ट हेर्नुहोस्।",
        "title": "Client Onboarding Package"
      },
      "client-performance-summary": {
        "description": "Client Performance Summary रिपोर्ट हेर्नुहोस्।",
        "title": "Client Performance Summary"
      },
      "client-portfolio-statement": {
        "description": "Client Portfolio Statement रिपोर्ट हेर्नुहोस्।",
        "title": "Client Portfolio Statement"
      },
      "client-retention-analysis": {
        "description": "Client Retention Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Client Retention Analysis"
      },
      "client-risk-profile": {
        "description": "Client Risk Profile रिपोर्ट हेर्नुहोस्।",
        "title": "Client Risk Profile"
      },
      "client-tax-statement": {
        "description": "Client Tax Statement रिपोर्ट हेर्नुहोस्।",
        "title": "Client Tax Statement"
      },
      "client-transaction-history": {
        "description": "Client Transaction History रिपोर्ट हेर्नुहोस्।",
        "title": "Client Transaction History"
      },
      "code-of-ethics-attestation": {
        "description": "Code Of Ethics Attestation रिपोर्ट हेर्नुहोस्।",
        "title": "Code Of Ethics Attestation"
      },
      "collateral-management": {
        "description": "Collateral Management रिपोर्ट हेर्नुहोस्।",
        "title": "Collateral Management"
      },
      "commodity-exposure": {
        "description": "Commodity Exposure रिपोर्ट हेर्नुहोस्।",
        "title": "Commodity Exposure"
      },
      "compliance-monitoring-dashboard": {
        "description": "Compliance Monitoring Dashboard रिपोर्ट हेर्नुहोस्।",
        "title": "Compliance Monitoring Dashboard"
      },
      "compliance-training-tracking": {
        "description": "Compliance Training Tracking रिपोर्ट हेर्नुहोस्।",
        "title": "Compliance Training Tracking"
      },
      "concentration-risk": {
        "description": "Concentration Risk रिपोर्ट हेर्नुहोस्।",
        "title": "Concentration Risk"
      },
      "conflict-of-interest": {
        "description": "Conflict Of Interest रिपोर्ट हेर्नुहोस्।",
        "title": "Conflict Of Interest"
      },
      "consolidated-financial-statements": {
        "description": "Consolidated Financial Statements रिपोर्ट हेर्नुहोस्।",
        "title": "Consolidated Financial Statements"
      },
      "controversy-monitoring": {
        "description": "Controversy Monitoring रिपोर्ट हेर्नुहोस्।",
        "title": "Controversy Monitoring"
      },
      "convertible-bond-analysis": {
        "description": "Convertible Bond Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Convertible Bond Analysis"
      },
      "corep": {
        "description": "Corep रिपोर्ट हेर्नुहोस्।",
        "title": "Corep"
      },
      "corporate-action-processing": {
        "description": "Corporate Action Processing रिपोर्ट हेर्नुहोस्।",
        "title": "Corporate Action Processing"
      },
      "corporate-announcement": {
        "description": "Corporate Announcement रिपोर्ट हेर्नुहोस्।",
        "title": "Corporate Announcement"
      },
      "corporate-governance-report": {
        "description": "Corporate Governance Report रिपोर्ट हेर्नुहोस्।",
        "title": "Corporate Governance Report"
      },
      "correlation-matrix": {
        "description": "Correlation Matrix रिपोर्ट हेर्नुहोस्।",
        "title": "Correlation Matrix"
      },
      "cost-allocation": {
        "description": "Cost Allocation रिपोर्ट हेर्नुहोस्।",
        "title": "Cost Allocation"
      },
      "counterparty-risk": {
        "description": "Counterparty Risk रिपोर्ट हेर्नुहोस्।",
        "title": "Counterparty Risk"
      },
      "coupon-payment-schedule": {
        "description": "Coupon Payment Schedule रिपोर्ट हेर्नुहोस्।",
        "title": "Coupon Payment Schedule"
      },
      "credit-rating-distribution": {
        "description": "Credit Rating Distribution रिपोर्ट हेर्नुहोस्।",
        "title": "Credit Rating Distribution"
      },
      "credit-risk-exposure": {
        "description": "Credit Risk Exposure रिपोर्ट हेर्नुहोस्।",
        "title": "Credit Risk Exposure"
      },
      "credit-spread-analysis": {
        "description": "Credit Spread Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Credit Spread Analysis"
      },
      "cross-entity-risk-aggregation": {
        "description": "Cross Entity Risk Aggregation रिपोर्ट हेर्नुहोस्।",
        "title": "Cross Entity Risk Aggregation"
      },
      "cryptocurrency-holdings": {
        "description": "Cryptocurrency Holdings रिपोर्ट हेर्नुहोस्।",
        "title": "Cryptocurrency Holdings"
      },
      "currency-exposure": {
        "description": "Currency Exposure रिपोर्ट हेर्नुहोस्।",
        "title": "Currency Exposure"
      },
      "custom-report-builder": {
        "description": "Custom Report Builder रिपोर्ट हेर्नुहोस्।",
        "title": "Custom Report Builder"
      },
      "data-breach-notification": {
        "description": "Data Breach Notification रिपोर्ट हेर्नुहोस्।",
        "title": "Data Breach Notification"
      },
      "data-completeness": {
        "description": "Data Completeness रिपोर्ट हेर्नुहोस्।",
        "title": "Data Completeness"
      },
      "data-lineage": {
        "description": "Data Lineage रिपोर्ट हेर्नुहोस्।",
        "title": "Data Lineage"
      },
      "data-quality-dashboard": {
        "description": "Data Quality Dashboard रिपोर्ट हेर्नुहोस्।",
        "title": "Data Quality Dashboard"
      },
      "depreciation-schedule": {
        "description": "Depreciation Schedule रिपोर्ट हेर्नुहोस्।",
        "title": "Depreciation Schedule"
      },
      "derivative-portfolio-analysis": {
        "description": "Derivative Portfolio Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Derivative Portfolio Analysis"
      },
      "disaster-recovery-test": {
        "description": "Disaster Recovery Test रिपोर्ट हेर्नुहोस्।",
        "title": "Disaster Recovery Test"
      },
      "dividend-calendar": {
        "description": "Dividend Calendar रिपोर्ट हेर्नुहोस्।",
        "title": "Dividend Calendar"
      },
      "dividend-report": {
        "description": "Dividend Report रिपोर्ट हेर्नुहोस्।",
        "title": "Dividend Report"
      },
      "drawdown-analysis": {
        "description": "Drawdown Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Drawdown Analysis"
      },
      "drift-analysis": {
        "description": "Drift Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Drift Analysis"
      },
      "due-diligence-package": {
        "description": "Due Diligence Package रिपोर्ट हेर्नुहोस्।",
        "title": "Due Diligence Package"
      },
      "duration-convexity-analysis": {
        "description": "Duration Convexity Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Duration Convexity Analysis"
      },
      "earnings-calendar": {
        "description": "Earnings Calendar रिपोर्ट हेर्नुहोस्।",
        "title": "Earnings Calendar"
      },
      "economic-indicator": {
        "description": "Economic Indicator रिपोर्ट हेर्नुहोस्।",
        "title": "Economic Indicator"
      },
      "efficient-frontier": {
        "description": "Efficient Frontier रिपोर्ट हेर्नुहोस्।",
        "title": "Efficient Frontier"
      },
      "emir-reporting": {
        "description": "Emir Reporting रिपोर्ट हेर्नुहोस्।",
        "title": "Emir Reporting"
      },
      "entity-performance-comparison": {
        "description": "Entity Performance Comparison रिपोर्ट हेर्नुहोस्।",
        "title": "Entity Performance Comparison"
      },
      "equalization-calculation": {
        "description": "Equalization Calculation रिपोर्ट हेर्नुहोस्।",
        "title": "Equalization Calculation"
      },
      "error-rate-tracking": {
        "description": "Error Rate Tracking रिपोर्ट हेर्नुहोस्।",
        "title": "Error Rate Tracking"
      },
      "es-report": {
        "description": "Es Report रिपोर्ट हेर्नुहोस्।",
        "title": "Es Report"
      },
      "esg-scorecard": {
        "description": "Esg Scorecard रिपोर्ट हेर्नुहोस्।",
        "title": "Esg Scorecard"
      },
      "exception-alert-summary": {
        "description": "Exception Alert Summary रिपोर्ट हेर्नुहोस्।",
        "title": "Exception Alert Summary"
      },
      "exception-report": {
        "description": "Exception Report रिपोर्ट हेर्नुहोस्।",
        "title": "Exception Report"
      },
      "executive-dashboard": {
        "description": "Executive Dashboard रिपोर्ट हेर्नुहोस्।",
        "title": "Executive Dashboard"
      },
      "expense-analysis": {
        "description": "Expense Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Expense Analysis"
      },
      "factor-exposure": {
        "description": "Factor Exposure रिपोर्ट हेर्नुहोस्।",
        "title": "Factor Exposure"
      },
      "failed-trade": {
        "description": "Failed Trade रिपोर्ट हेर्नुहोस्।",
        "title": "Failed Trade"
      },
      "fatca-crs-reporting": {
        "description": "Fatca Crs Reporting रिपोर्ट हेर्नुहोस्।",
        "title": "Fatca Crs Reporting"
      },
      "fee-report": {
        "description": "Fee Report रिपोर्ट हेर्नुहोस्।",
        "title": "Fee Report"
      },
      "financial-ratios": {
        "description": "Financial Ratios रिपोर्ट हेर्नुहोस्।",
        "title": "Financial Ratios"
      },
      "finrep": {
        "description": "Finrep रिपोर्ट हेर्नुहोस्।",
        "title": "Finrep"
      },
      "fixed-asset-register": {
        "description": "Fixed Asset Register रिपोर्ट हेर्नुहोस्।",
        "title": "Fixed Asset Register"
      },
      "form-pf": {
        "description": "Form Pf रिपोर्ट हेर्नुहोस्।",
        "title": "Form Pf"
      },
      "forward-contract-analysis": {
        "description": "Forward Contract Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Forward Contract Analysis"
      },
      "fund-balance-report": {
        "description": "Fund Balance Report रिपोर्ट हेर्नुहोस्।",
        "title": "Fund Balance Report"
      },
      "fund-factsheet": {
        "description": "Fund Factsheet रिपोर्ट हेर्नुहोस्।",
        "title": "Fund Factsheet"
      },
      "fund-of-funds-look-through": {
        "description": "Fund Of Funds Look Through रिपोर्ट हेर्नुहोस्।",
        "title": "Fund Of Funds Look Through"
      },
      "general-ledger": {
        "description": "General Ledger रिपोर्ट हेर्नुहोस्।",
        "title": "General Ledger"
      },
      "geographic-exposure": {
        "description": "Geographic Exposure रिपोर्ट हेर्नुहोस्।",
        "title": "Geographic Exposure"
      },
      "gips-compliance": {
        "description": "Gips Compliance रिपोर्ट हेर्नुहोस्।",
        "title": "Gips Compliance"
      },
      "hedge-fund-performance": {
        "description": "Hedge Fund Performance रिपोर्ट हेर्नुहोस्।",
        "title": "Hedge Fund Performance"
      },
      "high-water-mark-tracking": {
        "description": "High Water Mark Tracking रिपोर्ट हेर्नुहोस्।",
        "title": "High Water Mark Tracking"
      },
      "holdings-based-analysis": {
        "description": "Holdings Based Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Holdings Based Analysis"
      },
      "hurdle-rate-calculation": {
        "description": "Hurdle Rate Calculation रिपोर्ट हेर्नुहोस्।",
        "title": "Hurdle Rate Calculation"
      },
      "ifrs13-fair-value-hierarchy": {
        "description": "Ifrs13 Fair Value Hierarchy रिपोर्ट हेर्नुहोस्।",
        "title": "Ifrs13 Fair Value Hierarchy"
      },
      "ifrs15-revenue-disaggregation": {
        "description": "Ifrs15 Revenue Disaggregation रिपोर्ट हेर्नुहोस्।",
        "title": "Ifrs15 Revenue Disaggregation"
      },
      "ifrs16-lease-schedule": {
        "description": "Ifrs16 Lease Schedule रिपोर्ट हेर्नुहोस्।",
        "title": "Ifrs16 Lease Schedule"
      },
      "ifrs7-financial-instrument-risk": {
        "description": "Ifrs7 Financial Instrument Risk रिपोर्ट हेर्नुहोस्।",
        "title": "Ifrs7 Financial Instrument Risk"
      },
      "ifrs9-ecl-impairment": {
        "description": "Ifrs9 Ecl Impairment रिपोर्ट हेर्नुहोस्।",
        "title": "Ifrs9 Ecl Impairment"
      },
      "impact-measurement": {
        "description": "Impact Measurement रिपोर्ट हेर्नुहोस्।",
        "title": "Impact Measurement"
      },
      "impairment-assessment": {
        "description": "Impairment Assessment रिपोर्ट हेर्नुहोस्।",
        "title": "Impairment Assessment"
      },
      "income-report": {
        "description": "Income Report रिपोर्ट हेर्नुहोस्।",
        "title": "Income Report"
      },
      "income-statement": {
        "description": "Income Statement रिपोर्ट हेर्नुहोस्।",
        "title": "Income Statement"
      },
      "index-performance": {
        "description": "Index Performance रिपोर्ट हेर्नुहोस्।",
        "title": "Index Performance"
      },
      "information-ratio": {
        "description": "Information Ratio रिपोर्ट हेर्नुहोस्।",
        "title": "Information Ratio"
      },
      "intercompany-eliminations": {
        "description": "Intercompany Eliminations रिपोर्ट हेर्नुहोस्।",
        "title": "Intercompany Eliminations"
      },
      "intercompany-loan-tracking": {
        "description": "Intercompany Loan Tracking रिपोर्ट हेर्नुहोस्।",
        "title": "Intercompany Loan Tracking"
      },
      "interim-financial-report": {
        "description": "Interim Financial Report रिपोर्ट हेर्नुहोस्।",
        "title": "Interim Financial Report"
      },
      "ipo-pipeline": {
        "description": "Ipo Pipeline रिपोर्ट हेर्नुहोस्।",
        "title": "Ipo Pipeline"
      },
      "iso20022-messaging": {
        "description": "Iso20022 Messaging रिपोर्ट हेर्नुहोस्।",
        "title": "Iso20022 Messaging"
      },
      "key-metrics-summary": {
        "description": "Key Metrics Summary रिपोर्ट हेर्नुहोस्।",
        "title": "Key Metrics Summary"
      },
      "key-performance-indicators": {
        "description": "Key Performance Indicators रिपोर्ट हेर्नुहोस्।",
        "title": "Key Performance Indicators"
      },
      "kyc-aml-status": {
        "description": "Kyc Aml Status रिपोर्ट हेर्नुहोस्।",
        "title": "Kyc Aml Status"
      },
      "license-compliance": {
        "description": "License Compliance रिपोर्ट हेर्नुहोस्।",
        "title": "License Compliance"
      },
      "liquidity-forecast": {
        "description": "Liquidity Forecast रिपोर्ट हेर्नुहोस्।",
        "title": "Liquidity Forecast"
      },
      "liquidity-risk": {
        "description": "Liquidity Risk रिपोर्ट हेर्नुहोस्।",
        "title": "Liquidity Risk"
      },
      "liquidity-tier-analysis": {
        "description": "Liquidity Tier Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Liquidity Tier Analysis"
      },
      "loan-portfolio-summary": {
        "description": "Loan Portfolio Summary रिपोर्ट हेर्नुहोस्।",
        "title": "Loan Portfolio Summary"
      },
      "look-through-analysis": {
        "description": "Look Through Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Look Through Analysis"
      },
      "manual-adjustment-audit": {
        "description": "Manual Adjustment Audit रिपोर्ट हेर्नुहोस्।",
        "title": "Manual Adjustment Audit"
      },
      "manual-intervention-tracking": {
        "description": "Manual Intervention Tracking रिपोर्ट हेर्नुहोस्।",
        "title": "Manual Intervention Tracking"
      },
      "market-capitalization": {
        "description": "Market Capitalization रिपोर्ट हेर्नुहोस्।",
        "title": "Market Capitalization"
      },
      "market-risk-exposure": {
        "description": "Market Risk Exposure रिपोर्ट हेर्नुहोस्।",
        "title": "Market Risk Exposure"
      },
      "market-share-analysis": {
        "description": "Market Share Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Market Share Analysis"
      },
      "master-feeder-allocation": {
        "description": "Master Feeder Allocation रिपोर्ट हेर्नुहोस्।",
        "title": "Master Feeder Allocation"
      },
      "maturity-ladder": {
        "description": "Maturity Ladder रिपोर्ट हेर्नुहोस्।",
        "title": "Maturity Ladder"
      },
      "mifid-transaction-reporting": {
        "description": "Mifid Transaction Reporting रिपोर्ट हेर्नुहोस्।",
        "title": "Mifid Transaction Reporting"
      },
      "model-validation": {
        "description": "Model Validation रिपोर्ट हेर्नुहोस्।",
        "title": "Model Validation"
      },
      "money-weighted-return": {
        "description": "Money Weighted Return रिपोर्ट हेर्नुहोस्।",
        "title": "Money Weighted Return"
      },
      "monte-carlo-simulation": {
        "description": "Monte Carlo Simulation रिपोर्ट हेर्नुहोस्।",
        "title": "Monte Carlo Simulation"
      },
      "monthly-commentary": {
        "description": "Monthly Commentary रिपोर्ट हेर्नुहोस्।",
        "title": "Monthly Commentary"
      },
      "multi-currency-consolidation": {
        "description": "Multi Currency Consolidation रिपोर्ट हेर्नुहोस्।",
        "title": "Multi Currency Consolidation"
      },
      "multi-entity-consolidation": {
        "description": "Multi Entity Consolidation रिपोर्ट हेर्नुहोस्।",
        "title": "Multi Entity Consolidation"
      },
      "nav-production-status": {
        "description": "Nav Production Status रिपोर्ट हेर्नुहोस्।",
        "title": "Nav Production Status"
      },
      "nepal-advance-tax-calculation": {
        "description": "Nepal Advance Tax Calculation रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Advance Tax Calculation"
      },
      "nepal-aml-ctr-report": {
        "description": "Nepal Aml Ctr Report रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Aml Ctr Report"
      },
      "nepal-aml-str-report": {
        "description": "Nepal Aml Str Report रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Aml Str Report"
      },
      "nepal-annual-return-filing": {
        "description": "Nepal Annual Return Filing रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Annual Return Filing"
      },
      "nepal-annual-tax-audit": {
        "description": "Nepal Annual Tax Audit रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Annual Tax Audit"
      },
      "nepal-board-resolution-filing": {
        "description": "Nepal Board Resolution Filing रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Board Resolution Filing"
      },
      "nepal-capital-gains-tax-report": {
        "description": "Nepal Capital Gains Tax Report रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Capital Gains Tax Report"
      },
      "nepal-cit-contribution-report": {
        "description": "Nepal Cit Contribution Report रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Cit Contribution Report"
      },
      "nepal-compliance-audit": {
        "description": "Nepal Compliance Audit रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Compliance Audit"
      },
      "nepal-customs-duty-report": {
        "description": "Nepal Customs Duty Report रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Customs Duty Report"
      },
      "nepal-dividend-tax-report": {
        "description": "Nepal Dividend Tax Report रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Dividend Tax Report"
      },
      "nepal-epf-contribution-report": {
        "description": "Nepal Epf Contribution Report रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Epf Contribution Report"
      },
      "nepal-excise-duty-report": {
        "description": "Nepal Excise Duty Report रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Excise Duty Report"
      },
      "nepal-fiscal-year-report": {
        "description": "Nepal Fiscal Year Report रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Fiscal Year Report"
      },
      "nepal-gratuity-fund-valuation": {
        "description": "Nepal Gratuity Fund Valuation रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Gratuity Fund Valuation"
      },
      "nepal-internal-audit-report": {
        "description": "Nepal Internal Audit Report रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Internal Audit Report"
      },
      "nepal-memorandum-amendment-filing": {
        "description": "Nepal Memorandum Amendment Filing रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Memorandum Amendment Filing"
      },
      "nepal-mutual-fund-distribution": {
        "description": "Nepal Mutual Fund Distribution रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Mutual Fund Distribution"
      },
      "nepal-mutual-fund-investment-compliance": {
        "description": "Nepal Mutual Fund Investment Compliance रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Mutual Fund Investment Compliance"
      },
      "nepal-mutual-fund-nav-calculation": {
        "description": "Nepal Mutual Fund Nav Calculation रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Mutual Fund Nav Calculation"
      },
      "nepal-mutual-fund-unit-holder-report": {
        "description": "Nepal Mutual Fund Unit Holder Report रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Mutual Fund Unit Holder Report"
      },
      "nepal-nfrs-accounting-policies": {
        "description": "Nepal Nfrs Accounting Policies रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Accounting Policies"
      },
      "nepal-nfrs-borrowing-costs": {
        "description": "Nepal Nfrs Borrowing Costs रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Borrowing Costs"
      },
      "nepal-nfrs-cash-flow": {
        "description": "Nepal Nfrs Cash Flow रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Cash Flow"
      },
      "nepal-nfrs-day-one-gain-loss-deferral": {
        "description": "Nepal Nfrs Day One Gain Loss Deferral रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Day One Gain Loss Deferral"
      },
      "nepal-nfrs-earnings-per-share": {
        "description": "Nepal Nfrs Earnings Per Share रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Earnings Per Share"
      },
      "nepal-nfrs-embedded-derivative-identification": {
        "description": "Nepal Nfrs Embedded Derivative Identification रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Embedded Derivative Identification"
      },
      "nepal-nfrs-employee-benefits": {
        "description": "Nepal Nfrs Employee Benefits रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Employee Benefits"
      },
      "nepal-nfrs-events-after-reporting": {
        "description": "Nepal Nfrs Events After Reporting रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Events After Reporting"
      },
      "nepal-nfrs-fair-value-option-designation": {
        "description": "Nepal Nfrs Fair Value Option Designation रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Fair Value Option Designation"
      },
      "nepal-nfrs-financial-instrument-disclosure": {
        "description": "Nepal Nfrs Financial Instrument Disclosure रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Financial Instrument Disclosure"
      },
      "nepal-nfrs-first-time-adoption-reconciliation": {
        "description": "Nepal Nfrs First Time Adoption Reconciliation रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs First Time Adoption Reconciliation"
      },
      "nepal-nfrs-first-time-adoption": {
        "description": "Nepal Nfrs First Time Adoption रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs First Time Adoption"
      },
      "nepal-nfrs-foreign-exchange": {
        "description": "Nepal Nfrs Foreign Exchange रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Foreign Exchange"
      },
      "nepal-nfrs-impairment-assets": {
        "description": "Nepal Nfrs Impairment Assets रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Impairment Assets"
      },
      "nepal-nfrs-income-taxes": {
        "description": "Nepal Nfrs Income Taxes रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Income Taxes"
      },
      "nepal-nfrs-intangible-assets": {
        "description": "Nepal Nfrs Intangible Assets रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Intangible Assets"
      },
      "nepal-nfrs-interim-reporting": {
        "description": "Nepal Nfrs Interim Reporting रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Interim Reporting"
      },
      "nepal-nfrs-investment-property": {
        "description": "Nepal Nfrs Investment Property रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Investment Property"
      },
      "nepal-nfrs-presentation-financial-statements": {
        "description": "Nepal Nfrs Presentation Financial Statements रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Presentation Financial Statements"
      },
      "nepal-nfrs-prior-period-restatement": {
        "description": "Nepal Nfrs Prior Period Restatement रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Prior Period Restatement"
      },
      "nepal-nfrs-property-plant-equipment": {
        "description": "Nepal Nfrs Property Plant Equipment रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Property Plant Equipment"
      },
      "nepal-nfrs-provisions-contingencies": {
        "description": "Nepal Nfrs Provisions Contingencies रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Provisions Contingencies"
      },
      "nepal-nfrs-related-party-disclosure": {
        "description": "Nepal Nfrs Related Party Disclosure रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Related Party Disclosure"
      },
      "nepal-nfrs-related-party": {
        "description": "Nepal Nfrs Related Party रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs Related Party"
      },
      "nepal-nfrs13-fair-value-hierarchy": {
        "description": "Nepal Nfrs13 Fair Value Hierarchy रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs13 Fair Value Hierarchy"
      },
      "nepal-nfrs13-level-transfers": {
        "description": "Nepal Nfrs13 Level Transfers रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs13 Level Transfers"
      },
      "nepal-nfrs13-level3-rollforward": {
        "description": "Nepal Nfrs13 Level3 Rollforward रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs13 Level3 Rollforward"
      },
      "nepal-nfrs13-unobservable-input-sensitivity": {
        "description": "Nepal Nfrs13 Unobservable Input Sensitivity रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs13 Unobservable Input Sensitivity"
      },
      "nepal-nfrs13-valuation-technique": {
        "description": "Nepal Nfrs13 Valuation Technique रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs13 Valuation Technique"
      },
      "nepal-nfrs15-revenue-recognition": {
        "description": "Nepal Nfrs15 Revenue Recognition रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs15 Revenue Recognition"
      },
      "nepal-nfrs16-lease": {
        "description": "Nepal Nfrs16 Lease रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs16 Lease"
      },
      "nepal-nfrs17-insurance-contract": {
        "description": "Nepal Nfrs17 Insurance Contract रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs17 Insurance Contract"
      },
      "nepal-nfrs7-collateral-credit-enhancement": {
        "description": "Nepal Nfrs7 Collateral Credit Enhancement रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs7 Collateral Credit Enhancement"
      },
      "nepal-nfrs7-credit-concentration": {
        "description": "Nepal Nfrs7 Credit Concentration रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs7 Credit Concentration"
      },
      "nepal-nfrs7-maturity-analysis": {
        "description": "Nepal Nfrs7 Maturity Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs7 Maturity Analysis"
      },
      "nepal-nfrs7-transferred-assets-not-derecognized": {
        "description": "Nepal Nfrs7 Transferred Assets Not Derecognized रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs7 Transferred Assets Not Derecognized"
      },
      "nepal-nfrs9-business-model-assessment": {
        "description": "Nepal Nfrs9 Business Model Assessment रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs9 Business Model Assessment"
      },
      "nepal-nfrs9-classification-measurement": {
        "description": "Nepal Nfrs9 Classification Measurement रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs9 Classification Measurement"
      },
      "nepal-nfrs9-ecl-impairment": {
        "description": "Nepal Nfrs9 Ecl Impairment रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs9 Ecl Impairment"
      },
      "nepal-nfrs9-ecl-movement-reconciliation": {
        "description": "Nepal Nfrs9 Ecl Movement Reconciliation रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs9 Ecl Movement Reconciliation"
      },
      "nepal-nfrs9-ecl-provision-matrix": {
        "description": "Nepal Nfrs9 Ecl Provision Matrix रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs9 Ecl Provision Matrix"
      },
      "nepal-nfrs9-ecl-staging-analysis": {
        "description": "Nepal Nfrs9 Ecl Staging Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs9 Ecl Staging Analysis"
      },
      "nepal-nfrs9-hedge-accounting": {
        "description": "Nepal Nfrs9 Hedge Accounting रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs9 Hedge Accounting"
      },
      "nepal-nfrs9-impairment-reversal": {
        "description": "Nepal Nfrs9 Impairment Reversal रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs9 Impairment Reversal"
      },
      "nepal-nfrs9-modification-gain-loss": {
        "description": "Nepal Nfrs9 Modification Gain Loss रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs9 Modification Gain Loss"
      },
      "nepal-nfrs9-sppi-test-assessment": {
        "description": "Nepal Nfrs9 Sppi Test Assessment रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Nfrs9 Sppi Test Assessment"
      },
      "nepal-pep-screening-report": {
        "description": "Nepal Pep Screening Report रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Pep Screening Report"
      },
      "nepal-quarterly-advance-tax": {
        "description": "Nepal Quarterly Advance Tax रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Quarterly Advance Tax"
      },
      "nepal-sanctions-compliance": {
        "description": "Nepal Sanctions Compliance रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Sanctions Compliance"
      },
      "nepal-share-register-update": {
        "description": "Nepal Share Register Update रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Share Register Update"
      },
      "nepal-social-security-fund-report": {
        "description": "Nepal Social Security Fund Report रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Social Security Fund Report"
      },
      "nepal-statutory-audit-report": {
        "description": "Nepal Statutory Audit Report रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Statutory Audit Report"
      },
      "nepal-tax-audit": {
        "description": "Nepal Tax Audit रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Tax Audit"
      },
      "nepal-tax-return-preparation": {
        "description": "Nepal Tax Return Preparation रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Tax Return Preparation"
      },
      "nepal-tds-certificate-tracking": {
        "description": "Nepal Tds Certificate Tracking रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Tds Certificate Tracking"
      },
      "nepal-vat-return": {
        "description": "Nepal Vat Return रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Vat Return"
      },
      "nepal-withholding-tax-report": {
        "description": "Nepal Withholding Tax Report रिपोर्ट हेर्नुहोस्।",
        "title": "Nepal Withholding Tax Report"
      },
      "nepse-52-week-high-low": {
        "description": "Nepse 52 Week High Low रिपोर्ट हेर्नुहोस्।",
        "title": "Nepse 52 Week High Low"
      },
      "nepse-block-bulk-deals": {
        "description": "Nepse Block Bulk Deals रिपोर्ट हेर्नुहोस्।",
        "title": "Nepse Block Bulk Deals"
      },
      "nepse-broker-transaction": {
        "description": "Nepse Broker Transaction रिपोर्ट हेर्नुहोस्।",
        "title": "Nepse Broker Transaction"
      },
      "nepse-daily-trading-summary": {
        "description": "Nepse Daily Trading Summary रिपोर्ट हेर्नुहोस्।",
        "title": "Nepse Daily Trading Summary"
      },
      "nepse-index-composition": {
        "description": "Nepse Index Composition रिपोर्ट हेर्नुहोस्।",
        "title": "Nepse Index Composition"
      },
      "nepse-margin-trading-exposure": {
        "description": "Nepse Margin Trading Exposure रिपोर्ट हेर्नुहोस्।",
        "title": "Nepse Margin Trading Exposure"
      },
      "nepse-market-depth": {
        "description": "Nepse Market Depth रिपोर्ट हेर्नुहोस्।",
        "title": "Nepse Market Depth"
      },
      "nepse-sector-performance": {
        "description": "Nepse Sector Performance रिपोर्ट हेर्नुहोस्।",
        "title": "Nepse Sector Performance"
      },
      "nepse-settlement-obligation": {
        "description": "Nepse Settlement Obligation रिपोर्ट हेर्नुहोस्।",
        "title": "Nepse Settlement Obligation"
      },
      "nepse-short-sale-disclosure": {
        "description": "Nepse Short Sale Disclosure रिपोर्ट हेर्नुहोस्।",
        "title": "Nepse Short Sale Disclosure"
      },
      "nrb-agriculture-lending": {
        "description": "Nrb Agriculture Lending रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Agriculture Lending"
      },
      "nrb-aml-suspicious-transaction": {
        "description": "Nrb Aml Suspicious Transaction रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Aml Suspicious Transaction"
      },
      "nrb-base-rate-calculation": {
        "description": "Nrb Base Rate Calculation रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Base Rate Calculation"
      },
      "nrb-capital-adequacy-basel": {
        "description": "Nrb Capital Adequacy Basel रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Capital Adequacy Basel"
      },
      "nrb-crr-slr-compliance": {
        "description": "Nrb Crr Slr Compliance रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Crr Slr Compliance"
      },
      "nrb-deprived-sector-lending": {
        "description": "Nrb Deprived Sector Lending रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Deprived Sector Lending"
      },
      "nrb-energy-lending": {
        "description": "Nrb Energy Lending रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Energy Lending"
      },
      "nrb-forex-position": {
        "description": "Nrb Forex Position रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Forex Position"
      },
      "nrb-ict-risk-assessment": {
        "description": "Nrb Ict Risk Assessment रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Ict Risk Assessment"
      },
      "nrb-interest-rate-risk": {
        "description": "Nrb Interest Rate Risk रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Interest Rate Risk"
      },
      "nrb-interest-rate-spread": {
        "description": "Nrb Interest Rate Spread रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Interest Rate Spread"
      },
      "nrb-large-exposure": {
        "description": "Nrb Large Exposure रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Large Exposure"
      },
      "nrb-liquidity-coverage": {
        "description": "Nrb Liquidity Coverage रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Liquidity Coverage"
      },
      "nrb-loan-loss-provisioning": {
        "description": "Nrb Loan Loss Provisioning रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Loan Loss Provisioning"
      },
      "nrb-mfi-reporting": {
        "description": "Nrb Mfi Reporting रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Mfi Reporting"
      },
      "nrb-net-stable-funding": {
        "description": "Nrb Net Stable Funding रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Net Stable Funding"
      },
      "nrb-npa-aging": {
        "description": "Nrb Npa Aging रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Npa Aging"
      },
      "nrb-priority-sector-lending": {
        "description": "Nrb Priority Sector Lending रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Priority Sector Lending"
      },
      "nrb-refinancing-report": {
        "description": "Nrb Refinancing Report रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Refinancing Report"
      },
      "nrb-related-party-lending": {
        "description": "Nrb Related Party Lending रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Related Party Lending"
      },
      "nrb-remittance": {
        "description": "Nrb Remittance रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Remittance"
      },
      "nrb-sectoral-lending": {
        "description": "Nrb Sectoral Lending रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Sectoral Lending"
      },
      "nrb-stress-test": {
        "description": "Nrb Stress Test रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Stress Test"
      },
      "nrb-tourism-lending": {
        "description": "Nrb Tourism Lending रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Tourism Lending"
      },
      "nrb-wholesale-lending": {
        "description": "Nrb Wholesale Lending रिपोर्ट हेर्नुहोस्।",
        "title": "Nrb Wholesale Lending"
      },
      "operational-cost-per-trade": {
        "description": "Operational Cost Per Trade रिपोर्ट हेर्नुहोस्।",
        "title": "Operational Cost Per Trade"
      },
      "operational-risk-events": {
        "description": "Operational Risk Events रिपोर्ट हेर्नुहोस्।",
        "title": "Operational Risk Events"
      },
      "ops-break-report": {
        "description": "Ops Break Report रिपोर्ट हेर्नुहोस्।",
        "title": "Ops Break Report"
      },
      "ops-daily-checklist": {
        "description": "Ops Daily Checklist रिपोर्ट हेर्नुहोस्।",
        "title": "Ops Daily Checklist"
      },
      "ops-sla-dashboard": {
        "description": "Ops Sla Dashboard रिपोर्ट हेर्नुहोस्।",
        "title": "Ops Sla Dashboard"
      },
      "ops-team-productivity": {
        "description": "Ops Team Productivity रिपोर्ट हेर्नुहोस्।",
        "title": "Ops Team Productivity"
      },
      "ops-vendor-performance": {
        "description": "Ops Vendor Performance रिपोर्ट हेर्नुहोस्।",
        "title": "Ops Vendor Performance"
      },
      "optimization-results": {
        "description": "Optimization Results रिपोर्ट हेर्नुहोस्।",
        "title": "Optimization Results"
      },
      "option-greeks": {
        "description": "Option Greeks रिपोर्ट हेर्नुहोस्।",
        "title": "Option Greeks"
      },
      "overlay-exposure": {
        "description": "Overlay Exposure रिपोर्ट हेर्नुहोस्।",
        "title": "Overlay Exposure"
      },
      "peer-comparison": {
        "description": "Peer Comparison रिपोर्ट हेर्नुहोस्।",
        "title": "Peer Comparison"
      },
      "performance-fee-calculation": {
        "description": "Performance Fee Calculation रिपोर्ट हेर्नुहोस्।",
        "title": "Performance Fee Calculation"
      },
      "personal-account-dealing": {
        "description": "Personal Account Dealing रिपोर्ट हेर्नुहोस्।",
        "title": "Personal Account Dealing"
      },
      "pm-attribution-report": {
        "description": "Pm Attribution Report रिपोर्ट हेर्नुहोस्।",
        "title": "Pm Attribution Report"
      },
      "pm-cash-management": {
        "description": "Pm Cash Management रिपोर्ट हेर्नुहोस्।",
        "title": "Pm Cash Management"
      },
      "pm-daily-report": {
        "description": "Pm Daily Report रिपोर्ट हेर्नुहोस्।",
        "title": "Pm Daily Report"
      },
      "pm-risk-report": {
        "description": "Pm Risk Report रिपोर्ट हेर्नुहोस्।",
        "title": "Pm Risk Report"
      },
      "pm-trade-idea-tracking": {
        "description": "Pm Trade Idea Tracking रिपोर्ट हेर्नुहोस्।",
        "title": "Pm Trade Idea Tracking"
      },
      "policy-exception-report": {
        "description": "Policy Exception Report रिपोर्ट हेर्नुहोस्।",
        "title": "Policy Exception Report"
      },
      "portfolio-performance": {
        "description": "Portfolio Performance रिपोर्ट हेर्नुहोस्।",
        "title": "Portfolio Performance"
      },
      "position-limit-monitoring": {
        "description": "Position Limit Monitoring रिपोर्ट हेर्नुहोस्।",
        "title": "Position Limit Monitoring"
      },
      "price-history": {
        "description": "Price History रिपोर्ट हेर्नुहोस्।",
        "title": "Price History"
      },
      "private-equity-valuation": {
        "description": "Private Equity Valuation रिपोर्ट हेर्नुहोस्।",
        "title": "Private Equity Valuation"
      },
      "product-performance-analysis": {
        "description": "Product Performance Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Product Performance Analysis"
      },
      "profitability-by-client": {
        "description": "Profitability By Client रिपोर्ट हेर्नुहोस्।",
        "title": "Profitability By Client"
      },
      "profitability-by-strategy": {
        "description": "Profitability By Strategy रिपोर्ट हेर्नुहोस्।",
        "title": "Profitability By Strategy"
      },
      "proxy-voting-report": {
        "description": "Proxy Voting Report रिपोर्ट हेर्नुहोस्।",
        "title": "Proxy Voting Report"
      },
      "quarterly-investment-review": {
        "description": "Quarterly Investment Review रिपोर्ट हेर्नुहोस्।",
        "title": "Quarterly Investment Review"
      },
      "real-estate-valuation": {
        "description": "Real Estate Valuation रिपोर्ट हेर्नुहोस्।",
        "title": "Real Estate Valuation"
      },
      "realized-unrealized-pnl": {
        "description": "Realized Unrealized Pnl रिपोर्ट हेर्नुहोस्।",
        "title": "Realized Unrealized Pnl"
      },
      "rebalancing-recommendation": {
        "description": "Rebalancing Recommendation रिपोर्ट हेर्नुहोस्।",
        "title": "Rebalancing Recommendation"
      },
      "reconciliation-summary": {
        "description": "Reconciliation Summary रिपोर्ट हेर्नुहोस्।",
        "title": "Reconciliation Summary"
      },
      "reference-data-change-log": {
        "description": "Reference Data Change Log रिपोर्ट हेर्नुहोस्।",
        "title": "Reference Data Change Log"
      },
      "regulatory-change-impact": {
        "description": "Regulatory Change Impact रिपोर्ट हेर्नुहोस्।",
        "title": "Regulatory Change Impact"
      },
      "regulatory-examination-package": {
        "description": "Regulatory Examination Package रिपोर्ट हेर्नुहोस्।",
        "title": "Regulatory Examination Package"
      },
      "regulatory-filing-calendar": {
        "description": "Regulatory Filing Calendar रिपोर्ट हेर्नुहोस्।",
        "title": "Regulatory Filing Calendar"
      },
      "related-party-transactions": {
        "description": "Related Party Transactions रिपोर्ट हेर्नुहोस्।",
        "title": "Related Party Transactions"
      },
      "report-distribution-log": {
        "description": "Report Distribution Log रिपोर्ट हेर्नुहोस्।",
        "title": "Report Distribution Log"
      },
      "restricted-list-compliance": {
        "description": "Restricted List Compliance रिपोर्ट हेर्नुहोस्।",
        "title": "Restricted List Compliance"
      },
      "returns-based-analysis": {
        "description": "Returns Based Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Returns Based Analysis"
      },
      "revenue-recognition": {
        "description": "Revenue Recognition रिपोर्ट हेर्नुहोस्।",
        "title": "Revenue Recognition"
      },
      "risk-adjusted-return": {
        "description": "Risk Adjusted Return रिपोर्ट हेर्नुहोस्।",
        "title": "Risk Adjusted Return"
      },
      "risk-appetite-dashboard": {
        "description": "Risk Appetite Dashboard रिपोर्ट हेर्नुहोस्।",
        "title": "Risk Appetite Dashboard"
      },
      "risk-limit-utilization": {
        "description": "Risk Limit Utilization रिपोर्ट हेर्नुहोस्।",
        "title": "Risk Limit Utilization"
      },
      "rm-client-activity-summary": {
        "description": "Rm Client Activity Summary रिपोर्ट हेर्नुहोस्।",
        "title": "Rm Client Activity Summary"
      },
      "rm-client-meeting-notes": {
        "description": "Rm Client Meeting Notes रिपोर्ट हेर्नुहोस्।",
        "title": "Rm Client Meeting Notes"
      },
      "rm-client-portfolio-overview": {
        "description": "Rm Client Portfolio Overview रिपोर्ट हेर्नुहोस्।",
        "title": "Rm Client Portfolio Overview"
      },
      "rm-client-satisfaction-survey": {
        "description": "Rm Client Satisfaction Survey रिपोर्ट हेर्नुहोस्।",
        "title": "Rm Client Satisfaction Survey"
      },
      "rm-cross-sell-opportunities": {
        "description": "Rm Cross Sell Opportunities रिपोर्ट हेर्नुहोस्।",
        "title": "Rm Cross Sell Opportunities"
      },
      "rolling-performance": {
        "description": "Rolling Performance रिपोर्ट हेर्नुहोस्।",
        "title": "Rolling Performance"
      },
      "sanctions-screening": {
        "description": "Sanctions Screening रिपोर्ट हेर्नुहोस्।",
        "title": "Sanctions Screening"
      },
      "scenario-analysis": {
        "description": "Scenario Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Scenario Analysis"
      },
      "scheduled-report-status": {
        "description": "Scheduled Report Status रिपोर्ट हेर्नुहोस्।",
        "title": "Scheduled Report Status"
      },
      "sebon-annual-audit": {
        "description": "Sebon Annual Audit रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Annual Audit"
      },
      "sebon-circuit-breaker-report": {
        "description": "Sebon Circuit Breaker Report रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Circuit Breaker Report"
      },
      "sebon-client-account-segregation": {
        "description": "Sebon Client Account Segregation रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Client Account Segregation"
      },
      "sebon-credit-rating-report": {
        "description": "Sebon Credit Rating Report रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Credit Rating Report"
      },
      "sebon-daily-trading": {
        "description": "Sebon Daily Trading रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Daily Trading"
      },
      "sebon-debenture-trustee-report": {
        "description": "Sebon Debenture Trustee Report रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Debenture Trustee Report"
      },
      "sebon-dmat-account-verification": {
        "description": "Sebon Dmat Account Verification रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Dmat Account Verification"
      },
      "sebon-foreign-investment-report": {
        "description": "Sebon Foreign Investment Report रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Foreign Investment Report"
      },
      "sebon-insider-trading-surveillance": {
        "description": "Sebon Insider Trading Surveillance रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Insider Trading Surveillance"
      },
      "sebon-issue-manager-report": {
        "description": "Sebon Issue Manager Report रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Issue Manager Report"
      },
      "sebon-margin-trading-disclosure": {
        "description": "Sebon Margin Trading Disclosure रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Margin Trading Disclosure"
      },
      "sebon-market-maker-obligation": {
        "description": "Sebon Market Maker Obligation रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Market Maker Obligation"
      },
      "sebon-market-manipulation-detection": {
        "description": "Sebon Market Manipulation Detection रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Market Manipulation Detection"
      },
      "sebon-monthly-compliance": {
        "description": "Sebon Monthly Compliance रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Monthly Compliance"
      },
      "sebon-mutual-fund-nav": {
        "description": "Sebon Mutual Fund Nav रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Mutual Fund Nav"
      },
      "sebon-net-capital-adequacy": {
        "description": "Sebon Net Capital Adequacy रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Net Capital Adequacy"
      },
      "sebon-online-trading-compliance": {
        "description": "Sebon Online Trading Compliance रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Online Trading Compliance"
      },
      "sebon-portfolio-manager-quarterly": {
        "description": "Sebon Portfolio Manager Quarterly रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Portfolio Manager Quarterly"
      },
      "sebon-prospectus-filing": {
        "description": "Sebon Prospectus Filing रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Prospectus Filing"
      },
      "sebon-quarterly-financial": {
        "description": "Sebon Quarterly Financial रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Quarterly Financial"
      },
      "sebon-share-registrar-report": {
        "description": "Sebon Share Registrar Report रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Share Registrar Report"
      },
      "sebon-short-selling-report": {
        "description": "Sebon Short Selling Report रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Short Selling Report"
      },
      "sebon-underwriter-quarterly": {
        "description": "Sebon Underwriter Quarterly रिपोर्ट हेर्नुहोस्।",
        "title": "Sebon Underwriter Quarterly"
      },
      "sector-attribution": {
        "description": "Sector Attribution रिपोर्ट हेर्नुहोस्।",
        "title": "Sector Attribution"
      },
      "sector-exposure": {
        "description": "Sector Exposure रिपोर्ट हेर्नुहोस्।",
        "title": "Sector Exposure"
      },
      "sector-performance": {
        "description": "Sector Performance रिपोर्ट हेर्नुहोस्।",
        "title": "Sector Performance"
      },
      "security-attribution": {
        "description": "Security Attribution रिपोर्ट हेर्नुहोस्।",
        "title": "Security Attribution"
      },
      "security-incident-report": {
        "description": "Security Incident Report रिपोर्ट हेर्नुहोस्।",
        "title": "Security Incident Report"
      },
      "segment-reporting": {
        "description": "Segment Reporting रिपोर्ट हेर्नुहोस्।",
        "title": "Segment Reporting"
      },
      "series-class-accounting": {
        "description": "Series Class Accounting रिपोर्ट हेर्नुहोस्।",
        "title": "Series Class Accounting"
      },
      "settlement-status": {
        "description": "Settlement Status रिपोर्ट हेर्नुहोस्।",
        "title": "Settlement Status"
      },
      "sfdr-classification": {
        "description": "Sfdr Classification रिपोर्ट हेर्नुहोस्।",
        "title": "Sfdr Classification"
      },
      "share-based-payment-valuation": {
        "description": "Share Based Payment Valuation रिपोर्ट हेर्नुहोस्।",
        "title": "Share Based Payment Valuation"
      },
      "shareholder-letter": {
        "description": "Shareholder Letter रिपोर्ट हेर्नुहोस्।",
        "title": "Shareholder Letter"
      },
      "sharpe-ratio-analysis": {
        "description": "Sharpe Ratio Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Sharpe Ratio Analysis"
      },
      "side-pocket-valuation": {
        "description": "Side Pocket Valuation रिपोर्ट हेर्नुहोस्।",
        "title": "Side Pocket Valuation"
      },
      "sla-compliance": {
        "description": "Sla Compliance रिपोर्ट हेर्नुहोस्।",
        "title": "Sla Compliance"
      },
      "sortino-ratio": {
        "description": "Sortino Ratio रिपोर्ट हेर्नुहोस्।",
        "title": "Sortino Ratio"
      },
      "spread-analysis": {
        "description": "Spread Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Spread Analysis"
      },
      "statement-of-changes-in-equity": {
        "description": "Statement Of Changes In Equity रिपोर्ट हेर्नुहोस्।",
        "title": "Statement Of Changes In Equity"
      },
      "straight-through-processing-rate": {
        "description": "Straight Through Processing Rate रिपोर्ट हेर्नुहोस्।",
        "title": "Straight Through Processing Rate"
      },
      "stress-test-results": {
        "description": "Stress Test Results रिपोर्ट हेर्नुहोस्।",
        "title": "Stress Test Results"
      },
      "structured-product-valuation": {
        "description": "Structured Product Valuation रिपोर्ट हेर्नुहोस्।",
        "title": "Structured Product Valuation"
      },
      "style-analysis": {
        "description": "Style Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Style Analysis"
      },
      "sustainable-investment-allocation": {
        "description": "Sustainable Investment Allocation रिपोर्ट हेर्नुहोस्।",
        "title": "Sustainable Investment Allocation"
      },
      "swap-valuation": {
        "description": "Swap Valuation रिपोर्ट हेर्नुहोस्।",
        "title": "Swap Valuation"
      },
      "system-availability": {
        "description": "System Availability रिपोर्ट हेर्नुहोस्।",
        "title": "System Availability"
      },
      "system-performance-metrics": {
        "description": "System Performance Metrics रिपोर्ट हेर्नुहोस्।",
        "title": "System Performance Metrics"
      },
      "tail-risk-analysis": {
        "description": "Tail Risk Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Tail Risk Analysis"
      },
      "tax-loss-harvesting": {
        "description": "Tax Loss Harvesting रिपोर्ट हेर्नुहोस्।",
        "title": "Tax Loss Harvesting"
      },
      "tcfd-climate-risk": {
        "description": "Tcfd Climate Risk रिपोर्ट हेर्नुहोस्।",
        "title": "Tcfd Climate Risk"
      },
      "time-weighted-return": {
        "description": "Time Weighted Return रिपोर्ट हेर्नुहोस्।",
        "title": "Time Weighted Return"
      },
      "tracking-error": {
        "description": "Tracking Error रिपोर्ट हेर्नुहोस्।",
        "title": "Tracking Error"
      },
      "trade-execution-summary": {
        "description": "Trade Execution Summary रिपोर्ट हेर्नुहोस्।",
        "title": "Trade Execution Summary"
      },
      "trade-surveillance": {
        "description": "Trade Surveillance रिपोर्ट हेर्नुहोस्।",
        "title": "Trade Surveillance"
      },
      "treasury-management": {
        "description": "Treasury Management रिपोर्ट हेर्नुहोस्।",
        "title": "Treasury Management"
      },
      "trial-balance": {
        "description": "Trial Balance रिपोर्ट हेर्नुहोस्।",
        "title": "Trial Balance"
      },
      "upside-downside-capture": {
        "description": "Upside Downside Capture रिपोर्ट हेर्नुहोस्।",
        "title": "Upside Downside Capture"
      },
      "user-activity": {
        "description": "User Activity रिपोर्ट हेर्नुहोस्।",
        "title": "User Activity"
      },
      "var-report": {
        "description": "Var Report रिपोर्ट हेर्नुहोस्।",
        "title": "Var Report"
      },
      "vendor-data-quality": {
        "description": "Vendor Data Quality रिपोर्ट हेर्नुहोस्।",
        "title": "Vendor Data Quality"
      },
      "vendor-expense-tracking": {
        "description": "Vendor Expense Tracking रिपोर्ट हेर्नुहोस्।",
        "title": "Vendor Expense Tracking"
      },
      "vendor-risk-assessment": {
        "description": "Vendor Risk Assessment रिपोर्ट हेर्नुहोस्।",
        "title": "Vendor Risk Assessment"
      },
      "volatility-surface": {
        "description": "Volatility Surface रिपोर्ट हेर्नुहोस्।",
        "title": "Volatility Surface"
      },
      "volume-analysis": {
        "description": "Volume Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Volume Analysis"
      },
      "what-if-analysis": {
        "description": "What If Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "What If Analysis"
      },
      "workflow-status": {
        "description": "Workflow Status रिपोर्ट हेर्नुहोस्।",
        "title": "Workflow Status"
      },
      "working-capital-analysis": {
        "description": "Working Capital Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Working Capital Analysis"
      },
      "year-end-tax-package": {
        "description": "Year End Tax Package रिपोर्ट हेर्नुहोस्।",
        "title": "Year End Tax Package"
      },
      "yield-analysis": {
        "description": "Yield Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Yield Analysis"
      },
      "yield-curve-analysis": {
        "description": "Yield Curve Analysis रिपोर्ट हेर्नुहोस्।",
        "title": "Yield Curve Analysis"
      }
    },
    "errors": {
      "notFoundTitle": "रिपोर्ट फेला परेन",
      "notFoundDescription": "माँगी गई रिपोर्ट फेला परेन।",
      "missingReportId": "रिपोर्ट आईडी की कमी छ",
      "missingReportIdDescription": "URL मा रिपोर्ट आईडी प्रदान गरिएको छैन।",
      "invalidReportId": "निष्क्रिय रिपोर्ट आईडी",
      "invalidReportIdDescription": "रिपोर्ट \"{{reportId}}\" वैध छैन। रिपोर्ट्स हबबाट नेभिगेट गर्नुहोस्।",
      "unauthorizedTitle": "रिपोर्ट एक्सेस नियंत्रित",
      "unauthorizedDescription": "हालको संगठनका लागि यो रिपोर्ट मार्गको अनुमति तपाईंसँग छैन।",
      "unauthorizedAuditDescription": "तपाईंलाई यो रिपोर्टको लेखापरीक्षण ट्रेल हेर्ने अनुमति छैन। लेखापरीक्षण पहुँचका लागि रिपोर्ट प्रमाणीकरण र लेखापरीक्षण हेर्ने अनुमति आवश्यक छ।"
    },
    "trust": {
      "verified": "प्रमाणित",
      "warning": "विश्वास चेतावनी",
      "error": "विश्वास त्रुटि"
    },
    "card": {
      "badges": {
        "exportReady": "निर्यात तयार",
        "viewOnly": "हेर्ने मात्र",
        "issueCount": "{{count}} मुद्दाहरू"
      },
      "actions": {
        "reviewReadiness": "रिपोर्ट तयारी समीक्षा गर्नुहोस्",
        "reviewStatus": "रिपोर्ट स्थिति समीक्षा गर्नुहोस्",
        "remediate": "समस्या समाधान गर्नुहोस्"
      },
      "snapshot": {
        "issues": "मुद्दाहरू",
        "status": "स्थिति"
      }
    },
    "statusPage": {
      "title": "रिपोर्ट स्थिति",
      "description": "सबै रिपोर्ट मार्गहरूको उपलब्धता, विश्वास, र सुधार मार्गदर्शन समीक्षा गर्नुहोस्।",
      "errorTitle": "रिपोर्ट स्थिति उपलब्ध छैन",
      "errorDescription": "रिपोर्ट स्थिति लोड गर्न सकिएन। रिपोर्ट रजिस्ट्री कनेक्टिभिटी पुष्टि गरेर पुन: प्रयास गर्नुहोस्।",
      "summary": {
        "total": "कुल रिपोर्टहरू",
        "available": "उपलब्ध",
        "locked": "लक",
        "unavailable": "अनुपलब्ध"
      },
      "trustSummary": "विश्वास संकेतहरू भेटिए: {{warnings}} चेतावनी, {{errors}} त्रुटि। वितरण अघि प्रभावित रिपोर्टहरू समीक्षा गर्नुहोस्।",
      "table": {
        "title": "रिपोर्ट अनुसार रजिस्ट्री स्थिति",
        "report": "रिपोर्ट",
        "availability": "उपलब्धता",
        "trust": "विश्वास",
        "remediation": "सुधार"
      },
      "empty": "यो स्कोपका लागि हाल कुनै रिपोर्ट दर्ता गरिएको छैन।",
      "none": "कुनै छैन",
      "legend": {
        "available": "उपलब्ध",
        "availableDescription": "मार्ग पहुँचयोग्य छ र रिपोर्ट डाटा तयार छ।",
        "locked": "लक",
        "lockedDescription": "मार्ग छ तर टियर अपग्रेड वा थप अनुमति आवश्यक छ।",
        "unavailable": "अनुपलब्ध",
        "unavailableDescription": "यो रिपोर्टका लागि मार्ग वा स्रोत डाटा हाल उपलब्ध छैन।"
      },
      "fallback": {
        "statusNotChecked": "स्थिति जाँच गरिएको छैन",
        "statusUnavailable": "स्थिति उपलब्ध छैन",
        "reportTitle": "रिपोर्ट {{reportId}}",
        "trustSummary": "विश्वास संकेतहरू भेटिए: {{warnings}} चेतावनी, {{errors}} त्रुटि। वितरण अघि प्रभावित रिपोर्टहरू समीक्षा गर्नुहोस्।"
      }
    },
    "overview": "अवलोकन",
    "portfolioHoldings": "पोर्टफोलियो होल्डिङहरू",
    "transactionsLots": "लेनदेन समूह",
    "gainLossTax": "लाभ नुकसान कर",
    "monthlyAnalytics": "महीना विश्लेषण",
    "nepalNfrs": "नेपाल एनएफआरएस",
    "qualityAuditExports": "गुणवत्ता ऑडिट एक्सपोर्ट्स",
    "reportCategories": "रिपोर्ट श्रेणीहरू",
    "registry": {
      "fallback": {
        "description": "पुनर्प्राप्ति विवरण"
      }
    },
    "month": "महिना",
    "year": "वर्ष",
    "company": "कम्पनी",
    "purchaseQty": "खरिद मात्रा",
    "purchaseAmount": "खरिद रकम",
    "salesQty": "बिक्री मात्रा",
    "salesAmount": "बिक्री रकम",
    "closingUnits": "बन्द एकाइहरू",
    "wacc": "वैक्स",
    "realizedPL": "वास्तविक P&L",
    "netTradeAmount": "शुद्ध व्यापार रकम",
    "date": "मिति",
    "type": "प्रकार",
    "symbol": "प्रतीक",
    "quantity": "मात्रा",
    "price": "मूल्य",
    "totalAmount": "कुल रकम",
    "commission": "कमिसन",
    "grossSaleProceeds": "सकल बिक्री रकम",
    "purchasesMinusSales": "खरिद घटाउ बिक्री",
    "activeCompanies": "सक्रिय कम्पनीहरू",
    "uniqueHoldings": "अद्वितीय होल्डिङहरू",
    "monthlyFilterTitle": "महीना फिल्टर",
    "monthlyFilterDescription": "महीना फिल्टर विवरण",
    "selectMonth": "मासिक चयन",
    "portfolioActivityDesc": "महिना-देखि-महिना पोर्टफोलियो गतिविधि र बन्द मात्रा",
    "noMonthlyData": "कुनै मासिक डाटा उपलब्ध छैन।",
    "purchaseQuantity": "खरिद मात्रा",
    "salesQuantity": "बिक्री मात्रा",
    "waccNfrs": "वैक्स एनएफआरएस",
    "backingTransactions": "समर्थन कारोबारहरू",
    "loadingTransactions": "कारोबारहरू लोड गर्दै…",
    "noTransactionsMatch": "यो अवधिमा कुनै कारोबार मिलेन।",
    "failedToLoadPerformanceBreakdown": "प्रदर्शन विश्लेषण लोड करने मा असफल रहा",
    "na": "ना",
    "sector": "क्षेत्र",
    "secondary": "सेकंडरी",
    "timeDimension": "समय पैमाना",
    "byYear": "वर्ष द्वारा",
    "byMonth": "मासिक द्वारा",
    "dateRange": " तिथि के बीच",
    "secondaryGroup": "सेकंडरी समूह",
    "from": "बाट",
    "to": "सम्म",
    "symbolPlaceholder": "प्रतीक",
    "sectorPlaceholder": "क्षेत्र",
    "performanceBy": "फर्कले अनुसार",
    "returnFormula": "पुनर्निर्माण सूत्र",
    "totalInvestment": "कुल लगानी",
    "portfolioValue": "पोर्टफोलियो मूल्य",
    "realizedGain": "रियलाइज्ड गेन",
    "soldCostBasis": "बेचिएको लागत आधार",
    "realizedReturnPct": "रियलाइज्ड रिटर्न %",
    "unrealizedGain": "अनरियलाइज्ड नाफा",
    "returnPct": "पुनर्निर्माण प्रतिशत",
    "noResultsMatch": "परिणाम मेल खाएन",
    "capitalGainTax": {
      "clientAccount": "ग्राहक खाता",
      "clientAccountDesc": "ग्राहक खाता",
      "instrument": "उपकरण",
      "instrumentDesc": "उपकरण",
      "dateFrom": "मिति देखि",
      "dateFromDesc": "मिति देखि",
      "dateTo": "मिति सम्म",
      "dateToDesc": "मिति सम्म",
      "holdingPeriod": "धारणकाल",
      "holdingPeriodDesc": "धारणकाल",
      "saleDate": "बिक्री तिथि",
      "saleDateDesc": "बिक्री तिथि",
      "client": "ग्राहक",
      "clientDesc": "ग्राहक",
      "symbol": "प्रतीक",
      "symbolDesc": "प्रतीक",
      "instrumentName": "निवेश साधन का नाम",
      "instrumentNameDesc": "निवेश साधन का नाम",
      "quantity": "मात्रा",
      "quantityDesc": "मात्रा",
      "capitalGain": "व्यय मूल्य",
      "capitalGainDesc": "व्यय मूल्य",
      "cgtRate": "CGT दर",
      "cgtRateDesc": "CGT दर",
      "cgt": "CGT",
      "cgtDesc": "CGT",
      "grossProceeds": "मूल्यांकन के लिए मुनाफा",
      "grossProceedsDesc": "मूल्यांकन के लिए मुनाफा",
      "taxCostBasis": "व्यय कस्ता आधार",
      "taxCostBasisDesc": "व्यय कस्ता आधार",
      "deductibleSellingCharges": "माफ्य सेलिंग चार्ज",
      "deductibleSellingChargesDesc": "माफ्य सेलिंग चार्ज",
      "nonDeductibleSellingCharges": "न माफ्य सेलिंग चार्ज",
      "nonDeductibleSellingChargesDesc": "न माफ्य सेलिंग चार्ज",
      "taxableCapitalGain": "करमुक्त राजकोषीय लाभ",
      "taxableCapitalGainDesc": "करमुक्त राजकोषीय लाभ",
      "holdingPeriodDays": "धारण काल दिवस",
      "holdingPeriodDaysDesc": "धारण काल दिवस",
      "holdingPeriodBucket": "धारण काल बकेट",
      "holdingPeriodBucketDesc": "धारण काल बकेट",
      "investorType": "निवेशक प्रकार",
      "investorTypeDesc": "निवेशक प्रकार",
      "rateSource": "दर स्रोत",
      "rateSourceDesc": "दर स्रोत",
      "rateVersion": "दर संस्करण",
      "rateVersionDesc": "दर संस्करण",
      "costBasisMethod": "कस्ता आधार विधि",
      "costBasisMethodDesc": "कस्ता आधार विधि",
      "calculationSource": "निकास स्रोत",
      "calculationSourceDesc": "निकास स्रोत",
      "sourcePriceDate": "स्रोत कीमत तिथि",
      "sourcePriceDateDesc": "स्रोत कीमत तिथि",
      "brokerNo": "ब्रोकर नम्बर",
      "brokerNoDesc": "ब्रोकर नम्बर",
      "totalCapitalGain": "कुल व्यय लाभ",
      "totalCapitalGainDesc": "कुल व्यय लाभ",
      "totalCgt": "कुल सामान्य कर",
      "totalCgtDesc": "कुल सामान्य कर",
      "disposalCount": "विसर्जन गिनती",
      "disposalCountDesc": "विसर्जन गिनती",
      "averageCgtRate": "सामान्य व्यय लाभ दर",
      "averageCgtRateDesc": "सामान्य व्यय लाभ दर"
    },
    "companyStatement": {
      "clientAccount": "ग्राहक खाता",
      "clientAccountDesc": "ग्राहक खाता",
      "instrumentSymbol": "निवेश सัญक",
      "instrumentSymbolDesc": "निवेश सัญक",
      "asOfDate": "मिति अनुसार",
      "asOfDateDesc": "मिति अनुसार",
      "dateFrom": "मिति देखि",
      "dateFromDesc": "मिति देखि",
      "dateTo": "मिति सम्म",
      "dateToDesc": "मिति सम्म",
      "includeUnapproved": "अनुमोदित नभएका समावेश",
      "includeUnapprovedDesc": "अनुमोदित नभएका समावेश",
      "transactionDate": "वित्तीय वार्षिक रिपोर्ट का तिथि",
      "transactionDateDesc": "वित्तीय वार्षिक रिपोर्ट का तिथि",
      "transactionType": "व्यापारिक लेनदेन प्रकार",
      "transactionTypeDesc": "व्यापारिक लेनदेन प्रकार",
      "symbol": "प्रतीक",
      "symbolDesc": "प्रतीक",
      "purchaseQuantity": "खरिद मात्रा",
      "purchaseQuantityDesc": "खरिद मात्रा",
      "purchaseAmount": "खरिद रकम",
      "purchaseAmountDesc": "खरिद रकम",
      "salesQuantity": "बिक्री मात्रा",
      "salesQuantityDesc": "बिक्री मात्रा",
      "salesAmount": "बिक्री रकम",
      "salesAmountDesc": "बिक्री रकम",
      "plNfrs": "पी&एल (एनएफआरएस)",
      "plNfrsDesc": "पी&एल (एनएफआरएस)",
      "netReceivables": "नेट प्राप्त राशि",
      "netReceivablesDesc": "नेट प्राप्त राशि",
      "status": "स्थिति",
      "statusDesc": "स्थिति",
      "totalPurchaseAmount": "कुल खरीद की राशि",
      "totalPurchaseAmountDesc": "कुल खरीद की राशि",
      "totalSalesAmount": "कुल बिक्री की राशि",
      "totalSalesAmountDesc": "कुल बिक्री की राशि",
      "totalPrincipalCostNfrs": "नेट प्राप्त राशि (एनएफआरएस)",
      "totalPrincipalCostNfrsDesc": "नेट प्राप्त राशि (एनएफआरएस)",
      "totalPlNfrs": "कुल पी&एल (एनएफआरएस)",
      "totalPlNfrsDesc": "कुल पी&एल (एनएफआरएस)",
      "totalNetReceivables": "नेट निर्यात राशि",
      "totalNetReceivablesDesc": "नेट निर्यात राशि",
      "transactionCount": "व्यापारिक लेनदेन की संख्या",
      "transactionCountDesc": "व्यापारिक लेनदेन की संख्या"
    },
    "concentration": {
      "clientAccount": "खाता",
      "clientAccountDesc": "खाता",
      "portfolioAccount": "पोर्टफोलियो खाता",
      "portfolioAccountDesc": "पोर्टफोलियो खाता",
      "asOfDate": "मिति अनुसार",
      "asOfDateDesc": "मिति अनुसार",
      "symbol": "प्रतीक",
      "symbolDesc": "प्रतीक",
      "name": "नाम",
      "nameDesc": "नाम",
      "sector": "क्षेत्र",
      "sectorDesc": "क्षेत्र",
      "quantity": "मात्रा",
      "quantityDesc": "मात्रा",
      "marketValue": "बाजार मूल्य",
      "marketValueDesc": "बाजार मूल्य",
      "allocationPercent": "निवेश प्रतिशत",
      "allocationPercentDesc": "निवेश प्रतिशत",
      "riskLevel": "जोखिम स्तर",
      "riskLevelDesc": "जोखिम स्तर",
      "totalMarketValue": "कुल बाजार मूल्य",
      "totalMarketValueDesc": "कुल बाजार मूल्य",
      "top10Concentration": "टॉप १० समावेश",
      "top10ConcentrationDesc": "टॉप १० समावेश"
    },
    "fifoVsNfrs": {
      "clientAccount": "खाता",
      "clientAccountDesc": "खाता",
      "instrument": "उपकरण",
      "instrumentDesc": "उपकरण",
      "dateFrom": "मिति देखि",
      "dateFromDesc": "मिति देखि",
      "dateTo": "मिति सम्म",
      "dateToDesc": "मिति सम्म",
      "client": "ग्राहक",
      "clientDesc": "ग्राहक",
      "symbol": "प्रतीक",
      "symbolDesc": "प्रतीक",
      "instrumentName": "साधन का नाम",
      "instrumentNameDesc": "साधन का नाम",
      "fifoCostBasis": "एफआईओ स्थिर मूल्य आधार",
      "fifoCostBasisDesc": "एफआईओ स्थिर मूल्य आधार",
      "nfrsCostBasis": "न्र्स कस्ती आधार",
      "nfrsCostBasisDesc": "नर्स कस्ती आधार",
      "costBasisDiff": "कस्ती आधार व्यत्यास",
      "costBasisDiffDesc": "कस्ती आधार व्यत्यास",
      "costBasisDiffPct": "कस्ती आधार व्यत्यास प्रतिशत",
      "costBasisDiffPctDesc": "कस्ती आधार व्यत्यास प्रतिशत",
      "fifoUnrealizedGainLoss": "फिफो अस्थायिक लाभहानि",
      "fifoUnrealizedGainLossDesc": "फिफो अस्थायिक लाभहानि",
      "nfrsUnrealizedGainLoss": "नर्स अस्थायिक लाभहानि",
      "nfrsUnrealizedGainLossDesc": "नर्स अस्थायिक लाभहानि",
      "unrealizedGainLossDiff": "अस्थायिक लाभहानि व्यत्यास",
      "unrealizedGainLossDiffDesc": "अस्थायिक लाभहानि व्यत्यास",
      "reconciliationStatus": "मिलान स्थिति",
      "reconciliationStatusDesc": "मिलान स्थिति",
      "totalFifoCostBasis": "फिफो कस्ती आधार",
      "totalFifoCostBasisDesc": "फिफो कस्ती आधार",
      "totalNfrsCostBasis": "नर्स कस्ती आधार",
      "totalNfrsCostBasisDesc": "नर्स कस्ती आधार",
      "totalCostBasisDiff": "कस्ती आधार व्यत्यास",
      "totalCostBasisDiffDesc": "कस्ती आधार व्यत्यास",
      "totalFifoUnrealizedGainLoss": "फिफो अस्थायिक लाभहानि",
      "totalFifoUnrealizedGainLossDesc": "फिफो अस्थायिक लाभहानि",
      "totalNfrsUnrealizedGainLoss": "सामान्य NFRS अनुत्पादित लाभ-हानि कुल",
      "totalNfrsUnrealizedGainLossDesc": "सामान्य NFRS अनुत्पादित लाभ-हानि कुल",
      "reconciledPositions": "समन्वयित स्थितियाँ",
      "reconciledPositionsDesc": "समन्वयित स्थितियाँ",
      "unreconciledPositions": "असमन्वयित स्थितियाँ",
      "unreconciledPositionsDesc": "असमन्वयित स्थितियाँ"
    },
    "monthlyMovement": {
      "clientAccount": "ग्राहक खाता",
      "clientAccountDesc": "ग्राहक खाता",
      "instrument": "उपकरण",
      "instrumentDesc": "उपकरण",
      "dateFrom": "मिति देखि",
      "dateFromDesc": "मिति देखि",
      "dateTo": "मिति सम्म",
      "dateToDesc": "मिति सम्म",
      "month": "महिना",
      "monthDesc": "महिना",
      "client": "ग्राहक",
      "clientDesc": "ग्राहक",
      "symbol": "प्रतीक",
      "symbolDesc": "प्रतीक",
      "instrumentName": "साधन का नाम",
      "instrumentNameDesc": "साधन का नाम",
      "openingQuantity": "प्रारंभिक मात्रा",
      "openingQuantityDesc": "प्रारंभिक मात्रा",
      "purchases": "खरीद",
      "purchasesDesc": "खरीद",
      "sales": "बिक्री",
      "salesDesc": "बिक्री",
      "closingQuantity": "निष्कर्ष मात्रा",
      "closingQuantityDesc": "निष्कर्ष मात्रा",
      "openingValue": "प्रारंभिक मूल्य",
      "openingValueDesc": "प्रारंभिक मूल्य",
      "purchaseValue": "खर्च का मूल्य",
      "purchaseValueDesc": "खर्च का मूल्य",
      "saleValue": "बिक्री का मूल्य",
      "saleValueDesc": "बिक्री का मूल्य",
      "closingValue": "बंद का मूल्य",
      "closingValueDesc": "बंद का मूल्य",
      "netMovement": "नेट आंदोलन",
      "netMovementDesc": "नेट आंदोलन",
      "netMovementPct": "नेट आंदोलन प्रतिशत",
      "netMovementPctDesc": "नेट आंदोलन प्रतिशत",
      "totalPurchases": "कुल खरिद",
      "totalPurchasesDesc": "कुल खरिद",
      "totalSales": "कुल बिक्री",
      "totalSalesDesc": "कुल बिक्री",
      "totalNetMovement": "मूल्य नेट आंदोलन",
      "totalNetMovementDesc": "मूल्य नेट आंदोलन",
      "totalClosingValue": "बंद का मूल्य",
      "totalClosingValueDesc": "बंद का मूल्य"
    },
    "nfrsDashboard": {
      "clientAccount": "ग्राहक खाता",
      "clientAccountDesc": "ग्राहक खाता",
      "instrument": "उपकरण",
      "instrumentDesc": "उपकरण",
      "asOfDate": "मिति अनुसार",
      "asOfDateDesc": "मिति अनुसार",
      "client": "ग्राहक",
      "clientDesc": "ग्राहक",
      "symbol": "प्रतीक",
      "symbolDesc": "प्रतीक",
      "instrumentName": "निवेश नाम",
      "instrumentNameDesc": "निवेश नाम",
      "quantity": "मात्रा",
      "quantityDesc": "मात्रा",
      "nfrsCostPerUnit": "एनएफआरएस खर्च प्रति इकाई",
      "nfrsCostPerUnitDesc": "एनएफआरएस खर्च प्रति इकाई",
      "nfrsTotalCost": "नफर्स कुल लागत",
      "nfrsTotalCostDesc": "नफर्स कुल लागत",
      "marketPrice": "बाजार मूल्य",
      "marketPriceDesc": "बाजार मूल्य",
      "marketValue": "बाजार मूल्य",
      "marketValueDesc": "बाजार मूल्य",
      "nfrsUnrealizedGainLoss": "नफर्स अस्थायी लाभ हानि",
      "nfrsUnrealizedGainLossDesc": "नफर्स अस्थायी लाभ हानि",
      "nfrsUnrealizedGainLossPct": "नफर्स अस्थायी लाभ हानि प्रतिशत",
      "nfrsUnrealizedGainLossPctDesc": "नफर्स अस्थायी लाभ हानि प्रतिशत",
      "sector": "क्षेत्र",
      "sectorDesc": "क्षेत्र",
      "lastPriceDate": "अंतिम मूल्य तिथि",
      "lastPriceDateDesc": "अंतिम मूल्य तिथि",
      "totalNfrsCost": "नफर्स कुल लागत",
      "totalNfrsCostDesc": "नफर्स कुल लागत",
      "totalMarketValue": "नफर्स कुल बाजार मूल्य",
      "totalMarketValueDesc": "नफर्स कुल बाजार मूल्य",
      "totalNfrsUnrealizedGainLoss": "नफर्स कुल अस्थायी लाभ हानि",
      "totalNfrsUnrealizedGainLossDesc": "नफर्स कुल अस्थायी लाभ हानि",
      "positionCount": "स्थितियों की संख्या",
      "positionCountDesc": "स्थितियों की संख्या"
    },
    "nfrsMonthly": {
      "clientAccount": "ग्राहक खाता",
      "clientAccountDesc": "ग्राहक खाता",
      "instrument": "उपकरण",
      "instrumentDesc": "उपकरण",
      "dateFrom": "मिति देखि",
      "dateFromDesc": "मिति देखि",
      "dateTo": "मिति सम्म",
      "dateToDesc": "मिति सम्म",
      "month": "महिना",
      "monthDesc": "महिना",
      "client": "ग्राहक",
      "clientDesc": "ग्राहक",
      "symbol": "प्रतीक",
      "symbolDesc": "प्रतीक",
      "instrumentName": "निवेश नाम",
      "instrumentNameDesc": "निवेश नाम",
      "openingNfrsCost": "प्रारंभिक एनएफआरसी लागत",
      "openingNfrsCostDesc": "प्रारंभिक एनएफआरसी लागत",
      "purchasesNfrs": "एनएफआरसी खरीद",
      "purchasesNfrsDesc": "एनएफआरसी खरीद",
      "salesNfrs": "एनएफआरसी बिक्री",
      "salesNfrsDesc": "एनएफआरसी बिक्री",
      "closingNfrsCost": "प्रत्येक एनएफआरसी लागत",
      "closingNfrsCostDesc": "प्रत्येक एनएफआरसी लागत",
      "nfrsProfitLoss": "एनएफआरसी लाभ हानि",
      "nfrsProfitLossDesc": "एनएफआरसी लाभ हानि",
      "nfrsProfitLossPct": "एनएफआरसी लाभ हानि प्रतिशत",
      "nfrsProfitLossPctDesc": "एनएफआरसी लाभ हानि प्रतिशत",
      "totalPurchasesNfrs": "कुल एनएफआरसी खरीद",
      "totalPurchasesNfrsDesc": "कुल एनएफआरसी खरीद",
      "totalSalesNfrs": "कुल एनएफआरसी बिक्री",
      "totalSalesNfrsDesc": "कुल एनएफआरसी बिक्री",
      "totalNfrsProfitLoss": "नफ्र्स कुल लाभ-हानि",
      "totalNfrsProfitLossDesc": "नफ्र्स कुल लाभ-हानि",
      "totalClosingNfrsCost": "NFRS कुल बन्द हुने लागत",
      "totalClosingNfrsCostDesc": "NFRS कुल बन्द हुने लागत"
    },
    "performanceBenchmark": {
      "clientAccount": "ग्राहक खाता",
      "clientAccountDesc": "ग्राहक खाता",
      "benchmark": "बेन्चमार्क",
      "benchmarkDesc": "बेन्चमार्क",
      "startDate": "प्रारंभ तिथि",
      "startDateDesc": "प्रारंभ तिथि",
      "endDate": "अंत तिथि",
      "endDateDesc": "अंत तिथि",
      "period": "अवधि छान्नुहोस्",
      "periodDesc": "अवधि छान्नुहोस्",
      "portfolioReturn": "पोर्टफोलियो लाभ",
      "portfolioReturnDesc": "पोर्टफोलियो लाभ",
      "benchmarkReturn": "मानक लाभ",
      "benchmarkReturnDesc": "मानक लाभ",
      "excessReturn": "व्यापारिक लाभ",
      "excessReturnDesc": "व्यापारिक लाभ",
      "trackingError": "प्रबंधन त्रुटि",
      "trackingErrorDesc": "प्रबंधन त्रुटि",
      "informationRatio": "जानकारी अनुपात",
      "informationRatioDesc": "जानकारी अनुपात",
      "avgExcessReturn": "ग्राहक लाभ का औसत व्यापार",
      "avgExcessReturnDesc": "ग्राहक लाभ का औसत व्यापार",
      "avgTrackingError": "ग्राहक लाभ की औसत ट्रैकिंग त्रुटि",
      "avgTrackingErrorDesc": "ग्राहक लाभ की औसत ट्रैकिंग त्रुटि"
    },
    "performanceDrivers": {
      "clientAccount": "ग्राहक खाता",
      "clientAccountDesc": "ग्राहक खाता",
      "startDate": "प्रारंभ तिथि",
      "startDateDesc": "प्रारंभ तिथि",
      "endDate": "अंत तिथि",
      "endDateDesc": "अंत तिथि",
      "driver": "ड्राइवर",
      "driverDesc": "ड्राइवर",
      "contribution": "सहयोग",
      "contributionDesc": "सहयोग",
      "contributionPercent": "सहयोग का प्रतिशत",
      "contributionPercentDesc": "सहयोग का प्रतिशत",
      "description": "ग्राहक लाभ ड्राइवर विवरण",
      "descriptionDesc": "IRD-संगत CSV ढाँचामा कर रजिस्टरहरू डाउनलोड गर्नुहोस्।",
      "totalReturn": "कुल फिर्ती",
      "totalReturnDesc": "कुल फिर्ती",
      "totalAttribution": "कुल संबद्धता",
      "totalAttributionDesc": "कुल संबद्धता"
    },
    "performanceRisk": {
      "clientAccount": "ग्राहक खाता",
      "clientAccountDesc": "खाता विवरण",
      "startDate": "प्रारंभिक तिथि",
      "startDateDesc": "प्रारंभिक तिथि",
      "endDate": "अंतिम तिथि",
      "endDateDesc": "अंतिम तिथि",
      "riskMetric": "जोखिम माप",
      "riskMetricDesc": "जोखिम माप",
      "metricOption": {
        "volatility": "अस्थिरता",
        "volatilityDesc": "अस्थिरता",
        "sharpeRatio": "शार्प अनुपात",
        "sharpeRatioDesc": "शार्प अनुपात",
        "maxDrawdown": "अधिकतम ड्रअडाउन",
        "maxDrawdownDesc": "अधिकतम ड्रअडाउन",
        "sortinoRatio": "सोर्टिनो अनुपात",
        "sortinoRatioDesc": "सोर्टिनो अनुपात",
        "var95": "वर 95",
        "var95Desc": "वार95"
      },
      "value": "मान",
      "valueDesc": "मान",
      "benchmark": "बेन्चमार्क",
      "benchmarkDesc": "बेन्चमार्क",
      "percentile": "प्रतिशत",
      "percentileDesc": "प्रतिशत",
      "status": "स्थिति",
      "statusDesc": "स्थिति",
      "description": "निष्कर्ष की जोखिम",
      "descriptionDesc": "IRD-संगत CSV ढाँचामा कर रजिस्टरहरू डाउनलोड गर्नुहोस्।",
      "overallRiskScore": "सामान्य जोखिम स्कोर",
      "overallRiskScoreDesc": "सामान्य जोखिम स्कोर",
      "riskAdjustedReturn": "जोखिम प्रबंधित लाभ",
      "riskAdjustedReturnDesc": "जोखिम प्रबंधित लाभ"
    },
    "performanceSummary": {
      "clientAccount": "ग्राहक खाता",
      "clientAccountDesc": "ग्राहक खाता",
      "dateFrom": "मिति देखि",
      "dateFromDesc": "मिति देखि",
      "dateTo": "मिति सम्म",
      "dateToDesc": "मिति सम्म",
      "month": "महिना",
      "monthDesc": "महिना",
      "purchases": "खर्च",
      "purchasesDesc": "खर्च",
      "sales": "बिक्री",
      "salesDesc": "बिक्री",
      "netFlow": "नेट फ्लो",
      "netFlowDesc": "नेट फ्लो",
      "totalPurchases": "कुल खरिद",
      "totalPurchasesDesc": "कुल खरिद",
      "totalSales": "कुल बिक्री",
      "totalSalesDesc": "कुल बिक्री",
      "totalNetFlow": "मुलभूत नेट फ्लो",
      "totalNetFlowDesc": "मुलभूत नेट फ्लो",
      "monthCount": " महिना संख्या",
      "monthCountDesc": "महिना संख्या"
    },
    "pivotAnalysis": {
      "pivotBy": "पिवोट द्वारा",
      "pivotByDesc": "पिवोट द्वारा",
      "pivotByOption": {
        "sector": "क्षेत्र",
        "sectorDesc": "क्षेत्र",
        "symbol": "प्रतीक",
        "symbolDesc": "प्रतीक"
      },
      "timeDimension": "समय प्रतिमान",
      "timeDimensionDesc": "समय प्रतिमान",
      "timeDimensionOption": {
        "month": "महिना",
        "monthDesc": "महिना",
        "year": "वर्ष",
        "yearDesc": "वर्ष",
        "all": "सबै",
        "allDesc": "सबै",
        "dateRange": "कालावधि",
        "dateRangeDesc": "कालावधि"
      },
      "clientAccount": "ग्राहक खाता",
      "clientAccountDesc": "ग्राहक खाता",
      "dateFrom": "मिति देखि",
      "dateFromDesc": "मिति देखि",
      "dateTo": "मिति सम्म",
      "dateToDesc": "मिति सम्म",
      "instrument": "उपकरण",
      "instrumentDesc": "उपकरण",
      "sector": "क्षेत्र",
      "sectorDesc": "क्षेत्र",
      "group": "समूह",
      "groupDesc": "समूह",
      "totalInvestment": "कुल लगानी",
      "totalInvestmentDesc": "कुल लगानी",
      "portfolioValue": "पोर्टफोलियो मूल्य",
      "portfolioValueDesc": "पोर्टफोलियो मूल्य",
      "returnPct": "प्रत्येक प्रतिशत",
      "returnPctDesc": "प्रत्येक प्रतिशत",
      "rowCount": "बार की संख्या",
      "rowCountDesc": "बार की संख्या"
    },
    "profitLoss": {
      "realizedLens": {
        "tax": "कर",
        "taxDesc": "कर",
        "afterTaxCash": "नफा/हानि मा बाद मा कर लेने का पैसा",
        "afterTaxCashDesc": "नफा/हानि मा बाद मा कर लेने का पैसा",
        "nfrs": "एनएफआरएस",
        "nfrsDesc": "एनएफआरएस"
      },
      "realizedLensDesc": "निर्धारित लेंस"
    },
    "realizedProfitLoss": {
      "clientAccount": "ग्राहक खाता",
      "clientAccountDesc": "ग्राहक खाता",
      "instrument": "उपकरण",
      "instrumentDesc": "उपकरण",
      "dateFrom": "मिति देखि",
      "dateFromDesc": "मिति देखि",
      "dateTo": "मिति सम्म",
      "dateToDesc": "मिति सम्म",
      "saleDate": "बिक्री की तिथि",
      "saleDateDesc": "बिक्री की तिथि",
      "client": "ग्राहक",
      "clientDesc": "ग्राहक",
      "symbol": "प्रतीक",
      "symbolDesc": "प्रतीक",
      "instrumentName": "निवेश प्रतीक",
      "instrumentNameDesc": "निवेश प्रतीक",
      "quantity": "मात्रा",
      "quantityDesc": "मात्रा",
      "saleRate": "बिक्री दर",
      "saleRateDesc": "बिक्री दर",
      "saleAmount": "बिक्री मूल्य",
      "saleAmountDesc": "बिक्री मूल्य",
      "costBasis": "लागत आधार",
      "costBasisDesc": "लागत आधार",
      "grossGain": "मुनाफा",
      "grossGainDesc": "लाभ की मूल्य",
      "sellingCharges": "विक्री शुल्क",
      "sellingChargesDesc": "विक्री शुल्क",
      "cgt": "सामान्य कर",
      "cgtDesc": "सामान्य कर",
      "netGain": "नेट लाभ",
      "netGainDesc": "नेट लाभ",
      "capitalGain": "वित्तीय लाभ",
      "capitalGainDesc": "वित्तीय लाभ",
      "cgtRate": "सामान्य कर दर",
      "cgtRateDesc": "सामान्य कर दर",
      "holdingPeriodDays": "धारणकाल दिन",
      "holdingPeriodDaysDesc": "धारणकाल दिन",
      "holdingPeriodBucket": "धारणकाल बकेट",
      "holdingPeriodBucketDesc": "धारणकाल बकेट",
      "brokerNo": "व्यापारी नं",
      "brokerNoDesc": "व्यापारी नं",
      "totalSales": "कुल बिक्री",
      "totalSalesDesc": "कुल बिक्री",
      "totalCostBasis": "मूल्य मूल्यांकन",
      "totalCostBasisDesc": "मूल्य मूल्यांकन",
      "totalGrossGain": "सामान्य लाभ",
      "totalGrossGainDesc": "सामान्य लाभ",
      "totalSellingCharges": "विक्री शुल्क",
      "totalSellingChargesDesc": "विक्री शुल्क",
      "totalCgt": "मुक्त प्रतिबंधित लाभ",
      "totalCgtDesc": "मुक्त प्रतिबंधित लाभ",
      "totalNetGain": "नेट लाभ",
      "totalNetGainDesc": "नेट लाभ",
      "disposalCount": "विसर्जन संख्या",
      "disposalCountDesc": "विसर्जन संख्या"
    },
    "reportsHub": {
      "category": "श्रेणी",
      "categoryDesc": "श्रेणी",
      "availability": "उपलब्धता",
      "availabilityDesc": "उपलब्धता",
      "report": "रिपोर्ट",
      "reportDesc": "रिपोर्ट",
      "tier": "टियर",
      "tierDesc": "टियर",
      "exports": "निर्यात",
      "exportsDesc": "निर्यात",
      "reports": "रिपोर्टहरू",
      "reportsDesc": "रिपोर्टहरू",
      "available": "उपलब्ध",
      "availableDesc": "उपलब्ध",
      "locked": "लक",
      "lockedDesc": "लक",
      "unavailable": "अनुपलब्ध",
      "unavailableDesc": "अनुपलब्ध"
    },
    "sectorAllocation": {
      "clientAccount": "ग्राहक खाता",
      "clientAccountDesc": "ग्राहक खाता",
      "portfolioAccount": "पोर्टफोलियो खाता",
      "portfolioAccountDesc": "पोर्टफोलियो खाता",
      "sector": "क्षेत्र",
      "sectorDesc": "क्षेत्र",
      "asOfDate": "मिति अनुसार",
      "asOfDateDesc": "मिति अनुसार",
      "marketValue": "बाजार मूल्य",
      "marketValueDesc": "बाजार मूल्य",
      "allocationPercent": "निवेश प्रतिशत",
      "allocationPercentDesc": "निकासको का प्रतिशत",
      "positionCount": "स्थानों की संख्या",
      "positionCountDesc": "स्थानों की संख्या",
      "missingValuationCount": "निकासको की मूल्यांकन संख्या",
      "missingValuationCountDesc": "निकासको की मूल्यांकन संख्या",
      "denominatorBasis": "प्रतिनिधित्व आधार",
      "denominatorBasisDesc": "प्रतिनिधित्व आधार",
      "totalMarketValue": "कुल बाजार मूल्य",
      "totalMarketValueDesc": "कुल बाजार मूल्य",
      "sectorCount": "सेक्टर की संख्या",
      "sectorCountDesc": "सेक्टर की संख्या",
      "totalPositionCount": "कुल स्थानों की संख्या",
      "totalPositionCountDesc": "कुल स्थानों की संख्या"
    },
    "organizationClientStatement": {
      "parametersTitle": "ग्राहक विवरण खोज्नुहोस्",
      "parametersDescription": "ग्राहक छान्नुहोस् र आवश्यक परे पोर्टफोलियो वा ठ्याक्कै विवरण अवधि छान्नुहोस्। पूरा भएका शासित विवरणहरू मात्र देखाइन्छ।"
    },
    "liveParameters": {
      "title": "प्रतिवेदन मापदण्ड",
      "description": "तपाईंको स्वीकृत डाटा दायरा नबढाई शासित प्रत्यक्ष प्रतिवेदन सीमित गर्नुहोस्।",
      "run": "प्रतिवेदन चलाउनुहोस्",
      "requestFailed": "प्रतिवेदन अनुरोध पूरा हुन सकेन।",
      "asOfDate": "मिति सम्म",
      "clientAccount": "ग्राहक खाता",
      "portfolioAccount": "पोर्टफोलियो खाता",
      "reconciliationRun": "मिलान चलाइ",
      "status": "स्थिति",
      "severity": "गम्भीरता",
      "from": "कारोबार मिति सुरु",
      "to": "कारोबार मिति अन्त्य",
      "transactionType": "कारोबार प्रकार",
      "instrument": "उपकरण संकेत",
      "periodStart": "कार्यसम्पादन अवधि सुरु",
      "periodStartHelp": "साकार नाफा र नेपाल कर प्रमाणमा समावेश हुने पहिलो मिति।",
      "requested": "प्रतिवेदन अनुरोध पेश गरियो।"
    },
    "platformInstrumentInventory": {
      "title": "वित्तीय साधन सूची",
      "description": "वित्तीय साधन सन्दर्भ डाटा, जीवनचक्र अवस्था, मेटाडाटा पूर्णता र बजार मूल्य कभरेज समीक्षा गर्नुहोस्।",
      "parameters": {
        "title": "वित्तीय साधन सूचीका प्यारामिटर",
        "description": "आवश्यक भए जीवनचक्र अवस्थाअनुसार वित्तीय साधन फिल्टर गर्नुहोस्।",
        "accessibilityLabel": "वित्तीय साधन सूची प्रतिवेदनका प्यारामिटर",
        "status": "जीवनचक्र अवस्था"
      },
      "status": {
        "active": "सक्रिय",
        "inactive": "निष्क्रिय",
        "suspended": "निलम्बित",
        "delisted": "सूचीबाट हटाइएको"
      },
      "columns": {
        "symbol": "संकेत",
        "name": "वित्तीय साधनको नाम",
        "isin": "ISIN",
        "exchange": "विनिमय बजार",
        "sector": "क्षेत्र",
        "type": "वित्तीय साधन प्रकार",
        "currency": "मुद्रा",
        "status": "अवस्था",
        "marketDataCount": "मूल्य अभिलेख",
        "latestPriceDate": "पछिल्लो मूल्य मिति",
        "updatedAt": "पछिल्लो अद्यावधिक"
      }
    },
    "performanceParameters": {
      "title": "पोर्टफोलियो कार्यसम्पादन मापदण्ड",
      "description": "तपाईंको अधिकृत दायरामा उपलब्ध मिति, कार्यसम्पादन अवधि, ग्राहक र पोर्टफोलियो चयन गर्नुहोस्।"
    },
    "authority": {
      "section": {
        "title": "फाइलिङ अधिकार",
        "description": "यस परिभाषालाई आन्तरिक नियन्त्रण वा नियामकद्वारा अधिकृत फाइलिङका रूपमा वर्गीकृत गर्नुहोस्। अधिकृत फाइलिङका लागि प्रमाणित ढाँचा विवरण र संस्थामा लागू हुने सक्रिय इजाजतपत्र आवश्यक हुन्छ।"
      },
      "fields": {
        "classification": "आउटपुट वर्गीकरण",
        "regulator": "नियामक निकाय",
        "templateId": "आधिकारिक ढाँचा आईडी",
        "templateVersion": "ढाँचा संस्करण",
        "submissionChannel": "पेश गर्ने माध्यम",
        "sourceReference": "अधिकार स्रोत सन्दर्भ",
        "effectiveFrom": "ढाँचा लागू हुने मिति",
        "effectiveTo": "ढाँचा लागू हुने अन्तिम मिति"
      },
      "help": {
        "classification": "आउटपुट पेश गर्न स्वीकृत नभए खाली छोड्नुहोस् वा आन्तरिक नियन्त्रण चयन गर्नुहोस्।",
        "regulator": "प्रमाणित फाराम वा स्किमा जारी गर्ने निकाय चयन गर्नुहोस्।",
        "templateId": "नियामकद्वारा जारी फाराम, स्किमा वा सन्देश पहिचान प्रयोग गर्नुहोस्।",
        "submissionChannel": "जस्तै नियामक पोर्टल, हस्ताक्षरित अपलोड वा प्रमाणित मेशिन सबमिशन एडाप्टर।",
        "sourceReference": "निर्देशन, प्रकाशित फाराम, परिपत्र वा अन्य आधिकारिक स्रोत अभिलेख गर्नुहोस्।"
      },
      "classification": {
        "internalControl": "आन्तरिक नियन्त्रण मात्र",
        "authoritativeFiling": "आधिकारिक नियामक फाइलिङ"
      }
    },
    "visualizations": {
      "allocation": {
        "title": "पोर्टफोलियो एकाग्रता",
        "description": "एउटै नियन्त्रित मुद्राभित्र छानिएको समूहको प्रतिशत एकाग्रता।",
        "tableCaption": "पहुँचयोग्य पोर्टफोलियो एकाग्रता डेटा",
        "empty": "यो छनोटका लागि तुलना गर्न मिल्ने विनियोजन डेटा उपलब्ध छैन।",
        "partial": "एक वा बढी सक्रिय स्थितिमा पूर्ण मूल्यांकन कभरेज नभएकाले विनियोजन दृश्य अपूर्ण छ।"
      }
    },
    "options": {
      "dimension": {
        "currency": "मुद्रा",
        "instrument": "साधन",
        "instrumentType": "साधन प्रकार",
        "sector": "क्षेत्र"
      }
    }
  },
  "dashboard": {
    "title": "लगानी ड्यासबोर्ड",
    "platform": {
      "title": "प्लेटफर्म सञ्चालन",
      "branchHealth": "संस्थाहरू",
      "jobFailures": "असफल तथ्य कार्यहरू",
      "authorizationPosture": "सक्षम अधिकारहरू",
      "empty": "प्लेटफर्म डेटा उपलब्ध छैन।",
      "emptyDescription": "यस दायराका लागि प्लेटफर्म डेटा छैन।",
      "partial": "केही प्लेटफर्म विजेटहरू अस्थायी रूपमा उपलब्ध छैनन्।"
    },
    "organization": {
      "title": "संस्थाको पोर्टफोलियो",
      "empty": "यस दायराका लागि पोर्टफोलियो होल्डिङ उपलब्ध छैन।",
      "emptyDescription": "यस संस्थाका लागि कुनै होल्डिङ छैन।",
      "partial": "पोर्टफोलियो डेटा आंशिक रूपमा उपलब्ध छ।"
    },
    "client": {
      "title": "ग्राहक पोर्टफोलियो",
      "empty": "ग्राहक होल्डिङ उपलब्ध छैन।",
      "emptyDescription": "यस ग्राहकका लागि कुनै होल्डिङ छैन।",
      "partial": "ग्राहक पोर्टफोलियो डेटा आंशिक रूपमा उपलब्ध छ।"
    },
    "widgets": {
      "marketValue": "बजार मूल्य",
      "costBasis": "लागत आधार",
      "unrealizedGain": "अवास्तविक लाभ/हानि",
      "realizedGain": "साकार नाफा/नोक्सानी",
      "totalGainLoss": "कुल नाफा/नोक्सानी",
      "returnOnCost": "लागतमा प्रतिफल",
      "capitalGainTax": "पूँजीगत लाभ कर",
      "taxProvenanceCoverage": "कर स्रोत प्रमाण कभरेज",
      "nfrsEvidence": "एनएफआरएस प्रमाण तथ्य",
      "missingPrices": "मूल्य उपलब्ध नभएका उपकरण",
      "pendingApprovals": "बाँकी स्वीकृतिहरू",
      "failedImports": "असफल वा आंशिक आयात",
      "reconciliationBreaks": "खुला मिलान अन्तरहरू",
      "periodReturn": "अवधि रिटर्न",
      "cash": "नगद",
      "holdings": "होल्डिङहरू",
      "recentActivity": "हालको गतिविधि"
    },
    "home": {
      "needsAttention": "ध्यान आवश्यक",
      "criticalDataQualityIssues": "गम्भीर डाटा गुणस्तर समस्याहरू तत्काल ध्यान आवश्यक छ",
      "PERIOD_RETURN_REQUIRES_SINGLE_PORTFOLIO_SCOPE": "अवधि रिटर्नका लागि एकल पोर्टफोलियो क्षेत्र आवश्यक छ",
      "PERIOD_RETURN_TWR_UNAVAILABLE": "समय-भारित रिटर्न उपलब्ध छैन",
      "CASH_POSITION_AUTHORITY_UNAVAILABLE": "नगद शेष अस्थायी रूपमा उपलब्ध छैन",
      "CASH_POSITION_EMPTY": "क्षेत्रमा नगद स्थितिहरू छैनन्",
      "CASH_MULTI_CURRENCY_REPORT_FIRST": "बहु-मुद्रा नगद — पहिलो मुद्रा देखाउँदै",
      "asOfContext": "{{date}} सम्मको वित्तीय स्थिति",
      "returnMethodologyContext": "प्रतिफल: {{methodology}}",
      "sourceAsOfContext": "प्रमाण {{date}} मा अद्यावधिक",
      "needsAttentionDescription": "पोर्टफोलियो सञ्चालन वा वित्तीय प्रतिवेदनमा प्रभाव पार्न सक्ने प्राथमिकताकृत विषयहरू।",
      "attentionCount": "{{count}} विषय समीक्षा आवश्यक",
      "review": "समीक्षा गर्नुहोस्",
      "CASH_AS_OF_UNAVAILABLE": "छानिएको वित्तीय मितिपछि हालको नगद मौज्दात परिवर्तन भएकाले यस मितिको ऐतिहासिक नगद उपलब्ध छैन।"
    },
    "dragWidget": "विजेट पुनः क्रमबद्ध गर्न तान्नुहोस्",
    "widgetReordered": "विजेट क्रम अद्यावधिक भयो",
    "tagline": "वित्तीय पोर्टफोलियो नियंत्रण साथ साक्ष्य",
    "signedInTagline": "पोर्टफोलियो संचालन, वित्तीय नियंत्रण और साक्ष्य प्रबंधन",
    "asOf": "{{date}} सम्म",
    "liveIndicator": "प्रत्यक्ष",
    "liveAsOf": "प्रत्यक्ष · {{date}} सम्म",
    "sectorDistribution": "सेक्टर वितरण",
    "topHoldings": "शीर्ष होल्डिङहरू",
    "transactionActivity": "कारोबार गतिविधि",
    "buyTransactions": "खरिद कारोबारहरू",
    "sellTransactions": "बिक्री कारोबारहरू",
    "totalTransactions": "कुल कारोबारहरू",
    "supportPanel": {
      "ariaLabel": "डैशबोर्ड समर्थन पैनल"
    },
    "sidebar": {
      "ariaLabel": "ड्यासबोर्ड साइडबार नेभिगेसन"
    },
    "status": {
      "asOf": "{{date}} सम्म",
      "positions": "{{count}} स्थानहरू",
      "dataQuality": "डाटा {{quality}}",
      "suggested": "सुझाव",
      "report": "रिपोर्ट"
    },
    "kpiStrip": {
      "portfolioValue": "पोर्टफोलियो मूल्य",
      "currentPortfolioMarketValue": "वर्तमान पोर्टफोलियो बाजार मूल्य",
      "portfolioKpiSummaryAria": "पोर्टफोलियो KPI सारांश",
      "ytdReturnVsBenchmark": "YTD प्रतिफल बनाम बेञ्चमार्क",
      "benchmark": "बेञ्चमार्क",
      "benchmarkNotSet": "बेञ्चमार्क (सेट गरिएको छैन)",
      "benchmarkNotSetSubtext": "बेञ्चमार्क सेट गरिएको छैन",
      "unrealizedGain": "अनरियलाइज्ड गेन",
      "vsCost": "लागत विरुद्ध",
      "costBasis": "लागत आधार",
      "alerts": "सतर्कता",
      "positions": "पोजिसनहरू",
      "positionsWithPriceDate": "{{count}} स्थान · कीमतें {{date}} के रूप में",
      "costBasisWithDate": "लागत आधार {{costBasis}} · कीमतें {{date}} के रूप में",
      "critical": "गम्भीर",
      "alertMix": "{{monitoring}} संचालन · {{attention}} ध्यान",
      "approvalsPending": "अनुमोदनहरू विचाराधीन",
      "noActiveAlerts": "कुनै सक्रिय सतर्कता छैन",
      "outperformance": "बेहतर प्रदर्शन",
      "checkingReportAvailability": "रिपोर्ट उपलब्धता जाँच गर्दै…",
      "reportUnavailable": "रिपोर्ट उपलब्ध छैन",
      "approvalsUnavailable": "प्रमाणपत्र अनुपलब्ध",
      "disabledReasonTier": "निष्क्रिय कारण स्तर",
      "disabledReasonTierGeneric": "निष्क्रिय कारण स्तर सामान्य",
      "disabledReasonPermission": "निष्क्रिय कारण अनुमति",
      "asOfUnavailable": "प्रमाणित मिति अनुपलब्ध",
      "disabledReasonPermissionGeneric": "निष्क्रिय कारण अनुमति सामान्य",
      "disabledReasonQuality": "निष्क्रिय कारण गुणवत्ता",
      "disabledReasonReportUnavailable": "रिपोर्ट अनुपलब्ध",
      "disabledReasonDataUnavailable": "डेटा अनुपलब्ध",
      "disabledReasonGeneric": "निष्क्रिय कारण सामान्य",
      "gapVsTarget": "गैप विरुद्ध लक्ष्य",
      "remediationHoldings": "होल्डिङ रिपोर्ट पहुँच सक्षम गर्न प्रशासकलाई सम्पर्क गर्नुहोस्",
      "remediationPerformance": "बेञ्चमार्क डाटा कन्फिगर गर्नुहोस् वा प्रदर्शन रिपोर्ट पहुँच सक्षम गर्नुहोस्",
      "remediationGainLoss": "विस्तृत विवरण हेर्न गेन/लस रिपोर्ट पहुँच सक्षम गर्नुहोस्",
      "explanationMeaning": "व्याख्या अर्थ",
      "explanationSource": "व्याख्या स्रोत",
      "explanationAsOfDate": "व्याख्या प्रमाणित तिथि",
      "explanationValuationPolicy": "मूल्य नीति व्याख्या",
      "explanationQualityStatus": "गुणवत्ता स्थिति व्याख्या",
      "valueExplanation": "मूल्य व्याख्या",
      "hideValueExplanation": "मूल्य व्याख्या लुकाउनुहोस्",
      "showValueExplanation": "मूल्य व्याख्या देखाउनुहोस्",
      "explanationReconciliationTarget": "विलय लक्ष्य व्याख्या",
      "unknownSource": "अज्ञात स्रोत",
      "unknownPolicy": "अज्ञात नीति",
      "asOfDate": "मिति अनुसार",
      "explanationScopeHash": "व्याख्या क्षेत्रफल छश",
      "explanationValue": "व्याख्या मूल्य",
      "explanationCurrency": "व्याख्या वित्तीय मुद्रा",
      "explanationLabel": "व्याख्या",
      "explanationIncludedCount": "व्याख्या समाविष्ट गिनती",
      "explanationExcludedCount": "व्याख्या विलंबित गिनती",
      "remediationHoldingsDesc": "सुधार संपत्ति वर्णन"
    },
    "monthlySummary": {
      "reportValidation": "रिपोर्ट सत्यापन: ",
      "unitInvestmentChecksPassed": "वित्तीय निवेश जांचें पूरी हुई छं (वर्तमान दृश्य के लिए)।",
      "endingInvestment": "अन्तिम लगानी",
      "endingValue": "अन्तिम मूल्य",
      "realizedGain": "रियलाइज्ड गेन",
      "soldCostBasis": "बेचिएको लागत आधार",
      "realizedReturnPct": "रियलाइज्ड रिटर्न %",
      "s": "बचत गरिँदै",
      "period": "अवधि",
      "from": "से ",
      "to": "तक ",
      "costBasis": "लागत आधार: ",
      "noResultsMatch": "निर्दिष्ट फिल्टरहरूसँग मेल खाएन।",
      "rowPeriodChecks": "पंक्ति अवधि जाँचहरू",
      "grandTotalChecks": "पूर्ण अवधि जाँच (ग्रान्ड टोटल) अपूर्ण छन्। दुवै ब्रिज समीक्षा गर्नुहोस्: सुरुवाती एकाइ + अवधि खरिद मात्रा - अवधि बिक्री मात्रा = अन्तिम एकाइयाँ, और शुरुआती निवेश + अवधि खरीद की मात्रा - बेचने की लागत आधार = अंतिम निवेश। वर्तमान समस्या की गिनती: इकाइयाँ",
      "row": "पंक्ति",
      "total": "कुल",
      "investment": "लगानी",
      "unit": "एक đơn位",
      "checksFailed": "जांचें विफल हुईं",
      "rowUnitIssues": "रो-इकाई समस्याएँ",
      "totalUnitIssues": "सामान्य इकाइयों की मात्रा",
      "rowInvestmentIssues": "लगानी भएका पङ्क्तिहरू",
      "totalInvestmentIssues": "निवेश संबंधित सामान्य मात्रा",
      "orgIdRequired": "संगठन ID आवश्यक छ",
      "fromToDatesRequired": "दिनांक श्रृंखला के लिए दोनों तिथियाँ आवश्यक छं",
      "fromAfterTo": "मिति श्रृंखलामा पहिलो मिति पछिल्लो मितिभन्दा पछि हुन सक्दैन",
      "failedLoadPivot": "पाइवोट डेटा लोड गर्न विफल रहा",
      "byMonth": "मासिक द्वारा",
      "byYear": "वर्ष द्वारा",
      "allTime": "संपूर्ण समय",
      "dateRange": "दिनांक श्रृंखला",
      "portfolioPivotReport": "निवेश पोर्टफोलियो रिपोर्ट",
      "crossTab": "स्क्रॉस-टेबल: रो = ",
      "columnsSeparator": ", कॉलम = ",
      "rowsPivotBy": "रो (पाइवोट द्वारा)",
      "columnsTime": "कॉलम (समय)",
      "reportValidationWarning": "रिपोर्ट सत्यापन संकेत:"
    },
    "sectionStatus": {
      "OK": "उपलब्ध",
      "NO_DATA": "नो डेटा",
      "PARTIAL": "पार्टियल",
      "UNAVAILABLE": "अनुपलब्ध",
      "ERROR": "त्रुटि",
      "LOCKED": "लक"
    },
    "sectionStatus_description": {
      "OK": "खण्ड डेटा लोड गरियो।",
      "NO_DATA": "नतिज निकासक लागू नही छ",
      "PARTIAL": "निर्धारित मूल्य उपलब्ध नही छ। परिणाम पूर्ण नही हो सकते छं",
      "UNAVAILABLE": "यह सेक्शन वर्तमान मा असमर्थ छ",
      "ERROR": "इस सेक्शन का लोड करने मा एक त्रुटि आ गई छ",
      "LOCKED": "आपकी योजना को अपग्रेड करके इस सेक्शन तक पहुँच प्राप्त गर्नुहोस्"
    },
    "holdings": {
      "title": "सम्पत्ति वर्ग अनुसार होल्डिङहरू",
      "allocation": "आवंटन",
      "empty": "होल्डिङ डाटा उपलब्ध छैन। आवंटन हेर्न कारोबार आयात गर्नुहोस्।",
      "missingPrices": "मूल्य छुटेका छन्",
      "missingPricesAria": "केही होल्डिङहरूमा हालको बजार मूल्य छैन",
      "marketPricesUnavailable": "सबै स्थानका लागि बजार मूल्य उपलब्ध छैन",
      "updatePrices": "आवंटन चार्ट हेर्न मूल्य अद्यावधिक गर्नुहोस्",
      "viewReportAria": "होल्डिङ रिपोर्ट हेर्नुहोस्",
      "allocationOfKnownMarketValueOnly": "प्रसिद्ध बाजार मूल्य केवल वितरण",
      "allocationOfTotalPortfolioMarketValue": "कुल पोर्टफोलियो बाजार मूल्य वितरण",
      "excludedBecauseMarketValueUnavailable": "बाजार मूल्य उपलब्ध नही छ। इसे छोड़ दिया गया छ",
      "excludedBecauseSectorMissing": "विभाग की कमी के कारण इसे छोड़ दिया गया छ",
      "excludedMarketValueAmount": "बाजार मूल्य से वंचित राशि",
      "denominatorReconciliationNote": "विवरण पुनर्मेल खाता नोट"
    },
    "monthlyPnl": {
      "title": "मासिक P&L",
      "netRealized": "नेट रियलाइज्ड"
    },
    "portfolioPerformanceCard": {
      "title": "समयमा पोर्टफोलियो मूल्य",
      "noHistoricalData": "ऐतिहासिक डाटा उपलब्ध छैन",
      "historicalDataNotAvailable": "ऐतिहासिक पोर्टफोलियो मूल्य डाटा उपलब्ध छैन",
      "benchmarkNotConfiguredAria": "बजार बेन्चमार्क कन्फिगर गरिएको छैन",
      "benchmarkNotConfiguredTitle": "आउटपरफरमेन्स ट्र्याक गर्न लगानी सेटिङ्समा बेन्चमार्क इन्डेक्स सेट गर्नुहोस्",
      "benchmarkNA": "बेन्चमार्क N/A",
      "portfolioValue": "पोर्टफोलियो मूल्य",
      "ytd": "YTD",
      "benchmark": "बेन्चमार्क",
      "vsBenchmark": "बेन्चमार्क विरुद्ध",
      "viewPerformanceReport": "पोर्टफोलियो प्रदर्शन रिपोर्ट हेर्नुहोस्",
      "valuationDate": "मूल्यांकन मिति",
      "currentValuationMarker": "वर्तमान मूल्य संकेतक",
      "mismatchDefaultReason": "डाटा समयको कारणले KPI र चार्ट मानहरू फरक हुन सक्छन्",
      "currencyUnavailable": "मुद्रा जानकारी उपलब्ध छैन",
      "transactionPolicyApprovedOnly": "मात्र स्वीकृत",
      "transactionPolicyIncludeDraft": "मस्यौदा समावेश गर्नुहोस्",
      "transactionPolicyIncludeReversed": "उल्टो समावेश गर्नुहोस्",
      "stalePricePolicyRequireFresh": "ताजा मूल्यहरू आवश्यक",
      "stalePricePolicyAllowStale": "पुरानो मूल्यहरू अनुमति दिनुहोस्",
      "mismatch": {
        "KPI_CHART_POINT_DIVERGENCE": "चार्ट और पोर्टफोलियो KPI विभिन्न मूल्य तिथि या लेनदेन नीतियों के कारण अलग हो जाती छ",
        "KPI_NO_CHART_DATA": "चार्ट डेटा उपलब्ध नही छ। इसे पोर्टफोलियो KPI के साथ तुलना करने के लिए",
        "KPI_UNAVAILABLE_MISSING_FACTS": "पोर्टफोलियो KPI कंप्यूट करने मा असमर्थ छ — मानक स्थिति तथ्यों की कमी छ",
        "NO_CANONICAL_SNAPSHOTS": "इस दायरे के लिए कोई मानक पोर्टफोलियो स्नैपशॉट उपलब्ध नही छं"
      }
    },
    "nfrs": {
      "title": "NFRS अनुसार पोर्टफोलियो",
      "shortTitle": "NFRS अनुसार पोर्टफोलियो",
      "fullTitle": "नेपाल वित्तीय प्रतिवेदन मानक",
      "cardAria": "NFRS अनुसार पोर्टफोलियो",
      "errorAria": "NFRS अनुसार पोर्टफोलियो त्रुटि",
      "emptyAria": "NFRS अनुसार पोर्टफोलियो खाली",
      "notAvailable": "NFRS डाटा उपलब्ध छैन",
      "noData": "NFRS डाटा उपलब्ध छैन",
      "noDataAsOf": "{{date}} सम्म NFRS पोर्टफोलियो डाटा उपलब्ध छैन",
      "noDataHelp": "NFRS पोर्टफोलियो डाटा उपलब्ध छैन। आफ्नो पोर्टफोलियो होल्डिङ जाँच गरी फेरि प्रयास गर्नुहोस्।",
      "noHoldings": "NFRS होल्डिङ छैन",
      "holdingsCount": "{{count}} होल्डिङहरू",
      "generated": "{{date}} मा सिर्जना गरिएको",
      "fullReport": "पूरा रिपोर्ट",
      "fullReportAria": "पूरा NFRS रिपोर्ट हेर्नुहोस्",
      "learnMore": "थप जान्नुहोस्",
      "learnMoreAria": "NFRS पहुँच सक्षम गर्ने तरिका जान्नुहोस्",
      "tierLocked": "प्रोफेशनल वा एन्टरप्राइज टियरमा अपग्रेड गर्नुहोस्",
      "permissionLocked": "पहुँचका लागि प्रशासकसँग सम्पर्क गर्नुहोस्",
      "missingValuationFacts": "मूल्यांकन तथ्यहरू उत्पन्न गर्न पोर्टफोलियो डाटा आयात गर्नुहोस्",
      "missingMonthlyFacts": "लेनदेनहरूबाट मासिक चाल तथ्यहरू उत्पन्न गर्नुहोस्",
      "status": {
        "AVAILABLE": "उपलब्ध",
        "TIER_LOCKED": "स्तर बंद",
        "PERMISSION_LOCKED": "अनुमति की आवश्यकता छ",
        "MISSING_VALUATION_FACTS": "मूल्य तथ्यों की कमी",
        "MISSING_MONTHLY_FACTS": "मासिक तथ्यहरू खस्प",
        "DATA_STALE": "डेटा पुरानो",
        "UNAVAILABLE": "अनुपलब्ध"
      },
      "remediation": {
        "upgrade_tier": "अपग्रेड टियर",
        "upgrade_tierDesc": "अपग्रेड टियर",
        "contact_admin": "संचार प्रशासक",
        "contact_adminDesc": "संचार प्रशासक",
        "import_portfolio_data": "पोर्टफोलियो डेटा लिइन",
        "import_portfolio_dataDesc": "पोर्टफोलियो डेटा लिइन",
        "generate_monthly_facts": "मासिक तथ्यहरू उत्पादन गर्नु",
        "generate_monthly_factsDesc": "मासिक तथ्यहरू उत्पादन गर्नु",
        "update_market_prices": "बाजार कीमतहरू अद्यतन गर्नु",
        "update_market_pricesDesc": "बाजार कीमतहरू अद्यतन गर्नु",
        "fix_negative_holdings": "नगativo होल्डिंग्स ठीक गर्नु",
        "fix_negative_holdingsDesc": "नगativo होल्डिंग्स ठीक गर्नु",
        "run_reconciliation": "सहमति गर्नु",
        "run_reconciliationDesc": "सहमति गर्नु",
        "contact_support": "समर्थन संचार गर्नु",
        "contact_supportDesc": "समर्थन संचार गर्नु"
      }
    },
    "formulas": {
      "definition": "सूत्र परिभाषा",
      "variables": "चरहरू:",
      "glossaryTitle": "NFRS सूत्र शब्दावली"
    },
    "attention": {
      "title": "ध्यान आवश्यक",
      "monitoring": "मनिटरिङ",
      "dataTrust": "डाटा विश्वास",
      "pending_approvals": {
        "title": "पेन्डिङ अनुमोदनहरू",
        "description": "तपाईंको समीक्षा र अनुमोदनको लागि प्रतीक्षारत लेनदेनहरू"
      },
      "market_prices": {
        "synced": {
          "title": "बाजार कीमतहरू सिंक हो",
          "description": "सबै holdings वर्तमान बाजार कीमतमा हुन्छ"
        },
        "stale": {
          "title": "पुरानी बाजार कीमतें",
          "description": "कुछ संपत्तियों मा पुरानी बाजार कीमतें छं"
        }
      },
      "imports": {
        "cost_basis": {
          "title": "लागत-आधारित मूल्य निर्धारण पत्ता लाग्यो",
          "description": "केही होल्डिङहरू हराएका बजार मूल्यका कारण लागत आधारमा मूल्याङ्कन गरिएका छन्।"
        },
        "no_gaps": {
          "title": "आयात कभरेज पूरा",
          "description": "हालको पोर्टफोलियो दायरामा कुनै आयात डाटा खाली ठाउँ फेला परेन।"
        }
      },
      "viewAll": "सबै हेर्नुहोस्",
      "viewAllAria": "ध्यान आवश्यक सबै आइटम हेर्नुहोस्",
      "checkingExceptions": "अपवादहरू जाँच हुँदैछ…",
      "allClear": "सबै डाटा स्रोतहरू सञ्चालनमा छन्। कुनै समस्या भेटिएन।",
      "codeLabel": "कोड:",
      "remediate": "समाधान गर्नुहोस् →",
      "remediateAria": "{{title}} समाधान गर्नुहोस्",
      "moreExceptions": "+{{count}} थप अपवादहरू →",
      "moreExceptionsAria": "{{count}} थप अपवादहरू हेर्नुहोस्",
      "severity": {
        "error": "त्रुटि",
        "warning": "चेतावनी",
        "info": "जानकारी",
        "success": "सफलता",
        "critical": "गम्भीर"
      }
    },
    "alert": {
      "import_failure": {
        "title": "आयात असफल भयो",
        "description": "हालको आयात प्रक्रिया असफल भयो। त्रुटि विवरण समीक्षा गरेर वर्कफ्लो पुनः प्रयास गर्नुहोस्।"
      },
      "stale_prices": {
        "title": "पुराना बजार मूल्यहरू पत्ता लागे",
        "description": "एक वा बढी होल्डिङहरू पुराना बजार मूल्य प्रयोग गर्दैछन्। मूल्याङ्कन भरोसा पुनःस्थापना गर्न मूल्य अद्यावधिक गर्नुहोस्।"
      }
    },
    "recentActivity": {
      "title": "हालको गतिविधि",
      "noRecentActivity": "हालसालै कुनै गतिविधि भएन",
      "reasons": {
        "default": "हालसालैको गतिविधि अस्थायी रूपमा उपलब्ध छैन",
        "missingData": "आवश्यक डेटा अवस्थित छैन",
        "staleData": "डेटा पुराना छ",
        "serviceUnavailable": "सेवा अस्थायी रूपमा उपलब्ध छैन"
      },
      "columns": {
        "transactionDate": "मिति",
        "transactionType": "प्रकार",
        "instrumentSymbol": "इन्स्ट्रुमेन्ट",
        "quantity": "परिमाण",
        "totalAmount": "रकम",
        "status": "स्थिति"
      }
    },
    "sectionDegradation": {
      "partialFailures": "आंशिक विफलता",
      "partialFailuresPlural": "आंशिक विफलताहरू",
      "traceLabel": "ट्रेस:",
      "dismiss": "{{section}} सूचना खारेज गर्नुहोस्",
      "section": {
        "canonical_facts": {
          "unavailable": "पोर्टफोलियो मूल्याङ्कन डाटा अस्थायी रूपमा अनुपलब्ध छ। प्रदर्शित तथ्याङ्कहरू अपूर्ण हुन सक्छ।"
        },
        "performance": {
          "unavailable": "प्रदर्शन डाटा अस्थायी रूपमा अनुपलब्ध छ। चार्टहरूले नवीनतम प्रतिफल देखाउन नसक्ने सक्छ।"
        },
        "monthly_pnl": {
          "unavailable": "मासिक नाफा/नोक्सान डाटा अस्थायी रूपमा अनुपलब्ध छ।"
        },
        "monitoring": {
          "unavailable": "मनिटरिङ अलर्टहरू अस्थायी रूपमा अनुपलब्ध छन्।"
        },
        "recent_activity": {
          "unavailable": "हालको गतिविधि फिड अस्थायी रूपमा अनुपलब्ध छ।"
        },
        "approvals": {
          "unavailable": "विचाराधीन अनुमोदन गणना अस्थायी रूपमा अनुपलब्ध छ।"
        }
      }
    },
    "stateBanner": {
      "dismiss": "सूचना खारेज गर्नुहोस्",
      "dismissAria": "सूचना खारेज गर्नुहोस्"
    },
    "topBar": {
      "subtitle": "पोर्टफोलियो ड्यासबोर्ड",
      "subtitleWithDate": "पोर्टफोलियो ड्यासबोर्ड · {{date}} सम्म",
      "priceSyncedToday": "मूल्य आज सिंक गरियो",
      "priceSyncedOn": "मूल्य {{date}} मा सिंक गरियो",
      "instruments": "{{count}} उपकरणहरू",
      "failedImports": "{{count}} असफल आयातहरू"
    },
    "errors": {
      "noData": "ड्यासबोर्ड डाटा उपलब्ध छैन",
      "unexpected": "निर्दिष्ट अनुप्रयोग मा एक अप्रत्याशित त्रुटि हुई छ",
      "unauthorized": {
        "title": "प्रवेश प्रतिबंधित",
        "message": "तपाईंलाई यो पोर्टफोलियो ड्यासबोर्ड हेर्ने अनुमति छैन। यदि यो अनपेक्षित छ भने, आफ्नो प्रशासकसँग सम्पर्क गर्नुहोस्।"
      }
    },
    "kpiAction": {
      "disabled_reason": {
        "TIER_LOCKED": "अपने योजना को अपग्रेड करके इस विशेषता तक पहुंच प्राप्त गर्नुहोस्।",
        "PERMISSION_DENIED": "तपाईंलाई यो सुविधामा पहुँचको अनुमति छैन।",
        "NO_DATA": "पोर्टफोलियोमा डेटा उपलब्ध छैन जिस पर दिखाना चाहते छन्।",
        "UNAVAILABLE": "यो सुविधा अस्थायी रूपमा उपलब्ध छैन।",
        "NOT_CONFIGURED": "यो सुविधा अझै निर्दिष्ट गरिएको छैन।"
      }
    },
    "actions": {
      "resolveStalePrices": {
        "label": "पुराना मूल्यहरू समाधान गर्नुहोस्",
        "description": "{{count}} होल्डिङ(हरू) मा पुरानो बजार मूल्य छ",
        "labelDesc": "पुरानी बाजार कीमतें सुधारने का लेबल"
      },
      "reviewPendingApprovals": {
        "label": "लम्बित अनुमोदन समीक्षा गर्नुहोस्",
        "description": "{{count}} कारोबार(हरू) अनुमोदनको प्रतीक्षामा छन्",
        "labelDesc": "अवश्य प्राप्त अनुमोदनों को समीक्षा करने का लेबल"
      },
      "reviewMonitoringException": {
        "label": "अनुगमन अपवाद समीक्षा गर्नुहोस्",
        "description": "एक अनुगमन अलर्टको ध्यान आवश्यक छ",
        "labelDesc": "अनुगमन अपवादहरू मेल नखाएको समीक्षा"
      },
      "importMarketData": {
        "label": "नवीनतम बजार मूल्यहरू आयात गर्नुहोस्",
        "description": "केही होल्डिङहरू लागत आधारबाट मूल्याङ्कन गरिएका छन्",
        "labelDesc": "बजार डाटा आयात गर्नुहोस्"
      },
      "reviewPerformance": {
        "label": "प्रदर्शन समीक्षा गर्नुहोस्",
        "description": "पोर्टफोलियो प्रदर्शन रिपोर्ट खोल्नुहोस्",
        "labelDesc": "समीक्षण प्रदर्शन समीक्षा करने का लेबल"
      },
      "status": {
        "critical": "गम्भीर",
        "highPriority": "उच्च प्राथमिकता",
        "suggested": "सुझाव",
        "report": "रिपोर्ट"
      }
    },
    "action": {
      "importMarketData": {
        "label": "नवीनतम बजार मूल्यहरू आयात गर्नुहोस्",
        "description": "केही होल्डिङहरू लागत आधारबाट मूल्याङ्कन गरिएका छन्"
      },
      "reviewPendingApprovals": {
        "label": "लम्बित अनुमोदन समीक्षा गर्नुहोस्",
        "description": "{{count}} कारोबार(हरू) अनुमोदनको प्रतीक्षामा छन्"
      },
      "reviewPerformance": {
        "label": "प्रदर्शन समीक्षा गर्नुहोस्",
        "description": "पोर्टफोलियो प्रदर्शन रिपोर्ट खोल्नुहोस्"
      }
    },
    "reconciliation": {
      "banner": {
        "title": "डाटा गुणस्तर सूचना",
        "dismiss": "मेलमिलाप सूचना हटाउनुहोस्",
        "computedLabel": "गणना गरिएको:",
        "qualityStatus": {
          "OK": "सबै डाटा स्रोतहरू क्यानोनिकल छन्।",
          "EMPTY": "कुनै क्यानोनिकल स्थिति तथ्यहरू फेला परेनन्। पोर्टफोलियो डाटा निर्माण गर्न कारोबार आयात गर्नुहोस्।",
          "STALE_PRICES": "केही होल्डिङहरूले पुरानो बजार मूल्यहरू प्रयोग गर्छन्। सही मूल्याङ्कनको लागि मूल्यहरू अद्यावधिक गर्नुहोस्।",
          "MISSING_PRICES": "एक वा बढी होल्डिङहरूको लागि बजार मूल्यहरू हराइरहेका छन्। फलब्याकको रूपमा लागत आधार प्रयोग गरिएको छ।",
          "MISSING_FACTS": "क्यानोनिकल स्थिति तथ्यहरू अपूर्ण छन्। केही रिपोर्ट संख्याहरू अनुमानित हुन सक्छन्।",
          "ERROR": "क्यानोनिकल तथ्यहरू लोड गर्दा त्रुटि भयो। यदि यो जारी रहन्छ भने समर्थनसँग सम्पर्क गर्नुहोस्।"
        }
      },
      "strip": {
        "currentMarketAllMatch": "पोर्टफोलियो मूल्यों को संतुलित कर दिया गया छ।",
        "actionRequired": "पोर्टफोलियो की मूल्यांकन आवश्यकता छ.",
        "currentMarketLine": "वर्तमान बाजार मूल्य: {{value}}",
        "holdingsLine": "संपत्ति कुल: {{value}}",
        "snapshotLine": "अधिकृत स्नैपशॉट: {{value}} ({{status}})",
        "viewDiagnostics": "निदान देखना",
        "allMatch": "सब तुलनाएँ मेल खाती छं",
        "notAvailable": "मूल्याङ्कन उपलब्ध छैन",
        "mismatchDetected": "अनुक्रमिकता का पता चला छ",
        "partiallyAvailable": "कुछ उपलब्ध छ",
        "status": {
          "match": "मेल खाता छ",
          "mismatch": "अनुक्रमिकता मा असहमति छ",
          "notApplicable": "लागू हुँदैन",
          "notAvailable": "उपलब्ध छैन"
        },
        "deltaLabel": "व्युत्पन्न: {{delta}}",
        "comparisonUnavailable": "तुलना अनुपलब्ध छ",
        "ariaLabel": "निवेश पुनर्मूल्यांकन सारांश",
        "asOfUnavailable": "मिति उपलब्ध छैन"
      },
      "reason": {
        "staleSnapshot": "अधिकृत स्नैपशॉट वर्तमान बाजार मूल्य से पुराना छ।",
        "staleSnapshotDesc": "पुराना स्नैपशॉट"
      },
      "action": {
        "refreshValuation": "मूल्याङ्कन पुन: लोड गर्नुहोस्",
        "reviewMarketData": "बजार डेटा समीक्षा गर्नुहोस्",
        "viewReconciliation": "पुनर्व्यवस्था देख",
        "reviewMarketDataDesc": "बाजार डेटा समीक्षा करो",
        "viewReconciliationDesc": "पुनर्व्यवस्था देखो",
        "refreshValuationDesc": "मूल्य पुनः संशोधित करो"
      },
      "parity": {
        "kpiVsChart": "KPI बनाम चार्ट",
        "kpiVsHoldings": "KPI बनाम होल्डिङहरू",
        "kpiVsSnapshot": "KPI बनाम स्न्यापसट",
        "kpiVsExportExpected": "KPI बनाम अपेक्षित निर्यात"
      }
    },
    "sectionStatusList": {
      "title": "खण्ड उपलब्धता",
      "ariaLabel": "ड्यासबोर्ड खण्ड उपलब्धता सारांश",
      "completeness": "{{pct}}% पूर्ण",
      "available": "उपलब्ध",
      "unavailable": "अनुपलब्ध",
      "degraded": "खराब",
      "error": "त्रुटि",
      "sectionHeader": "विभाग की शीर्षक",
      "statusHeader": "स्थिति की शीर्षक",
      "completenessHeader": "पूर्णता की शीर्षक"
    },
    "dataCompletenessBadge": {
      "ariaLabel": "खण्ड डाटा कभरेज: {{pct}}%",
      "complete": "डाटा पूर्ण",
      "partial": "{{pct}}% डाटा कभरेज",
      "review": "समीक्षा",
      "help": "यो सूचकले ड्यासबोर्डका कति खण्डहरूको डाटा हाल प्रयोगयोग्य छ भन्ने देखाउँछ।"
    },
    "secondaryDisclosure": {
      "title": "ध्यान र अगाडीका कार्यहरू",
      "subtitle": "पूर्वनिर्धारित रूपमा संकुचित ताको खोज र निदान रिपोर्ट ग्रिडसँग प्रतिस्पर्धा नगरी उपलब्ध रहन्छ।",
      "titleNoAttention": "हालको गतिविधि",
      "subtitleNoAttention": "हालको गतिविधि र निदान जानकारी।",
      "showDiagnostics": "डायग्नोस्टिक्स देखाउनुहोस्"
    },
    "scope": {
      "clientScoped": "ग्राहक खाता {{clientAccountId}} मा देखाइने डेटा।",
      "clientScopedWithName": "ग्राहक नामले लेबल गरिएको"
    },
    "performance": {
      "title": "पोर्टफोलियो प्रदर्शन",
      "ytdReturn": "YTD प्रतिफल",
      "oneYearReturn": "१-वर्ष प्रतिफल",
      "threeYearReturn": "३-वर्ष प्रतिफल",
      "fiveYearReturn": "५-वर्ष प्रतिफल",
      "sinceInception": "सुरुवातदेखि",
      "degradedNotice": "प्रमाणित बेन्चमार्क डेटा उपलब्ध नभएसम्म प्रदर्शन मेट्रिक्समा अनुमानित मूल्यहरू हुन सक्छन्।",
      "missingBenchmark": "बेञ्चमार्क सेट गरिएको छैन",
      "configureBenchmark": "बेन्चमार्क सेट गर्नुहोस्",
      "toRestore": "लोड हो रहेको छ...",
      "stalePrices": "बाजार मूल्य अनपड़ते छं",
      "updateMarketData": "बजार डेटा अद्यावधिक गर्नुहोस्",
      "or": " या ",
      "degradedTitle": "प्रदर्शन सन्दर्भ आंशिक रूपमा कमजोर छ",
      "reviewStaleCoverage": "पुरानो कभरेज समीक्षा गर्नुहोस्",
      "reviewDataQuality": "डेटा गुणस्तर समीक्षा गर्नुहोस्",
      "reviewDataQualityDesc": "डेटा गुणवत्ता समीक्षा",
      "updateMarketDataDesc": "बाजार डेटा अपडेट"
    },
    "dataQuality": {
      "trustScore": "विश्वास स्कोर",
      "priceIssues": "मूल्य समस्याहरू",
      "marketData": "बजार डाटा",
      "reconIssues": "मेलमिलाप समस्याहरू",
      "reconciliation": "मेलमिलाप",
      "lastChecked": "अन्तिम जाँच",
      "trustStatus": {
        "excellent": "उत्कृष्ट",
        "good": "राम्रो",
        "needsAttention": "ध्यान आवश्यक"
      },
      "today": "आज",
      "yesterday": "हिजो",
      "justNow": "अहिले",
      "minutesAgo": "{{minutes}} मिनेट अघि",
      "hoursAgo": "{{hours}} घण्टा अघि",
      "daysAgo": "{{days}} दिन अघि",
      "trustStatusLabel": "विश्वास स्थिति",
      "criticalIssues": "गम्भीर समस्याहरू",
      "fixFirst": "प्रथम पुनर्स्थापना करो",
      "notAvailable": "अनुपलब्ध",
      "neverChecked": "पहिले जाँच गरिएको छैन"
    },
    "priorityStatus": {
      "singleIssue": "१ मुद्दा ध्यान आवश्यक",
      "multipleIssues": "{{count}} मुद्दाहरू ध्यान आवश्यक",
      "breakdown": "{{actions}} कार्य · {{sections}} बिग्रिएका खण्डहरू · {{reconciliation}} मेलमिलाप मुद्दा",
      "viewAction": "कार्य हेर्नुहोस्",
      "viewDetails": "विवरण हेर्नुहोस्",
      "reviewReconciliation": "मेलमिलाप समीक्षा गर्नुहोस्",
      "viewAll": "सबै मुद्दाहरू हेर्नुहोस्"
    },
    "nextActions": {
      "title": "अर्काे कार्यहरू",
      "prioritizedCount": "{{count}} प्राथमिकतामा",
      "readOnlyHint": "हेर्ने मात्र"
    },
    "exceptionBanner": {
      "checkingExceptions": "विशेषताओं का निरीक्षण कर रहे छं",
      "unableToCheck": "अपवादहरू जाँच गर्न असमर्थ। पुन: लोड गर्नुहोस्।",
      "allSystemsOperational": "सब सिस्टम संचालन मा सक्षम छं",
      "exception": "विशेषता",
      "exceptions": "अपवादहरू",
      "requiringAttention": "ध्यान देने की आवश्यकता छ",
      "critical": "गम्भीर",
      "high": "उच्च",
      "medium": "मध्यम",
      "viewAll": "सबै हेर्नुहोस्",
      "viewAllExceptions": "{{count}} अपवादहरू हेर्नुहोस्",
      "noExceptions": "कुनै अपवादहरू छैनन्",
      "checking": "जाँच गर्दै...",
      "alert": "सूचना",
      "alerts": "चेतावनीहरू",
      "affected": "प्रभावित: ",
      "value": "मूल्य: ",
      "exceptionSeverityCounts": "विशेषता गंभीरता संख्याएँ",
      "navigateTo": "{{action}} मा नेभिगेट गर्नुहोस्"
    },
    "operationalSnapshot": {
      "title": "ऑपरेशनल सर्वेक्षण",
      "subtitle": "डेटा, रिपोर्ट्स, और नियंत्रण से संबंधित विश्वसनीयता और प्रक्रियाहरू की महत्वपूर्ण संकेतक.",
      "cards": {
        "dataTrust": {
          "title": "डाटा विश्वसनीयता",
          "description": "रिपोर्ट निर्यात गर्नुअघि डेटा-गुणस्तर अपवादहरू पहिले समाधान गर्नुहोस्।",
          "exceptions": "अपवादहरू",
          "critical": "गम्भीर"
        },
        "reports": {
          "title": "रिपोर्ट्स की तैयारी",
          "description": "निर्यात गर्नुअघि रिपोर्ट उपलब्धता र विश्वसनीयता स्थिति समीक्षा गर्नुहोस्।",
          "status": "स्थिति"
        },
        "approvals": {
          "title": "पेन्डिङ अनुमोदनहरू",
          "description": "पोस्टिङ र नियन्त्रण स्वस्थ राख्न प्रतीक्षारत अनुमोदनहरू स्पष्ट गर्नुहोस्।",
          "pending": "विचाराधीन"
        }
      }
    },
    "totalInvestment": "कुल लगानी",
    "closingUnits": "बन्द एकाइहरू",
    "noPivotRowsToDisplay": "देखाउनका लागि पिभोट तालिकाका पङ्क्तिहरू छैनन्",
    "complianceMonitor": {
      "title": "अनुपालन मनिटर",
      "description": "पोर्टफोलियो अनुपालन, एकाग्रता सीमा, र नियामकीय आवश्यकताहरू",
      "refresh": "रिफ्रेस",
      "criticalLabel": "गम्भीर - तुरुन्तै कार्बाही आवश्यक",
      "warningLabel": "चेतावनी - ध्यान आवश्यक",
      "healthyLabel": "स्वस्थ - सबै अनुपालित",
      "healthClaimsDisabled": "स्वास्थ्य दावीहरू असक्षम: पोर्टफोलियो वास्तविक बजार डाटाको प्रयोग गरेर मूल्यांकन गरिएको छैन ({{mode}} मोड)",
      "complianceStatusLimited": "अनुपालन स्थिति (सीमित)",
      "healthClaimsUnavailable": "लागत-आधार वा मिश्रित मूल्यांकनका कारण स्वास्थ्य दावीहरू उपलब्ध छैन",
      "activeBreachesImmediate": "{{count}} सक्रिय उल्लंघनहरूले तुरुन्तै समाधान आवश्यक गर्छन्",
      "itemsNeedAttention": "{{count}} वस्तुहरूले अनुपालन कायम राख्न ध्यान आवश्यक गर्छन्",
      "fullyCompliant": "पोर्टफोलियो सबै नियामकीय आवश्यकताहरूसँग पूर्ण रूपमा अनुपालित छ",
      "concentrationBreaches": "एकाग्रता उल्लंघनहरू",
      "allWithinLimits": "सबै सीमा भित्र",
      "requireRebalancing": "पुन: सन्तुलन आवश्यक",
      "activeBreaches": "सक्रिय उल्लंघनहरू",
      "totalComplianceViolations": "कुल अनुपालन उल्लंघनहरू",
      "documentationGaps": "कागजात खाडलहरू",
      "missingIncompleteDocs": "हराइरहेक वा अपूर्ण कागजातहरू",
      "upcomingDeadlines": "आगामी समयसीमाहरू",
      "requireTimelyAction": "समयमै कार्बाही आवश्यक",
      "concentrationAnalysis": "एकाग्रता विश्लेषण",
      "concentrationAnalysisDescription": "नियामकीय सीमाहरू सम्बन्धमा क्षेत्र र होल्डिङ एकाग्रता",
      "sectorConcentration": "क्षेत्र एकाग्रता (प्रति क्षेत्र ३०% सीमा)",
      "critical": "गम्भीर",
      "breached": "उल्लंघन भयो",
      "limit": "सीमा",
      "valueLabel": "मान:",
      "top10HoldingsConcentration": "शीर्ष १० होल्डिङहरू एकाग्रता (४०% सीमा)",
      "top10Holdings": "शीर्ष १० होल्डिङहरू",
      "exceedsLimit": "सीमा से बाहर छ",
      "withinLimit": "सीमा भीतर छ",
      "top10ExceedMessage": "शीर्ष १० होल्डिङहरूले पोर्टफोलियोको {{limit}}% भन्दा बढी छन्। एकाग्रता जोखिम कम गर्न विविधता विचार गर्नुहोस्।",
      "viewRebalancingRecommendations": "पुन: सन्तुलन सिफारिसहरू हेर्नुहोस्",
      "activeComplianceBreaches": "सक्रिय अनुपालन उल्लंघनहरू",
      "requireImmediateAttention": "नियामकीय अनुपालन कायम राख्न यी वस्तुहरूले तुरुन्तै ध्यान आवश्यक गर्छन्",
      "affected": "प्रभावित",
      "current": "वर्तमान",
      "deadline": "समयसीमा",
      "regulatoryGuidelines": "नियामकीय मार्गनिर्देशिकाहरू",
      "regulatoryGuidelinesDescription": "प्रणालीले अनुगमन गर्ने मुख्य अनुपालन सीमा र सीमाहरू",
      "sectorConcentrationDescription": "कुनै पनि एकल क्षेत्रले कुल पोर्टफोलियो मूल्यको ३०% भन्दा बढी हुनु हुँदैन। ४०% मा गम्भीर उल्लंघन।",
      "top10HoldingsDescription": "शीर्ष १० होल्डिङहरूको संयुक्त मूल्यले पोर्टफोलियोको ४०% भन्दा बढी हुनु हुँदैन। ५०% मा गम्भीर उल्लंघन।",
      "singleHoldingLimit": "एकल होल्डिङ सीमा",
      "singleHoldingLimitDescription": "व्यक्तिगत सिक्योरिटी होल्डिङहरूले पोर्टफोलियो मूल्यको १०% भन्दा बढी हुनु हुँदैन।",
      "documentation": "कागजात",
      "documentationDescription": "सबै लेनदेन र कर्पोरेट कार्यहरूसँग पूर्ण कागजात हुनु आवश्यक छ।"
    },
    "issueTable": {
      "loadingIssues": "समस्याहरू लोड हुँदैछ...",
      "noIssuesFound": "कुनै समस्या फेला परेन",
      "everythingGoodShape": "बहुत अच्छा! हर चीज ठीक से छ.",
      "severity": "गम्भीरता",
      "affectedItem": "प्रभावित वस्तु",
      "issue": "मुद्दा",
      "impact": "प्रभाव",
      "nextAction": "अगली कार्रवाई",
      "critical": "गम्भीर",
      "warning": "चेतावनी",
      "supportDetails": "समर्थन विवरण",
      "copied": "कॉपी!",
      "copy": "प्रतिलिपि गर्नु",
      "issueId": "मुद्दे ID",
      "sourceCheck": "स्रोत जांच",
      "detected": "पाया गया छ",
      "reference": "सन्दर्भ",
      "fix": "समाधान"
    },
    "noPeriodsToDisplay": "देखाउनका लागि कुनै अवधि छैन",
    "investmentVsPortfolioValue": "निवेश विरुद्ध पोर्टफोलियो मूल्य द्वारा",
    "month": "महिना",
    "symbol": "प्रतीक",
    "sector": "क्षेत्र",
    "investment": "लगानी",
    "portfolioValue": "पोर्टफोलियो मूल्य",
    "allTime": "सबसे अधिक समय",
    "byYear": "वार्षिक",
    "byMonth": "मासिक",
    "dateRange": "कालरेखा",
    "year": "वर्ष",
    "selectMonth": "मासिक चयन",
    "from": "बाट",
    "to": "सम्म",
    "pivotReportTable": {
      "beginningInvestment": "सुरुआती लगानी",
      "beginningInvestmentHelp": "चयन गरिएको अवधिमा लिएर आएको लागत आधार, अघिल्लो दिन बन्द गरेको अवस्थामा।",
      "beginningUnits": "सुरुआती एकाइहरू",
      "beginningUnitsHelp": "चयन गरिएको अवधिमा लिएर आएका एकाइहरू, अघिल्लो दिन बन्द गरेको अवस्थामा।",
      "endingInvestment": "अन्तिम लगानी",
      "endingInvestmentHelp": "{{costBasis}} प्रयोग गरेर अवधि अन्त्यमा बाँकी लागत आधार।",
      "endingValue": "अन्तिम मूल्य",
      "endingValueHelp": "अवधि अन्त्यमा बाँकी होल्डिङहरूको बजार मूल्य।",
      "endingUnrealized": "अन्तिम अनरियलाइज्ड",
      "endingUnrealizedHelp": "अवधि अन्त्यमा बाँकी होल्डिङहरूमा अनरियलाइज्ड नाफा वा घाटा।",
      "endingTotalReturnPct": "अन्तिम कुल रिटर्न %",
      "endingTotalReturnPctHelp": "(रियलाइज्ड गेन + अन्तिम अनरियलाइज्ड गेन) / अन्तिम लगानी। जब कुनै अन्तिम लगानी बाँकी छैन N/A को रूपमा देखाइएको छ।",
      "endingUnits": "अन्तिम एकाइहरू",
      "endingUnitsHelp": "अवधि अन्त्यमा अझै राखिएका एकाइहरू।",
      "soldCostBasis": "बेचिएको लागत आधार",
      "soldCostBasisHelp": "चयन गरिएको अवधिमा बेचिएका एकाइहरूको लागत आधार।",
      "realizedGain": "रियलाइज्ड गेन",
      "realizedGainHelp": "चयन गरिएको अवधिमा बिक्री पछि बिक्री शुल्क र कर लगाउँदा मान्यता प्राप्त नाफा वा घाटा।",
      "realizedReturnPct": "रियलाइज्ड रिटर्न %",
      "realizedReturnPctHelp": "चयन गरिएको अवधिमा बेचिएका एकाइहरूको बेचिएको लागत आधार द्वारा विभाजित रियलाइज्ड गेन।",
      "periodPurchQty": "अवधि खरिद Qty",
      "periodPurchQtyHelp": "चयन गरिएको अवधिमा किनिएका एकाइहरू।",
      "periodSalesQty": "अवधि बिक्री Qty",
      "periodSalesQtyHelp": "चयन गरिएको अवधिमा बेचिएका एकाइहरू, यो अवधि अघि किनिएका एकाइहरू समावेश।",
      "periodPurchAmt": "अवधि खरिद Amt",
      "periodPurchAmtHelp": "चयन गरिएको अवधिमा बुक गरिएको खरिद राशि।",
      "periodSalesAmt": "अवधि बिक्री Amt",
      "periodSalesAmtHelp": "चयन गरिएको अवधिमा बुक गरिएको सकल बिक्री राशि शुल्क र कर अघि।",
      "capGainTax": "प्राप्ति कर",
      "capGainTaxHelp": "चयन गरिएको अवधिमा बिक्रीमा मान्यता प्राप्त पूँजीगत लाभ कर।",
      "noValidationData": "कुनै प्रमाणीकरण डाटा छैन",
      "unitsOkInvestmentOk": "एकाइहरू ठीक छ, लगानी ठीक छ",
      "unitDelta": "एकाइ डेल्टा ",
      "investmentDelta": "लगानी डेल्टा ",
      "separator": " | ",
      "sector": "क्षेत्र",
      "symbol": "प्रतीक",
      "totalEndingInvestment": "कुल - अन्तिम लगानी",
      "totalEndingTotalReturnPct": "कुल - अन्तिम कुल रिटर्न %",
      "totalRealizedReturnPct": "कुल - रियलाइज्ड रिटर्न %",
      "grandTotal": "सामान्य कुल",
      "reportType": "रिपोर्ट प्रकार",
      "pivotReport": "Pivot रिपोर्ट",
      "pivotBy": "व्यवस्था द्वारा",
      "dataQualityStatus": "डाटा गुणस्तर स्थिति",
      "dataQualityIssueCount": "डाटा गुणस्तर समस्या गणना",
      "validationRowIssues": "प्रमाणीकरण पंक्ति समस्याहरू",
      "validationTotalIssues": "प्रमाणीकरण कुल समस्याहरू",
      "pivotTimeAllMetrics": "{{pivot}} × समय (सबै मेट्रिक्स)",
      "pivotTimeAllMetricsSuffix": " × समय (सबै मेट्रिक्स)",
      "total": "कुल",
      "beginningPosition": "सुरुआती स्थिति:",
      "beginningPositionLabel": "प्रारंभिक स्थिति: ",
      "endingPosition": "अन्तिम स्थिति:",
      "endingPositionLabel": "अंतिम स्थिति: ",
      "periodActivity": "अवधि गतिविधि:",
      "periodActivityLabel": "कालरेखा गतिविधि: ",
      "totals": "कुलहरू",
      "unknown": "अज्ञात",
      "validation": "प्रमाणीकरण",
      "validationSummaryApplies": "प्रमाणीकरण सारांश माथिको प्रति-अवधि स्तम्भहरूमा लागू हुन्छ।",
      "pivotReportDataQualityIssue": "Pivot रिपोर्ट डाटा गुणस्तर समस्या",
      "howToRead": "यो तालिका कसरी पढ्ने:",
      "howToReadDescription": "सुरुआती स्थिति बाट सुरु गर्नुहोस्, त्यसपछि अवधि गतिविधि, त्यसपछि अन्तिम स्थिति। एक सही एकाइ पुल सामान्यतया यस्तो हुनुपर्छ: सुरुआती एकाइहरू + अवधि खरिद Qty - अवधि बिक्री Qty = अन्तिम एकाइहरू।",
      "beginningPositionDescription": "सुरुआती लगानी र सुरुआती एकाइहरू अघिल्लो दिनको होल्डिङहरू बाट प्रत्येक चयन गरिएको अवधि सुरु हुनु अघि गणना गरिएको छ।",
      "endingPositionDescription": "अन्तिम लगानी, अन्तिम अनरियलाइज्ड, अन्तिम कुल रिटर्न %, र अन्तिम एकाइहरॲले अवधि अन्त्यमा अझै खुल्ला होल्डिङहरू मात्र प्रयोग गर्छन्।",
      "periodActivityDescription": "बेचिएको लागत आधार, रियलाइज्ड गेन, रियलाइज्ड रिटर्न %, खरिद र बिक्री मात्रा/राशि, र Cap Gain Tax ले चयन गरिएको अवधि भित्र लेनदेनहरू सारांश गर्छन्।",
      "zeroValuesShown": "शून्य मानहरू ड्यासको सट्टा 0.00 को रूपमा देखाइएको छ ताकि बन्द स्थितिहरू स्पष्ट रहन्।",
      "endingTotalReturnPctDescription": "अन्तिम कुल रिटर्न % देखाउँछ ",
      "endingTotalReturnPctDescriptionSuffix": " जब एक पंक्तिमा बिक्री गतिविधि छ तर कुनै बाँकी अन्तिम लगानी छैन, किनकि शून्यले भाग गर्न भ्रामक हुनेछ। बन्द स्थितिहरूको लागि रियलाइज्ड रिटर्न % प्रयोग गर्नुहोस्।",
      "continuityWarning": "निरन्तरता चेतावनी:",
      "rowPeriodChecks": "पंक्ति अवधि जाँचहरू",
      "and": " र ",
      "grandTotalPeriodChecks": "grand-total अवधि जाँचहरू",
      "doNotReconcile": "मिल्दैन।",
      "unitIssues": "एकाइ समस्याहरू:",
      "row": "पंक्ति",
      "investmentIssues": "लगानी समस्याहरू:",
      "treatAsDiagnostic": "ती डेल्टाहरू समाधान हुनु नगरुञ्जेल यो रिपोर्टलाई निदानात्मकको रूपमा व्यवहार गर्नुहोस्।",
      "totalLabel": "कुल",
      "csv": "CSV",
      "excel": "एक्सेल"
    },
    "realizedGain": "रियलाइज्ड गेन",
    "unrealizedGain": "अनुभवी लाभ ({{costBasis}})",
    "profitLossLineChart": {
      "noData": "कोई डेटा",
      "realizedGain": "रियलाइज्ड गेन",
      "unrealizedGain": "अनरियलाइज्ड नाफा"
    },
    "sectorPieChart": {
      "noSectors": "कुनै क्षेत्र छैन",
      "total": "कुल",
      "hoverForDetails": "विवरणका लागि होभर गर्नुहोस्"
    },
    "symbolDrilldownDrawer": {
      "title": "प्रतीक विस्तार ड्रॉअर खंड",
      "noSymbols": "कुनै प्रतीक छैन",
      "symbol": "प्रतीक",
      "units": "यूनिटहरू",
      "price": "मूल्य",
      "value": "प्रतीक विस्तार ड्रॉअर मूल्य",
      "returnPct": "प्रत्येक प्रतिशत",
      "trust": "विश्वास"
    },
    "unifiedDashboard": {
      "portfolioMarketValue": "पोर्टफोलियो बजार मूल्य",
      "portfolioValueMixed": "पोर्टफोलियो मूल्य (मिश्रित आधार)",
      "portfolioValueCost": "लागतमा पोर्टफोलियो मूल्य",
      "dashboardDataUnavailable": "ड्यासबोर्ड डाटा उपलब्ध छैन",
      "refreshDashboard": "ड्यासबोर्ड रिफ्रेस गर्नुहोस्",
      "addTransaction": "लेनदेन थप्नुहोस्",
      "viewHoldings": "होल्डिङहरू हेर्नुहोस्",
      "performance": "प्रदर्शन",
      "overview": "अवलोकन",
      "portfolioSnapshotLive": "प्रत्यक्ष बजार डाटासँग तपाईंको पोर्टफोलियो स्न्यापसट",
      "portfolioAtGlanceCost": "लागत आधार मूल्यांकन प्रयोग गरेर एक नजरमा तपाईंको पोर्टफोलियो",
      "quotesAsOf": "{{date}} सम्म उद्धरणहरू",
      "noQuoteTimestamp": "उद्धरण टाइमस्ट्याम्प उपलब्ध छैन",
      "readModelRefreshed": " • पढ्ने मोडेल रिफ्रेस गरियो ",
      "liveQuotesConnected": "प्रत्यक्ष उद्धरणहरू जडान गरियो",
      "partialQuoteCoverage": "आंशिक उद्धरण कभरेज",
      "costBasisValuation": "लागत-आधार मूल्यांकन",
      "lastUpdated": "अन्तिम अपडेट: ",
      "notAvailable": "उपलब्ध छैन",
      "refresh": "रिफ्रेस",
      "mixedValuation": "मिश्रित मूल्यांकन: {{stale}} पुरानो उद्धरण{{stalePlural}} र {{cost}} लागत-आधार होल्डिङ{{costPlural}}",
      "and": " र ",
      "costBasisHolding": " लागत-आधार होल्डिङ",
      "costBasisValuationDescription": "लागत-आधार मूल्यांकन: सबै होल्डिङहरू लागतमा मूल्यांकन गरिएको, बजार मूल्यमा होइन",
      "checking": "जाँच गर्दै...",
      "importing": "आयात गर्दै...",
      "importMarketData": "बजार डाटा आयात गर्नुहोस्",
      "marketValuation": "बजार मूल्यांकन",
      "totalInvestment": "कुल लगानी",
      "costBasisAcrossHoldings": "सबै होल्डिङहरूमा लागत आधार",
      "unrealizedPL": "अनरियलाइज्ड P&L",
      "onQuotedHoldings": " उद्धरित होल्डिङहरूमा",
      "zeroUntilQuotes": "विश्वसनीय उद्धरणहरू कन्फिगर नगरुञ्जेल शून्य",
      "coverage": "कभरेज",
      "quoteCoverageHoldings": "हालको होल्डिङहरूमा उद्धरण कभरेज",
      "transactionActivity": "लेनदेन गतिविधि",
      "viewAll": "सबै हेर्नुहोस्",
      "recentTransactionSummary": "हालको लेनदेन सारांश र गतिविधि विभाजन",
      "totalTransactions": "कुल लेनदेनहरू",
      "buyTransactions": "खरिद लेनदेनहरू",
      "sellTransactions": "बिक्री लेनदेनहरू",
      "topHoldings": "शीर्ष होल्डिङहरू",
      "largestPositions": "मूल्य अनुसार सबैभन्दा ठूलो वर्तमान स्थितिहरू",
      "units": "एकाइहरू",
      "quoted": "उद्धरित",
      "costBasis": "लागत आधार",
      "noHoldingsYet": "अझै होल्डिङहरू छैनन्।",
      "addFirstTransaction": "पहिलो लेनदेन थप्नुहोस्",
      "sectorDistribution": "क्षेत्र वितरण",
      "viewAnalysis": "विश्लेषण हेर्नुहोस्",
      "portfolioAllocationSector": "क्षेत्र अनुसार पोर्टफोलियो आवंटन"
    },
    "trustBadge": {
      "warning": "वार्निंग: विश्वास की चेतावनी",
      "error": "विश्वास की त्रुटि"
    },
    "explanations": {
      "qualityStatus": {
        "ok": "ठीक",
        "empty": "खाली",
        "stalePrices": "पुराना मूल्यहरू",
        "missingPrices": "हराइरहेका मूल्यहरू",
        "missingFacts": "हराइरहेका तथ्यहरू",
        "error": "त्रुटि"
      },
      "currencyUnconfigured": "मुद्रा कन्फिगर गरिएको छैन",
      "hideDebug": "डिबग लुकाउनुहोस्",
      "showDebug": "डिबग देखाउनुहोस्",
      "label": {
        "portfolioMarketValue": "पोर्टफोलियो बजार मूल्य",
        "portfolioMarketValueDesc": "पोर्टफोलियो बजार मूल्य",
        "ytdReturnPct": "वार्षिक रिटर्न प्रतिशत",
        "ytdReturnPctDesc": "वार्षिक रिटर्न प्रतिशत विवरण",
        "unrealizedGain": "अनरियलाइज्ड नाफा",
        "unrealizedGainDesc": "अनरियलाइज्ड नाफा",
        "benchmarkReturnPct": "प्रामाणिकता के आधार पर रिटर्न प्रतिशत",
        "benchmarkReturnPctDesc": "प्रामाणिकता के आधार पर रिटर्न प्रतिशत विवरण",
        "targetReturnPct": "लक्ष्य रिटर्न प्रतिशत",
        "targetReturnPctDesc": "लक्ष्य रिटर्न प्रतिशत विवरण",
        "outperformanceVsBenchmarkPct": "प्रदर्शन का मुकाबला प्रामाणिकता प्रतिशत",
        "outperformanceVsBenchmarkPctDesc": "प्रदर्शन की तुलना मा स्टॉक प्रतिशत",
        "gapVsTargetPct": "लाभ की तुलना मा लक्ष्य प्रतिशत",
        "gapVsTargetPctDesc": "लाभ की तुलना मा लक्ष्य प्रतिशत",
        "unrealizedGainPctVsCost": "अनुभवहीन लाभ प्रतिशत व्यय के साथ",
        "unrealizedGainPctVsCostDesc": "अनुभवहीन लाभ प्रतिशत व्यय के साथ",
        "costBasis": "लागत आधार",
        "costBasisDesc": "लागत आधार",
        "pendingApprovalsCount": "प्रतीक्षित मंजूरी गिनती",
        "pendingApprovalsCountDesc": "प्रतीक्षित मंजूरी गिनती"
      }
    },
    "empty": {
      "addFirstTransaction": "पहिलो लेनदेन थप्नुहोस्",
      "addFirstTransactionDesc": "पहिलो लेनदेन थप्नुहोस्"
    },
    "admin": {
      "approvals": "अनुमोदनहरू",
      "approvalsDesc": "अनुमोदनहरू"
    },
    "kpiActions": {
      "holdings": {
        "label": "होल्डिङहरू",
        "labelDesc": "होल्डिङहरू"
      },
      "performance": {
        "label": "प्रदर्शन",
        "labelDesc": "प्रदर्शन"
      },
      "gainLoss": {
        "label": "लाभ हानि",
        "labelDesc": "लाभ हानि"
      },
      "quality": {
        "label": "गुणवत्ता",
        "labelDesc": "गुणवत्ता"
      }
    },
    "persona": {
      "title": "व्यक्ति",
      "currentContext": "हालको प्रसंग",
      "availableContexts": "संभव संदर्भ",
      "welcome": "नमस्ता, {{name}}"
    },
    "recentActivityUnavailable": "हालका कारोबार गतिविधि अस्थायी रूपमा उपलब्ध छैन। पोर्टफोलियो मूल्य र अन्य ड्यासबोर्ड डेटा प्रभावित भएका छैनन्।",
    "viewAllTransactions": "सबै कारोबार हेर्नुहोस्"
  },
  "transactions": {
    "status": {
      "draft": "ड्राफ्ट",
      "pendingApproval": "प्रतीक्षामा मित्र्य",
      "approved": "कार्यप्रवाह सफलतापूर्वक अनुमोदित।",
      "rejected": "KYC अस्वीकार",
      "posted": "पोस्ट गरियो",
      "void": "खाली"
    },
    "type": {
      "purchase": "खरिद",
      "sale": "बिक्री",
      "bonusShare": "बोनस शेयर",
      "rightShare": "हक शेयर",
      "openingBalance": "प्रारंभिक संतुलन"
    },
    "lifecycle": {
      "createDraft": "नयाँ मस्यौदा बनाउनुहोस्",
      "submitForApproval": "स्वीकृतिका लागि पेश गर्नुहोस्",
      "approve": "अनुमोदन गर्नुहोस्",
      "reject": "अस्वीकार गर्नुहोस्",
      "post": "पोस्ट",
      "void": "खाली",
      "repair": "सुधार र पुन: पोस्ट गर्नुहोस्",
      "bulkSubmit": "सबै सबमिट गर्नुहोस्",
      "bulkApprove": "सब को स्वीकृति दें"
    },
    "lifecycleState": {
      "DRAFT": "ड्राफ्ट",
      "PENDING_APPROVAL": "प्रतीक्षामा मित्र्य",
      "APPROVED": "कार्यप्रवाह सफलतापूर्वक अनुमोदित।",
      "REJECTED": "KYC अस्वीकार",
      "POSTED": "पोस्ट गरियो",
      "VOID": "खाली",
      "REPAIR_PENDING": "सुधार प्रतीक्षामा मित्र्य"
    },
    "actions": {
      "viewDetails": "विवरणहरू हेर्नुहोस्",
      "editDraft": "मस्यौदा सम्पादन गर्नुहोस्",
      "deleteDraft": "मस्यौदा हटाउनुहोस्",
      "submitDraft": "स्वीकृतिका लागि मस्यौदा पेश गर्नुहोस्",
      "approveTransaction": "व्यापारिक विवरण स्वीकृति गर्नुहोस्",
      "rejectTransaction": "प्रस्ताव अस्वीकार गर्नुहोस्",
      "voidTransaction": "प्रस्ताव रद्द गर्नुहोस्",
      "repairTransaction": "प्रस्ताव सुधार गर्नुहोस्",
      "reverse": "उल्टाउनुहोस्",
      "repair": "ठीक गर्नुहोस्",
      "bulkReverse": "सार्वजनिक रूप से उल्टाउनुहोस्",
      "reverseDesc": "पीछे लाने का विवरण",
      "repairDesc": "ठीक करने का विवरण",
      "create": "सिर्जना",
      "createDesc": "सिर्जना",
      "view": "हेर्नुहोस्",
      "viewDesc": "हेर्नुहोस्",
      "import": "आयात",
      "importDesc": "आयात"
    },
    "errors": {
      "invalidTransition": "यो कारोबार असंगत अवस्थामा ({{status}}) भएकाले यो कार्य गर्न सकिँदैन।",
      "optimisticConflict": "अर्को प्रयोगकर्ताले कारोबार परिमार्जन गरेका छन्। कृपया रिफ्रेस गर्नुहोस् र फेरि प्रयास गर्नुहोस्।",
      "makerCheckerViolation": "एउटै प्रयोगकर्ताले कारोबार सिर्जना र अनुमोदन दुवै गर्न पाउँदैन (मेकर-चेकर नीति)।",
      "clientUserForbidden": "ग्राहक प्रयोगकर्ताहरूलाई यो कार्य गर्न अनुमति छैन।",
      "versionMismatch": "कारोबार संस्करण मेल खाएन। कृपया कारोबार पुनः लोड गर्नुहोस्।",
      "bulkPartialFailure": "{{total}} मध्ये {{failed}} कारोबारहरू प्रशोधन गर्न सकिएन।"
    },
    "list": {
      "title": "कारोबार इतिहास",
      "description": "खरिद/बिक्री कारोबारहरू हेर्नुहोस् र व्यवस्थापन गर्नुहोस्",
      "ariaLabel": "कारोबार इतिहास",
      "actions": {
        "addTransaction": "कारोबार थप्नुहोस्",
        "importTransactions": "कारोबारहरू आयात गर्नुहोस्"
      },
      "pagination": {
        "previous": "अघिल्लो",
        "next": "पछिल्लो",
        "pageOf": "पृष्ठ {{currentPage}} को {{totalPages}}"
      },
      "statement": {
        "selectCompanyLabel": "कम्पनी छनोट गर्नुहोस्:",
        "placeholder": "प्रतीक वा कम्पनी नाम टाइप गर्नुहोस्...",
        "noMatchingCompanies": "मेल खाने कम्पनीहरू छैन",
        "noCompanyStatementsAvailable": "कम्पनी विवरणहरू उपलब्ध छैन",
        "selectCompanyInstruction": "विवरण हेर्न कम्पनी छनोट गर्नुहोस्",
        "selectCompanyDescription": "कारोबार इतिहास, WACC, रिटर्न, र बजार डाटा हेर्नुहोस्",
        "noStatementsInstruction": "कारोबार भएका कम्पनीहरूको लागि मात्र कम्पनी विवरणहरू देखाइएको छ।"
      },
      "groupBy": {
        "none": "कुनै पनि होइन",
        "company": "कम्पनी",
        "type": "प्रकार",
        "status": "स्थिति"
      },
      "columns": {
        "date": "मिति",
        "symbol": "प्रतीक",
        "type": "प्रकार",
        "quantity": "मात्रा",
        "amount": "मात्रा",
        "status": "स्थिति"
      }
    },
    "filters": {
      "company": "कम्पनी",
      "type": "प्रकार",
      "searchPlaceholder": "खोज",
      "lessFilters": "कम फिल्टर",
      "moreFilters": "अधिक फिल्टर",
      "clearAll": "सबै खाली गर्नुहोस्",
      "allCompanies": "सार्वजनिक कंपनियाँ",
      "transactionType": "व्यापार प्रकार",
      "allTypes": "सार्वजनिक प्रकार",
      "dateRange": "काल रेखा",
      "amountRange": "मात्रा रेखा",
      "sortBy": "यस अनुसार क्रमबद्ध",
      "sortOrder": "सारणी क्रम"
    },
    "types": {
      "purchase": "खरिद",
      "sale": "बिक्री",
      "bonusShare": "बोनस शेयर",
      "rightShare": "हक शेयर"
    },
    "sort": {
      "date": "मिति",
      "company": "कम्पनी",
      "type": "प्रकार",
      "amount": "प्रत्येक",
      "descending": "नीचे",
      "ascending": "उपरे"
    },
    "modeLabels": {
      "list": "सूची",
      "bulk": "मात्रा",
      "statement": "विवरण",
      "reversals": "विपरीत"
    },
    "reversals": {
      "reasons": {
        "approved": "कार्यप्रवाह सफलतापूर्वक अनुमोदित।",
        "pending": "KYC विचाराधीन",
        "repair": "सुधारित कर"
      },
      "errors": {
        "reversePermission": "प्रत्येक विपरीत अनुमति",
        "approvePermission": "अनुमति देने की अनुमति",
        "rejectPermission": "निरस्त करने की अनुमति",
        "repairPermission": "सुधारित कर अनुमति"
      },
      "reversePrompt": "उल्टाउने पुष्टि गर्नुहोस्",
      "reversePromptPlaceholder": "उल्टाउने पुष्टि गर्नुहोस्",
      "success": {
        "requested": "मागच्या केले हो",
        "approved": "कार्यप्रवाह सफलतापूर्वक अनुमोदित।",
        "rejected": "KYC अस्वीकार",
        "repaired": "सुधारित केले हो"
      },
      "actions": {
        "approve": "अनुमोदन गर्नुहोस्",
        "approveConfirm": "अनुमोदन पुष्टि गर्नुहोस्",
        "reject": "अस्वीकार गर्नुहोस्",
        "rejectPrompt": "अस्वीकारको अनुरोध गर्नुहोस्",
        "rejectPlaceholder": "अस्वीकार गर्नुहोस्",
        "approveDesc": "अनुमोदन गर्नुहोस्",
        "rejectDesc": "अस्वीकार गर्नुहोस्"
      },
      "repairPrompt": "सुधार गर्नुहोस्",
      "repairPlaceholder": "सुधार गर्नुहोस्",
      "bulk": {
        "reverseNotSupported": "सामूहिक उल्टाउने समर्थित छैन",
        "repairNotSupported": "पुनर्प्रत्यारोपण नस्विक्ति"
      },
      "empty": {
        "title": "खाली",
        "description": "पुनर्प्रत्यारोपण वर्णन"
      },
      "filter": {
        "status": "फिल्टर स्थिति",
        "all": "सबै",
        "eligible": "योग्य",
        "pending": "KYC विचाराधीन",
        "repair": "पुनर्प्रत्यारोपण",
        "reversed": "उल्टाइयो"
      },
      "selected": "चयनित",
      "tableTitle": "तालिका",
      "submitting": "सहेजना कर रहे छं",
      "title": "पुनर्प्रत्यारोपण"
    },
    "mode": {
      "corporateAction": "कॉर्पोरेट कार्रवाई"
    },
    "view": {
      "invalidFallback": "अवैध पुनःप्रयोग"
    },
    "bulk": {
      "title": "संख्या"
    },
    "statement": {
      "title": "विवरण"
    }
  },
  "imports": {
    "preview": {
      "title": "आयात पूर्वावलोकन"
    },
    "validation": {
      "rowError": "पङ्क्ति त्रुटि"
    },
    "workflow": {
      "title": "डाटा आयात",
      "description": {
        "allFormats": "NEPSE पोर्टफोलियो विवरण, करार नोट, वा स्क्यान गरिएको बिलबाट कारोबार आयात गर्नुहोस्",
        "pdfAndStatements": "NEPSE पोर्टफोलियो विवरण र करार नोटबाट कारोबार आयात गर्नुहोस्",
        "statementAndScans": "NEPSE पोर्टफोलियो विवरण वा स्क्यान बिलबाट कारोबार आयात गर्नुहोस्",
        "statementsOnly": "NEPSE पोर्टफोलियो विवरणबाट कारोबार आयात गर्नुहोस्"
      },
      "formats": {
        "excel": "एक्सेल",
        "csv": "CSV",
        "excelShort": ".xlsx .xls",
        "csvShort": ".csv",
        "pdfContract": "PDF करार",
        "imageOcr": "तस्बिर (OCR)",
        "pdfContractNotes": "PDF करार नोट",
        "scannedImages": "स्क्यान गरिएको तस्बिर",
        "pdfShort": "करार नोट",
        "imageShort": "JPG PNG HEIC"
      },
      "supportedFormats": {
        "title": "समर्थित ढाँचाहरू",
        "single": "{{format}} समर्थित",
        "double": "{{first}} र {{second}} समर्थित",
        "multi": "{{prefix}}, र {{last}} समर्थित"
      },
      "dragDrop": {
        "dropFilesHere": "फाइल यहाँ छोड्नुहोस्",
        "dragOrClick": "फाइल ड्र्याग र ड्रप गर्नुहोस् वा ब्राउज गर्न क्लिक गर्नुहोस्",
        "ariaLabel": "प्रशासक नेभिगेसन"
      },
      "clientAccount": {
        "requiredLabel": "ग्राहक खाता (अनिवार्य)",
        "selectPlaceholder": "ग्राहक खाता छान्नुहोस्",
        "loading": "ग्राहक खाताहरू लोड हुँदै...",
        "scopedHint": "आयात चयन गरिएको ग्राहक खातामा सीमित हुन्छ।",
        "optionalLabel": "वैकल्पिक",
        "scopedTo": "सीमित गरिएको छ"
      },
      "selectClientAccountBeforeUploadHint": "अपलोड गर्नु अघि ग्राहक खाता छान्नुहोस्।",
      "scanFromImage": {
        "label": "तस्बिरबाट स्क्यान (OCR)",
        "hint": "- ब्रोकर बिलको फोटो वा स्क्रिनसटबाट आयात गर्नुहोस्"
      },
      "processingTitle": "प्रशोधन:",
      "processing": {
        "uploadingFile": "फाइल अपलोड हुँदै...",
        "parsingContent": "सामग्री पार्स हुँदै...",
        "preparingReview": "समीक्षा तयार हुँदै..."
      },
      "reviewReady": {
        "title": "समीक्षाका लागि आयात जब तयार",
        "subtitle": "{{count}} पङ्क्ति पार्स भयो - जब #{{jobId}}",
        "openReview": "समीक्षा खोल्नुहोस्"
      },
      "ocr": {
        "uploadingToServer": "सर्भर-साइड OCR को लागि अपलोड हुँदै..."
      },
      "sources": {
        "ocrImport": "OCR आयात",
        "pdfImport": "PDF आयात",
        "csvImport": "CSV आयात",
        "excelImport": "Excel आयात"
      },
      "actions": {
        "downloadCsvTemplate": "CSV टेम्प्लेट डाउनलोड",
        "advancedImportOptions": "उन्नत आयात विकल्पहरू",
        "cancelOcrNow": "OCR अहिले रद्द गर्नुहोस्",
        "cancelNow": "अहिले रद्द गर्नुहोस्",
        "remove": "हटाउनुहोस्"
      },
      "aria": {
        "cancelFile": "{{fileName}} रद्द गर्नुहोस्",
        "removeFile": "{{fileName}} हटाउनुहोस्",
        "uploadProgress": "अपलोड प्रगति"
      },
      "settings": {
        "title": "आयात सेटिङ्स",
        "autoConfirmHighCertainty": "उच्च निश्चितताका प्रविष्टिहरू स्वतः पुष्टि गर्नुहोस्",
        "createShellInstruments": "अज्ञात संकेतका लागि shell instrument सिर्जना गर्नुहोस्",
        "autoSkipInvalidEntries": "अवैध प्रविष्टिहरू स्वतः स्किप गर्नुहोस्",
        "defaultExchange": "पूर्वनिर्धारित एक्सचेञ्ज:"
      },
      "guide": {
        "title": "आयात कार्यप्रवाह:",
        "step1": "ढाँचा छान्नुहोस् वा फाइल ड्र्याग/ड्रप गर्नुहोस् (Excel, PDF करार नोट, वा स्क्यान बिल)",
        "step2": "तस्बिर/PDF का लागि OCR ले कारोबार विवरण स्वतः निकाल्छ",
        "step3": "निश्चितता तह (High/Medium/Low/Invalid) अनुसार वर्गीकृत प्रविष्टि समीक्षा गर्नुहोस्",
        "step4": "व्यक्तिगत प्रविष्टि पुष्टि, सम्पादन, वा स्किप गर्नुहोस्",
        "step5": "कारोबार सिर्जना गर्न अन्तिम गर्नुहोस् - अज्ञात संकेतका लागि shell instrument स्वतः सिर्जना हुन्छ",
        "disclosureTitle": "पारस्परिक छापदान",
        "disclosureSubtitle": "पारस्परिक छापदान विवरण"
      },
      "errors": {
        "unableToLoadClientAccounts": "आयात स्कोपका लागि ग्राहक खाता लोड गर्न सकेन।",
        "unsupportedFileType": "असमर्थित फाइल प्रकार: {{fileName}}",
        "fileEmpty": "{{fileName}} खाली छ।",
        "fileTooLarge": "{{fileName}} 25 MB आयात सीमाभन्दा ठूलो छ।",
        "uploadCancelled": "अपलोड रद्द गरियो",
        "failedToProcessFile": "{{format}} फाइल प्रशोधन गर्न असफल",
        "ocrProcessingFailed": "OCR प्रशोधन असफल",
        "pdfProcessingFailed": "PDF प्रशोधन असफल",
        "uploadFailed": "अपलोड असफल",
        "selectClientAccountBeforeUpload": "फाइल अपलोड गर्नु अघि ग्राहक खाता छान्नुहोस्।",
        "failedToLoadTemplate": "टेम्प्लेट लोड गर्न असफल",
        "failedToDownloadTemplate": "टेम्प्लेट डाउनलोड गर्न असफल भयो। फेरि प्रयास गर्नुहोस्।"
      },
      "success": {
        "ocrCancelledRemoved": "OCR प्रशोधन रद्द गरियो। वस्तु क्युउबाट हटाइयो।",
        "importFinalized": "आयात सफलतापूर्वक अन्तिम गरियो",
        "templateDownloaded": "टेम्प्लेट सफलतापूर्वक डाउनलोड भयो"
      },
      "status": {
        "pending": "KYC विचाराधीन",
        "processing": "प्रशोधन हुँदै",
        "completed": "सम्पन्न",
        "failed": "असफल",
        "cancelled": "रद्द",
        "partial": "भाग्यशाली"
      }
    },
    "status": {
      "queued": "पालोमा",
      "processing": "प्रशोधन हुँदै",
      "uploading": "अपलोड हुँदै",
      "parsing": "पार्स हुँदै",
      "ocr": "ऑस्केनर",
      "review": "समीक्षा",
      "finalizing": "अन्तिम गर्दै",
      "completed": "सम्पन्न",
      "failed": "असफल",
      "cancelled": "रद्द"
    },
    "certainty": {
      "high": "उच्च",
      "medium": "मध्यम",
      "low": "न्यून",
      "invalid": "अनियमित"
    },
    "rowStatus": {
      "PENDING": "KYC विचाराधीन",
      "SKIPPED": "छोडियो",
      "POSTED": "पोस्ट गरियो",
      "DUPLICATE": "दोहराया गया",
      "ERROR": "त्रुटि",
      "REMEDIATED": "सुधारित"
    },
    "rowError": {
      "MISSING_SYMBOL": "प्रतीक की कमी छ",
      "INVALID_DATE": "अनियमित तिथि",
      "INVALID_QUANTITY": "अनियमित मात्रा मान",
      "INVALID_PRICE": "अनियमित मूल्य",
      "DUPLICATE_TRANSACTION": "दोहराए गए व्यापारिक कार्रवाई की सूचना",
      "UNKNOWN_INSTRUMENT": "अज्ञात प्रतीक",
      "MISSING_REQUIRED_FIELD": "आवश्यक क्षेत्र मा कमी छ",
      "PARSE_ERROR": "सूची विश्लेषण गर्न सकिएन",
      "VALIDATION_FAILED": "नियमों के अनुसार व्यापारिक कार्रवाई असफल रही"
    },
    "errors": {
      "rowValidation": "एक वा बढी पङ्क्तिहरूमा प्रमाणीकरण त्रुटिहरू छन्। अन्तिम गर्नु अघि सुधार गर्नुहोस्।",
      "duplicateRow": "यो पङ्क्ति अवस्थित कारोबारको नक्कल जस्तो देखिन्छ र छोडिएको थियो।",
      "branchBindingRequired": "यस आयातका लागि शाखा सन्दर्भ आवश्यक छ।",
      "traceUnavailable": "यस जबका लागि आयात ट्रेस डाटा उपलब्ध छैन।",
      "finalizationFailed": "आयात अन्तिम गर्न असफल भयो।",
      "rowCount": "{{count}} पङ्क्ति त्रुटि",
      "rowCountPlural": "{{count}} पङ्क्ति त्रुटिहरू",
      "evidenceDisabled": "आयात प्रमाण सुविधा अक्षम छ। यो सुविधा सक्षम गर्न आफ्नो प्रशासकलाई सम्पर्क गर्नुहोस्।"
    },
    "modeLabels": {
      "list": "कारोबार इतिहास",
      "create": "कारोबार कार्य बनाउनुहोस्",
      "bulk": "संख्या मा प्रवेश",
      "statement": "कम्पनी स्टेटमेन्ट",
      "reversals": "प्रतिक्रिया और सुधार"
    },
    "evidence": {
      "actions": {
        "finalize": "अख्त्या कर",
        "finalizeDesc": "अख्त्या कर",
        "retry": "पुनर्निरीक्षण",
        "retryDesc": "पुनर्निरीक्षण",
        "retryFailedRows": "अख्त्या केले गए वार्डनमा पुनर्निरीक्षण",
        "retryFailedRowsDesc": "अख्त्या केले गए वार्डनमा पुनर्निरीक्षण",
        "remediateRow": "वार्डनमा सुधारणा गर्न",
        "remediateRowDesc": "वार्डनमा सुधारणा गर्न",
        "traceRow": "वार्डनमा पथप्रदर्शित गर्न",
        "traceRowDesc": "वार्डनमा पथप्रदर्शित गर्न",
        "skipRow": "वार्डनमा छोड्न",
        "skipRowDesc": "वार्डनमा छोड्न"
      }
    },
    "actions": {
      "upload": "अपलोड गर्न",
      "uploadDesc": "अपलोड गर्न",
      "commit": "समायोजन गर्न",
      "commitDesc": "समायोजन गर्न"
    }
  },
  "companyStatement": {
    "title": "कम्पनी विवरण",
    "description": "प्रति उपकरण कारोबार समयरेखा र मूल्यांकन सन्दर्भ।",
    "helperDescription": "होल्डिङ, खरिद, बिक्री, लागत आधार, र विवरण प्रमाण हेर्न सूचीबद्ध कम्पनी प्रतीक प्रविष्ट गर्नुहोस्।",
    "symbol": {
      "label": "उपकरण प्रतीक",
      "placeholder": "उपकरण प्रतीक प्रविष्ट गर्नुहोस्...",
      "error": "मान्य उपकरण प्रतीक प्रविष्ट गर्नुहोस्।"
    },
    "viewButton": "विवरण हेर्नुहोस्",
    "actions": {
      "generate": "निर्माण गर्न",
      "generateDesc": "निर्माण गर्न",
      "export": "निकास गर्न",
      "exportDesc": "निकास गर्न"
    }
  },
  "filters": {
    "min": "कमचासो",
    "max": "मаксचासो",
    "from": "बाट",
    "to": "सम्म",
    "field": "खाता",
    "operator": "ऋण",
    "value": "मान",
    "operators": {
      "contains": "सही हुन्छ",
      "equals": "समान",
      "notEquals": "भिन्न",
      "startsWith": "प्रारंभ हुन्छ",
      "endsWith": "अंतिम हुन्छ",
      "gt": "बडो",
      "gte": "बडो या समान",
      "lt": "छोटो",
      "lte": "छोटो या समान",
      "between": "मध्यस्थ",
      "on": "प्रति",
      "before": "पूर्व",
      "after": "पश्चात्त",
      "isNull": "खाली हुन्छ",
      "isNotNull": "खाली नै हुन्छ",
      "in": "कोणसा हुन्छ",
      "notIn": "नहुन्त्यो"
    }
  },
  "transaction": {
    "new": "नया व्यापारिक अनुभव",
    "action": {
      "success": "कारोबार कार्य सफलतापूर्वक पूरा भयो",
      "submitSuccess": "कारोबार अनुमोदनका लागि पेश गरियो",
      "approveSuccess": "कारोबार अनुमोदित भयो र पोस्टिंगका लागि तयार छ",
      "postSuccess": "कारोबार सफलतापूर्वक पोस्ट भयो",
      "reverseSuccess": "कारोबार सफलतापूर्वक उल्टाइयो"
    },
    "approvals": {
      "title": "व्यापारिक अनुमतिहरु"
    },
    "reversals": {
      "title": "व्यापारिक प्रत्यर्थिता"
    },
    "detail": {
      "notFound": "व्यापारिक विवरण नपाहुने",
      "title": "व्यापारिक विवरण",
      "closeAriaLabel": "व्यापारिक विवरण बंद गर्नु",
      "basicInformation": "आधारिक जानकारी",
      "financialBreakdown": " आर्थिक विस्तार",
      "baseAmount": "मूल मात्रा",
      "taxInformation": "कर जानकारी",
      "capitalGainsTax": "व्यापारिक लाभ प्राप्ति कर",
      "taxBasis": "कर आधार",
      "taxBasisFifo": "पहलो-पहलो (FIFO)",
      "realizedPnl": "सक्षम P&L",
      "auditTrail": "नियंत्रण पथ",
      "createdAt": "बनाइयो:",
      "approvedBy": "कारोबार स्वीकृत गर्नेले",
      "approvedAt": "बनाइयो:",
      "submitForApproval": "व्यापारिक अनुमति लागू गर्नु",
      "requestReversal": "उल्ट्याउने अनुरोध गर्नुहोस्",
      "labels": {
        "symbol": "प्रतीक: ",
        "transactionId": "कारोबार ID:",
        "billNumber": "बिल संख्या: ",
        "date": "दिनांक: ",
        "type": "प्रकार: "
      },
      "transactionNumber": "व्यवसायिक अनुबंध संख्या",
      "clientAccount": "ग्राहक खाता",
      "portfolioAccount": "निवेश खाता",
      "quantity": "मात्रा",
      "pricePerUnit": "मूल्य/युनिट",
      "amounts": "मूल्य",
      "grossAmount": "सामान्य मूल्य",
      "charges": "भार",
      "total": "कुल",
      "settlement": "व्यवस्थापन",
      "idempotencyKey": "पुनर्निर्धारण की चाबी",
      "actions": "कार्यहरू",
      "approve": "अनुमोदन गर्नुहोस्",
      "post": "पोस्ट",
      "exportPdf": "निकास PDF",
      "exportExcel": "निकास Excel",
      "noDisposals": "व्यवस्थापन निषेध",
      "noFacts": "सामान्य तप्ति निर्माण नाहुन्",
      "historyPlaceholder": "गणना इतिहास देखिने होला यो स्थान",
      "actionFailed": "कारोबार कार्य पूरा गर्न सकिएन। हालको स्थिति जाँच गरी पुनः प्रयास गर्नुहोस्।",
      "enterReversalReason": "प्रतिक्रिया कारण प्रवेश कर्न: ",
      "tabs": {
        "lots": "संख्या ({{count}})",
        "disposals": "विक्री ({{count}})",
        "facts": " तथ्य ({{count}})",
        "history": "इतिहास"
      },
      "disposalsTable": {
        "lot": "लॉट",
        "acquired": "प्राप्त गरियो",
        "qty": "मात्रा",
        "costPerUnit": "व्यय/एकheiten",
        "holdingDays": "धारण की दिने",
        "realizedPnl": "पूँजीगत लाभ कर"
      },
      "factsTable": {
        "factType": " तथ्य प्रकार",
        "asOf": "से",
        "qty": "मात्रा",
        "costBase": "मूल्य",
        "marketValue": "बाजार मूल्य",
        "unrealizedPnl": "अनरियलाइज्ड P&L",
        "averageCostPerUnit": "प्रति एकाइ औसत लागत",
        "totalCost": "कुल लागत",
        "saleProceeds": "बिक्री प्राप्ति",
        "costBasis": "लागत आधार",
        "realizedGain": "वास्तविक लाभ/हानि",
        "taxableGain": "करयोग्य लाभ",
        "cgtRate": "पूँजीगत लाभकर दर",
        "capitalGainTax": "पूँजीगत लाभकर",
        "holdingPeriodDays": "धारण अवधि (दिन)"
      },
      "factsSections": {
        "position": "स्थिति तथ्यहरू",
        "realized": "वास्तविक लाभ/हानि तथ्यहरू",
        "cgt": "पूँजीगत लाभकर तथ्यहरू"
      }
    },
    "form": {
      "error": {
        "noEditPermission": "तपाईंलाई कारोबार परिमार्जन गर्ने अनुमति छैन",
        "noCreatePermission": "तपाईंलाई कारोबार बनाउने अनुमति छैन",
        "clientAccountRequired": "क्लाइन्ट खाता आवश्यक छ",
        "updateFailed": "विक्री संशोधन असफल रहा",
        "createFailed": "विक्री बनाने मा असफलता हुई"
      },
      "title": {
        "edit": "कारोबार परिमार्जन गर्नुहोस्",
        "create": "नयाँ कारोबार रेकर्ड बनाउनुहोस्"
      },
      "description": {
        "edit": "कारोबार विवरण अद्यावधिक गर्नुहोस्",
        "create": "खरिद वा बिक्री कारोबार रेकर्ड दर्ज गर्नुहोस्"
      },
      "field": {
        "clientAccount": "खाता",
        "company": "कम्पनी",
        "transactionType": "व्यापार प्रकार",
        "transactionDate": "व्यापार तिथि",
        "billNumber": "बिल #",
        "quantity": "मात्रा",
        "pricePerUnit": "प्रति इकाई की कीमत",
        "totalAmount": "कुल रकम",
        "commissionBrokerage": "कमीशन (ब्रोकरेज)",
        "dpCharges": "डीप चार्ज्स",
        "sebonFee": "SEBON शुल्क",
        "otherCharges": "अन्य शुल्क",
        "capitalGainTax": "विभाजन लाभ कर"
      },
      "placeholder": {
        "clientAccount": "क्लाइन्ट खाता चयन गर्नुहोस्",
        "company": "कम्पनी छान्नुहोस्",
        "billNumber": "बिल संख्या",
        "pricePerUnit": "प्रति इकाई की कीमत",
        "autoCalculated": "स्वतः गणना",
        "zeroAmount": "०.००"
      },
      "type": {
        "purchase": "खरिद",
        "sale": "बिक्री",
        "bonusShare": "बोनस शेयर",
        "rightShare": "हक शेयर",
        "openingBalance": "प्रारंभिक लाभ"
      },
      "section": {
        "openingBalance": "प्रारंभिक लाभ जीवन चक्र क्षेत्र",
        "transactionDetails": "व्यापार विवरण",
        "allocation": "बाँटफाँट",
        "charges": "शुल्क र कर",
        "source": "स्रोत र सन्दर्भ"
      },
      "openingBalance": {
        "description": "ये क्षेत्र NFRS/कर संबंधित छं और पोर्टफोलियो की शुरुआती स्थिति का प्रतिनिधित्व करते छन्।",
        "fields": {
          "principalCostNfrs": "प्राथमिक लागत (एनएफआरएस)",
          "transactionCostNfrs": "व्यापार लागत (एनएफआरएस)",
          "unitSum": "युनिट योग",
          "waccNfrs": "WACC (एनएफआरएस)",
          "profitLossNfrs": "लाभ/हानि (एनएफआरएस)",
          "principalAmountTax": "प्राथमिक राशि (कर)",
          "tcTax": "टीसी कर",
          "waccTax": "वेसी (कर)",
          "profitLossTax": "लाभ/हानि (कर)"
        }
      },
      "fields": {
        "quantityPlaceholder": "परिमाण भर्नुहोस्"
      },
      "imports": {
        "cost_basis": {
          "title": "मूल्य निर्धारण पricing डिटेक्ट गरिएको छ",
          "description": "केही होल्डिङहरू हराएका बजार मूल्यका कारण लागत आधारमा मूल्याङ्कन गरिएका छन्।"
        }
      },
      "chargePreview": {
        "title": "भुगतान पूर्व दृश्य",
        "brokerage": "ब्रोकरेज",
        "dpCharges": "डीप चार्ज्स",
        "sebonFee": "एसईबोन शुल्क",
        "totalCharges": "कुल शुल्क",
        "totalCost": "कुल लागत",
        "netReceivable": "नेट प्राप्त"
      },
      "chargeDifferences": {
        "title": "मान्यता मा परिवर्तन:",
        "description": "तपाईंले भर्नुभएका मूल्यहरू प्रयोग गरिनेछन् (प्रयोगकर्ता प्रविष्टिलाई प्राथमिकता दिइन्छ)।"
      },
      "charges": {
        "title": "भुगतान शुल्क & शुल्क (वैकल्पिक)",
        "subtitle": "स्वतः-गणना गरिएका मूल्यहरू परिमार्जन गर्नुहोस्",
        "taxTitle": "भुगतान, शुल्क & कर (वैकल्पिक)"
      },
      "action": {
        "updating": "अपडेट कर रहे...",
        "creating": " बना रहे...",
        "updateTransaction": "अपडेट ट्रांजेक्शन",
        "previewTransaction": "ट्रांजेक्शन प्रिव्यू",
        "backToEdit": "संपादनमा वापस जाए",
        "confirmAndSubmit": "निश्चित करे & पोस्ट करे",
        "processing": "प्रक्रिया..."
      },
      "preview": {
        "title": "ट्रांजेक्शन प्रिव्यू",
        "stateActions": "स्थिति & कार्यवाही",
        "action": "कार्य",
        "type": "प्रकार",
        "symbol": "प्रतीक",
        "quantity": "मात्रा",
        "price": "मूल्य",
        "total": "कुल",
        "chargesSummary": "भरण-व्यय संक्षेप",
        "approvalWorkflow": "नियुक्ति प्रक्रिया",
        "approvalWorkflowEditDescription": "सम्पादनमा गरिएका परिवर्तनहरूले यो कारोबारलाई पुनर्अनुमोदन आवश्यक पार्न सक्छ।",
        "approvalWorkflowCreateDescription": "ये ट्रांजेक्शनलाई PENDING_APPROVAL स्थितिमा मा बनाए राखी होला आणि पोस्टिंग को भाग्यान्वित गर्ने लाग्छ."
      },
      "confirmation": {
        "title": "ट्रांजेक्शन निश्चित करे",
        "updatePrompt": "यस ट्रांजेक्शनलाई अपडेट गर्ने को पुष्टि गर्न यसप सुनिश्चित होला?",
        "createPrompt": "यस ट्रांजेक्शनलाई बनाए राखी गर्ने को पुष्टि गर्न यसप सुनिश्चित होला?"
      }
    },
    "list": {
      "title": "कारोबारहरू",
      "empty": "ट्रांजेक्शन निकालिएको छ"
    },
    "create": {
      "title": "नया ट्रांजेक्शन",
      "buy": "खरीद",
      "sell": "बेच"
    },
    "status": {
      "draft": "ड्राफ्ट",
      "submitted": "सहपात होला",
      "approved": "कार्यप्रवाह सफलतापूर्वक अनुमोदित।",
      "posted": "पोस्ट गरियो",
      "rejected": "KYC अस्वीकार",
      "reversed": "उल्टाइयो"
    },
    "approve": {
      "confirm": "ट्रांजेक्शनलाई मान्य गर्न को पुष्टि गर्न?"
    },
    "reject": {
      "reason": "प्रतिक्रिया प्रत्याक्षेपक कारण"
    },
    "post": {
      "success": "व्यवसायीकरण लागू होये"
    },
    "reverse": {
      "confirm": "त्यस व्यवस्था कसा कराव?",
      "title": "लेनदेन उल्टाउनुहोस्",
      "reasonPrompt": "कृपया यो लेनदेन उल्टाउने कारण प्रदान गर्नुहोस्।",
      "reasonLabel": "उल्टाउने कारण",
      "reasonRequired": "उल्टाउने कारण आवश्यक छ।"
    },
    "export": "निर्यात"
  },
  "form": {
    "unsavedChanges": "तपाईंका सुरक्षित नभएका परिवर्तनहरू छन्",
    "saved": "सुरक्षित भयो",
    "saveFailed": "सुरक्षित गर्न असफल",
    "unknownFieldType": "अज्ञात फिल्ड प्रकार: {{fieldType}} (फिल्ड: {{fieldId}})",
    "noOptionsAvailable": "प्रकल्पांची उपलब्धता नाही",
    "optionsLoadError": "विकल्प लोड होय नाही",
    "typeToSearch": "खोज्न कम्तिमा {{count}} अक्षर टाइप गर्नुहोस्",
    "role": {
      "title": "भूमिका",
      "createTitle": "भूमिका सिर्जना गर्नुहोस्",
      "editTitle": "भूमिका सम्पादन गर्नुहोस्",
      "viewTitle": "भूमिका विवरण",
      "success": "भूमिका सफलतापूर्वक सुरक्षित भयो",
      "error": "भूमिका सुरक्षित गर्न सकिएन"
    },
    "reconciliationRun": {
      "title": "संयोजन पुनरावृत्ती शुरू करणे",
      "success": "संयोजन पुनरावृत्ती शुरू केले आहे",
      "error": "संयोजन पुनरावृत्ती शुरू होण्यात विफल झाले आहेत"
    },
    "importJob": {
      "title": "अपलोड करणे",
      "success": "अपलोड निर्मित केले आहे",
      "error": "अपलोड निर्माण होण्यात विफल झाले आहेत"
    },
    "user": {
      "title": "प्रयोगकर्ता",
      "createTitle": "प्रयोगकर्ता सिर्जना गर्नुहोस्",
      "editTitle": "प्रयोगकर्ता सम्पादन गर्नुहोस्",
      "viewTitle": "प्रयोगकर्ता विवरण",
      "createDescription": "नयाँ संगठन प्रयोगकर्ता बनाउनुहोस्",
      "success": "प्रयोगकर्ता सफलतापूर्वक सुरक्षित भयो",
      "error": "प्रयोगकर्ता सुरक्षित गर्न सकिएन"
    },
    "branch": {
      "createTitle": "शाखा सिर्जना गर्नुहोस्",
      "editTitle": "शाखा सम्पादन गर्नुहोस्",
      "viewTitle": "शाखा विवरण"
    },
    "platformOrganization": {
      "createTitle": "प्लेटफर्म संगठन सिर्जना गर्नुहोस्",
      "editTitle": "प्लेटफर्म संगठन सम्पादन गर्नुहोस्",
      "viewTitle": "प्लेटफर्म संगठन विवरण",
      "disableReason": "यस संगठनलाई निष्क्रिय बनाउनुको कारण",
      "disableApproval": "म यस संगठनलाई निष्क्रिय बनाई सक्रिय पहुँच रद्द गर्न स्वीकृति दिन्छु",
      "filingProfile": {
        "title": "नियामकीय दाखिला पहिचान",
        "description": "शासित सेबोन र आन्तरिक राजस्व प्रतिवेदनका लागि प्रयोग हुने कानुनी पहिचान। PAN क्यानोनिकल संस्था प्रोफाइलमा सुरक्षित हुन्छ र UI मा मास्क गरिन्छ।"
      }
    },
    "client": {
      "createTitle": "ग्राहक सिर्जना गर्नुहोस्",
      "editTitle": "ग्राहक सम्पादन गर्नुहोस्",
      "viewTitle": "ग्राहक विवरण",
      "createDescription": "लगानीकर्ताको प्रोफाइल र खाता विवरण सेट अप गर्नुहोस्।",
      "success": "ग्राहक सफलतापूर्वक सुरक्षित भयो",
      "error": "ग्राहक सुरक्षित गर्न असफल भयो"
    },
    "transaction": {
      "title": "नयाँ कारोबार",
      "createTitle": "नयाँ कारोबार",
      "editTitle": "कारोबार सम्पादन गर्नुहोस्",
      "viewTitle": "कारोबार विवरण",
      "success": "कारोबार सफलतापूर्वक सुरक्षित भयो",
      "error": "कारोबार सुरक्षित गर्न सकिएन"
    },
    "instrument": {
      "createTitle": "साधन सिर्जना गर्नुहोस्",
      "editTitle": "साधन सम्पादन गर्नुहोस्",
      "viewTitle": "साधन विवरण",
      "success": "साधन सफलतापूर्वक सुरक्षित गरियो",
      "error": "साधन सुरक्षित गर्न असफल भयो",
      "section": {
        "identity": "परिचय",
        "details": "सन्दर्भ विवरण",
        "status": "स्थिति"
      }
    },
    "clientAccount": {
      "createTitle": "ग्राहक खाता सिर्जना गर्नुहोस्",
      "editTitle": "ग्राहक खाता सम्पादन गर्नुहोस्",
      "viewTitle": "ग्राहक खाता विवरण",
      "success": "ग्राहक खाता सफलतापूर्वक सुरक्षित गरियो",
      "error": "ग्राहक खाता सुरक्षित गर्न असफल भयो"
    },
    "portfolio": {
      "createTitle": "पोर्टफोलियो सिर्जना गर्नुहोस्",
      "editTitle": "पोर्टफोलियो सम्पादन गर्नुहोस्",
      "viewTitle": "पोर्टफोलियो विवरण",
      "createDescription": "विद्यमान लगानीकर्तासँग पोर्टफोलियो खाता जोड्नुहोस्।",
      "success": "पोर्टफोलियो सफलतापूर्वक सुरक्षित भयो",
      "error": "पोर्टफोलियो सुरक्षित गर्न असफल भयो"
    },
    "moduleAssignments": {
      "createTitle": "मोड्यूल सक्षम गर्नुहोस्",
      "editTitle": "मोड्यूल असाइनमेन्ट कन्फिगर गर्नुहोस्",
      "viewTitle": "मोड्यूल असाइनमेन्ट विवरण"
    },
    "portfolioAccount": {
      "createTitle": "पोर्टफोलियो खाता सिर्जना गर्नुहोस्",
      "editTitle": "पोर्टफोलियो खाता सम्पादन गर्नुहोस्",
      "viewTitle": "पोर्टफोलियो खाता विवरण",
      "success": "पोर्टफोलियो खाता सफलतापूर्वक सुरक्षित गरियो",
      "error": "पोर्टफोलियो खाता सुरक्षित गर्न असफल भयो"
    },
    "collection": {
      "missingConfiguration": "यो संरचित क्षेत्र सही रूपमा कन्फिगर गरिएको छैन।",
      "invalid": "संरचित सम्पादक प्रयोग गरी पङ्क्तिहरू प्रविष्ट गर्नुहोस्।",
      "minimumRows": "कम्तीमा {{count}} पङ्क्ति थप्नुहोस्।",
      "maximumRows": "अधिकतम {{count}} पङ्क्ति मात्र अनुमति छ।",
      "invalidRow": "पङ्क्ति {{index}} अमान्य छ।",
      "requiredCell": "पङ्क्ति {{index}} मा {{field}} आवश्यक छ।",
      "invalidDecimal": "पङ्क्ति {{index}} मा {{field}} को मान अमान्य छ।",
      "journalUnbalanced": "पूर्वावलोकनअघि कुल डेबिट र क्रेडिट बराबर हुनुपर्छ।",
      "journalSummary": "डेबिट: {{debit}} · क्रेडिट: {{credit}}",
      "count": "{{count}} पङ्क्ति",
      "row": "पङ्क्ति {{index}}",
      "count_other": "{{count}} पङ्क्तिहरू",
      "minimumRows_other": "कम्तीमा {{count}} पङ्क्तिहरू थप्नुहोस्।",
      "maximumRows_other": "अधिकतम {{count}} पङ्क्तिहरू मात्र अनुमति छन्।",
      "journalLineInvalid": "पङ्क्ति {{index}} मा सकारात्मक डेबिट वा क्रेडिटमध्ये एउटा मात्र हुनुपर्छ।",
      "journalAmountInvalid": "पङ्क्ति {{index}} मा अमान्य वा ऋणात्मक जर्नल रकम छ।",
      "journalTotalRequired": "पेश गर्नु अघि जर्नलको कुल रकम शून्यभन्दा बढी हुनुपर्छ।"
    },
    "corporateAction": {
      "createTitle": "कर्पोरेट कार्यी सिर्जना गर्नुहोस्",
      "editTitle": "कर्पोरेट कार्यी सम्पादन गर्नुहोस्",
      "viewTitle": "कर्पोरेट कार्यी विवरण",
      "section": {
        "identity": "परिचय",
        "dates": "मितिहरू",
        "terms": "शर्त र दरहरू"
      },
      "success": "कर्पोरेट कार्यी सफलतापूर्वक सुरक्षित भयो।",
      "error": "कर्पोरेट कार्यी सुरक्षित गर्न असफल।"
    },
    "organizationProfile": {
      "editTitle": "संस्था प्रोफाइल सम्पादन गर्नुहोस्",
      "viewTitle": "संस्था प्रोफाइल",
      "section": {
        "identity": "संस्था विवरण"
      },
      "success": "संस्था प्रोफाइल सफलतापूर्वक अपडेट भयो।",
      "error": "संस्था प्रोफाइल अपडेट गर्न असफल।"
    },
    "platformModuleAssignment": {
      "createTitle": "मोड्युल असाइन गर्नुहोस्"
    },
    "platformUser": {
      "createTitle": "प्लेटफर्म प्रयोगकर्ता सिर्जना गर्नुहोस्",
      "editTitle": "प्लेटफर्म प्रयोगकर्ता सम्पादन गर्नुहोस्",
      "viewTitle": "प्लेटफर्म प्रयोगकर्ता हेर्नुहोस्"
    },
    "chooseFile": "फाइल छान्नुहोस्",
    "removeFile": "फाइल हटाउनुहोस्"
  },
  "openingCutover": {
    "history": {
      "title": "खोलिने कटओभर इतिहास"
    },
    "fields": {
      "journalLines": "प्रारम्भिक जर्नल लाइन",
      "cutoverDate": "कटओभर मिति",
      "supersedesBatchId": "प्रतिस्थापन गरिने ब्याच",
      "lots": "प्रारम्भिक पोजिसन लट",
      "cash": "प्रारम्भिक नगद मौज्दात",
      "receivables": "प्रारम्भिक प्राप्य रकम",
      "status": "अवस्था",
      "version": "संस्करण",
      "manifestHash": "म्यानिफेस्ट ह्यास",
      "journalEntryId": "जर्नल प्रविष्टि",
      "supersededByBatchId": "प्रतिस्थापन ब्याच",
      "previewedBy": "पूर्वावलोकन गर्ने",
      "approvedBy": "स्वीकृत गर्ने",
      "approvedAt": "स्वीकृत समय",
      "createdAt": "सिर्जना समय",
      "updatedAt": "अद्यावधिक समय"
    },
    "help": {
      "journalLines": "कम्तीमा दुई प्रारम्भिक जर्नल पङ्क्ति थप्नुहोस्। प्रत्येक पङ्क्तिको प्रयोग नभएको पक्षमा शून्य राख्नुहोस्; कुल डेबिट र क्रेडिट बराबर हुनुपर्छ।",
      "cutoverDate": "प्रभावकारी प्रारम्भिक मिति। यो उपलब्ध लेखा अवधिभित्र हुनुपर्छ।",
      "supersedesBatchId": "यो प्रतिस्थापन स्वीकृत हुँदा उल्टाइने वैकल्पिक स्वीकृत ब्याच।",
      "lots": "प्रत्येक प्रारम्भिक स्थितिलाई ग्राहक, वैकल्पिक पोर्टफोलियो, उपकरण, सटीक परिमाण, कुल लागत र खरिद मितिसहित छुट्टै पङ्क्तिमा थप्नुहोस्।",
      "cash": "प्रत्येक ग्राहक वा पोर्टफोलियो नगद मौज्दातलाई मुद्रा र सटीक रकमसहित छुट्टै पङ्क्तिमा थप्नुहोस्।",
      "receivables": "प्रत्येक प्रारम्भिक प्राप्यलाई ग्राहक, वैकल्पिक पोर्टफोलियो, प्राप्य प्रकार, मुद्रा, सटीक रकम र वैकल्पिक भुक्तानी मितिसहित थप्नुहोस्।",
      "status": "हालको पूर्वावलोकन, स्वीकृति वा उल्ट्याउने अवस्था।",
      "version": "अपरिवर्तनीय जीवनचक्र अभिलेखको आशावादी लक संस्करण।",
      "manifestHash": "प्रमाणित प्रारम्भिक म्यानिफेस्टको निर्धारक फिङ्गरप्रिन्ट।",
      "journalEntryId": "कटओभर स्वीकृत हुँदा सिर्जना भएको लेखा जर्नल।",
      "supersededByBatchId": "यस ब्याचलाई प्रतिस्थापन गर्ने स्वीकृत ब्याच।",
      "previewedBy": "म्यानिफेस्ट प्रमाणित र पूर्वावलोकन गर्ने प्रयोगकर्ता।",
      "approvedBy": "कटओभर स्वीकृत गर्ने फरक अधिकृत प्रयोगकर्ता।",
      "approvedAt": "कटओभर परमाणविक रूपमा लागू भएको समय।",
      "createdAt": "पूर्वावलोकन ब्याच सिर्जना भएको समय।",
      "updatedAt": "जीवनचक्र अभिलेख अन्तिम पटक परिवर्तन भएको समय।"
    },
    "columns": {
      "ledgerAccountId": "लेजर खाता",
      "debit": "डेबिट",
      "credit": "क्रेडिट",
      "clientAccountId": "ग्राहक खाता",
      "portfolioAccountId": "पोर्टफोलियो खाता",
      "instrumentSymbol": "उपकरण",
      "quantity": "परिमाण",
      "totalCost": "कुल लागत",
      "acquisitionDate": "खरिद मिति",
      "currency": "मुद्रा",
      "amount": "रकम",
      "receivableType": "प्राप्य प्रकार",
      "dueDate": "भुक्तानी मिति",
      "narration": "विवरण"
    },
    "collections": {
      "journalLines": {
        "add": "जर्नल पङ्क्ति थप्नुहोस्",
        "empty": "कुनै प्रारम्भिक जर्नल पङ्क्ति थपिएको छैन।",
        "item": "जर्नल पङ्क्ति {{index}}"
      },
      "remove": "पङ्क्ति हटाउनुहोस्",
      "lots": {
        "add": "स्थिति थप्नुहोस्",
        "empty": "कुनै प्रारम्भिक स्थिति थपिएको छैन।",
        "item": "स्थिति {{index}}"
      },
      "cash": {
        "add": "नगद मौज्दात थप्नुहोस्",
        "empty": "कुनै प्रारम्भिक नगद मौज्दात थपिएको छैन।",
        "item": "नगद मौज्दात {{index}}"
      },
      "receivables": {
        "add": "प्राप्य थप्नुहोस्",
        "empty": "कुनै प्रारम्भिक प्राप्य थपिएको छैन।",
        "item": "प्राप्य {{index}}"
      }
    },
    "actions": {
      "restate": "सुरुको कटओभर पुनः विवरण गर्नुहोस्",
      "reverse": "सुरुको कटओभर उल्टाउनुहोस्",
      "history": "कटओभर इतिहास हेर्नुहोस्",
      "preview": "प्रमाणित गरी पूर्वावलोकन गर्नुहोस्",
      "approve": "कटओभर स्वीकृत गर्नुहोस्"
    },
    "messages": {
      "restateSuccess": "सुरुको कटओभर सफलतापूर्वक पुनः विवरण गरियो।",
      "reverseSuccess": "सुरुको कटओभर सफलतापूर्वक उल्टाइयो।",
      "previewSuccess": "प्रारम्भिक कटओभर प्रमाणित गरी पूर्वावलोकन गरियो।",
      "approveSuccess": "प्रारम्भिक कटओभर स्वीकृत गरी लागू गरियो।"
    },
    "restate": {
      "message": "के तपाईं यो सुरुको कटओभर पुनः विवरण गर्न निश्चित हुनुहुन्छ?",
      "title": "सुरुको कटओभर पुनः विवरण गर्नुहोस्"
    },
    "reverse": {
      "message": "के तपाईं यो सुरुको कटओभर उल्टाउन निश्चित हुनुहुन्छ?",
      "title": "सुरुको कटओभर उल्टाउनुहोस्"
    },
    "create": {
      "title": "प्रारम्भिक कटओभर पूर्वावलोकन गर्नुहोस्",
      "description": "स्वीकृतिअघि प्रारम्भिक होल्डिङ, नगद, प्राप्य रकम र सन्तुलित प्रारम्भिक जर्नल प्रमाणित गर्नुहोस्। पूर्वावलोकनले आधिकारिक मौज्दात परिवर्तन गर्दैन।"
    },
    "replace": {
      "title": "प्रारम्भिक कटओभर प्रतिस्थापन गर्नुहोस्",
      "description": "यस ब्याचको अपरिवर्तनीय प्रतिस्थापन सिर्जना गर्नुहोस्। स्वीकृत भएपछि पुरानो ब्याच उल्टाइन्छ र नयाँ ब्याच परमाणविक रूपमा लागू हुन्छ।"
    },
    "view": {
      "title": "प्रारम्भिक कटओभर विवरण",
      "description": "नियन्त्रित म्यानिफेस्ट, स्वीकृति अवस्था, जर्नल सम्बन्ध, वंशावली र अडिट समय समीक्षा गर्नुहोस्।"
    },
    "approve": {
      "title": "प्रारम्भिक कटओभर स्वीकृत गर्ने?",
      "message": "यसले प्रारम्भिक होल्डिङ, नगद, प्राप्य रकम र सन्तुलित जर्नल परमाणविक रूपमा सिर्जना गर्छ। स्वीकृत गर्ने प्रयोगकर्ता पूर्वावलोकन गर्नेभन्दा फरक हुनुपर्छ।"
    },
    "sections": {
      "scope": {
        "title": "कटओभर दायरा",
        "description": "लेखा मिति छान्नुहोस् र यस ब्याचले प्रतिस्थापन गर्ने पूर्वावलोकन पहिचान गर्नुहोस्।"
      },
      "positions": {
        "title": "प्रारम्भिक स्थिति",
        "description": "प्रत्येक ग्राहक र पोर्टफोलियो लटको सटीक परिमाण, लागत र खरिद मिति प्रविष्ट गर्नुहोस्।"
      },
      "cash": {
        "title": "नगद र प्राप्य",
        "description": "प्रमाण स्पष्ट राख्न प्रारम्भिक नगद मौज्दात र प्राप्य रकम छुट्टाछुट्टै अभिलेख गर्नुहोस्।"
      },
      "journal": {
        "title": "प्रारम्भिक जर्नल",
        "description": "कम्तीमा दुई जर्नल पङ्क्ति प्रविष्ट गर्नुहोस्। पूर्वावलोकनअघि डेबिट र क्रेडिट बराबर हुनुपर्छ।"
      }
    },
    "columnHelp": {
      "clientAccountId": "अधिकृत ग्राहक खाता सन्दर्भ प्रयोग गर्नुहोस्।",
      "portfolioAccountId": "ग्राहक खाताभित्रको वैकल्पिक पोर्टफोलियो दायरा।",
      "instrumentSymbol": "मानक उपकरण संकेत।",
      "quantity": "सटीक प्रारम्भिक परिमाण; दशमलव शुद्धता सुरक्षित रहन्छ।",
      "totalCost": "यो प्रारम्भिक लटको कुल खरिद लागत।",
      "acquisitionDate": "होल्डिङ अवधि प्रमाणका लागि मूल खरिद मिति।",
      "currency": "तीन अक्षरको ISO मुद्रा कोड।",
      "amount": "सटीक प्रारम्भिक रकम।",
      "receivableType": "लेखांकनले प्रयोग गर्ने मानक प्राप्य वर्गीकरण।",
      "dueDate": "वैकल्पिक अपेक्षित भुक्तानी मिति।",
      "ledgerAccountId": "यो जर्नल पङ्क्ति प्राप्त गर्ने अधिकृत लेजर खाता।",
      "debit": "डेबिट रकम; क्रेडिट पङ्क्ति भए शून्य राख्नुहोस्।",
      "credit": "क्रेडिट रकम; डेबिट पङ्क्ति भए शून्य राख्नुहोस्।",
      "narration": "वैकल्पिक पङ्क्ति-स्तर विवरण।"
    }
  },
  "common": {
    "loading": "लोड हुँदै...",
    "amount": "रकम",
    "AAL_INSUFFICIENT": "थप प्रमाणीकरण आवश्यक छ।",
    "planned": "यो सुविधा योजनाबद्ध छ र अहिलेसम्म उपलब्ध छैन।",
    "locked": "पहुँच प्रतिबन्धित",
    "maintenance": "अस्थायी रूपमा अनुपलब्ध",
    "error": {
      "unexpected": "एक अप्रत्याशित त्रुटि भयो",
      "description": "अपहरण वर्णन",
      "title": "त्रुटि",
      "stackTrace": "स्टैक ट्रेस",
      "tryAgain": "पुन: प्रयास गर्नुहोस्",
      "contactSupport": "सहायताका लागि सम्पर्क गर्नुहोस्",
      "reportDisplayError": "प्रदर्शन अनुप्रयोग रिपोर्ट",
      "insufficientPermission": "तपाईंलाई यो कार्य गर्ने अनुमति छैन।",
      "fetchFailed": "डेटा लोड गर्न विफल रहा।",
      "fetchProfileFailed": "प्रोफाइल डेटा लोड गर्न विफल रहा।",
      "fetchNavigationFailed": "नेविगेशन डेटा लोड गर्न विफल रहा।"
    },
    "errorTitle": "कुछ गलत हुआ",
    "retry": "पुन: प्रयास गर्नुहोस्",
    "emptyTitle": "अहिलेसम्म देखाउन केही छैन",
    "permissionDeniedTitle": "पहुँच अनुमति दिइएको छैन",
    "permissionDeniedDescription": "तपाईंलाई यो वित्तीय सत्र हेर्ने अनुमति छैन।",
    "staleDataTitle": "डेटा पुरानो हुन सक्छ",
    "staleDataDescription": "नयाँ र अद्यावधिक मूल्यहरू पुन: लोड वा आयात गर्नुहोस् ताकि यसमा भर गर्न सकियोस्।",
    "unsavedChangesPrompt": "तपाईंसँग बचत नगरिएका परिवर्तनहरू छन्। के तपाईं यो पृष्ठ छोड्न निश्चित हुनुहुन्छ?",
    "sectionUnavailable": "विभाग अनुपलब्ध।",
    "errorBoundary": {
      "unexpectedError": "असामान्य अपहरण",
      "errorInSection": "{{section}} विभाग मा एक अपहरण हुआ।",
      "application": "अनुप्रयोग",
      "errorDetails": "अपेक्षा अनुपलाब्य न भएको विवरण",
      "tryAgain": "पुनः प्रयास गर्नु",
      "authError": "स्वीकृति त्रुटी",
      "authErrorDescription": "स्वीकृति प्रणाली लोड गर्ने मागे तपशील दिने हो सकेन। पुनः पृष्ठभूमि गर्नु.",
      "refreshPage": "पृष्ठ रिफ्रेस गर्नुहोस्",
      "dashboardError": "डैशबोर्ड त्रुटी",
      "unableToLoadDashboard": "डैशबोर्ड डेटा लोड गर्न न सक्यो.",
      "reloadDashboard": "डैशबोर्ड रिलोड गर्नु",
      "portfolioError": "पोर्टफोलियो त्रुटी",
      "unableToLoadPortfolio": "पोर्टफोलियो डेटा लोड गर्न न सक्यो.",
      "reloadPortfolio": "पोर्टफोलियो रिलोड गर्नु",
      "transactionError": "व्यापार त्रुटी",
      "unableToLoadTransactions": "व्यापार डेटा लोड गर्न न सक्यो,.",
      "reloadTransactions": "व्यापार रिलोड गर्नु",
      "adminError": "अधिकारिक पैनल त्रुटी",
      "unableToLoadAdmin": "अधिकारिक पैनल लोड गर्न न सक्यो.",
      "reloadAdmin": "अधिकारिक पैनल रिलोड गर्नु",
      "reportsError": "रिपोर्ट त्रुटी",
      "unableToLoadReports": "रिपोर्ट डेटा लोड गर्न न सक्यो.",
      "reloadReports": "रिपोर्ट रिलोड गर्नु"
    },
    "dataTable": {
      "noRowsToDisplay": "प्रदर्शन गर्न कुनै पङ्क्ति छैन"
    },
    "financeHelpPanel": {
      "howItWorks": "कसे काम गर्छ?"
    },
    "dashboard": {
      "widgets": {
        "marketValue": "बजार मूल्य",
        "costBasis": "लागत आधार",
        "unrealizedGain": "अवास्तविक लाभ/हानि",
        "realizedGain": "वास्तविक लाभ/हानि",
        "totalGainLoss": "कुल लाभ/हानि",
        "capitalGainTax": "पूँजीगत लाभ कर",
        "returnOnCost": "लागतमा प्रतिफल",
        "taxProvenanceCoverage": "कर प्रमाणिकरण कभरेज",
        "nfrsEvidence": "NFRS प्रमाण"
      }
    },
    "accountNumber": "खाता नम्बर",
    "actionType": "कार्य प्रकार",
    "asOfDate": "मिति अनुसार",
    "availableQuantity": "उपलब्ध मात्रा",
    "avgCost": "औसत लागत",
    "boId": "बीओ आईडी",
    "breachType": "उल्लङ्घन प्रकार",
    "breachValue": "उल्लङ्घन मूल्य",
    "severity": "गम्भीरता",
    "calculationVersion": "गणना संस्करण",
    "capitalGain": "पूँजीगत लाभ",
    "change": "परिवर्तन",
    "clientAccountId": "ग्राहक खाता",
    "clientCode": "ग्राहक कोड",
    "clientName": "ग्राहक नाम",
    "clientType": "ग्राहक प्रकार",
    "completedAt": "पूरा भएको समय",
    "concentrationPct": "एकाग्रता %",
    "costBasis": "लागत आधार",
    "createdAt": "सिर्जना गरिएको समय",
    "currency": "मुद्रा",
    "detectedAt": "पत्ता लागेको समय",
    "displayName": "नाम",
    "dpCode": "DP कोड",
    "endDate": "अन्तिम मिति",
    "entityId": "इकाई ID",
    "entityType": "इकाई प्रकार",
    "errorCount": "त्रुटिहरू",
    "exDate": "बहिष्करण मिति",
    "exchange": "एक्सचेन्ज",
    "fiscalYear": "आर्थिक वर्ष",
    "fiscalYearName": "आर्थिक वर्ष",
    "holdingPeriodDays": "होल्डिङ अवधि दिन",
    "id": "आईडी",
    "importType": "आयात प्रकार",
    "instrumentId": "इन्स्ट्रुमेन्ट ID",
    "instrumentName": "इन्स्ट्रुमेन्ट नाम",
    "instrumentSymbol": "इन्स्ट्रुमेन्ट संकेत",
    "instrumentType": "इन्स्ट्रुमेन्ट प्रकार",
    "isActive": "सक्रिय",
    "isDefault": "पूर्वनिर्धारित",
    "isLocked": "लक गरिएको",
    "isSystem": "प्रणाली",
    "isin": "ISIN",
    "journalDate": "जर्नल मिति",
    "kind": "प्रकार",
    "lastUpdated": "अन्तिम अद्यावधिक",
    "limitValue": "सीमा मूल्य",
    "marketPrice": "बजार मूल्य",
    "valuationAsOf": "मूल्याङ्कन मिति",
    "valuationFreshness": "ताजा",
    "valuationSource": "मूल्याङ्कन स्रोत",
    "unrealizedGainLoss": "अप्राप्त नाफा / नोक्सान",
    "marketValue": "बजार मूल्य",
    "marketValueCurrency": "मुद्रा",
    "matchedRecords": "मिलेका रेकर्ड",
    "membershipStatus": "सदस्यता स्थिति",
    "mfaEnabled": "MFA सक्षम",
    "ownerType": "स्वामी प्रकार",
    "payDate": "भुक्तानी मिति",
    "periodNumber": "अवधि नम्बर",
    "portfolioAccountId": "पोर्टफोलियो खाता",
    "quantity": "मात्रा",
    "realizedGain": "वास्तविक लाभ",
    "recordCount": "रेकर्डहरू",
    "recordDate": "रेकर्ड मिति",
    "reference": "सन्दर्भ",
    "riskMeasure": "जोखिम मापन",
    "roles": "भूमिकाहरू",
    "ruleId": "नियम ID",
    "ruleVersion": "नियम संस्करण",
    "runId": "रन ID",
    "saleDate": "बिक्री मिति",
    "sector": "क्षेत्र",
    "securityName": "सुरक्षा नाम",
    "sourceAuthority": "स्रोत प्राधिकरण",
    "sourceBatchId": "स्रोत ब्याच",
    "sourceBook": "स्रोत पुस्तक",
    "sourceFileName": "स्रोत फाइल",
    "sourceState": "स्रोत स्थिति",
    "startDate": "सुरुवात मिति",
    "startedAt": "सुरु भएको समय",
    "symbol": "संकेत",
    "taxAmount": "कर रकम",
    "taxDomain": "कर डोमेन",
    "taxRate": "कर दर",
    "branchId": "शाखा ID",
    "totalCost": "कुल लागत",
    "totalCredit": "कुल क्रेडिट",
    "totalDebit": "कुल डेबिट",
    "totalQuantity": "कुल मात्रा",
    "totalRecords": "कुल",
    "unmatchedRecords": "नमिलेका रेकर्ड",
    "unrealizedGain": "अवास्तविक लाभ",
    "unrealizedPnl": "अवास्तविक P&L",
    "userEmail": "प्रयोगकर्ता इमेल",
    "userTypeId": "प्रयोगकर्ता प्रकार",
    "warningCount": "चेतावनीहरू",
    "weightedAverageCost": "भारित औसत लागत",
    "commission": "कमिशन",
    "dpCharge": "DP शुल्क",
    "otherCharges": "अन्य शुल्क",
    "price": "मूल्य",
    "sebonFee": "SEBON शुल्क",
    "tradeDate": "व्यापार मिति",
    "transactionType": "व्यापार प्रकार",
    "success": "सफलता",
    "cancel": "बाट्ना रद्द कर",
    "confirm": "सहमति द्यो",
    "save": "बचाव",
    "saveSuccess": "सफलतापूर्वक सुरक्षित गरियो",
    "delete": "मेटाउनुहोस्",
    "edit": "सम्पादन गर्नुहोस्",
    "view": "हेर्नुहोस्",
    "create": "सिर्जना",
    "update": "अद्यावधिक गर्नुहोस्",
    "submit": "नियुक्त कर",
    "back": "पछाडि",
    "next": "पछिल्लो",
    "previous": "अघिल्लो",
    "close": "बन्द",
    "search": "खोज",
    "clearSearch": "खोज क्लियर कर",
    "show": "दिखाउने",
    "hide": "छिप्ने",
    "bullet": "•",
    "name": "नाम",
    "description": "विवरण",
    "module": "मोड्युल",
    "filter": "फिल्टर",
    "sort": "क्रमबद्ध",
    "export": "निर्यात",
    "import": "आयात",
    "download": "डाउनलोड",
    "upload": "अपलोड",
    "refresh": "रिफ्रेस गर्नुहोस्",
    "actions": {
      "label": "कार्यहरू",
      "export": "निर्यात",
      "exportDesc": "निर्यात",
      "viewDetails": "विवरण हेर्नुहोस्",
      "available": "उपलब्ध कार्यहरू"
    },
    "details": "विवरण",
    "settings": "सेटिङ्स",
    "unknown": "अज्ञात",
    "notAvailable": "लागू हुँदैन",
    "help": "सहायता",
    "about": "बारे मा",
    "version": "संस्करण",
    "language": "भाषा",
    "theme": "थीम",
    "logout": "निकाल्नु",
    "login": "लॉगिन",
    "signup": "प्रतिष्ठान निर्माण कर",
    "forgotPassword": "पासवर्ड भूल्यो?",
    "resetPassword": "पासवर्ड रिसेट गर्नुहोस्",
    "changePassword": "पासवर्ड बदल",
    "profile": "प्रोफाइल",
    "account": "खाता",
    "preferences": "सेटिङहरू",
    "notifications": "सूचनाहरू",
    "security": "सुरक्षा",
    "privacy": "निजता",
    "hubCatalog": {
      "emptyTitle": "कुनै हबहरू उपलब्ध छैन",
      "labelUnavailable": "शीर्षक उपलब्ध छैन"
    },
    "unifiedTable": {
      "of": "मध्ये",
      "records": "रेकर्डहरू",
      "items": "वस्तुहरू",
      "searchPlaceholder": "खोज...",
      "pageOf": "पृष्ठ {{page}} मध्ये {{totalPages}}",
      "noRowsToDisplay": "दृश्यमान विवरण नाही",
      "selectAllRows": "सबस्ता सब रोअर्स चुन",
      "filterByColumn": "कलम द्वारे फिल्टर कर",
      "selectRowNumber": "रोअर नंबर चुन",
      "total": "कुल",
      "previousPage": "पिछला पृष्ठ",
      "nextPage": "आगे का पृष्ठ",
      "editRecord": "रिकॉर्ड संपादित कर",
      "openRecordDetails": "रिकॉर्ड विवरण खोल"
    },
    "terms": "प्रतिष्ठान नियम",
    "privacyPolicy": "गोपनीयता नीति",
    "termsOfService": "सेवा शर्तहरू",
    "cookiePolicy": "कुकी नीति",
    "accessDenied": "पहुँच अस्वीकृत",
    "unauthorizedAccess": "अनधिकृत पहुँच",
    "noPermission": "तपाईंलाई यो पृष्ठको सामग्रीमा पहुँच गर्ने अधिकार छैन। यदि यो गल्ती हो भन्ने लाग्छ भने, कृपया आफ्नो प्रशासकसँग सम्पर्क गर्नुहोस्।",
    "goToHome": "घर जाएँ",
    "goBack": "पीछे वापस जाएँ",
    "pageNotFound": "पृष्ठ नोट फ़ॉन्ड",
    "pageNotFoundDescription": "तपाईं खोज्दै हुनुभएको पृष्ठ छैन वा स्थान परिवर्तन भएको छ।",
    "errorState": {
      "authenticationRequired": "साइन इन करने की आवश्यकता छ",
      "pleaseLogin": "कृपया यो स्रोतमा पहुँच गर्न लगइन गर्नुहोस्।",
      "refreshPage": "पृष्ठ रिफ्रेस गर्नुहोस्",
      "serviceUnavailable": "सेवा उपलब्ध छैन छ",
      "serviceUnavailableDescription": "सेवा कुछ समय के लिए असमर्थ छ। कृपया पुन: प्रयास गर्नुहोस्.",
      "noResults": "कुनै परिणाम देखिएनन्",
      "noResultsDescription": "इस दृष्टिकोण के लिए कोई डेटा उपलब्ध छैन।",
      "partialDataFailure": "केही डेटा लोड हुन असफल",
      "partialDataFailureDescription": "पृष्ठ आंशिक रूपमा स्थिर छ। कृपया पुन: प्रयास गर्नुहोस्।",
      "dataQualityWarning": "डाटा गुणस्तर चेतावनी",
      "dataQualityWarningDescription": "डेटा गुणस्तर समस्याहरू पाइएका छन्। परिणामहरू अपूर्ण हुन सक्छन्।",
      "systemError": "सिस्टम त्रुटि",
      "systemErrorDescription": "अनपेक्षित त्रुटि हुई। कृपया पुन: प्रयास गर्नुहोस्।",
      "networkError": "नेटवर्क त्रुटि - सर्वर तक पहुँचने मा असमर्थ",
      "authenticationRequiredShort": "प्रमाणीकरण आवश्यक छ",
      "accessDeniedShort": "पहुँच अनुमति दिइएको छैन",
      "serviceUnavailableShort": "सेवा केही समयका लागि अनुपलब्ध छ",
      "unexpectedError": "एक अप्रत्याशित त्रुटि भयो"
    },
    "available": "उपलब्ध",
    "checking": "जाँच हुँदैछ",
    "live": "प्रत्यक्ष",
    "home": "होम",
    "data": "डाटा",
    "operations": "कार्य",
    "reports": "रिपोर्टहरू",
    "admin": "प्रशासन",
    "saving": "बचत गर्दै…",
    "status": {
      "active": "सक्रिय",
      "inactive": "निष्क्रिय",
      "warning": "चेतावनी",
      "error": "त्रुटि",
      "success": "सफलता"
    },
    "email": "इमेल",
    "phone": "फोन",
    "address": "गल्ली ठेगाना",
    "notes": "आन्तरिक टिप्पणीहरू (ग्राहकलाई देखिँदैन)",
    "optional": "वैकल्पिक",
    "dismissNotification": "सूचना खारेज गर्नुहोस्",
    "dismiss": "खारेज गर्नुहोस्",
    "prompt": {
      "enterValue": "मान्यता देने की आवश्यकता छ",
      "enterReason": "कारण भर्नुहोस्"
    },
    "filters": {
      "field": "क्षेत्र",
      "operator": "ऑपरेटर",
      "min": "न्यूनतम",
      "max": "सीमित",
      "value": "मान"
    },
    "conditionBuilder": {
      "condition": "शर्त",
      "conditions": "शर्त",
      "addCondition": "शर्त जोड़",
      "noConditionsAdded": "कुनै सर्त थपिएको छैन"
    },
    "dataFreshness": {
      "ariaLabel": "प्रशासक नेभिगेसन"
    },
    "degradedState": {
      "dataQuality": "डाटा गुणस्तर",
      "error": "विलंबित राज्य त्रुटि",
      "warning": "विलंबित राज्य सूचना",
      "issue": "मुद्दा",
      "issues": "समस्याहरू",
      "detected": "पत्ता लाग्यो",
      "treatAsDiagnostic": "आधारिक निदान के रूप मा संभालें",
      "hideDetails": "विवरण लुकाउनुहोस्",
      "showDetails": "विवरण देखाउनुहोस्",
      "dataQualityOk": "डेटा गुणवत्ता ठीक हो"
    },
    "drawers": {
      "closeDrawer": "ड्रॉअर बंद कर्न",
      "auditLog": "ऐतिहासिक लेख",
      "loadingAuditEntries": "ऐतिहासिक प्रविष्टिहरू लोड हुँदैछ",
      "noAuditEntries": "कोई ऐतिहासिक लेख नही छ",
      "by": "द्वारा",
      "evidence": "साक्ष्य",
      "evidenceDescription": "साक्ष्य विवरण",
      "loadingEvidence": "प्रमाण लोड हुँदैछ",
      "noEvidenceItems": "कोई साक्ष्य वस्तु नही छ",
      "openEvidence": "साक्ष्य खोल्न",
      "dataLineage": "डाटा लाइनएज",
      "lineageForField": "क्षेत्र के लिए शृंखला",
      "lineageDescription": "शृंखला विवरण",
      "loadingLineage": "शृंखला लोड हुँदैछ",
      "noLineageInfo": "कोई शृंखला जानकारी नही छ",
      "produces": "उत्पादित गरिएको छ",
      "rowDetailTitle": "रो डिटेल टाइटल",
      "rowDetail": "रो डिटेल",
      "primaryFields": "प्राथमिक क्षेत्र",
      "secondaryFields": "सेकेंडरी क्षेत्र",
      "technicalFields": "प्रौद्योगिकी क्षेत्र"
    },
    "groupedTable": {
      "noRowsToDisplay": "नमुना प्रदर्शन मा कोई रो छैन",
      "expandAll": "सब कुछ खोल",
      "collapseAll": "सब कुछ बंद कर",
      "group": "समूह",
      "groups": "समूह",
      "totalItems": "कुल वस्तु"
    },
    "hubTabs": {
      "noContentAvailable": "नमुना उपलब्ध छैन छ"
    },
    "marketFreshness": {
      "quotedTitle": "उद्धृत",
      "pricesAsOf": "मूल्य की तिथि से",
      "marketPricesCurrent": "वर्तमान बाजार मूल्य",
      "mixedTitle": "मिश्रित",
      "partialQuotesAsOf": "केवल पूर्ण नमुना की तिथि से",
      "partialMarketCoverage": "बाजार की कवरेज केवल छ",
      "costBasisTitle": "लागत आधार",
      "costBasisOnly": "मूल्य आधार केवल छ",
      "partialMarketData": "केवल बाजार डेटा छ"
    },
    "moduleGuard": {
      "moduleNotAvailable": "प्रोग्राम उपलब्ध छैन छ",
      "moduleNotEnabled": "प्रोग्राम सक्षम छैन"
    },
    "networkStatus": {
      "offlineMessage": "ऑनलाइन न होने की संदेश",
      "connection": "संचार"
    },
    "tableToolbar": {
      "filter": "फिल्टर",
      "filters": "फिल्टर",
      "filterPlaceholder": "फिल्टर कर्नाला",
      "clearFilters": "फिल्टर खाली गर्नुहोस्",
      "clearSearch": "सोधी साफ कर्नाला",
      "activeFilters": "कार्यान्वित फिल्टर",
      "clearAll": "सब कुछ साफ कर्नाला",
      "compact": "संक्षिप्त",
      "comfortable": "आनंददायक",
      "groupBy": "समूह बनाउने",
      "sort": "क्रमबद्ध",
      "sortBy": "यस अनुसार क्रमबद्ध",
      "columns": "स्तम्भहरू",
      "visibleColumns": "देखिने स्तम्भहरू",
      "none": "कुनै पनि",
      "export": "अपशिष्ट कर्नाला",
      "clearFilter": "फिल्टर साफ कर्नाला"
    },
    "all": "सबै",
    "table": {
      "resizeColumn": "स्तम्भ परिवर्तन गर्नुहोस्",
      "actions": "कार्यहरू",
      "moreActions": "थप कार्यहरू",
      "selectRow": "रोइँको चुन्नाला",
      "collapseDetails": "विस्तार नपाउनाला",
      "expandDetails": "विस्तार कर्नाला",
      "showLess": "देखी जाने हुने कुर्सी कम कर्नाला",
      "showMore": "देखी जाने हुने कुर्सी बढ़ानाला",
      "globalSearch": {
        "placeholder": "खोज..."
      },
      "clearFilters": "फिल्टर साफ कर्नाला",
      "groupBy": "समूह र कुल",
      "sum": "कुल",
      "showFilterRow": "फिल्टर रोइँको दिखाउनाला",
      "hideFilterRow": "फिल्टर रोइँको छुपाउनाला",
      "showFilters": "फिल्टर दिखाउनाला",
      "hideFilters": "फिल्टर छुपाउनाला",
      "columns": "स्तम्भहरू",
      "searchColumns": "पश्चिमा खोज क्षेत्र",
      "pinnedLeft": "पश्चिमी पक्ष",
      "pinnedRight": "पश्चिमी पक्ष",
      "showAll": "सबै प्रकार",
      "hideOptional": "अनावश्यक को लुकाउनुहोस्",
      "resetLayout": "लेइट सेट करे",
      "densityLabel": "घनता",
      "density": {
        "compact": "संक्षिप्त",
        "standard": "प्रमाणित",
        "comfortable": "अनुकूल"
      },
      "refresh": "रिफ्रेस गर्नुहोस्",
      "exportLabel": "निकाल",
      "export": {
        "scope": "निकास का व्यापक",
        "currentPage": "वर्तमान पृष्ठ",
        "selectedRows": "चुनी हुई रो",
        "allMatching": "सबै मेल खाने हुने",
        "configureSchema": "स्किमा परिभाषित गर्नुहोस्",
        "availableFields": "उपलब्ध क्षेत्रहरू",
        "schemaFields": "निर्यात स्किमा",
        "schemaHelp": "उपलब्ध सूचीबाट क्षेत्रहरूलाई निर्यात स्थानहरूमा तान्नुहोस् र स्लटहरूबीच तानेर पुन:क्रम मिलाउनुहोस्।",
        "position": "निर्यात स्तम्भ {{position}}",
        "dropField": "क्षेत्र यहाँ छोड्नुहोस्",
        "included": "समावेश गरिएको",
        "available": "उपलब्ध",
        "resetSchema": "स्किमा रिसेट गर्नुहोस्",
        "applySchema": "स्किमा लागू गर्नुहोस्",
        "selectAll": "सबै चयन गर्नुहोस्",
        "deselectAll": "सबै चयन हटाउनुहोस्",
        "fieldsSelected": "{{total}} मध्ये {{selected}} क्षेत्र चयनित",
        "help": "निर्यातमा समावेश गरिने क्षेत्रहरु छान्नुहोस्।",
        "visibleFields": "देखिने क्षेत्रहरु"
      },
      "bulkActions": "मात्रा कार्य",
      "rowSelected": "रो चयनित",
      "rowsSelected": "रो चयनित",
      "savedViews": "भंडारण दृश्य",
      "saveViewAs": "दृश्य को सेवा के रूप में",
      "unsavedChanges": "अपडेट न गरिएका परिवर्तन",
      "resetFilters": "फिल्टर रीसेट कर",
      "resetAll": "सब कुछ रीसेट कर",
      "resultsCount": "{{count}} परिणाम",
      "perPage": "प्रति पृष्ठ",
      "rowsPerPage": "पृष्ठ/परिणाम",
      "pageInfo": "{{start}}–{{end}} / {{total}}",
      "pageOf": "पृष्ठ {{current}} of {{total}}",
      "firstPage": "प्रथम पृष्ठ",
      "previousPage": "पिछला पृष्ठ",
      "nextPage": "आगे का पृष्ठ",
      "lastPage": "अंतिम पृष्ठ",
      "collapseGroup": "समूह को संकुचित कर",
      "expandGroup": "समूह को विस्तारित कर",
      "aggregates": "जम्मा: {{value}}",
      "row": "पंक्ति",
      "rows": "पृष्ठ",
      "group": {
        "nullValue": "कुनै पनि"
      },
      "loading": "ग्राहक खाताहरू लोड गर्दै…",
      "viewOptions": "दृश्य विकल्पहरू",
      "emptyState": {
        "readOnlyHint": "यो डाटा कारोबार र प्रारम्भिक मौजदाबीबाट प्राप्त हुन्छ। यसलाई भर्न कारोबार पोस्ट गर्नुहोस् वा प्रारम्भिक मौजदाबी आयात गर्नुहोस्।"
      }
    },
    "upgradePrompt": {
      "featureNotAvailable": "विशेषता उपलब्ध छैन छ",
      "featureNotAvailableInPlan": "विशेषता योजना मा उपलब्ध छैन छ",
      "feature": "विशेषता"
    },
    "errorLabel": "त्रुटि",
    "failedToLoadData": "डेटा लोड गर्न विफल रहा",
    "unknownError": "अपेक्षित त्रुटि",
    "clear": "साफ़ गर्नुहोस्",
    "apply": "लागू गर्नुहोस्",
    "yes": "हो",
    "no": "होइन",
    "listSeparator": "तालिका विभाजनकारी",
    "enabled": "सक्षम",
    "disabled": "अक्षम",
    "ok": "ठीक",
    "unavailable": "अनुपलब्ध",
    "configurationMismatchTitle": "निर्धारण असंगति",
    "configurationMismatchShort": "निर्धारण असंगति",
    "configurationMismatchDescription": "वर्तमान निर्धारण से अपेक्षित निर्धारण मा मतभेद छ। कृपया समीक्षा गर्नुहोस् और अपने निर्धारण को अद्यावधिक गर्नुहोस्।",
    "unexpectedError": "असामान्य त्रुटि",
    "remove": "हटाउनुहोस्",
    "notAvailableShort": "लागू हुँदैन",
    "system": "प्रणाली",
    "partialData": "कम पूर्ण डेटा",
    "noDataAvailable": "पूरी डेटा उपलब्ध छैन",
    "copy": "कॉपी गर्नुहोस्",
    "copied": "कॉपी गरिएको छ",
    "done": "सम्पन्न",
    "clearFilter": "फिल्टर साफ़ गर्नुहोस्",
    "general": "सामान्य",
    "organization": "संस्था",
    "modules": "मोड्युलहरू",
    "importing": "आयात करने में",
    "none": "कुनै पनि",
    "space": "स्थान",
    "redacted": "रेडैक्ट गरिएको छ",
    "cancelDesc": "बंद गर्नुहोस्",
    "nextDesc": "पछिल्लो",
    "submitDesc": "प्रस्तुत गर्नुहोस्",
    "empty": "खाली",
    "action": {
      "save": "सेभ गर्नुहोस्",
      "edit": "सम्पादन गर्नुहोस्",
      "delete": "निष्क्रिय बनाउनुहोस्",
      "suspend": "निलम्बन गर्नुहोस्",
      "reactivate": "पुन: सक्रिय गर्नुहोस्"
    },
    "assign": "निर्धारित गर्नुहोस्",
    "confirmAction": "सहमति दें",
    "enterReason": "पश्चात्ताप का कारण भर्नुहोस्",
    "reasonRequiredForAction": "कार्रवाई के लिए आवश्यक कारण भर्नुहोस्",
    "reasonPlaceholder": "कारण",
    "loadMore": "अधिक लोड गर्नुहोस्",
    "form": {
      "noOptionsAvailable": "विकल्प उपलब्ध छैन छं",
      "jsonParseError": "निष्पक्ष JSON फॉर्मेट मा त्रुटि छ",
      "requiredField": "आवश्यक क्षेत्र",
      "validationSummary": "प्रस्तुत करने से पहले निम्नलिखित त्रुटियों को ठीक गर्नुहोस्:",
      "reviewTitle": "परिवर्तन समीक्षा गर्नुहोस्",
      "reviewDescription": "नीचे दिए गए विवरण की समीक्षा करने से पहले प्रस्तुत गर्नुहोस्.",
      "edit": "सम्पादन गर्नुहोस्",
      "confirmSubmit": "पुष्टि गर्नुहोस् और भेजें"
    },
    "file": {
      "selected": "चुना हुआ"
    },
    "breadcrumb": "मार्गदर्शक",
    "jobs": "नौकरियाँ",
    "branches": "शाखाहरू",
    "errorShort": "त्रुटि",
    "appName": "वित्तीय प्लेटफ़ॉर्म",
    "welcome": "स्वागत छ",
    "states": {
      "empty": {
        "title": "कुछ छैन दिखाई देता छ",
        "message": "डेटा उपलब्ध छैन।"
      },
      "error": {
        "title": "कुछ गलत हुआ",
        "message": "असामान्य त्रुटि हुई छ।"
      },
      "forbidden": {
        "title": "अपेक्षित पहुँच छैन",
        "message": "आपको इस संसाधन को देखने की अनुमति छैन।"
      },
      "notFound": {
        "title": "छैन पाया गया",
        "message": "मांगे गए संसाधन या मार्ग को फेला परेन।"
      },
      "degraded": {
        "title": "भाग्यशाली डेटा",
        "message": "पूर्ण डेटा दिखाने के लिए पुरानी सेवा के कारण भाग्यशाली डेटा दिखाया जा भइरहेको छ।"
      },
      "stale": {
        "title": "डेटा शुष्क हो सक्छ",
        "message": "डेटा शुष्क हो सक्छ।"
      },
      "planned": {
        "message": "यो गन्तव्य उत्पादन योजनामा छ तर अहिले उपलब्ध छैन।",
        "title": "यो सुविधा तयार हुँदैछ"
      },
      "noResults": {
        "message": "आपके फिल्टर के अनुसार कोई परिणाम फेला परेन।"
      },
      "permissionLimited": {
        "message": "आपको यह डेटा देखने की सीमित अनुमति छ।"
      },
      "offline": {
        "message": "आप ऑनलाइन छैनन्। डेटा शुष्क हो सक्छ।"
      },
      "maintenance": {
        "title": "अस्थायी रूपमा उपलब्ध छैन",
        "message": "यो गन्तव्य मर्मतमा छ। कृपया केही समयपछि पुनः प्रयास गर्नुहोस्।"
      },
      "unavailable": {
        "title": "सुविधा उपलब्ध छैन",
        "message": "यो गन्तव्य हालको संगठन वा उत्पादन कन्फिगरेसनका लागि सक्षम गरिएको छैन।"
      }
    },
    "validation": {
      "required": "यो फिल्ड आवश्यक हो",
      "accepted": "स्वीकार गरिएको हुनुपर्छ",
      "min": "कम्तिमा {{min}} हुनुपर्छ",
      "max": "बढिमा {{max}} हुनुपर्छ",
      "minLength": "कम्तिमा {{min}} अक्षर हुनुपर्छ",
      "maxLength": "बढिमा {{max}} अक्षर हुनुपर्छ",
      "integer": "पूर्णांक हुनुपर्छ",
      "decimalPrecision": "बढिमा {{precision}} दशमलव स्थान हुनुपर्छ",
      "email": "मान्य इमेल ठेगाना हुनुपर्छ",
      "stepIncomplete": "अघि बढ्नु अघि सबै आवश्यक क्षेत्रहरू पूरा गर्नुहोस्।",
      "url": "मान्य URL हुनुपर्छ",
      "pattern": "प्याटर्न {{pattern}} मेल खानुपर्छ",
      "invalidPattern": "अमान्य प्याटर्न: {{pattern}}",
      "allowedValues": "यी मध्ये एक हुनुपर्छ: {{values}}",
      "dateMin": "{{minDate}} वा त्यसपछि हुनुपर्छ",
      "dateMax": "{{maxDate}} वा त्यसभन्दा अघि हुनुपर्छ",
      "fileType": "फाइल प्रकार हुनुपर्छ: {{accepted}}",
      "fileSize": "फाइल {{maxBytes}} बाइटभन्दा सानो हुनुपर्छ",
      "crossField": "{{field}} सँग मेल खानुपर्छ",
      "registeredDomain": "डोमेन यी मध्ये एक हुनुपर्छ: {{domains}}",
      "unknownValidator": "अज्ञात सत्यापनकर्ता: {{ruleId}}"
    },
    "section": {
      "user": {
        "identity": "पहिचान",
        "assignment": "कार्यभार"
      },
      "role": {
        "definition": "भूमिका परिभाषा",
        "permissions": "अनुमतिहरू"
      }
    },
    "field": {
      "role": {
        "name": "नाम",
        "code": "कोड",
        "status": "स्थिति"
      }
    },
    "permissions": {
      "data": {
        "hub": "डाटा हब"
      },
      "admin": {
        "hub": "प्रशासन हब",
        "users": {
          "view": "प्रशासन प्रयोगकर्ताहरू हेर्नुहोस्"
        },
        "user": {
          "create": "प्रशासन प्रयोगकर्ता सिर्जना गर्नुहोस्",
          "update": "प्रशासन प्रयोगकर्ता अद्यावधिक गर्नुहोस्",
          "delete": "प्रशासन प्रयोगकर्ता मेटाउनुहोस्"
        },
        "roles": {
          "view": "प्रशासन भूमिकाहरू हेर्नुहोस्"
        },
        "role": {
          "create": "प्रशासन भूमिका सिर्जना गर्नुहोस्",
          "update": "प्रशासन भूमिका अद्यावधिक गर्नुहोस्",
          "delete": "प्रशासन भूमिका मेटाउनुहोस्"
        },
        "organization": {
          "view": "प्रशासन संगठन हेर्नुहोस्"
        },
        "audit": {
          "view": "प्रशासन अडिट हेर्नुहोस्"
        },
        "auditLog": {
          "view": "प्रशासन अडिट लग हेर्नुहोस्"
        }
      },
      "access": {
        "members": {
          "read": "पहुँच सदस्यहरू पढ्नुहोस्"
        },
        "roles": {
          "read": "पहुँच भूमिकाहरू पढ्नुहोस्",
          "manage": "पहुँच भूमिकाहरू व्यवस्थापन गर्नुहोस्"
        },
        "permissions": {
          "read": "पहुँच अनुमतिहरू पढ्नुहोस्",
          "manage": "पहुँच अनुमतिहरू व्यवस्थापन गर्नुहोस्"
        },
        "membership": {
          "manage": "पहुँच सदस्यता व्यवस्थापन गर्नुहोस्"
        }
      },
      "auth": {
        "context": {
          "switch": "प्राधिकरण सन्दर्भ बदल्नुहोस्"
        },
        "logout": "साइन आउट गर्नुहोस्",
        "profile": {
          "read": "प्रमाणीकरण प्रोफाइल पढ्नुहोस्"
        },
        "password": {
          "change": "प्रमाणीकरण पासवर्ड परिवर्तन गर्नुहोस्"
        },
        "sessions": "प्रमाणीकरण सत्रहरू"
      },
      "navigation": {
        "read": "नेभिगेसन पढ्नुहोस्"
      },
      "platform": {
        "organizations": {
          "list": "प्लेटफर्म संगठनहरू सूचीबद्ध गर्नुहोस्",
          "read": "प्लेटफर्म संगठन पढ्नुहोस्",
          "create": "प्लेटफर्म संगठन सिर्जना गर्नुहोस्",
          "update": "प्लेटफर्म संगठन अद्यावधिक गर्नुहोस्",
          "disable": "प्लेटफर्म संगठन निष्क्रिय बनाउनुहोस्"
        },
        "modules": {
          "list": "प्लेटफर्म मोड्युलहरू सूचीबद्ध गर्नुहोस्",
          "read": "प्लेटफर्म मोड्युल पढ्नुहोस्",
          "assign": "प्लेटफर्म मोड्युल assign गर्नुहोस्",
          "revoke": "प्लेटफर्म मोड्युल खारेज गर्नुहोस्"
        },
        "users": {
          "list": "प्लेटफर्म प्रयोगकर्ताहरू सूचीबद्ध गर्नुहोस्",
          "read": "प्लेटफर्म प्रयोगकर्ता पढ्नुहोस्",
          "create": "प्लेटफर्म प्रयोगकर्ता सिर्जना गर्नुहोस्",
          "update": "प्लेटफर्म प्रयोगकर्ता अद्यावधिक गर्नुहोस्",
          "disable": "प्लेटफर्म प्रयोगकर्ता निष्क्रिय बनाउनुहोस्"
        },
        "audit": {
          "read": "प्लेटफर्म अडिट पढ्नुहोस्",
          "list": "प्लेटफर्म अडिट सूचीबद्ध गर्नुहोस्",
          "export": "प्लेटफर्म अडिट निर्यात गर्नुहोस्"
        },
        "health": {
          "read": "प्लेटफर्म स्वास्थ्य पढ्नुहोस्"
        },
        "support-delegations": {
          "list": "समर्थन प्रतिनिधित्व सूचीबद्ध गर्नुहोस्",
          "read": "समर्थन प्रतिनिधित्व पढ्नुहोस्",
          "create": "समर्थन प्रतिनिधित्व सिर्जना गर्नुहोस्",
          "update": "समर्थन प्रतिनिधित्व अद्यावधिक गर्नुहोस्",
          "revoke": "समर्थन प्रतिनिधित्व खारेज गर्नुहोस्",
          "enter": "समर्थन प्रतिनिधित्व सन्दर्भमा प्रवेश गर्नुहोस्",
          "exit": "समर्थन प्रतिनिधित्व सन्दर्भबाट बाहिरिनुहोस्"
        }
      },
      "organization": {
        "accounting": {
          "manage": "संस्थाको लेखा व्यवस्थापन गर्नुहोस्",
          "read": "संस्थाको लेखा हेर्नुहोस्"
        },
        "profile": {
          "read": "संगठन प्रोफाइल पढ्नुहोस्",
          "update": "संगठन प्रोफाइल अद्यावधिक गर्नुहोस्"
        },
        "branches": {
          "list": "संगठन शाखाहरू सूचीबद्ध गर्नुहोस्",
          "read": "संगठन शाखा पढ्नुहोस्",
          "create": "संगठन शाखा सिर्जना गर्नुहोस्",
          "update": "संगठन शाखा अद्यावधिक गर्नुहोस्",
          "disable": "संगठन शाखा निष्क्रिय बनाउनुहोस्"
        },
        "modules": {
          "list": "संगठन मोड्युलहरू सूचीबद्ध गर्नुहोस्",
          "enable": "संगठन मोड्युल सक्षम गर्नुहोस्",
          "disable": "संगठन मोड्युल अक्षम गर्नुहोस्",
          "configure": "संगठन मोड्युल कन्फिगर गर्नुहोस्"
        },
        "users": {
          "list": "संगठन प्रयोगकर्ताहरू सूचीबद्ध गर्नुहोस्",
          "read": "संगठन प्रयोगकर्ता पढ्नुहोस्",
          "create": "संगठन प्रयोगकर्ता सिर्जना गर्नुहोस्",
          "update": "संगठन प्रयोगकर्ता अद्यावधिक गर्नुहोस्",
          "disable": "संगठन प्रयोगकर्ता निष्क्रिय बनाउनुहोस्"
        },
        "roles": {
          "list": "संगठन भूमिकाहरू सूचीबद्ध गर्नुहोस्",
          "read": "संगठन भूमिका पढ्नुहोस्",
          "create": "संगठन भूमिका सिर्जना गर्नुहोस्",
          "update": "संगठन भूमिका अद्यावधिक गर्नुहोस्",
          "disable": "संगठन भूमिका निष्क्रिय बनाउनुहोस्"
        },
        "permissions": {
          "list": "संगठन अनुमतिहरू सूचीबद्ध गर्नुहोस्",
          "assign": "संगठन अनुमतिहरू प्रदान गर्नुहोस्",
          "revoke": "संगठन अनुमतिहरू खारेज गर्नुहोस्"
        },
        "permission-assignments": {
          "list": "संगठन अनुमति निर्धारण सूचीबद्ध गर्नुहोस्",
          "edit": "संगठन अनुमति निर्धारण सम्पादन गर्नुहोस्"
        },
        "clients": {
          "list": "संगठनका ग्राहकहरू सूचीबद्ध गर्नुहोस्",
          "read": "संगठनको ग्राहक पढ्नुहोस्",
          "create": "संगठनमा ग्राहक सिर्जना गर्नुहोस्",
          "update": "संगठनको ग्राहक अद्यावधिक गर्नुहोस्",
          "disable": "संगठनको ग्राहक निष्क्रिय बनाउनुहोस्"
        },
        "client-accounts": {
          "list": "ग्राहक खाताहरू सूचीबद्ध गर्नुहोस्",
          "read": "ग्राहक खाता पढ्नुहोस्",
          "create": "ग्राहक खाता सिर्जना गर्नुहोस्",
          "update": "ग्राहक खाता अद्यावधिक गर्नुहोस्"
        },
        "portfolios": {
          "list": "पोर्टफोलियोहरू सूचीबद्ध गर्नुहोस्",
          "read": "पोर्टफोलियो पढ्नुहोस्",
          "create": "पोर्टफोलियो सिर्जना गर्नुहोस्",
          "update": "पोर्टफोलियो अद्यावधिक गर्नुहोस्"
        },
        "audit": {
          "read": "संगठन अडिट पढ्नुहोस्",
          "list": "संगठन अडिट अभिलेखहरू सूचीबद्ध गर्नुहोस्",
          "export": "संगठन अडिट अभिलेखहरू निर्यात गर्नुहोस्"
        },
        "access-inspector": {
          "read": "संगठन पहुँच निरीक्षक निदान पढ्नुहोस्"
        },
        "dashboard": {
          "read": "ड्यासबोर्ड पढ्नुहोस्"
        },
        "transactions": {
          "list": "कारोबारहरू सूचीबद्ध गर्नुहोस्",
          "read": "कारोबार पढ्नुहोस्",
          "create": "कारोबार सिर्जना गर्नुहोस्",
          "update": "कारोबार अद्यावधिक गर्नुहोस्",
          "approve": "कारोबार स्वीकृत गर्नुहोस्",
          "post": "कारोबार पोस्ट गर्नुहोस्",
          "submit": "कारोबार पेश गर्नुहोस्",
          "reject": "कारोबार अस्वीकृत गर्नुहोस्",
          "withdraw": "कारोबार फिर्ता लिनुहोस्",
          "repair": "कारोबार मर्मत गर्नुहोस्",
          "repost": "कारोबार पुनः पोस्ट गर्नुहोस्",
          "reverse": "कारोबार उल्टाउनुहोस्"
        },
        "holdings": {
          "read": "होल्डिङहरू पढ्नुहोस्"
        },
        "reports": {
          "read": "रिपोर्टहरू पढ्नुहोस्",
          "export": "रिपोर्टहरू निर्यात गर्नुहोस्",
          "list": "रिपोर्टहरू सूचीबद्ध गर्नुहोस्",
          "run": "रिपोर्टहरू चलाउनुहोस्",
          "schedule": "रिपोर्टहरू तालिकाबद्ध गर्नुहोस्"
        },
        "imports": {
          "list": "आयातहरू सूचीबद्ध गर्नुहोस्",
          "upload": "आयात अपलोड गर्नुहोस्",
          "commit": "आयात प्रतिबद्ध गर्नुहोस्",
          "validate": "आयात प्रमाणित गर्नुहोस्",
          "preview": "आयात पूर्वावलोकन गर्नुहोस्",
          "cancel": "आयात रद्द गर्नुहोस्",
          "retry": "आयात पुनः प्रयास गर्नुहोस्"
        },
        "reconciliation": {
          "list": "मिलान चलाइहरू सूचीबद्ध गर्नुहोस्",
          "manage": "मिलान व्यवस्थापन गर्नुहोस्",
          "read": "मिलान चलाइ पढ्नुहोस्",
          "create": "मिलान चलाइ सिर्जना गर्नुहोस्",
          "match": "मिलान वस्तुहरू मिलाउनुहोस्",
          "resolve": "मिलान अपवादहरू समाधान गर्नुहोस्",
          "complete": "मिलान चलाइ पूरा गर्नुहोस्",
          "reopen": "मिलान चलाइ पुनः खोल्नुहोस्",
          "export": "मिलान परिणामहरू निर्यात गर्नुहोस्"
        },
        "instruments": {
          "read": "उपकरणहरू पढ्नुहोस्",
          "manage": "उपकरणहरू व्यवस्थापन गर्नुहोस्"
        },
        "corporate-actions": {
          "read": "कर्पोरेट कार्यहरू पढ्नुहोस्",
          "manage": "कर्पोरेट कार्यहरू व्यवस्थापन गर्नुहोस्"
        },
        "facts": {
          "read": "तथ्यहरू पढ्नुहोस्",
          "manage": "तथ्यहरू व्यवस्थापन गर्नुहोस्"
        }
      },
      "client": {
        "dashboard": {
          "read": "आफ्नो ड्यासबोर्ड पढ्नुहोस्"
        },
        "holdings": {
          "list-own": "आफ्ना होल्डिङहरू सूचीबद्ध गर्नुहोस्",
          "read-own": "आफ्ना होल्डिङहरू पढ्नुहोस्"
        },
        "transactions": {
          "list-own": "आफ्ना कारोबारहरू सूचीबद्ध गर्नुहोस्",
          "read-own": "आफ्ना कारोबारहरू पढ्नुहोस्"
        },
        "reports": {
          "list-own": "आफ्ना रिपोर्टहरू सूचीबद्ध गर्नुहोस्",
          "read-own": "आफ्ना रिपोर्टहरू पढ्नुहोस्",
          "export-own": "आफ्ना रिपोर्टहरू निर्यात गर्नुहोस्"
        },
        "profile": {
          "read": "आफ्नो ग्राहक प्रोफाइल पढ्नुहोस्",
          "limited-update": "आफ्नो ग्राहक प्रोफाइल अद्यावधिक गर्नुहोस् (सीमित)"
        },
        "documents": {
          "read-own": "आफ्ना कागजातहरू पढ्नुहोस्"
        }
      },
      "settings": {
        "view": "सेटिङ हब हेर्नुहोस्",
        "profile": {
          "update": "आफ्नो प्रोफाइल सेटिङ अद्यावधिक गर्नुहोस्"
        },
        "preferences": {
          "update": "आफ्ना प्राथमिकताहरू अद्यावधिक गर्नुहोस्"
        },
        "mfa": "MFA सेटिङ हेर्नुहोस्",
        "password": {
          "change": "आफ्नो पासवर्ड परिवर्तन गर्नुहोस्"
        },
        "sessions": "आफ्ना सक्रिय सत्रहरू व्यवस्थापन गर्नुहोस्"
      }
    },
    "inDevelopment": "विकासमा",
    "unsaved": "नसेव गरिएको",
    "reason": "कारण",
    "noData": "कुनै डाटा छैन",
    "processing": "प्रक्रिया हुँदैछ...",
    "warning": "चेतावनी",
    "i18n": {
      "contentUnavailable": "सामग्री उपलब्ध छैन"
    },
    "unsavedChanges": "तपाईंका सुरक्षित नभएका परिवर्तनहरू छन्",
    "isMarginEligible": "मार्जिन योग्य",
    "capitalGainTax": "पूँजीगत लाभ कर",
    "sourceReference": "स्रोत सन्दर्भ"
  },
  "investment": {
    "holdings": {
      "title": "होल्डिङहरू",
      "description": "प्रति साधन हालको परिमाण, लागत आधार, र बजार मूल्य देखाउने समग्र पोर्टफोलियो होल्डिङहरू। होल्डिङहरू पोस्ट गरिएका कारोबार र प्रारम्भिक मौजदाबीबाट प्राप्त हुन्छन्।",
      "empty": {
        "title": "कुनै होल्डिङ छैन",
        "description": "कारोबार पोस्ट भएपछि वा प्रारम्भिक मौजदाबी समाप्त भएपछि होल्डिङहरू यहाँ देखिनेछन्। सुरु गर्न कारोबार पोस्ट गर्नुहोस् वा प्रारम्भिक मौजदाबी आयात गर्नुहोस्।"
      },
      "error": {
        "title": "होल्डिङ लोड गर्ने त्रुटि"
      }
    },
    "dataQuality": {
      "title": "डाटा गुणस्तर",
      "description": "डेटा गुणवत्ता मेट्रिक्स और सत्यापन स्थिति हेर्नुहोस्।"
    },
    "instruments": {
      "title": "उपकरणहरू",
      "description": "आपके पोर्टफोलियो के लिए कंपनी और साधन संदर्भ डेटा प्रबंधित गर्नुहोस्।"
    },
    "marketData": {
      "title": "बजार डाटा",
      "description": "आपके पोर्टफोलियो मा उपकरणों के लिए बाजार डेटा।",
      "marketDataView": {
        "importMarketData": "बजार डाटा आयात गर्नुहोस्",
        "import": "आयात",
        "importHelpText": "नेपSE या अन्य स्रोतों से नवीनतम बाजार मूल्य आयात करने की सहायता"
      },
      "pricesView": {
        "title": "मूल्य"
      }
    },
    "transactions": {
      "title": "कारोबारहरू",
      "description": "विवरण, फिल्टर, बनाउनुहोस्, आयात गर्नुहोस्, और निकालें निवेश व्यवहारों.",
      "reversalsView": {
        "title": "निवेश व्यवहार प्रतिक्रिया"
      },
      "create": {
        "title": "निवेश व्यवहार बनाउनुहोस्",
        "page": {
          "title": "कारोबारहरू",
          "description": "पोर्टफोलियो कारोबारहरूको समीक्षा र व्यवस्थापन गर्नुहोस्।"
        }
      },
      "bulk": {
        "title": "थोप लेनदेनहरू"
      },
      "page": {
        "title": "कारोबारहरू",
        "description": "पोर्टफोलियो कारोबारहरूको समीक्षा र व्यवस्थापन गर्नुहोस्।"
      },
      "empty": {
        "title": "खाली",
        "description": "व्यवहार विवरण"
      },
      "error": {
        "title": "त्रुटि"
      },
      "actions": {
        "delete": "मेटाउनुहोस्",
        "deleteDesc": "मेटाउनुहोस्",
        "submit": "प्रस्तुत गर्नुहोस्",
        "submitDesc": "प्रस्तुत गर्नुहोस्",
        "requestReversal": "उल्ट्याउने अनुरोध गर्नुहोस्",
        "requestReversalDesc": "उल्ट्याउने अनुरोध गर्नुहोस्"
      }
    },
    "reports": {
      "page": {
        "title": "लगानी रिपोर्टहरू",
        "description": "तपाईंको लगानी पोर्टफोलियोका लागि प्रदर्शन ट्र्याक गर्नुहोस्, होल्डिङहरू समीक्षा गर्नुहोस्, र कारोबार डाटा निर्यात गर्नुहोस्।",
        "descriptionWithDataQuality": "निश्चित पोर्टफोलो, प्रदर्शन, कर, खाता, एनएफआरएस, और डेटा-गुणवत्ता रिपोर्ट ढूंढें। उपलब्धता आपके भूमिका, स्तर, और डेटा तैयारी पर निर्भर करती छ।"
      },
      "error": {
        "title": "रिपोर्टहरू लोड गर्न असफल",
        "description": "एक अप्रत्याशित त्रुटि भयो"
      },
      "empty": {
        "title": "रिपोर्टहरू उपलब्ध छैन",
        "description": "यो खाताका लागि हाल कुनै लगानी रिपोर्ट सतहहरू उपलब्ध छैन।"
      },
      "availability": {
        "ariaLabel": "उपलब्धता अनुसार फिल्टर गर्नुहोस्",
        "all": "सबै",
        "available": "उपलब्ध",
        "unavailable": "अनुपलब्ध"
      },
      "hub": {
        "title": "रिपोर्टहरू हब",
        "description": "सबै लगानी रिपोर्टहरू एउटै ठाउँमा पहुँच गर्नुहोस्।",
        "searchPlaceholder": "रिपोर्टहरू खोज्नुहोस्...",
        "searchAriaLabel": "रिपोर्टहरू खोज्नुहोस्",
        "refineFiltersTitle": "फिल्टरहरू परिमार्जन गर्नुहोस्",
        "refineFiltersSubtitle": "उपलब्धता र डाटा गुणस्तर अनुसार रिपोर्टहरू फिल्टर गर्नुहोस्",
        "secondaryDisclosureTitle": "माध्यमिक प्रकटीकरण",
        "secondaryDisclosureSubtitle": "अतिरिक्त सन्दर्भ र मेटाडाटा",
        "contextTitle": "सन्दर्भ",
        "contextSubtitle": "रिपोर्ट सन्दर्भ जानकारी",
        "totalReports": "कुल रिपोर्टहरू",
        "availableLocked": "उपलब्ध / लक",
        "dataQualityAvailability": "डाटा गुणस्तर उपलब्धता"
      },
      "profitLoss": {
        "title": "नाफा र नोक्सान",
        "description": "लाभ-हानि रिपोर्ट"
      },
      "realizedPnl": {
        "title": "रियलाइज्ड नाफा र नोक्सान",
        "description": "वास्तविक लाभ-हानि रिपोर्ट"
      },
      "transactions": {
        "title": "लेनदेनहरू",
        "description": "लगानी लेनदेनहरू हेर्नुहोस् र व्यवस्थापन गर्नुहोस्"
      },
      "cgt": {
        "title": "कैपिटल गेन टैक्स",
        "description": "कैपिटल गेन टैक्स रिपोर्ट"
      },
      "monthlyMovement": {
        "title": "महीना गतिविधि",
        "description": "महीना गतिविधि रिपोर्ट"
      },
      "nfrsDashboard": {
        "title": "NFRS ड्यासबोर्ड",
        "description": "एनएफआरएस डैशबोर्ड रिपोर्ट"
      },
      "nfrsMonthly": {
        "title": "एनएफआरएस महीना",
        "description": "एनएफआरएस महीना रिपोर्ट"
      },
      "fifoNfrsReconciliation": {
        "title": "FIFO-एनएफआरएस संतुलन",
        "description": "FIFO-एनएफआरएस संतुलन रिपोर्ट"
      },
      "dataQuality": {
        "title": "डेटा-गुणवत्ता रिपोर्ट",
        "description": "प्रत्येकता रिपोर्ट रिपोर्ट"
      },
      "pivotAnalysis": {
        "title": "पिवोट विश्लेषण",
        "description": "पिवोट विश्लेषण रिपोर्ट"
      },
      "portfolioSummary": {
        "title": "पोर्टफोलियो सारांश",
        "description": "व्यावसायिक संपत्ति का समग्र परिचय और मापदंड हेर्नुहोस्।"
      },
      "concentration": {
        "title": "केंद्रीकरण",
        "description": "केंद्रीकरण रिपोर्ट"
      },
      "performanceDrivers": {
        "title": "प्रदर्शन प्रवाहकर्ता",
        "description": "प्रदर्शन प्रवाहकर्ता रिपोर्ट"
      },
      "performanceBenchmark": {
        "title": "प्रदर्शन मानक",
        "description": "प्रदर्शन मानक रिपोर्ट"
      },
      "performanceRisk": {
        "title": "प्रदर्शन जोखिम",
        "description": "प्रदर्शन जोखिम रिपोर्ट"
      },
      "allocation": {
        "title": "विभाजन",
        "description": "विभाजन रिपोर्ट"
      },
      "holdings": {
        "title": "होल्डिङ विवरण",
        "description": "होल्डिङ विवरण रिपोर्ट"
      },
      "companyStatement": {
        "title": "कम्पनी विवरण",
        "description": "कंपनी का बयान रिपोर्ट"
      },
      "performanceHub": {
        "title": "प्रदर्शन केंद्र",
        "description": "प्रदर्शन केंद्र रिपोर्ट"
      },
      "rebalancing": {
        "title": "रिब्यालेन्सिङ",
        "description": "संतुलन रिपोर्ट"
      },
      "qualityIssues": {
        "title": "रिपोर्ट {{reportId}} मा गुणस्तर समस्याहरू"
      },
      "stalePrices": {
        "title": "पुराना मूल्य निर्धारण {{count}} को पुराना हो चुका छ (>7 दिन)"
      },
      "missingPrices": {
        "title": "पुराना मूल्य निर्धारण {{count}} के लिए उपलब्ध छैन छ"
      },
      "category": {
        "overview": {
          "description": "विवरण रिपोर्ट"
        },
        "portfolio-holdings": {
          "description": "पोर्टफोलियो होल्डिङ रिपोर्टहरू"
        },
        "portfolio": {
          "description": "पोर्टफोलियो रिपोर्ट"
        },
        "transactions-lots": {
          "description": "कारोबार र लट रिपोर्टहरू"
        },
        "transactions": {
          "description": "लेन-देन रिपोर्ट"
        },
        "gain-loss-tax": {
          "description": "नाफा/नोक्सान र कर रिपोर्टहरू"
        },
        "monthly-analytics": {
          "description": "मासिक विश्लेषण रिपोर्टहरू"
        },
        "quality-audit-exports": {
          "description": "गुणस्तर, अडिट, र निर्यात रिपोर्टहरू"
        },
        "performance": {
          "description": "परिणाम रिपोर्ट"
        },
        "tax": {
          "description": "कर रिपोर्ट"
        },
        "nfrs": {
          "description": "NFRS रिपोर्टहरू"
        },
        "compliance": {
          "description": "नियमितता रिपोर्ट"
        }
      },
      "audit": {
        "title": "अडिट रिपोर्टहरू",
        "lineageView": {
          "title": "वंशावली"
        },
        "diagnosticsView": {
          "title": "निदान"
        }
      },
      "actions": {
        "openFilter": "फिल्टर खोलें",
        "openFilterDesc": "फिल्टर खोलें",
        "applyFilter": "फिल्टर लागू गर्नुहोस्",
        "applyFilterDesc": "फिल्टर लागू गर्नुहोस्",
        "resetFilter": "फिल्टर रीसेट गर्नुहोस्",
        "resetFilterDesc": "फिल्टर रीसेट गर्नुहोस्",
        "copyLink": "लिंक कॉपी गर्नुहोस्",
        "copyLinkDesc": "लिंक कॉपी गर्नुहोस्"
      }
    },
    "approvals": {
      "page": {
        "title": "अनुमोदनहरू",
        "description": "प्रतीक्षित निवेश व्यापारिक अनुमति और अपवादों का समीक्षण गर्नुहोस्।"
      },
      "title": "अनुमोदनहरू",
      "actions": {
        "approve": "अनुमोदन गर्नुहोस्",
        "approveDesc": "अनुमोदन गर्नुहोस्",
        "reject": "अस्वीकार गर्नुहोस्",
        "rejectDesc": "अस्वीकार गर्नुहोस्"
      }
    },
    "portfolio": {
      "page": {
        "title": "पोर्टफोलियो होल्डिङहरू",
        "description": "तपाईंको हालको पोर्टफोलियो होल्डिङ र आवंटन हेर्नुहोस्।"
      },
      "positive": "सहज",
      "negative": "नकारात्मक",
      "totalValue": "कुल मूल्य",
      "totalValueDesc": "कुल मूल्य",
      "unrealizedGain": "अनरियलाइज्ड नाफा",
      "unrealizedGainDesc": "अनरियलाइज्ड नाफा",
      "unrealizedReturn": "अप्रत्यक्ष लाभ",
      "unrealizedReturnDesc": "अनुभवहीन लाभ"
    },
    "overview": {
      "page": {
        "title": "पोर्टफोलियो अवलोकन",
        "description": "पोर्टफोलियो मूल्य, डाटा विश्वसनीयता, र मुख्य नेभिगेसन सर्टकटहरू।"
      },
      "loading": "ड्यासबोर्ड डाटा लोड हुँदैछ...",
      "errorTitle": "ड्यासबोर्ड अनुपलब्ध",
      "error": "ड्यासबोर्ड लोड गर्दा त्रुटि",
      "metrics": {
        "unavailable": "अनुपलब्ध",
        "ariaLabel": "पोर्टफोलियो सारांश मेट्रिक्स",
        "portfolioValue": "पोर्टफोलियो मूल्य",
        "unrealizedGain": "अनरियलाइज्ड नाफा",
        "unrealizedLoss": "अनरियलाइज्ड नोक्सानी",
        "holdings": "होल्डिङहरू",
        "dataTrust": "डाटा विश्वसनीयता"
      },
      "dataTrust": {
        "ok": "ठीक",
        "warning": "चेतावनी",
        "stale": "पुरानो",
        "alerts": "चेतावनीहरू",
        "pendingApprovals": "विचाराधीन अनुमोदन"
      },
      "dataQuality": {
        "approximated": "ड्यासबोर्ड डाटा अनुमानित छ। केही मेट्रिक्स अपूर्ण हुन सक्छन्।",
        "unavailable": "ड्यासबोर्ड डाटा अनुपलब्ध छ। केही मेट्रिक्स अपूर्ण हुन सक्छन्।",
        "holding": "होल्डिङ",
        "staleMarketPrices": "पुराना बजार मूल्य सहित।",
        "failedImport": "असफल आयात",
        "monitoringException": "मनिटरिङ अपवाद",
        "review": "समीक्षा"
      },
      "quickActions": {
        "ariaLabel": "छिटो कार्यहरू",
        "title": "छिटो कार्यहरू"
      },
      "operational": {
        "requestId": "अनुरोध आईडी",
        "scope": "क्षेत्र",
        "scopeOrg": "संस्था",
        "dataQuality": "डाटा गुणस्तर",
        "trustStatus": "विश्वास"
      },
      "recentActivity": {
        "title": "हालको गतिविधि"
      },
      "attention": {
        "title": "ध्यान दिनुपर्ने वस्तुहरू",
        "description": "डाटा गुणस्तर वा कार्यप्रवाहमा प्रभाव बढ्नु अघि कार्य आवश्यक वस्तुहरू।"
      },
      "monthlyPnl": {
        "title": "मासिक P&L स्न्यापसट",
        "description": "क्यानोनिकल तथ्य स्न्यापसटबाट हालका मासिक प्रवृत्तिहरू।"
      },
      "kpiActions": {
        "title": "KPI ड्रिलडाउनहरू",
        "description": "KPI कार्यहरूसँग नक्सा गरिएका प्रत्यक्ष रिपोर्ट लिङ्कहरू।",
        "open": "खोल्नुहोस्",
        "unavailable": "अनुपलब्ध"
      },
      "adminLinks": {
        "title": "प्रशासनिक लिङ्कहरू"
      },
      "performance": {
        "title": "प्रदर्शन प्रवृत्ति",
        "description": "क्यानोनिकल प्रदर्शन तथ्यहरूबाट हालका पोर्टफोलियो मूल्य बिन्दुहरू।"
      },
      "holdingsBySector": {
        "title": "क्षेत्र अनुसार होल्डिङहरू",
        "description": "क्यानोनिकल बजार-मूल्य तौल सहित क्षेत्रीय आवंटन।"
      },
      "monitoring": {
        "title": "मनिटरिङ अलर्टहरू",
        "description": "लगानी मनिटरिङले देखाएका हालका अपवादहरू।",
        "severity": "गम्भीरता"
      },
      "sectionStatus": {
        "title": "खण्ड उपलब्धता"
      }
    },
    "dashboard": {
      "title": "ड्यासबोर्ड"
    },
    "import": {
      "title": "आयात",
      "actions": {
        "preview": "पूर्वदृश्य",
        "previewDesc": "पूर्वदृश्य",
        "commit": "समायोजन",
        "commitDesc": "समायोजन",
        "cancel": "बताली गर्नु",
        "cancelDesc": "बताली गर्नु",
        "copyEvidenceLink": "साक्ष्य लिंक को प्रतिलिपि बनाउनुहोस्",
        "copyEvidenceLinkDesc": "साक्ष्य लिंक को प्रतिलिपि बनाउनुहोस्",
        "openLineage": "वारिसगती खोलें",
        "openLineageDesc": "वारिसगती खोलें",
        "retryJob": "काम फिर से शुरू गर्नुहोस्",
        "retryJobDesc": "काम फिर से शुरू गर्नुहोस्"
      }
    },
    "settings": {
      "title": "सेटिङ्स",
      "marketData": {
        "title": "बाजार डेटा सेटिङहरू"
      },
      "benchmark": {
        "title": "बेन्चमार्क कन्फिगरेसन",
        "description": "ड्यासबोर्ड र प्रदर्शन रिपोर्टहरूमा देखाइने बेन्चमार्क तुलना मानहरू नियन्त्रण गर्छ।",
        "fields": {
          "symbol": "बेन्चमार्क प्रतीक",
          "period": "तुलना अवधि",
          "manualTarget": "म्यानुअल लक्ष्य फिर्ती (%)",
          "sectorLimit": "क्षेत्र एकाग्रता सीमा (%)",
          "top10Limit": "शीर्ष 10 होल्डिंग लिमिट (%)"
        },
        "placeholders": {
          "symbol": "विशेषण प्रतीक (उदाहरण के लिए, NEPSE)",
          "period": "तुलना अवधि छान्नुहोस्",
          "manualTarget": "उदाहरण के लिए, 15",
          "sectorLimit": "उदाहरण के लिए, 30",
          "top10Limit": "उदाहरण के लिए, 40"
        },
        "periods": {
          "oneMonth": "१ महिना",
          "threeMonths": "३ महिना",
          "sixMonths": "६ महिना",
          "oneYear": "१ वर्ष",
          "threeYears": "३ वर्ष"
        },
        "descriptions": {
          "manualTarget": "निर्दिष्ट लक्ष्य वापसी कोणता हिसाब से लागू गर्नुहोस्",
          "sectorLimit": "किसी एक क्षेत्र मा पोर्टफोलियो की मूल्य का अधिकतम प्रतिशत",
          "top10Limit": "पोर्टफोलियो की मूल्य का अधिकतम प्रतिशत शीर्ष 10 निवेशों में"
        },
        "notes": {
          "dataSourceLabel": "ब्याकएन्ड इन्डेक्स प्रदायकबाट दैनिक मूल्य श्रृंखला।",
          "dataSource": "बेंचमार्क डेटा बाजार के मूल्य फीड से स्रोतित छ",
          "manualTargetLabel": "कन्फिगर गरिएको भए, ड्यासबोर्डले YTD फिर्तीलाई यस लक्ष्यसँग तुलना गर्छ।",
          "manualTarget": "निर्दिष्ट लक्ष्य वापसी कोणता हिसाब से लागू गर्नुहोस्",
          "concentrationLimitsLabel": "क्षेत्र र शीर्ष-१० निगरानीका लागि कन्फिगर गर्न सकिने सीमाहरू।",
          "concentrationLimits": "पोर्टफोलियो नियन्त्रण गर्नका लागि एकाग्रता सीमाहरू"
        }
      },
      "actions": {
        "saveProfile": "प्रोफाइल सेभ गर्नुहोस्",
        "saveProfileDesc": "प्रोफाइल सेभ गर्नुहोस्",
        "saveSecurity": "सुरक्षा सेभ गर्नुहोस्",
        "saveSecurityDesc": "सुरक्षा सेभ गर्नुहोस्",
        "saveNotifications": "सूचनाहरू सेभ गर्नुहोस्",
        "saveNotificationsDesc": "सूचनाहरू सेभ गर्नुहोस्",
        "saveInvestment": "लगानी सेभ गर्नुहोस्",
        "saveInvestmentDesc": "लगानी सेभ गर्नुहोस्",
        "restore": "पुनर्स्थापित गर्नुहोस्",
        "restoreDesc": "पुनर्स्थापित गर्नुहोस्",
        "saveMarketData": "बजार डेटा सेभ गर्नुहोस्",
        "saveMarketDataDesc": "बजार डेटा सेभ गर्नुहोस्",
        "saveBenchmarks": "बेन्चमार्क सेभ गर्नुहोस्",
        "saveBenchmarksDesc": "बेन्चमार्क सेभ गर्नुहोस्"
      }
    },
    "rebalancing": {
      "title": "रिब्यालेन्सिङ",
      "description": "पोर्टफोलियो विचलन समीक्षा गर्नुहोस् र स्वीकृत पुनःसन्तुलन कार्यहरू तयारी गर्नुहोस्।"
    },
    "marketDataSettings": {
      "title": "व्यापारिक डेटा सेटिङहरू",
      "description": "व्यापारिक डेटा सेटिङहरू विवरण",
      "feedSource": "निर्देशित स्रोत",
      "actions": {
        "openDataQuality": "डेटा गुणवत्ता खोल",
        "openOperationalPage": "ऑपरेशनल पेज खोल"
      },
      "policyTitle": "नीति",
      "policyDescription": "नीति विवरण",
      "operationalBoundary": {
        "title": "कार्यान्वित सीमा",
        "description": "कार्यान्वित सीमा विवरण"
      },
      "governance": {
        "title": "नियंत्रण",
        "subtitlePrefix": "पूर्व नाम प्राप्ति",
        "subtitleSuffix": "पश्चात्त नाम प्राप्ति",
        "items": {
          "provider": "सेवा प्रदाता",
          "freshness": "नयापन",
          "remediation": "सुधार"
        }
      }
    },
    "workflow": {
      "actions": {
        "submit": "प्रस्तुत कर",
        "submitDesc": "प्रस्तुत",
        "approve": "अनुमोदन गर्नुहोस्",
        "approveDesc": "अनुमोदन गर्नुहोस्",
        "post": "पोस्ट",
        "postDesc": "पोस्ट",
        "reject": "अस्वीकार गर्नुहोस्",
        "rejectDesc": "अस्वीकार गर्नुहोस्",
        "withdraw": "वापस लेना",
        "withdrawDesc": "वापस लेना",
        "requestReversal": "उल्ट्याउने अनुरोध गर्नुहोस्",
        "requestReversalDesc": "उल्ट्याउने अनुरोध गर्नुहोस्",
        "approveReversal": "स्वीकार कर वापस लेना",
        "approveReversalDesc": "स्वीकार कर वापस लेना",
        "rejectReversal": "प्रत्यर्थ निलंबित कर",
        "rejectReversalDesc": "प्रत्यर्थ निलंबित कर",
        "repair": "सुधारित कर",
        "repairDesc": "सुधारित कर",
        "repost": "फिर से पोस्ट कर",
        "repostDesc": "फिर से पोस्ट कर"
      }
    },
    "data": {
      "instruments": {
        "actions": {
          "create": "सिर्जना",
          "createDesc": "सिर्जना",
          "save": "बनाए रखें",
          "saveDesc": "बनाए रखें"
        }
      },
      "marketData": {
        "actions": {
          "createPrice": "मूल्य बनाउनुहोस्",
          "createPriceDesc": "मूल्य बनाउनुहोस्",
          "savePrice": "मूल्य संग्रहित गर्नुहोस्",
          "savePriceDesc": "मूल्य संग्रहित गर्नुहोस्"
        }
      },
      "taxRules": {
        "title": "कर नियमहरू",
        "actions": {
          "create": "सिर्जना",
          "createDesc": "सिर्जना",
          "save": "कर नियम संग्रहित गर्नुहोस्",
          "saveDesc": "कर नियम संग्रहित गर्नुहोस्",
          "createVersion": "कर नियम संस्करण सिर्जना गर्नुहोस्",
          "view": "कर नियम संस्करण हेर्नुहोस्"
        },
        "fields": {
          "jurisdiction": "क्षेत्राधिकार",
          "ruleType": "नियम प्रकार",
          "investorCategory": "लगानीकर्ता वर्ग",
          "instrumentType": "साधन प्रकार",
          "holdingPeriodClassification": "धारण अवधि वर्गीकरण",
          "holdingPeriodMinimumDays": "न्यूनतम धारण अवधि (दिन)",
          "effectiveFrom": "प्रभावी मिति",
          "effectiveTo": "समाप्ति मिति",
          "capitalGainsTaxRate": "पुँजीगत लाभ कर दर (%)",
          "withholdingTaxRate": "स्रोतमा कट्टी कर दर (%)",
          "roundingPolicy": "पूर्णांक नीति",
          "sourceReference": "स्रोत सन्दर्भ",
          "status": "स्थिति",
          "version": "संस्करण"
        },
        "holdingPeriodOptions": {
          "shortTerm": "छोटो अवधि",
          "longTerm": "लामो अवधि"
        },
        "section": {
          "scope": "कार्यक्षेत्र",
          "holdingPeriod": "धारण अवधि",
          "rates": "कर दर",
          "effectiveDates": "प्रभावी मितिहरू",
          "reference": "सन्दर्भ"
        },
        "description": "लगानी सञ्चालनका लागि कर नियमहरू व्यवस्थापन गर्नुहोस्।",
        "help": {
          "jurisdictionNepal": "यस संस्करणमा नेपाल (NP) का कर नियमहरू प्रयोग हुन्छन्।",
          "ratePercent": "दर प्रतिशतमा लेख्नुहोस्, जस्तै ७.५% का लागि 7.5।",
          "roundingPolicy": "पोस्टिङअघि गणना गरिएको कर रकम कसरी गोलाइ गर्ने भन्ने छान्नुहोस्।"
        },
        "roundingOptions": {
          "halfUp2": "नजिकको पैसा — हाफ अप",
          "halfEven2": "नजिकको पैसा — हाफ इभेन",
          "down2": "पैसासम्म तल गोलाइ",
          "up2": "पैसासम्म माथि गोलाइ",
          "halfUp0": "नजिकको रुपैयाँ — हाफ अप",
          "halfEven0": "नजिकको रुपैयाँ — हाफ इभेन"
        }
      },
      "issuers": {
        "actions": {
          "create": "सिर्जना",
          "createDesc": "सिर्जना",
          "save": "वित्तीय कंपनियों को संग्रहित गर्नुहोस्",
          "saveDesc": "वित्तीय कंपनियों को संग्रहित गर्नुहोस्"
        }
      },
      "openingBalances": {
        "actions": {
          "create": "सिर्जना",
          "createDesc": "सिर्जना",
          "save": "प्रारंभिक विवरण संग्रहित गर्नुहोस्",
          "saveDesc": "प्रारंभिक विवरण संग्रहित गर्नुहोस्"
        }
      },
      "feeRules": {
        "actions": {
          "create": "सिर्जना",
          "createDesc": "सिर्जना",
          "save": "भुगतान नियम संग्रहित गर्नुहोस्",
          "saveDesc": "भुगतान नियम संग्रहित गर्नुहोस्"
        },
        "title": "शुल्क नियमहरू",
        "description": "ब्रोकरेज, डीपी र सेबोन शुल्कका प्रभावकारी-मितियुक्त नियमहरू व्यवस्थापन गर्नुहोस्।",
        "fields": {
          "jurisdiction": "क्षेत्राधिकार",
          "ruleType": "नियम प्रकार",
          "deductibleClassification": "कटौतीयोग्य वर्गीकरण",
          "effectiveFrom": "लागू हुने मिति",
          "effectiveTo": "लागू रहने अन्तिम मिति",
          "roundingPolicy": "राउन्डिङ नीति",
          "components": "शुल्क अवयवहरू",
          "componentSummary": "शुल्क घटकहरू",
          "sourceReference": "स्रोत सन्दर्भ",
          "status": "स्थिति",
          "version": "संस्करण"
        },
        "ruleTypeOptions": {
          "brokerageSebonDp": "ब्रोकरेज, सेबोन र डीपी शुल्क",
          "standardSecurities": "मानक सिक्युरिटिज",
          "brokerage": "ब्रोकरेज"
        },
        "deductibleOptions": {
          "deductible": "कटौतीयोग्य",
          "nonDeductible": "कटौतीयोग्य होइन",
          "partial": "आंशिक रूपमा कटौतीयोग्य"
        },
        "roundingOptions": {
          "halfUp2": "२ दशमलवमा हाफ-अप",
          "halfEven2": "२ दशमलवमा हाफ-इभन",
          "down2": "२ दशमलवमा तलतिर राउन्ड",
          "up2": "२ दशमलवमा माथितिर राउन्ड",
          "halfUp0": "पूर्ण अंकमा हाफ-अप",
          "halfEven0": "पूर्ण अंकमा हाफ-इभन"
        },
        "section": {
          "scope": "नियमको दायरा",
          "classification": "शुल्क वर्गीकरण",
          "effectiveDates": "प्रभावकारी मितिहरू",
          "components": "गणना अवयवहरू",
          "reference": "स्रोत र सन्दर्भ"
        },
        "help": {
          "jurisdictionNepal": "नेपालका नियमका लागि NP क्षेत्राधिकार कोड प्रयोग गर्नुहोस्।",
          "ruleType": "यो तालिकाले प्रतिनिधित्व गर्ने शुल्क संयोजन चयन गर्नुहोस्।",
          "deductibleClassification": "कर वा लागत आधारका लागि शुल्कको कटौतीयोग्य व्यवहार चयन गर्नुहोस्।",
          "roundingPolicy": "गणनाको नतिजामा लागू हुने राउन्डिङ नीति चयन गर्नुहोस्।",
          "components": "ब्रोकरेज, डीपी र सेबोन गणना अवयवहरूको संरचित परिभाषा प्रविष्ट गर्नुहोस्।"
        }
      },
      "corporateActions": {
        "actions": {
          "create": "सिर्जना",
          "createDesc": "सिर्जना",
          "save": "बन्दी",
          "saveDesc": "बन्दी",
          "submit": "प्रस्तुत कर",
          "submitDesc": "प्रस्तुत कर",
          "approve": "अनुमोदन गर्नुहोस्",
          "approveDesc": "अनुमोदन गर्नुहोस्",
          "reject": "अस्वीकार गर्नुहोस्",
          "rejectDesc": "अस्वीकार गर्नुहोस्"
        }
      }
    }
  },
  "platform": {
    "accounting": {
      "overview": {
        "title": "लेखांकन अवलोकन",
        "description": "सञ्चालन लेखांकन स्थिति, नियन्त्रण, र पोस्टिङ गतिविधि।"
      },
      "chartOfAccounts": {
        "title": "हिसाब किताब",
        "description": "जर्नल पोस्टिङको लागि प्रयोग गरिने खाता खाताहरू समीक्षा गर्नुहोस् र मर्मत गर्नुहोस्।"
      },
      "journalReview": {
        "title": "जर्नल समीक्षा",
        "description": "अडिट ट्रेसेबिलिटी सहिक ड्राफ्ट र पोस्ट गरिएका जर्नल प्रविष्टिहरू निरीक्षण गर्नुहोस्।"
      },
      "bankReconciliation": {
        "title": "बैंक मेलमिलाप",
        "description": "बैंक विवरणहरू विरुद्ध खाता ब्यालेन्स मेलमिलाप गर्नुहोस् र अपवादहरू समाधान गर्नुहोस्।"
      }
    },
    "tax": {
      "overview": {
        "title": "कर अवलोकन",
        "description": "कर अनुपालन मुद्रा, फाइलिङ स्थिति, र मुख्य समयसीमाहरू।"
      },
      "vat": {
        "title": "वट",
        "description": "VAT गणना, फाइलिङ समर्थन, र मेलमिलाप संकेतहरू।"
      },
      "ird": {
        "title": "IRD निर्यातहरू",
        "description": "IRD-तयार कर आउटपुटहरू उत्पन्न गर्नुहोस् र समीक्षा गर्नुहोस्।"
      },
      "irdExports": {
        "title": "IRD निर्यातहरू",
        "description": "IRD-तयार कर आउटपुटहरू उत्पन्न गर्नुहोस् र समीक्षा गर्नुहोस्।"
      },
      "filings": {
        "title": "फाइलिङहरू",
        "healthyFallback": "स्वस्थ"
      }
    },
    "data": {
      "pages": {
        "instruments": {
          "columns": {
            "symbol": "प्रतीक",
            "name": "नाम",
            "securityType": "प्रतिभूति प्रकार",
            "sector": "क्षेत्र",
            "status": "स्थिति"
          },
          "cards": {
            "total": {
              "label": "कुल",
              "hint": "संलग्न साधनों की संख्या"
            },
            "active": {
              "label": "सक्रिय",
              "hint": "संलग्न साधन"
            },
            "verification": {
              "label": "नियंत्रण",
              "hint": "संलग्न साधनों की सत्यापन प्रक्रिया में"
            }
          },
          "tableTitle": "उपकरणहरू",
          "empty": "कोई संलग्न साधन छैन पाया गया",
          "emptyFiltered": "आपके फिल्टर के अनुसार कोई संलग्न साधन फेला परेन",
          "status": {
            "active": "सक्रिय",
            "watchlist": "वॉचलिस्ट"
          },
          "referenceReadOnlyMessage": "सन्दर्भ पढ्न मात्र अनुमति छ",
          "settingsWorkflowMessage": "फ्लोवर्क संदेश",
          "actions": {
            "openCompanyStatement": "कंपनी का वित्तीय बिल खोलें",
            "verifyInstrumentMapping": "संलग्न साधनों के मानचित्रण की सत्यापन गर्नुहोस्",
            "openInstrumentSettings": "संलग्न साधनों की सेटिंग खोलें",
            "openCompanyStatementDesc": "कंपनी का वित्तीय बिल खोलने का विवरण",
            "viewDetails": "विवरणहरू हेर्नुहोस्",
            "viewDetailsDesc": "विवरणहरू हेर्नुहोस्",
            "create": "सिर्जना",
            "createDesc": "सिर्जना",
            "edit": "सम्पादन गर्नुहोस्",
            "editDesc": "सम्पादन गर्नुहोस्",
            "delete": "मेटाउनुहोस्",
            "deleteDesc": "मेटाउनुहोस्",
            "import": "आयात",
            "importDesc": "आयात"
          },
          "disabledReasons": {
            "openCompanyStatement": "इस संलग्न साधन के लिए प्रतीक उपलब्ध छैन छ"
          }
        },
        "reportRuns": {
          "columns": {
            "completedAt": "पूर्ण गरिएको समय",
            "report": "रिपोर्ट",
            "runId": "पुर्न ID",
            "startedAt": "शुरू हुने समय",
            "duration": "काला",
            "status": "स्थिति"
          },
          "cards": {
            "runsToday": {
              "label": "आजको पुर्नहरू",
              "hint": "आजको पुर्नहरूका कार्य सम्पन्न हुने होला"
            },
            "successful": {
              "label": "सफल",
              "hint": "सफलतापूर्वक चलाइएको"
            },
            "failed": {
              "label": "असफल",
              "hint": "अफेल पुर्नहरूका कार्य सम्पन्न नै हुने होला"
            }
          },
          "status": {
            "success": "स्थिति सफल",
            "failed": "असफल",
            "running": "चालuchha",
            "unknown": "अज्ञात"
          },
          "title": "रिपोर्ट रनहरू",
          "description": "निकासी का वर्णन",
          "tableTitle": "तालिका",
          "empty": "निकासी खाली",
          "actions": {
            "exportLogs": "लॉग निकासी निर्यात",
            "openDetail": "विवरणहरू हेर्नुहोस्",
            "openDetailDesc": "प्रारंभिक विवरण खोल्नु",
            "exportLogsDesc": "लॉग्स निर्यात गर्नु"
          }
        },
        "corporateActions": {
          "columns": {
            "symbol": "प्रतीक",
            "actionType": "कार्यवाही प्रकार",
            "effectiveDate": "सक्रिय तिथि",
            "ratio": "गुणांक",
            "status": "स्थिति"
          },
          "cards": {
            "recentActions": {
              "label": "पश्चात्त कार्यान्वयन",
              "hint": "सामूहिक कार्यान्वयन उपलब्ध संख्या",
              "labelDesc": "पश्चात्त कार्यान्वयन"
            },
            "applied": {
              "label": "अनुप्रयोगित",
              "hint": "कार्यान्वयन के लिए पहले से अनुप्रयोगित कार्य",
              "labelDesc": "अनुप्रयोगित"
            },
            "pendingReview": {
              "label": "प्रतीक्षा पर समीक्षा",
              "hint": "समीक्षा के लिए प्रतीक्षा मा कार्यान्वयन",
              "labelDesc": "प्रतीक्षा पर समीक्षा"
            }
          },
          "tableTitle": "कर्पोरेट कार्यहरू",
          "empty": "कोई सामूहिक कार्यान्वयन उपलब्ध छैन छ",
          "filteredEmpty": "फिल्टर के अनुसार कोई सामूहिक कार्यान्वयन उपलब्ध छैन छ",
          "types": {
            "bonus": "बोनस",
            "right": "हक शेयर",
            "split": "विभाजन",
            "dividend": "विभाजन",
            "cash": "पैसा विभाजन"
          },
          "status": {
            "pending": "KYC विचाराधीन",
            "applied": "अनुप्रयोगित",
            "skipped": "छोडियो"
          },
          "ratio": {
            "cashRate": "पैसे की दर",
            "ratio": "गुणांक",
            "none": "कुनै पनि"
          },
          "actions": {
            "reviewAuditTrail": "समीक्षा ऑडिट ट्रेल",
            "apply": "अनुप्रयोगित गर्नुहोस्",
            "holdingsImpact": "हेर्नुहोस् निवेश प्रभाव",
            "reviewAuditTrailDesc": "समीक्षा ऑडिट ट्रेल",
            "applyDesc": "अप्लाई कर",
            "holdingsImpactDesc": "होल्डिंग्स प्रभाव"
          },
          "disabledReasons": {
            "apply": {
              "applied": "कार्रवाई को पहले से ही लागू गरिएको छ"
            },
            "holdingsImpact": {
              "noSymbol": "इस कार्रवाई के लिए प्रतीक उपलब्ध छैन छ"
            }
          }
        },
        "feeChargeRules": {
          "columns": {
            "rule": "नियम",
            "scope": "क्षेत्र",
            "basis": "आधार",
            "rate": "दर",
            "status": "कलम स्थिति"
          },
          "scopes": {
            "allPortfolios": "सब पोर्टफोलियो"
          },
          "status": {
            "draft": "ड्राफ्ट",
            "active": "सक्रिय"
          },
          "title": "फीस चार्ज नियम",
          "description": "फीस चार्ज नियम विवरण",
          "cards": {
            "configuredRules": {
              "label": "निर्धारित नियम",
              "hint": "निर्धारित नियम की सुझाव",
              "labelDesc": "निर्धारित नियम"
            },
            "active": {
              "label": "सक्रिय",
              "hint": "सक्रिय सुझाव",
              "labelDesc": "सक्रिय"
            },
            "draft": {
              "label": "ड्राफ्ट",
              "hint": "ड्राफ्ट सुझाव",
              "labelDesc": "ड्राफ्ट"
            }
          },
          "tableTitle": "टेबल",
          "empty": "फीस चार्ज नियम खाली",
          "actions": {
            "viewDetail": "विवरण हेर्नुहोस्",
            "editRule": "नियम संपादित गर्नुहोस्",
            "edit": "फीस चार्ज नियम संपादित गर्नुहोस्",
            "viewDetailDesc": "देख्ने की विवरण",
            "editDesc": "सम्पादन गर्नुहोस्"
          }
        },
        "issuers": {
          "columns": {
            "symbol": "प्रतीक",
            "issuer": "प्रवर्तनकर्ता",
            "sector": "क्षेत्र",
            "status": "स्थिति"
          },
          "status": {
            "active": "सक्रिय",
            "watchlist": "वाच्य सूची"
          },
          "cards": {
            "totalIssuers": {
              "label": "मुल्यानिर्धारित प्रवर्तनकर्ताहरू कोणते आहेत",
              "hint": "मुल्यानिर्धारित प्रवर्तनकर्ताहरू की संख्या"
            },
            "activeListings": {
              "label": "सक्रिय सूची",
              "hint": "सक्रिय सूची की संख्या"
            },
            "needsReview": {
              "label": "पुनर्विचार आवश्यकता",
              "hint": "पुनर्विचार आवश्यकता हुने प्रवर्तनकर्ताहरू"
            }
          },
          "tableTitle": "प्रवर्तनकर्ताहरू",
          "empty": "कोणताही प्रवर्तनकर्ता उपलब्ध नाही",
          "issuerSurfaceDescription": "प्रवर्तनकर्ता सतह विवरण",
          "referenceReadOnlyMessage": "संदर्भ पढ्याचे संदेश",
          "settingsWorkflowMessage": "गतिशीलता संदेश",
          "actions": {
            "openIssuerStatement": "प्रवर्तनकर्ता विवरण खोला",
            "openIssuerStatementDesc": "प्रवर्तनकर्ता विवरण खोला"
          },
          "actionsDisabledReasons": {
            "openIssuerStatement": "प्रवर्तनकर्ता विवरण खोल्यासाठी प्रतिबंधित कारण नाही"
          }
        },
        "openingBalances": {
          "columns": {
            "account": "खाता",
            "symbol": "प्रतीक",
            "quantity": "मात्रा",
            "cost": "व्यय",
            "asOf": "कालांतराने",
            "status": "स्थिती"
          },
          "status": {
            "posted": "पोस्ट गरियो",
            "review": "समीक्षा गर्नुहोस्"
          },
          "cards": {
            "openRows": {
              "label": "प्रारंभिक संतुलन के खातों की खुली रेखा",
              "hint": "प्रारंभिक संतुलन के खातों की खुली रेखा",
              "labelDesc": "प्रारंभिक संतुलन के खातों की खुली रेखा"
            },
            "readyToPost": {
              "label": "सहज होने के लिए पोस्ट गर्नुहोस्",
              "hint": "सहज होने के लिए पोस्ट गर्नु",
              "labelDesc": "सहज होने के लिए पोस्ट गर्नुहोस्"
            },
            "needsRemediation": {
              "label": "निर्माण की आवश्यकता छ",
              "hint": "निर्माण की आवश्यकता छ",
              "labelDesc": "निर्माण की आवश्यकता छ"
            }
          },
          "readinessTableTitle": "तैयारी टेबल",
          "tableTitle": "टेबल",
          "empty": "प्रारंभिक संतुलन के खाते खाली छं",
          "invalidViewFallback": "वैध दृश्य वापसी",
          "actions": {
            "reviewTransactionRepairs": "विवरण समीक्षा गर्नुहोस् और मरम्मत गर्नुहोस्",
            "remediateBalance": "संतुलन को सुधारें",
            "viewSourceEvidence": "स्रोत प्रमाण हेर्नुहोस्",
            "postOpeningBalance": "प्रारंभिक संतुलन का पोस्ट गर्नुहोस्",
            "repairOpeningBalance": "प्रारंभिक संतुलन की मरम्मत गर्नुहोस्",
            "repostOpeningBalance": "प्रारंभिक संतुलन को पुनः पोस्ट गर्नुहोस्",
            "viewSourceEvidenceDesc": "स्रोत प्रमाण हेर्नुहोस्",
            "reviewTransactionRepairsDesc": "पुनर्निरीक्षण व्यावसायिक कार्यवाही",
            "postOpeningBalanceDesc": "प्रारंभिक लाभ पोस्ट करो",
            "remediateBalanceDesc": "वित्तीय संतुलन ठीक करो",
            "repairOpeningBalanceDesc": "प्रारंभिक लाभ ठीक करो",
            "repostOpeningBalanceDesc": "पुनर्पोस्ट प्रारंभिक लाभ"
          },
          "confirmPostOpeningBalance": "आपकी पुष्टि के साथ प्रारंभिक लाभ पोस्ट गर्नु चाहते छं?",
          "confirmRepairOpeningBalance": "आपकी पुष्टि के साथ प्रारंभिक लाभ ठीक गर्नु चाहते छं?",
          "confirmRepostOpeningBalance": "आपकी पुष्टि के साथ पुनर्पोस्ट प्रारंभिक लाभ"
        },
        "reportReadiness": {
          "columns": {
            "report": "रिपोर्ट",
            "asOf": "से",
            "coverage": "कभरेज",
            "freshness": "नयापन",
            "status": "कलम स्थिति"
          },
          "status": {
            "review": "समीक्षा गर्नुहोस्",
            "ready": "तयार",
            "blocked": "रोका हुआ"
          },
          "issueCount": "विवाद की गिनती",
          "title": "रिपोर्ट तयारी",
          "description": "प्रतिक्रिया तैयारी विवरण",
          "cards": {
            "readyReports": {
              "label": "सही रिपोर्ट",
              "hint": "सही रिपोर्ट के लिए सुझाव"
            },
            "needsReview": {
              "label": "निरीक्षण की आवश्यकता छ",
              "hint": "निरीक्षण की आवश्यकता के लिए सुझाव"
            },
            "blocked": {
              "label": "रोका हुआ",
              "hint": "रोका हुआ सुझाव"
            }
          },
          "tableTitle": "खाता",
          "empty": "रिपोर्ट रेडनेस खाली",
          "actions": {
            "openRemediation": "रेमीडिएशन खोल",
            "openReport": "रिपोर्ट खोल",
            "openReportDesc": "रिपोर्ट खोल",
            "openRemediationDesc": "रेमीडिएशन खोल"
          }
        }
      },
      "instruments": {
        "title": "इन्स्ट्रुमेन्ट्स",
        "description": "कारोबार, होल्डिङ, र मूल्यांकनको लागि सन्दर्भ उपकरणहरू।"
      },
      "marketPrices": {
        "title": "बजार मूल्यहरू",
        "description": "मूल्यांकन र रिपोर्टका लागि प्रयोग हुने बजार मूल्य रेकर्ड, अद्यावधिक, र कभरेज ताजापन व्यवस्थापन गर्नुहोस्।",
        "viewAction": "बजार मूल्य कभरेज हेर्नुहोस्",
        "manageAction": "बजार मूल्यहरू व्यवस्थापन गर्नुहोस्"
      },
      "imports": {
        "title": "डाटा आयातहरू",
        "description": "बजार सन्दर्भ डाटा अद्यावधिकहरू आयात गर्नुहोस् र प्रमाणित गर्नुहोस्।"
      },
      "lineage": {
        "title": "लाइनएज",
        "description": "डेटा परिवर्तन ट्रैक गर्नुहोस् और सिस्टम के लिए ऑडिट ट्रेल बनाउनुहोस्।",
        "columns": {
          "action": "कार्य",
          "entityType": "इकाइ प्रकार",
          "entityId": "हरूटिटी आईडी",
          "occurredAt": "हुआ समय",
          "actor": "कार्यकर्ता"
        },
        "cards": {
          "total": {
            "label": "कुल घटनाहरू"
          },
          "latestAction": {
            "label": "नया कार्य",
            "hint": "अंतिम डेटा परिवर्तन",
            "labelDesc": "नया कार्य"
          },
          "latestActor": {
            "label": "नया कार्यकर्ता",
            "hint": "नया कार्यकर्ता संकेत"
          }
        },
        "table": {
          "title": "डेटा लाइनेज इवेंट्स"
        },
        "empty": {
          "description": "कोई डेटा लाइनेज इवेंट पाया गया छैन"
        },
        "actions": {
          "redacted": "इस हरूट्री मा संपादित गरिएका जानकारी छ",
          "auditDetail": "डिटेल्स हेर्नुहोस्",
          "lineageReport": "व्यवस्था क्रम विवरण",
          "auditDetailDesc": "गणना विवरण",
          "lineageReportDesc": "व्यवस्था क्रम विवरण"
        }
      },
      "reconciliation": {
        "title": "मेलमिलाप",
        "description": "खाता और पोर्टफोलियो प्रणाली बीच डेटा संरेखीकरण अपेक्षाओं को निगरानी गर्नु और उन्हें समाधान गर्नु",
        "columns": {
          "account": "खाता",
          "exceptionType": "अनियमितता प्रकार",
          "lastAttempt": "पिछला प्रयास",
          "amount": "मात्रा"
        },
        "cards": {
          "failed": {
            "label": "असफल"
          },
          "pending": {
            "label": "KYC विचाराधीन"
          },
          "overdue": {
            "label": "विलंबित"
          }
        },
        "table": {
          "title": "अनियमितता अपेक्षाहरू"
        },
        "empty": "कोई अनियमितता पायी छैन",
        "partialError": "भागीदारी त्रुटि",
        "actions": {
          "exceptionDetail": "अनियमितता विवरण हेर्नुहोस्",
          "openTransaction": "व्यापार खोलें",
          "exceptionDetailDesc": "अनियमितता विवरण",
          "openTransactionDesc": "व्यापार खोलें"
        }
      },
      "taxRules": {
        "title": "कर नियम",
        "description": "कर नियम विवरण",
        "actions": {
          "openFeeChargeRules": "कर शुल्क नियम खोलें",
          "openFeeRules": "व्यय नियम हेर्नुहोस्",
          "review": "कर नियम समीक्षा गर्नुहोस्",
          "reviewDesc": "समीक्षा गर्नुहोस्",
          "openFeeRulesDesc": "प्रारंभिक शुल्क नियम"
        },
        "cards": {
          "shortTerm": {
            "label": "संक्षिप्त अवधि",
            "labelDesc": "संक्षिप्त अवधि"
          },
          "longTerm": {
            "label": "दीर्घकालिक अवधि",
            "labelDesc": "दीर्घकालिक अवधि"
          },
          "institutional": {
            "label": "संस्थागत"
          },
          "sebon": {
            "label": "SEBON"
          },
          "dpCharge": {
            "label": "डीप चार्ज"
          },
          "brokerageBands": {
            "label": "ब्रोकरेज बैंड",
            "hint": "ब्रोकरेज बैंड्स हिंट",
            "labelDesc": "ब्रोकरेज बैंड"
          }
        },
        "rows": {
          "brokerageBand": "ब्रोकरेज बैंड"
        },
        "categories": {
          "brokerage": "ब्रोकरेज",
          "cgt": "सीजीएफटी",
          "regulatory": "नियामक",
          "depository": "व्यापारिक"
        },
        "status": {
          "active": "सक्रिय"
        },
        "table": {
          "columns": {
            "rule": "नियम",
            "category": "श्रेणी",
            "rate": "दर",
            "minimum": "न्यूनतम",
            "status": "स्थिति"
          },
          "title": "कर पात्र"
        },
        "empty": "खाली"
      },
      "feeRules": {
        "title": "शुल्क नियमहरू",
        "description": "प्लेटफर्म शुल्क नियम र प्रभावकारी तालिकाहरू समीक्षा गर्नुहोस्।",
        "table": {
          "title": "शुल्क नियम तालिका"
        },
        "empty": "कुनै शुल्क नियम उपलब्ध छैन।"
      }
    },
    "hubs": {
      "data": {
        "title": "डाटा",
        "description": "लगानी वर्कफ्लोहरूमा प्रयोग हुने सन्दर्भ रेकर्ड, मूल्य, ओपनिङ ब्यालेन्स, कारोबार, र कन्फिगरेसन डाटा मर्मत गर्नुहोस्।",
        "actionLabels": {
          "instruments": "उपकरणहरू व्यवस्थापन गर्नुहोस्",
          "marketData": "मूल्यहरू अपडेट गर्नुहोस्",
          "imports": "कारोबारहरू आयात गर्नुहोस्",
          "dataQuality": "समस्याहरू समीक्षा गर्नुहोस्",
          "lineage": "रेकर्डहरू ट्रेस गर्नुहोस्",
          "reconciliation": "डाटा मिलान गर्नुहोस्",
          "referenceImports": "सन्दर्भ डाटा आयात गर्नुहोस्",
          "marketPriceImports": "बजार मूल्यहरू आयात गर्नुहोस्"
        },
        "emptyStates": {
          "admin": {
            "title": "कुनै डाटा स्रोतहरू कन्फिगर गरिएको छैन",
            "description": "सन्दर्भ डाटा आयात गरेर वा बजार मूल्य फिड सेट अप गरेर सुरु गर्नुहोस्।"
          },
          "nonAdmin": {
            "title": "कुनै डाटा उपलब्ध छैन",
            "description": "डाटा स्रोतहरू कन्फिगर गर्न तपाईंको प्रशासकसँग सम्पर्क गर्नुहोस्।"
          }
        },
        "groups": {
          "reference": {
            "title": "सन्दर्भ डाटा कायम गर्नुहोस्",
            "description": "लगानी वर्कफ्लोहरूद्वारा प्रयोग गरिने सन्दर्भ रेकर्डहरू र सेटअप डाटा।"
          },
          "operational": {
            "title": "गतिविधि थप्नुहोस् वा आयात गर्नुहोस्",
            "description": "परिचालन लगानी गतिविधि सिर्जना गर्नुहोस्, आयात गर्नुहोस्, र अनुमोदन गर्नुहोस्।"
          },
          "trust": {
            "title": "डाटा तयारी प्रमाणित गर्नुहोस्",
            "description": "रिपोर्टिङ अघि तयारी, गुणस्तर, र मेलमिलाप जाँचहरू।"
          },
          "generated": {
            "title": "उत्पन्न डाटा र प्रमाण",
            "description": "उत्पन्न होल्डिङ र रिपोर्ट रन इतिहास समीक्षा गर्नुहोस्।"
          },
          "support": {
            "title": "प्रतिनिधित्व गरिएको समर्थन उपकरणहरू",
            "description": "समर्थन वर्कफ्लोका लागि प्रतिनिधित्व गरिएको डायग्नोस्टिक्स र ट्रेसेबिलिटी।"
          },
          "configuration": {
            "title": "कन्फिगरेसन डाटा",
            "description": "कर नियम, शुल्क नियम, र गणनामा प्रयोग हुने अन्य कन्फिगरेसन रेकर्डहरू व्यवस्थापन गर्नुहोस्।"
          },
          "orgSupport": {
            "title": "संगठन डायग्नोस्टिक्स",
            "description": "सुरक्षित अनुसन्धानका लागि संगठन-स्कोप डायग्नोस्टिक्स, लाइनएज, र अडिट प्रमाण।"
          }
        },
        "cards": {
          "actions": {
            "open": "खोल्नुहोस्",
            "view": "विवरण हेर्नुहोस्",
            "openSupport": "समर्थन दृश्य खोल्नुहोस्"
          },
          "instruments": {
            "title": "उपकरणहरू",
            "description": "उपकरण मास्टर र वर्गीकरण गुणहरू मर्मत गर्नुहोस्।",
            "action": "व्यवस्थापन गर्नुहोस्"
          },
          "issuers": {
            "title": "कम्पनीहरू र इश्यूअरहरू",
            "description": "इश्यूअर र कम्पनी सन्दर्भ विवरणहरू मर्मत गर्नुहोस्।",
            "action": "व्यवस्थापन गर्नुहोस्"
          },
          "marketPrices": {
            "title": "बजार मूल्यहरू",
            "description": "मूल्य स्रोत रेकर्ड, अपलोड, सुधार, र मूल्यांकन तथ्यहरूका लागि पुराना/हराइरहेका मूल्य कभरेज व्यवस्थापन गर्नुहोस्।",
            "action": "अद्यावधिक गर्नुहोस्",
            "viewAction": "बजार मूल्य कभरेज हेर्नुहोस्",
            "manageAction": "बजार मूल्यहरू व्यवस्थापन गर्नुहोस्"
          },
          "benchmarks": {
            "title": "बेञ्चमार्कहरू",
            "description": "बेञ्चमार्क उपकरण र तुलना सेटहरू कन्फिगर गर्नुहोस्।",
            "action": "व्यवस्थापन गर्नुहोस्"
          },
          "openingBalances": {
            "title": "ओपनिङ ब्यालेन्सहरू",
            "description": "पोजिसन सुरु गर्न प्रयोग हुने ओपनिङ ब्यालेन्स स्रोत रेकर्डहरू सिर्जना र मर्मत गर्नुहोस्।",
            "action": "व्यवस्थापन गर्नुहोस्"
          },
          "openingBalanceReadiness": {
            "description": "पोस्ट गर्नु अघि अझै सुधार आवश्यक पर्ने ओपनिङ ब्यालेन्स पङ्क्तिहरू समीक्षा गर्नुहोस्।"
          },
          "taxRules": {
            "title": "वट",
            "description": "VAT गणना, फाइलिङ समर्थन, र मेलमिलाप निदानहरू समीक्षा गर्नुहोस्।",
            "action": "व्यवस्थापन गर्नुहोस्"
          },
          "feeRules": {
            "title": "फी र शुल्क नियमहरू",
            "description": "ब्रोकरज, फी, र शुल्क नियम परिभाषाहरू कन्फिगर गर्नुहोस्।",
            "action": "व्यवस्थापन गर्नुहोस्"
          },
          "corporateActions": {
            "title": "कर्पोरेट कार्यहरू",
            "description": "कर्पोरेट कार्य रेकर्ड र प्रोसेसिङ नियमहरू मर्मत गर्नुहोस्।",
            "action": "व्यवस्थापन गर्नुहोस्"
          },
          "transactions": {
            "title": "कारोबारहरू",
            "description": "तपाईंको हालको स्कोपभित्र कारोबार गतिविधि समीक्षा र कार्यान्वयन गर्नुहोस्।",
            "action": "समीक्षा"
          },
          "createTransaction": {
            "title": "नया व्यापारिक अनुबंध बनाउनुहोस्",
            "description": "एक योग्य पोर्टफोलियो या ग्राहक के लिए एक नया व्यापारिक अनुबंध बनाउनुहोस्।",
            "action": "सिर्जना"
          },
          "bulkTransactions": {
            "title": "थोप लेनदेनहरू",
            "description": "एक ही समय मा कई व्यापारिक अनुबंध बनाउनुहोस्।",
            "action": "सब्सक्राइब गर्नुहोस्"
          },
          "importTransactions": {
            "title": "लेनदेनहरू आयात गर्नुहोस्",
            "description": "व्यापारिक कारोबार फाइलहरू अपलोड गर्नुहोस् र सत्यापन प्रक्रियाहरू चलाउनुहोस्।",
            "action": "आयात"
          },
          "importEvidence": {
            "title": "आयात प्रमाण समीक्षा",
            "description": "आयात जब प्रमाण, असफलता, र सुधार ट्रेस समीक्षा गर्नुहोस्।",
            "action": "समीक्षा"
          },
          "importMarketPrices": {
            "title": "बजार मूल्यहरू आयात गर्नुहोस्",
            "description": "मूल्य अद्यतन के लिए बाजार मूल्य फाइलों को अपलोड गर्नुहोस्।",
            "action": "आयात"
          },
          "importReferenceData": {
            "title": "सन्दर्भ डाटा आयात गर्नुहोस्",
            "description": "निवेश प्रक्रियाहरू द्वारा उपयोग की जाने हुने संदर्भ इकाइयों को अपलोड गर्नुहोस्।",
            "action": "आयात"
          },
          "approvals": {
            "title": "कारोबार कार्यप्रवाह अनुमोदनहरू",
            "description": "विचाराधीन वर्कफ्लो सबमिसनहरू समीक्षा र अनुमोदन गर्नुहोस्।",
            "action": "समीक्षा"
          },
          "reversalsRepairs": {
            "title": "उल्टाउने र मर्मत",
            "description": "योग्य उल्टाउने केस र मर्मत वर्कफ्लोहरू समीक्षा गर्नुहोस्।",
            "action": "समीक्षा"
          },
          "dataQuality": {
            "title": "डाटा गुणस्तर",
            "description": "पोस्ट गरिएको लगानी डाटाभर विश्वास अपवाद र नीति उल्लङ्घनहरू समीक्षा गर्नुहोस्।",
            "action": "समीक्षा"
          },
          "reconciliation": {
            "title": "मेलमिलाप",
            "description": "रिपोर्टिङ अघि मेलमिलाप स्थिति, अपवादहरू र प्रमाण समीक्षा गर्नुहोस्।",
            "action": "समीक्षा गर्नुहोस्"
          },
          "lineage": {
            "title": "डाटा लाइनएज",
            "description": "स्रोत रेकर्डदेखि रिपोर्ट आउटपुटसम्म डाटा लाइनएज ट्रेस गर्नुहोस्।",
            "action": "हेर्नुहोस्"
          },
          "reportReadiness": {
            "title": "रिपोर्ट तयारी",
            "description": "रिपोर्ट इनपुटको तयारी र अवरोधहरू समीक्षा गर्नुहोस्।",
            "action": "हेर्नुहोस्"
          },
          "holdingsSnapshot": {
            "title": "होल्डिङ डाटा",
            "description": "पोस्ट गरिएका कारोबार र बजार मूल्यबाट उत्पन्न होल्डिङ डाटा हेर्नुहोस्।",
            "action": "हेर्नुहोस्"
          },
          "reportRuns": {
            "title": "रिपोर्ट रनहरू",
            "description": "रिपोर्ट उत्पन्न इतिहास र रन स्थिति हेर्नुहोस्।",
            "action": "हेर्नुहोस्"
          },
          "supportTechnicalLineage": {
            "title": "प्राविधिक लाइनएज सन्दर्भ",
            "description": "घटना समीक्षा लागि समर्थन-विशेष लाइनएज सन्दर्भहरू।",
            "action": "खोल्नुहोस्"
          },
          "supportDiagnostics": {
            "title": "समर्थन डायग्नोस्टिक्स",
            "description": "प्रतिनिधित्व गरिएको अनुसन्धानका लागि समर्थन-विशेष डायग्नोस्टिक्स।",
            "action": "खोल्नुहोस्"
          },
          "supportAuditTraces": {
            "title": "अडिट/समर्थन ट्रेसहरू",
            "description": "समर्थन-विशेष अडिट र ट्रेसेबिलिटी सन्दर्भहरू।",
            "action": "खोल्नुहोस्"
          },
          "orgSupportTechnicalLineage": {
            "title": "डाटा लाइनएज डायग्नोस्टिक्स",
            "description": "अनुसन्धानका लागि संगठन-सुरक्षित प्राविधिक लाइनएज सन्दर्भहरू समीक्षा गर्नुहोस्।",
            "action": "खोल्नुहोस्"
          },
          "orgSupportDiagnostics": {
            "title": "डाटा स्वास्थ्य डायग्नोस्टिक्स",
            "description": "डाटा सञ्चालन र शासन वर्कफ्लोका लागि संगठन-सुरक्षित डायग्नोस्टिक्स समीक्षा गर्नुहोस्।",
            "action": "खोल्नुहोस्"
          },
          "orgSupportAuditTraces": {
            "title": "अडिट प्रमाण ट्रेसहरू",
            "description": "संगठन-स्कोप अडिट ट्रेस र प्रमाण सन्दर्भहरू समीक्षा गर्नुहोस्।",
            "action": "खोल्नुहोस्"
          }
        },
        "badges": {
          "locked": "लक",
          "readOnly": "पढ्ने मात्र",
          "unavailable": "डाटा छैन"
        },
        "trustBanner": {
          "title": "डाटा गुणस्तर समीक्षा आवश्यक",
          "detail": "{{count}} समस्या(हरू)ले ड्यासबोर्ड मूल्यहरू र रिपोर्टहरूलाई असर गर्न सक्छ।",
          "action": "डाटा गुणस्तर समीक्षा गर्नुहोस्",
          "detailSingle": "१ समस्याले ड्यासबोर्ड मूल्यहरू र रिपोर्टहरूलाई असर गर्न सक्छ।",
          "detailPlural": "{{count}} समस्याहरूले ड्यासबोर्ड मूल्यहरू र रिपोर्टहरूलाई असर गर्न सक्छ।",
          "readinessTitle": "तयारी"
        },
        "supportSection": {
          "subtitle": "समर्थन वर्कफ्लोहरूको लागि प्रतिनिधित्व गरिएको डायग्नोस्टिक्स र ट्रेसेबिलिटी"
        },
        "snapshots": {
          "exceptions": "अपवादहरू",
          "critical": "गम्भीर",
          "staleCoverage": "पुराना वा हराएका मूल्यहरू",
          "failedReconciliation": "असफल",
          "exceptionsDesc": "अपवादहरू",
          "criticalDesc": "गम्भीर",
          "staleCoverageDesc": "पुरानी कवरेज",
          "failedReconciliationDesc": "असफल संतुलनीकरण"
        }
      },
      "reports": {
        "title": "रिपोर्ट हब",
        "description": "तपाईंको भूमिका र टियर अनुसार उपलब्ध विश्वसनीय पोर्टफोलियो, प्रदर्शन, कर, लेखा, र NFRS रिपोर्टहरू खोज्नुहोस्।",
        "descriptionWithDataQuality": "तपाईंको भूमिका, टियर, र डाटा तयारी अनुसार उपलब्ध विश्वसनीय पोर्टफोलियो, प्रदर्शन, कर, लेखा, NFRS, र डाटा-गुणस्तर रिपोर्टहरू खोज्नुहोस्।"
      },
      "admin": {
        "title": "प्रशासन",
        "description": "संगठन पहुँच, शासन, ग्राहक प्रशासन, र सक्षम नियन्त्रण सतहहरू व्यवस्थापन गर्नुहोस्।",
        "clientAdminSection": {
          "title": "ग्राहक प्रशासन",
          "description": "ग्राहक खाताहरू व्यवस्थापन गर्नुहोस्"
        }
      },
      "generatedSection": {
        "title": "उत्पन्न डाटा र प्रमाण",
        "subtitle": "उत्पन्न होल्डिङ र रिपोर्ट रन इतिहास"
      },
      "supportSection": {
        "title": "समर्थन विभाग",
        "subtitle": "उत्पन्न होल्डिङ र रिपोर्ट रन इतिहास"
      }
    },
    "settings": {
      "title": "सेटिङ्स"
    },
    "investment": {
      "imports": {
        "title": "आयातहरू",
        "description": "व्यापारिक अनुबंध अपलोड, सत्यापन गर्नुहोस्, और प्रतिक्रिया की ट्रेसिंग गर्नुहोस्।",
        "loadingTitle": "लोड हुँदैछ निवेश साधन",
        "loadingDescription": "अपलोड सत्यापन डेटा तैयार करने मा प्रतिकूल छ।",
        "errorTitle": "निवेश साधन लोड छैन हो रहे छं",
        "errorDescription": "अपलोड सत्यापन डेटा लोड छैन हुआ। फिर से जारी रखें।",
        "helperTitle": "निवेश साधन अपलोड करने से पहले",
        "helperSubtitle": " समर्थित स्रोत, सत्यापन व्यवहार, और प्रतिक्रिया ट्रेसिंग।",
        "helperFormats": "सहायक स्रोतों मा CSV/Excel पोर्टफोलियो एक्सपोर्ट और संरचनात्मक नोट के दस्तावेज शामिल छन्।",
        "helperScope": "अनुकूलन पोस्ट करने की स्कोप मा चयनित ग्राहक/ खाता स्कोप मा अनुकूलन पोस्ट किए जाते छं ताकि ऑडिट मालिकता को बनाए रखा जा सके।",
        "helperValidation": "प्रत्येक फाइल की सत्यापन किया जाता छ पहले पोस्ट करने से पहले; विफल रोड्स अभी भी निर्माण विवरणों के साथ ट्रेसेबिल होते छन्।",
        "helperEvidence": "प्रत्येक अनुकूलन एक सत्यापन मार्ग का गठन करता छ जिसमें टाइमस्टैम्प, अभिनेता, रोड आउटकम, और स्रोत मेटाडेटा शामिल छन्।",
        "transactionsContext": "कारोबार आयात सन्दर्भ सक्रिय भयो।",
        "backToTransactions": "कारोबारहरूमा फर्कनुहोस्",
        "viewImportEvidence": "आयात अडिट ट्रेल हेर्नुहोस्",
        "openAuditHub": "अडिट रिपोर्ट हब खोल्नुहोस्",
        "startAnotherTitle": "एक अन्य अनुकूलन शुरू गर्नुहोस्",
        "startAnotherSubtitle": "यह प्रमाण का संदर्भ बनाए रखने के लिए एक नया प्रक्रिया खोलें, इस प्रमाण को दिखाने की सुविधा प्रदान करते हुए।",
        "jobEvidenceTitle": "आयात जब प्रमाण",
        "rowsTitle": "पङ्क्तिहरू",
        "copySuccess": "लिंक कॉपी हुई",
        "copySuccessDescription": "प्रमाण लिंक को क्लिपबोर्ड मा कॉपी गरिएको छ।",
        "copyError": "कॉपी विफल हुई",
        "copyErrorDescription": "लिंक को क्लिपबोर्ड मा कॉपी करने मा असमर्थ छन्।",
        "copyEvidenceLink": "प्रमाण लिंक को कॉपी गर्नुहोस्",
        "evidenceMissingTitle": "नए अनुकूलन नौकरियों का खोज छैन गरिएको",
        "evidenceMissingDescription": "एक अनुकूलन प्रक्रिया शुरू गर्नुहोस् ताकि आप यहां प्रमाण बना सकें।",
        "evidenceMissingAction": "अनुकूलन प्रक्रिया शुरू गर्नुहोस्",
        "evidenceQueueTitle": "नए अनुकूलन के प्रमाण",
        "evidenceQueueDescription": "एक नौकरी छान्नुहोस् जिसमें आप रोड आउटकम, निर्माण कदम, और लाइनेज प्रमाण को देख सकें।",
        "evidenceQueueLoadingTitle": "नए अनुकूलन के प्रमाण लोड होने मा विफल हुआ",
        "evidenceQueueLoadingDescription": "आपकी वर्तमान स्कोप मा नवीनतम नौकरियों को लोड करने मा असमर्थ छन्।",
        "evidenceQueueErrorTitle": "नए अनुकूलन के प्रमाण लोड होने मा विफल हुआ",
        "evidenceQueueError": "पछिल्लो कार्यको प्रमाण लोड गर्न असमर्थ। कृपया पुन: प्रयास गर्नुहोस्।",
        "unknownSourceFile": "अनजान स्रोत फाइल",
        "rowsProcessedSummary": "{{processed}}/{{total}} rowहरो प्रक्रिया पूरा गरिएका",
        "evidenceDisabledTitle": "निरीक्षण साक्ष्य समीक्षा अनुपलब्ध छैन",
        "evidenceDisabledDescription": "संगठनको लागू गरिएको निरीक्षण साक्ष्य सक्रिय छोड़ देने के लिए साक्ष्य दृश्य फिल्टर हटाना आवश्यक छ।",
        "status": "निवेश स्थिति",
        "openDataQualityPage": "ओपन डेटा गुणवत्ता पृष्ठ",
        "evidenceModeActive": "साक्ष्य मोड सक्रिय",
        "importReference": "निर्माण संदर्भ",
        "copyFullReference": "पूर्ण संदर्भ का प्रतिलिपि बनाउनुहोस्",
        "retryFailedRows": "अतिरिक्त गरिएका विफल रोहरो",
        "rows": "रोहरो",
        "failed": "असफल",
        "retries": "पुनः प्रयास",
        "loadingJobTitle": "लोड हुँदैछ नौकरी",
        "loadingJobDescription": "लोड हुँदैछ नौकरी विवरण",
        "rowsDescription": "रोहरो विवरण",
        "rowHeader": "रोहरो सिरा",
        "statusHeader": "स्थिति सिरा",
        "resultHeader": " परिणाम सिरा",
        "createdHeader": " बनाए गए सिरा",
        "errorHeader": " त्रुटि सिरा",
        "actionsHeader": "कार्रवाई सिरा",
        "editRowTitle": "संशोधन खंड",
        "traceRowTitle": "खण्ड अनुसरण",
        "noRowsTitle": "खण्ड कोई छैन",
        "noRowsDescription": "खण्ड कोई छैन विवरण",
        "rowTraceDetails": "खण्ड अनुसरण विवरण",
        "rowTraceTitle": "खण्ड अनुसरण",
        "hideSupportReferences": "सहायता संदर्भ लुकाउनुहोस्",
        "showSupportReferences": "सहायता संदर्भ देखाउनुहोस्",
        "postedRecordLabel": "पोस्ट गरिएको रिकॉर्ड",
        "transactionLabel": "लेनदेन",
        "available": "उपलब्ध",
        "notCreated": "निर्मित छैन",
        "lotsLabel": "खण्ड",
        "realizedFactsLabel": "सिद्ध तथ्य",
        "supportReferences": "सहायता संदर्भ",
        "createdRecordReference": "निर्मित रिकॉर्ड संदर्भ",
        "copyCreatedRecordReference": "निर्मित रिकॉर्ड संदर्भ की प्रति",
        "transactionReference": "व्यापार संदर्भ",
        "copyTransactionReference": "व्यापार संदर्भ की प्रति",
        "editRowRegion": "खण्ड अनुसरण क्षेत्र",
        "editRowHeading": "खण्ड अनुसरण शीर्षक",
        "hideTechnicalRowData": "तकनीकी खण्ड डेटा लुकाउनुहोस्",
        "showTechnicalRowData": "प्रदर्शनी विवरण दिखाएँ",
        "technicalRowPayload": "विवरण पayload",
        "cancelEditing": "संपादन रद्द गर्नुहोस्",
        "rowDataJson": "विवरण डेटा (JSON)",
        "rowDataJsonDescription": "विवरण डेटा (JSON) विवरण",
        "technicalPayloadHidden": "विवरण पayload छिपा हुआ",
        "rowStatus": {
          "pending": "KYC विचाराधीन",
          "processed": "प्रसंस्कृत",
          "failed": "असफल",
          "success": "सफलता",
          "skipped": "छोडियो",
          "retrying": "पुनर्प्रयास कर रहे छं",
          "unknown": "अज्ञात स्थिति"
        },
        "postingResult": {
          "posted": "पोस्ट गरियो",
          "failed": "पोस्टिंग विफल",
          "skipped": "छोडियो",
          "partial": "कम पूर्ण",
          "unknown": "अज्ञात परिणाम"
        },
        "jobStatus": {
          "pending": "KYC विचाराधीन",
          "processing": "प्रशोधन हुँदै",
          "completed": "सम्पन्न",
          "failed": "असफल",
          "cancelled": "रद्द",
          "partial": "कार्य स्थिति कम पूर्ण",
          "unknown": "अज्ञात स्थिति"
        },
        "entityCreation": {
          "created": "सिर्जना गरिएको",
          "notCreated": "निर्माण न गरिएको"
        },
        "errors": {
          "duplicate": "दोहराव हुने प्रविष्टि — रिकॉर्ड पहले से ही मौजूद छ",
          "notFound": "मांगे गए संदर्भ को खोजना असंभव छ",
          "invalid": "अस्थिर डेटा प्रकार",
          "permission": "नियंत्रण अनुमति दी गई छैन",
          "unknown": "प्रसंस्करण विफल हुआ"
        },
        "invalidViewFallback": "अपवादी दृश्य पुनर्स्थापना"
      },
      "settings": {
        "validation": {
          "benchmarkSymbol": "संकेतक को 1-20 अक्षर, संख्या, बिंदु, अंडरस्कोर या हाइफन से बनाउनुहोस्।",
          "benchmarkPeriod": " समर्थन तुलना अवधि छान्नुहोस्।",
          "percentRange": "0 से 100% तक का प्रतिशत दर्ज गर्नुहोस्।",
          "fixBeforeSave": "निर्माण से पहले अपवादों को ठीक गर्नुहोस्।"
        },
        "saveSuccess": "निवेश सेटिङहरू सेवा हुईं।",
        "saveError": "सेटिङहरू को सेव करने मा असमर्थ। कृपया पुन: प्रयास गर्नुहोस्।",
        "saveErrorPermission": "इन सेटिङहरू को सेव करने के लिए आपको अनुमति छैन।",
        "saveErrorValidation": "सेटिङहरू की सत्यापन मा असमर्थ। अपने प्रवेशों पर नज़र भर्नुहोस्।",
        "saveErrorNetwork": "नेटवर्क से एक विफल हुआ। अपने कनेक्शन और पुन: प्रयास गर्नुहोस्।",
        "saveErrorConflict": "अन्य प्रयोगकर्ता द्वारा सेटिङहरू मा बदलाव गरिएको। फिर से लोड गर्नुहोस् और पुन: प्रयास गर्नुहोस्।",
        "loadError": {
          "title": "सेटिङहरू लोड करने मा असमर्थ",
          "description": "सेटिङहरू को लोड करने मा असमर्थ। पुन: प्रयास गर्नुहोस्।"
        },
        "accessDenied": {
          "title": "अनुमति दी गई छैन",
          "message": "निवेश सेटिङहरू तक पहुंचने के लिए आपको अनुमति छैन।"
        },
        "moduleUnavailable": {
          "title": "निवेश मॉड्यूल निष्क्रिय",
          "message": "आपकी संगठनात्मक आवश्यकताओं के लिए निवेश मॉड्यूल सक्षम छैन। अपने प्रशासक से इसे सक्षम गर्नुहोस्।"
        },
        "moduleStatusTitle": "निवेश मॉड्यूल स्थिति",
        "moduleStatusSubtitle": "वर्तमान मॉड्यूल अधिकार और क्षमता स्थिति",
        "moduleStatusState": "निवेश सक्रिय",
        "rebalancingEnabled": "पुनर्वित्तीयन कार्यस्थिति सक्षम",
        "rebalancingDisabled": "पुनर्वित्तीयन कार्यस्थिति असमर्थ",
        "group": {
          "ownership": "मालिकत्व",
          "benchmarkAndRisk": "विश्लेषण और जोखिम सीमाएँ"
        },
        "approvalWorkflowInline": "निगरानी कार्यस्थिति प्रबंधन निगरानी सेटिङहरूमा भेजी गई छ.",
        "openOrgSettings": "निगरानी सेटिङहरू खुली",
        "approvalWorkflowNoAccess": "निगरानी कार्यस्थिति प्रबंधन निगरानी सेटिङहरूमा प्रशासकों द्वारा प्रबंधित होता छ।",
        "secondaryConfigTitle": "प्राथमिक सेटिङहरू के लिए वैकल्पिक सेटिङहरू क्षेत्र",
        "secondaryConfigSubtitle": "स्थिति विवरण प्राथमिक नियंत्रणों पर ध्यान केंद्रित रखने के लिए आवश्यक छन्।",
        "secondaryConfigTier": "प्रतिष्ठा अधिकार: {{tier}}",
        "secondaryConfigRebalancing": "पुनर्वित्तीयन क्षमता: {{state}}",
        "page": {
          "title": "लगानी सेटिङ्स",
          "description": "निवेश मॉड्यूल सेटिङहरू और विकल्पों को निर्धारित गर्नुहोस्।"
        },
        "loading": {
          "title": "ग्राहक खाताहरू लोड गर्दै…",
          "description": "सेटिङ्गहरु लोड गर्दै..."
        },
        "reset": "रिसेट",
        "save": "सेभ गर्नुहोस्"
      },
      "rebalancing": {
        "title": "रिब्यालेन्सिङ",
        "description": "पोर्टफोलियो विचलन समीक्षा गर्नुहोस् र स्वीकृत पुनःसन्तुलन कार्यहरू तयारी गर्नुहोस्।"
      }
    },
    "workflows": {
      "imports": {
        "title": "आयातहरू"
      }
    },
    "admin": {
      "clientAccounts": {
        "searchUnavailable": "खोज अनुपलब्ध",
        "selectedOrganization": "निर्वाचित संगठन",
        "clearOrganization": "संगठन मेटाउनुहोस्",
        "changeOrganization": "संगठन परिवर्तन गर्नुहोस्",
        "selectOrganizationTitle": "संगठन छान्नुहोस्",
        "selectOrganizationDescription": "संगठन विवरण",
        "organizationSearchPlaceholder": "संस्थान खोज",
        "noOrganizationsFound": "संस्थान न पाए गए"
      }
    },
    "role": {
      "platformadmin": "प्लेटफर्म प्रशासक",
      "platformroot": "प्लेटफर्म रुट",
      "platformuser": "प्लेटफर्म प्रयोगकर्ता"
    }
  },
  "shell": {
    "skipToMainContent": "मुख्य सामग्री को स्किप कर्नु",
    "mainContentLabel": "मुख्य सामग्री",
    "defaultOrganizationName": "निवेश पोर्टफोलियो",
    "delegationBanner": {
      "ariaLabel": "प्रतिनिधित्व गरिएको समर्थन सत्र",
      "title": "प्रतिनिधित्व गरिएको समर्थन",
      "organizationLabel": "संगठन",
      "exitAriaLabel": "प्रतिनिधित्व गरिएको समर्थनबाट बाहिरिनुहोस्",
      "exitLabel": "प्रतिनिधित्व अन्त्य गर्नुहोस्"
    },
    "search": {
      "ariaLabel": "खोज या पेज मा जाने के लिए",
      "label": "खोज",
      "keyboardShortcut": "कंट्रोल + के",
      "macShortcut": "⌘K",
      "windowsShortcut": "Ctrl+K"
    },
    "globalNav": {
      "primaryAriaLabel": "प्राथमिक नेविगेशन",
      "moreNavigationItemsAriaLabel": "अधिक नेविगेशन सामग्री"
    },
    "mobileNav": {
      "ariaLabel": "मोबाइल नेविगेशन"
    },
    "breadcrumbs": {
      "ariaLabel": "ब्रेडक्रंब"
    },
    "commandPalette": {
      "dialogAria": "वित्त आदेश प्यालेट",
      "searchPlaceholder": "वित्त पृष्ठमा जान खोज्नुहोस्...",
      "searchAria": "वित्त पृष्ठहरू खोज्नुहोस्",
      "closeAria": "आदेश प्यालेट बन्द गर्नुहोस्",
      "destinationsAria": "पहुँचयोग्य वित्त गन्तव्यहरू",
      "noMatches": "खोजसँग मिल्ने पहुँचयोग्य रुट भेटिएन।",
      "noDestinations": "तपाईंको हालको सन्दर्भका लागि कुनै पहुँचयोग्य पृष्ठ वा आदेश उपलब्ध छैन।",
      "typeToSearch": "थप रेकर्ड र लेनदेन खोज्न टाइप गर्नुहोस्",
      "categories": {
        "pinned": "पिन गरिएको",
        "navigation": "नेभिगेसन",
        "records": "रेकर्डहरू",
        "actions": "कार्यहरू",
        "reports": "रिपोर्ट",
        "data": "डाटा",
        "settings": "सेटिङ्स",
        "admin": "प्रशासन",
        "other": "थप गन्तव्य",
        "recent": "हालसालै",
        "suggested": "सुझाव",
        "operations": "सञ्चालन",
        "portfolio": "ग्राहक, पोर्टफोलियो र बजार डेटा",
        "administration": "प्रशासन",
        "results": "उत्कृष्ट मिलान"
      },
      "pinned": {
        "dashboard": "ड्यासबोर्ड",
        "holdings": "होल्डिङहरू",
        "transactions": "लेनदेनहरू",
        "imports": "आयात",
        "approvals": "अनुमोदनहरू",
        "reports": "रिपोर्टहरू",
        "dataQuality": "डाटा गुणस्तर",
        "marketData": "बजार डाटा",
        "settings": "सेटिङ्स",
        "security": "सुरक्षा",
        "updateMarketData": "व्यापार डेटा अपडेट कर्नु",
        "viewTransactions": "व्यापार ट्रांजैक्शन देख्नु",
        "viewHoldings": "होल्डिङहरू हेर्नुहोस् →",
        "openDashboard": "डैशबोर्ड खोल्नु",
        "reviewDataQuality": "डेटा गुणवत्ता समीक्षा कर्नु",
        "openReports": "रिपोर्ट खोल्नु",
        "manageUsersRoles": "प्रयोगकर्ता & भूमिका प्रबंधित कर्नु",
        "openSettings": "सेटिंग खोल्नु"
      },
      "actions": {
        "addTransaction": "लेनदेन थप्नुहोस्",
        "addTransactionDesc": "नयाँ लेनदेन सिर्जना गर्नुहोस्",
        "bulkTransactions": "थोप लेनदेनहरू",
        "bulkTransactionsDesc": "एकै पटक धेरै लेनदेनहरू आयात गर्नुहोस्",
        "importTransactions": "लेनदेनहरू आयात गर्नुहोस्",
        "importTransactionsDesc": "CSV वा Excel बाट लेनदेनहरू आयात गर्नुहोस्",
        "importReferenceData": "सन्दर्भ डाटा आयात गर्नुहोस्",
        "importReferenceDataDesc": "बजार डाटा र सन्दर्भ जानकारी आयात गर्नुहोस्",
        "importMarketPrices": "बजार मूल्यहरू आयात गर्नुहोस्",
        "importMarketPricesDesc": "NEPSE बाट बजार मूल्यहरू आयात गर्नुहोस्",
        "reviewApprovals": "अनुमोदनहरू समीक्षा गर्नुहोस्",
        "reviewApprovalsDesc": "विचाराधीन अनुमोदन अनुरोधहरू समीक्षा गर्नुहोस्",
        "reviewFailedImports": "असफल आयातहरू समीक्षा गर्नुहोस्",
        "reviewFailedImportsDesc": "असफल आयात सञ्चालनहरू समीक्षा गर्नुहोस् र मर्मत गर्नुहोस्",
        "reverseRepairTransaction": "लेनदेन उल्टाउनुहोस्/मर्मत गर्नुहोस्",
        "reverseRepairTransactionDesc": "लेनदेन उल्टाउनुहोस् वा मर्मत गर्नुहोस्",
        "configureBenchmarks": "बेन्चमार्क कन्फिगर गर्नुहोस्",
        "configureBenchmarksDesc": "प्रदर्शन बेन्चमार्कहरू सेट अप गर्नुहोस्",
        "configureTaxRules": "कर नियम कन्फिगर गर्नुहोस्",
        "configureTaxRulesDesc": "मूल्याङ्कन र रिपोर्टिङमा प्रयोग हुने लगानी कर-नियम कन्फिगरेसन समीक्षा गर्नुहोस्",
        "exportReportTable": "रिपोर्ट तालिका निर्यात गर्नुहोस्",
        "exportReportTableDesc": "वर्तमान रिपोर्ट दृश्यलाई सुरक्षित निर्यात ढाँचामा डाउनलोड गर्नुहोस्"
      },
      "untitledAction": "अनिर्दिष्ट कार्य",
      "untitledDestination": "अनिर्दिष्ट स्थान",
      "refreshing": "खोज नतिजा अद्यावधिक हुँदैछ",
      "retry": "फेरि प्रयास गर्नुहोस्",
      "staleResults": "प्रत्यक्ष नतिजा अद्यावधिक गर्न सकिएन। उपलब्ध मिल्ने गन्तव्यहरू अझै देखाइएका छन्।",
      "browseHint": "अभिलेख, रिपोर्ट, कार्यक्षेत्र र कार्य खोज्न टाइप गर्नुहोस्।",
      "resultKinds": {
        "navigation": "कार्यस्थल",
        "record": "अभिलेख",
        "action": "कार्य"
      },
      "resultLimitHint": "शीर्ष २४ नतिजा देखाइएका छन् — थप विशिष्ट मिलान खोज्न आफ्नो खोज परिष्कृत गर्नुहोस्।"
    },
    "userMenu": {
      "userFallback": "प्रयोगकर्ता",
      "organizationFallback": "संस्था",
      "initialFallback": "प",
      "roleLabel": "भूमिका",
      "tierLabel": "टियर",
      "profilePreferences": "प्रोफाइल र प्राथमिकताहरू",
      "profilePreferencesDescription": "आफ्नो व्यक्तिगत विवरण, भाषा, ढाँचा र स्वरूप व्यवस्थापन गर्नुहोस्।",
      "security": "सुरक्षा र सत्रहरू",
      "securityDescription": "पासवर्ड, बहु-कारक प्रमाणीकरण, पुनःप्राप्ति कोड र सक्रिय सत्रहरू व्यवस्थापन गर्नुहोस्।",
      "scope": {
        "organization": "संस्था स्कोप",
        "client": "ग्राहक स्कोप"
      },
      "triggerLabel": "प्रयोगकर्ता खाता मेनु खोल्नुहोस्",
      "context": {
        "organization": "संस्था",
        "scope": "स्कोप",
        "branch": "शाखा"
      },
      "role": {
        "ORG_ADMIN": "प्रशासक",
        "ORGANIZATION_ADMIN": "प्रशासक",
        "ORG_CLIENT": "ग्राहक",
        "CLIENT_USER": "ग्राहक",
        "ADMIN": "प्रशासक",
        "USER": "प्रयोगकर्ता",
        "UNKNOWN": "प्रयोगकर्ता",
        "PLATFORM_ROOT": "प्लेटफर्म रूट",
        "PLATFORM_ADMIN": "प्लेटफर्म प्रशासक",
        "PLATFORM_USER": "प्लेटफर्म प्रयोगकर्ता"
      },
      "fallback": {
        "settingsDescription": "सेटिङ्स केन्द्र",
        "profileDescription": "प्रयोगकर्ता प्रोफाइल र प्राथमिकताहरू",
        "securityDescription": "पासवर्ड, MFA, र सेसनहरू",
        "notificationsDescription": "सूचना प्राथमिकताहरू"
      },
      "contextLabel": "प्रयोगकर्ता सन्दर्भ",
      "moreRolesTooltip": "भूमिका",
      "switchContext": "सन्दर्भ परिवर्तन गर्नुहोस्",
      "accountActions": "खाता",
      "actionsUnavailable": "खाता",
      "navigationRequestFailed": "खाता नेविगेसन लोड गर्न सकिएन",
      "retryNavigation": "खाता नेविगेसन पुन: प्रयास गर्नुहोस्",
      "logoutError": "साइन आउट असफल",
      "delegated": "प्रतिनिधित्व मोड",
      "tier": {
        "BASIC": "आधारभूत",
        "PROFESSIONAL": "व्यावसायिक",
        "ENTERPRISE": "उद्यम",
        "UNKNOWN": "अज्ञात"
      },
      "actionsConfiguredUnavailable": "No actions configured",
      "switchContextFailed": "कार्यस्थल परिवर्तन गर्न सकिएन। हालको पहुँच सुरक्षित रूपमा मिलाइएको छ; फेरि प्रयास गर्नुहोस्।"
    },
    "trustBadge": {
      "error": "डाटा त्रुटि",
      "warning": "डाटा चेतावनी"
    },
    "moduleSelector": {
      "ariaLabel": "पन्ना चयन",
      "fallback": "मोड्युलहरू"
    },
    "contextSelector": {
      "ariaLabel": "सन्दर्भ परिवर्तन गर्नुहोस्",
      "fallback": "सन्दर्भ चयन गर्नुहोस्",
      "switchSuccess": "सन्दर्भ सफलतापूर्वक परिवर्तन भयो",
      "switchError": "सन्दर्भ परिवर्तन असफल भयो"
    },
    "navigation": {
      "open": "नेविगेशन खोल",
      "homeTitle": "होम",
      "dataTitle": "डाटा",
      "reportsTitle": "रिपोर्टहरू",
      "adminTitle": "प्रशासन",
      "homeDescription": "सक्रिय मोड्युल ड्यासबोर्ड",
      "dataDescription": "रेकर्ड र गुणस्तर",
      "reportsDescription": "प्रमाणित आउटपुटहरू",
      "adminDescription": "प्रयोगकर्ता र अडिट"
    },
    "settingsNav": {
      "investment": {
        "title": "लगानी सेटिङ्स",
        "description": "लगानी मोड्युल सेटिङ्स"
      },
      "accounting": {
        "title": "लेखा सेटिङ्स",
        "description": "लेखा मोड्युल सेटिङ्स"
      },
      "tax": {
        "title": "कर सेटिङ्स",
        "description": "कर मोड्युल सेटिङ्स"
      },
      "organization": {
        "description": "संगठन सेटिङ्स"
      },
      "modules": {
        "description": "मोड्युल व्यवस्थापन र कन्फिगरेसन"
      }
    },
    "activeModule": {
      "resolving": "सक्रिय पन्ना लोड हो भइरहेको छ"
    },
    "topBar": {
      "dataTrust": {
        "error": "डेटा ट्रस्ट त्रुटि",
        "warning": "डेटा ट्रस्ट सूचना",
        "ok": "डेटा ट्रस्ट सही",
        "syncedToday": "आज सिंक हुआ",
        "syncedYesterday": "पिछले दिन सिंक हुआ",
        "syncedDaysAgo": "पूर्व मा सिंक हुआ",
        "instruments": "उपकरणहरू",
        "unknown": "अज्ञात"
      }
    },
    "primaryNavigationLabel": "मुख्य नेभिगेसन"
  },
  "workflow": {
    "transactions": {
      "title": "कारोबारहरू",
      "description": "निवेश व्यापार का समीक्षा, फिल्टर, बनाने, आयात करने, और निकालने की प्रक्रिया।"
    },
    "createTransaction": {
      "title": "निवेश व्यापार लेनदेन बनाउनुहोस्",
      "description": "निवेश व्यापार लेनदेन को सत्यापन और मंजूरी संचालन के साथ रिकॉर्ड गर्नुहोस्।"
    },
    "approvals": {
      "title": "अनुमोदनहरू",
      "description": "निवेश व्यापार लेनदेन के प्रतीक्षित मंजूरी और अपवादों का समीक्षा गर्नुहोस्।"
    },
    "imports": {
      "title": "लेनदेनहरू आयात गर्नुहोस्",
      "description": "निवेश व्यापार लेनदेन को CSV या Excel फाइल से आयात गर्नुहोस्।"
    },
    "rebalancing": {
      "title": "पोर्टफोलियो संतुलनीकरण",
      "description": "पोर्टफोलियो संतुलनीकरण रणनीतियों का विश्लेषण और लागू गर्नुहोस्।"
    },
    "settings": {
      "title": "लगानी सेटिङ्स",
      "description": "निवेश पन्ने सेटिङहरू और पसंदों को निर्धारित गर्नुहोस्।",
      "validation": {
        "benchmarkSymbol": "1-20 अक्षर, संख्या, बिंदु, अंडरस्कोर या हाइफन से बने लेबल का उपयोग गर्नुहोस्।",
        "benchmarkPeriod": " समर्थित तुलना अवधि छान्नुहोस्।",
        "percentRange": "0 से 100% तक की प्रतिशत सीमा।",
        "fixBeforeSave": "पूर्व-बच्चने त्रुटियों को ठीक कर्ने पूर्व सेवा"
      },
      "saveSuccess": "निवेश सेटिङहरू सेवा होला",
      "saveError": "सेटिङहरू सेवा न होला",
      "moduleStatusTitle": "निवेश मोड्यूल की स्थिति",
      "moduleStatusSubtitle": "त्रिय: {{tier}} · पुनर्गणना: {{state}}",
      "moduleStatusState": "सक्रिय",
      "approvalWorkflowInline": "निगरानी कार्यक्रम व्यवस्था निगरानी सेटिङहरूमा प्रबंधित होला",
      "openOrgSettings": "निगरानी सेटिङहरू खुल्नु",
      "group": {
        "ownership": "मालिकत्व",
        "benchmarkAndRisk": "स्तर और जोखिम सीमाएँ"
      },
      "secondaryConfigTitle": "प्राथमिक नियंत्रण को केंद्रित रखने के लिए वैकल्पिक सेटिङहरू का परिदृश्य",
      "secondaryConfigSubtitle": "स्थिति विवरण आवश्यकतानुसार उपलब्ध छ ताकि प्राथमिक नियंत्रणों को ध्यान मा रखा जा सके।",
      "secondaryConfigTier": "स्तर अधिकृतता: {{tier}}",
      "secondaryConfigRebalancing": "पुनर्गणना क्षमता: {{state}}"
    },
    "marketDataSettings": {
      "title": "बाजार डेटा सेटिङहरू",
      "description": "बाजार डेटा स्रोतों और मूल्य संश्लेषण निर्देशित गर्नुहोस्।",
      "feedSource": "बाजार की मूल्य पीडी",
      "policyTitle": "प्रदाता और नवाचार नीति",
      "policyDescription": "यह पृष्ठ इस पेज पर प्रदाता नीति और नियंत्रण संचालनों को प्रबंधित करने के लिए उपयोग गर्नुहोस्। ऑपरेशनल इम्पोर्ट और मूल्य सुधार बाजार डेटा वर्कस्पेसमा होला",
      "operationalBoundary": {
        "title": "ऑपरेशनल फ्लो विवरण जीवित डेटा > बाजार डेटा",
        "description": "ऑपरेशनल पेज का उपयोग करके मूल्यों की समीक्षा, सimbोल-स्तरीय नवाचार की समीक्षा और शून्य मूल्यों को ठीक करने के लिए।"
      },
      "actions": {
        "openDataQuality": "डाटा गुणस्तर",
        "openOperationalPage": "प्राप्तानीय बाजार डेटा संचालन खोल्ने की कार्य"
      },
      "governance": {
        "title": "नियामक जांच",
        "subtitlePrefix": "अनियमित डेटा अपदेश और पुनर्मूल्यीकरण संकेत निवारणमा",
        "subtitleSuffix": "लोड हो रहेको छ...",
        "items": {
          "provider": "प्राप्तानीय बाजार-डेटा प्रदाता परिभाषित गर्ने र अपक्षय संकेत निवारणमा",
          "freshness": "सัญच्य को मूल्यापन या व्यापार कार्यान्वयन कार्यक्रममा बाधा पात्र सัญच्य को ताजगी नीति निर्धारण गर्ने",
          "remediation": "ऑपरेशनल बाजार-डेटा पृष्ठको लागि निर्देशित गर्ने र डेटा ठीक कार्यान्वयन र अपलोड संचालनमा"
        }
      }
    }
  },
  "auth": {
    "username": "प्रयोगकर्ता नाम",
    "usernamePlaceholder": "आफ्नो प्रयोगकर्ता नाम प्रविष्ट गर्नुहोस्",
    "password": "पासवर्ड",
    "passwordPlaceholder": "आफ्नो पासवर्ड प्रविष्ट गर्नुहोस्",
    "passwordRequirement": "पासवर्ड कम्तिमा ८ अक्षर हुनुपर्छ",
    "forgotPassword": {
      "title": "पासवर्ड बिर्सनुभयो",
      "instructions": "आफ्नो इमेल ठेगाना प्रविष्ट गर्नुहोस्। खाता योग्य भए पासवर्ड रिसेट निर्देशन पठाइनेछ।",
      "email": "इमेल ठेगाना",
      "submit": "रिसेट लिंक पठाउनुहोस्",
      "sending": "पठाइँदैछ…",
      "error": "रिसेट निर्देशन पठाउन सकिएन। पुनः प्रयास गर्नुहोस्।",
      "successTitle": "आफ्नो इमेल जाँच गर्नुहोस्",
      "successMessage": "योग्य खाता भए पासवर्ड रिसेट निर्देशन पठाइएको छ। लिंक एक घण्टापछि म्याद सकिन्छ।",
      "sendAnother": "अर्को इमेल पठाउनुहोस्",
      "backToLogin": "लगइनमा फर्कनुहोस्"
    },
    "resetPassword": {
      "title": "पासवर्ड रिसेट गर्नुहोस्",
      "tokenRequired": "रिसेट टोकन आवश्यक छ",
      "invalidTitle": "अमान्य रिसेट लिंक",
      "invalidMessage": "यो पासवर्ड रिसेट लिंक अमान्य छ वा म्याद सकिएको छ।",
      "requestNew": "नयाँ रिसेट लिंक अनुरोध गर्नुहोस्",
      "newPassword": "नयाँ पासवर्ड",
      "confirmPassword": "नयाँ पासवर्ड पुष्टि गर्नुहोस्",
      "submit": "पासवर्ड रिसेट गर्नुहोस्",
      "resetting": "रिसेट हुँदैछ…",
      "error": "पासवर्ड रिसेट गर्न सकिएन। नयाँ लिंक अनुरोध गरी पुनः प्रयास गर्नुहोस्।",
      "successTitle": "पासवर्ड सफलतापूर्वक रिसेट भयो",
      "successMessage": "तपाईंको पासवर्ड अद्यावधिक भयो। अब नयाँ पासवर्डले साइन इन गर्न सक्नुहुन्छ।",
      "signIn": "साइन इन गर्नुहोस्"
    },
    "contactAdminUnlock": "तपाईंको खाता खोल्न कृपया प्रणाली प्रशासकलाई सम्पर्क गर्नुहोस्।",
    "awaitingApproval": "तपाईंको खाता प्रशासकको अनुमोदनको पर्खाइमा छ। अनुमोदन भएपछि तपाईंलाई सूचित गरिनेछ।",
    "signingIn": "साइन इन गर्दै...",
    "signIn": "साइन इन गर्नुहोस्",
    "loginHeadline": "तपाईंको खातामा साइन इन गर्नुहोस्",
    "setupHeadline": "पहिलो प्रशासक र संस्था सेटअप गर्नुहोस्",
    "termsOfService": "सेवा शर्तहरू",
    "privacyPolicy": "गोपनीयता नीति",
    "loginForm": {
      "usernameRequired": "कृपया प्रयोगकर्ता नाम प्रविष्ट गर्नुहोस् (कम्तिमा ३ अक्षर)",
      "passwordRequired": "कृपया पासवर्ड प्रविष्ट गर्नुहोस् (कम्तिमा ८ अक्षर)"
    },
    "apiErrors": {
      "loginFailed": "लगइन असफल",
      "contextSelectionFailed": "सन्दर्भ चयन असफल",
      "mfaVerificationFailed": "MFA प्रमाणीकरण असफल",
      "mfaEnrollmentFailed": "MFA दर्ता असफल",
      "mfaConfirmationFailed": "MFA पुष्टिकरण असफल",
      "mfaDisableFailed": "MFA निष्क्रिय गर्न असफल",
      "backupCodesRegenerationFailed": "बैकअप कोड पुनः उत्पन्न गर्न असफल",
      "passwordResetEmailFailed": "पासवर्ड रिसेट इमेल पठाउन असफल",
      "passwordResetFailed": "पासवर्ड रिसेट असफल",
      "tokenRefreshFailed": "टोकिन रिफ्रेस असफल",
      "profileLoadFailed": "प्रोफाइल लोड गर्न असफल",
      "logoutFailed": "लगआउट असफल",
      "noMfaChallengeToken": "MFA च्यालेन्ज टोकन छैन",
      "recentAuthRequired": "हालको प्रमाणीकरण आवश्यक छ। जारी राख्न कृपया आफ्नो प्रमाणपत्र प्रमाणित गर्नुहोस्।"
    },
    "setupWizard": {
      "errors": {
        "organizationNameRequired": "संस्थाको नाम आवश्यक छ",
        "organizationCodeRequired": "संस्थाको कोड आवश्यक छ",
        "usernameRequired": "प्रयोगकर्ता नाम आवश्यक छ",
        "usernameTooShort": "प्रयोगकर्ता नाम कम्तिमा ३ अक्षर हुनुपर्छ",
        "adminEmailRequired": "प्रशासक इमेल आवश्यक छ",
        "invalidEmail": "कृपया मान्य इमेल ठेगाना प्रविष्ट गर्नुहोस्",
        "passwordRequirements": "पासवर्ड कम्तिमा ८ अक्षर र अक्षर र संख्या समावेश हुनुपर्छ",
        "passwordMismatch": "पासवर्ड मेल खान्छैन",
        "invalidPan": "PAN नम्बर ठीक ९ अल्फान्युमेरिक अक्षर हुनुपर्छ",
        "invalidVat": "VAT नम्बर ९-१२ अंक हुनुपर्छ",
        "registrationFailed": "दर्ता असफल",
        "noOrganizationId": "कुनै संस्था आईडी भेटिएन",
        "importWithWarnings": "आयात चेतावनीहरूसँग सम्पन्न भयो",
        "importFailed": "फाइल आयात गर्न असफल"
      },
      "defaults": {
        "adminUser": "प्रशासक",
        "adminSurname": "प्रशासन"
      },
      "progress": {
        "readingExcel": "Excel फाइल पढ्दै...",
        "importComplete": "सम्पन्न। आयात गरियो"
      },
      "checkmark": "✓",
      "separator": "›",
      "steps": {
        "createAdmin": "प्रशासक बनाउनुहोस्",
        "importData": "डाटा आयात गर्नुहोस्",
        "done": "सम्पन्न"
      },
      "labels": {
        "organizationName": "संस्थाको नाम",
        "organizationCode": "संस्थाको कोड",
        "adminUsername": "प्रशासक प्रयोगकर्ता नाम",
        "adminEmail": "प्रशासक इमेल",
        "panNumber": "PAN नम्बर",
        "vatNumber": "VAT नम्बर",
        "address": "ठेगाना",
        "phone": "फोन",
        "password": "पासवर्ड",
        "confirmPassword": "पासवर्ड पुष्टि गर्नुहोस्",
        "enabledModules": "सक्षम मोड्युलहरू",
        "initialFiscalYear": "प्रारम्भिक आर्थिक वर्ष",
        "fiscalYearLabel": "आर्थिक वर्ष लेबल",
        "fiscalYearStart": "आर्थिक वर्ष सुरु मिति",
        "fiscalYearEnd": "आर्थिक वर्ष अन्त्य मिति"
      },
      "placeholders": {
        "organizationName": "उदाहरण निगमीय बाजार प्राइवेट लिमिटेड",
        "organizationCode": "निगम कोड",
        "username": "प्रशासक_उचित",
        "email": "प्रशासक@उदाहरण.com",
        "address": "दर्ता गरिएको ठेगाना",
        "password": "कम्तिमा ८ अक्षर",
        "confirmPassword": "पासवर्ड दोहोर्याउनुहोस्",
        "fiscalYearLabel": "आर्थिक वर्ष लेबल"
      },
      "modules": {
        "investment": "लगानी",
        "accounting": "लेखापरीक्षा",
        "inventory": "इन्भेन्टरी"
      },
      "info": {
        "firstRunRequired": "पहिलो पटक सेटअप छोड्न सकिँदैन किनकि अनुप्रयोगमा अहिलेसम्म कुनै सञ्चालक खाता छैन।",
        "selectWorkbook": "कम्पनीहरूको सूची र प्रति-कम्पनी कारोबार सिटहरू समावेश गर्ने वर्कबुक चयन गर्नुहोस्।"
      },
      "buttons": {
        "creatingAccount": "खाता बनाइँदै…",
        "createOrganizationAndAdmin": "संस्था र प्रशासक बनाउनुहोस्",
        "goToDashboard": "ड्यासबोर्डमा जानुहोस्"
      },
      "titles": {
        "importExistingData": "अवस्थित डाटा आयात गर्नुहोस्",
        "setupComplete": "सेटअप सम्पन्न"
      },
      "descriptions": {
        "importOption": "इच्छाअनुसार तपाईंको कम्पनी मास्टर र कारोबार इतिहास Excel फाइलबाट लोड गर्नुहोस्। तपाईं खाली सुरु गरेर पछि आयात गर्न सक्नुहुन्छ।",
        "workspaceReady": "तपाईंको पोर्टफोलियो कार्यस्थल तयार छ।"
      }
    },
    "forcedPasswordChange": {
      "successMessage": "पासवर्ड अद्यावधिक गरियो। तपाईंले अनुप्रयोगमा जारी राख्न सक्नुहुन्छ।",
      "title": "तपाईंको बुटस्ट्र्याप पासवर्ड परिवर्तन गर्नुहोस्",
      "description": "{{username}} ले प्रारम्भिक विशेषाधिकार प्राप्त प्रमाणपत्र प्रयोग गर्दै हुनुहुन्छ। बाँकी उत्पादन पहुँच गर्नुअघि यसलाई परिवर्तन गर्नुहोस्।",
      "thisAccount": "यो खाता",
      "labels": {
        "currentPassword": "हालको पासवर्ड",
        "newPassword": "नयाँ पासवर्ड",
        "confirmPassword": "नयाँ पासवर्ड पुष्टि गर्नुहोस्"
      },
      "passwordRequirements": "कम्तिमा ८ र अधिकतम १२८ अक्षर प्रयोग गर्नुहोस्, जसमा कम्तिमा एक अक्षर र एक संख्या हुनुपर्छ।",
      "errors": {
        "title": "पासवर्ड परिवर्तन असफल"
      },
      "successTitle": "सफलता",
      "buttons": {
        "updating": "पासवर्ड अद्यावधिक गर्दै...",
        "update": "पासवर्ड अद्यावधिक गर्नुहोस्",
        "signOut": "साइन आउट गर्नुहोस्"
      }
    },
    "initialSetup": {
      "errors": {
        "emailRequired": "मान्य इमेल ठेगाना आवश्यक छ",
        "firstNameRequired": "पहिलो नाम आवश्यक छ",
        "surnameRequired": "थर आवश्यक छ",
        "passwordTooShort": "पासवर्ड कम्तिमा १२ अक्षर हुनुपर्छ",
        "passwordRequirements": "पासवर्डमा ठूला अक्षर, साना अक्षर र संख्या समावेश हुनुपर्छ",
        "passwordMismatch": "पासवर्ड मेल खान्छैन",
        "creationFailed": "रूट प्रयोगकर्ता बनाउन असफल"
      },
      "creating": "प्लेटफर्म रूट बनाइँदै...",
      "creatingDescription": "कृपया प्रतीक्षा गर्नुहोस्, हामी प्रारम्भिक प्रशासक सेटअप गर्दै छौं",
      "successTitle": "प्लेटफर्म रूट सिर्जना गरियो!",
      "redirecting": "लगइनमा पुनर्निर्देशित गर्दै...",
      "firstNamePlaceholder": "पहिलो नाम",
      "lastNamePlaceholder": "थर",
      "title": "प्रारम्भिक सेटअप",
      "subtitle": "उपशीर्षक",
      "labels": {
        "firstName": "पहिलो नाम",
        "surname": "थर",
        "email": "इमेल",
        "password": "पासवर्ड",
        "confirmPassword": "पासवर्ड पुष्टि गर्नुहोस्"
      },
      "placeholders": {
        "email": "इमेल",
        "password": "पासवर्ड",
        "confirmPassword": "पासवर्ड पुष्टि गर्नुहोस्"
      },
      "showPassword": "पासवर्ड देखाउनुहोस्",
      "createButton": "सिर्जना गर्नुहोस्",
      "info": "जानकारी"
    },
    "login": {
      "title": "साइन इन",
      "email": "इमेल",
      "password": "पासवर्ड",
      "submit": "साइन इन",
      "invalidCredentials": "अमान्य इमेल वा पासवर्ड",
      "localSignOutWarning": "तपाईंलाई यो डिभाइसमा साइन आउट गरिएको छ। रिमोट सेशन खारेज गर्न सकिएन — यो स्वतः समाप्त हुनेछ। यदि तपाईं चिन्तित हुनुहुन्छ भने, अर्को डिभाइसबाट आफ्नो सेशनहरू खारेज गर्नुहोस्।",
      "signingIn": "साइन इन हुँदैछ…"
    },
    "mfa": {
      "title": "बहु-कारक प्रमाणीकरण",
      "enterCode": "तपाईंको प्रमाणीकरण कोड प्रविष्ट गर्नुहोस्",
      "useRecoveryCode": "रिकभरी कोड प्रयोग गर्नुहोस्",
      "invalidCode": "अमान्य प्रमाणीकरण कोड",
      "enroll": "MFA दर्ता गर्नुहोस्",
      "stepUp": {
        "title": "आफ्नो परिचय प्रमाणित गर्नुहोस्",
        "description": "उच्च विशेषाधिकार आवश्यक",
        "privilegesRequired": "यो कार्यको लागि बहु-कारक प्रमाणीकरण आवश्यक छ। जारी राख्न कृपया MFA दर्ता गर्नुहोस् वा प्रमाणित गर्नुहोस्।",
        "notEnrolled": "यो कार्य गर्न तपाईंले बहु-कारक प्रमाणीकरणमा दर्ता गर्नुपर्छ।",
        "alreadyEnrolled": "तपाईंको खातामा बहु-कारक प्रमाणीकरण सक्षम छ। कृपया साइन आउट गरेर MFA कोडसहित पुनः साइन इन गर्नुहोस् वा प्रशासकलाई सम्पर्क गर्नुहोस्।"
      }
    },
    "logout": {
      "success": "तपाईंलाई साइन आउट गराइयो"
    },
    "context": {
      "switch": "सन्दर्भ स्विच गर्नुहोस्",
      "organization": "संस्था",
      "branch": "शाखा"
    },
    "validation": {
      "invalidEmail": "मान्य इमेल ठेगाना प्रविष्ट गर्नुहोस्",
      "passwordRequired": "पासवर्ड आवश्यक छ",
      "passwordMinLength": "पासवर्ड कम्तीमा ८ अक्षरको हुनुपर्छ",
      "passwordsMismatch": "पासवर्डहरू मेल खाँदैनन्",
      "passwordTooShort": "पासवर्ड कम्तिमा ८ अक्षरको हुनुपर्छ",
      "passwordMismatch": "पासवर्डहरू मेल खाँदैनन्"
    },
    "contextSelection": {
      "title": "आफ्नो कार्यस्थल छान्नुहोस्",
      "description": "यस सत्रमा प्रयोग गर्न चाहेको संगठन र शाखा छान्नुहोस्।",
      "continue": "जारी राख्नुहोस्",
      "back": "अर्को खाता प्रयोग गर्नुहोस्",
      "error": "छानिएको कार्यस्थल खोल्न सकिएन। पुनः प्रयास गर्नुहोस्।"
    },
    "mfaChallenge": {
      "title": "दुई-चरण प्रमाणीकरण",
      "description": "जारी राख्न आफ्नो पहिचान पुष्टि गर्नुहोस्।",
      "instructions": "आफ्नो प्रमाणीकरण एपको ६-अङ्कको कोड प्रविष्ट गर्नुहोस्।",
      "codeLabel": "प्रमाणीकरण कोड",
      "codeError": "मान्य ६-अङ्कको कोड प्रविष्ट गर्नुहोस्",
      "verify": "पुष्टि गर्नुहोस्",
      "verifying": "पुष्टि हुँदैछ…",
      "invalid": "प्रमाणीकरण कोड पुष्टि गर्न सकिएन। पुनः प्रयास गर्नुहोस्।",
      "expired": "यो प्रमाणीकरण अनुरोधको म्याद सकिएको छ। लगइनमा फर्केर पुनः प्रयास गर्नुहोस्।"
    },
    "initialPasswordChange": {
      "title": "आफ्नो पासवर्ड परिवर्तन गर्नुहोस्",
      "description": "अघि बढ्नु अघि तपाईंले नयाँ पासवर्ड सेट गर्नुपर्छ।",
      "newPassword": "नयाँ पासवर्ड",
      "confirmPassword": "नयाँ पासवर्ड पुनः प्रविष्ट गर्नुहोस्",
      "submit": "पासवर्ड परिवर्तन गर्नुहोस्",
      "submitting": "पासवर्ड परिवर्तन हुँदैछ…",
      "backToLogin": "लगइनमा फर्कनुहोस्"
    }
  },
  "settings": {
    "title": "सेटिङ्स",
    "summary": {
      "title": "खाता सारांश"
    },
    "hub": {
      "title": "सेटिङ्स केन्द्र"
    },
    "profile": {
      "title": "प्रोफाइल",
      "description": "आपको निजी जानकारी",
      "name": "नाम",
      "firstName": "पहिलो नाम",
      "lastName": "थर",
      "email": "इमेल",
      "phone": "फोन",
      "mfa": "MFA",
      "mfaEnabled": "सक्षम",
      "mfaDisabled": "अक्षम",
      "status": "स्थिति",
      "credentialSource": "प्रमाण स्रोत",
      "localPassword": "स्थानीय पासवर्ड",
      "sso": "एकल साइन-ओन",
      "emailReadOnly": "संगठन",
      "mfaReadOnly": "सुरक्षा सेटिङ पृष्ठमा MFA व्यवस्थापन गर्नुहोस्।",
      "statusReadOnly": "खाता",
      "firstNameRequired": "पहिलो नाम आवश्यक छ",
      "lastNameRequired": "थर आवश्यक छ",
      "phoneInvalid": "फोन नम्बर अमान्य छ",
      "saved": "प्रोफाइल सफलतापूर्वक सुरक्षित भयो",
      "helpText": {
        "firstName": "नियामक कागजातमा देखिने तपाईंको कानुनी पहिलो नाम।",
        "lastName": "नियामक कागजातमा देखिने तपाईंको कानुनी थर।",
        "email": "साइन-इन र खाता सञ्चारका लागि प्रयोग हुने तपाईंको प्राथमिक इमेल ठेगाना।",
        "phone": "खाता पुनःप्राप्ति र सहयोगका लागि वैकल्पिक सम्पर्क फोन नम्बर।",
        "status": "तपाईंको खाताको हालको स्थिति। सक्रियता सम्बन्धी सहयोग आवश्यक भए समर्थन टोलीलाई सम्पर्क गर्नुहोस्।"
      },
      "saveError": "प्रोफाइल सुरक्षित गर्न सकिएन। जानकारी जाँच गरी पुनः प्रयास गर्नुहोस्।",
      "sectionNavigation": "प्रोफाइल र प्राथमिकताहरू"
    },
    "organization": {
      "title": "निगम र शाखा",
      "organization": "संस्था",
      "branch": "शाखा",
      "selectOrganization": "निगम चुन्ने",
      "selectTenant": "शाखा छान्नुहोस्"
    },
    "security": {
      "title": "सुरक्षा",
      "manageMfa": "MFA प्रबंधित गर्ने",
      "changePassword": "पासवर्ड बदल्न",
      "manageSessions": "सेशन प्रबंधित गर्नु",
      "logout": "बाहिर जाना",
      "ssoPasswordNote": "तपाईंको खाताले एकल साइन-ओन (SSO) प्रयोग गर्छ। पासवर्ड परिवर्तनहरू तपाईंको पहिचान प्रदायकद्वारा व्यवस्थापन गरिन्छ।",
      "overviewTitle": "सुरक्षा अवलोकन",
      "overviewLoadError": "सुरक्षा अवलोकन लोड गर्न असफल",
      "manageSecurity": "सुरक्षा प्रबंधन",
      "manageSecurityDescription": "तपाईंको प्रमाणीकरण सेटिङहरू समीक्षा र अपडेट गर्नुहोस्",
      "mfaStatus": "मल्टी-फ्याक्टर प्रमाणीकरण",
      "mfaEnabled": "सक्षम",
      "mfaNotEnabled": "सक्षम छैन",
      "activeSessionsCount": "{{count}} सक्रिय सेशन(हरू)",
      "passwordCardDescription": "तपाईंको खाता पासवर्ड बदल्नुहोस्",
      "mfaCardDescription": "द्वि-कारक प्रमाणीकरण र पुनर्प्राप्ति कोडहरू प्रबंधित गर्नुहोस्",
      "sessionsCardDescription": "सक्रिय सेशनहरू हेर्नुहोस् र खारेज गर्नुहोस्",
      "sectionNavigation": "सुरक्षा र सत्रहरू",
      "helpText": {
        "currentPassword": "सुरक्षा परिवर्तन अघि आफ्नो पहिचान पुष्टि गर्न हालको पासवर्ड प्रविष्ट गर्नुहोस्।",
        "newPassword": "ठूलो अक्षर, संख्या र प्रतीकसहित कम्तीमा १२ वर्णको बलियो पासवर्ड बनाउनुहोस्।",
        "confirmPassword": "नयाँ पासवर्ड ठ्याक्कै मिलेको पुष्टि गर्न फेरि प्रविष्ट गर्नुहोस्।",
        "totpCode": "यो संवेदनशील पासवर्ड परिवर्तन पुष्टि गर्न आफ्नो प्रमाणीकरण एपको हालको ६-अङ्के कोड प्रविष्ट गर्नुहोस्।",
        "mfaMethod": "बहु-कारक प्रमाणीकरणले अनधिकृत पहुँचबाट खाता जोगाउन थप सुरक्षा तह दिन्छ।",
        "backupCodes": "यी पुनःप्राप्ति कोड सुरक्षित स्थानमा राख्नुहोस्। MFA उपकरण हराएमा खाता पहुँच गर्न प्रयोग गर्न सकिन्छ।",
        "recoveryEmail": "प्राथमिक इमेल उपलब्ध नभए खाता पुनःप्राप्तिका लागि वैकल्पिक इमेल तोक्नुहोस्।"
      }
    },
    "password": {
      "title": "पासवर्ड परिवर्तन गर्नुहोस्",
      "description": "खाता",
      "currentPassword": "हालको पासवर्ड",
      "newPassword": "नयाँ पासवर्ड",
      "confirmPassword": "नयाँ पासवर्ड पुष्टि गर्नुहोस्",
      "totpCode": "प्रमाणीकरण कोड",
      "submit": "पासवर्ड परिवर्तन गर्नुहोस्",
      "success": "पासवर्ड सफलतापूर्वक परिवर्तन भयो",
      "mismatch": "नयाँ पासवर्डहरू मेल खाँदैनन्",
      "currentRequired": "हालको पासवर्ड आवश्यक छ",
      "newRequired": "नयाँ पासवर्ड आवश्यक छ",
      "strength": "पासवर्ड कम्तिमा ८ अक्षरको हुनुपर्छ र मिश्रित केस, नम्बर र प्रतीकहरू समावेश हुनुपर्छ",
      "sameAsCurrent": "नयाँ पासवर्ड हालको पासवर्डभन्दा फरक हुनुपर्छ",
      "ssoNote": "तपाईंको खाताले एकल साइन-अन (SSO) प्रयोग गर्दछ। पासवर्ड परिवर्तनहरू तपाईंको पहिचान प्रदायकद्वारा व्यवस्थापन गरिन्छ।",
      "sessionsRevoked": "अन्य सबै सक्रिय सत्रहरू खारेज गरिएका छन्।",
      "capsLock": "Caps Lock अन छ",
      "strengthMeter": {
        "label": "पासवर्ड शक्ति",
        "weak": "कमजोर",
        "fair": "उचित",
        "good": "राम्रो",
        "strong": "बलियो"
      },
      "error": "पासवर्ड परिवर्तन गर्न सकिएन। आवश्यकताहरू जाँच गरी पुनः प्रयास गर्नुहोस्।"
    },
    "sessions": {
      "title": "सक्रिय सत्रहरू",
      "description": "सत्रहरू हेर्नुहोस् र व्यवस्थापन गर्नुहोस्",
      "device": "उपकरण",
      "ipAddress": "IP ठेगाना",
      "createdAt": "साइन इन",
      "current": "हालको सत्र",
      "revoke": "साइन आउट",
      "revokeSuccess": "सत्र समाप्त भयो",
      "revokeConfirm": "यो सत्र अन्त्य गर्ने?",
      "empty": "कुनै सक्रिय सत्रहरू फेला परेनन्",
      "summary": "सक्रिय सत्रहरू समीक्षा र खारेज गर्नुहोस्।",
      "revokeAllOthers": "अन्य सबै उपकरणहरूबाट साइन आउट गर्नुहोस्",
      "revokeAllSuccess": "अन्य सबै उपकरणहरूबाट साइन आउट गरिएको छ।",
      "currentDeviceFallback": "यो ब्राउजर",
      "otherDeviceFallback": "अर्को साइन-इन सत्र",
      "lastActivityAt": "पछिल्लो सत्र रिफ्रेस भएको समय",
      "expiresAt": "समाप्त हुने समय",
      "strongAuthentication": "बलियो प्रमाणीकरण (MFA पुष्टि गरिएको)",
      "standardAuthentication": "मानक प्रमाणीकरण",
      "helpText": {
        "sessions": "सबै सक्रिय सत्र समीक्षा गर्नुहोस्। अनधिकृत पहुँचको शङ्का भए अन्य उपकरणका सत्र रद्द गर्न सक्नुहुन्छ।",
        "signOut": "यो उपकरणबाट तुरुन्त साइन आउट गर्नुहोस्। स्थानीय सत्र अवस्था हटाइनेछ।"
      },
      "unknownDevice": "अज्ञात उपकरण",
      "aal": "प्रमाणीकरण स्तर",
      "revokeError": "सत्र रद्द गर्न सकिएन। पुनः प्रयास गर्नुहोस्।",
      "revokeAllError": "अन्य सत्रहरू रद्द गर्न सकिएन। पुनः प्रयास गर्नुहोस्।",
      "confirmAllTitle": "अन्य सबै सत्र रद्द गर्ने?",
      "confirmAllMessage": "यसले अर्को {{count}} सत्रबाट साइन आउट गर्नेछ। हालको सत्र सक्रिय रहनेछ।",
      "confirmAllMessage_other": "यसले अन्य {{count}} सत्रबाट साइन आउट गर्नेछ। हालको सत्र सक्रिय रहनेछ।"
    },
    "preferences": {
      "title": "अनुरोध",
      "saved": "अनुरोध संग्रहीत गरिएको",
      "save": "प्राथमिकताहरू सुरक्षित गर्नुहोस्",
      "description": "तपाईंका अनुप्रयोग प्राथमिकताहरू कन्फिगर गर्नुहोस्",
      "theme": {
        "label": "रंग योजना",
        "description": "प्राथमिक रंग योजना चुन्न"
      },
      "language": {
        "label": "भाषा",
        "description": "अप्लिकेशन भाषा"
      },
      "dateFormat": {
        "label": "दिनांक प्रतिपादन तरीका",
        "description": "अप्लिकेशनमा दिनांक प्रतिपादन गर्ने तरीका"
      },
      "numberFormat": {
        "label": "संख्या प्रतिपादन तरीका",
        "description": "संख्या प्रतिपादन कोण सारखो हुन्छ"
      },
      "timeZone": {
        "label": "समय क्षेत्र",
        "kathmandu": "काठमाडौं (UTC+०५:४५)",
        "kolkata": "कोलकाता (UTC+०५:३०)",
        "utc": "समन्वित विश्व समय (UTC)",
        "losAngeles": "लस एन्जलस (प्रशान्त समय)",
        "london": "लन्डन (संयुक्त अधिराज्य)"
      },
      "selectTheme": "रंग योजना चुन्न",
      "selectLanguage": "भाषा चुन्न",
      "selectDateFormat": "दिनांक प्रतिपादन तरीका चुन्न",
      "themeLight": "सुरंगी रंग योजना",
      "themeDark": "अंधेरो रंग योजना",
      "themeAuto": "प्रणाली",
      "languageEn": "अंग्रेजी",
      "languageNe": "नेपाली",
      "dateFormatAD": "वस्तु (ग्रेगोरियन)",
      "dateFormatBS": "बिक्रम संवत (बिक्रम संवत)",
      "dateFormatDual": "द्विधारा (वस्तु / बिक्रम संवत)",
      "numberFormatEnNP": "नेपाली (१,२३,४५६.७८)",
      "numberFormatEnUS": "US (१,२३४,५६७.८९)",
      "sidebarCollapsed": "साइडबार संलग्न — स्टैंडर्ड नेविगेशन साइडबार को स्वाभाविक रूप से संलग्न रखें",
      "notifications": "सूचनाहरू",
      "tableData": "टेबल & डेटा",
      "emailNotifications": "ईमेल सूचनाएँ — महत्वपूर्ण घटनाओं के लिए ईमेल अलर्ट प्राप्त गर्नुहोस्",
      "inAppNotifications": "इन-एप्लिकेशन सूचनाएँ — एप्लिकेशन मा सूचनाएँ देखाउनुहोस्",
      "pushNotifications": "पुश सूचनाएँ — ब्राउज़र पुश सूचनाएँ प्राप्त गर्नुहोस्",
      "defaultPageSize": {
        "label": "विस्तारित पृष्ठ आकार",
        "description": "टेबल मा प्रति पृष्ठ की संख्या",
        "error": "पृष्ठ आकार {{min}} र {{max}} बीचको पूर्णांक हुनुपर्छ"
      },
      "resetDefaults": "पूर्वनिर्धारितमा रिसेट गर्नुहोस्",
      "loadError": "प्राथमिकताहरू लोड गर्न सकिएन",
      "notificationsDisabled": "सूचना प्राथमिकताहरू केन्द्रीय रूपमा व्यवस्थापन गरिन्छ।",
      "numberFormatEnIN": "भारत (अंग्रेजी)",
      "helpText": {
        "locale": "उपयोगकर्ता इन्टरफेस र मिति/समय ढाँचाका लागि आफ्नो मनपर्ने भाषा चयन गर्नुहोस्।",
        "theme": "हल्का, गाढा वा प्रणालीअनुसारको रूप चयन गर्नुहोस्।",
        "timezone": "समय, कारोबार टाइमस्ट्याम्प र रिपोर्टिङ मिति सही देखाउन आफ्नो समय क्षेत्र चयन गर्नुहोस्।",
        "emailNotifications": "महत्त्वपूर्ण खाता गतिविधि र सूचनाको इमेल सारांश प्राप्त गर्नुहोस्।",
        "pushNotifications": "समय-संवेदनशील कार्य र स्वीकृतिका लागि ब्राउजर सूचना प्राप्त गर्नुहोस्।"
      },
      "saveError": "प्राथमिकताहरू सुरक्षित गर्न सकिएन। मानहरू जाँच गरी पुनः प्रयास गर्नुहोस्।",
      "defaultContext": {
        "label": "पूर्वनिर्धारित शाखा"
      }
    },
    "mfa": {
      "title": "MFA सेटिङहरू",
      "description": "बहु-चरण प्रमाणीकरण व्यवस्थापन गर्नुहोस्",
      "enrollment": {
        "title": "मुलभूत सुरक्षा प्रणाली",
        "description": "मुलभूत सुरक्षा प्रणालीमा जोडने के लिए पंजीकरण गर्नुहोस्। यह आपको खाते मा अतिरिक्त सुरक्षा स्तर जोड़ता छ।",
        "button": "MFA दर्ता गर्नुहोस्",
        "supports": "गूगल ऑथेन्टिकेटर, ऑथी ऐप्स, माइक्रोसॉफ्ट ऑथेन्टिकेटर, और अन्य टोटीपी ऐप्स सहित समर्थन करता छ"
      },
      "status": {
        "label": "MFA स्थिति",
        "enabled": "सक्षम",
        "disabled": "अक्षम",
        "enable": "मुलभूत सुरक्षा प्रणाली सक्षम गर्नुहोस्"
      },
      "backupCodes": {
        "title": "बैकअप कोड",
        "remaining": "{{count}} कोड बाकी छन्। प्रत्येक कोड एक बार उपयोग किया जा सक्छ।",
        "regenerate": "कोड पुनर्प्राप्त गर्नुहोस्",
        "disableMfa": "मुलभूत सुरक्षा प्रणाली बंद गर्नुहोस्",
        "important": "महत्वपूर्ण: ",
        "warning": "इन बैकअप कोडों को एक सुरक्षित स्थान पर संग्रहीत गर्नुहोस्। प्रत्येक कोड केवल एक बार उपयोग किया जा सक्छ।",
        "copyImmediately": "यी पुनर्प्राप्ति कोडहरू सुरक्षित ठाउँमा बचत गर्नुहोस्। तिनीहरू फेरि देखाइने छैनन्।",
        "description": "तपाईंसँग {{count}} वटा पुनर्प्राप्ति कोडहरू छन्। तिनीहरूलाई सुरक्षित ठाउँमा राख्नुहोस्। तपाईंको प्रमाणीकरण एप उपलब्ध नभएमा, साइन इन गर्न एक कोड प्रयोग गर्नुहोस्। प्रत्येक कोड एकपटक मात्र प्रयोग गर्न सकिन्छ, त्यसैले भविष्यका आपत्कालीन अवस्थाका लागि बाँकी कोडहरूलाई सुरक्षित राख्नुहोस्। यदि यी कोडहरू हराउँछन् भने, तपाईं कुनै पनि समयमा नयाँ सेट उत्पन्न गर्न सक्नुहुन्छ।",
        "done": "मैले आफ्ना कोडहरू बचत गरें"
      },
      "enroll": {
        "scanQr": "ऑथेन्टिकेटर ऐप के साथ QR कोड स्कैन गर्नुहोस्",
        "manualKey": "मैनुअल इनपुट कुंजी",
        "backupCodesTitle": "बैकअप कोड (सेभ गर्नुहोस्!)",
        "cancel": "रद्द गर्नुहोस्",
        "scanned": "कोड स्कैन गरिएको छ",
        "qrAlt": "MFA QR कोड",
        "manualKeyHelp": "QR कोड स्क्यान गर्न नसक्ने भएमा, आफ्नो प्रमाणीकरण एप खोल्नुहोस् र \"सेटअप कुञ्जी हाल्नुहोस्\" छान्नुहोस्, त्यसपछि यो कुञ्जी टाँस्नुहोस्।"
      },
      "verify": {
        "title": "कोड सत्यापित गर्नुहोस्",
        "description": "ऑथेन्टिकेटर ऐप से प्राप्त 6-दशमिक कोड भर्नुहोस्",
        "placeholder": "000000",
        "back": "पछाडि",
        "button": "सत्यापन & सक्षम गर्नुहोस्",
        "enterCode": "6-दशमिक कोड भर्नुहोस्"
      },
      "disable": {
        "title": "नस्कारा MFA",
        "warning": "MFA बंद करने द्वारा आपके खाते की सुरक्षा की अतिरिक्त परत हट हुनेछ।",
        "description": "आपके स्वीकृतकर्ता ऐप या बैकअप कोड से 6-दशमलवां कोड भर्नुहोस्",
        "placeholder": "000000",
        "cancel": "बंद कर",
        "button": "MFA बंद कर",
        "enterCode": "6-दशमलवां कोड भर्नुहोस्",
        "confirmTitle": "MFA अक्षम गर्ने?",
        "confirmBody": "MFA अक्षम गर्दा तपाईंको दोस्रो कारक हट्छ। अघि बढ्न एक मान्य ६-अंकी कोड प्रविष्ट गर्नुहोस्।"
      },
      "regenerate": {
        "confirmTitle": "पुनःप्राप्ति कोडहरू पुनः उत्पन्न गर्ने?",
        "confirmBody": "पुनःप्राप्ति कोडहरू पुनः उत्पन्न गर्दा पहिले जारी गरिएका सबै कोडहरू अमान्य हुनेछन्। जारी राख्ने?"
      },
      "success": {
        "enabled": "MFA सक्षम हो गया",
        "disabled": "MFA बंद हो गया",
        "regenerated": "बैकअप कोड पुनर्निर्मित हुए"
      },
      "errors": {
        "invalidCode": "अस्थायी कोड",
        "enrollmentFailed": "नामांकन विफल हो गया",
        "regenerateFailed": "पुनर्निर्माण असफल रहा",
        "clipboardFailed": "क्लिपबोर्डमा प्रतिलिपि गर्न सकिएन",
        "invalidSetup": "अमान्य MFA सेटअप प्रतिक्रिया",
        "setupExpired": "MFA सेटअप म्याद सकियो। कृपया फेरि सुरु गर्नुहोस्।"
      },
      "copyCode": "कोड प्रतिलिपि गर्नुहोस्"
    }
  },
  "companies": {
    "companyList": {
      "deleteCompany": "कम्पनी मेटाउनुहोस्",
      "deleteConfirmation": "{{symbol}} मेटाउनुहुन्छ? यो कार्वा उल्टाउन सकिँदैन।",
      "deleteFailed": "मेटाउन असफल",
      "failedToDeleteCompany": "कम्पनी मेटाउन असफल",
      "companyDeleted": "कम्पनी मेटाइयो",
      "companyRemoved": "{{symbol}} सफलतापूर्वक हटाइयो।",
      "loadingCompanies": "कम्पनीहरू लोड गर्दै...",
      "totalInstruments": "कुल उपकरणहरू",
      "groupsCount": "{{count}} समूहहरू",
      "companyDetails": "कम्पनी विवरणहरू",
      "reviewProfile": "{{name}} को लागि प्रोफाइल जानकारी समीक्षा गर्नुहोस्",
      "closeDetails": "विवरणहरू बन्द गर्नुहोस्",
      "company": "कम्पनी",
      "symbol": "प्रतीक",
      "sector": "क्षेत्र",
      "notAssigned": "नतोकिइएको",
      "securityType": "सुरक्षा प्रकार",
      "alternateSymbol2": "वैकल्पिक प्रतीक २",
      "alternateSymbol3": "वैकल्पिक प्रतीक ३",
      "notSet": "सेट गरिएको छैन",
      "companyList": "कम्पनी सूची",
      "companiesInSystem": "{{count}} कम्पनीहरू प्रणालीमा",
      "bulkImport": "थप आयात",
      "addCompany": "कम्पनी थप्नुहोस्",
      "previous": "अघिल्लो",
      "next": "पछिल्लो",
      "pageOf": "पृष्ठ {{page}} कुल {{total}}",
      "companyName": "कम्पनी नाम",
      "actions": "कार्यहरू",
      "viewDetails": "विवरणहरू हेर्नुहोस्",
      "statement": "विवरण",
      "edit": "सम्पादन गर्नुहोस्",
      "delete": "मेटाउनुहोस्",
      "none": "कुनै पनि",
      "type": "प्रकार",
      "noCompaniesFound": "कुनै कम्पनीहरू फेला परेन। सुरु गर्न तपाईंको पहिलो कम्पनी थप्नुहोस्।"
    },
    "editCompany": "कंपनी संपादित कर",
    "addNewCompany": "नया कंपनी जोड़",
    "updateCompanyDetails": "कंपनी विवरण अद्यावधिक गर्नुहोस्",
    "enterCompanyDetails": "कंपनी विवरण जोड़ने के लिए दर्ज गर्नुहोस्",
    "symbolPlaceholder": "उदाहरण के लिए, AAPL",
    "companyName": "कम्पनी नाम",
    "companyNamePlaceholder": "उदाहरण के लिए, Apple Inc.",
    "serialNumber": "सीरियल नंबर",
    "serialNumberPlaceholder": "प्रत्येक कंपनी का सीरियल नंबर हो सक्छ",
    "sectorPlaceholder": "कंपनी का क्षेत्र हो सक्छ",
    "symbol2": "सimbोल २",
    "alternativeSymbol": "वैकल्पिक सimbोल",
    "symbol3": "सimbोल ३",
    "alternativeSymbol3": "वैकल्पिक सimbोल ३",
    "selectType": "प्रकार चुनने का विकल्प छ",
    "equity": "मूल्य",
    "bond": "बॉन्ड",
    "mutualFund": "साझेदारी संस्थान",
    "etf": "ईटीएफ",
    "other": "अन्य",
    "updating": "อัปडेटिंग...",
    "creating": " बनाई जा भइरहेको छ...",
    "updateCompany": "कंपनी को अद्यावधिक गर्नुहोस्",
    "createCompany": "एक नया कंपनी बनाउनुहोस्",
    "bulkImport": {
      "invalidJsonFile": "अस्थायी Json फाइल वैध छैन",
      "invalidJsonFormat": "अस्थायी Json रूपांतरण वैध छैन",
      "failedToDownloadTemplate": "मानचित्र डाउनलोड करने मा असफल रहा",
      "selectCsvFile": "सीईवी फाइल चुनने का विकल्प छ",
      "enterJsonContent": "अस्थायी Json सामग्री दर्ज गर्नुहोस्",
      "bulkImportFailed": "ब bulk इंपोर्ट विफल हो गया",
      "bulkImportCompleted": "बulk इंपोर्ट पूरा हो गया",
      "bulkImportFailedCheckFormat": "bulk इंपोर्ट विफल चेक फॉर्मेट",
      "title": "थप आयात",
      "description": "bulk इंपोर्ट वर्णन",
      "importFormat": "इंपोर्ट फॉर्मेट",
      "csvFile": "CSV फाइल",
      "downloadTemplate": "डाउनलोड टेम्पलेट",
      "requiredColumns": "आवश्यक स्तंभ",
      "jsonFile": "JSON फाइल",
      "orPasteJsonContent": "या पेस्ट JSON कंटेंट",
      "forceImportDescription": "स्थिर इंपोर्ट वर्णन",
      "preview": "प्रिव्यू {{count}}"
    },
    "importCompanies": "कंपनियाँ आयात गर्नुहोस्",
    "symbol": "प्रतीक",
    "sector": "क्षेत्र",
    "securityType": "सुरक्षा प्रकार"
  },
  "bulkImport": {
    "invalidJsonFile": "अयोग्य JSON फाइल",
    "invalidJsonFormat": "अयोग्य JSON फॉर्मेट",
    "failedToDownloadTemplate": "टेम्पलेट डाउनलोड गर्न विफल रहा",
    "selectCsvFile": "कृपया एक CSV फाइल छान्नुहोस्",
    "enterJsonContent": "कृपया JSON कंटेंट या एक JSON फाइल अपलोड गर्नुहोस्",
    "bulkImportFailed": "बulk इंपोर्ट विफल हो गया",
    "bulkImportCompleted": "बulk इंपोर्ट पूरा हो गया",
    "bulkImportFailedCheckFormat": "बल्क आयात असफल भयो। कृपया आफ्नो फाइल ढाँचा जाँच्नुहोस् र पुनः प्रयास गर्नुहोस्।",
    "title": "बल्क आयात कम्पनीहरू",
    "description": "CSV वा JSON ढाँचा प्रयोग गरेर एकै पटक धेरै कम्पनीहरू आयात गर्नुहोस्",
    "importFormat": "आयात ढाँचा",
    "csvFile": "CSV फाइल",
    "downloadTemplate": "टेम्प्लेट डाउनलोड गर्नुहोस्",
    "requiredColumns": "आवश्यक स्तम्भहरू: symbol, instrumentName। वैकल्पिक: serialNumber, symbol2, sector, symbol3, instrumentType",
    "jsonFile": "JSON फाइल",
    "orPasteJsonContent": "वा JSON सामग्री पेस्ट गर्नुहोस्",
    "forceImportDescription": "बल आयात (नक्कली पत्ता लागेतापनि अवस्थित कम्पनीहरू अद्यावधिक गर्नुहोस्)",
    "preview": "पूर्वावलोकन ({{count}} रेकर्डहरू)"
  },
  "importCompanies": "कम्पनीहरू आयात गर्नुहोस्",
  "importing": "आयात गर्दै...",
  "legal": {
    "termsOfService": {
      "back": "पछाडि",
      "title": "सेवा शर्तहरू",
      "section1Title": "१. शर्तहरूको स्वीकार",
      "section1Description": "{{brand}} मा पहुँच गरेर प्रयोग गर्नुभएमा, तपाईं यी सेवा शर्तहरूद्वारा बाँधिन स्वीकार गर्नुहुन्छ। यदि तपाईं यी शर्तहरूलाई स्वीकार गर्नुहुँदैन, कृपया हाम्रो सेवा प्रयोग नगर्नुहोस्।",
      "section2Title": "२. सेवाको विवरण",
      "section2Description": "{{brand}} ले संगठनहरूको लागि पोर्टफोलियो व्यवस्थापन र हिसाब-नामाको प्लेटफर्म प्रदान गर्दछ। सेवा कुनै पनि प्रकारको वारेन्टी बिना \"जस्तो छ त्यस्तै\" आधारमा प्रदान गरिएको छ।",
      "section3Title": "३. प्रयोगकर्ता जिम्मेवारीहरू",
      "section3Description": "प्रयोगकर्ताहरू आफ्नो खाता क्रेडेन्सियलहरूको गोपनीयता कायम गर्न र आफ्नो खाता अन्तर्गत हुने सबै गतिविधिहरूको लागि जिम्मेवार हुन्छन्। तपाईंको खाताको कुनै अनधिकृत प्रयोगको बारेमा हामीलाई तुरुन्तै सूचित गर्न सहमत हुनुहुन्छ।",
      "section4Title": "४. डाटा गोपनीयता",
      "section4Description": "हाम्रो सेवाको तपाईंको प्रयोग हाम्रो गोपनीयता नीतिद्वारा पनि नियन्त्रित हुन्छ। कृपया हाम्रो गोपनीयता नीति समीक्षा गर्नुहोस्, जसले हाम्रो सेहुनेई पनि नियन्त्रण गर्छ र हामीले तपाईंको व्यक्तिगत जानकारी कसरी संकलन, प्रयोग, र सुरक्षित गर्छौं भनेरू रूपरेखा तयार गर्छ।",
      "section5Title": "५. बौद्धिक सम्पत्ति",
      "section5Description": "{{brand}} को सबै सामग्री, सुविधाहरू, र कार्यक्षमता हामीसँग स्वामित्वमा छ र अन्तर्राष्ट्रिय कपिराइट, ट्रेडमार्क, र अन्य बौद्धिक सम्पत्ति कानुनहरूद्वारा सुरक्षित छन्।",
      "section6Title": "६. दायित्व सीमा",
      "section6Description": "कुनै पनि परिस्थितिमा {{brand}} ले अप्रत्यक्ष, आकस्मिक, विशेष, परिणामी, वा दण्डात्मक क्षतिहरूको लागि जिम्मेवार हुनुहुँदैन, जसमा बिना सीमा, नाफाको क्षति, डाटा, प्रयोग, शुभइच्छा, वा अन्य अमूर्त क्षतिहरू समावेश छन्।",
      "section7Title": "७. परिमार्जनहरू",
      "section7Description": "हामी कुनै पनि समयमा यी शर्तहरू परिमार्जन गर्ने अधिकार आरक्ष गर्छौं। यस्ता परिमार्जन पछि सेवाको तपाईंको निरन्तर प्रयोगले संशोधित शर्तहरूको तपाईंको स्वीकार गठन गर्छ।",
      "section8Title": "८. सम्पर्क जानकारी",
      "section8Description": "यी सेवा शर्तहरूको बारेमा तपाईंसँग कुनै पनि प्रश्नहरू भएमा, कृपया आफ्नो संगठनको प्रशासक मार्फत हामीसँग सम्पर्क गर्नुहोस्।",
      "lastUpdated": "अन्तिम अद्यावधिक: "
    },
    "privacyPolicy": {
      "back": "पछाडि",
      "title": "गोपनीयता नीति",
      "section1Title": "१. हामीले संकलन गर्ने जानकारी",
      "section1Description": "{{brand}} ले तपाईंले सिधै हामीलाई प्रदान गर्नुभएको जानकारी संकलन गर्छ, जसमा तपाईंको प्रयोगकर्ता नाम, इमेल ठेगाना, र अन्य खाता जानकारी समावेश छ। हामी पनि तपाईंको सेवा प्रयोग बारे जानकारी संकलन गर्छौ।",
      "section2Title": "२. हामी तपाईंको जानकारी कसरी प्रयोग गर्छौ",
      "section2Description": "हामीले संकलन गरेको जानकारी प्रयोग गर्छौं सेवाहरू प्रदान गर्न, मर्मत गर्न, र सुधार गर्न, लेनदेन प्रक्रिया गर्न, तपाईंलाई प्राविधिक सूचना र समर्थन सन्देशहरू पठाउन, र तपाईंको टिप्पणीहरू र प्रश्नहरूको जवाफ दिन।",
      "section3Title": "३. डाटा सुरक्षा",
      "section3Description": "हामी अनधिकृत पहुँच, परिवर्तन, प्रकटीकरण, वा विनाश विरुद्ध तपाईंको व्यक्तिगत जानकारी सुरक्षित गर्न उपयुक्त प्राविधिक र संगठनात्मक उपायहरू लागू गर्छौं। यद्यपि, इन्टरनेट मार्फत प्रसारणको कुनै विधि १००% सुरक्षित छैन।",
      "section4Title": "४. डाटा राख्यता",
      "section4Description": "हामी यो गोपनीयता नीतिमा उल्लेख गरिएका उद्देश्यहरू पूरा गर्न हाम्रो सेवाहरू प्रदान गर्न आवश्यक भएसम्म तपाईंको व्यक्तिगत जानकारी राख्छौं, जबसम्म लामो राख्यता अवधि कानुन द्वारा आवश्यक वा अनुमति गरिएको छैन।",
      "section5Title": "५. तपाईंको अधिकारहरू",
      "section5Description": "तपाईंसँग आफ्नो व्यक्तिगत जानकारी पहुँच गर्न, सुधार गर्न, वा मेटाउने अधिकार छ। तपाईं हामीबाट केही संचारहरू बाहिर निस्कन सक्नुहुन्छ। यी अधिकारहरू प्रयोग गर्न आफ्नो संगठन प्रशासकसँग सम्पर्क गर्नुहोस्।",
      "section6Title": "६. तेस्रो-पक्ष सेवाहरू",
      "section6Description": "हाम्रो सेवामा तेस्रो-पक्ष वेबसाइटहरू वा सेवाहरूमा लिंकहरू हुन सक्छन्। हामी यस्ता तेस्रो-पक्षहरूको गोपनीयता अभ्यासहरूको लागि जिम्मेवार हुँदैनौं। हामी तपाईंले हाम्रो सेवा छोड्दा सचेत हुन प्रोत्साहन गर्छौं।",
      "section7Title": "७. बालबालिकाको गोपनीयता",
      "section7Description": "हाम्रो सेवा १३ वर्ष मुनिका बालबालिकाहरूको लागि अभिप्रेत छैन। हामी १३ वर्ष मुनिका बालबालिकाहरूबाट जानबुझेर व्यक्तिगत जानकारी संकलन गर्दैनौं।",
      "section8Title": "८. यो नीतिमा परिवर्तनहरू",
      "section8Description": "हामी समय-समयमा हाम्रो गोपनीयता नीति अद्यावधिक गर्न सक्छौं। हामी यो पृष्ठमा नयाँ गोपनीयता नीति पोस्ट गरेर कुनै पनि परिवर्तनहरूको बारेमा तपाईंलाई सूचित गर्नेछौं।",
      "section9Title": "९. हामीसँग सम्पर्क गर्नुहोस्",
      "section9Description": "यो गोपनीयता नीतिको बारेमा तपाईंसँग कुनै पनि प्रश्नहरू भएमा, कृपया आफ्नो संगठनको प्रशासक मार्फत हामीसँग सम्पर्क गर्नुहोस्।",
      "lastUpdated": "अन्तिम अद्यावधिक: "
    }
  },
  "errors": {
    "investment": {
      "purchaseDateInvalid": "खरिद मिति अमान्य छ। कृपया वैध मिति प्रदान गर्नुहोस्।",
      "saleDateInvalid": "बिक्री मिति अमान्य छ। कृपया वैध मिति प्रदान गर्नुहोस्।",
      "saleDateBeforePurchaseDate": "बिक्री मिति खरिद मितिपछि हुनुपर्छ।",
      "idempotentDisposalMismatch": "आइडेम्पोटेन्ट निपटान बेमेल पत्ता लाग्यो।"
    },
    "surface": {
      "modelMissing": "सतह डाटा लोड गर्न सकिएन",
      "contractInvalid": "अमान्य सतह सम्झौता",
      "actionFailed": "कार्य असफल भयो",
      "formInvalid": "अमान्य फारम",
      "configurationInvalid": "निर्धारित सेटअप वैध छैन",
      "empty": {
        "noRows": "कुनै डाटा उपलब्ध छैन",
        "filteredOut": "आपके फिल्टर के अनुसार कोई परिणाम मेल छैन खाता छ"
      }
    },
    "report": {
      "runtimeFailed": "रिपोर्ट उत्पन्न करने मा एक त्रुटि हुई। कृपया पुन: प्रयास गर्नुहोस् या समर्थन से अनुरोध ID से संपर्क गर्नुहोस्।",
      "lineageRequired": "इस रिपोर्ट के लिए लाइनेज जानकारी आवश्यक छ",
      "lineageCollectionFailed": "इस रिपोर्ट के लिए लाइनेज जानकारी इकट्ठा करने मा विफल रहा।",
      "metadataUnavailable": "रिपोर्ट मेटाडेटा उपलब्ध छैन।",
      "tenantContextRequired": "रिपोर्ट प्रश्नों के लिए शाखा संदर्भ आवश्यक छ",
      "invalidPivotBy": "पिवोट बाई मूल्य वैध छैन",
      "branchIdRequired": "शाखा आईडी आवश्यक छ।",
      "organizationIdRequired": "संगठन आईडी आवश्यक छ।",
      "userIdRequired": "प्रयोगकर्ता आईडी (कार्यकर्ता) आवश्यक छ।",
      "nameRequired": "नाम आवश्यक छ।",
      "definitionNotFound": "रिपोर्ट परिभाषा फेला परेन।",
      "runNotFound": "रिपोर्ट रन फेला परेन।",
      "outputNotFound": "रिपोर्ट आउटपुट फेला परेन।",
      "unsupportedType": " समर्थित रिपोर्ट प्रकार छैन।"
    },
    "common": {
      "unauthorized": "नियंत्रित छैन",
      "forbidden": "पहुँच अस्वीकृत",
      "notFound": "संसाधन नोट फाउंड छैन।",
      "conflict": "द्वन्द्व",
      "badRequest": "बुरा अनुरोध छ।",
      "internalError": "अंतर्निहित सर्वर त्रुटि"
    },
    "branch": {
      "hasActiveChildren": "यस शाखासँग सक्रिय उप-शाखाहरू छन्। कृपया पहिले सबै उप-शाखाहरू निलम्बित वा निष्क्रिय गर्नुहोस्।",
      "lastUsableProtected": "यो संगठनको अन्तिम सक्रिय शाखा हो र निष्क्रिय गर्न सकिँदैन।",
      "lifecycleReasonRequired": "शाखा निलम्बित वा निष्क्रिय गर्दा कारण आवश्यक हुन्छ।",
      "mustBeActiveToDefault": "पूर्वनिर्धारित शाखा बनाउन शाखा सक्रिय हुनुपर्छ।"
    },
    "governance": {
      "unhandledExperience": "अपवित्र अनुभव या नियामक परिभाषा खोजी छैन पाई गई",
      "unhandledAction": "अपवित्र कार्य इस अनुभव के लिए फेला परेन",
      "organizationIdRequired": "संगठन ID इस ऑपरेशन के लिए आवश्यक छ",
      "organizationNameRequired": "संगठन नाम आवश्यक छ",
      "bundleNameRequired": "नियामक बंडल नाम आवश्यक छ",
      "bundleNameDuplicate": "संगठन मा एक नियामक बंडल इस नाम से पहले ही मौजूद छ",
      "bundleIdRequired": "नियामक बंडल ID आवश्यक छ",
      "bundleNotFound": "नियामक बंडल खोजा छैन गया",
      "bundleNoChanges": "नियामक बंडल मा कोई बदलाव छैन गरिएको छ",
      "functionIdsRequired": "कम से कम एक फंक्शन ID इस ऑपरेशन के लिए आवश्यक छ"
    },
    "rateLimit": {
      "blacklisted": "प्राप्त करने की अनुमति छैन - पहचान ब्लैकलिस्टेड छ",
      "exceeded": "मात्रा अधिक छ। पुन: प्रयास गर्नुहोस् और बाद में"
    },
    "csrf": {
      "tokenMissing": "CSRF टोकन मौजूद छैन",
      "tokenMismatch": "CSRF टोकन मेल खाने मा विफल हुआ",
      "tokenInvalid": "CSRF टोकन वैध या समय से पहले हीหมด हो गया छ"
    },
    "context": {
      "requestContextRequired": "रिक्वेस्ट कॉनटेक्स्ट आवश्यक छ",
      "organizationContextRequired": "संस्था सन्दर्भ आवश्यक छ",
      "userContextRequired": "यूज़र कॉनटेक्स्ट आवश्यक छ",
      "tenantContextRequired": "शाखा सन्दर्भ आवश्यक छ"
    },
    "user": {
      "notFound": "प्रयोगकर्ता फेला परेन",
      "alreadyExists": "प्रयोगकर्ता पहले से मौजूद छ",
      "idTooLong": "प्रयोगकर्ता ID 15 से अधिक अक्षर छैन हो सक्छ",
      "idInvalidFormat": "प्रयोगकर्ता आईडी केवल अक्षर, हाइफन वा अन्डरस्कोर सहित हुनुपर्छ",
      "usernameAlreadyExists": "नाम déjàExists",
      "emailAlreadyExists": "ईमेल déjàExists",
      "branchNotFound": "शाखा नभाग्य",
      "userTypeNotFound": "प्रयोगकर्ता प्रकार नभाग्य",
      "cannotSuspendSelf": "तपाईं आफ्नै खाता निलम्बन गर्न सक्नुहुन्न",
      "suspensionReasonRequired": "स्थगन कारण आवश्यक छ",
      "reactivationReasonRequired": "पुनर्प्रारंभ कारण आवश्यक छ",
      "notSuspended": "प्रयोगकर्ता स्थगित छैन",
      "accountNotLocked": "खाते की खिड़की नभाग्य छ या स्थगित छ",
      "deletionReasonRequired": "नाश कारण आवश्यक छ",
      "cannotDeleteSelf": "आप अपने खाते को छैन हटा सकते",
      "alreadyDeleted": "प्रयोगकर्ता पहले से ही नष्ट हो गया छ",
      "notPendingDeletion": "नाश की मंजूरी की आवश्यकता छैन",
      "reapplyReasonRequired": "पुनर्प्रारंभ कारण आवश्यक छ",
      "notRejected": "मात्र REJECTED प्रयोगकर्ताहरू को पुनः प्रयास किया जा सक्छ",
      "accountLocked": "खाते की खिड़की {{lockedUntil}} तक स्थगित छ",
      "passwordTooShort": "पासवर्ड कम्तीमा ८ अक्षरको हुनुपर्छ",
      "passwordTooLong": "पासवर्ड 128 अक्षर से अधिक छैन हो सक्छ",
      "passwordComplexity": "पासवर्डमा कम्तीमा एउटा ठूलो अक्षर, एउटा सानो अक्षर, एउटा संख्या र एउटा विशेष चिन्ह (@$!%*?&) हुनुपर्छ",
      "notActive": "प्रयोगकर्ता खाता सक्रिय छैन",
      "notPendingApproval": "अप्रत्यक्ष प्रतिबंधित प्रयोगकर्ता छैन (वर्तमान स्थिति: {{status}})",
      "rejectionReasonTooLong": "निर्णय कारण अधिकतम 2500 चार्टर्स तक न हो",
      "cannotCreatePlatformRoot": "प्लेटफ़ॉर्म रूट प्रयोगकर्ता प्रकार से बनाए जाने हुने प्रयोगकर्ताहरू को बनाया छैन जा सकता। यह बस्ट्राप सिर्फ छ",
      "notActiveForSuspension": "केवल सक्रिय प्रयोगकर्ताहरू को निलंबित किया जा सक्छ। वर्तमान स्थिति: {{status}}",
      "cannotUpdateStatus": "वर्तमान स्थिति: {{status}} के साथ प्रयोगकर्ता की स्थिति अपडेट छैन की जा सकती।",
      "cannotApproveOwnDeletion": "तपाईं आफ्नै निलम्बन अनुरोध अनुमोदन गर्न सक्नुहुन्न (दोहोरो नियन्त्रण आवश्यक छ)"
    },
    "portfolio": {
      "notFound": "पोर्टफोलियो खोजा गया छैन",
      "accessDenied": "आपकी संगठनात्मक पोर्टफोलियो के लिए पहुँच दी गई छ।",
      "clientAccessDenied": "आपके क्लाइंट अकाउंट के लिए पोर्टफोलियो का पहुँच दिया गया छ।",
      "holdingsNotFound": "संगठन {{organizationId}} और शाखा {{branchId}} के लिए स्थिति तथ्य फेला परेन। होल्डिंग डेटा उपलब्ध छैन। प्रोसेसिंग की जाने हुने अनुसंधानों को सुनिश्चित गर्नुहोस् और स्थिति तथ्यों को उत्पन्न करने के बाद,",
      "organizationRequired": "संगठनीय परिप्रेक्ष्य आवश्यक छ पोर्टफोलियो होल्डिंग्स की प्राप्ति के लिए",
      "tenantRequired": "शाखा परिप्रेक्ष्य आवश्यक छ पोर्टफोलियो होल्डिंग्स की प्राप्ति के लिए",
      "invalidClientAccount": "पोर्टफोलियो रिकैलकुलेशन के लिए वैध clientAccountId छैन।",
      "clientAccountRequired": "clientAccountId आवश्यक छ जब स्कोप CLIENT_ACCOUNT छ",
      "analyticsDisabled": "अनलिटिक्स फीचर्स वर्तमान मा बंद छन्। यह फीचर सिमुलेटेड डेटा का उपयोग करता छ और अभी तक प्रोडक्शन-युक्त छैन।",
      "positive": "पॉजिटिव",
      "periodUnsupported": "अनुमति दी गई अवधि '{{period}}' समर्थित छैन। अनुमति दी गई अवधियाँ: {{allowedPeriods}}।",
      "holdingLotQuantityPositive": "होल्डिंग लॉट मात्रा सकारात्मक होनी चाहिए",
      "holdingLotRemainingNegative": "होल्डिंग लॉट बाकी मात्रा नकारात्मक छैन हो सक्छ",
      "remainingExceedsPurchased": "बाँकी परिमाण खरिद गरिएको परिमाणभन्दा बढी हुन सक्दैन",
      "costPerUnitNegative": "प्रति इकाई लागत नकारात्मक छैन होनी चाहिए",
      "totalLotCostNegative": "कुल लॉट की लागत नकारात्मक छैन हो सकती",
      "disposalQuantityPositive": "कारोबार मूल्य सकारात्मक हुनुपर्छ",
      "saleRateNegative": "बिक्री दर नकारात्मक छैन हो सकती",
      "saleAmountNegative": "बिक्री मूल्य नकारात्मक छैन हो सकता",
      "soldCostBasisNegative": "विक्रित लागत आधार नकारात्मक छैन हो सकती",
      "transactionQuantityPositive": "कारोबार मूल्य सकारात्मक हुनुपर्छ",
      "pricePerUnitNegative": "प्रति इकाई कीमत नकारात्मक छैन हो सकती",
      "totalAmountNegative": "कुल मूल्य नकारात्मक छैन हो सकता",
      "commissionNegative": "कमीशन नकारात्मक छैन हो सकता",
      "dpChargesNegative": "डीपी शुल्क नकारात्मक छैन हो सकते",
      "sebonFeeNegative": "एसईबोन शुल्क नकारात्मक छैन हो सकता",
      "otherChargesNegative": "अन्य शुल्क नकारात्मक छैन हो सकते",
      "totalCostNegative": "कुल लागत नकारात्मक छैन हो सकती",
      "capitalGainTaxNegative": "वित्तीय लाभ कर नकारात्मक छैन हो सकता"
    },
    "transaction": {
      "notFound": "व्यापारिक विस्तारित मूल्य खोजा छैन गया",
      "organizationRequired": "व्यापारिक विस्तारित मूल्य के लिए संगठन आईडी आवश्यक छ",
      "tenantRequired": "व्यापारिक विस्तारित मूल्य के लिए शाखा आईडी आवश्यक छ",
      "userNotFound": "प्रयोगकर्ता फेला परेन",
      "approvalWorkflowNotFound": "व्यापारिक विस्तारित मूल्य का स्वीकृति प्रक्रिया खोजा छैन गया",
      "notPendingApproval": "व्यापारिक विस्तारित मूल्य स्वीकृति की प्रतीक्षा मा छैन",
      "rejectionReasonRequired": "स्वीकृति के लिए निर्णय कारण आवश्यक छ",
      "batchNotFound": "ब bulk transaction batch {{batchId}} not found",
      "idsRequired": "लेनदेन",
      "bulkBatchNotFound": "लेनदेन",
      "reversalReasonRequired": "उल्टाउने कारण आवश्यक छ",
      "reversalReasonTooShort": "उल्टाउने कारण कम्तिमा १० अक्षरको हुनुपर्छ",
      "accessDenied": "अनुमति",
      "statusAlreadySet": "कारोबार पहिले नै {{toStatus}} स्थितिमा छ। कुनै संक्रमण आवश्यक छैन।",
      "invalidStatusTransition": "अमान्य स्थिति संक्रमण: {{from}} -> {{to}} लाई {{operation}} का लागि अनुमति छैन। {{from}} बाट वैध संक्रमणहरू: {{validTransitions}}",
      "openingBalanceDateAfterTransaction": "सुरुको ब्यालेन्स मिति ({{openingDate}}) पहिलो कारोबार मिति ({{transactionDate}}) पछि छ, {{instrumentSymbol}} का लागि खाता {{clientAccountId}} मा। यो डाटा अखण्डता समस्या हो जसलाई मर्मत आवश्यक छ। कृपया सुरुको ब्यालेन्स मिति वा कारोबार मिति सच्याउनुहोस्।"
    },
    "export": {
      "notFound": "निर्यात फेला परेन वा पहुँच अस्वीकृत",
      "notReady": "निर्यात डाउनलोडका लागि तयार छैन",
      "expired": "निर्यात म्याद सकियो",
      "unsupportedFormat": "असमर्थित निर्यात ढाँचा",
      "generationFailed": "निर्यात उत्पादन असफल भयो",
      "gainLossBlocked": "प्रतिवेदन",
      "tenantRequired": "शाखा",
      "userNotFound": "प्रयोगकर्ता फेला परेन",
      "userNoOrganization": "सिर्जना गरिँदै"
    },
    "import": {
      "noPortfolioStatementSheets": "एक्सेल",
      "invalidExcelFormat": "अवैध Excel फाइल ढाँचा",
      "csvFileEmpty": "CSV फाइल खाली छ",
      "clientAccountIdRequired": "खाता"
    },
    "validation": {
      "transactionTypeNotFound": "कारोबार प्रकार फेला परेन",
      "investmentApproachNotFound": "लगानी दृष्टिकोण फेला परेन",
      "fiscalYearNotFound": "आर्थिक वर्ष फेला परेन",
      "sectorNotFound": "क्षेत्र फेला परेन"
    },
    "company": {
      "notFound": "कम्पनी फेला परेन"
    },
    "clientAccount": {
      "notFound": "अपेक्षित खाता पायो छैन"
    },
    "permission": {
      "denied": "नियंत्रण अनुमति दी छैन"
    },
    "search": {
      "savedNotFound": "बचाए गए खोज को ढूंढ न सकिए",
      "organizationNotFound": "प्रयोगकर्ता के लिए संगठन पायो छैन"
    },
    "reportScope": {
      "startDateAfterEndDate": "शुरुआत तिथि को अंत तिथि से पहले या बराबर होनी चाहिए",
      "asOfDateBeforeStartDate": "अस्तित्व तिथि शुरुआत तिथि से बाद या बराबर होनी चाहिए",
      "asOfDateAfterEndDate": "अस्तित्व तिथि को अंत तिथि से पहले या बराबर होनी चाहिए"
    },
    "lot": {
      "quantityPositive": "लॉट मात्रा सकारात्मक होनी चाहिए",
      "saleQuantityPositive": "बिक्री मात्रा सकारात्मक होनी चाहिए"
    },
    "upload": {
      "fileTooLarge": "फाइल बहुत बड़ी छ",
      "invalidMimeType": "वैध मिम टाइप छैन",
      "invalidExtension": "वैध विस्तार छैन"
    }
  },
  "marketData": {
    "pricesView": {
      "title": "कीमतें देखना"
    },
    "summary": {
      "totalSymbols": "मिली सimbोल्स की संख्या",
      "staleCount": "पुराने गिनती की संख्या",
      "latestAvailableDate": "सबसे नवीन उपलब्ध तिथि",
      "latestNepseTradeDay": "नवीन NEPSE ट्रेड डे",
      "needsTodayImport": "आज की सामग्री लोड गर्नु आवश्यक छ",
      "todayIsTradeDay": "आज व्यापारिक दिन छ"
    },
    "marketDataView": {
      "freshnessModeBanner": "नवीनता मोड सक्रिय छ। शुरुआत तिथि के बिना सimbोल्स दिखाने की प्रक्रिया ({{date}})।",
      "importReview": "आयात समीक्षा",
      "importSummary": "निर्यात संक्षेप",
      "problematicRows": "समस्याग्रस्त पंक्तिहरू",
      "row": "पंक्ति",
      "symbol": "प्रतीक",
      "issues": "समस्याहरू",
      "errorsTitle": "त्रुटिहरू",
      "andMore": "…अन्य {{count}} थप",
      "reimporting": "पुनः आयात गर्दै…",
      "skipProblematic": "समस्याग्रस्त छोड्नुहोस् र पुनः आयात गर्नुहोस्",
      "dismiss": "खारेज गर्नुहोस्",
      "loadErrorTitle": "लोड त्रुटि",
      "marketDataNotAvailable": "{{date}} को लागि बजार डाटा उपलब्ध छैन।",
      "importMarketData": "बजार डाटा आयात गर्नुहोस् मूल्यहरू अपडेट गर्न।",
      "nonTradingDayImportHint": "अवस्थित दिन निर्यात सुझाव",
      "backToAllPrices": "सबै मूल्यहरूमा फर्कनुहोस्",
      "latestPrice": "नवीनतम मूल्य",
      "latestClose": "नवीनतम बन्द",
      "date": "मिति",
      "previousDayChange": "अघिल्लो दिन परिवर्तन",
      "noHistoricalData": "ऐतिहासिक डाटा उपलब्ध छैन",
      "priceHistory": "मूल्य इतिहास (अन्तिम ३० दिन)",
      "dailyPriceData": "{{symbol}} को लागि दैनिक मूल्य डाटा",
      "priceHistoryTitle": "मूल्य इतिहास (अन्तिम ३० दिन)",
      "latestMarketPrices": "नवीनतम बजार मूल्यहरू",
      "latestPricesDescription": "सबै उपकरणहरूको लागि नवीनतम बन्द मूल्यहरू ({{date}} को रूपमा)",
      "uploading": "अपलोड गर्दै…",
      "import": "आयात",
      "importHelpText": "निर्यात सहायता विवरण",
      "closePrice": "बन्द मूल्य",
      "open": "खुल्ने",
      "high": "उच्च",
      "low": "न्यून",
      "volume": "मात्रा",
      "dayChange": "दिन परिवर्तन",
      "currency": "मुद्रा",
      "basis": "आधार",
      "asOfDate": "मिति अनुसार",
      "qualityStatus": "गुणवत्ता स्थिति",
      "source": "स्रोत",
      "close": "बन्द",
      "invalidViewFallback": "अस्थायी दृश्य प्रतिस्थापन",
      "upload": "निर्यात करो",
      "uploadDesc": "निर्यात करो"
    },
    "marketDataImport": {
      "title": "दैनिक बजार डाटा आयात गर्नुहोस्",
      "description": "NEPSE दैनिक मूल्य डाटा CSV फाइल अपलोड गर्नुहोस्। यो अपरेसन idempotent छ - उस्तै मितिका लागि पछिका अपलोडहरूले अघिला मानहरू अधिलेख्नेछन्।",
      "checkingFile": "फाइल जाँच गर्दै...",
      "uploadingMarketData": "बजार डाटा अपलोड गर्दै...",
      "dropCsvOrBrowse": "CSV फाइल यहाँ छोड्नुहोस् वा ब्राउज गर्न क्लिक गर्नुहोस्",
      "supportsNepseFormat": "NEPSE दैनिक मूल्य ढाँचा (.csv) समर्थन गर्छ",
      "importCompleted": "आयात सफलतापूर्वक पूरा भयो!",
      "newRecordsImported": "नयाँ रेकर्डहरू आयात गरियो",
      "existingRecordsUpdated": "अवस्थित रेकर्डहरू अपडेट गरियो",
      "rowsSkipped": "पंक्तिहरू छोडियो (अमान्य डाटा)",
      "errors": "त्रुटिहरू (विस्तृतहरूको लागि कन्सोल हेर्नुहोस्)",
      "expectedCsvFormat": "अपेक्षित CSV ढाँचा:",
      "formatLine1": "व्यवसाय मिति, प्रतीक, सिक्योरिटी नाम",
      "formatLine2": "खुल्ने मूल्य, उच्च मूल्य, न्यून मूल्य, बन्द मूल्य",
      "formatLine3": "कुल व्यापार मात्रा, कुल व्यापार मूल्य",
      "formatLine4": "अघिल्लो दिन बन्द मूल्य, ५२ हप्ता उच्च/न्यून",
      "downloadFromNepse": "NEPSE वा ब्रोकर प्लेटफर्मबाट दैनिक मूल्य डाटा डाउनलोड गर्नुहोस्"
    },
    "review": {
      "title": "आयात समस्याहरू समीक्षा गर्नुहोस्",
      "rowsWithIssues": "{{count}} पङ्क्ति(हरू)मा ध्यान दिनुपर्ने समस्याहरू छन्।",
      "proceedOrCancel": "तपाईं {{validRows}} मान्य पङ्क्तिहरू आयात गर्न अगाडि बढ्न सक्नुहुन्छ, वा CSV फाइल मर्मत गर्न रद्द गर्न सक्नुहुन्छ।",
      "rowsReadyToImport": "{{count}} पङ्क्तिहरू आयात गर्न तयार छन्",
      "rowsWithIssuesCount": "{{count}} पङ्क्तिहरूमा समस्याहरू छन्",
      "rowNumber": "पङ्क्ति #",
      "symbol": "प्रतीक",
      "issues": "समस्याहरू",
      "rawDataPreview": "कच्चा डाटा पूर्वावलोकन",
      "close": "बन्द",
      "open": "खुल्ने",
      "high": "उच्च",
      "low": "न्यून",
      "volume": "मात्रा",
      "problematicRowsSkipped": "यदि तपाईं अगाडि बढ्नुभयो भने {{count}} समस्याग्रस्त पङ्क्तिहरू छोडिनेछ।",
      "importValidRows": "मान्य पङ्क्तिहरू आयात गर्नुहोस् ({{count}})"
    },
    "actions": {
      "importPrice": "निर्यात मूल्य",
      "refreshMarketData": "बाजार डेटा फिर से लोड करो",
      "refreshPrice": "मूल्य फिर से लोड करो",
      "uploadMarketData": "बाजार डेटा अपलोड करो",
      "viewHistory": "विवरण देखो",
      "viewHistoryDesc": "विवरण देखो",
      "importPriceDesc": "निर्यात मूल्य",
      "refreshPriceDesc": "मूल्य फिर से लोड करो",
      "uploadMarketDataDesc": "बाजार डेटा अपलोड करो",
      "refreshMarketDataDesc": "बाजार डेटा फिर से लोड करो"
    },
    "upload": {
      "confirmation": "निर्यात किया छ यह बाजार डेटा फाइल?",
      "success": "विक्री तप्त होयोस"
    }
  },
  "navigation": {
    "lockedReasons": {
      "requiresEnterpriseTier": "इन्टरप्राइज टियर आवश्यक",
      "requiresProfessionalTier": "प्रोफेशनल टियर आवश्यक",
      "permissionRequired": "अनुमति आवश्यक",
      "unavailableData": "डाटा उपलब्ध छैन",
      "descriptorRequired": "डेस्क्रिप्टर आवश्यक छ",
      "notAvailable": "उपलब्ध नाह"
    },
    "planned": "चाँडै आउँदै",
    "maintenance": "मर्मतमा",
    "disabled": "अक्षम",
    "moduleDisabled": "मोड्युल अक्षम",
    "denied": "पहुँच अस्वीकृत",
    "aalRequired": "थप प्रमाणीकरण आवश्यक",
    "permissionDenied": "अनुमति आवश्यक",
    "actorDenied": "तपाईंको भूमिकाका लागि उपलब्ध छैन",
    "scopeDenied": "यो सन्दर्भमा उपलब्ध छैन",
    "clientScopeRequired": "ग्राहक सन्दर्भ आवश्यक",
    "delegationDenied": "प्रतिनिधित्व अनुमति छैन",
    "entitlementMissing": "उच्च तह आवश्यक",
    "reports": "रिपोर्टहरू"
  },
  "dataQualityOperational": {
    "criticalIssues": "मुख्य समस्या",
    "fixFirst": "पहले ठीक कर",
    "ok": "ठीक",
    "title": "डेटा गुणवत्ता संचालन",
    "description": "डेटा गुणवत्ता संचालन विवरण",
    "refresh": "रिफ्रेस गर्नुहोस्",
    "dataReliability": "डेटा विश्वसनीयता",
    "lastChecked": "अन्तिम जाँच",
    "marketPriceIssues": "बाजार की मूल्य समस्याहरू",
    "affectsValuation": "मूल्य पर प्रभाव डालता छ",
    "reconciliationIssues": "सहमति समस्याहरू",
    "affectsReports": "रिपोर्टों पर प्रभाव डालता छ",
    "importIssues": "आयात समस्याहरू",
    "affectsImports": "आयात पर प्रभाव डालता छ",
    "primaryIssueQueue": "प्राथमिक समस्या की शृंखला",
    "highestSeverityFirst": "उच्च गंभीरता पहले",
    "noIssuesTitle": "कोई समस्या छैन",
    "noIssuesDescription": "कोई समस्या छैन विवरण",
    "remediationActions": "समाधान कार्रवाई",
    "remediationActionsSubtitle": "समाधान कार्रवाई उपविभाग",
    "updateMarketPrices": "बाजार को अद्यतन कर्ने",
    "fixOpeningBalances": "प्रारंभिक वित्तीय संतुलन ठीक कर्ने",
    "reconcileTransactions": "व्यापारिक लेन-देन का समायोजन कर्ने",
    "fixContinuityGaps": "स्थिरता की खामियों को ठीक कर्ने",
    "needCertifiedEvidence": "प्रमाणित सबूत की आवश्यकता छ",
    "certifiedReportDescription": "प्रमाणित रिपोर्ट विवरण",
    "openDataQualityReport": "डेटा गुणवत्ता रिपोर्ट खोल्ने",
    "invalidViewFallback": "अस्थायी दृश्य पुनर्स्थापना कर्ने"
  },
  "nepal": {
    "vatDashboard": {
      "failedToLoadConfig": "वैट निगरानी मा सेटिंग को लोड करने मा असफल रहा",
      "failedToLoadReturns": "वैट रिटर्न्स लोड करने मा असफल रहा",
      "failedToLoadFiscalYears": "वैट वित्तीय वर्षों को लोड करने मा असफल रहा",
      "title": "वैट निगरानी",
      "updateConfig": "सेटिंग अपडेट कर्ने",
      "configureVat": "वैट सेटिंग स्थापित कर्ने",
      "loadingConfig": "सेटिंग लोड हो भइरहेको छ...",
      "registrationNo": "निगरानी नंबर",
      "notProvided": "प्रदान गरिएको छैन",
      "vatRate": "वैट दर",
      "registered": "संज्ञित",
      "since": "से",
      "vatRegistrationNumber": "वट रजिस्ट्रेशन नंबर",
      "vatRatePercent": "वट दर (%)",
      "effectiveFrom": "कार्यस्थिति से प्रभावित होने हुने तिथि",
      "registrationStatus": "रजिस्ट्रेशन की स्थिति",
      "submit": "प्रस्तुत गर्नुहोस्",
      "noReturnsYet": "तब्बे पुनः लेने का अवसर छैन",
      "activeFiscalYears": "सक्रिय वित्तीय वर्ष"
    },
    "irdExport": {
      "downloadFailed": "डाउनलोड असफल भयो",
      "title": "IRD निर्यातहरू",
      "description": "IRD-संगत CSV ढाँचामा कर रजिस्टरहरू डाउनलोड गर्नुहोस्।",
      "refreshFiscalYears": "आर्थिक वर्षहरू रिफ्रेस गर्नुहोस्",
      "loadingFiscalYears": "आर्थिक वर्षहरू लोड गर्दै…",
      "vatRegisters": "VAT रजिस्टरहरू (एनेक्स ९ / १०)",
      "from": "बाट",
      "to": "सम्म",
      "downloading": "डाउनलोड गर्दै…",
      "salesRegister": "बिक्री रजिस्टर (CSV)",
      "purchaseRegister": "खरिद रजिस्टर (CSV)",
      "tdsRegister": "TDS रजिस्टर (वार्षिक)",
      "fiscalYear": "आर्थिक वर्ष",
      "selectFiscalYear": "आर्थिक वर्ष छनोट गर्नुहोस्…",
      "tdsRegisterCsv": "TDS रजिस्टर (CSV)"
    }
  },
  "vat": {
    "registered": "पंजीकृत",
    "notRegistered": "पंजीकृत छैन",
    "vatReturns": "वट रिटर्न",
    "generateReturn": "रिटर्न बनाउनुहोस्",
    "period": "अवधि छान्नुहोस्",
    "outputVat": "निकाली गई वट",
    "inputVat": "प्रवेश गरिएको वट",
    "netVat": "नेट वट",
    "status": "स्थिति"
  },
  "root": {
    "navigation": {
      "overview": "अवलोकन",
      "branches": "शाखाहरू",
      "users": "प्रयोगकर्ताहरू",
      "audit": "अडिट",
      "system": "प्रणाली",
      "approvals": "अनुमोदनहरू",
      "jobs": "काम",
      "alerts": "सतर्कता",
      "powerTools": "पावर टुल्स",
      "settings": "सेटिङ्स"
    },
    "shell": {
      "title": "अधिनियम पोर्टल",
      "moreNavigationAria": "अधिक नेविगेशन",
      "openAdminToolsAria": "अधिनियम उपकरण खोलें",
      "adminTools": "अधिनियम उपकरण",
      "rootTools": "प्रारंभिक उपकरण",
      "connected": "जडान भयो",
      "logout": "निष्कासन गर्नुहोस्",
      "back": "पछाडि"
    },
    "health": {
      "healthy": "स्वस्थ",
      "degraded": "खराब"
    }
  },
  "rebalancing": {
    "view": {
      "disabled": {
        "title": "अक्षम",
        "description": "वर्तमान पोर्टफोलियो के लिए रीसेटिंग वर्तमान रूप से बंद छ.",
        "configurationHint": "संपर्क अपने प्रशासक से रीसेटिंग सक्षम करने के लिए।"
      },
      "header": {
        "title": "रिब्यालेन्सिङ",
        "description": "पोर्टफोलियो रीसेटिंग विश्लेषण और प्रस्तावों का विवरण.",
        "portfolioScenario": "पोर्टफोलियो स्केनरी",
        "refreshAnalysis": "विश्लेषण फिर से अद्यावधिक गर्नुहोस्"
      },
      "featureDisabled": {
        "title": "विशेषता बंद",
        "description": "आपकी संगठन के लिए रीसेटिंग विशेषता सक्षम छैन।"
      },
      "summary": {
        "portfolioId": "पोर्टफोलियो आईडी",
        "historyEntries": "इतिहास प्रवेश",
        "lastRebalanced": "अंतिम रीसेट गरिएको"
      },
      "analysis": {
        "title": "विश्लेषण",
        "description": "ड्रिफ विश्लेषण और सुझावित समायोजन।",
        "loading": "ग्राहक खाताहरू लोड गर्दै…",
        "totalDrift": "कुल ड्रिफ",
        "maxDrift": "मैक्स ड्रिफ",
        "rebalancingRequired": "रीसेटिंग आवश्यक छ",
        "noDriftData": "ड्रिफ डेटा छैन",
        "generateProposal": "प्रस्ताव बनाउनुहोस्"
      },
      "proposalReview": {
        "title": "प्रस्ताव समीक्षा",
        "description": "प्रस्तावित विनिमय का समीक्षा और मंजूरी देने के लिए समीक्षा गर्नुहोस्",
        "empty": "खाली",
        "proposalId": "प्रस्ताव ID",
        "estimatedCost": "अनुमानित लागत",
        "complianceChecks": "सहमति जांचें",
        "recommendedTrades": "प्रस्तावित विनिमय",
        "noTrades": "कोई विनिमय छैन",
        "submitForApproval": "मंजूरी के लिए जमा गर्नुहोस्",
        "approveProposal": "प्रस्ताव मंजूरी दें",
        "executeRebalancing": "विनिमय को चलहरू"
      },
      "execution": {
        "title": "निष्पादन",
        "description": "पुनर्व्यवस्थापन कार्यवाही को स्वीकृति प्राप्त कर लेने के लिए चलहरू।",
        "empty": "खाली",
        "successes": "सफलता",
        "failures": "असफलता",
        "totalCost": "कुल खर्च"
      },
      "history": {
        "title": "इतिहास",
        "description": "पूर्व पुनर्व्यवस्थापन प्रस्ताव और कार्यवाही.",
        "loading": "ग्राहक खाताहरू लोड गर्दै…",
        "empty": "खाली",
        "loadProposal": "प्रस्ताव लोड गर्नुहोस्"
      }
    },
    "actions": {
      "generateProposal": "प्रस्ताव बनाउनुहोस्",
      "generateProposalDesc": "प्रस्ताव बनाउनुहोस्",
      "execute": "कार्यवाही",
      "executeDesc": "पुनर्व्यवस्था कर"
    }
  },
  "investmentSettings": {
    "benchmark": {
      "title": "बेन्चमार्क कन्फिगरेसन",
      "description": "ड्यासबोर्ड र प्रदर्शन रिपोर्टहरूमा देखाइने बेन्चमार्क तुलना मानहरू नियन्त्रण गर्छ।",
      "fields": {
        "symbol": "बेन्चमार्क प्रतीक",
        "period": "तुलना अवधि",
        "manualTarget": "म्यानुअल लक्ष्य फिर्ती (%)",
        "sectorLimit": "क्षेत्र एकाग्रता सीमा (%)",
        "top10Limit": "शीर्ष १० होल्डिङ एकाग्रता सीमा (%)"
      },
      "placeholders": {
        "symbol": "उदाहरण: NEPSE",
        "period": "अवधि छान्नुहोस्",
        "manualTarget": "उदाहरण: 12.0",
        "sectorLimit": "उदाहरण: 30.0",
        "top10Limit": "उदाहरण: 40.0"
      },
      "periods": {
        "oneMonth": "१ महिना",
        "threeMonths": "३ महिना",
        "sixMonths": "६ महिना",
        "oneYear": "१ वर्ष",
        "threeYears": "३ वर्ष"
      },
      "descriptions": {
        "manualTarget": "YTD तुलनाका लागि वार्षिक लक्ष्य फिर्ती।",
        "sectorLimit": "कुनै एकल क्षेत्रका लागि अधिकतम अनुमति।",
        "top10Limit": "संयुक्त शीर्ष १० होल्डिङका लागि अधिकतम अनुमति।"
      },
      "notes": {
        "dataSourceLabel": "डेटा स्रोत:",
        "dataSource": "ब्याकएन्ड इन्डेक्स प्रदायकबाट दैनिक मूल्य श्रृंखला।",
        "manualTargetLabel": "म्यानुअल लक्ष्य:",
        "manualTarget": "कन्फिगर गरिएको भए, ड्यासबोर्डले YTD फिर्तीलाई यस लक्ष्यसँग तुलना गर्छ।",
        "concentrationLimitsLabel": "एकाग्रता सीमाहरू:",
        "concentrationLimits": "क्षेत्र र शीर्ष-१० निगरानीका लागि कन्फिगर गर्न सकिने सीमाहरू।"
      }
    }
  },
  "action": {
    "label": "कार्य",
    "labelDesc": "कार्य",
    "preview": "पूर्वदृश्य",
    "commit": "निर्धारित कर",
    "recover": "पुनः प्राप्त कर",
    "process": "चालू कर",
    "edit": "सम्पादन गर्नुहोस्",
    "delete": "मेटाउनुहोस्",
    "submit": "सहमति दे",
    "approve": "स्वीकृत गर्नुहोस्",
    "post": "पोस्ट",
    "reverse": "वापसी कर",
    "start": "शुरू कर",
    "upload": "अपलोड कर",
    "cancel": "रद्द कर",
    "save": "सेभ गर्नुहोस्",
    "saveSuccess": "सफलतापूर्वक सुरक्षित गरियो",
    "withdraw": "निकाले जाना",
    "repair": "मर्मत गर्नुहोस्",
    "repost": "पुनः पोस्ट गर्नुहोस्",
    "create": "सिर्जना गर्नुहोस्",
    "import": "आयात गर्",
    "viewBreaks": "भिन्नताहरू हेर्नुहोस्",
    "retry": "पुनः प्रयास",
    "transferPosition": "स्थिति स्थानान्तरण गर्नुहोस्",
    "eligibility": {
      "invalidState": "हालको रेकर्ड अवस्थाको लागि यो कार्य उपलब्ध छैन।",
      "makerCheckerViolation": "मेकर-चेकर नीति: तपाईं आफ्नै अनुरोध स्वीकृत गर्न सक्नुहुन्न।",
      "selfModification": "तपाईं आफ्नो पहुँच परिमार्जन गर्न सक्नुहुन्न।",
      "lastAdmin": "यो अन्तिम प्रशासक हो र असक्षम गर्न सकिँदैन।",
      "systemRole": "प्रणाली भूमिकाहरू परिमार्जन वा मेटाउन सकिँदैन।",
      "roleInUse": "यो भूमिका प्रयोगकर्ताहरूलाई assigned छ र मेटाउन सकिँदैन।"
    },
    "reactivate": "पुनः सक्रिय गर्नुहोस्",
    "restate": "पुनः विवरण गर्नुहोस्",
    "retire": "अवकाश दिनुहोस्",
    "suspend": "निलम्बित गर्नुहोस्",
    "view": "हेर्नुहोस्",
    "reject": "अस्वीकृत गर्नुहोस्: Investment Corporate Action",
    "disable": "असक्षम गर्नुहोस्"
  },
  "journal": {
    "createTitle": "जर्नल सिर्जना गर्नुहोस्",
    "entryDate": "प्रविष्टि मिति",
    "fiscalYear": "आर्थिक वर्ष",
    "reference": "सन्दर्भ",
    "narration": "विवरण",
    "lines": "जर्नल लाइनहरू",
    "ledgerAccount": "लेजर खाता",
    "debit": "डेबिट",
    "credit": "क्रेडिट",
    "lineNarration": "लाइन विवरण",
    "addLine": "लाइन थप्नुहोस्",
    "removeLine": "लाइन हटाउनुहोस्",
    "create": "मस्यौदा सिर्जना गर्नुहोस्",
    "createFailed": "जर्नल मस्यौदा सिर्जना गर्न सकिएन।",
    "balancedLineGuidance": "सन्तुलित डेबिट र क्रेडिट लाइनहरू प्रविष्ट गर्नुहोस्। सुरक्षित गर्नु अघि सर्भरले अन्तिम जर्नल प्रमाणीकरण गर्छ।",
    "reverseTitle": "जर्नल प्रविष्टि उल्टाउनुहोस्",
    "reversePrompt": "के तपाईं यो जर्नल प्रविष्टि उल्टाउन निश्चित हुनुहुन्छ? विपरित दिशामा एक उल्टाउने प्रविष्टि सिर्जना हुनेछ।",
    "reversalDate": "उल्टाउने मिति",
    "reversalReason": "उल्टाउने कारण",
    "validation": {
      "entryDateOutsideFiscalYear": "प्रविष्टि मिति चयन गरिएको खुला आर्थिक वर्षभित्र हुनुपर्छ।",
      "accountRequired": "यस पङ्क्तिका लागि लेजर खाता चयन गर्नुहोस्।",
      "amountInvalid": "मान्य ऋणात्मक नभएको रकम प्रविष्ट गर्नुहोस्।",
      "sideRequired": "धनात्मक डेबिट वा क्रेडिट रकममध्ये एउटा मात्र प्रविष्ट गर्नुहोस्।"
    }
  },
  "item": {
    "label": "वस्तु",
    "labelDesc": "वस्तु"
  },
  "report": {
    "table": {
      "row": "पंक्ति",
      "rowDesc": "पंक्ति",
      "value": "मान",
      "valueDesc": "मान"
    },
    "portfolio": {
      "title": "पोर्टफोलियो रिपोर्ट"
    },
    "tax": {
      "title": "कर रिपोर्ट"
    },
    "download": "डाउनलोड करे",
    "asOf": "मिति अनुसार",
    "parameters": "प्यारामिटरहरू",
    "formats": "उपलब्ध ढाँचाहरू"
  },
  "composition": {
    "chartRendered": "चार्ट पुनः चित्रित हुआ",
    "chartNoData": "चार्ट मा डेटा छैन",
    "tableNotAvailable": "उपलब्ध छैन"
  },
  "governance": {
    "noAuditEntries": "प्रत्येक प्रमाणीकरण न गरिएका प्रवेश",
    "auditTimelineTitle": "प्रमाणीकरण समयरेखा",
    "explainAccessTitle": "विस्तार से पहुँच",
    "runExplainAccess": "विस्तार से पहुँच",
    "formNotAvailable": "उपलब्ध छैन",
    "formFieldPlaceholder": "क्षेत्रफल",
    "tableNotAvailable": "उपलब्ध छैन",
    "systemPostureTitle": "प्रणाली अवस्था",
    "actionResult": {
      "exportId": "निर्यात आईडी",
      "recordCount": "रेकर्डहरू",
      "status": "स्थिति",
      "download": "निर्यात डाउनलोड गर्नुहोस्",
      "checkStatus": "स्थिति जाँचें",
      "entityCreated": "मूल रूप से बनाया गया {{entityType}} ({{entityId}})",
      "entityUpdated": "बदला गया {{entityType}} ({{entityId}})",
      "changedFields": "परिवर्तित क्षेत्र",
      "refreshedAt": "नई से अपडेट गरिएको",
      "affectedCount": "प्रभावित रिकॉर्ड",
      "fieldLabels": {
        "name": "नाम",
        "address": "गल्ली ठेगाना",
        "description": "क्षेत्रफल वर्णन",
        "status": "स्थिति",
        "email": "इमेल",
        "phone": "फोन",
        "code": "कोड",
        "tier": "टियर"
      },
      "entityDeleted": "मूल रूप से हटा दिया गया"
    },
    "explainAccessResultTitle": "विस्तार से पहुँच परिणाम",
    "explainAccess": {
      "finalDecision": "अंतिम निर्णय"
    },
    "formSubmitActionMissing": "नप्र कानूनका अनुसार प्रस्तुतीकरण कराए"
  },
  "workflows": {
    "noStep": "चाल आइटम नाहो",
    "stepIndicator": "चाल संकेतक",
    "formNotAvailable": "आयोजन नै",
    "formFieldPlaceholder": "खण्ड",
    "previewNotAvailable": "नस्विचित हुन्छ",
    "previewTitle": "पूर्वदृश्य",
    "previewTruncated": "पूर्वदृश्य सीमित",
    "startOver": "पुनः शुरू कर",
    "reviewTitle": "समीक्षा गर्नुहोस्",
    "uploadInstructions": "अपलोड निर्देश",
    "selectFile": "चित्र चुन्न",
    "confirmUpload": "अपलोड सत्यापित गर्छन",
    "validationPassed": "सत्यापन सफल होय",
    "validationIssues": "सत्यापन समस्या"
  },
  "approvals": {
    "actions": {
      "approve": "अनुमोदन गर्नुहोस्",
      "approveDesc": "अनुमोदन गर्नुहोस्",
      "reject": "अस्वीकार गर्नुहोस्",
      "rejectDesc": "अस्वीकार गर्नुहोस्"
    }
  },
  "submit": "भेज",
  "submitDesc": "भेज",
  "navigate": "पार्न्थन गर्छन",
  "navigateDesc": "पार्नथन गर्छन",
  "delete": "मेटाउनुहोस्",
  "deleteDesc": "मेटाउनुहोस्",
  "Next": "पछिल्लो",
  "NextDesc": "पछिल्लो",
  "dataQuality": {
    "actions": {
      "remediate": "सुधार गर्छन",
      "remediateDesc": "सुधार"
    }
  },
  "bulkTransactions": {
    "actions": {
      "validate": "नियंत्रित गर्ने",
      "validateDesc": "नियंत्रित गर्ने",
      "commit": "समायोजन गर्नु",
      "commitDesc": "समायोजन गर्नु"
    }
  },
  "surface": {
    "actions": {
      "errors": {
        "unsupportedActionKind": "सहयोग गर्ने किसिमको समर्थन छैन",
        "missingEndpoint": "अन्तिम बिंदु निकालिए",
        "missingMethod": "विधि निकालिए",
        "invalidReasonPayload": "अस्थिर कारण भारी पेमा",
        "uploadPayloadRequired": "भारी पेमा अपलोड गर्ने आवश्यक"
      }
    }
  },
  "a11y": {
    "form": {
      "reports": {
        "parameters": "प्रतिवेदन प्यारामिटरहरू",
        "definition": "प्रतिवेदन परिभाषा",
        "run": "रिपोर्ट चलाउने फारम",
        "runIrdFiscalYear": "Reports Run Ird Fiscal Year फारम",
        "liveParameters": "प्रत्यक्ष प्रतिवेदन मापदण्ड फारम",
        "holdingsParameters": "होल्डिङ प्रतिवेदन मापदण्ड फारम",
        "clientHoldingsParameters": "ग्राहक होल्डिङ प्रतिवेदन मापदण्ड फारम",
        "trialBalanceParameters": "ट्रायल ब्यालेन्स प्रतिवेदन मापदण्ड फारम",
        "reconciliationParameters": "मिलान प्रतिवेदन मापदण्ड फारम",
        "transactionActivityParameters": "कारोबार गतिविधि प्रतिवेदन मापदण्ड फाराम",
        "financialStatementsParameters": "वित्तीय विवरण प्रतिवेदन मापदण्ड फाराम",
        "irdRun": "IRD पूँजीगत लाभकर दाखिला चलाइ फारम",
        "portfolioPerformance": "पोर्टफोलियो कार्यसम्पादन प्रतिवेदन मापदण्ड",
        "portfolioCustodyEvidence": "सीडीएससी कस्टडी प्रमाण प्रतिवेदन मापदण्ड"
      },
      "admin": {
        "branch": {
          "create": "admin branch सिर्जना फारम",
          "edit": "admin branch सम्पादन फारम",
          "view": "प्रशासन शाखा हेर्ने फारम"
        },
        "client": {
          "create": "admin client सिर्जना फारम",
          "edit": "admin client सम्पादन फारम",
          "view": "प्रशासन ग्राहक हेर्ने फारम"
        },
        "clientAccount": {
          "create": "admin clientAccount सिर्जना फारम",
          "edit": "admin clientAccount सम्पादन फारम",
          "view": "प्रशासन ग्राहक खाता हेर्ने फारम"
        },
        "moduleAssignment": {
          "create": "admin moduleAssignment सिर्जना फारम",
          "edit": "admin moduleAssignment सम्पादन फारम",
          "view": "प्रशासन मोड्युल असाइनमेन्ट हेर्ने फारम"
        },
        "organizationProfile": {
          "edit": "प्रशासन संगठन प्रोफाइल सम्पादन फारम"
        },
        "platformModuleAssignment": {
          "create": "admin platformModuleAssignment सिर्जना फारम"
        },
        "platformOrganization": {
          "edit": "admin platformOrganization सम्पादन फारम",
          "view": "प्रशासन Platform Organization हेर्ने फारम"
        },
        "platformUser": {
          "create": "admin platformUser सिर्जना फारम",
          "edit": "admin platformUser सम्पादन फारम",
          "view": "प्रशासन प्लेटफर्म प्रयोगकर्ता हेर्ने फारम"
        },
        "portfolio": {
          "create": "admin portfolio सिर्जना फारम",
          "edit": "admin portfolio सम्पादन फारम",
          "view": "प्रशासन पोर्टफोलियो हेर्ने फारम"
        },
        "role": {
          "create": "प्रशासन भूमिका सिर्जना फारम",
          "edit": "प्रशासन भूमिका सम्पादन फारम",
          "view": "प्रशासन भूमिका हेर्ने फारम"
        },
        "user": {
          "create": "प्रशासन प्रयोगकर्ता सिर्जना फारम",
          "edit": "प्रशासन प्रयोगकर्ता सम्पादन फारम",
          "view": "प्रशासन प्रयोगकर्ता हेर्ने फारम"
        }
      },
      "data": {
        "corporateAction": {
          "create": "डाटा Corporate Action सिर्जना फारम",
          "edit": "डाटा Corporate Action सम्पादन फारम",
          "view": "डाटा Corporate Action हेर्ने फारम"
        },
        "instrument": {
          "create": "डाटा Instrument सिर्जना फारम",
          "edit": "डाटा Instrument सम्पादन फारम",
          "view": "डाटा Instrument हेर्ने फारम"
        }
      },
      "importJob": {
        "create": "आयात कार्य सिर्जना फारम"
      },
      "report": {
        "clientStatement": {
          "parameters": "Report Client Statement Parameters फारम"
        }
      },
      "transaction": {
        "create": "लेखा सिर्जना फारम"
      },
      "platformSupportDelegation": {
        "create": "मर्मत प्रतिनिधित्व सिर्जना फारम",
        "view": "मर्मत प्रतिनिधित्व विवरण फारम",
        "revoke": "मर्मत प्रतिनिधित्व रद्द फारम"
      }
    },
    "action": {
      "accounting": {
        "journals": {
          "post": "पोस्ट गर्नुहोस् लेखा जरनल",
          "reverse": "उल्टाउनुहोस् लेखा जरनल"
        }
      },
      "admin": {
        "openingCutover": {
          "import": "आयात गर्नुहोस् प्रशासन सुरुको कटओभर"
        }
      },
      "data": {
        "cash": {
          "view": "हेर्नुहोस् डाटा नगद"
        },
        "corporateActions": {
          "approve": "अनुमोदन गर्नुहोस् डाटा कर्पोरेट कार्य",
          "cancel": "रद्द गर्नुहोस् डाटा कर्पोरेट कार्य",
          "create": "सिर्जना गर्नुहोस् डाटा कर्पोरेट कार्य",
          "edit": "सम्पादन गर्नुहोस् डाटा कर्पोरेट कार्य",
          "process": "प्रशोधन गर्नुहोस् डाटा कर्पोरेट कार्य",
          "submit": "पेश गर्नुहोस् डाटा कर्पोरेट कार्य"
        },
        "instruments": {
          "create": "सिर्जना गर्नुहोस् डाटा साधन",
          "edit": "सम्पादन गर्नुहोस् डाटा साधन",
          "import": "आयात गर्नुहोस् डाटा साधन"
        },
        "marketPrices": {
          "import": "आयात गर्नुहोस् डाटा बजार मूल्य"
        },
        "positions": {
          "transfer": "स्थानान्तरण गर्नुहोस् डाटा स्थिति",
          "view": "हेर्नुहोस् डाटा स्थिति"
        },
        "reconciliation": {
          "cancel": "रद्द गर्नुहोस् डाटा मेलमिलाप",
          "create": "सिर्जना गर्नुहोस् डाटा मेलमिलाप",
          "retry": "पुनः प्रयास गर्नुहोस् डाटा मेलमिलाप",
          "viewBreaks": "विच्छेदनहरू हेर्नुहोस् डाटा मेलमिलाप"
        }
      },
      "holdings": {
        "view": "हेर्नुहोस् होल्डिङ"
      },
      "importJob": {
        "create": "सिर्जना गर्नुहोस् आयात कार्य"
      },
      "investment": {
        "positionTransfers": {
          "approve": "अनुमोदन गर्नुहोस् लगानी स्थिति स्थानान्तरण",
          "cancel": "रद्द गर्नुहोस् लगानी स्थिति स्थानान्तरण",
          "execute": "कार्यान्वयन गर्नुहोस् लगानी स्थिति स्थानान्तरण",
          "request": "अनुरोध गर्नुहोस् लगानी स्थिति स्थानान्तरण",
          "reverse": "उल्टाउनुहोस् लगानी स्थिति स्थानान्तरण"
        },
        "transactions": {
          "approve": "अनुमोदन गर्नुहोस् लगानी लेखा",
          "import": "आयात गर्नुहोस् लगानी लेखा",
          "post": "पोस्ट गर्नुहोस् लगानी लेखा",
          "reject": "अस्वीकृत गर्नुहोस् लगानी लेखा",
          "repair": "मरम्मत गर्नुहोस् लगानी लेखा",
          "repost": "पुनः पोस्ट गर्नुहोस् लगानी लेखा",
          "reverse": "उल्टाउनुहोस् लगानी लेखा",
          "submit": "पेश गर्नुहोस् लगानी लेखा",
          "withdraw": "फिर्ता लिनुहोस् लगानी लेखा"
        }
      },
      "moduleAssignment": {
        "configure": "कन्फिगर गर्नुहोस् मोड्युल असाइनमेन्ट"
      },
      "openingCutover": {
        "view": "हेर्नुहोस् सुरुको कटओभर"
      },
      "organizationBranch": {
        "delete": "मेटाउनुहोस् संगठन शाखा",
        "edit": "सम्पादन गर्नुहोस् संगठन शाखा"
      },
      "organizationClient": {
        "delete": "मेटाउनुहोस् संगठन ग्राहक",
        "edit": "सम्पादन गर्नुहोस् संगठन ग्राहक"
      },
      "organizationClientAccount": {
        "disable": "अक्षम गर्नुहोस् संगठन ग्राहक खाता",
        "edit": "सम्पादन गर्नुहोस् संगठन ग्राहक खाता"
      },
      "organizationModuleAssignment": {
        "delete": "मेटाउनुहोस् संगठन मोड्युल असाइनमेन्ट"
      },
      "organizationPortfolio": {
        "disable": "अक्षम गर्नुहोस् संगठन पोर्टफोलियो",
        "edit": "सम्पादन गर्नुहोस् संगठन पोर्टफोलियो"
      },
      "organizationProfile": {
        "edit": "सम्पादन गर्नुहोस् संगठन प्रोफाइल",
        "save": "सुरक्षित गर्नुहोस् संगठन प्रोफाइल"
      },
      "platformModule": {
        "revoke": "revoke प्लेटफर्म मोड्युल"
      },
      "platformUser": {
        "disable": "अक्षम गर्नुहोस् प्लेटफर्म प्रयोगकर्ता",
        "edit": "सम्पादन गर्नुहोस् प्लेटफर्म प्रयोगकर्ता"
      },
      "role": {
        "create": "सिर्जना गर्नुहोस् भूमिका",
        "update": "अद्यावधिक गर्नुहोस् भूमिका"
      },
      "settlement": {
        "instructions": {
          "cancel": "रद्द गर्नुहोस् निस्तारण निर्देशन",
          "confirm": "पुष्टि गर्नुहोस् निस्तारण निर्देशन",
          "correct": "सच्याउनुहोस् निस्तारण निर्देशन",
          "create": "सिर्जना गर्नुहोस् निस्तारण निर्देशन"
        }
      },
      "submit": "पेश गर्नुहोस्",
      "transaction": {
        "create": "सिर्जना गर्नुहोस् लेखा"
      },
      "user": {
        "create": "सिर्जना गर्नुहोस् प्रयोगकर्ता",
        "update": "अद्यावधिक गर्नुहोस् प्रयोगकर्ता"
      },
      "form": {
        "admin": {
          "branch": {
            "create": {
              "submit": "प्रशासन शाखा सिर्जना फारम पेश गर्नुहोस्"
            },
            "edit": {
              "submit": "प्रशासन शाखा सम्पादन फारम पेश गर्नुहोस्"
            }
          },
          "client": {
            "create": {
              "submit": "प्रशासन ग्राहक सिर्जना फारम पेश गर्नुहोस्"
            },
            "edit": {
              "submit": "प्रशासन ग्राहक सम्पादन फारम पेश गर्नुहोस्"
            }
          },
          "clientAccount": {
            "create": {
              "submit": "प्रशासन ग्राहक खाता सिर्जना फारम पेश गर्नुहोस्"
            },
            "edit": {
              "submit": "प्रशासन ग्राहक खाता सम्पादन फारम पेश गर्नुहोस्"
            }
          },
          "moduleAssignment": {
            "create": {
              "submit": "प्रशासन मोड्युल असाइनमेन्ट सिर्जना फारम पेश गर्नुहोस्"
            },
            "edit": {
              "submit": "प्रशासन मोड्युल असाइनमेन्ट सम्पादन फारम पेश गर्नुहोस्"
            }
          },
          "platformModuleAssignment": {
            "create": {
              "submit": "प्रशासन Platform Module Assignment सिर्जना फारम पेश गर्नुहोस्"
            }
          },
          "platformOrganization": {
            "edit": {
              "submit": "प्रशासन Platform Organization सम्पादन फारम पेश गर्नुहोस्"
            }
          },
          "platformUser": {
            "create": {
              "submit": "प्रशासन प्लेटफर्म प्रयोगकर्ता सिर्जना फारम पेश गर्नुहोस्"
            },
            "edit": {
              "submit": "प्रशासन प्लेटफर्म प्रयोगकर्ता सम्पादन फारम पेश गर्नुहोस्"
            }
          },
          "portfolio": {
            "create": {
              "submit": "प्रशासन पोर्टफोलियो सिर्जना फारम पेश गर्नुहोस्"
            },
            "edit": {
              "submit": "प्रशासन पोर्टफोलियो सम्पादन फारम पेश गर्नुहोस्"
            }
          }
        }
      },
      "reports": {
        "cancel": "रिपोर्ट संवाद रद्द गर्नुहोस्",
        "runLive": "शासित प्रत्यक्ष प्रतिवेदन चलाउनुहोस्"
      },
      "create": "सिर्जना गर्नुहोस्",
      "edit": "सम्पादन गर्नुहोस्",
      "delete": "निष्क्रिय बनाउनुहोस्",
      "cancel": "रद्द गर्नुहोस्",
      "platformSupportDelegation": {
        "create": "सीमित मर्मत प्रतिनिधित्व सिर्जना गर्नुहोस्",
        "revoke": "मर्मत प्रतिनिधित्व रद्द पृष्ठ खोल्नुहोस्",
        "confirmRevoke": "मर्मत प्रतिनिधित्व रद्द पुष्टि गर्नुहोस्"
      }
    },
    "dashboard": {
      "platform": "प्लेटफर्म सञ्चालन ड्यासबोर्ड",
      "organization": "संस्थाको पोर्टफोलियो ड्यासबोर्ड",
      "client": "ग्राहक पोर्टफोलियो ड्यासबोर्ड"
    },
    "accountNumber": "खाता नम्बर",
    "accountType": "खाता प्रकार",
    "actionType": "कार्य प्रकार",
    "approvedAt": "अनुमोदन मिति",
    "approvedBy": "अनुमोदनकर्ता",
    "asOfDate": "मिति सम्म",
    "assignedModules": "असाइन गरिएका मोड्युल",
    "availableQuantity": "उपलब्ध परिमाण",
    "avgCost": "औसत लागत",
    "baseCurrency": "आधार मुद्रा",
    "boId": "BO आईडी",
    "branchCount": "शाखा संख्या",
    "breachType": "उल्लंघन प्रकार",
    "breachValue": "उल्लंघन मूल्य",
    "businessReference": "व्यावसायिक सन्दर्भ",
    "capitalGain": "पुँजी लाभ",
    "change": "परिवर्तन",
    "client": "ग्राहक",
    "clientAccountId": "ग्राहक खाता आईडी",
    "clientCode": "ग्राहक कोड",
    "clientName": "ग्राहक नाम",
    "clientType": "ग्राहक प्रकार",
    "code": "कोड",
    "completedAt": "सम्पन्न मिति",
    "concentrationPct": "कन्सन्ट्रेसन प्रतिशत",
    "configurationVersionId": "कन्फिगरेसन संस्करण आईडी",
    "createdAt": "सिर्जना मिति",
    "currency": "मुद्रा",
    "currentBalance": "हालको मौज्दात",
    "custodyAccount": "कस्टडी खाता",
    "destinationPortfolioAccountId": "गन्तव्य पोर्टफोलियो खाता आईडी",
    "detectedAt": "पत्ता लागेको मिति",
    "displayName": "प्रदर्शन नाम",
    "dpCode": "DP कोड",
    "email": "इमेल",
    "endDate": "अन्तिम मिति",
    "entityId": "इकाई आईडी",
    "entityType": "इकाई प्रकार",
    "entryDate": "प्रविष्टि मिति",
    "entryNumber": "प्रविष्टि नम्बर",
    "errorCount": "त्रुटि संख्या",
    "exDate": "Ex-मिति",
    "exchange": "एक्सचेञ्ज",
    "expectedCash": "अपेक्षित नगद",
    "expectedDate": "अपेक्षित मिति",
    "expectedQuantity": "अपेक्षित परिमाण",
    "externalReference": "बाह्य सन्दर्भ",
    "failureReason": "असफलता कारण",
    "firstName": "पहिलो नाम",
    "fiscalYearName": "आर्थिक वर्ष नाम",
    "fullName": "पूरा नाम",
    "holdingPeriodDays": "होल्डिङ अवधि (दिन)",
    "id": "आईडी",
    "importType": "आयात प्रकार",
    "instrumentName": "साधन नाम",
    "instrumentSymbol": "साधन प्रतीक",
    "instrumentType": "साधन प्रकार",
    "isActive": "सक्रिय",
    "isDefault": "पूर्वनिर्धारित",
    "isLocked": "बन्द",
    "isSystem": "प्रणाली",
    "isin": "ISIN",
    "journalEntryId": "जरनल प्रविष्टि आईडी",
    "jurisdiction": "क्षेत्राधिकार",
    "lastName": "थर",
    "lastUpdated": "अन्तिम अद्यावधिक",
    "limitValue": "सीमा मूल्य",
    "lots": "लट",
    "manifestHash": "म्यानिफेस्ट ह्यास",
    "marketPrice": "बजार मूल्य",
    "marketValue": "बजार मूल्य",
    "marketValueCurrency": "बजार मूल्य मुद्रा",
    "matchedRecords": "मेल खाएका रेकर्ड",
    "membershipStatus": "सदस्यता स्थिति",
    "mfaEnabled": "MFA सक्षम",
    "module": "मोड्युल",
    "name": "नाम",
    "narration": "विवरण",
    "ownerClientAccountId": "स्वामी ग्राहक खाता आईडी",
    "ownerType": "स्वामी प्रकार",
    "parentBranchId": "मूल शाखा आईडी",
    "parentBranchName": "मूल शाखा नाम",
    "payDate": "भुक्तानी मिति",
    "periodNumber": "अवधि नम्बर",
    "platformAccess": {
      "action": "कार्य",
      "module": "मोड्युल",
      "permission": "नुमति",
      "persona": "पर्सोना",
      "resource": "स्रोत",
      "roleCode": "भूमिका कोड",
      "scope": "क्षेत्र"
    },
    "platformModule": {
      "effectiveFrom": "प्रभावकारी मिति",
      "expectedUpdatedAt": "अपेक्षित अद्यावधिक मिति",
      "maxBranches": "अधिकतम शाखा",
      "maxUsers": "अधिकतम प्रयोगकर्ता",
      "module": "मोड्युल",
      "organization": "संगठन",
      "organizationCode": "संगठन कोड",
      "status": "स्थिति"
    },
    "portfolioAccountId": "पोर्टफोलियो खाता आईडी",
    "portfolioAccountNumber": "पोर्टफोलियो खाता नम्बर",
    "previewedBy": "पूर्वावलोकनकर्ता",
    "pricePerUnit": "एकाइ मूल्य",
    "quantity": "परिमाण",
    "reason": "कारण",
    "recordCount": "रेकर्ड संख्या",
    "recordDate": "रेकर्ड मिति",
    "recoveryQueue": "पुनःप्राप्ति पङ्क्ति",
    "reference": "सन्दर्भ",
    "reports": {
      "generateRun": "रिपोर्ट चलाउनुहोस्",
      "saveDefinition": "रिपोर्ट परिभाषा सुरक्षित गर्नुहोस्"
    },
    "reversalReason": "उल्टाउने कारण",
    "reversedAt": "उल्टाइएको मिति",
    "reversedBy": "उल्टाउने",
    "riskMeasure": "जोखिम मापन",
    "roles": "भूमिकाहरू",
    "ruleId": "नियम आईडी",
    "ruleVersion": "नियम संस्करण",
    "runId": "चलाइएको आईडी",
    "saleDate": "बिक्री मिति",
    "sector": "क्षेत्र",
    "securityName": "सुरक्षा नाम",
    "settledCash": "निस्तारण भएको नगद",
    "settledQuantity": "निस्तारण भएको परिमाण",
    "severity": "गम्भीरता",
    "sourceAuthority": "स्रोत अधिकारी",
    "sourceBatchId": "स्रोत ब्याच आईडी",
    "sourceFileName": "स्रोत फाइल नाम",
    "sourcePortfolioAccountId": "स्रोत पोर्टफोलियो खाता आईडी",
    "sourceState": "स्रोत स्थिति",
    "startDate": "सुरु मिति",
    "startedAt": "सुरु भएको मिति",
    "status": "स्थिति",
    "strategy": "रणनीति",
    "supersededByBatchId": "प्रतिस्थापन भएको ब्याच आईडी",
    "supersedesBatchId": "प्रतिस्थापन गर्ने ब्याच आईडी",
    "symbol": "प्रतीक",
    "table": {
      "admin": {
        "audit": "प्रशासन Audit तालिका",
        "openingCutover": "प्रशासन सुरुको कटओभर तालिका",
        "organizationBranches": "प्रशासन Organization Branches तालिका",
        "organizationClientAccounts": "प्रशासन Organization Client Accounts तालिका",
        "organizationClients": "प्रशासन Organization Clients तालिका",
        "organizationModuleAssignments": "प्रशासन Organization Module Assignments तालिका",
        "organizationPortfolios": "प्रशासन Organization Portfolios तालिका",
        "organizations": "प्रशासन Organizations तालिका",
        "platformAccessInspector": "प्रशासन Platform Access Inspector तालिका",
        "platformModules": "प्रशासन Platform Modules तालिका",
        "roles": "प्रशासन भूमिकाहरू तालिका",
        "users": "प्रशासन Users तालिका"
      },
      "dashboard": {
        "holdings": "Dashboard होल्डिङ तालिका"
      },
      "data": {
        "cashPositions": "डाटा Cash Positions तालिका",
        "clients": "डाटा Clients तालिका",
        "complianceBreaches": "डाटा Compliance Breaches तालिका",
        "corporateActions": "डाटा कर्पोरेट कार्य तालिका",
        "factBatches": "डाटा Fact Batches तालिका",
        "fiscalPeriods": "डाटा Fiscal Periods तालिका",
        "holdings": "डाटा होल्डिङ तालिका",
        "importJobs": "डाटा Import Jobs तालिका",
        "instruments": "डाटा साधन तालिका",
        "journals": "डाटा जरनल तालिका",
        "portfolios": "डाटा Portfolios तालिका",
        "positions": "डाटा स्थिति तालिका",
        "reconciliationRuns": "डाटा Reconciliation Runs तालिका",
        "riskExposures": "डाटा Risk Exposures तालिका",
        "taxRecords": "डाटा Tax Records तालिका",
        "fiscalYears": "आर्थिक वर्षहरू तालिका"
      },
      "investment": {
        "positionTransfers": "लगानी स्थिति स्थानान्तरण तालिका",
        "transactions": "लगानी लेखा तालिका"
      },
      "settlement": {
        "instructions": "निस्तारण निर्देशन तालिका"
      },
      "platformSupportDelegations": "मर्मत प्रतिनिधित्व तालिका",
      "marketPrices": "बजार मूल्य र मूल्याङ्कन अवलोकन",
      "portfolioPerformance": "पोर्टफोलियो कार्यसम्पादन, नेपाल कर र एनएफआरएस प्रमाण सारांश"
    },
    "taxAmount": "कर रकम",
    "taxDomain": "कर क्षेत्र",
    "taxRate": "कर दर",
    "totalAmount": "कुल रकम",
    "totalCost": "कुल लागत",
    "totalCredit": "कुल क्रेडिट",
    "totalDebit": "कुल डेबिट",
    "totalLines": "कुल लाइन",
    "totalQuantity": "कुल परिमाण",
    "totalRecords": "कुल रेकर्ड",
    "transactionDate": "लेखा मिति",
    "transactionId": "लेखा आईडी",
    "transactionType": "लेखा प्रकार",
    "unmatchedRecords": "मेल नखाएका रेकर्ड",
    "unrealizedGainLoss": "अनरियलाइज्ड लाभ/हानि",
    "unrealizedPnl": "अनरियलाइज्ड P&L",
    "updatedAt": "अद्यावधिक मिति",
    "userEmail": "प्रयोगकर्ता इमेल",
    "userTypeId": "प्रयोगकर्ता प्रकार आईडी",
    "valuation": "मूल्याङ्कन",
    "valuationAsOf": "मूल्याङ्कन मिति सम्म",
    "valuationFreshness": "मूल्याङ्कन ताजापन",
    "valuationSource": "मूल्याङ्कन स्रोत",
    "version": "संस्करण",
    "warningCount": "चेतावनी संख्या",
    "weightedAverageCost": "भारित औसत लागत",
    "col": {
      "rowData": "सेरी डेटा",
      "approvedAt": "अनुमोदन मिति",
      "approvedBy": "अनुमोदनकर्ता",
      "journalEntryId": "जरनल प्रविष्टि आईडी",
      "manifestHash": "म्यानिफेस्ट ह्यास",
      "previewedBy": "पूर्वावलोकनकर्ता",
      "reversalReason": "उल्टाउने कारण",
      "recoveryQueue": "पुनःप्राप्ति पङ्क्ति",
      "reversedAt": "उल्टाइएको मिति",
      "reversedBy": "उल्टाउने",
      "supersededByBatchId": "प्रतिस्थापन भएको ब्याच आईडी",
      "supersedesBatchId": "प्रतिस्थापन गर्ने ब्याच आईडी",
      "totalLines": "कुल लाइन",
      "errors": "त्रुटिहरू (विस्तृतहरूको लागि कन्सोल हेर्नुहोस्)",
      "warnings": "चेतावनियाँ",
      "importType": "आयात प्रकार",
      "sourceFileName": "स्रोत फाइल नाम",
      "symbol": "प्रतीक",
      "name": "नाम",
      "firstName": "पहिलो नाम",
      "lastName": "थर",
      "isin": "ISIN",
      "assetType": "वस्तु प्रकार",
      "runId": "चलाइएको आईडी",
      "businessReference": "व्यावसायिक सन्दर्भ",
      "sourcePortfolioAccountId": "स्रोत पोर्टफोलियो खाता आईडी",
      "destinationPortfolioAccountId": "गन्तव्य पोर्टफोलियो खाता आईडी",
      "transactionId": "लेखा आईडी",
      "expectedQuantity": "अपेक्षित परिमाण",
      "settledQuantity": "निस्तारण भएको परिमाण",
      "expectedCash": "अपेक्षित नगद",
      "settledCash": "निस्तारण भएको नगद",
      "expectedDate": "अपेक्षित मिति",
      "failureReason": "असफलता कारण",
      "reason": "कारण",
      "status": "स्थिति",
      "startedAt": "सुरु भएको मिति",
      "completedAt": "सम्पन्न मिति",
      "id": "आईडी",
      "type": "प्रकार",
      "date": "मिति",
      "email": "इमेल",
      "mfa": "एमएफए",
      "roles": "भूमिकाहरू",
      "orgTenant": "संगठन / शाखा",
      "userType": "व्यक्ति प्रकार",
      "system": "प्रणाली",
      "quantity": "परिमाण",
      "avgCost": "औसत लागत",
      "marketPrice": "बजार मूल्य",
      "marketValue": "बजार मूल्य",
      "valuation": "मूल्याङ्कन",
      "valuationAsOf": "मूल्याङ्कन मिति सम्म",
      "unrealizedPnl": "अनरियलाइज्ड P&L",
      "unrealizedGainLoss": "अनरियलाइज्ड लाभ/हानि",
      "lots": "लट",
      "change": "परिवर्तन",
      "reportId": "रिपोर्ट आईडी",
      "reportDefinitionId": "रिपोर्ट परिभाषा आईडी",
      "reportingPeriodStart": "कालावधि शुरू होने का समय",
      "reportingPeriodEnd": "कालावधि समाप्त होने का समय",
      "createdAt": "सिर्जना मिति",
      "updatedAt": "अद्यावधिक मिति",
      "currentBalance": "हालको मौज्दात",
      "sourceBatchId": "स्रोत ब्याच आईडी",
      "price": "मूल्य",
      "grossAmount": "ग्रॉस मूल्य",
      "instrument": "उपकरण",
      "actionType": "कार्य प्रकार",
      "currency": "मुद्रा",
      "clientCode": "ग्राहक कोड",
      "clientName": "ग्राहक नाम",
      "marketValueCurrency": "बजार मूल्य मुद्रा",
      "sourceState": "स्रोत स्थिति",
      "valuationFreshness": "मूल्याङ्कन ताजापन",
      "valuationSource": "मूल्याङ्कन स्रोत",
      "difference": "अन्तर",
      "displayName": "प्रदर्शन नाम",
      "errorCount": "त्रुटि संख्या",
      "exDate": "Ex-मिति",
      "exchange": "एक्सचेञ्ज",
      "generatedAt": "निर्मित तिथि",
      "instrumentSymbol": "साधन प्रतीक",
      "isSystem": "प्रणाली",
      "matchedRecords": "मेल खाएका रेकर्ड",
      "mfaEnabled": "MFA सक्षम",
      "payDate": "भुक्तानी मिति",
      "pricePerUnit": "एकाइ मूल्य",
      "recordCount": "रेकर्ड संख्या",
      "recordDate": "रेकर्ड मिति",
      "resolved": "समाधानित",
      "resolvedAt": "समाधानित तिथि",
      "resolvedBy": "समाधानित द्वारा",
      "rowNumber": "पंक्ति",
      "sourceValue": "स्रोत मूल्य",
      "targetValue": "लक्ष्य मूल्य",
      "branchId": "शाखा ID",
      "totalRecords": "कुल रेकर्ड",
      "totalAmount": "कुल रकम",
      "transactionDate": "लेखा मिति",
      "transactionType": "लेखा प्रकार",
      "unmatchedRecords": "मेल नखाएका रेकर्ड",
      "userTypeId": "प्रयोगकर्ता प्रकार आईडी",
      "validationErrors": "संसाधक त्रुटियाँ",
      "warningCount": "चेतावनी संख्या",
      "code": "कोड",
      "isDefault": "पूर्वनिर्धारित",
      "module": "मोड्युल",
      "configurationVersionId": "कन्फिगरेसन संस्करण आईडी",
      "version": "संस्करण",
      "fullName": "पूरा नाम",
      "accountType": "खाता प्रकार",
      "isActive": "सक्रिय",
      "client": "ग्राहक",
      "custodyAccount": "कस्टडी खाता",
      "accountNumber": "खाता नम्बर",
      "baseCurrency": "आधार मुद्रा स्तम्भ",
      "strategy": "रणनीति स्तम्भ",
      "ownerType": "स्वामी प्रकार",
      "ownerClientAccountId": "स्वामी ग्राहक खाता आईडी",
      "boId": "BO आईडी",
      "dpCode": "DP कोड",
      "clientType": "ग्राहक प्रकार",
      "action": "कार्य",
      "asOfDate": "मिति सम्म",
      "availableQuantity": "उपलब्ध परिमाण",
      "breachType": "उल्लंघन प्रकार",
      "breachValue": "उल्लंघन मूल्य",
      "severity": "गम्भीरता",
      "calculationVersion": "गणना संस्करण",
      "capitalGain": "पुँजी लाभ",
      "clientAccountId": "ग्राहक खाता आईडी",
      "concentrationPct": "कन्सन्ट्रेसन प्रतिशत",
      "costBasis": "लागत आधार",
      "description": "विवरण",
      "detectedAt": "पत्ता लागेको मिति",
      "endDate": "अन्तिम मिति",
      "entityId": "इकाई आईडी",
      "entityType": "इकाई प्रकार",
      "fiscalYear": "आर्थिक वर्ष",
      "fiscalYearName": "आर्थिक वर्ष नाम",
      "holdingPeriodDays": "होल्डिङ अवधि (दिन)",
      "instrumentId": "इन्स्ट्रुमेन्ट ID",
      "instrumentName": "साधन नाम",
      "instrumentType": "साधन प्रकार",
      "isLocked": "बन्द",
      "journalDate": "जर्नल मिति",
      "kind": "प्रकार",
      "lastUpdated": "अन्तिम अद्यावधिक",
      "limitValue": "सीमा मूल्य",
      "membershipStatus": "सदस्यता स्थिति",
      "periodNumber": "अवधि नम्बर",
      "portfolioAccountId": "पोर्टफोलियो खाता आईडी",
      "realizedGain": "वास्तविक लाभ",
      "reference": "सन्दर्भ",
      "riskMeasure": "जोखिम मापन",
      "ruleId": "नियम आईडी",
      "ruleVersion": "नियम संस्करण",
      "saleDate": "बिक्री मिति",
      "sector": "क्षेत्र",
      "securityName": "सुरक्षा नाम",
      "sourceAuthority": "स्रोत अधिकारी",
      "sourceBook": "स्रोत पुस्तक",
      "startDate": "सुरु मिति",
      "taxAmount": "कर रकम",
      "taxDomain": "कर क्षेत्र",
      "taxRate": "कर दर",
      "totalCost": "कुल लागत",
      "totalCredit": "कुल क्रेडिट",
      "totalDebit": "कुल डेबिट",
      "totalQuantity": "कुल परिमाण",
      "unrealizedGain": "अवास्तविक लाभ",
      "userEmail": "प्रयोगकर्ता इमेल",
      "weightedAverageCost": "भारित औसत लागत",
      "jurisdiction": "क्षेत्राधिकार",
      "assignedModules": "असाइन गरिएका मोड्युल",
      "branchCount": "शाखा संख्या",
      "parentBranchId": "मूल शाखा आईडी",
      "parentBranchName": "मूल शाखा नाम",
      "portfolioAccountNumber": "पोर्टफोलियो खाता नम्बर",
      "effectiveFrom": "प्रभावकारी मिति",
      "entryDate": "प्रविष्टि मिति",
      "entryNumber": "प्रविष्टि नम्बर",
      "expectedUpdatedAt": "अपेक्षित अद्यावधिक मिति",
      "externalReference": "बाह्य सन्दर्भ",
      "maxBranches": "अधिकतम शाखा",
      "maxUsers": "अधिकतम प्रयोगकर्ता",
      "narration": "विवरण",
      "organizationCode": "संगठन कोड",
      "organizationName": "संगठन नाम",
      "permission": "अनुमति",
      "persona": "पर्सोना",
      "resource": "स्रोत",
      "resourceScope": "स्रोत क्षेत्र",
      "roleCode": "भूमिका कोड",
      "platformModule": {
        "organization": "संगठन",
        "organizationCode": "संगठन कोड",
        "module": "मोड्युल",
        "status": "स्थिति",
        "maxBranches": "अधिकतम शाखा",
        "maxUsers": "अधिकतम प्रयोगकर्ता",
        "effectiveFrom": "प्रभावकारी मिति",
        "expectedUpdatedAt": "अपेक्षित अद्यावधिक मिति"
      },
      "platformAccess": {
        "persona": "पर्सोना",
        "roleCode": "भूमिका कोड",
        "permission": "नुमति",
        "module": "मोड्युल",
        "resource": "स्रोत",
        "action": "कार्य",
        "scope": "क्षेत्र"
      },
      "yearCode": "वर्ष कोड स्तम्भ",
      "isClosed": "वन्द स्तम्भ",
      "address": "ठेगाना स्तम्भ",
      "phone": "फोन स्तम्भ",
      "panNumber": "PAN नम्बर स्तम्भ",
      "mandateStartDate": "अधिकृत सुरु मिति स्तम्भ",
      "mandateEndDate": "अधिकृत अन्त्य मिति स्तम्भ",
      "legalName": "कानुनी नाम स्तम्भ",
      "branchName": "शाखा स्तम्भ",
      "lastLoginAt": "अन्तिम लगइन स्तम्भ",
      "commission": "कमिसन स्तम्भ",
      "sebonFee": "SEBON शुल्क स्तम्भ",
      "dpCharges": "DP शुल्क स्तम्भ",
      "declarationDate": "घोषणा मिति स्तम्भ",
      "ratioNumerator": "अनुपात अंश स्तम्भ",
      "ratioDenominator": "अनुपात हर स्तम्भ",
      "cashRate": "नगद दर स्तम्भ",
      "fiscalYearId": "आर्थिक वर्ष स्तम्भ",
      "postedAt": "पोस्ट गरिएको स्तम्भ",
      "reversalOf": "उल्टो प्रविष्टि स्तम्भ",
      "maintenanceDelegations": {
        "supportUserIdentityId": "सहयोग प्रयोगकर्ता स्तम्भ",
        "targetOrganizationId": "लक्षित संस्था स्तम्भ",
        "purpose": "उद्देश्य स्तम्भ",
        "ticketReference": "टिकट स्तम्भ",
        "status": "स्थिति स्तम्भ",
        "effectiveFrom": "लागू समय स्तम्भ",
        "expiresAt": "समाप्ति समय स्तम्भ",
        "sessionStartedAt": "सत्र सुरु स्तम्भ",
        "sessionEndedAt": "सत्र समाप्त स्तम्भ",
        "policyVersion": "नीति संस्करण स्तम्भ"
      }
    }
  },
  "nav": {
    "dashboard": "होम",
    "transactions": "कारोबारहरू",
    "holdings": "होल्डिङहरू",
    "reports": "रिपोर्टहरू",
    "reconciliation": "मेलमिलाप",
    "regulatory": "नियामक",
    "corporateActions": "कर्पोरेट कार्यहरू",
    "data": "डाटा",
    "admin": "प्रशासन",
    "settings": "सेटिङ्स"
  },
  "domain": {
    "investments": "निवेश",
    "dataOperations": "डेटा & संचालन",
    "reportsCompliance": "रिपोर्ट्स & नियमितता",
    "administration": "प्रशासन",
    "platform": "प्लेटफार्म"
  },
  "holding": {
    "list": {
      "title": "होल्डिङहरू"
    },
    "quantity": "मात्रा",
    "costBasis": "लागत आधार",
    "marketValue": "बाजार मूल्य",
    "unrealizedGain": "अनरियलाइज्ड नाफा"
  },
  "corporateActions": {
    "planned": "कर्पोरेट कार्यहरू योजनाबद्ध छन् र अहिलेसम्म उपलब्ध छैनन्।"
  },
  "reconciliation": {
    "title": "मेलमिलाप",
    "matched": "मेल खाने",
    "breaks": "टूटने",
    "adjust": "संशोधन गर्नु",
    "startRun": "पुनः संयोजन शुरू कर",
    "planned": "मेलमिलाप योजनाबद्ध छ र अहिलेसम्म उपलब्ध छैन।",
    "adjustment": {
      "title": "संशोधन बनाउनुहोस्",
      "breakId": "विच्छेदन ID: {{breakId}}",
      "adjustmentType": "संशोधन प्रकार",
      "reason": "कारण",
      "reasonPlaceholder": "क्यों यह संशोधन आवश्यक छ",
      "reasonMinLength": "विवरण कम से कम 10 चाराकहर माना जाना चाहिए",
      "adjustmentAmount": "संशोधन राशि",
      "adjustmentQuantity": "संशोधन मात्रा",
      "referenceId": "संदर्भ ID",
      "referenceIdPlaceholder": "वैकल्पिक संदर्भ (उदाहरण के लिए, टिकट संख्या)",
      "notes": "आन्तरिक टिप्पणीहरू (ग्राहकलाई देखिँदैन)",
      "notesPlaceholder": "अधिक जानकारी",
      "cancel": "बनाउनुहोस्",
      "submit": "संशोधन बनाउनुहोस्",
      "types": {
        "manualMatch": "मैनुअल मैच",
        "priceAdjustment": "कीमत संशोधन",
        "quantityAdjustment": "मात्रा संशोधन",
        "feeAdjustment": "भर्ती संशोधन",
        "writeOff": "लिखित विलंब"
      }
    }
  },
  "regulatory": {
    "sebon": {
      "title": "SEBON रिपोर्ट"
    },
    "ird": {
      "title": "IRD रिपोर्ट"
    },
    "nrb": {
      "title": "NRB रिपोर्ट"
    },
    "fiu": {
      "title": "प्रतिवेदन"
    },
    "submit": {
      "manual": "म्यानुअल पेशगरी"
    }
  },
  "import": {
    "upload": {
      "title": "आयात अपलोड गर्नुहोस्"
    },
    "preview": {
      "title": "आयात पूर्वावलोकन",
      "confirm": "आयात पुष्टि गर्नुहोस्",
      "success": "आयात पूर्वावलोकन सफल भयो"
    },
    "errors": {
      "rowErrors": "पङ्क्ति त्रुटिहरू"
    },
    "retry": "पुनः प्रयास गर्नुहोस्",
    "commit": {
      "success": "आयात सफलतापूर्वक प्रतिबद्ध भयो"
    },
    "recover": {
      "success": "आयात सफलतापूर्वक पुनःप्राप्त भयो"
    },
    "detail": {
      "title": "आयात कार्य विवरण"
    },
    "rows": {
      "title": "आयात पङ्क्तिहरू"
    }
  },
  "calendar": {
    "gregorian": "ग्रेगोरियन",
    "bikramSambat": "बिक्रम सम्बत",
    "switch": "पात्रो परिवर्तन गर्नुहोस्"
  },
  "error": {
    "auth": {
      "unauthorized": "तपाईं अधिकृत हुनुहुन्न",
      "forbidden": "पहुँच निषेधित",
      "tokenExpired": "तपाईंको सत्र समाप्त भयो",
      "mfaRequired": "बहु-चरण प्रमाणीकरण आवश्यक"
    },
    "validation": {
      "failed": "प्रमाणीकरण असफल भयो"
    },
    "notFound": "पश्चात्तगत संसाधन छैन पाया गया",
    "conflict": "एक संघर्ष हुआ",
    "rateLimit": "निर्धारित सीमा से अधिक लिमिटेड हो गया",
    "server": "अंतर्निहित सर्वर त्रुटि",
    "serviceUnavailable": "सेवा अनुपलब्ध"
  },
  "operations": {
    "search": {
      "query": {
        "label": "अधिकृत अनुभव खोज्नुहोस्",
        "description": "अधिकृत संगठन कार्यक्षेत्र भित्र नेभिगेसन, रेकर्ड र कार्यहरू खोज्नुहोस्।"
      },
      "selection": {
        "label": "खोज चयन रेकर्ड गर्नुहोस्",
        "description": "प्रासंगिक विश्लेषणको लागि सीमित खोज चयन टेलिमेट्री रेकर्ड गर्नुहोस्।"
      }
    },
    "organizationGovernance": {
      "read": {
        "label": "संस्थाको शासन हेर्नुहोस्",
        "description": "सक्रिय संस्थाका शासन अभिलेख र प्रमाण हेर्नुहोस्।"
      },
      "manage": {
        "label": "संस्थाको शासन व्यवस्थापन गर्नुहोस्",
        "description": "लेखापरीक्षण र समवर्ती नियन्त्रणसहित सक्रिय संस्थामा शासित निर्णय अभिलेख गर्नुहोस्।"
      }
    },
    "accounting": {
      "ledger": {
        "rebuildBalances": {
          "label": "लेजर बैलेंस को फिर से बनाउनुहोस्",
          "description": "वित्तीय खातों की सभी लेजर लाइनों से खाता विवरण पुनः गणना गर्नुहोस्।",
          "makerChecker": {
            "reason": "मैनुअल लेजर बैलेंस फिर से बनाने की अनुरोध गरिएको छ।"
          }
        },
        "trialBalance": {
          "label": "सञ्चालन गर्नुहोस्: Accounting Ledger",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Ledger सञ्चालन गर्नुहोस्।"
        },
        "generalLedger": {
          "label": "सञ्चालन गर्नुहोस्: Accounting Ledger",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Ledger सञ्चालन गर्नुहोस्।"
        }
      },
      "fiscalYear": {
        "get": {
          "label": "आर्थिक वर्ष हेर्नुहोस्",
          "description": "सम्बन्धित अवधिहरू सहित एकल आर्थिक वर्ष प्राप्त गर्नुहोस्।"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Accounting Fiscal Year",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Fiscal Year सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "list": {
          "label": "सूची हेर्नुहोस्: Accounting Fiscal Year",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Fiscal Year सञ्चालन गर्नुहोस्।"
        },
        "close": {
          "label": "बन्द गर्नुहोस्: Accounting Fiscal Year",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Fiscal Year सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "reopen": {
          "label": "पुनः खोल्नुहोस्: Accounting Fiscal Year",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Fiscal Year सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        }
      },
      "fiscalPeriods": {
        "generate": {
          "label": "आर्थिक अवधिहरू उत्पन्न गर्नुहोस्",
          "description": "आर्थिक वर्षका लागि 12 बिएस-पात्रो अवधिहरू स्वचालित उत्पन्न गर्नुहोस्।",
          "makerChecker": {
            "reason": "समूह अवधि उत्पादनले मेकर-चेकर अनुमोदन आवश्यक छ।"
          }
        }
      },
      "management-fee": {
        "list": {
          "label": "व्यवस्थापन शुल्कहरू सूचीबद्ध गर्नुहोस्",
          "description": "अधिकृत दायराका व्यवस्थापन-शुल्क सञ्चय र जीवनचक्र अभिलेखहरू सूचीबद्ध गर्नुहोस्।"
        },
        "get": {
          "label": "व्यवस्थापन शुल्क हेर्नुहोस्",
          "description": "एउटा व्यवस्थापन-शुल्क सञ्चय वा जीवनचक्र अभिलेख हेर्नुहोस्।"
        },
        "calculate": {
          "label": "व्यवस्थापन शुल्क गणना गर्नुहोस्",
          "description": "छानिएको अधिकृत दायरा र अवधिका लागि व्यवस्थापन शुल्क गणना गर्नुहोस्।"
        },
        "approve": {
          "label": "व्यवस्थापन शुल्क स्वीकृत गर्नुहोस्",
          "description": "पछिल्लो लेखांकन प्रक्रियाका लागि गणना गरिएको व्यवस्थापन शुल्क स्वीकृत गर्नुहोस्।"
        },
        "waive": {
          "label": "व्यवस्थापन शुल्क माफ गर्नुहोस्",
          "description": "अडिट योग्य कारणसहित योग्य व्यवस्थापन शुल्क माफ गर्नुहोस्।"
        },
        "invoice": {
          "label": "व्यवस्थापन शुल्कको बिजक बनाउनुहोस्",
          "description": "स्वीकृत व्यवस्थापन शुल्कका लागि बिजक सिर्जना गर्नुहोस्।"
        },
        "pay": {
          "label": "व्यवस्थापन शुल्क भुक्तानी अभिलेख गर्नुहोस्",
          "description": "बिजक गरिएको व्यवस्थापन शुल्कविरुद्ध भुक्तानी अभिलेख गर्नुहोस्।"
        },
        "credit": {
          "label": "व्यवस्थापन शुल्क क्रेडिट गर्नुहोस्",
          "description": "योग्य व्यवस्थापन शुल्कका लागि क्रेडिट समायोजन सिर्जना गर्नुहोस्।"
        },
        "reverse": {
          "label": "व्यवस्थापन शुल्क उल्टाउनुहोस्",
          "description": "अडिट प्रमाणसहित योग्य व्यवस्थापन-शुल्क जीवनचक्र प्रविष्टि उल्टाउनुहोस्।"
        }
      },
      "performance-fee": {
        "list": {
          "label": "कार्यसम्पादन शुल्कहरू सूचीबद्ध गर्नुहोस्",
          "description": "अधिकृत दायराका कार्यसम्पादन-शुल्क गणना र जीवनचक्र अभिलेखहरू सूचीबद्ध गर्नुहोस्।"
        },
        "calculate": {
          "label": "कार्यसम्पादन शुल्क गणना गर्नुहोस्",
          "description": "छानिएको अधिकृत दायरा र कार्यसम्पादन अवधिका लागि शुल्क गणना गर्नुहोस्।"
        },
        "approve": {
          "label": "कार्यसम्पादन शुल्क स्वीकृत गर्नुहोस्",
          "description": "पछिल्लो लेखांकन प्रक्रियाका लागि गणना गरिएको कार्यसम्पादन शुल्क स्वीकृत गर्नुहोस्।"
        },
        "crystallize": {
          "label": "कार्यसम्पादन शुल्क निश्चित गर्नुहोस्",
          "description": "लागू जीवनचक्र बिन्दुमा स्वीकृत कार्यसम्पादन शुल्क निश्चित गर्नुहोस्।"
        },
        "invoice": {
          "label": "कार्यसम्पादन शुल्कको बिजक बनाउनुहोस्",
          "description": "निश्चित गरिएको कार्यसम्पादन शुल्कका लागि बिजक सिर्जना गर्नुहोस्।"
        },
        "invoice-post": {
          "label": "कार्यसम्पादन शुल्क बिजक पोस्ट गर्नुहोस्",
          "description": "कार्यसम्पादन-शुल्क बिजक लेखांकन लेजरमा पोस्ट गर्नुहोस्।"
        },
        "pay": {
          "label": "कार्यसम्पादन शुल्क भुक्तानी अभिलेख गर्नुहोस्",
          "description": "बिजक गरिएको कार्यसम्पादन शुल्कविरुद्ध भुक्तानी अभिलेख गर्नुहोस्।"
        },
        "payment-post": {
          "label": "कार्यसम्पादन शुल्क भुक्तानी पोस्ट गर्नुहोस्",
          "description": "कार्यसम्पादन-शुल्क भुक्तानी लेखांकन लेजरमा पोस्ट गर्नुहोस्।"
        },
        "restate": {
          "label": "कार्यसम्पादन शुल्क पुनःनिर्धारण गर्नुहोस्",
          "description": "आधिकारिक डाटा सेट प्रयोग गरी योग्य कार्यसम्पादन-शुल्क गणना पुनःनिर्धारण गर्नुहोस्।"
        },
        "restatement-reversal-post": {
          "label": "कार्यसम्पादन शुल्क पुनःनिर्धारण उल्टो प्रविष्टि पोस्ट गर्नुहोस्",
          "description": "कार्यसम्पादन-शुल्क पुनःनिर्धारणबाट बनेको लेखांकन उल्टो प्रविष्टि पोस्ट गर्नुहोस्।"
        }
      },
      "reconciliation": {
        "list": {
          "label": "सूची हेर्नुहोस्: Accounting Reconciliation",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Reconciliation सञ्चालन गर्नुहोस्।"
        },
        "get": {
          "label": "हेर्नुहोस्: Accounting Reconciliation",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Reconciliation सञ्चालन गर्नुहोस्।"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Accounting Reconciliation",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Reconciliation सञ्चालन गर्नुहोस्।"
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Accounting Reconciliation",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Reconciliation सञ्चालन गर्नुहोस्।"
        }
      },
      "journal": {
        "list": {
          "label": "सूची हेर्नुहोस्: Accounting Journal",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Journal सञ्चालन गर्नुहोस्।"
        },
        "create": {
          "label": "सञ्चालन गर्नुहोस्: Accounting Opening Cutover",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Opening Cutover सञ्चालन गर्नुहोस्।"
        },
        "post": {
          "label": "पोस्ट गर्नुहोस्: Accounting Journal",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Journal सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "get": {
          "label": "हेर्नुहोस्: Accounting Journal",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Journal सञ्चालन गर्नुहोस्।"
        },
        "reverse": {
          "label": "उल्ट्याउनुहोस्: Accounting Journal",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Journal सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        }
      },
      "coa": {
        "createGroup": {
          "label": "सञ्चालन गर्नुहोस्: Accounting Coa",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Coa सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "getGroups": {
          "label": "सञ्चालन गर्नुहोस्: Accounting Coa",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Coa सञ्चालन गर्नुहोस्।"
        },
        "createAccount": {
          "label": "सञ्चालन गर्नुहोस्: Accounting Coa",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Coa सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "getAccounts": {
          "label": "सञ्चालन गर्नुहोस्: Accounting Coa",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Coa सञ्चालन गर्नुहोस्।"
        },
        "getAccount": {
          "label": "सञ्चालन गर्नुहोस्: Accounting Coa",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Coa सञ्चालन गर्नुहोस्।"
        },
        "updateAccount": {
          "label": "सञ्चालन गर्नुहोस्: Accounting Coa",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Coa सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "getAccountBalance": {
          "label": "सञ्चालन गर्नुहोस्: Accounting Coa",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Coa सञ्चालन गर्नुहोस्।"
        }
      },
      "fiscalPeriod": {
        "create": {
          "label": "सिर्जना गर्नुहोस्: Accounting Fiscal Period",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Fiscal Period सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "list": {
          "label": "सूची हेर्नुहोस्: Accounting Fiscal Period",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Fiscal Period सञ्चालन गर्नुहोस्।"
        },
        "lock": {
          "label": "लक गर्नुहोस्: Accounting Fiscal Period",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Fiscal Period सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "unlock": {
          "label": "लक खोल्नुहोस्: Accounting Fiscal Period",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Fiscal Period सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        }
      },
      "postingRule": {
        "create": {
          "label": "सिर्जना गर्नुहोस्: Accounting Posting Rule",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Posting Rule सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "list": {
          "label": "सूची हेर्नुहोस्: Accounting Posting Rule",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Posting Rule सञ्चालन गर्नुहोस्।"
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Accounting Posting Rule",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Posting Rule सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "test": {
          "label": "परीक्षण गर्नुहोस्: Accounting Posting Rule",
          "description": "तपाईंको अनुमत दायराभित्र Accounting Posting Rule सञ्चालन गर्नुहोस्।"
        }
      },
      "autoPost": {
        "label": "सञ्चालन गर्नुहोस्: Accounting",
        "description": "तपाईंको अनुमत दायराभित्र Accounting सञ्चालन गर्नुहोस्।",
        "makerChecker": {
          "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
        }
      }
    },
    "reporting": {
      "export": {
        "label": "रिपोर्ट निर्यात गर्नुहोस्",
        "description": "फर्मुला-इन्जेक्शन सुरक्षा र अडिट ट्रेल सहित शासित रिपोर्ट CSV को रूपमा निर्यात गर्नुहोस्।"
      }
    },
    "marketData": {
      "correct": {
        "label": "बजार डाटा अवलोकन सच्याउनुहोस्",
        "description": "अडिट प्रमाण र पुनर्विवरण भर्सनिङ सहित बजार डाटा अवलोकन सच्याउनुहोस्।"
      },
      "history": {
        "label": "बजार डाटा सच्याइ इतिहास पढ्नुहोस्",
        "description": "बजार डाटा अवलोकनको सच्याइ इतिहास र अडिट संशोधनहरू हेर्नुहोस्।"
      },
      "prices": {
        "list": {
          "label": "बजार मूल्य र मूल्याङ्कन डाटा हेर्नुहोस्",
          "description": "अधिकृत दैनिक OHLCV बजार अवलोकन, मूल्याङ्कन मूल्य र स्रोत प्रमाण हेर्नुहोस्।"
        },
        "get": {
          "label": "बजार डाटा विवरण हेर्नुहोस्",
          "description": "दैनिक स्न्यापसट सन्दर्भ र लाइनएजसहित एउटा आधिकारिक बजार वा मूल्याङ्कन अवलोकन हेर्नुहोस्।"
        }
      }
    },
    "investment": {
      "compliance": {
        "breaches": {
          "get": {
            "label": "अनुपालन उल्लङ्घन हेर्नुहोस्",
            "description": "स्कोप गरिएको अनुपालन उल्लङ्घन र यसको सुधार प्रमाण हेर्नुहोस्।"
          },
          "list": {
            "label": "सूची हेर्नुहोस्: Compliance Breaches",
            "description": "तपाईंको अनुमत दायराभित्र Compliance Breaches सञ्चालन गर्नुहोस्।"
          }
        }
      },
      "risk": {
        "exposures": {
          "list": {
            "label": "जोखिम एक्सपोजरहरू सूचीबद्ध गर्नुहोस्",
            "description": "सक्रिय संस्थाका जोखिम एक्सपोजर र एकाग्रता मेट्रिकहरू सूचीबद्ध गर्नुहोस्।"
          }
        }
      },
      "corporateAction": {
        "list": {
          "label": "सूची हेर्नुहोस्: Investment Corporate Action",
          "description": "तपाईंको अनुमत दायराभित्र Investment Corporate Action सञ्चालन गर्नुहोस्।"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Investment Corporate Action",
          "description": "तपाईंको अनुमत दायराभित्र Investment Corporate Action सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Investment Corporate Action",
          "description": "तपाईंको अनुमत दायराभित्र Investment Corporate Action सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "get": {
          "label": "हेर्नुहोस्: Investment Corporate Action",
          "description": "तपाईंको अनुमत दायराभित्र Investment Corporate Action सञ्चालन गर्नुहोस्।"
        },
        "process": {
          "label": "प्रक्रिया गर्नुहोस्: Investment Corporate Action",
          "description": "तपाईंको अनुमत दायराभित्र Investment Corporate Action सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "entitlements": {
          "list": {
            "label": "सूची हेर्नुहोस्: Investment Corporate Action Entitlements",
            "description": "तपाईंको अनुमत दायराभित्र Investment Corporate Action Entitlements सञ्चालन गर्नुहोस्।"
          }
        },
        "elect": {
          "label": "छनोट गर्नुहोस्: Investment Corporate Action",
          "description": "तपाईंको अनुमत दायराभित्र Investment Corporate Action सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "allocate": {
          "label": "विनियोजन गर्नुहोस्: Investment Corporate Action",
          "description": "तपाईंको अनुमत दायराभित्र Investment Corporate Action सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "exDate": {
          "classify": {
            "label": "वर्गीकरण गर्नुहोस्: Investment Corporate Action Ex Date",
            "description": "तपाईंको अनुमत दायराभित्र Investment Corporate Action Ex Date सञ्चालन गर्नुहोस्।"
          },
          "verify": {
            "label": "प्रमाणित गर्नुहोस्: Investment Corporate Action Ex Date",
            "description": "तपाईंको अनुमत दायराभित्र Investment Corporate Action Ex Date सञ्चालन गर्नुहोस्।"
          }
        }
      },
      "fact": {
        "list": {
          "label": "सूची हेर्नुहोस्: Investment Fact",
          "description": "तपाईंको अनुमत दायराभित्र Investment Fact सञ्चालन गर्नुहोस्।"
        },
        "get": {
          "label": "हेर्नुहोस्: Investment Fact",
          "description": "तपाईंको अनुमत दायराभित्र Investment Fact सञ्चालन गर्नुहोस्।"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Investment Fact",
          "description": "तपाईंको अनुमत दायराभित्र Investment Fact सञ्चालन गर्नुहोस्।"
        },
        "position": {
          "label": "सञ्चालन गर्नुहोस्: Investment Fact",
          "description": "तपाईंको अनुमत दायराभित्र Investment Fact सञ्चालन गर्नुहोस्।"
        },
        "valuation": {
          "label": "सञ्चालन गर्नुहोस्: Investment Fact",
          "description": "तपाईंको अनुमत दायराभित्र Investment Fact सञ्चालन गर्नुहोस्।"
        },
        "movement": {
          "label": "सञ्चालन गर्नुहोस्: Investment Fact",
          "description": "तपाईंको अनुमत दायराभित्र Investment Fact सञ्चालन गर्नुहोस्।"
        },
        "realized": {
          "label": "सञ्चालन गर्नुहोस्: Investment Fact",
          "description": "तपाईंको अनुमत दायराभित्र Investment Fact सञ्चालन गर्नुहोस्।"
        },
        "cgt": {
          "label": "सञ्चालन गर्नुहोस्: Investment Fact",
          "description": "तपाईंको अनुमत दायराभित्र Investment Fact सञ्चालन गर्नुहोस्।"
        },
        "nfrs": {
          "label": "सञ्चालन गर्नुहोस्: Investment Fact",
          "description": "तपाईंको अनुमत दायराभित्र Investment Fact सञ्चालन गर्नुहोस्।"
        },
        "batches": {
          "list": {
            "label": "सूची हेर्नुहोस्: Investment Fact Batches",
            "description": "तपाईंको अनुमत दायराभित्र Investment Fact Batches सञ्चालन गर्नुहोस्।"
          }
        },
        "batch": {
          "get": {
            "label": "हेर्नुहोस्: Investment Fact Batch",
            "description": "तपाईंको अनुमत दायराभित्र Investment Fact Batch सञ्चालन गर्नुहोस्।"
          },
          "lineage": {
            "label": "सञ्चालन गर्नुहोस्: Investment Fact Batch",
            "description": "तपाईंको अनुमत दायराभित्र Investment Fact Batch सञ्चालन गर्नुहोस्।"
          }
        }
      },
      "transaction": {
        "create": {
          "label": "सिर्जना गर्नुहोस्: Investment Transaction",
          "description": "तपाईंको अनुमत दायराभित्र Investment Transaction सञ्चालन गर्नुहोस्।"
        },
        "list": {
          "label": "सूची हेर्नुहोस्: Investment Transaction",
          "description": "तपाईंको अनुमत दायराभित्र Investment Transaction सञ्चालन गर्नुहोस्।"
        },
        "export": {
          "label": "निर्यात गर्नुहोस्: Investment Transaction",
          "description": "तपाईंको अनुमत दायराभित्र Investment Transaction सञ्चालन गर्नुहोस्।"
        },
        "get": {
          "label": "हेर्नुहोस्: Investment Transaction",
          "description": "तपाईंको अनुमत दायराभित्र Investment Transaction सञ्चालन गर्नुहोस्।"
        },
        "submit": {
          "label": "पेश गर्नुहोस्: Investment Transaction",
          "description": "तपाईंको अनुमत दायराभित्र Investment Transaction सञ्चालन गर्नुहोस्।"
        },
        "approve": {
          "label": "स्वीकृत गर्नुहोस्: Investment Transaction",
          "description": "तपाईंको अनुमत दायराभित्र Investment Transaction सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "reject": {
          "label": "अस्वीकृत गर्नुहोस्: Investment Transaction",
          "description": "तपाईंको अनुमत दायराभित्र Investment Transaction सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "withdraw": {
          "label": "फिर्ता लिनुहोस्: Investment Transaction",
          "description": "तपाईंको अनुमत दायराभित्र Investment Transaction सञ्चालन गर्नुहोस्।"
        },
        "post": {
          "label": "पोस्ट गर्नुहोस्: Investment Transaction",
          "description": "तपाईंको अनुमत दायराभित्र Investment Transaction सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "repair": {
          "label": "सुधार गर्नुहोस्: Investment Transaction",
          "description": "तपाईंको अनुमत दायराभित्र Investment Transaction सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "repost": {
          "label": "पुनः पोस्ट गर्नुहोस्: Investment Transaction",
          "description": "तपाईंको अनुमत दायराभित्र Investment Transaction सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "reverse": {
          "label": "उल्ट्याउनुहोस्: Investment Transaction",
          "description": "तपाईंको अनुमत दायराभित्र Investment Transaction सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "lots": {
          "label": "सञ्चालन गर्नुहोस्: Investment Transaction",
          "description": "तपाईंको अनुमत दायराभित्र Investment Transaction सञ्चालन गर्नुहोस्।"
        },
        "disposals": {
          "label": "सञ्चालन गर्नुहोस्: Investment Transaction",
          "description": "तपाईंको अनुमत दायराभित्र Investment Transaction सञ्चालन गर्नुहोस्।"
        },
        "facts": {
          "label": "सञ्चालन गर्नुहोस्: Investment Transaction",
          "description": "तपाईंको अनुमत दायराभित्र Investment Transaction सञ्चालन गर्नुहोस्।"
        }
      },
      "instrument": {
        "list": {
          "label": "सूची हेर्नुहोस्: Investment Instrument",
          "description": "तपाईंको अनुमत दायराभित्र Investment Instrument सञ्चालन गर्नुहोस्।"
        },
        "get": {
          "label": "हेर्नुहोस्: Investment Instrument",
          "description": "तपाईंको अनुमत दायराभित्र Investment Instrument सञ्चालन गर्नुहोस्।"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Investment Instrument",
          "description": "तपाईंको अनुमत दायराभित्र Investment Instrument सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Investment Instrument",
          "description": "तपाईंको अनुमत दायराभित्र Investment Instrument सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "override": {
          "create": {
            "label": "सिर्जना गर्नुहोस्: Investment Instrument Override",
            "description": "तपाईंको अनुमत दायराभित्र Investment Instrument Override सञ्चालन गर्नुहोस्।",
            "makerChecker": {
              "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
            }
          },
          "list": {
            "label": "सूची हेर्नुहोस्: Investment Instrument Override",
            "description": "तपाईंको अनुमत दायराभित्र Investment Instrument Override सञ्चालन गर्नुहोस्।"
          },
          "update": {
            "label": "अद्यावधिक गर्नुहोस्: Investment Instrument Override",
            "description": "तपाईंको अनुमत दायराभित्र Investment Instrument Override सञ्चालन गर्नुहोस्।",
            "makerChecker": {
              "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
            }
          },
          "delete": {
            "label": "मेटाउनुहोस्: Investment Instrument Override",
            "description": "तपाईंको अनुमत दायराभित्र Investment Instrument Override सञ्चालन गर्नुहोस्।",
            "makerChecker": {
              "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
            }
          }
        },
        "delete": {
          "label": "मेटाउनुहोस्: Investment Instrument",
          "description": "तपाईंको अनुमत दायराभित्र Investment Instrument सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "bulkUpsert": {
          "label": "सञ्चालन गर्नुहोस्: Investment Instrument",
          "description": "तपाईंको अनुमत दायराभित्र Investment Instrument सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        }
      },
      "marketData": {
        "create": {
          "label": "सिर्जना गर्नुहोस्: Investment Market Data",
          "description": "तपाईंको अनुमत दायराभित्र Investment Market Data सञ्चालन गर्नुहोस्।"
        },
        "list": {
          "label": "सूची हेर्नुहोस्: Investment Market Data",
          "description": "तपाईंको अनुमत दायराभित्र Investment Market Data सञ्चालन गर्नुहोस्।"
        },
        "get": {
          "label": "हेर्नुहोस्: Investment Market Data",
          "description": "तपाईंको अनुमत दायराभित्र Investment Market Data सञ्चालन गर्नुहोस्।"
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Investment Market Data",
          "description": "तपाईंको अनुमत दायराभित्र Investment Market Data सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "delete": {
          "label": "मेटाउनुहोस्: Investment Market Data",
          "description": "तपाईंको अनुमत दायराभित्र Investment Market Data सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "bulkUpsert": {
          "label": "सञ्चालन गर्नुहोस्: Investment Market Data",
          "description": "तपाईंको अनुमत दायराभित्र Investment Market Data सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        }
      },
      "portfolioAccount": {
        "list": {
          "label": "सूची हेर्नुहोस्: Investment Portfolio Account",
          "description": "तपाईंको अनुमत दायराभित्र Investment Portfolio Account सञ्चालन गर्नुहोस्।"
        },
        "get": {
          "label": "हेर्नुहोस्: Investment Portfolio Account",
          "description": "तपाईंको अनुमत दायराभित्र Investment Portfolio Account सञ्चालन गर्नुहोस्।"
        },
        "getBalance": {
          "label": "सञ्चालन गर्नुहोस्: Investment Portfolio Account",
          "description": "तपाईंको अनुमत दायराभित्र Investment Portfolio Account सञ्चालन गर्नुहोस्।"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Investment Portfolio Account",
          "description": "तपाईंको अनुमत दायराभित्र Investment Portfolio Account सञ्चालन गर्नुहोस्।"
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Investment Portfolio Account",
          "description": "तपाईंको अनुमत दायराभित्र Investment Portfolio Account सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "signatories": {
          "list": {
            "label": "सूची हेर्नुहोस्: Investment Portfolio Account Signatories",
            "description": "तपाईंको अनुमत दायराभित्र Investment Portfolio Account Signatories सञ्चालन गर्नुहोस्।"
          }
        },
        "signatory": {
          "create": {
            "label": "सिर्जना गर्नुहोस्: Investment Portfolio Account Signatory",
            "description": "तपाईंको अनुमत दायराभित्र Investment Portfolio Account Signatory सञ्चालन गर्नुहोस्।",
            "makerChecker": {
              "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
            }
          },
          "delete": {
            "label": "मेटाउनुहोस्: Investment Portfolio Account Signatory",
            "description": "तपाईंको अनुमत दायराभित्र Investment Portfolio Account Signatory सञ्चालन गर्नुहोस्।",
            "makerChecker": {
              "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
            }
          }
        }
      },
      "position-transfer": {
        "list": {
          "label": "पोजिसन स्थानान्तरणहरू सूचीबद्ध गर्नुहोस्",
          "description": "अधिकृत संगठन दायरामा देखिने पोजिसन-स्थानान्तरण अनुरोधहरू सूचीबद्ध गर्नुहोस्।"
        },
        "get": {
          "label": "पोजिसन स्थानान्तरण हेर्नुहोस्",
          "description": "एउटा अधिकृत पोजिसन-स्थानान्तरण अनुरोध र यसको बाँडफाँट हेर्नुहोस्।"
        },
        "eligibility": {
          "label": "पोजिसन स्थानान्तरण योग्यता जाँच गर्नुहोस्",
          "description": "पोजिसन स्थानान्तरणका लागि उपलब्ध हालका जीवनचक्र कार्यहरू मूल्याङ्कन गर्नुहोस्।"
        },
        "request-eligibility": {
          "label": "स्थानान्तरण अनुरोध योग्यता जाँच गर्नुहोस्",
          "description": "पोजिसन स्थानान्तरण अनुरोध गर्नुअघि योग्य गन्तव्य र स्रोत लटहरू मूल्याङ्कन गर्नुहोस्।"
        },
        "request": {
          "label": "पोजिसन स्थानान्तरण अनुरोध गर्नुहोस्",
          "description": "अधिकृत स्रोत लटहरूबाट मेकर-चेकर पोजिसन-स्थानान्तरण अनुरोध सिर्जना गर्नुहोस्।"
        },
        "approve": {
          "label": "पोजिसन स्थानान्तरण स्वीकृत गर्नुहोस्",
          "description": "मेकर-चेकर नियन्त्रणअन्तर्गत योग्य पोजिसन-स्थानान्तरण अनुरोध स्वीकृत गर्नुहोस्।"
        },
        "execute": {
          "label": "पोजिसन स्थानान्तरण कार्यान्वयन गर्नुहोस्",
          "description": "स्वीकृत पोजिसन स्थानान्तरण कार्यान्वयन गरी आधिकारिक लट वंशावली सुरक्षित राख्नुहोस्।"
        },
        "cancel": {
          "label": "पोजिसन स्थानान्तरण रद्द गर्नुहोस्",
          "description": "कार्यान्वयनअघि योग्य पोजिसन-स्थानान्तरण अनुरोध रद्द गर्नुहोस्।"
        },
        "reverse": {
          "label": "पोजिसन स्थानान्तरण उल्टाउनुहोस्",
          "description": "अडिट योग्य वंशावलीसहित योग्य कार्यान्वित पोजिसन स्थानान्तरण उल्टाउनुहोस्।"
        }
      }
    },
    "navigation": {
      "read": {
        "label": "पाठन नेविगेशन",
        "description": "वर्तमान प्रयोगकर्ता संदर्भ मा नेविगेशन तत्वों को प्राप्त गर्नुहोस्।"
      },
      "hub": {
        "label": "सञ्चालन गर्नुहोस्: Navigation",
        "description": "तपाईंको अनुमत दायराभित्र Navigation सञ्चालन गर्नुहोस्।",
        "read": {
          "label": "हेर्नुहोस्: Navigation Hub",
          "description": "तपाईंको अनुमत दायराभित्र Navigation Hub सञ्चालन गर्नुहोस्।"
        }
      },
      "shell": {
        "read": {
          "label": "हेर्नुहोस्: Navigation Shell",
          "description": "तपाईंको अनुमत दायराभित्र Navigation Shell सञ्चालन गर्नुहोस्।"
        }
      },
      "routes": {
        "read": {
          "label": "हेर्नुहोस्: Navigation Routes",
          "description": "तपाईंको अनुमत दायराभित्र Navigation Routes सञ्चालन गर्नुहोस्।"
        }
      },
      "route": {
        "read": {
          "label": "हेर्नुहोस्: Navigation Route",
          "description": "तपाईंको अनुमत दायराभित्र Navigation Route सञ्चालन गर्नुहोस्।"
        }
      }
    },
    "auth": {
      "delegation": {
        "enter": {
          "label": "समर्थन प्रतिनिधित्वमा प्रवेश गर्नुहोस्",
          "description": "स्वीकृत पढ्न-मात्र समर्थन प्रतिनिधित्वमा प्रवेश गर्नुहोस्।"
        },
        "exit": {
          "label": "सञ्चालन गर्नुहोस्: Auth Delegation",
          "description": "तपाईंको अनुमत दायराभित्र Auth Delegation सञ्चालन गर्नुहोस्।"
        }
      },
      "exit": {
        "label": "सपोर्ट डेलिगेसनबाट बाहिरिने",
        "description": "डेलिगेट गरिएको सपोर्ट पहुँच अन्त्य गरी आफ्नो प्लेटफर्म सत्रमा फर्कनुहोस्।"
      },
      "switchContext": {
        "label": "सक्रिय संदर्भ परिवर्तन गर्नुहोस्",
        "description": "एक अन्य संगठन या शाखा संदर्भ मा जाने के लिए सक्रिय संदर्भ को परिवर्तन गर्नुहोस्।"
      },
      "password": {
        "change": {
          "label": "पासवर्ड परिवर्तन गर्नुहोस्",
          "description": "हालको प्रयोगकर्ताको पासवर्ड परिवर्तन गर्नुहोस्।"
        },
        "forgot": {
          "label": "सञ्चालन गर्नुहोस्: Auth Password",
          "description": "तपाईंको अनुमत दायराभित्र Auth Password सञ्चालन गर्नुहोस्।"
        },
        "reset": {
          "label": "सञ्चालन गर्नुहोस्: Auth Password",
          "description": "तपाईंको अनुमत दायराभित्र Auth Password सञ्चालन गर्नुहोस्।"
        }
      },
      "sessions": {
        "manage": {
          "label": "सत्रहरू व्यवस्थापन गर्नुहोस्",
          "description": "प्रयोगकर्ता"
        },
        "revoke": {
          "label": "सत्र खारेज गर्नुहोस्",
          "description": "प्रयोगकर्ता"
        }
      },
      "login": {
        "label": "सञ्चालन गर्नुहोस्: Auth",
        "description": "तपाईंको अनुमत दायराभित्र Auth सञ्चालन गर्नुहोस्।"
      },
      "logout": {
        "label": "सञ्चालन गर्नुहोस्: Auth",
        "description": "तपाईंको अनुमत दायराभित्र Auth सञ्चालन गर्नुहोस्।"
      },
      "refresh": {
        "label": "सञ्चालन गर्नुहोस्: Auth",
        "description": "तपाईंको अनुमत दायराभित्र Auth सञ्चालन गर्नुहोस्।"
      },
      "challenge": {
        "totp": {
          "label": "सञ्चालन गर्नुहोस्: Auth Challenge",
          "description": "तपाईंको अनुमत दायराभित्र Auth Challenge सञ्चालन गर्नुहोस्।"
        },
        "recovery": {
          "label": "सञ्चालन गर्नुहोस्: Auth Challenge",
          "description": "तपाईंको अनुमत दायराभित्र Auth Challenge सञ्चालन गर्नुहोस्।"
        }
      },
      "selectContext": {
        "label": "सञ्चालन गर्नुहोस्: Auth Select",
        "description": "तपाईंको अनुमत दायराभित्र Auth Select सञ्चालन गर्नुहोस्।"
      },
      "invitation": {
        "accept": {
          "label": "सञ्चालन गर्नुहोस्: Auth Invitation",
          "description": "तपाईंको अनुमत दायराभित्र Auth Invitation सञ्चालन गर्नुहोस्।"
        }
      },
      "mfa": {
        "enroll": {
          "label": "सञ्चालन गर्नुहोस्: Auth Mfa",
          "description": "तपाईंको अनुमत दायराभित्र Auth Mfa सञ्चालन गर्नुहोस्।"
        },
        "verify": {
          "label": "प्रमाणित गर्नुहोस्: Auth Mfa",
          "description": "तपाईंको अनुमत दायराभित्र Auth Mfa सञ्चालन गर्नुहोस्।"
        },
        "disable": {
          "label": "निष्क्रिय गर्नुहोस्: Auth Mfa",
          "description": "तपाईंको अनुमत दायराभित्र Auth Mfa सञ्चालन गर्नुहोस्।"
        },
        "backupCodes": {
          "regenerate": {
            "label": "सञ्चालन गर्नुहोस्: Auth Mfa Backup Codes",
            "description": "तपाईंको अनुमत दायराभित्र Auth Mfa Backup Codes सञ्चालन गर्नुहोस्।"
          }
        }
      },
      "readProfile": {
        "label": "सञ्चालन गर्नुहोस्: Auth",
        "description": "तपाईंको अनुमत दायराभित्र Auth सञ्चालन गर्नुहोस्।"
      }
    },
    "regulatory": {
      "reportRun": {
        "export": {
          "label": "प्रतिवेदन रन निर्यात गर्नुहोस्",
          "description": "अधिकृत पूरा भएको प्रतिवेदन रन निर्यात गर्नुहोस्।"
        },
        "generate": {
          "label": "तयार गर्नुहोस्: Regulatory Report Run",
          "description": "तपाईंको अनुमत दायराभित्र Regulatory Report Run सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "list": {
          "label": "सूची हेर्नुहोस्: Regulatory Report Run",
          "description": "तपाईंको अनुमत दायराभित्र Regulatory Report Run सञ्चालन गर्नुहोस्।"
        },
        "get": {
          "label": "हेर्नुहोस्: Regulatory Report Run",
          "description": "तपाईंको अनुमत दायराभित्र Regulatory Report Run सञ्चालन गर्नुहोस्।"
        },
        "artifact": {
          "get": {
            "label": "हेर्नुहोस्: Regulatory Report Run Artifact",
            "description": "तपाईंको अनुमत दायराभित्र Regulatory Report Run Artifact सञ्चालन गर्नुहोस्।"
          }
        },
        "cancel": {
          "label": "रद्द गर्नुहोस्: Regulatory Report Run",
          "description": "तपाईंको अनुमत दायराभित्र Regulatory Report Run सञ्चालन गर्नुहोस्।"
        },
        "retry": {
          "label": "पुनः प्रयास गर्नुहोस्: Regulatory Report Run",
          "description": "तपाईंको अनुमत दायराभित्र Regulatory Report Run सञ्चालन गर्नुहोस्।"
        },
        "validate": {
          "label": "प्रमाणित गर्नुहोस्: Regulatory Report Run",
          "description": "तपाईंको अनुमत दायराभित्र Regulatory Report Run सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "submit": {
          "label": "पेश गर्नुहोस्: Regulatory Report Run",
          "description": "तपाईंको अनुमत दायराभित्र Regulatory Report Run सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        }
      },
      "taxRemittance": {
        "list": {
          "label": "कर रेमिटेन्सहरू सूचीबद्ध गर्नुहोस्",
          "description": "सक्रिय संगठनका शासित कर रेमिटेन्स रेकर्डहरू सूचीबद्ध गर्नुहोस्।"
        },
        "record": {
          "label": "कर रेमिटेन्स रेकर्ड गर्नुहोस्",
          "description": "स्वीकृत कर फाइलिङ विरुद्ध भुक्तानी वा समायोजन रेकर्ड गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "makerChecker": {
          "reason": "कर रेमिटेन्स रेकर्डिङका लागि स्वतन्त्र स्वीकृति आवश्यक हुन्छ।"
        }
      },
      "reportDefinition": {
        "list": {
          "label": "सूची हेर्नुहोस्: Regulatory Report Definition",
          "description": "तपाईंको अनुमत दायराभित्र Regulatory Report Definition सञ्चालन गर्नुहोस्।"
        },
        "get": {
          "label": "हेर्नुहोस्: Regulatory Report Definition",
          "description": "तपाईंको अनुमत दायराभित्र Regulatory Report Definition सञ्चालन गर्नुहोस्।"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Regulatory Report Definition",
          "description": "तपाईंको अनुमत दायराभित्र Regulatory Report Definition सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Regulatory Report Definition",
          "description": "तपाईंको अनुमत दायराभित्र Regulatory Report Definition सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "disable": {
          "label": "निष्क्रिय गर्नुहोस्: Regulatory Report Definition",
          "description": "तपाईंको अनुमत दायराभित्र Regulatory Report Definition सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        }
      },
      "submission": {
        "list": {
          "label": "सूची हेर्नुहोस्: Regulatory Submission",
          "description": "तपाईंको अनुमत दायराभित्र Regulatory Submission सञ्चालन गर्नुहोस्।"
        },
        "acknowledge": {
          "label": "स्वीकार गर्नुहोस्: Regulatory Submission",
          "description": "तपाईंको अनुमत दायराभित्र Regulatory Submission सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        }
      }
    },
    "platform": {
      "organizations": {
        "offboardingExport": {
          "label": "संगठन अफबोर्डिङ बन्डल निर्यात गर्नुहोस्",
          "description": "संगठन अफबोर्डिङका लागि इन्क्रिप्ट गरिएको र अभिरक्षा-अडिट गरिएको निर्यात सिर्जना गर्नुहोस्।"
        },
        "list": {
          "label": "सूची हेर्नुहोस्: Platform Organizations"
        },
        "read": {
          "label": "हेर्नुहोस्: Platform Organizations"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Platform Organizations"
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Platform Organizations"
        },
        "disable": {
          "label": "निष्क्रिय गर्नुहोस्: Platform Organizations"
        },
        "onboardingReadiness": {
          "label": "हेर्नुहोस्: Platform Organizations Onboarding Readiness"
        },
        "supportCommand": {
          "issue": {
            "label": "जारी गर्नुहोस्: Platform Organizations Support Command"
          }
        }
      },
      "integration": {
        "entitlements": {
          "issue": {
            "label": "अधिकार दाबी जारी गर्नुहोस्",
            "description": "संगठन रनटाइमले प्रयोग गर्ने हस्ताक्षरित संगठन अधिकार दाबी जारी गर्नुहोस्।"
          }
        },
        "reference-data": {
          "issue": {
            "label": "सन्दर्भ डाटा दाबी जारी गर्नुहोस्",
            "description": "संगठन रनटाइमले प्रयोग गर्ने हस्ताक्षरित सन्दर्भ-डाटा रिलिज दाबी जारी गर्नुहोस्।"
          }
        },
        "support-delegation": {
          "issue": {
            "label": "सहायता प्रतिनिधि दाबी जारी गर्नुहोस्",
            "description": "अधिकृत सहायता सत्रका लागि हस्ताक्षरित सहायता-प्रतिनिधि दाबी जारी गर्नुहोस्।"
          }
        },
        "runtime-heartbeat": {
          "ingest": {
            "label": "रनटाइम हर्टबिट ग्रहण गर्नुहोस्",
            "description": "अधिकृत संगठन रनटाइम स्थापनाबाट आएको हर्टबिट अभिलेख गर्नुहोस्।"
          }
        },
        "usage-statement": {
          "ingest": {
            "label": "प्रयोग विवरण ग्रहण गर्नुहोस्",
            "description": "प्लेटफर्म मिटरिङका लागि संगठन रनटाइमको प्रयोग विवरण अभिलेख गर्नुहोस्।"
          }
        },
        "bootstrap-attestation": {
          "ingest": {
            "label": "बुटस्ट्र्याप प्रमाणीकरण ग्रहण गर्नुहोस्",
            "description": "संगठन रनटाइम बुटस्ट्र्याप पूरा भएको प्रमाणीकरण अभिलेख गर्नुहोस्।"
          }
        },
        "support-commands": {
          "read": {
            "label": "सहायता आदेशहरू पढ्नुहोस्",
            "description": "संगठन रनटाइमका लागि बाँकी प्लेटफर्म सहायता आदेशहरू पढ्नुहोस्।"
          }
        },
        "support-command": {
          "acknowledge": {
            "label": "सहायता आदेश स्वीकार गर्नुहोस्",
            "description": "संगठन सहायता आदेश प्राप्त वा कार्यान्वयन भएको स्वीकार गर्नुहोस्।"
          }
        }
      },
      "reference-data": {
        "release": {
          "create": {
            "label": "सन्दर्भ डाटा रिलिज सिर्जना गर्नुहोस्",
            "description": "प्लेटफर्म सन्दर्भ-डाटा रिलिजको मस्यौदा सिर्जना गर्नुहोस्।"
          },
          "publish": {
            "label": "सन्दर्भ डाटा रिलिज प्रकाशित गर्नुहोस्",
            "description": "संगठन रनटाइमका लागि स्वीकृत सन्दर्भ-डाटा रिलिज प्रकाशित गर्नुहोस्।"
          }
        }
      },
      "dashboard": {
        "read": {
          "label": "प्लेटफर्म ड्यासबोर्ड हेर्नुहोस्",
          "description": "संगठनको व्यावसायिक डाटा नदेखाई प्लेटफर्म सञ्चालन कार्यक्षेत्र हेर्नुहोस्।"
        }
      },
      "health": {
        "check": {
          "label": "सञ्चालन गर्नुहोस्: Platform Health",
          "description": "तपाईंको अनुमत दायराभित्र Platform Health सञ्चालन गर्नुहोस्।"
        },
        "readiness": {
          "label": "सञ्चालन गर्नुहोस्: Platform Health",
          "description": "तपाईंको अनुमत दायराभित्र Platform Health सञ्चालन गर्नुहोस्।"
        },
        "liveness": {
          "label": "सञ्चालन गर्नुहोस्: Platform Health",
          "description": "तपाईंको अनुमत दायराभित्र Platform Health सञ्चालन गर्नुहोस्।"
        }
      },
      "module": {
        "enable": {
          "label": "सक्रिय गर्नुहोस्: Platform Module",
          "description": "तपाईंको अनुमत दायराभित्र Platform Module सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "disable": {
          "label": "निष्क्रिय गर्नुहोस्: Platform Module",
          "description": "तपाईंको अनुमत दायराभित्र Platform Module सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        }
      },
      "entitlements": {
        "list": {
          "label": "सूची हेर्नुहोस्: Platform Entitlements",
          "description": "तपाईंको अनुमत दायराभित्र Platform Entitlements सञ्चालन गर्नुहोस्।"
        }
      },
      "license": {
        "create": {
          "label": "सिर्जना गर्नुहोस्: Platform License",
          "description": "तपाईंको अनुमत दायराभित्र Platform License सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "list": {
          "label": "सूची हेर्नुहोस्: Platform License",
          "description": "तपाईंको अनुमत दायराभित्र Platform License सञ्चालन गर्नुहोस्।"
        }
      },
      "dataHub": {
        "read": {
          "label": "हेर्नुहोस्: Platform Data Hub",
          "description": "तपाईंको अनुमत दायराभित्र Platform Data Hub सञ्चालन गर्नुहोस्।"
        }
      },
      "reports": {
        "read": {
          "label": "हेर्नुहोस्: Platform Reports",
          "description": "तपाईंको अनुमत दायराभित्र Platform Reports सञ्चालन गर्नुहोस्।"
        },
        "snapshot": {
          "create": {
            "label": "सिर्जना गर्नुहोस्: Platform Reports Snapshot"
          }
        },
        "restatement": {
          "create": {
            "label": "सिर्जना गर्नुहोस्: Platform Reports Restatement"
          }
        }
      },
      "modules": {
        "list": {
          "label": "सूची हेर्नुहोस्: Platform Modules"
        },
        "read": {
          "label": "हेर्नुहोस्: Platform Modules"
        },
        "assign": {
          "label": "तोक्नुहोस्: Platform Modules"
        },
        "revoke": {
          "label": "खारेज गर्नुहोस्: Platform Modules"
        },
        "catalog": {
          "list": {
            "label": "सूची हेर्नुहोस्: Platform Modules Catalog"
          },
          "manage": {
            "label": "व्यवस्थापन गर्नुहोस्: Platform Modules Catalog"
          }
        },
        "assignToOrganization": {
          "label": "सञ्चालन गर्नुहोस्: Platform Modules"
        },
        "revokeFromOrganization": {
          "label": "सञ्चालन गर्नुहोस्: Platform Modules"
        }
      },
      "supportDelegations": {
        "list": {
          "label": "सूची हेर्नुहोस्: Platform Support Delegations"
        }
      },
      "users": {
        "list": {
          "label": "सूची हेर्नुहोस्: Platform Users"
        },
        "read": {
          "label": "हेर्नुहोस्: Platform Users"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Platform Users"
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Platform Users"
        },
        "disable": {
          "label": "निष्क्रिय गर्नुहोस्: Platform Users"
        }
      },
      "audit": {
        "list": {
          "label": "सूची हेर्नुहोस्: Platform Audit"
        },
        "read": {
          "label": "हेर्नुहोस्: Platform Audit"
        },
        "export": {
          "label": "निर्यात गर्नुहोस्: Platform Audit"
        }
      },
      "configuration-rollout": {
        "read": {
          "label": "हेर्नुहोस्: Platform Configuration Rollout"
        },
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Platform Configuration Rollout"
        }
      },
      "data-residency": {
        "read": {
          "label": "हेर्नुहोस्: Platform Data Residency"
        },
        "policy": {
          "update": {
            "label": "अद्यावधिक गर्नुहोस्: Platform Data Residency Policy"
          }
        },
        "transfer": {
          "evaluate": {
            "label": "मूल्याङ्कन गर्नुहोस्: Platform Data Residency Transfer"
          }
        },
        "exception": {
          "approve": {
            "label": "स्वीकृत गर्नुहोस्: Platform Data Residency Exception"
          }
        }
      },
      "jurisdiction-packages": {
        "read": {
          "label": "हेर्नुहोस्: Platform Jurisdiction Packages"
        },
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Platform Jurisdiction Packages"
        }
      },
      "reference-master": {
        "read": {
          "label": "हेर्नुहोस्: Platform Reference Master"
        },
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Platform Reference Master"
        }
      },
      "market-data-quality": {
        "read": {
          "label": "हेर्नुहोस्: Platform Market Data Quality"
        },
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Platform Market Data Quality"
        },
        "approve": {
          "label": "स्वीकृत गर्नुहोस्: Platform Market Data Quality"
        }
      },
      "provider-ingestion": {
        "read": {
          "label": "हेर्नुहोस्: Platform Provider Ingestion"
        },
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Platform Provider Ingestion"
        }
      },
      "issuer-events": {
        "read": {
          "label": "हेर्नुहोस्: Platform Issuer Events"
        },
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Platform Issuer Events"
        },
        "approve": {
          "label": "स्वीकृत गर्नुहोस्: Platform Issuer Events"
        }
      },
      "permission-catalog-migrations": {
        "read": {
          "label": "हेर्नुहोस्: Platform Permission Catalog Migrations"
        },
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Platform Permission Catalog Migrations"
        }
      },
      "federation": {
        "read": {
          "label": "हेर्नुहोस्: Platform Federation"
        },
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Platform Federation"
        }
      },
      "service-accounts": {
        "read": {
          "label": "हेर्नुहोस्: Platform Service Accounts"
        },
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Platform Service Accounts"
        }
      },
      "access-reviews": {
        "read": {
          "label": "हेर्नुहोस्: Platform Access Reviews"
        },
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Platform Access Reviews"
        }
      },
      "cryptographic-keys": {
        "read": {
          "label": "हेर्नुहोस्: Platform Cryptographic Keys"
        },
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Platform Cryptographic Keys"
        }
      },
      "scheduled-controls": {
        "read": {
          "label": "हेर्नुहोस्: Platform Scheduled Controls"
        },
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Platform Scheduled Controls"
        },
        "approve": {
          "label": "स्वीकृत गर्नुहोस्: Platform Scheduled Controls"
        }
      },
      "security-incidents": {
        "read": {
          "label": "हेर्नुहोस्: Platform Security Incidents"
        },
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Platform Security Incidents"
        }
      },
      "organization-ownership": {
        "read": {
          "label": "हेर्नुहोस्: Platform Organization Ownership"
        },
        "request": {
          "label": "अनुरोध गर्नुहोस्: Platform Organization Ownership"
        },
        "approve": {
          "label": "स्वीकृत गर्नुहोस्: Platform Organization Ownership"
        }
      },
      "migration-governance": {
        "read": {
          "label": "हेर्नुहोस्: Platform Migration Governance"
        },
        "request": {
          "label": "अनुरोध गर्नुहोस्: Platform Migration Governance"
        },
        "approve": {
          "label": "स्वीकृत गर्नुहोस्: Platform Migration Governance"
        }
      },
      "organization-portability": {
        "read": {
          "label": "हेर्नुहोस्: Platform Organization Portability"
        },
        "request": {
          "label": "अनुरोध गर्नुहोस्: Platform Organization Portability"
        },
        "approve": {
          "label": "स्वीकृत गर्नुहोस्: Platform Organization Portability"
        },
        "purge": {
          "label": "स्थायी रूपमा मेटाउनुहोस्: Platform Organization Portability"
        }
      },
      "notification-governance": {
        "read": {
          "label": "हेर्नुहोस्: Platform Notification Governance"
        },
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Platform Notification Governance"
        },
        "approve": {
          "label": "स्वीकृत गर्नुहोस्: Platform Notification Governance"
        }
      },
      "support-delegations": {
        "read": {
          "label": "हेर्नुहोस्: Platform Support Delegations"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Platform Support Delegations"
        },
        "approve": {
          "label": "स्वीकृत गर्नुहोस्: Platform Support Delegations"
        },
        "revoke": {
          "label": "खारेज गर्नुहोस्: Platform Support Delegations"
        }
      },
      "clientAccount": {
        "list": {
          "label": "सूची हेर्नुहोस्: Platform Client Account",
          "description": "तपाईंको अनुमत दायराभित्र Platform Client Account सञ्चालन गर्नुहोस्।"
        },
        "get": {
          "label": "हेर्नुहोस्: Platform Client Account",
          "description": "तपाईंको अनुमत दायराभित्र Platform Client Account सञ्चालन गर्नुहोस्।"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Platform Client Account",
          "description": "तपाईंको अनुमत दायराभित्र Platform Client Account सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Platform Client Account",
          "description": "तपाईंको अनुमत दायराभित्र Platform Client Account सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "documents": {
          "list": {
            "label": "सूची हेर्नुहोस्: Platform Client Account Documents",
            "description": "तपाईंको अनुमत दायराभित्र Platform Client Account Documents सञ्चालन गर्नुहोस्।"
          }
        },
        "document": {
          "create": {
            "label": "सिर्जना गर्नुहोस्: Platform Client Account Document",
            "description": "तपाईंको अनुमत दायराभित्र Platform Client Account Document सञ्चालन गर्नुहोस्।",
            "makerChecker": {
              "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
            }
          }
        }
      }
    },
    "feeRules": {
      "list": {
        "label": "शुल्क तालिका हेर्नुहोस्",
        "description": "प्रभावकारी विश्वव्यापी, संस्था र शाखा शुल्क तालिकाहरू हेर्नुहोस्।"
      },
      "read": {
        "label": "शुल्क तालिका पढ्नुहोस्",
        "description": "एउटा प्रभावकारी-मितियुक्त शुल्क तालिका र यसको गणना अवयवहरू समीक्षा गर्नुहोस्।"
      },
      "create-version": {
        "label": "शुल्क तालिका संस्करण सिर्जना गर्नुहोस्",
        "description": "ब्रोकरेज, डीपी र सेबोन शुल्कहरूको अपरिवर्तनीय मस्यौदा संस्करण सिर्जना गर्नुहोस्।"
      },
      "submit": {
        "label": "शुल्क तालिका पेश गर्नुहोस्",
        "description": "स्वतन्त्र स्वीकृतिका लागि मस्यौदा शुल्क तालिका पेश गर्नुहोस्।"
      },
      "approve": {
        "label": "शुल्क तालिका स्वीकृत गर्नुहोस्",
        "description": "मेकर-चेकर स्वीकृतिबाट पेश गरिएको शुल्क तालिका सक्रिय गर्नुहोस्।"
      },
      "suspend": {
        "label": "शुल्क तालिका निलम्बन गर्नुहोस्",
        "description": "नयाँ पोस्टिङका लागि सक्रिय शुल्क तालिका छनोट हुनबाट रोक्नुहोस्।"
      },
      "retire": {
        "label": "शुल्क तालिका अवकाश गर्नुहोस्",
        "description": "गणना वंशावली कायम राख्दै निष्क्रिय शुल्क तालिका अवकाश गर्नुहोस्।"
      },
      "impact-analyze": {
        "label": "शुल्क तालिका प्रभाव विश्लेषण गर्नुहोस्",
        "description": "प्रभावकारी अवधिका अपरिवर्तनीय पोस्ट गरिएका कारोबार र सम्भावित गतिविधि गणना गर्नुहोस्।"
      }
    },
    "organization": {
      "regulatory-profile": {
        "read": {
          "label": "संस्थाको नियामक प्रोफाइल हेर्नुहोस्",
          "description": "संस्थाको प्रमाणित नियामक पहिचान र प्रभावकारी इजाजतपत्र विवरण हेर्नुहोस्।"
        },
        "update": {
          "label": "संस्थाको नियामक प्रोफाइल अद्यावधिक गर्नुहोस्",
          "description": "AAL2, आशावादी लक, अडिट र आइडेम्पोटेन्सी नियन्त्रणअन्तर्गत प्रमाणित नियामक इजाजतपत्र र फाइलिङ पहिचान अद्यावधिक गर्नुहोस्।"
        }
      },
      "branches": {
        "list": {
          "label": "सूची हेर्नुहोस्: Organization Branches"
        },
        "read": {
          "label": "हेर्नुहोस्: Organization Branches"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Organization Branches"
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Organization Branches"
        },
        "disable": {
          "label": "निष्क्रिय गर्नुहोस्: Organization Branches"
        },
        "make-default": {
          "label": "सञ्चालन गर्नुहोस्: Organization Branches"
        }
      },
      "clients": {
        "list": {
          "label": "सूची हेर्नुहोस्: Organization Clients"
        },
        "read": {
          "label": "हेर्नुहोस्: Organization Clients"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Organization Clients"
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Organization Clients"
        },
        "disable": {
          "label": "निष्क्रिय गर्नुहोस्: Organization Clients"
        }
      },
      "clientAccounts": {
        "list": {
          "label": "सूची हेर्नुहोस्: Organization Client Accounts"
        },
        "read": {
          "label": "हेर्नुहोस्: Organization Client Accounts"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Organization Client Accounts"
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Organization Client Accounts"
        },
        "disable": {
          "label": "निष्क्रिय गर्नुहोस्: Organization Client Accounts"
        },
        "documents": {
          "list": {
            "label": "सूची हेर्नुहोस्: Organization Client Accounts Documents"
          },
          "create": {
            "label": "सिर्जना गर्नुहोस्: Organization Client Accounts Documents"
          },
          "remove": {
            "label": "हटाउनुहोस्: Organization Client Accounts Documents"
          }
        },
        "signatories": {
          "list": {
            "label": "सूची हेर्नुहोस्: Organization Client Accounts Signatories"
          },
          "create": {
            "label": "सिर्जना गर्नुहोस्: Organization Client Accounts Signatories"
          },
          "remove": {
            "label": "हटाउनुहोस्: Organization Client Accounts Signatories"
          }
        }
      },
      "portfolios": {
        "list": {
          "label": "सूची हेर्नुहोस्: Organization Portfolios"
        },
        "read": {
          "label": "सूची हेर्नुहोस्: Organization Benchmark Assignments"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Organization Benchmark Assignments"
        },
        "update": {
          "label": "स्वीकृत गर्नुहोस्: Organization Benchmark Assignments"
        },
        "disable": {
          "label": "निष्क्रिय गर्नुहोस्: Organization Portfolios"
        }
      },
      "modules": {
        "listAssigned": {
          "label": "सञ्चालन गर्नुहोस्: Organization Modules"
        },
        "enable": {
          "label": "सक्रिय गर्नुहोस्: Organization Modules"
        },
        "disable": {
          "label": "निष्क्रिय गर्नुहोस्: Organization Modules"
        },
        "configure": {
          "label": "कन्फिगर गर्नुहोस्: Organization Modules"
        }
      },
      "profile": {
        "read": {
          "label": "हेर्नुहोस्: Organization Profile"
        },
        "detail": {
          "read": {
            "label": "हेर्नुहोस्: Organization Profile Detail",
            "description": "तपाईंको अनुमत दायराभित्र Organization Profile Detail सञ्चालन गर्नुहोस्।"
          }
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Organization Profile"
        }
      },
      "users": {
        "list": {
          "label": "सूची हेर्नुहोस्: Organization Users"
        },
        "read": {
          "label": "हेर्नुहोस्: Organization Users"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Organization Users"
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Organization Users"
        },
        "disable": {
          "label": "निष्क्रिय गर्नुहोस्: Organization Users"
        },
        "unlock": {
          "label": "लक खोल्नुहोस्: Organization Users"
        },
        "force-password-reset": {
          "label": "सञ्चालन गर्नुहोस्: Organization Users"
        },
        "mfa": {
          "require-enrollment": {
            "label": "सञ्चालन गर्नुहोस्: Organization Users Mfa"
          },
          "reset-enrollment": {
            "label": "सञ्चालन गर्नुहोस्: Organization Users Mfa"
          },
          "disable": {
            "label": "निष्क्रिय गर्नुहोस्: Organization Users Mfa"
          },
          "regenerate-recovery": {
            "label": "सञ्चालन गर्नुहोस्: Organization Users Mfa"
          }
        }
      },
      "roles": {
        "list": {
          "label": "सूची हेर्नुहोस्: Organization Roles"
        },
        "read": {
          "label": "हेर्नुहोस्: Organization Roles"
        },
        "create": {
          "label": "सिर्जना गर्नुहोस्: Organization Roles"
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Organization Roles"
        },
        "disable": {
          "label": "निष्क्रिय गर्नुहोस्: Organization Roles"
        }
      },
      "permissions": {
        "list": {
          "label": "सूची हेर्नुहोस्: Organization Permissions"
        }
      },
      "permission-assignments": {
        "list": {
          "label": "सूची हेर्नुहोस्: Organization Permission Assignments"
        },
        "edit": {
          "label": "सञ्चालन गर्नुहोस्: Organization Permission Assignments"
        }
      },
      "audit": {
        "list": {
          "label": "सूची हेर्नुहोस्: Organization Audit"
        },
        "read": {
          "label": "हेर्नुहोस्: Organization Audit"
        },
        "export": {
          "label": "निर्यात गर्नुहोस्: Organization Audit"
        }
      },
      "access-inspector": {
        "read": {
          "label": "हेर्नुहोस्: Organization Access Inspector"
        }
      },
      "legal-hold": {
        "place": {
          "label": "राख्नुहोस्: Organization Legal Hold"
        },
        "remove": {
          "label": "हटाउनुहोस्: Organization Legal Hold"
        },
        "list": {
          "label": "सूची हेर्नुहोस्: Organization Legal Hold"
        }
      },
      "admin-delegation": {
        "create": {
          "label": "सिर्जना गर्नुहोस्: Organization Admin Delegation"
        },
        "revoke": {
          "label": "खारेज गर्नुहोस्: Organization Admin Delegation"
        },
        "list": {
          "label": "सूची हेर्नुहोस्: Organization Admin Delegation"
        }
      }
    },
    "portfolioPerformance": {
      "list": {
        "label": "पोर्टफोलियो कार्यसम्पादन हेर्नुहोस्",
        "description": "दायराभित्रको पोर्टफोलियो मूल्यांकन, नाफा/नोक्सानी, नेपाल कर स्रोत प्रमाण र एनएफआरएस प्रमाण हेर्नुहोस्।"
      },
      "export": {
        "label": "निर्यात गर्नुहोस्: Investment Performance",
        "description": "तपाईंको अनुमत दायराभित्र Investment Performance सञ्चालन गर्नुहोस्।"
      },
      "clientReadOwn": {
        "label": "सञ्चालन गर्नुहोस्: Client Portfolio Performance",
        "description": "तपाईंको अनुमत दायराभित्र Client Portfolio Performance सञ्चालन गर्नुहोस्।"
      }
    },
    "portfolioCustody": {
      "list": {
        "label": "पोर्टफोलियो कस्टडी प्रमाण हेर्नुहोस्",
        "description": "बाह्य मौज्दात मेलमिलाप भएको दाबी नगरी दायराभित्रको बोआईडी, डीपी कोड, आन्तरिक स्थिति र सीडीएससी कागजात प्रमाण हेर्नुहोस्।"
      },
      "clientReadOwn": {
        "label": "मेरो कस्टडी प्रमाण हेर्नुहोस्",
        "description": "तपाईंको बोआईडी, डीपी कोड, आन्तरिक स्थिति र सीडीएससी कागजात प्रमाण हेर्नुहोस्।"
      }
    },
    "dashboard": {
      "view": {
        "label": "हेर्नुहोस्: Dashboard",
        "description": "तपाईंको अनुमत दायराभित्र Dashboard सञ्चालन गर्नुहोस्।"
      }
    },
    "holdings": {
      "view": {
        "label": "हेर्नुहोस्: Holdings",
        "description": "तपाईंको अनुमत दायराभित्र Holdings सञ्चालन गर्नुहोस्।"
      }
    },
    "reports": {
      "view": {
        "label": "हेर्नुहोस्: Reports",
        "description": "तपाईंको अनुमत दायराभित्र Reports सञ्चालन गर्नुहोस्।"
      },
      "detail": {
        "read": {
          "label": "हेर्नुहोस्: Reports Detail",
          "description": "तपाईंको अनुमत दायराभित्र Reports Detail सञ्चालन गर्नुहोस्।"
        }
      }
    },
    "reconciliation": {
      "view": {
        "label": "हेर्नुहोस्: Reconciliation",
        "description": "तपाईंको अनुमत दायराभित्र Reconciliation सञ्चालन गर्नुहोस्।"
      },
      "statement": {
        "create": {
          "label": "सिर्जना गर्नुहोस्: Reconciliation Statement",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Statement सञ्चालन गर्नुहोस्।"
        },
        "list": {
          "label": "सूची हेर्नुहोस्: Reconciliation Statement",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Statement सञ्चालन गर्नुहोस्।"
        },
        "get": {
          "label": "हेर्नुहोस्: Reconciliation Statement",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Statement सञ्चालन गर्नुहोस्।"
        }
      },
      "run": {
        "create": {
          "label": "सिर्जना गर्नुहोस्: Reconciliation Run",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Run सञ्चालन गर्नुहोस्।"
        },
        "list": {
          "label": "सूची हेर्नुहोस्: Reconciliation Run",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Run सञ्चालन गर्नुहोस्।"
        },
        "get": {
          "label": "हेर्नुहोस्: Reconciliation Run",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Run सञ्चालन गर्नुहोस्।"
        },
        "breaks": {
          "list": {
            "label": "सूची हेर्नुहोस्: Reconciliation Run Breaks",
            "description": "तपाईंको अनुमत दायराभित्र Reconciliation Run Breaks सञ्चालन गर्नुहोस्।"
          }
        },
        "matches": {
          "list": {
            "label": "सूची हेर्नुहोस्: Reconciliation Run Matches",
            "description": "तपाईंको अनुमत दायराभित्र Reconciliation Run Matches सञ्चालन गर्नुहोस्।"
          }
        },
        "cancel": {
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Run सञ्चालन गर्नुहोस्।"
        },
        "retry": {
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Run सञ्चालन गर्नुहोस्।"
        }
      },
      "break": {
        "get": {
          "label": "हेर्नुहोस्: Reconciliation Break",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Break सञ्चालन गर्नुहोस्।"
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Reconciliation Break",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Break सञ्चालन गर्नुहोस्।"
        }
      },
      "adjustment": {
        "create": {
          "label": "सिर्जना गर्नुहोस्: Reconciliation Adjustment",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Adjustment सञ्चालन गर्नुहोस्।"
        },
        "list": {
          "label": "सूची हेर्नुहोस्: Reconciliation Adjustment",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Adjustment सञ्चालन गर्नुहोस्।"
        },
        "approve": {
          "label": "स्वीकृत गर्नुहोस्: Reconciliation Adjustment",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Adjustment सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "reject": {
          "label": "अस्वीकृत गर्नुहोस्: Reconciliation Adjustment",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Adjustment सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "post": {
          "label": "पोस्ट गर्नुहोस्: Reconciliation Adjustment",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Adjustment सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        }
      },
      "aging": {
        "execute": {
          "label": "कार्यान्वयन गर्नुहोस्: Reconciliation Aging",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Aging सञ्चालन गर्नुहोस्।"
        }
      },
      "escalation": {
        "execute": {
          "label": "कार्यान्वयन गर्नुहोस्: Reconciliation Escalation",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Escalation सञ्चालन गर्नुहोस्।"
        }
      },
      "suspenseCash": {
        "caseCreate": {
          "label": "सिर्जना गर्नुहोस्: Reconciliation Suspense Cash",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Suspense Cash सञ्चालन गर्नुहोस्।"
        },
        "caseList": {
          "label": "सूची हेर्नुहोस्: Reconciliation Suspense Cash",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Suspense Cash सञ्चालन गर्नुहोस्।"
        },
        "resolutionRequest": {
          "label": "सञ्चालन गर्नुहोस्: Reconciliation Suspense Cash",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Suspense Cash सञ्चालन गर्नुहोस्।"
        },
        "resolutionApprove": {
          "label": "सञ्चालन गर्नुहोस्: Reconciliation Suspense Cash",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Suspense Cash सञ्चालन गर्नुहोस्।"
        },
        "reopenRequest": {
          "label": "सञ्चालन गर्नुहोस्: Reconciliation Suspense Cash",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Suspense Cash सञ्चालन गर्नुहोस्।"
        },
        "reopenApprove": {
          "label": "सञ्चालन गर्नुहोस्: Reconciliation Suspense Cash",
          "description": "तपाईंको अनुमत दायराभित्र Reconciliation Suspense Cash सञ्चालन गर्नुहोस्।"
        }
      }
    },
    "corporateActions": {
      "view": {
        "label": "हेर्नुहोस्: Corporate Actions",
        "description": "तपाईंको अनुमत दायराभित्र Corporate Actions सञ्चालन गर्नुहोस्।"
      }
    },
    "settings": {
      "view": {
        "label": "हेर्नुहोस्: Settings",
        "description": "तपाईंको अनुमत दायराभित्र Settings सञ्चालन गर्नुहोस्।"
      },
      "profile": {
        "label": "सञ्चालन गर्नुहोस्: Settings",
        "description": "तपाईंको अनुमत दायराभित्र Settings सञ्चालन गर्नुहोस्।",
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Settings Profile",
          "description": "तपाईंको अनुमत दायराभित्र Settings Profile सञ्चालन गर्नुहोस्।"
        }
      },
      "preferences": {
        "label": "सञ्चालन गर्नुहोस्: Settings",
        "description": "तपाईंको अनुमत दायराभित्र Settings सञ्चालन गर्नुहोस्।",
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Settings Preferences",
          "description": "तपाईंको अनुमत दायराभित्र Settings Preferences सञ्चालन गर्नुहोस्।"
        }
      },
      "mfa": {
        "label": "सञ्चालन गर्नुहोस्: Settings",
        "description": "तपाईंको अनुमत दायराभित्र Settings सञ्चालन गर्नुहोस्।"
      },
      "security": {
        "label": "सञ्चालन गर्नुहोस्: Settings",
        "description": "तपाईंको अनुमत दायराभित्र Settings सञ्चालन गर्नुहोस्।"
      }
    },
    "admin": {
      "hub": {
        "label": "सञ्चालन गर्नुहोस्: Admin",
        "description": "तपाईंको अनुमत दायराभित्र Admin सञ्चालन गर्नुहोस्।",
        "platform": {
          "label": "सञ्चालन गर्नुहोस्: Admin Hub",
          "description": "तपाईंको अनुमत दायराभित्र Admin Hub सञ्चालन गर्नुहोस्।"
        },
        "organization": {
          "label": "सञ्चालन गर्नुहोस्: Admin Hub",
          "description": "तपाईंको अनुमत दायराभित्र Admin Hub सञ्चालन गर्नुहोस्।"
        }
      },
      "users": {
        "view": {
          "label": "हेर्नुहोस्: Admin Users",
          "description": "तपाईंको अनुमत दायराभित्र Admin Users सञ्चालन गर्नुहोस्।"
        },
        "detail": {
          "label": "सञ्चालन गर्नुहोस्: Admin Users",
          "description": "तपाईंको अनुमत दायराभित्र Admin Users सञ्चालन गर्नुहोस्।"
        }
      },
      "roles": {
        "view": {
          "label": "हेर्नुहोस्: Admin Roles",
          "description": "तपाईंको अनुमत दायराभित्र Admin Roles सञ्चालन गर्नुहोस्।"
        },
        "detail": {
          "label": "सञ्चालन गर्नुहोस्: Admin Roles",
          "description": "तपाईंको अनुमत दायराभित्र Admin Roles सञ्चालन गर्नुहोस्।"
        }
      },
      "organization": {
        "view": {
          "label": "हेर्नुहोस्: Admin Organization",
          "description": "तपाईंको अनुमत दायराभित्र Admin Organization सञ्चालन गर्नुहोस्।"
        }
      },
      "audit": {
        "view": {
          "label": "हेर्नुहोस्: Admin Audit",
          "description": "तपाईंको अनुमत दायराभित्र Admin Audit सञ्चालन गर्नुहोस्।"
        }
      },
      "auditLog": {
        "list": {
          "label": "सूची हेर्नुहोस्: Admin Audit Log",
          "description": "तपाईंको अनुमत दायराभित्र Admin Audit Log सञ्चालन गर्नुहोस्।"
        }
      },
      "modules": {
        "list": {
          "label": "सूची हेर्नुहोस्: Admin Modules",
          "description": "तपाईंको अनुमत दायराभित्र Admin Modules सञ्चालन गर्नुहोस्।"
        }
      },
      "user": {
        "create": {
          "label": "सिर्जना गर्नुहोस्: Admin User",
          "description": "तपाईंको अनुमत दायराभित्र Admin User सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Admin User",
          "description": "तपाईंको अनुमत दायराभित्र Admin User सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "delete": {
          "label": "मेटाउनुहोस्: Admin User",
          "description": "तपाईंको अनुमत दायराभित्र Admin User सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        }
      },
      "role": {
        "create": {
          "label": "सिर्जना गर्नुहोस्: Admin Role",
          "description": "तपाईंको अनुमत दायराभित्र Admin Role सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "update": {
          "label": "अद्यावधिक गर्नुहोस्: Admin Role",
          "description": "तपाईंको अनुमत दायराभित्र Admin Role सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "delete": {
          "label": "मेटाउनुहोस्: Admin Role",
          "description": "तपाईंको अनुमत दायराभित्र Admin Role सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        }
      }
    },
    "data": {
      "hub": {
        "label": "सञ्चालन गर्नुहोस्: Data",
        "description": "तपाईंको अनुमत दायराभित्र Data सञ्चालन गर्नुहोस्।"
      }
    },
    "import": {
      "list": {
        "label": "सूची हेर्नुहोस्: Import",
        "description": "तपाईंको अनुमत दायराभित्र Import सञ्चालन गर्नुहोस्।"
      },
      "get": {
        "label": "हेर्नुहोस्: Import",
        "description": "तपाईंको अनुमत दायराभित्र Import सञ्चालन गर्नुहोस्।"
      },
      "upload": {
        "label": "अपलोड गर्नुहोस्: Import",
        "description": "तपाईंको अनुमत दायराभित्र Import सञ्चालन गर्नुहोस्।"
      },
      "commit": {
        "label": "सञ्चालन गर्नुहोस्: Import",
        "description": "तपाईंको अनुमत दायराभित्र Import सञ्चालन गर्नुहोस्।",
        "makerChecker": {
          "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
        }
      },
      "validate": {
        "label": "प्रमाणित गर्नुहोस्: Import",
        "description": "तपाईंको अनुमत दायराभित्र Import सञ्चालन गर्नुहोस्।"
      },
      "reconcile": {
        "label": "सञ्चालन गर्नुहोस्: Import",
        "description": "तपाईंको अनुमत दायराभित्र Import सञ्चालन गर्नुहोस्।"
      },
      "rows": {
        "list": {
          "label": "सूची हेर्नुहोस्: Import Rows",
          "description": "तपाईंको अनुमत दायराभित्र Import Rows सञ्चालन गर्नुहोस्।"
        }
      },
      "recover": {
        "label": "पुनः प्राप्त गर्नुहोस्: Import",
        "description": "तपाईंको अनुमत दायराभित्र Import सञ्चालन गर्नुहोस्।",
        "makerChecker": {
          "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
        }
      },
      "cancel": {
        "label": "रद्द गर्नुहोस्: Import",
        "description": "तपाईंको अनुमत दायराभित्र Import सञ्चालन गर्नुहोस्।",
        "makerChecker": {
          "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
        }
      }
    },
    "access": {
      "members": {
        "read": {
          "label": "हेर्नुहोस्: Access Members",
          "description": "तपाईंको अनुमत दायराभित्र Access Members सञ्चालन गर्नुहोस्।"
        }
      },
      "roles": {
        "read": {
          "label": "हेर्नुहोस्: Access Roles",
          "description": "तपाईंको अनुमत दायराभित्र Access Roles सञ्चालन गर्नुहोस्।"
        },
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Access Roles",
          "description": "तपाईंको अनुमत दायराभित्र Access Roles सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        }
      },
      "permissions": {
        "read": {
          "label": "हेर्नुहोस्: Access Permissions",
          "description": "तपाईंको अनुमत दायराभित्र Access Permissions सञ्चालन गर्नुहोस्।"
        },
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Access Permissions",
          "description": "तपाईंको अनुमत दायराभित्र Access Permissions सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        }
      },
      "membership": {
        "manage": {
          "label": "व्यवस्थापन गर्नुहोस्: Access Membership",
          "description": "तपाईंको अनुमत दायराभित्र Access Membership सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        }
      }
    },
    "metrics": {
      "read": {
        "label": "हेर्नुहोस्: Platform Metrics",
        "description": "तपाईंको अनुमत दायराभित्र Platform Metrics सञ्चालन गर्नुहोस्।"
      },
      "read-json": {
        "label": "सञ्चालन गर्नुहोस्: Platform Metrics",
        "description": "तपाईंको अनुमत दायराभित्र Platform Metrics सञ्चालन गर्नुहोस्।"
      }
    },
    "client": {
      "dashboard": {
        "read": {
          "label": "हेर्नुहोस्: Client Dashboard"
        }
      },
      "profile": {
        "read": {
          "label": "हेर्नुहोस्: Client Profile"
        },
        "updateLimited": {
          "label": "सञ्चालन गर्नुहोस्: Client Profile"
        }
      },
      "holdings": {
        "readOwn": {
          "label": "सञ्चालन गर्नुहोस्: Client Holdings"
        }
      },
      "transactions": {
        "readOwn": {
          "label": "सञ्चालन गर्नुहोस्: Client Transactions"
        }
      },
      "reports": {
        "readOwn": {
          "label": "सञ्चालन गर्नुहोस्: Client Reports"
        },
        "exportOwn": {
          "label": "सञ्चालन गर्नुहोस्: Client Reports"
        }
      },
      "documents": {
        "readOwn": {
          "label": "सञ्चालन गर्नुहोस्: Client Documents"
        }
      }
    },
    "compliance": {
      "aml-cases": {
        "list": {
          "label": "सूची हेर्नुहोस्: Compliance Aml Cases",
          "description": "तपाईंको अनुमत दायराभित्र Compliance Aml Cases सञ्चालन गर्नुहोस्।"
        },
        "get": {
          "label": "हेर्नुहोस्: Compliance Aml Cases",
          "description": "तपाईंको अनुमत दायराभित्र Compliance Aml Cases सञ्चालन गर्नुहोस्।"
        },
        "open": {
          "label": "खोल्नुहोस्: Compliance Aml Cases",
          "description": "तपाईंको अनुमत दायराभित्र Compliance Aml Cases सञ्चालन गर्नुहोस्।"
        },
        "review": {
          "label": "सञ्चालन गर्नुहोस्: Compliance Aml Cases",
          "description": "तपाईंको अनुमत दायराभित्र Compliance Aml Cases सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "report": {
          "label": "सञ्चालन गर्नुहोस्: Compliance Aml Cases",
          "description": "तपाईंको अनुमत दायराभित्र Compliance Aml Cases सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        },
        "close": {
          "label": "बन्द गर्नुहोस्: Compliance Aml Cases",
          "description": "तपाईंको अनुमत दायराभित्र Compliance Aml Cases सञ्चालन गर्नुहोस्।",
          "makerChecker": {
            "reason": "यस नियन्त्रित सञ्चालनका लागि स्वतन्त्र स्वीकृति आवश्यक छ।"
          }
        }
      },
      "nepal": {
        "generate": {
          "label": "तयार गर्नुहोस्: Compliance Nepal",
          "description": "तपाईंको अनुमत दायराभित्र Compliance Nepal सञ्चालन गर्नुहोस्।"
        },
        "export": {
          "label": "निर्यात गर्नुहोस्: Compliance Nepal",
          "description": "तपाईंको अनुमत दायराभित्र Compliance Nepal सञ्चालन गर्नुहोस्।"
        }
      },
      "breaches": {
        "open": {
          "label": "अनुपालन उल्लङ्घन खोल्नुहोस्",
          "description": "अधिकृत निष्कर्ष वा अपवादबाट अनुपालन उल्लङ्घन खोल्नुहोस्।"
        },
        "remediate": {
          "label": "अनुपालन उल्लङ्घन सुधार गर्नुहोस्",
          "description": "खुला अनुपालन उल्लङ्घनका लागि सुधार अभिलेख गर्नुहोस्।"
        },
        "waive": {
          "label": "अनुपालन उल्लङ्घन छुट दिनुहोस्",
          "description": "मेकर-चेकर शासनअन्तर्गत योग्य अनुपालन उल्लङ्घनलाई छुट दिनुहोस्।"
        }
      }
    },
    "planned": {
      "market": {
        "prices": {
          "override": {
            "label": "सञ्चालन गर्नुहोस्: Market Prices",
            "description": "तपाईंको अनुमत दायराभित्र Market Prices सञ्चालन गर्नुहोस्।"
          }
        },
        "fxRates": {
          "list": {
            "label": "सूची हेर्नुहोस्: Market Fx Rates",
            "description": "तपाईंको अनुमत दायराभित्र Market Fx Rates सञ्चालन गर्नुहोस्।"
          }
        },
        "benchmarks": {
          "list": {
            "label": "सूची हेर्नुहोस्: Market Benchmarks",
            "description": "तपाईंको अनुमत दायराभित्र Market Benchmarks सञ्चालन गर्नुहोस्।"
          }
        },
        "providers": {
          "list": {
            "label": "सूची हेर्नुहोस्: Market Providers",
            "description": "तपाईंको अनुमत दायराभित्र Market Providers सञ्चालन गर्नुहोस्।"
          }
        },
        "exceptions": {
          "list": {
            "label": "सूची हेर्नुहोस्: Market Exceptions",
            "description": "तपाईंको अनुमत दायराभित्र Market Exceptions सञ्चालन गर्नुहोस्।"
          }
        }
      },
      "investment": {
        "mandates": {
          "list": {
            "label": "सूची हेर्नुहोस्: Investment Mandates",
            "description": "तपाईंको अनुमत दायराभित्र Investment Mandates सञ्चालन गर्नुहोस्।"
          }
        }
      },
      "custody": {
        "balances": {
          "list": {
            "label": "सूची हेर्नुहोस्: Custody Balances",
            "description": "तपाईंको अनुमत दायराभित्र Custody Balances सञ्चालन गर्नुहोस्।"
          }
        }
      },
      "accounting": {
        "journals": {
          "list": {
            "label": "सूची हेर्नुहोस्: Accounting Journals",
            "description": "तपाईंको अनुमत दायराभित्र Accounting Journals सञ्चालन गर्नुहोस्।"
          },
          "get": {
            "label": "हेर्नुहोस्: Accounting Journals",
            "description": "तपाईंको अनुमत दायराभित्र Accounting Journals सञ्चालन गर्नुहोस्।"
          }
        },
        "chartOfAccounts": {
          "list": {
            "label": "सूची हेर्नुहोस्: Accounting Chart Of Accounts",
            "description": "तपाईंको अनुमत दायराभित्र Accounting Chart Of Accounts सञ्चालन गर्नुहोस्।"
          }
        },
        "fiscalPeriods": {
          "list": {
            "label": "सूची हेर्नुहोस्: Accounting Fiscal Periods",
            "description": "तपाईंको अनुमत दायराभित्र Accounting Fiscal Periods सञ्चालन गर्नुहोस्।"
          }
        }
      },
      "tax": {
        "records": {
          "list": {
            "label": "सूची हेर्नुहोस्: Tax Records",
            "description": "तपाईंको अनुमत दायराभित्र Tax Records सञ्चालन गर्नुहोस्।"
          }
        },
        "calculations": {
          "list": {
            "label": "सूची हेर्नुहोस्: Tax Calculations",
            "description": "तपाईंको अनुमत दायराभित्र Tax Calculations सञ्चालन गर्नुहोस्।"
          }
        }
      },
      "evidence": {
        "list": {
          "label": "सूची हेर्नुहोस्: Evidence",
          "description": "तपाईंको अनुमत दायराभित्र Evidence सञ्चालन गर्नुहोस्।"
        },
        "get": {
          "label": "हेर्नुहोस्: Evidence",
          "description": "तपाईंको अनुमत दायराभित्र Evidence सञ्चालन गर्नुहोस्।"
        },
        "upload": {
          "label": "अपलोड गर्नुहोस्: Evidence",
          "description": "तपाईंको अनुमत दायराभित्र Evidence सञ्चालन गर्नुहोस्।"
        }
      },
      "organization": {
        "approval-policies": {
          "list": {
            "label": "सूची हेर्नुहोस्: Organization Approval Policies",
            "description": "तपाईंको अनुमत दायराभित्र Organization Approval Policies सञ्चालन गर्नुहोस्।"
          },
          "update": {
            "label": "अद्यावधिक गर्नुहोस्: Organization Approval Policies",
            "description": "तपाईंको अनुमत दायराभित्र Organization Approval Policies सञ्चालन गर्नुहोस्।"
          }
        },
        "permission-bundles": {
          "list": {
            "label": "सूची हेर्नुहोस्: Organization Permission Bundles",
            "description": "तपाईंको अनुमत दायराभित्र Organization Permission Bundles सञ्चालन गर्नुहोस्।"
          },
          "create": {
            "label": "सिर्जना गर्नुहोस्: Organization Permission Bundles",
            "description": "तपाईंको अनुमत दायराभित्र Organization Permission Bundles सञ्चालन गर्नुहोस्।"
          },
          "update": {
            "label": "अद्यावधिक गर्नुहोस्: Organization Permission Bundles",
            "description": "तपाईंको अनुमत दायराभित्र Organization Permission Bundles सञ्चालन गर्नुहोस्।"
          }
        },
        "retention-policies": {
          "read": {
            "label": "हेर्नुहोस्: Organization Retention Policies",
            "description": "तपाईंको अनुमत दायराभित्र Organization Retention Policies सञ्चालन गर्नुहोस्।"
          },
          "update": {
            "label": "अद्यावधिक गर्नुहोस्: Organization Retention Policies",
            "description": "तपाईंको अनुमत दायराभित्र Organization Retention Policies सञ्चालन गर्नुहोस्।"
          }
        },
        "export-policies": {
          "read": {
            "label": "हेर्नुहोस्: Organization Export Policies",
            "description": "तपाईंको अनुमत दायराभित्र Organization Export Policies सञ्चालन गर्नुहोस्।"
          },
          "update": {
            "label": "अद्यावधिक गर्नुहोस्: Organization Export Policies",
            "description": "तपाईंको अनुमत दायराभित्र Organization Export Policies सञ्चालन गर्नुहोस्।"
          }
        },
        "security-settings": {
          "read": {
            "label": "हेर्नुहोस्: Organization Security Settings",
            "description": "तपाईंको अनुमत दायराभित्र Organization Security Settings सञ्चालन गर्नुहोस्।"
          },
          "update": {
            "label": "अद्यावधिक गर्नुहोस्: Organization Security Settings",
            "description": "तपाईंको अनुमत दायराभित्र Organization Security Settings सञ्चालन गर्नुहोस्।"
          }
        },
        "jurisdiction-settings": {
          "read": {
            "label": "हेर्नुहोस्: Organization Jurisdiction Settings",
            "description": "तपाईंको अनुमत दायराभित्र Organization Jurisdiction Settings सञ्चालन गर्नुहोस्।"
          },
          "update": {
            "label": "अद्यावधिक गर्नुहोस्: Organization Jurisdiction Settings",
            "description": "तपाईंको अनुमत दायराभित्र Organization Jurisdiction Settings सञ्चालन गर्नुहोस्।"
          }
        },
        "support-access": {
          "read": {
            "label": "हेर्नुहोस्: Organization Support Access",
            "description": "तपाईंको अनुमत दायराभित्र Organization Support Access सञ्चालन गर्नुहोस्।"
          },
          "manage": {
            "label": "व्यवस्थापन गर्नुहोस्: Organization Support Access",
            "description": "तपाईंको अनुमत दायराभित्र Organization Support Access सञ्चालन गर्नुहोस्।"
          }
        }
      },
      "platform": {
        "security-posture": {
          "read": {
            "label": "हेर्नुहोस्: Platform Security Posture",
            "description": "तपाईंको अनुमत दायराभित्र Platform Security Posture सञ्चालन गर्नुहोस्।"
          }
        },
        "data-provider-health": {
          "read": {
            "label": "हेर्नुहोस्: Platform Data Provider Health",
            "description": "तपाईंको अनुमत दायराभित्र Platform Data Provider Health सञ्चालन गर्नुहोस्।"
          }
        },
        "maintenance-delegations": {
          "list": {
            "label": "सूची हेर्नुहोस्: Platform Maintenance Delegations",
            "description": "तपाईंको अनुमत दायराभित्र Platform Maintenance Delegations सञ्चालन गर्नुहोस्।"
          },
          "create": {
            "label": "सिर्जना गर्नुहोस्: Platform Maintenance Delegations",
            "description": "तपाईंको अनुमत दायराभित्र Platform Maintenance Delegations सञ्चालन गर्नुहोस्।"
          },
          "read": {
            "label": "हेर्नुहोस्: Platform Maintenance Delegations",
            "description": "तपाईंको अनुमत दायराभित्र Platform Maintenance Delegations सञ्चालन गर्नुहोस्।"
          },
          "approve": {
            "label": "स्वीकृत गर्नुहोस्: Platform Maintenance Delegations",
            "description": "तपाईंको अनुमत दायराभित्र Platform Maintenance Delegations सञ्चालन गर्नुहोस्।"
          },
          "revoke": {
            "label": "खारेज गर्नुहोस्: Platform Maintenance Delegations",
            "description": "तपाईंको अनुमत दायराभित्र Platform Maintenance Delegations सञ्चालन गर्नुहोस्।"
          }
        }
      }
    },
    "taxRules": {
      "list": {
        "label": "सूची हेर्नुहोस्: Organization Tax Rules",
        "description": "तपाईंको अनुमत दायराभित्र Organization Tax Rules सञ्चालन गर्नुहोस्।"
      },
      "read": {
        "label": "हेर्नुहोस्: Organization Tax Rules",
        "description": "तपाईंको अनुमत दायराभित्र Organization Tax Rules सञ्चालन गर्नुहोस्।"
      },
      "create-version": {
        "label": "सञ्चालन गर्नुहोस्: Organization Tax Rules",
        "description": "तपाईंको अनुमत दायराभित्र Organization Tax Rules सञ्चालन गर्नुहोस्।"
      },
      "submit": {
        "label": "पेश गर्नुहोस्: Organization Tax Rules",
        "description": "तपाईंको अनुमत दायराभित्र Organization Tax Rules सञ्चालन गर्नुहोस्।"
      },
      "approve": {
        "label": "स्वीकृत गर्नुहोस्: Organization Tax Rules",
        "description": "तपाईंको अनुमत दायराभित्र Organization Tax Rules सञ्चालन गर्नुहोस्।"
      },
      "suspend": {
        "label": "निलम्बन गर्नुहोस्: Organization Tax Rules",
        "description": "तपाईंको अनुमत दायराभित्र Organization Tax Rules सञ्चालन गर्नुहोस्।"
      },
      "retire": {
        "label": "अवकाश दिनुहोस्: Organization Tax Rules",
        "description": "तपाईंको अनुमत दायराभित्र Organization Tax Rules सञ्चालन गर्नुहोस्।"
      },
      "impact-analyze": {
        "label": "सञ्चालन गर्नुहोस्: Organization Tax Rules",
        "description": "तपाईंको अनुमत दायराभित्र Organization Tax Rules सञ्चालन गर्नुहोस्।"
      }
    },
    "settlement": {
      "instructions": {
        "list": {
          "label": "सेटलमेन्ट निर्देशनहरू सूचीबद्ध गर्नुहोस्",
          "description": "अधिकृत संगठन दायराभित्रका सेटलमेन्ट निर्देशनहरू सूचीबद्ध गर्नुहोस्।"
        },
        "get": {
          "label": "सेटलमेन्ट निर्देशन हेर्नुहोस्",
          "description": "एउटा सेटलमेन्ट निर्देशन र यसको हालको जीवनचक्र स्थिति हेर्नुहोस्।"
        },
        "create": {
          "label": "सेटलमेन्ट निर्देशन सिर्जना गर्नुहोस्",
          "description": "अधिकृत कारोबार वा दायित्वका लागि सेटलमेन्ट निर्देशन सिर्जना गर्नुहोस्।"
        },
        "confirm": {
          "label": "सेटलमेन्ट निर्देशन पुष्टि गर्नुहोस्",
          "description": "आवश्यक आश्वासन नियन्त्रणअन्तर्गत योग्य सेटलमेन्ट निर्देशन पुष्टि गर्नुहोस्।"
        },
        "correct": {
          "label": "सेटलमेन्ट निर्देशन सच्याउनुहोस्",
          "description": "अडिट इतिहास सुरक्षित राख्दै योग्य सेटलमेन्ट निर्देशन सच्याउनुहोस्।"
        },
        "cancel": {
          "label": "सेटलमेन्ट निर्देशन रद्द गर्नुहोस्",
          "description": "समापनअघि योग्य सेटलमेन्ट निर्देशन रद्द गर्नुहोस्।"
        },
        "availability": {
          "label": "सेटलमेन्ट उपलब्धता जाँच गर्नुहोस्",
          "description": "अधिकृत दायराका लागि सेटलमेन्ट कार्यहरू हाल उपलब्ध छन् कि छैनन् मूल्याङ्कन गर्नुहोस्।"
        }
      },
      "failures": {
        "list": {
          "label": "सेटलमेन्ट असफलताहरू सूचीबद्ध गर्नुहोस्",
          "description": "सञ्चालनात्मक ध्यान आवश्यक पर्ने असफल सेटलमेन्ट निर्देशनहरू सूचीबद्ध गर्नुहोस्।"
        }
      }
    }
  },
  "hub": {
    "data": {
      "title": "डाटा",
      "description": "निवेश, संदर्भ और संचालन डेटा प्रबंधित और समीक्षा गर्नुहोस्।",
      "reference": {
        "title": "संदर्भ डेटा"
      },
      "operational": {
        "title": "संचालन डेटा"
      },
      "exceptions": {
        "title": "अपवादहरू"
      },
      "facts": {
        "title": "तथ्य"
      },
      "market": {
        "title": "बजार डेटा"
      },
      "portfolio": {
        "title": "पोर्टफोलियो"
      },
      "settlement": {
        "title": "फर्छ्यौट"
      },
      "accounting": {
        "title": "लेखा"
      },
      "compliance": {
        "title": "अनुपालन"
      },
      "tax": {
        "title": "कर"
      },
      "documents": {
        "title": "कागजातहरू"
      }
    },
    "admin": {
      "title": "प्रशासन",
      "description": "संगठन, पहुंच और निगरानी प्रबंधन.",
      "core": {
        "title": "मूल संचालन प्रशासन"
      },
      "platform": {
        "title": "प्लेटफर्म प्रशासन",
        "description": "प्लेटफर्म संगठन, मोड्युल, सहायता पहुँच, स्वास्थ्य र प्लेटफर्म-व्यापी सुशासन व्यवस्थापन गर्नुहोस्।"
      },
      "organization": {
        "title": "संगठन प्रशासन",
        "description": "यस संगठनको प्रोफाइल, प्रयोगकर्ता, भूमिका, ग्राहक, पोर्टफोलियो, मोड्युल र अडिट गतिविधि व्यवस्थापन गर्नुहोस्।"
      },
      "setupHistory": {
        "title": "सेटअप इतिहास"
      },
      "organizationSetup": {
        "title": "संस्था",
        "description": "संस्थाको विवरण, शाखा र सक्षम पोर्टफोलियो क्षमताहरू व्यवस्थापन गर्नुहोस्।"
      },
      "peopleAccess": {
        "title": "प्रयोगकर्ता र पहुँच",
        "description": "प्रयोगकर्ता, भूमिका, जिम्मेवारी र सञ्चालन पहुँच व्यवस्थापन गर्नुहोस्।"
      },
      "clientPortfolio": {
        "title": "ग्राहक र पोर्टफोलियो सेटअप",
        "description": "ग्राहक दर्ता, खाता र पोर्टफोलियो कन्फिगरेसन तथा सेटलमेन्ट निर्देशन व्यवस्थापन गर्नुहोस्।"
      },
      "referenceData": {
        "title": "लगानी सन्दर्भ डेटा",
        "description": "पोर्टफोलियो सञ्चालनमा प्रयोग हुने उपकरण र सन्दर्भ कन्फिगरेसन व्यवस्थापन गर्नुहोस्।"
      },
      "assurance": {
        "title": "आश्वासन",
        "description": "अडिट प्रमाण समीक्षा गर्नुहोस् र प्रभावकारी पहुँच निर्णय बुझ्नुहोस्।"
      }
    }
  },
  "dataHub": {
    "description": "डेटा हब"
  },
  "page": {
    "users": {
      "title": "प्रयोगकर्ताहरू",
      "description": "प्रयोगकर्ताहरू को प्रबंधित गर्नुहोस् और भूमिका नियुक्ति करने की अनुमति दें।",
      "createTitle": "संस्थापक व्यक्ति बनाउनुहोस्",
      "editTitle": "व्यक्ति परिमार्जन गर्नुहोस्"
    },
    "roles": {
      "title": "भूमिकाहरू",
      "description": "अनुकूल्यizable भूमिकाओं और अनुमति क्षेत्रों को परिभाषित गर्नुहोस्।",
      "createTitle": "भूमिका बनाउनुहोस्",
      "editTitle": "भूमिका परिमार्जन गर्नुहोस्"
    },
    "organization": {
      "title": "संस्था",
      "description": "संगठन सेटिङहरू प्रबंधित गर्नुहोस्।",
      "detail": {
        "title": "संगठन विवरण"
      },
      "createTitle": "संगठन सिर्जना गर्नुहोस्",
      "editTitle": "संगठन सम्पादन गर्नुहोस्"
    },
    "organizationGovernance": {
      "title": "शासन तथा नीति नियन्त्रण",
      "description": "सक्रिय संस्थाका संस्करणयुक्त लेखा, अनुपालन, ग्राहक, गोपनीयता, एकीकरण, मौद्रिक स्वीकृति तथा जोखिम नियन्त्रण सञ्चालन गर्नुहोस्।"
    },
    "organizationUsers": {
      "title": "संगठन प्रयोगकर्ताहरू",
      "description": "यस संगठनका प्रयोगकर्ता, स्थिति र भूमिका व्यवस्थापन गर्नुहोस्।",
      "editTitle": "प्रयोगकर्ता सम्पादन गर्नुहोस्"
    },
    "organizationRoles": {
      "title": "संगठन भूमिकाहरू",
      "description": "यस संगठनका भूमिका र अनुमति सीमा व्यवस्थापन गर्नुहोस्।",
      "editTitle": "भूमिका सम्पादन गर्नुहोस्"
    },
    "organizationAudit": {
      "title": "संगठन अडिट",
      "description": "संगठन-सीमित परिवर्तन र अडिट घटनाहरू समीक्षा गर्नुहोस्।"
    },
    "openingCutover": {
      "title": "खोलिने कटओभर",
      "description": "पोर्टफोलियो बयान र शुरूवात स्थिति को लागि शुरूवात दिनांक सेट गर्नुहोस्।"
    },
    "openingCutoverHistory": {
      "title": "खोलिने कटओभर इतिहास",
      "description": "स्वीकृत र सम्पन्न खोलिने कटओभर ब्याचहरू समीक्षा गर्नुहोस्।"
    },
    "taxRules": {
      "title": "कर नियमहरू",
      "description": "कर नियमहरू र प्रभावी मिति संस्करण को प्रबंधित गर्नुहोस्।"
    },
    "audit": {
      "title": "अडिट एक्सप्लोरर",
      "description": "विवरण घटनाओं और परिवर्तनों को समीक्षा गर्नुहोस्।",
      "detailTitle": "अडिट विवरण"
    },
    "instruments": {
      "title": "उपकरणहरू",
      "description": "निवेश और सिक्योरिटी प्रबंधित गर्नुहोस्।",
      "detail": {
        "title": "निवेश विवरण"
      }
    },
    "imports": {
      "title": "आयात",
      "description": "डेटा आयात लोड गर्नुहोस् और समीक्षा गर्नुहोस्।",
      "detail": {
        "title": "आयात कार्य विवरण"
      },
      "rows": {
        "title": "आयात कार्य रेखहरू"
      }
    },
    "reconciliation": {
      "title": "मेलमिलाप",
      "description": "डेटा अपेक्षाओं को मिलान गर्नुहोस्।",
      "detail": {
        "title": "संतुलन पुनर्प्राप्ति विवरण"
      }
    },
    "corporateActions": {
      "title": "कर्पोरेट कार्यहरू",
      "description": "विभिन्न घटनाएँ, जैसे बोनस और विभाजन।",
      "detail": {
        "title": "कॉर्पोरेट कार्रवाई विवरण"
      }
    },
    "holdings": {
      "title": "हालका होल्डिङहरु",
      "description": "प्रति साधन समग्र परिमाण, लागत आधार, र बजार मूल्य — पोस्ट गरिएका कारोबार र प्रारम्भिक मौजदाबीबाट प्राप्त।"
    },
    "factBatches": {
      "title": "वास्तविक पैकेज",
      "description": "वास्तविक पैकेज प्रबंधित गर्नुहोस्।",
      "detail": {
        "title": "बन्दूक की विवरण"
      }
    },
    "transactions": {
      "title": "कारोबारहरू"
    },
    "reports": {
      "title": "रिपोर्टहरू"
    },
    "platformAccessInspector": {
      "title": "प्लेटफ़ॉर्म एक्सेस इंस्पेक्टर",
      "description": "कुनै पनि प्रयोगकर्ताको प्रभावकारी प्लेटफरम-व्यापी पहुँच निरीक्षण गर्नुहोस्।"
    },
    "organizationAccessInspector": {
      "title": "संगठन एक्सेस इंस्पेक्टर",
      "identity": "पहिचान सन्दर्भ",
      "delegation": "प्रतिनिधि पहुँच",
      "permissions": "अनुमतिहरू",
      "modules": "सक्रिय मोड्युलहरू",
      "accounts": "खाता दायरा",
      "policy": "पर्सोना नीति",
      "subject": "विषय प्रयोगकर्ता",
      "description": "संगठन प्रयोगकर्ताहरूको प्रभावकारी पहुँच निरीक्षण गर्नुहोस्।"
    },
    "moduleAssignments": {
      "title": "मोड्यूल",
      "description": "तपाईंको संगठनका मोड्यूल सक्षम, अक्षम र कन्फिगर गर्नुहोस्।",
      "createTitle": "मोड्यूल सक्षम गर्नुहोस्",
      "editTitle": "मोड्यूल असाइनमेन्ट कन्फिगर गर्नुहोस्"
    },
    "clients": {
      "title": "ग्राहक",
      "description": "ग्राहक प्रोफाइल र स्थिति व्यवस्थापन गर्नुहोस्।",
      "createTitle": "ग्राहक सिर्जना गर्नुहोस्",
      "editTitle": "ग्राहक सम्पादन गर्नुहोस्",
      "detailTitle": "ग्राहक विवरण"
    },
    "clientAccounts": {
      "title": "खाता",
      "description": "ग्राहक खाता र यसको कन्फिगरेसन व्यवस्थापन गर्नुहोस्।",
      "createTitle": "ग्राहक खाता सिर्जना गर्नुहोस्",
      "editTitle": "ग्राहक खाता सम्पादन गर्नुहोस्",
      "detailTitle": "ग्राहक खाता विवरण"
    },
    "portfolios": {
      "title": "पोर्टफोलियोहरू",
      "description": "तपाईंको संगठनका पोर्टफोलियो खाता व्यवस्थापन गर्नुहोस्।",
      "createTitle": "पोर्टफोलियो सिर्जना गर्नुहोस्",
      "editTitle": "पोर्टफोलियो सम्पादन गर्नुहोस्",
      "detailTitle": "पोर्टफोलियो विवरण"
    },
    "permissionAssignments": {
      "title": "अनुमति",
      "description": "भूमिका",
      "editTitle": "अनुमति असाइनमेन्ट सम्पादन गर्नुहोस्"
    },
    "platformOrganizations": {
      "title": "प्लेटफर्म संगठनहरू",
      "detail": {
        "title": "प्लेटफर्म संगठन विवरण"
      },
      "description": "प्लेटफर्म संगठनहरूको विवरण"
    },
    "platformModules": {
      "title": "प्लेटफर्म मोड्युलहरू",
      "description": "प्लेटफर्म मोड्युलहरूको विवरण"
    },
    "platformUsers": {
      "title": "प्लेटफर्म प्रयोगकर्ताहरू",
      "createTitle": "प्लेटफर्म प्रयोगकर्ता सिर्जना गर्नुहोस्",
      "editTitle": "प्लेटफर्म प्रयोगकर्ता सम्पादन गर्नुहोस्",
      "description": "प्लेटफर्म प्रयोगकर्ताहरूको विवरण"
    },
    "platformHealth": {
      "title": "प्लेटफर्म स्वास्थ्य",
      "description": "प्लेटफर्म स्वास्थ्यको विवरण"
    },
    "platformSupportDelegations": {
      "title": "मर्मतसम्भार प्रतिनिधित्व",
      "description": "स्वीकृत प्लेटफर्म सहयोग प्रयोगकर्तालाई कडाइका साथ सीमित र समयबद्ध मर्मत पहुँच दिनुहोस्।",
      "createTitle": "मर्मत प्रतिनिधित्व सिर्जना गर्नुहोस्",
      "detailTitle": "मर्मत प्रतिनिधित्व विवरण"
    },
    "platformAudit": {
      "title": "प्लेटफर्म अनुगमन",
      "description": "प्लेटफर्म अनुगमनको विवरण"
    },
    "organizationPermissionAssignments": {
      "title": "संगठन अनुमति तोकिएका"
    },
    "securityPosture": {
      "title": "सुरक्षा स्थिति",
      "description": "प्लेटफर्म सुरक्षा स्थिति र पहुँच नियन्त्रण कन्फिगरेसन अनुगमन गर्नुहोस्।"
    },
    "dataProviderHealth": {
      "title": "डेटा प्रदायक स्वास्थ्य",
      "description": "बजार डेटा प्रदायकहरूको स्वास्थ्य र कनेक्टिभिटी अनुगमन गर्नुहोस्।"
    },
    "maintenanceDelegations": {
      "title": "मर्मत प्रतिनिधित्व",
      "description": "समय-सीमित मर्मत पहुँच प्रतिनिधित्व अनुदानहरू व्यवस्थापन गर्नुहोस्।"
    },
    "permissionBundles": {
      "title": "अनुमति बण्डलहरू",
      "description": "भूमिका असाइनमेन्टका लागि पुनः प्रयोग योग्य अनुमति सेटहरू परिभाषित र व्यवस्थापन गर्नुहोस्।"
    },
    "approvalPolicies": {
      "title": "स्वीकृति नीतिहरू",
      "description": "वित्तीय सञ्चालनका लागि बहु-स्तरीय स्वीकृति कार्यप्रवाह कन्फिगर गर्नुहोस्।"
    },
    "supportAccess": {
      "title": "समर्थन पहुँच",
      "description": "संस्था डेटामा समर्थन टोली पहुँच अनुदानहरू व्यवस्थापन गर्नुहोस्।"
    },
    "retentionPolicies": {
      "title": "रिटेन्सन नीतिहरू",
      "description": "संस्थाका लागि डेटा रिटेन्सन र संग्रहण तालिकाहरू कन्फिगर गर्नुहोस्।"
    },
    "exportPolicies": {
      "title": "निर्यात नीतिहरू",
      "description": "अधिकृत डेटा निर्यात नियम र डेलिभरी च्यानलहरू व्यवस्थापन गर्नुहोस्।"
    },
    "securitySettings": {
      "title": "सुरक्षा सेटिङहरू",
      "description": "संस्था-स्तरीय सुरक्षा नीतिहरू र MFA आवश्यकताहरू कन्फिगर गर्नुहोस्।"
    },
    "regulatoryProfile": {
      "title": "नियामक प्रोफाइल",
      "description": "संस्थाको नियामक वर्गीकरण र क्षेत्राधिकार सेटिङहरू व्यवस्थापन गर्नुहोस्।"
    },
    "jurisdictionSettings": {
      "title": "क्षेत्राधिकार सेटिङहरू",
      "description": "संस्थाका लागि लागू क्षेत्राधिकारहरू र नियामक ढाँचाहरू कन्फिगर गर्नुहोस्।"
    },
    "branches": {
      "title": "शाखाहरू",
      "description": "तपाईंको संगठनका शाखाहरू व्यवस्थापन गर्नुहोस्।",
      "createTitle": "शाखा सिर्जना गर्नुहोस्",
      "editTitle": "शाखा सम्पादन गर्नुहोस्",
      "detailTitle": "शाखा विवरण"
    },
    "reportDetail": {
      "title": "रिपोर्ट विवरण",
      "description": "कन्फिगर योग्य प्यारामिटरहरूसँग विस्तृत रिपोर्ट डाटा हेर्नुहोस्।"
    },
    "feeRules": {
      "title": "शुल्क नियमहरू",
      "description": "प्रभावकारी शुल्क नियमहरू समीक्षा र व्यवस्थापन गर्नुहोस्।"
    },
    "fiscalYears": {
      "title": "आर्थिक वर्षहरू",
      "description": "आर्थिक वर्षहरू र लेखांकन अवधिहरू सिर्जना र व्यवस्थापन गर्नुहोस्।",
      "createTitle": "आर्थिक वर्ष सिर्जना गर्नुहोस्",
      "detail": {
        "title": "आर्थिक वर्ष"
      },
      "periods": {
        "title": "आर्थिक अवधिहरू"
      }
    },
    "marketPrices": {
      "detail": {
        "title": "बजार डाटा विवरण"
      }
    }
  },
  "card": {
    "organizationGovernance": "शासन तथा नीति नियन्त्रण",
    "instruments": {
      "title": "उपकरणहरू",
      "description": "निवेश और सिक्योरिटीज़ प्रबंधन गर्नुहोस्."
    },
    "transactions": {
      "title": "कारोबारहरू",
      "description": "व्यापार प्रबंधन."
    },
    "transactionApprovals": {
      "title": "अनुमोदनहरू",
      "description": "अप्रत्यक्ष व्यापारों को मान्यता दें।"
    },
    "transactionReversals": {
      "title": "पोस्ट गरिएका व्यापारों को वापस लें",
      "description": "पोस्ट गरिएका व्यापारों को वापस लें।"
    },
    "imports": {
      "title": "आवश्यक प्रमाण अपलोड गर्नुहोस्",
      "description": "आवश्यक प्रमाण अपलोड और समीक्षा गर्नुहोस्।"
    },
    "corporateActions": {
      "title": "कर्पोरेट कार्यहरू",
      "description": "डिविडेंड, बोनस, और अन्य घटनाएँ."
    },
    "holdings": {
      "title": "हालका होल्डिङहरु",
      "description": "प्रति साधन समग्र परिमाण, लागत आधार, र बजार मूल्य — पोस्ट गरिएका कारोबार र प्रारम्भिक मौजदाबीबाट प्राप्त।"
    },
    "reconciliation": {
      "title": "मेलमिलाप",
      "description": "अनियमितताओं को मिलान गर्नुहोस्।"
    },
    "factBatches": {
      "title": "बन्दूक के बैच",
      "description": "बन्दूक के बैच प्रबंधन गर्नुहोस्।"
    },
    "moduleAssignments": "मोड्यूल असाइनमेन्टहरु",
    "clients": "ग्राहकहरु",
    "clientAccounts": "ग्राहक खाताहरु",
    "portfolios": "पोर्टफोलियोहरु",
    "permissionAssignments": "अनुमति असाइनमेन्टहरु",
    "platformUsers": "प्लेटफर्म प्रयोगकर्ताहरु",
    "platformModules": "प्लेटफर्म मोड्युलहरू",
    "platformAudit": "प्लेटफर्म अडिट",
    "platformHealth": "प्लेटफर्म स्वास्थ्य",
    "platformSupportDelegations": "प्लेटफर्म समर्थन प्रतिनिधित्व",
    "marketPrices": {
      "title": "बजार मूल्य र मूल्याङ्कन",
      "description": "दैनिक OHLCV बजार अवलोकन र पोर्टफोलियो मूल्याङ्कनमा प्रयोग हुने आधिकारिक मूल्यहरू समीक्षा गर्नुहोस्।"
    },
    "fxRates": {
      "title": "विदेशी मुद्रा दरहरू",
      "description": "विदेशी मुद्रा विनिमय दरहरू हेर्नुहोस् र व्यवस्थापन गर्नुहोस्।"
    },
    "benchmarks": {
      "title": "बेन्चमार्कहरू",
      "description": "कार्यसम्पादन बेन्चमार्कहरू हेर्नुहोस् र व्यवस्थापन गर्नुहोस्।"
    },
    "marketDataProviders": {
      "title": "बजार डेटा प्रदायकहरू",
      "description": "बजार डेटा प्रदायक जडानहरू कन्फिगर र अनुगमन गर्नुहोस्।"
    },
    "marketDataExceptions": {
      "title": "बजार डेटा अपवादहरू",
      "description": "बजार डेटा गुणस्तर अपवादहरू समीक्षा र समाधान गर्नुहोस्।"
    },
    "clientsData": {
      "title": "ग्राहकहरू",
      "description": "ग्राहक डेटा हेर्नुहोस् र व्यवस्थापन गर्नुहोस्।"
    },
    "portfoliosData": {
      "title": "पोर्टफोलियोहरू",
      "description": "पोर्टफोलियो डेटा हेर्नुहोस् र व्यवस्थापन गर्नुहोस्।"
    },
    "mandates": {
      "title": "अनिवार्यहरू",
      "description": "लगानी अनिवार्यहरू हेर्नुहोस् र व्यवस्थापन गर्नुहोस्।"
    },
    "positions": {
      "title": "स्थितिहरू",
      "description": "उपकरण र खाता अनुसार एकत्रित हालको पोर्टफोलियो स्थितिहरू, परिमाण, लागत, र बजार मूल्य देखाउँदै। स्थितिहरू उही होल्डिङ डाटाको पोर्टफोलियो-व्यवस्थापन दृश्य हुन्।"
    },
    "cash": {
      "title": "नगद",
      "description": "ग्राहक खाता र पोर्टफोलियोमा नगद मौज्दात र आवागमन, जमानत, निकासी, शुल्क, र ब्याज सहित।"
    },
    "performance": {
      "title": "कार्यसम्पादन",
      "description": "पोर्टफोलियो कार्यसम्पादन मेट्रिक्स र एट्रिब्युसन हेर्नुहोस्।"
    },
    "compliance": {
      "title": "अनुपालन",
      "description": "अनुपालन स्थिति र उल्लङ्घनहरू हेर्नुहोस्।"
    },
    "journals": {
      "title": "जर्नलहरू",
      "description": "लेखा जर्नल र प्रविष्टिहरू हेर्नुहोस्।"
    },
    "chartOfAccounts": {
      "title": "खाताको तालिका",
      "description": "खाताको तालिका हेर्नुहोस् र व्यवस्थापन गर्नुहोस्।"
    },
    "fiscalPeriods": {
      "title": "वित्तीय अवधिहरू",
      "description": "वित्तीय वर्ष र अवधिहरू व्यवस्थापन गर्नुहोस्।"
    },
    "complianceBreaches": {
      "title": "अनुपालन उल्लङ्घनहरू",
      "description": "लगानी अनुपालन उल्लङ्घनहरू समीक्षा र व्यवस्थापन गर्नुहोस्।"
    },
    "riskExposures": {
      "title": "जोखिम एक्सपोजरहरू",
      "description": "पोर्टफोलियो जोखिम एक्सपोजर विश्लेषण हेर्नुहोस्।"
    },
    "taxRecords": {
      "title": "कर रेकर्डहरू",
      "description": "कर रेकर्ड र गणनाहरू हेर्नुहोस् र व्यवस्थापन गर्नुहोस्।"
    },
    "settlementInstructions": {
      "title": "फर्छ्यौट निर्देशनहरू",
      "description": "धितोपत्र फर्छ्यौट निर्देशनहरू हेर्नुहोस् र व्यवस्थापन गर्नुहोस्।"
    },
    "positionTransfers": {
      "title": "स्थिति स्थानान्तरणहरू",
      "description": "एउटै ग्राहकका योग्य पोर्टफोलियोहरूबीच वस्तुरूपमा स्थानान्तरण अनुरोध र नियन्त्रण गर्नुहोस्।",
      "empty": "कुनै स्थिति स्थानान्तरण भेटिएन।",
      "saved": "स्थिति स्थानान्तरण अद्यावधिक गरियो।",
      "requestFailed": "स्थिति स्थानान्तरण अनुरोध पूरा हुन सकेन।",
      "requestEligibilityFailed": "योग्य गन्तव्य पोर्टफोलियो र लटहरू लोड हुन सकेनन्।",
      "allocations": "लट विनियोजनहरू",
      "eligibility": "स्थिति: {{status}}। नगद: {{cash}}; निष्कासन: {{disposal}}; कर: {{tax}}; कृत्रिम नाफा: {{artificialGain}}।",
      "columns": {
        "reference": "सन्दर्भ",
        "instrument": "साधन",
        "status": "स्थिति",
        "source": "स्रोत पोर्टफोलियो",
        "destination": "गन्तव्य पोर्टफोलियो",
        "lots": "लटहरू",
        "actions": "कार्यहरू"
      },
      "fields": {
        "sourcePortfolioAccountId": "स्रोत पोर्टफोलियो आईडी",
        "destinationPortfolioAccountId": "गन्तव्य पोर्टफोलियो आईडी",
        "businessReference": "व्यावसायिक सन्दर्भ",
        "instrumentSymbol": "साधन संकेत",
        "reason": "कारण",
        "sourceLotId": "स्रोत लट आईडी",
        "quantity": "मात्रा",
        "workflowKind": "कार्यप्रवाह प्रकार",
        "id": "स्थानान्तरण आईडी",
        "expectedVersion": "अपेक्षित संस्करण",
        "allocationPlan": "लट विनियोजन योजना"
      },
      "actions": {
        "request": "स्थानान्तरण अनुरोध गर्नुहोस्",
        "approve": "स्वीकृत गर्नुहोस्",
        "execute": "कार्यान्वयन गर्नुहोस्",
        "cancel": "रद्द गर्नुहोस्",
        "reverse": "उल्ट्याउनुहोस्",
        "details": "विवरण",
        "addAllocation": "लट थप्नुहोस्",
        "removeAllocation": "लट हटाउनुहोस्"
      },
      "statuses": {
        "REQUESTED": "अनुरोध गरिएको",
        "APPROVED": "स्वीकृत",
        "EXECUTED": "कार्यान्वयन गरिएको",
        "CANCELLED": "रद्द गरिएको",
        "REVERSED": "उल्ट्याइएको"
      }
    },
    "managementFees": {
      "title": "व्यवस्थापन शुल्क",
      "description": "योग्य व्यवस्थित पोर्टफोलियो र नियन्त्रित शुल्क गणनाहरू समीक्षा गर्नुहोस्।",
      "portfolio": "पोर्टफोलियो",
      "period": "सेवा अवधि",
      "calculate": "गणना गर्नुहोस्",
      "reason": "कारण",
      "approve": "स्वीकृत गर्नुहोस्",
      "waive": "माफ गर्नुहोस्",
      "invoice": "बिजक जारी गर्नुहोस्",
      "pay": "भुक्तानी रेकर्ड गर्नुहोस्",
      "credit": "क्रेडिट",
      "reverse": "उल्ट्याउनुहोस्",
      "updated": "व्यवस्थापन शुल्क अद्यावधिक गरियो।",
      "requestFailed": "व्यवस्थापन शुल्क अनुरोध पूरा हुन सकेन।",
      "calculationPanel": "गणना",
      "selectPortfolioFirst": "पहिले पोर्टफोलियो छान्नुहोस्",
      "reasonHelper": "शुल्क कार्यको कारण",
      "accrualsTitle": "सञ्चित शुल्कहरू",
      "noAccruals": "कुनै सञ्चित शुल्क छैन",
      "noAccrualsDescription": "देखाउन कुनै सञ्चित शुल्क छैन।",
      "invoices": "बिजकहरू"
    },
    "performanceFees": {
      "title": "कार्यसम्पादन शुल्क",
      "description": "अन्तिम पोर्टफोलियो मूल्याङ्कन र नियन्त्रित बाह्य नगद प्रवाहबाट मात्र शुल्क गणना गर्नुहोस्।",
      "portfolio": "पोर्टफोलियो",
      "period": "क्रिस्टलाइजेसन अवधि",
      "calculate": "गणना गर्नुहोस्",
      "approve": "स्वीकृत गर्नुहोस्",
      "crystallize": "क्रिस्टलाइज गर्नुहोस्",
      "updated": "कार्यसम्पादन शुल्क अद्यावधिक गरियो।",
      "requestFailed": "कार्यसम्पादन शुल्क अनुरोध पूरा हुन सकेन।",
      "calculationPanel": "गणना",
      "periodStart": "अवधि सुरु",
      "periodEnd": "अवधि अन्त्य",
      "calculationsTitle": "गणनाहरू",
      "noCalculations": "कुनै गणना छैन",
      "noCalculationsDescription": "देखाउन कुनै गणना छैन।"
    },
    "settlement": {
      "title": "फर्छ्यौट निर्देशनहरू",
      "failuresTitle": "फर्छ्यौट असफलताहरू",
      "description": "आधारभूत कारोबार पोस्ट नगरी बाह्य फर्छ्यौट प्रगति ट्र्याक गर्नुहोस्।",
      "empty": "कुनै फर्छ्यौट निर्देशन भेटिएन।",
      "saved": "फर्छ्यौट निर्देशन अद्यावधिक गरियो।",
      "requestFailed": "फर्छ्यौट अनुरोध पूरा हुन सकेन।",
      "availability": "बाँकी मात्रा: {{unsettledQuantity}}; बाँकी नगद: {{unsettledCash}}।",
      "columns": {
        "status": "स्थिति",
        "transactionId": "कारोबार",
        "expectedQuantity": "अपेक्षित मात्रा",
        "settledQuantity": "फर्छ्यौट मात्रा",
        "expectedCash": "अपेक्षित नगद",
        "settledCash": "फर्छ्यौट नगद",
        "currency": "मुद्रा",
        "expectedDate": "अपेक्षित मिति",
        "externalReference": "बाह्य सन्दर्भ",
        "failureReason": "असफलता कारण",
        "actions": "कार्यहरू"
      },
      "fields": {
        "transactionId": "कारोबार आईडी",
        "expectedQuantity": "अपेक्षित मात्रा",
        "expectedCash": "अपेक्षित नगद",
        "expectedDate": "अपेक्षित मिति",
        "externalMessageId": "बाह्य सन्देश आईडी",
        "sequence": "क्रम",
        "quantity": "मात्रा",
        "cash": "नगद",
        "status": "स्थिति",
        "reason": "कारण",
        "workflowKind": "कार्यप्रवाह"
      },
      "actions": {
        "create": "निर्देशन सिर्जना गर्नुहोस्",
        "confirm": "पुष्टि गर्नुहोस्",
        "correct": "सच्याउनुहोस्",
        "cancel": "रद्द गर्नुहोस्",
        "availability": "उपलब्धता"
      },
      "statuses": {
        "PENDING": "बाँकी",
        "PARTIALLY_SETTLED": "आंशिक फर्छ्यौट",
        "SETTLED": "फर्छ्यौट",
        "FAILED": "असफल",
        "CANCELLED": "रद्द",
        "CORRECTED": "सच्याइएको"
      }
    },
    "custodyBalances": {
      "title": "संरक्षण मौज्दातहरू",
      "description": "संरक्षण खाता मौज्दात र स्थितिहरू हेर्नुहोस्।"
    },
    "evidence": {
      "title": "प्रमाणहरू",
      "description": "वित्तीय घटनाहरूका लागि सहायक प्रमाणहरू हेर्नुहोस् र व्यवस्थापन गर्नुहोस्।"
    },
    "branches": "शाखाहरू",
    "fiscalCalendar": {
      "title": "आर्थिक पात्रो",
      "description": "आर्थिक वर्षहरू, अवधिहरू, र लेखांकन पात्रो व्यवस्थापन गर्नुहोस्।"
    },
    "fiscalYears": {
      "title": "आर्थिक वर्षहरू",
      "description": "आर्थिक वर्षहरू र तिनीहरूको अवधिहरू सिर्जना र व्यवस्थापन गर्नुहोस्।"
    }
  },
  "corporateAction": {
    "process": {
      "success": "कॉर्पोरेट कार्रवाई सफलतापूर्वक प्रक्रिया हुई"
    }
  },
  "col": {
    "rowData": "सेरी डेटा",
    "approvedAt": "अनुमोदन मिति",
    "approvedBy": "अनुमोदनकर्ता",
    "journalEntryId": "जरनल प्रवेश आईडी",
    "manifestHash": "म्यानिफेस्ट ह्यास",
    "previewedBy": "पूर्वावलोकनकर्ता",
    "reversalReason": "उल्टाउनने कारण",
    "recoveryQueue": "पुनःप्राप्ति पङ्क्ति",
    "reversedAt": "उल्टाइएकको मिति",
    "reversedBy": "उल्टाउने",
    "supersededByBatchId": "पछिल्लो ब्याच आईडी ले प्रतिस्थापित",
    "supersedesBatchId": "विगत ब्याच आईडी",
    "totalLines": "कुल पंक्तिहरू",
    "errors": "त्रुटिहरू (विस्तृतहरूको लागि कन्सोल हेर्नुहोस्)",
    "warnings": "चेतावनियाँ",
    "importType": "आवश्यक प्रकार",
    "sourceFileName": "मूल स्त्रोत फ़ाइल",
    "symbol": "प्रतीक",
    "name": "नाम",
    "firstName": "पहिलो नाम",
    "lastName": "थर",
    "isin": "आइएसआईएन",
    "assetType": "वस्तु प्रकार",
    "runId": "रन आईडी",
    "businessReference": "व्यावसायिक सन्दर्भ",
    "sourcePortfolioAccountId": "स्रोत पोर्टफोलियो",
    "destinationPortfolioAccountId": "गन्तव्य पोर्टफोलियो",
    "transactionId": "कारोबार आईडी",
    "expectedQuantity": "अपेक्षित परिमाण",
    "settledQuantity": "फर्छ्यौट भएको परिमाण",
    "expectedCash": "अपेक्षित नगद",
    "settledCash": "फर्छ्यौट भएको नगद",
    "expectedDate": "अपेक्षित मिति",
    "failureReason": "असफलताको कारण",
    "reason": "कारण",
    "status": "स्थिति",
    "startedAt": "शुरू गरिएको समय",
    "completedAt": "पूरा गरिएको समय",
    "id": "आईडी",
    "type": "प्रकार",
    "date": "मिति",
    "email": "इमेल",
    "mfa": "एमएफए",
    "roles": "भूमिकाहरू",
    "orgTenant": "संगठन / शाखा",
    "userType": "व्यक्ति प्रकार",
    "system": "प्रणाली",
    "quantity": "मात्रा",
    "avgCost": "औसत लागत",
    "marketPrice": "बाजार मूल्य",
    "marketValue": "बाजार मूल्य",
    "valuation": "मूल्यांकन",
    "valuationAsOf": "मूल्यांकन मिति",
    "unrealizedPnl": "अनरियलाइज्ड P&L",
    "unrealizedGainLoss": "अवास्तविक लाभ/हानि",
    "lots": "लटहरू",
    "change": "परिवर्तन",
    "reportId": "रिपोर्ट आईडी",
    "reportDefinitionId": "रिपोर्ट परिभाषा आईडी",
    "reportingPeriodStart": "कालावधि शुरू होने का समय",
    "reportingPeriodEnd": "कालावधि समाप्त होने का समय",
    "createdAt": " बनाया गया समय",
    "updatedAt": "अद्यावधिक मिति",
    "currentBalance": "हालको मौज्दात",
    "sourceBatchId": "स्रोत ब्याच आईडी",
    "price": "मूल्य",
    "grossAmount": "कुल कारोबार रकम",
    "instrument": "उपकरण",
    "actionType": "कार्रवाई प्रकार",
    "currency": "मुद्रा",
    "clientCode": "ग्राहक कोड",
    "clientName": "ग्राहक नाम",
    "marketValueCurrency": "बाजार मूल्य मुद्रा",
    "sourceState": "स्रोत स्थिति",
    "valuationFreshness": "मूल्यांकन ताजगी",
    "valuationSource": "मूल्यांकन स्रोत",
    "difference": "अन्तर",
    "displayName": "नाम",
    "errorCount": "त्रुटिहरू (विस्तृतहरूको लागि कन्सोल हेर्नुहोस्)",
    "exDate": "पूर्व-तिथि",
    "exchange": "विनिमय",
    "generatedAt": "निर्मित तिथि",
    "instrumentSymbol": "साधन का प्रतीक",
    "isSystem": "प्रणाली",
    "matchedRecords": "मेल खाने हुने",
    "mfaEnabled": "MFA सक्षम",
    "payDate": "भुगतान तिथि",
    "pricePerUnit": "मूल्य/युनिट",
    "recordCount": "रेकर्डहरू",
    "recordDate": "रिकॉर्ड तिथि",
    "resolved": "समाधानित",
    "resolvedAt": "समाधानित तिथि",
    "resolvedBy": "समाधानित द्वारा",
    "rowNumber": "पंक्ति",
    "sourceValue": "स्रोत मूल्य",
    "targetValue": "लक्ष्य मूल्य",
    "branchId": "शाखा ID",
    "totalRecords": "कुल",
    "totalAmount": "कुल रकम",
    "transactionDate": "व्यापारिक तिथि",
    "transactionType": "व्यापारिक प्रकार",
    "unmatchedRecords": "अनमेल",
    "userTypeId": "प्रयोगकर्ता प्रकार",
    "validationErrors": "संसाधक त्रुटियाँ",
    "warningCount": "सूचनाएँ",
    "code": "कोड",
    "isDefault": "पूर्वनिर्धारित",
    "module": "मोड्युल",
    "configurationVersionId": "कन्फिगरेसन संस्करण",
    "version": "संस्करण",
    "fullName": "पूरा नाम",
    "accountType": "खाता प्रकार",
    "isActive": "सक्रिय",
    "client": "ग्राहक",
    "custodyAccount": "कस्टडी खाता",
    "accountNumber": "खाता नम्बर",
    "baseCurrency": "आधार मुद्रा",
    "strategy": "रणनीति",
    "ownerType": "धनी प्रकार",
    "ownerClientAccountId": "धनी ग्राहक खाता",
    "boId": "बीओ आईडी",
    "dpCode": "DP कोड",
    "clientType": "ग्राहक प्रकार",
    "action": "कार्य",
    "asOfDate": "मिति अनुसार",
    "availableQuantity": "उपलब्ध मात्रा",
    "breachType": "उल्लङ्घन प्रकार",
    "breachValue": "उल्लङ्घन मूल्य",
    "severity": "गम्भीरता",
    "calculationVersion": "गणना संस्करण",
    "capitalGain": "पूँजीगत लाभ",
    "clientAccountId": "ग्राहक खाता",
    "concentrationPct": "एकाग्रता %",
    "costBasis": "लागत आधार",
    "description": "विवरण",
    "detectedAt": "पत्ता लागेको समय",
    "endDate": "अन्तिम मिति",
    "entityId": "इकाई ID",
    "entityType": "इकाई प्रकार",
    "fiscalYear": "आर्थिक वर्ष",
    "fiscalYearName": "आर्थिक वर्ष",
    "holdingPeriodDays": "होल्डिङ अवधि दिन",
    "instrumentId": "इन्स्ट्रुमेन्ट ID",
    "instrumentName": "इन्स्ट्रुमेन्ट नाम",
    "instrumentType": "इन्स्ट्रुमेन्ट प्रकार",
    "isLocked": "लक गरिएको",
    "journalDate": "जर्नल मिति",
    "kind": "प्रकार",
    "lastUpdated": "अन्तिम अद्यावधिक",
    "limitValue": "सीमा मूल्य",
    "membershipStatus": "सदस्यता स्थिति",
    "periodNumber": "अवधि नम्बर",
    "portfolioAccountId": "पोर्टफोलियो खाता",
    "realizedGain": "वास्तविक लाभ",
    "reference": "सन्दर्भ",
    "riskMeasure": "जोखिम मापन",
    "ruleId": "नियम ID",
    "ruleVersion": "नियम संस्करण",
    "saleDate": "बिक्री मिति",
    "sector": "क्षेत्र",
    "securityName": "सुरक्षा नाम",
    "sourceAuthority": "स्रोत प्राधिकरण",
    "sourceBook": "स्रोत पुस्तक",
    "startDate": "सुरुवात मिति",
    "taxAmount": "कर रकम",
    "taxDomain": "कर डोमेन",
    "taxRate": "कर दर",
    "totalCost": "कुल लागत",
    "totalCredit": "कुल क्रेडिट",
    "totalDebit": "कुल डेबिट",
    "totalQuantity": "कुल मात्रा",
    "unrealizedGain": "अवास्तविक लाभ",
    "userEmail": "प्रयोगकर्ता इमेल",
    "weightedAverageCost": "भारित औसत लागत",
    "jurisdiction": "क्षेत्राधिकार",
    "assignedModules": "मोड्युलहरू",
    "branchCount": "शाखाहरू",
    "parentBranchId": "मूल शाखा",
    "parentBranchName": "मूल शाखा",
    "portfolioAccountNumber": "पोर्टफोलियो खाता",
    "effectiveFrom": "प्रभावकारी मिति",
    "entryDate": "प्रविष्टि मिति",
    "entryNumber": "प्रविष्टि नम्बर",
    "expectedUpdatedAt": "अपेक्षित अद्यावधिक मिति",
    "externalReference": "बाह्य सन्दर्भ",
    "maxBranches": "अधिकतम शाखा",
    "maxUsers": "अधिकतम प्रयोगकर्ता",
    "narration": "विवरण",
    "organizationCode": "संगठन कोड",
    "organizationName": "संगठन नाम",
    "permission": "अनुमति",
    "persona": "पर्सोना",
    "resource": "स्रोत",
    "resourceScope": "स्रोत क्षेत्र",
    "roleCode": "भूमिका कोड",
    "yearCode": "वर्ष कोड",
    "isClosed": "वन्द छ",
    "branchName": "शाखा",
    "lastLoginAt": "अन्तिम लगइन",
    "legalName": "कानुनी नाम",
    "componentSummary": "शुल्क घटकहरू",
    "phone": "फोन",
    "panNumber": "PAN नम्बर",
    "address": "ठेगाना",
    "mandateStartDate": "अधिकृत सुरु",
    "mandateEndDate": "अधिकृत अन्त्य",
    "commission": "कमिसन",
    "sebonFee": "SEBON शुल्क",
    "dpCharges": "DP शुल्क",
    "declarationDate": "घोषणा मिति",
    "ratioNumerator": "अनुपात अंश",
    "ratioDenominator": "अनुपात हर",
    "cashRate": "नगद दर",
    "fiscalYearId": "आर्थिक वर्ष",
    "postedAt": "पोस्ट गरिएको",
    "reversalOf": "उल्टो प्रविष्टि",
    "clientAccountName": "ग्राहक",
    "totalCharges": "कुल शुल्क",
    "postingStatus": "पोस्टिङ अवस्था"
  },
  "role": {
    "add": "प्रतिष्ठान जोड्न",
    "create": "प्रतिष्ठान बनाउनु",
    "edit": "प्रतिष्ठान समायोजन",
    "delete": "प्रतिष्ठान हटाउनु",
    "confirmDeleteTitle": "भूमिका हटाउने?",
    "confirmDelete": "के तपाईं यो भूमिका हटाउन चाहनुहुन्छ?",
    "deleteSuccess": "भूमिका सफलतापूर्वक निष्क्रिय भयो"
  },
  "field": {
    "txnType": "लेखा प्रकार",
    "transactionDate": "लेखा मिति",
    "settlementDate": "निस्तारण मिति",
    "instrumentSymbol": "साधन",
    "quantity": "परिमाण",
    "pricePerUnit": "एकाइ मूल्य",
    "currency": "मुद्रा",
    "accountId": "ग्राहक खाता",
    "portfolioId": "पोर्टफोलियो",
    "commission": "ब्रोकरेज",
    "sebonFee": "सेब्सन शुल्क",
    "dpCharge": "डिपी शुल्क",
    "externalReference": "बाह्य सन्दर्भ",
    "notes": "टिप्पणी",
    "role": {
      "name": "भूमिकाको नाम",
      "code": "भूमिका कोड",
      "description": "विवरण",
      "permissions": "अनुमतिहरू",
      "expectedVersion": "अपेक्षित संस्करण",
      "status": "स्थिति"
    },
    "user": {
      "email": "इमेल",
      "firstName": "पहिलो नाम",
      "lastName": "थर",
      "password": "पासवर्ड",
      "expectedVersion": "अपेक्षित संस्करण",
      "roles": "भूमिकाहरू",
      "status": "स्थिति",
      "branchId": "शाखा",
      "clientAccountId": "ग्राहक खाता"
    },
    "instrument": {
      "symbol": "प्रतीक",
      "instrumentName": "साधनको नाम",
      "securityName": "धितोपत्रको नाम",
      "isin": "ISIN",
      "currency": "मुद्रा",
      "exchange": "एक्सचेन्ज",
      "sector": "क्षेत्र",
      "instrumentType": "साधन प्रकार",
      "status": "स्थिति"
    },
    "clientAccount": {
      "code": "ग्राहक कोड",
      "fullName": "पूरा नाम",
      "email": "इमेल",
      "phone": "फोन",
      "panNumber": "PAN नम्बर",
      "accountType": "खाता प्रकार",
      "isActive": "सक्रिय",
      "notes": "टिप्पणी"
    },
    "clientCustodyAccount": {
      "clientAccountId": "ग्राहक",
      "expectedVersion": "रेकर्ड संस्करण",
      "accountNumber": "कस्टडी खाता नम्बर",
      "accountType": "कस्टडी खाता प्रकार",
      "baseCurrency": "आधार मुद्रा",
      "isDefault": "पूर्वनिर्धारित खाता",
      "isActive": "सक्रिय"
    },
    "branch": {
      "code": "कोड",
      "name": "नाम",
      "address": "ठेगाना",
      "status": "स्थिति",
      "expectedUpdatedAt": "रेकर्ड संस्करण",
      "locale": "भाषा",
      "timeZone": "समय क्षेत्र",
      "isDefault": "पूर्वनिर्धारित शाखा",
      "parentBranchId": "मूल शाखा",
      "parentBranchName": "मूल शाखा",
      "disableReason": "यस शाखालाई निष्क्रिय बनाउनुको कारण"
    },
    "organization": {
      "code": "कोड",
      "name": "नाम",
      "legalName": "कानुनी नाम",
      "jurisdiction": "क्षेत्राधिकार",
      "locale": "भाषा",
      "timeZone": "समय क्षेत्र",
      "modules": "मोड्युलहरू",
      "baseCurrency": "आधार मुद्रा",
      "adminEmail": "मालिक इमेल",
      "adminPassword": "प्रारम्भिक मालिक पासवर्ड",
      "status": "स्थिति",
      "assignedModules": "तोकिएका मोड्युलहरू",
      "branchCount": "शाखा संख्या",
      "defaultBranchCode": "पूर्वनिर्धारित शाखा कोड",
      "defaultBranchName": "पूर्वनिर्धारित शाखा नाम",
      "expectedVersion": "अपेक्षित संस्करण",
      "panNumber": "स्थायी लेखा नम्बर (PAN)",
      "sebonRegistrationNumber": "सेबोन दर्ता नम्बर",
      "regulatoryProfileReady": "नियामकीय दाखिला प्रोफाइल तयार"
    },
    "client": {
      "expectedUpdatedAt": "रेकर्ड संस्करण",
      "code": "कोड",
      "fullName": "पूरा नाम",
      "email": "इमेल",
      "phone": "फोन",
      "panNumber": "प्यान नम्बर",
      "accountType": "खाता प्रकार",
      "isActive": "सक्रिय",
      "notes": "नोटहरू",
      "branchId": "शाखा"
    },
    "portfolioAccount": {
      "accountNumber": "खाता नम्बर",
      "boId": "BOID",
      "dpCode": "DP कोड",
      "ownerType": "स्वामित्व प्रकार",
      "ownerClientAccountId": "स्वामी ग्राहक खाता",
      "isDefault": "पूर्वनिर्धारित पोर्टफोलियो",
      "isActive": "सक्रिय"
    },
    "portfolio": {
      "custodyAccountId": "कस्टडी खाता",
      "name": "पोर्टफोलियो नाम",
      "baseCurrency": "आधार मुद्रा",
      "strategy": "रणनीति",
      "mandateStartDate": "म्यान्डेट सुरु मिति",
      "mandateEndDate": "म्यान्डेट समाप्ति मिति",
      "status": "स्थिति"
    },
    "module": {
      "module": "मोड्यूल",
      "configurationVersionId": "कन्फिगरेसन संस्करण",
      "expectedVersion": "अपेक्षित संस्करण"
    },
    "transaction": {
      "status": "स्थिति",
      "transactionNumber": "कारोबार नम्बर",
      "totalAmount": "कुल रकम"
    },
    "reconciliationRun": {
      "reconciliationDate": "सहमति तिथी",
      "runType": "रन प्रकार",
      "statements": "बाह्य अनुमान",
      "matchThreshold": "अनुमान सीमा",
      "amountTolerance": "पैसा सहन सीमा"
    },
    "importJob": {
      "importType": "आयात प्रकार",
      "sourceFileName": "स्रोत फाइल नाम",
      "sourceSheetName": "स्रोत सिट नाम",
      "csv": "CSV डाटा",
      "idempotencyKey": "दोहोरो आयात रोक्ने कुञ्जी"
    },
    "corporateAction": {
      "actionType": "कार्य प्रकार",
      "recordDate": "रेकर्ड मिति",
      "exDate": "एक्स-डेट",
      "declarationDate": "घोषणा मिति",
      "bookCloseDate": "बुक क्लोज मिति",
      "payDate": "भुक्तानी मिति",
      "fiscalYear": "आर्थिक वर्ष",
      "ratioNumerator": "अनुपात अंश",
      "ratioDenominator": "अनुपात हर",
      "cashRate": "नगद दर",
      "rightPrice": "राइट मूल्य",
      "replacementInstrumentSymbol": "प्रतिस्थापन उपकरण प्रतीक",
      "sourceReference": "स्रोत सन्दर्भ",
      "status": "स्थिति",
      "cancellationReason": "रद्दको कारण"
    },
    "data": {
      "instrument": {
        "expectedVersion": "अपेक्षित संस्करण"
      }
    },
    "platformModule": {
      "effectiveFrom": "प्रभावकारी मिति",
      "effectiveTo": "प्रभावकारी अन्तिम मिति",
      "graceEndsAt": "ग्रेस अवधि समाप्ति",
      "maxBranches": "अधिकतम शाखा",
      "maxUsers": "अधिकतम प्रयोगकर्ता",
      "module": "मोड्युल",
      "organizationId": "संगठन आईडी"
    },
    "platformUser": {
      "email": "इमेल",
      "expectedVersion": "अपेक्षित संस्करण",
      "firstName": "पहिलो नाम",
      "lastName": "थर",
      "password": "पासवर्ड",
      "roleCode": "भूमिका कोड",
      "status": "स्थिति"
    }
  },
  "status": {
    "active": "सक्रिय",
    "inactive": "निष्क्रिय",
    "locked": "लक",
    "suspended": "निलम्बित",
    "enabled": "सक्षम",
    "disabled": "अक्षम",
    "success": "सफल",
    "pending": "प्रतीक्षामा",
    "failed": "असफल",
    "open": "खुला",
    "closed": "बन्द",
    "elected": "चयन गरिएको",
    "allocated": "बाँडफाँट गरिएको",
    "expired": "म्याद सकिएको",
    "ok": "OK",
    "unknown": "अज्ञात",
    "unhealthy": "अस्वस्थ",
    "cancelled": "रद्द गरिएको",
    "critical": "गम्भीर",
    "warning": "चेतावनी",
    "info": "जानकारी",
    "draft": "मस्यौदा",
    "submitted": "पेश गरिएको",
    "approved": "स्वीकृत",
    "posted": "पोस्ट गरिएको",
    "rejected": "अस्वीकृत",
    "withdrawn": "फिर्ता लिइएको",
    "reversed": "उल्टाइएको",
    "completed": "सम्पन्न",
    "planned": "योजनाबद्ध",
    "degraded": "अवनत",
    "stale": "पुरानो",
    "partial": "आंशिक",
    "investigating": "अनुसन्धानमा",
    "resolved": "समाधान भएको",
    "adjusted": "समायोजित",
    "ignored": "बेवास्ता गरिएको"
  },
  "txnType": {
    "purchase": "खरिद",
    "sale": "बिक्री",
    "bonusShare": "बोनस शेयर",
    "rightShare": "हक शेयर",
    "split": "विभाजन",
    "merger": "विलय",
    "transferIn": "स्थानान्तरण आवक",
    "transferOut": "स्थानान्तरण जावक",
    "cashDeposit": "नगद जमा",
    "cashWithdrawal": "नगद निकासा",
    "fee": "शुल्क",
    "tax": "कर",
    "interest": "ब्याज",
    "marginInterest": "मार्जिन ब्याज",
    "correction": "सुधार",
    "reversal": "उल्टो प्रविष्टि"
  },
  "permission": {
    "readUsers": "प्रयोगकर्ता पढ्ने",
    "manageUsers": "प्रयोगकर्ता व्यवस्थापन",
    "readRoles": "भूमिका पढ्ने",
    "manageRoles": "भूमिका व्यवस्थापन"
  },
  "reconciliationRun": {
    "runType": {
      "funding": "फन्डिङ",
      "position": "स्थिति",
      "cash": "नगद"
    }
  },
  "importJob": {
    "type": {
      "transaction": "लेनदेन",
      "instrument": "उपकरणहरू",
      "marketData": "बजार डाटा",
      "custodyPosition": "कस्टडी स्थिति",
      "openingCutover": "प्रारम्भिक कटओभर",
      "taxRule": "कर नियम",
      "fact": "तथ्य",
      "corporateAction": "कर्पोरेट कार्यहरू",
      "feeRule": "शुल्क नियम"
    },
    "corporateAction": {
      "actionType": "कार्य प्रकार",
      "recordDate": "रेकर्ड मिति",
      "declarationDate": "घोषणा मिति",
      "bookCloseDate": "बुक-क्लोज मिति",
      "exDate": "एक्स-मिति",
      "fiscalYear": "आर्थिक वर्ष",
      "ratioNumerator": "अनुपात अंश",
      "ratioDenominator": "अनुपात हर",
      "cashRate": "नगद दर",
      "rightPrice": "हक मूल्य",
      "replacementInstrumentSymbol": "प्रतिस्थापन इन्स्ट्रुमेन्ट"
    }
  },
  "user": {
    "add": "प्रयोगकर्ता जोडनु",
    "confirmDeleteTitle": "प्रयोगकर्ता निष्क्रिय बनाउने?",
    "confirmDelete": "के तपाईं यो प्रयोगकर्ता निष्क्रिय बनाउन चाहनुहुन्छ?",
    "delete": "निष्क्रिय बनाउनु",
    "deleteSuccess": "प्रयोगकर्ता सफलतापूर्वक निष्क्रिय भयो",
    "action": {
      "unlock": "अनलक गर्नु",
      "forcePasswordReset": "पासवर्ड रिसेट गर्न लगाउनु",
      "mfaRequireEnrollment": "MFA आवश्यक बनाउनु",
      "mfaResetEnrollment": "MFA रिसेट गर्नु",
      "mfaDisable": "MFA निष्क्रिय बनाउनु",
      "reasonLabel": "कारण"
    },
    "confirmUnlockTitle": "प्रयोगकर्ता अनलक गर्ने?",
    "confirmUnlock": "यो प्रयोगकर्ताको असफल लगइन लकआउट हटाएर फेरि साइन इन गर्न अनुमति दिने?",
    "unlockSuccess": "प्रयोगकर्ता सफलतापूर्वक अनलक भयो",
    "confirmForcePasswordResetTitle": "पासवर्ड रिसेट गर्न लगाउने?",
    "confirmForcePasswordReset": "यो प्रयोगकर्ताको पासवर्ड रिसेट गरेर लगआउट गर्ने? उनीहरूलाई एकपटक मात्र प्रयोज्य रिसेट टोकन प्राप्त हुनेछ।",
    "forcePasswordResetSuccess": "पासवर्ड रिसेट सफलतापूर्वक लगाइयो",
    "confirmMfaRequireEnrollmentTitle": "MFA दर्ता आवश्यक बनाउने?",
    "confirmMfaRequireEnrollment": "यो प्रयोगकर्तालाई अर्को साइन इनमा MFA दर्ता गर्न लगाउने? उनीहरूका सक्रिय सत्रहरू खारेज हुनेछन्।",
    "mfaRequireEnrollmentSuccess": "MFA दर्ता आवश्यक सफलतापूर्वक लागु भयो",
    "confirmMfaResetEnrollmentTitle": "MFA दर्ता रिसेट गर्ने?",
    "confirmMfaResetEnrollment": "यो प्रयोगकर्ताको MFA प्रमाणपत्र र आवश्यकता हटाउने? उनीहरूले फेरि दर्ता गर्नुपर्नेछ। सक्रिय सत्रहरू खारेज हुनेछन्।",
    "mfaResetEnrollmentSuccess": "MFA दर्ता सफलतापूर्वक रिसेट भयो",
    "confirmMfaDisableTitle": "MFA निष्क्रिय बनाउने?",
    "confirmMfaDisable": "यो प्रयोगकर्ताको MFA निष्क्रिय बनाउने? उनीहरूको MFA प्रमाणपत्र र पुनःप्राप्ति कोडहरू हटाइनेछ र सक्रिय सत्रहरू खारेज हुनेछन्।",
    "mfaDisableSuccess": "MFA सफलतापूर्वक निष्क्रिय भयो"
  },
  "maintenanceDelegations": {
    "actions": {
      "enter": "प्रतिनिधित्व प्रवेश गर्नुहोस्",
      "revoke": "रद्द गर्नुहोस्",
      "confirmRevoke": "प्रतिनिधिमन्त्री फिर्ता पुष्टि गर्नुहोस्",
      "create": "प्रतिनिधिमन्त्री सिर्जना गर्नुहोस्"
    },
    "title": "समर्थन प्रत्यायोजन",
    "description": "समय-सीमित रखरखाव पहुँच प्रत्यायोजन अनुदानहरू हेर्नुहोस् र व्यवस्थापन गर्नुहोस्।",
    "createTitle": "प्रत्यायोजन सिर्जना गर्नुहोस्",
    "createDescription": "यस संस्थाका लागि समर्थन प्रमुखलाई समय-सीमित रखरखाव पहुँच प्रदान गर्नुहोस्।",
    "revokeTitle": "प्रत्यायोजन रद्द गर्नुहोस्",
    "revokeDescription": "यो रखरखाव प्रत्यायोजन अनुदान तुरुन्त रद्द गर्नुहोस्। यो प्रत्यायोजन प्रयोग गरिरहेका सक्रिय सत्रहरूले पहुँच गुमाउनेछन्।",
    "viewTitle": "प्रत्यायोजन हेर्नुहोस्",
    "viewDescription": "यो रखरखाव प्रत्यायोजन अनुदानको विवरण हेर्नुहोस्।",
    "capability": {
      "ORG_ACCESS_INSPECT": "संगठन पहुँच निरीक्षण",
      "ORG_AUDIT_VIEW": "संगठन अडिट हेर्ने",
      "ORG_CONFIG_MANAGE": "संगठन कन्फिगर व्यवस्थापन",
      "ORG_CONFIG_VIEW": "संगठन कन्फिगर हेर्ने",
      "ORG_DATA_CORRECT": "संगठन डाटा सच्याउने",
      "ORG_DATA_VIEW": "संगठन डाटा हेर्ने",
      "ORG_FINANCIAL_EXPORT": "संगठन वित्तीय निर्यात",
      "ORG_IDENTITY_MANAGE": "संगठन परिचय व्यवस्थापन",
      "ORG_IDENTITY_VIEW": "संगठन परिचय हेर्ने",
      "ORG_IMPORT_RETRY": "संगठन आयात पुनः प्रयास",
      "ORG_LEGAL_HOLD_MANAGE": "संगठन कानूनी होल्ड व्यवस्थापन",
      "ORG_RECONCILIATION_MANAGE": "संगठन मेलमिलाप व्यवस्थापन",
      "ORG_RECONCILIATION_VIEW": "संगठन मेलमिलाप हेर्ने",
      "ORG_REPORT_RUN": "संगठन रिपोर्ट चलाउने",
      "ORG_REPORT_VIEW": "संगठन रिपोर्ट हेर्ने"
    },
    "fields": {
      "allowedOperationIds": "अनुमति प्राप्त सञ्चालन",
      "capabilities": "क्षमताहरू",
      "effectiveFrom": "प्रभावकारी मिति",
      "expiresAt": "समाप्ति मिति",
      "justification": "औचित्य",
      "policyVersion": "नीति संस्करण",
      "purpose": "उद्देश्य",
      "reason": "कारण",
      "requiredAal": "आवश्यक AAL",
      "resourceIds": "स्रोत आईडीहरू",
      "sessionEndedAt": "सत्र समाप्ति मिति",
      "sessionStartedAt": "सत्र सुरु मिति",
      "status": "स्थिति",
      "supportUserIdentityId": "सहयोग प्रयोगकर्ता परिचय",
      "targetBranchId": "लक्षित शाखा",
      "targetClientAccountId": "लक्षित ग्राहक खाता",
      "targetOrganizationId": "लक्षित संगठन",
      "targetPortfolioAccountId": "लक्षित पोर्टफोलियो खाता",
      "ticketReference": "टिकट सन्दर्भ"
    },
    "help": {
      "allowedOperationIds": "यो प्रतिनिधिमन्त्रीले अनुमति दिने सञ्चालन आईडीहरू।",
      "capabilities": "सहयोग प्रधानलाई प्रदान गरिएका क्षमताहरू।",
      "effectiveFrom": "प्रतिनिधिमन्त्री सक्रिय हुने मिति।",
      "expiresAt": "प्रतिनिधिमन्त्री समाप्त हुने मिति।",
      "justification": "प्रतिनिधिमन्त्रीको औचित्य।",
      "purpose": "मर्मतसम्भार प्रतिनिधिमन्त्रीको उद्देश्य।",
      "reason": "प्रतिनिधिमन्त्रीको कारण।",
      "resourceIds": "यो प्रतिनिधिमन्त्रीमा सीमित स्रोत आईडीहरू।",
      "supportUserIdentityId": "यो प्रतिनिधिमन्त्रीको सहयोग प्रयोगकर्ता परिचय।",
      "targetBranchId": "यो प्रतिनिधिमन्त्रीको लक्षित शाखा।",
      "targetClientAccountId": "यो प्रतिनिधिमन्त्रीको लक्षित ग्राहक खाता।",
      "targetOrganizationId": "यो प्रतिनिधिमन्त्रीको लक्षित संगठन।",
      "targetPortfolioAccountId": "यो प्रतिनिधिमन्त्रीको लक्षित पोर्टफोलियो खाता।",
      "ticketReference": "सहयोग टिकट सन्दर्भ।"
    },
    "purpose": {
      "ACCESS_TROUBLESHOOTING": "पहुँच समस्या समाधान",
      "AUDIT_SUPPORT": "अडिट सहयोग",
      "CALCULATION_DEFECT_INVESTIGATION": "गणना दोष अनुसन्धान",
      "CONFIGURATION_CORRECTION": "कन्फिगरेसन सुधार",
      "DATA_MIGRATION": "डाटा माइग्रेसन",
      "FAILED_IMPORT_INVESTIGATION": "असफल आयात अनुसन्धान",
      "MARKET_DATA_MAPPING_REPAIR": "बजार डाटा म्यापिङ मरम्मत",
      "ORGANIZATION_ADMINISTRATION_ASSISTANCE": "संगठन प्रशासन सहायता",
      "PRODUCTION_REMEDIATION_VALIDATION": "उत्पादन सुधार प्रमाणीकरण",
      "RECONCILIATION_SUPPORT": "मेलमिलाप सहयोग"
    }
  },
  "session": {
    "compromised": {
      "message": "अपनी सत्र माई बाध्य हो सक्छ। तपाला लागि लॉग आउट गर्नु पर्नु"
    },
    "degraded": {
      "message": "कुछ विशेषताहरू कारण सत्र समस्या हुने कारण अनुपलब्ध हुन सक्छन"
    },
    "noWorkspace": {
      "title": "कुनै कार्यक्षेत्र उपलब्ध छैन",
      "message": "कुनै कार्यक्षेत्र उपलब्ध छैन।"
    }
  },
  "intents": {
    "transaction": {
      "list": {
        "label": "कारोबारहरू",
        "description": "व्यावसायिक लाभ प्रतिक्रिया देख्न"
      },
      "approvals": {
        "label": "अपेक्षित मान्यता",
        "description": "पेन्डिङ कारोबारहरू समीक्षा र स्वीकृत गर्नुहोस्"
      },
      "reversals": {
        "label": "पुनः निर्धारण",
        "description": "पोस्ट गरिएका लाभकारी प्रतिक्रिया रिन्सन गर्नु र पुनः निर्धारण गर्नु"
      }
    },
    "instrument": {
      "list": {
        "label": "उपकरणहरू",
        "description": "संदर्भ साधन ब्राउज़ गर्नु"
      }
    },
    "import": {
      "list": {
        "label": "अपलोड कामहरू",
        "description": "रिव्यू र अपलोड डेटा अपलोड गर्ने"
      }
    },
    "corporateAction": {
      "list": {
        "label": "कार्पोरेट कार्यहरू",
        "description": "सामान्य कार्य व्यवस्था हुने कारण देख्न"
      }
    },
    "reconciliation": {
      "list": {
        "label": "पुनर्मापनन कार्यहरू",
        "description": "पुनर्मापनन कार्यहरू र त्रुटिहरू देख्न"
      },
      "suspenseCash": {
        "caseCreate": {
          "label": "अपरिचित नगद केस दर्ता गर्नुहोस्",
          "description": "बाँडफाँड नगरिएको प्राप्ति वा भुक्तानीलाई सस्पेन्स नगद नियन्त्रणमा अभिलेख गर्नुहोस्।"
        },
        "caseList": {
          "label": "अपरिचित नगद केसहरू सूचीबद्ध गर्नुहोस्",
          "description": "दायराभित्रका समाधान नभएका नगद केस र तिनको एस्केलेसन अवस्था समीक्षा गर्नुहोस्।"
        },
        "resolutionRequest": {
          "label": "अपरिचित नगद समाधान अनुरोध गर्नुहोस्",
          "description": "स्वतन्त्र स्वीकृतिका लागि प्रमाणमा आधारित बाँडफाँड वा फिर्ता समाधान पेश गर्नुहोस्।"
        },
        "resolutionApprove": {
          "label": "अपरिचित नगद समाधान स्वीकृत गर्नुहोस्",
          "description": "प्रमाणमा आधारित अपरिचित नगद समाधान स्वतन्त्र रूपमा स्वीकृत गर्नुहोस्।"
        },
        "reopenRequest": {
          "label": "अपरिचित नगद पुनःखोल्ने अनुरोध गर्नुहोस्",
          "description": "समाधान भएको अपरिचित नगद बाँडफाँडको सुधार अनुरोध गर्नुहोस्।"
        },
        "reopenApprove": {
          "label": "अपरिचित नगद पुनःखोल्ने स्वीकृत गर्नुहोस्",
          "description": "समाधान भएको बाँडफाँड उल्ट्याउने सुधार स्वतन्त्र रूपमा स्वीकृत गर्नुहोस्।"
        }
      }
    },
    "factBatch": {
      "list": {
        "label": "संकल्पना बैच",
        "description": "संकल्पना बैच लागि इन्गेस्ट गर्नु"
      }
    },
    "dataHoldings": {
      "list": {
        "label": "होल्डिङहरू",
        "description": "पोर्टफोलियो होल्डिङहरू समीक्षा गर्नुहोस्"
      }
    },
    "admin": {
      "users": {
        "label": "प्रयोगकर्ताहरू",
        "description": "संगठन प्रयोगकर्ताहरू प्रबंधित गर्नु"
      },
      "roles": {
        "label": "भूमिकाहरू",
        "description": "भूमिका र अनुमतिहरू प्रबंधित गर्नु"
      },
      "organization": {
        "label": "संस्था",
        "description": "संगठन विवरण देख्न र संशोधन गर्नु"
      },
      "audit": {
        "label": "अडिट एक्सप्लोरर",
        "description": "पुनर्निरीक्षणमा स्थिर लाग्ने वार्षिक प्रमाणपत्र"
      }
    }
  },
  "actions": {
    "admin": {
      "users": {
        "create": {
          "label": "ब्यक्ति बनाए"
        },
        "update": {
          "label": "ब्यक्ति समायोजन कर"
        },
        "delete": {
          "label": "प्रयोगकर्ता मेटाउनुहोस्"
        }
      },
      "roles": {
        "create": {
          "label": "भूमिका बनाए"
        },
        "update": {
          "label": "भूमिका समायोजन कर"
        },
        "delete": {
          "label": "भूमिका हटाए"
        }
      },
      "organization": {
        "edit": {
          "label": "संगठन समायोजन कर"
        }
      },
      "audit": {
        "export": {
          "label": "प्रमाणपत्र लागु करे"
        }
      }
    }
  },
  "enum": {
    "locale": {
      "en-US": "अंग्रेजी (संयुक्त राज्य)",
      "ne-NP": "नेपाली (नेपाल)"
    },
    "timeZone": {
      "Asia_Kathmandu": "एसिया/काठमाडौँ",
      "Asia_Singapore": "एसिया/सिंगापुर",
      "UTC": "समन्वित विश्व समय (UTC)"
    },
    "status": {
      "PENDING": "KYC विचाराधीन",
      "RUNNING": "चाला",
      "COMPLETED": "सम्पन्न",
      "FAILED": "असफल",
      "PROCESSING": "प्रशोधन हुँदै"
    },
    "corporateActionType": {
      "DIVIDEND": "लाभांश",
      "INTEREST": "ब्याज आय",
      "BONUS": "बोनस",
      "RIGHTS_ISSUE": "हकप्रद सेयर",
      "SPLIT": "शेयर विभाजन",
      "CONSOLIDATION": "शेयर एकीकरण",
      "MERGER": "विलय",
      "SPINOFF": "स्पिनअफ"
    },
    "corporateActionStatus": {
      "DRAFT": "ड्राफ्ट",
      "ANNOUNCED": "घोषणा गरिएको",
      "PROCESSING": "प्रशोधन हुँदै",
      "COMPLETED": "सम्पन्न",
      "CANCELLED": "रद्द"
    },
    "importJobStatus": {
      "PENDING": "विचाराधीन",
      "PREVIEWING": "पूर्वावलोकन हुँदै",
      "PREVIEWED": "पूर्वावलोकन गरिएको",
      "COMMITTING": "कमिट हुँदै",
      "COMMITTED": "कमिट गरिएको",
      "FAILED": "असफल",
      "PARTIAL": "आंशिक",
      "RECOVERING": "पुनर्स्थापना हुँदै"
    },
    "reconciliationStatus": {
      "PENDING": "विचाराधीन",
      "IN_PROGRESS": "प्रगतिमा",
      "COMPLETED": "सम्पन्न",
      "FAILED": "असफल"
    },
    "positionTransferStatus": {
      "REQUESTED": "अनुरोध गरिएको",
      "APPROVED": "स्वीकृत",
      "EXECUTED": "कार्यान्वित",
      "CANCELLED": "रद्द गरिएको",
      "REVERSED": "उल्टाइएको"
    },
    "settlementInstructionStatus": {
      "PENDING": "विचाराधीन",
      "PARTIALLY_SETTLED": "आंशिक फर्छ्यौट",
      "SETTLED": "फर्छ्यौट भएको",
      "FAILED": "असफल",
      "CANCELLED": "रद्द गरिएको",
      "CORRECTED": "सुधार गरिएको"
    },
    "caType": {
      "DIVIDEND": "लाभांश",
      "INTEREST": "ब्याज आय",
      "BONUS": "बोनस",
      "SPLIT": "विभाजन",
      "CONSOLIDATION": "शेयर एकीकरण",
      "MERGER": "विलय",
      "SPINOFF": "स्पिनऑफ",
      "RIGHTS_ISSUE": "हक्क की घोषणा"
    },
    "caStatus": {
      "DRAFT": "ड्राफ्ट",
      "ANNOUNCED": "घोषणा गरिएको",
      "PROCESSING": "प्रशोधन हुँदै",
      "COMPLETED": "सम्पन्न",
      "CANCELLED": "रद्द"
    },
    "importType": {
      "TRANSACTIONS": "कारोबारहरू",
      "HOLDINGS": "होल्डिङहरू",
      "INSTRUMENTS": "उपकरणहरू",
      "CLIENTS": "ग्राहक",
      "CORPORATE_ACTIONS": "कर्पोरेट कार्यहरू",
      "CORPORATE_ACTION": "कर्पोरेट कार्य",
      "CUSTODY_POSITION": "कस्टडी स्थिति",
      "OPENING_CUTOVER": "प्रारम्भिक कटओभर",
      "TAX_RULE": "कर नियम",
      "INSTRUMENT": "साधन",
      "TRANSACTION": "कारोबार",
      "MARKET_DATA": "बजार डाटा",
      "FACT": "तथ्य"
    },
    "importStatus": {
      "PENDING": "KYC विचाराधीन",
      "PREVIEWING": "पूर्व निरीक्षणमा",
      "PREVIEWED": "पूर्व निरीक्षणमा",
      "COMMITTING": "समायोजनमा",
      "COMMITTED": "समायोजन गरिएको",
      "FAILED": "असफल"
    },
    "rowStatus": {
      "VALID": "सही",
      "INVALID": "अपवादी",
      "WARNING": "चेतावनी"
    },
    "assetType": {
      "EQUITY": "सामान्य",
      "BOND": "बॉन्ड",
      "FUND": "फंड",
      "ETF": "ईटीएफ",
      "DERIVATIVE": "विकल्प",
      "CRYPTO": "क्रिप्टो",
      "CASH": "नगद"
    },
    "instrumentType": {
      "EQUITY": "इक्विटी",
      "DEBT": "ऋण",
      "MUTUAL_FUND": "म्युचुअल फन्ड",
      "PROMISSORY_NOTE": "प्रतिज्ञापत्र"
    },
    "instrumentStatus": {
      "ACTIVE": "सक्रिय",
      "CLOSED": "बन्द",
      "INACTIVE": "निष्क्रिय",
      "DELISTED": "पूर्वगत",
      "SUSPENDED": "निलम्बित"
    },
    "orgStatus": {
      "ACTIVE": "सक्रिय",
      "INACTIVE": "निष्क्रिय",
      "SUSPENDED": "निलम्बित"
    },
    "userStatus": {
      "ACTIVE": "सक्रिय",
      "INACTIVE": "निष्क्रिय",
      "SUSPENDED": "निलम्बित",
      "PENDING": "KYC विचाराधीन",
      "LOCKED": "लक"
    },
    "userType": {
      "ADMIN": "प्रशासन",
      "USER": "प्रयोगकर्ता",
      "CLIENT": "ग्राहक"
    },
    "roleStatus": {
      "ACTIVE": "सक्रिय",
      "INACTIVE": "निष्क्रिय"
    },
    "reconStatus": {
      "PENDING": "KYC विचाराधीन",
      "RUNNING": "चालू",
      "COMPLETED": "सम्पन्न",
      "FAILED": "असफल"
    },
    "factStatus": {
      "PENDING": "KYC विचाराधीन",
      "PROCESSING": "प्रशोधन हुँदै",
      "COMPLETED": "सम्पन्न",
      "FAILED": "असफल"
    },
    "reportStatus": {
      "GENERATING": "उत्पन्न होने हुने",
      "COMPLETED": "सम्पन्न",
      "FAILED": "असफल"
    },
    "recStatus": {
      "MATCHED": "मेल खाता छ",
      "MISMATCH": "असंगत",
      "MISSING_SOURCE": "स्रोत की कमी",
      "MISSING_TARGET": "लक्ष्य की कमी"
    },
    "txnType": {
      "PURCHASE": "खरिद",
      "SALE": "बिक्री",
      "BONUS_SHARE": "बोनस शेयर",
      "RIGHT_SHARE": "हक शेयर",
      "BUY": "खरीदना",
      "SELL": "बेचना",
      "DIVIDEND": "वित्तीय विभाग",
      "SPLIT": "विभाजन",
      "MERGER": "विलय",
      "FEE": "शुल्क",
      "TAX": "कर",
      "TRANSFER_IN": "स्थानान्तरण आवक",
      "TRANSFER_OUT": "स्थानान्तरण जावक"
    },
    "txnStatus": {
      "DRAFT": "ड्राफ्ट",
      "SUBMITTED": "प्रस्तुत गरिएको",
      "PENDING_APPROVAL": "स्वीकृतिको प्रतीक्षामा",
      "APPROVED": "कार्यप्रवाह सफलतापूर्वक अनुमोदित।",
      "POSTED": "पोस्ट गरियो",
      "REJECTED": "KYC अस्वीकार",
      "WITHDRAWN": "वापस ले लिया गया",
      "REVERSED": "उल्टाइयो",
      "ROLLED_BACK": "फिर्ता गरिएको"
    },
    "module": {
      "ACCOUNTING": "लेखा",
      "ADMIN": "प्रशासन",
      "AUTH": "प्रमाणीकरण",
      "CORPORATE_ACTIONS": "कर्पोरेट कार्य",
      "DASHBOARD": "ड्यासबोर्ड",
      "DATA": "डाटा",
      "FACTS": "तथ्य",
      "HOLDINGS": "होल्डिङ",
      "IMPORT": "आयात",
      "INSTRUMENTS": "साधन",
      "INVESTMENT": "लगानी",
      "MARKET_DATA": "बजार डाटा",
      "NAVIGATION": "नेभिगेसन",
      "RECONCILIATION": "मेलमिलाप",
      "REGULATORY": "नियामक",
      "REPORTING": "रिपोर्टिङ",
      "SETTINGS": "सेटिङ",
      "TAX": "कर"
    },
    "postingStatus": {
      "NOT_POSTED": "पोस्ट नभएको",
      "POSTING": "पोस्ट हुँदै",
      "POSTED": "पोस्ट गरिएको",
      "FAILED": "पोस्टिङ असफल",
      "REVERSED": "उल्टाइएको"
    },
    "calendarSystem": {
      "AD": "ग्रेगोरियन (ईस्वी संवत)",
      "BS": "विक्रम संवत (बि.सं.)",
      "DUAL": "दोहोरो (बि.सं. / ई.सं.)"
    }
  },
  "validation": {
    "required": "यो फिल्ड आवश्यक छ",
    "min": "न्यूनतम मान {{min}} हो",
    "max": "अधिकतम मान {{max}} हो",
    "minLength": "न्यूनतम लम्बाई {{min}} हो",
    "maxLength": "अधिकतम लम्बाई {{max}} हो",
    "integer": "पूर्ण संख्या हुनुपर्छ",
    "decimalPrecision": "अधिकतम {{precision}} दशमलव स्थानहरू अनुमत छन्",
    "email": "अमान्य इमेल ठेगाना",
    "url": "अमान्य URL",
    "pattern": "यो फिल्ड आवश्यक ढाँचासँग मेल खाँदैन।",
    "allowedValues": "यी मध्ये एक हुनुपर्छ: {{values}}",
    "dateMin": "मिति {{minDate}} वा पछि हुनुपर्छ",
    "dateMax": "मिति {{maxDate}} वा अघि हुनुपर्छ",
    "fileType": "फाइल प्रकार हुनुपर्छ: {{accepted}}",
    "fileSize": "फाइल आकार {{maxBytes}} बाइट भन्दा बढी छ",
    "branchParentActive": "मूल शाखा सक्रिय हुनुपर्छ",
    "patternFiscalYear": "YYYY/YY ढाँचा प्रयोग गर्नुहोस् (उदाहरण, २०८२/८३)।",
    "organizationPan": "PAN ठीक नौ अंकको हुनुपर्छ।"
  },
  "opt": {
    "clientCustodyAccountType": {
      "CUSTODY": "कस्टडी",
      "DEMAT": "डिम्याट",
      "BROKERAGE": "ब्रोकराज"
    },
    "clientAccountType": {
      "INDIVIDUAL": "व्यक्तिगत",
      "INSTITUTIONAL": "संस्थागत"
    },
    "txnType": {
      "PURCHASE": "खरिद",
      "SALE": "बिक्री",
      "BONUS_SHARE": "बोनस शेयर",
      "RIGHT_SHARE": "हक शेयर",
      "SPLIT": "विभाजन",
      "MERGER": "विलय",
      "TRANSFER_IN": "स्थानान्तरण आवक",
      "TRANSFER_OUT": "स्थानान्तरण जावक",
      "CASH_DEPOSIT": "नगद जमा",
      "CASH_WITHDRAWAL": "नगद निकासा",
      "FEE": "शुल्क",
      "TAX": "कर",
      "INTEREST": "ब्याज",
      "MARGIN_INTEREST": "मार्जिन ब्याज",
      "CORRECTION": "सुधार",
      "REVERSAL": "उल्टो प्रविष्टि"
    },
    "status": {
      "ACTIVE": "सक्रिय",
      "INACTIVE": "निष्क्रिय",
      "LOCKED": "बन्द",
      "SUSPENDED": "निलम्बित",
      "CLOSED": "बन्द"
    },
    "instrumentType": {
      "EQUITY": "इक्विटी",
      "DEBT": "ऋणपत्र",
      "MUTUAL_FUND": "म्युचुअल फन्ड",
      "PROMISSORY_NOTE": "प्रतिज्ञापत्र"
    },
    "accountType": {
      "INDIVIDUAL": "व्यक्तिगत",
      "JOINT": "संयुक्त",
      "CORPORATE": "संस्थागत",
      "TRUST": "ट्रस्ट",
      "NRI": "गैरआवासीय"
    },
    "ownerType": {
      "CLIENT": "ग्राहक",
      "ORGANIZATION": "संगठन"
    },
    "txnStatus": {
      "DRAFT": "मस्यौदा",
      "SUBMITTED": "पेश गरिएको",
      "APPROVED": "स्वीकृत",
      "POSTED": "पोस्ट गरिएको",
      "REJECTED": "अस्वीकृत",
      "REVERSED": "उल्टाइएको"
    },
    "boolean": {
      "true": "हो",
      "false": "होइन"
    },
    "importType": {
      "TRANSACTION": "कारोबार",
      "INSTRUMENT": "साधन",
      "FACT": "तथ्य",
      "MARKET_DATA": "बजार डाटा"
    },
    "runType": {
      "FUNDING": "फन्डिङ",
      "POSITION": "स्थिति",
      "CASH": "नगद"
    },
    "permission": {
      "ACCESS_READ_USERS": "प्रयोगकर्ता पढ्ने",
      "ACCESS_MANAGE_USERS": "प्रयोगकर्ता व्यवस्थापन",
      "ACCESS_READ_ROLES": "भूमिका पढ्ने",
      "ACCESS_MANAGE_ROLES": "भूमिका व्यवस्थापन"
    },
    "mock": {
      "option1": "विकल्प १",
      "option2": "प्रत्येक २",
      "option3": "प्रत्येक ३"
    }
  },
  "portfolioPerformance": {
    "columns": {
      "portfolioReference": "पोर्टफोलियो",
      "dpCode": "डीपी कोड",
      "boIdMasked": "बोआईडी",
      "asOfDate": "मिति सम्म (ईस्वी)",
      "asOfDateBs": "मिति सम्म (वि.सं.)",
      "periodStart": "अवधि सुरु (ईस्वी)",
      "currency": "मुद्रा",
      "totalCost": "लागत आधार",
      "marketValue": "बजार मूल्य",
      "realizedGainLoss": "साकार नाफा/नोक्सानी",
      "unrealizedGainLoss": "असाकार नाफा/नोक्सानी",
      "totalGainLoss": "कुल नाफा/नोक्सानी",
      "capitalGainTax": "पूँजीगत लाभ कर",
      "returnOnCostPct": "लागतमा प्रतिफल %",
      "benchmarkId": "बेन्चमार्क",
      "benchmarkReturnPct": "बेन्चमार्क प्रतिफल (%)",
      "activeReturnPct": "सक्रिय प्रतिफल (%)",
      "benchmarkAsOf": "बेन्चमार्क मिति",
      "benchmarkStatus": "बेन्चमार्क स्थिति",
      "valuationCoveragePct": "मूल्यांकन कभरेज %",
      "missingPriceCount": "मूल्य नपुगेका",
      "taxProvenanceCoveragePct": "कर नियम स्रोत प्रमाण %",
      "missingTaxProvenanceCount": "कर स्रोत प्रमाण नपुगेका",
      "nfrsEvidenceAvailable": "एनएफआरएस प्रमाण",
      "nfrsFactCount": "एनएफआरएस तथ्य संख्या",
      "nfrsStandards": "एनएफआरएस मापदण्ड",
      "nfrsMetrics": "एनएफआरएस सूचक",
      "partialData": "आंशिक तथ्यांक",
      "methodology": "गणना विधि",
      "methodologyVersion": "गणना विधि संस्करण",
      "performanceReturnMethodology": "नियन्त्रित प्रतिफल कार्यविधि",
      "performanceReturnMethodologyVersion": "नियन्त्रित प्रतिफल कार्यविधि संस्करण",
      "performanceReturnNetTwr": "शुद्ध TWR (%)",
      "performanceReturnGrossTwr": "कुल TWR (%)",
      "performanceReturnNetMwr": "शुद्ध MWR (%)",
      "performanceReturnGrossMwr": "कुल MWR (%)",
      "performanceReturnInputDigest": "प्रतिफल इनपुट प्रमाण डाइजेस्ट",
      "performanceReturnLimitations": "प्रतिफल सीमितताहरू",
      "sourceBook": "स्रोत अभिलेख",
      "sourceAsOf": "स्रोत ताजगी",
      "stalePriceCount": "पुरानो मूल्य संख्या"
    },
    "methodology": {
      "returnOnCost": "साकार तथा असाकार कुल नाफालाई लागत आधारले भाग गरिएको हो। यो TWR, MWR वा IRR होइन।",
      "taxProvenance": "प्रत्येक बिक्रीमा प्रयोग भएको प्रभावकारी कर नियमको पहिचान र स्रोत प्रमाण सुरक्षित हुँदा मात्र कर प्रमाण पूर्ण मानिन्छ।",
      "nfrsEvidence": "एनएफआरएस प्रमाणले शासित एनएफआरएस तथ्य उपलब्ध भएको देखाउँछ; यसले पूर्ण प्रकटीकरण मूल्यांकनलाई प्रतिस्थापन गर्दैन।"
    }
  },
  "governanceWorkspace": {
    "title": "शासन तथा नीति नियन्त्रण",
    "description": "ठ्याक्कै र संस्करणयुक्त आदेश सम्झौताबाट संस्थाको दायराभित्रका नियन्त्रण सञ्चालन गर्नुहोस्। लागू नीति र क्षेत्राधिकार सामग्री सर्भरले छनोट गर्छ।",
    "area": "शासन क्षेत्र",
    "areaLabel": "{{area}} नियन्त्रण",
    "commandTitle": "शासित आदेश",
    "commandDescription": "आधिकारिक सम्झौता प्रयोग गरेर जीवनचक्र आदेश पठाउनुहोस्। सर्भर नीति, शाखा दायरा र स्वतन्त्र स्वीकृति नियम आधिकारिक रहन्छन्।",
    "command": "आदेश",
    "commandLabel": "आदेश {{commandId}}",
    "pathFieldLabel": "{{field}} पथ पहिचानकर्ता",
    "fieldLabel": "क्षेत्र {{field}}",
    "structuredHint": "आदेश सम्झौताले परिभाषित गरेको संरचित वस्तु JSON का रूपमा प्रविष्ट गर्नुहोस्।",
    "listHint": "प्रति पङ्क्ति एउटा मान वा अल्पविरामले छुट्याएका मान प्रविष्ट गर्नुहोस्।",
    "instantHint": "मिलिसेकेन्डसहित ISO 8601 UTC समय प्रयोग गर्नुहोस्।",
    "submit": "शासित आदेश पठाउनुहोस्",
    "submitting": "शासित आदेश पठाइँदै छ",
    "commandSucceeded": "शासित आदेश पूरा भयो र प्रमाण दृश्य ताजा गरियो।",
    "evidenceTitle": "दायराबद्ध शासन प्रमाण",
    "evidenceDescription": "सक्रिय संस्था र शाखाका लागि सर्भरले प्रस्तुत गरेका अभिलेख। संवेदनशील प्रमाण सामग्री API ले हटाउँछ।",
    "loading": "शासन प्रमाण लोड हुँदै छ",
    "noAreas": "हालको मोड्युल अधिकारका लागि कुनै शासन क्षेत्र उपलब्ध छैन।"
  },
  "fixedIncome": {
    "title": "स्थिर आय मूल्याङ्कन",
    "description": "नियन्त्रित सफा मूल्य, आर्जित ब्याज, डर्टी मूल्य र प्रतिफल मूल्याङ्कन तथ्य गणना गर्नुहोस्।",
    "policyNotice": "सर्त, क्यालेन्डर, सम्मेलन र बजार-मूल्य नीति सक्रिय संस्थाका लागि सर्भरले चयन गर्छ।",
    "portfolioAccountId": "पोर्टफोलियो खाता आईडी",
    "instrumentSymbol": "साधन संकेत",
    "valuationDate": "मूल्याङ्कन मिति",
    "calculate": "मूल्याङ्कन गणना गर्नुहोस्",
    "calculating": "मूल्याङ्कन गणना हुँदैछ…",
    "result": "मूल्याङ्कन परिणाम",
    "cleanPrice": "सफा मूल्य",
    "accruedInterest": "आर्जित ब्याज",
    "dirtyPrice": "डर्टी मूल्य",
    "yieldToMaturity": "परिपक्वतासम्मको प्रतिफल",
    "carryingAmount": "बहन रकम",
    "status": "गणना स्थिति",
    "debtEventTitle": "प्रकाशित ऋण घटना",
    "debtEventDescription": "यस दायराबद्ध पोर्टफोलियोका लागि प्रकाशित कल, पुट, मोचन, डिफल्ट वा पुनर्संरचना सूचना प्रशोधन गर्नुहोस्।",
    "issuerEventVersionId": "जारीकर्ता घटना संस्करण आईडी",
    "processDebtEvent": "ऋण घटना प्रशोधन गर्नुहोस्",
    "processingDebtEvent": "ऋण घटना प्रशोधन हुँदैछ…",
    "debtEventType": "ऋण घटना प्रकार",
    "debtEventAmount": "नियन्त्रित रकम",
    "cashDelta": "नगद परिवर्तन",
    "impairmentDelta": "क्षति परिवर्तन",
    "settlementQuantityDelta": "स्थिति परिमाण परिवर्तन",
    "overrideTitle": "अपवादात्मक मूल्याङ्कन इनपुट",
    "overrideDescription": "प्रमाणसहित सीमित मूल्य वा विदेशी विनिमय ओभरराइड अनुरोध गर्नुहोस्। मूल्याङ्कनमा प्रयोग हुनुअघि अर्को संस्था प्रशासकले स्वीकृत गर्नुपर्छ।",
    "overrideField": "इनपुट प्रकार",
    "overridePriceClose": "बन्द मूल्य",
    "overrideFxRate": "विदेशी विनिमय दर",
    "overrideSourceState": "स्रोत अवस्था",
    "overrideMissing": "स्रोत हराएको",
    "overrideDisputed": "स्रोत विवादित",
    "overrideValue": "प्रस्तावित मान",
    "overrideSourceObservation": "विवादित अवलोकन आईडी",
    "overrideBaselineValue": "विवादित आधार मान",
    "overrideEffectiveFrom": "लागू हुने मिति",
    "overrideEffectiveTo": "लागू हुने अन्तिम मिति",
    "overrideEvidence": "प्रमाण सन्दर्भ",
    "overrideReason": "कारण",
    "overrideRequest": "ओभरराइड अनुरोध गर्नुहोस्",
    "overrideRequestCorrection": "सुधार अनुरोध गर्नुहोस्",
    "overrideCancelCorrection": "सुधार रद्द गर्नुहोस्",
    "overrideCorrectionOf": "ओभरराइड {{overrideId}} को सुधार",
    "overrideApprove": "स्वीकृत गर्नुहोस्",
    "overrideCorrect": "सुधार गर्नुहोस्",
    "overrideRequestRevocation": "खारेजी अनुरोध गर्नुहोस्",
    "overrideApproveRevocation": "खारेजी स्वीकृत गर्नुहोस्",
    "overrideOverTolerance": "सहनशीलताभन्दा बढी",
    "overrideSummary": "मान {{value}}; सहनशीलता {{toleranceBps}} आधार अङ्क; विचलन {{deviationBps}} आधार अङ्क",
    "overrideDecisionReason": "अपवादात्मक मूल्याङ्कन इनपुट समीक्षा गरियो",
    "unavailable": "उपलब्ध छैन",
    "overrideReference": "ओभरराइड सन्दर्भ: {{overrideId}}",
    "lifecycleSchedule": "जीवनचक्र घटना तालिकाबद्ध गर्नुहोस्",
    "lifecycleApprove": "जीवनचक्र घटना स्वीकृत गर्नुहोस्",
    "lifecyclePost": "जीवनचक्र घटना पोस्ट गर्नुहोस्",
    "lifecycleTitle": "स्थिर-आय जीवनचक्र",
    "lifecycleDescription": "निर्माता–जाँचकर्ता नियन्त्रणसहित शासित कुपन, परिपक्वता र अन्य स्थिर-आय जीवनचक्र घटनाहरू तालिकाबद्ध, स्वीकृत र पोस्ट गर्नुहोस्।",
    "lifecycleFailed": "स्थिर-आय जीवनचक्र कार्य पूरा गर्न सकिएन।",
    "lifecycleEventDate": "घटना मिति",
    "lifecycleEventId": "जीवनचक्र घटना",
    "expectedVersion": "अपेक्षित संस्करण",
    "lifecycleResult": "{{eventId}} संस्करण {{version}} मा {{status}} अवस्थामा छ।"
  },
  "valuationRun": {
    "title": "आधिकारिक पोर्टफोलियो मूल्याङ्कन रन",
    "description": "पूर्णता जाँच चलाउनुहोस् र नियन्त्रित स्वीकृति, प्रकाशन, लक र पुनर्प्रस्तुति वंश हेर्नुहोस्।",
    "portfolioAccountId": "पोर्टफोलियो खाता आईडी",
    "asOfDate": "मूल्याङ्कन मिति",
    "runPreliminary": "प्रारम्भिक मूल्याङ्कन चलाउनुहोस्",
    "running": "मूल्याङ्कन चल्दैछ…",
    "refresh": "रनहरू ताजा गर्नुहोस्",
    "status": "रन अवस्था",
    "netAssetValue": "खुद सम्पत्ति मूल्य",
    "checklist": "मूल्य / विदेशी विनिमय / कार्य / नगद",
    "exceptions": "महत्त्वपूर्ण अपवादहरू",
    "sourceDigest": "स्रोत डाइजेस्ट",
    "snapshotHash": "प्रकाशित स्न्यापसट ह्यास",
    "supersedes": "प्रतिस्थापित रन",
    "none": "कुनै छैन",
    "unavailable": "उपलब्ध छैन",
    "approve": "मूल्याङ्कन रन स्वीकृत गर्नुहोस्",
    "publish": "मूल्याङ्कन रन प्रकाशित गर्नुहोस्",
    "requestReopen": "पुनः खोल्न अनुरोध गर्नुहोस्",
    "approveReopen": "पुनः खोल्ने अनुरोध स्वीकृत गर्नुहोस्",
    "reason": "कारण",
    "reasonHelp": "स्वीकृति र पुनः खोल्ने अनुरोधका लागि आवश्यक। कारण अडिट प्रमाणका रूपमा सुरक्षित हुन्छ।"
  },
  "cutoffControls": {
    "title": "कटअफ नियन्त्रण प्रतिवेदन",
    "description": "स्रोत, सबलेजर र पोस्टिङ वंशसहितको पछिल्लो अपरिवर्तनीय नगद र होल्डिङ नियन्त्रण रन पढ्नुहोस्।",
    "loading": "कटअफ नियन्त्रण प्रतिवेदन लोड हुँदैछ…",
    "empty": "यस संस्थाका लागि कुनै कटअफ नियन्त्रण रन उपलब्ध छैन।",
    "policyVersion": "नीति संस्करण",
    "breaks": "नियन्त्रण ब्रेकहरू",
    "sourceLinks": "स्रोत लिङ्कहरू",
    "subledgerLinks": "सबलेजर लिङ्कहरू",
    "postingLinks": "पोस्टिङ लिङ्कहरू"
  },
  "ok": "ठिक छ",
  "err": "त्रुटि",
  "importWizard": {
    "title": "आयात",
    "step": {
      "upload": "अपलोड",
      "map": "स्तम्भ म्याप",
      "validate": "मान्यता",
      "preview": "पूर्वावलोकन",
      "commit": "प्रतिबद्ध",
      "result": "नतिजा"
    },
    "upload": {
      "dropHere": "CSV वा Excel यहाँ छोड्नुहोस्",
      "orClick": "वा फाइल चयन गर्न क्लिक गर्नुहोस्",
      "constraints": "अधिकतम २५ MB · .csv, .xlsx",
      "downloadTemplate": "टेम्प्लेट डाउनलोड गर्नुहोस्"
    },
    "map": {
      "title": "स्तम्भ म्याप",
      "sourceColumns": "फाइल स्तम्भहरू",
      "targetSchema": "उत्पादन स्किमा",
      "dragHelp": "प्रत्येक फाइल स्तम्भका लागि लक्ष्य फिल्ड छान्नुहोस्। चाहनुहुन्छ भने फाइल स्तम्भलाई लक्ष्य फिल्डमा तानेर पनि मिलाउन सक्नुहुन्छ।",
      "unmapped": "— अनम्याप गरिएको —",
      "matched": "मिलेको",
      "dropField": "फाइल स्तम्भ यहाँ छोड्नुहोस्",
      "mappingName": "म्यापिङ नाम",
      "savedMapping": "संग्रहित म्यापिङ",
      "autoMap": "स्वचालित स्तम्भ म्याप",
      "required": "आवश्यक क्षेत्र",
      "mappedCount": "{{count}} क्षेत्र म्याप गरियो",
      "unmappedCount": "{{count}} क्षेत्र अनम्याप छन्",
      "continue": "मान्यतामा जारी राख्नुहोस्",
      "selectionHelp": "द्रुत म्यापिङको लागि 'म्याप टु' चयनकर्ता प्रयोग गर्नुहोस्।",
      "chooseTarget": "म्याप टु",
      "transformLabel": "रूपान्तरण",
      "transform": {
        "NONE": "जस्ताको तस्तै",
        "TRIM": "अतिरिक्त खाली ठाउँ हटाउनुहोस्",
        "UPPERCASE": "ठूला अक्षरमा बदल्नुहोस्",
        "LOWERCASE": "साना अक्षरमा बदल्नुहोस्",
        "NUMBER": "संख्या (विभाजक हटाएर)",
        "PERCENT_TO_DECIMAL": "प्रतिशतलाई दशमलवमा बदल्नुहोस्",
        "DATE_ISO": "मिति: YYYY-MM-DD",
        "DATE_MDY": "मिति: MM/DD/YYYY",
        "DATE_DMY": "मिति: DD/MM/YYYY",
        "BOOLEAN": "बुलियन (हो/होइन)",
        "JSON": "JSON"
      }
    },
    "validate": {
      "title": "मान्यता परिणामहरू",
      "valid": "मान्य",
      "warnings": "चेतावनीहरू",
      "errors": "त्रुटिहरू",
      "status": "स्थिति",
      "details": "विवरणहरू",
      "rowValid": "पंक्ति मान्य छ",
      "rowWarning": "पंक्तिमा चेतावनीहरू छन्",
      "rowError": "पंक्तिमा त्रुटिहरू छन्",
      "andMore": "...र अझै {{count}}",
      "continue": "पूर्वावलोकनमा जारी राख्नुहोस्"
    },
    "preview": {
      "title": "परिवर्तनहरूको पूर्वावलोकन",
      "willCreate": "रेकर्डहरू सिर्जना गरिनेछ",
      "willUpdate": "रेकर्डहरू अद्यावधिक गरिनेछ",
      "willSkip": "अपरिवर्तित",
      "willReject": "अस्वीकृत",
      "commit": "पुष्टि गर्नुहोस् र आयात प्रतिबद्ध गर्नुहोस्"
    },
    "result": {
      "successTitle": "आयात पूरा भयो",
      "successMessage": "तपाईंको आयात सफलतापूर्वक प्रशोधन गरिएको छ।",
      "created": "सिर्जना गरिएको",
      "updated": "अद्यावधिक गरिएको",
      "skipped": "छोडिएको",
      "failed": "असफल",
      "committedBy": "प्रतिबद्ध गर्ने",
      "committedAt": "प्रतिबद्ध मिति",
      "sourceFile": "स्रोत फाइल",
      "auditReference": "अडिट सन्दर्भ",
      "viewRecords": "आयात गरिएका रेकर्डहरू हेर्नुहोस्",
      "importAnother": "अर्को फाइल आयात गर्नुहोस्"
    },
    "template": {
      "label": "टेम्प्लेट",
      "autoDetectedHigh": "ढाँचा पहिचान भयो — {{total}} मध्ये {{matched}} स्तम्भ मिल्यो",
      "autoDetectedMedium": "सम्भावित मिलान — {{total}} मध्ये {{matched}} स्तम्भ पहिचान भयो",
      "standardSection": "मानक टेम्प्लेटहरू",
      "savedSection": "तपाईंका सुरक्षित टेम्प्लेटहरू",
      "stale": "पुरानो"
    },
    "productTemplate": {
      "nepse": {
        "daily": "NEPSE दैनिक बजार डेटा"
      },
      "marketData": {
        "standard": "मानक बजार डेटा"
      },
      "transactions": {
        "standard": "मानक कारोबार"
      }
    }
  },
  "section": {
    "client": {
      "profile": "लगानीकर्ता प्रोफाइल",
      "settings": "खाता सेटिङ"
    },
    "portfolio": {
      "ownership": "ग्राहक र खाता लिङ्केज",
      "details": "पोर्टफोलियो विवरण"
    },
    "clientAccount": {
      "identity": "ग्राहक पहिचान",
      "details": "खाता विवरण"
    },
    "instrument": {
      "identity": "साधन पहिचान",
      "classification": "वर्गीकरण"
    },
    "portfolioAccount": {
      "identity": "पोर्टफोलियो पहिचान",
      "ownership": "स्वामित्व"
    },
    "role": {
      "definition": "भूमिका परिभाषा",
      "permissions": "अनुमतिहरू"
    },
    "transaction": {
      "trade": "व्यापार विवरण",
      "allocation": "विनियोजन",
      "charges": "शुल्कहरू",
      "details": "लेनदेन विवरण",
      "source": "स्रोत",
      "status": "स्थिति"
    },
    "user": {
      "identity": "पहिचान",
      "assignment": "पहुँच निर्धारण"
    },
    "profile": {
      "identity": "प्रोफाइल पहिचान"
    }
  },
  "helpText": {
    "field": {
      "user": {
        "email": "प्रयोगकर्ताको लगइन इमेल ठेगाना। प्लेटफर्म भित्र अद्वितीय हुनुपर्छ। प्रमाणीकरण र सूचनाको लागि प्रयोग गरिन्छ।",
        "emailEdit": "प्रयोगकर्ताको लगइन इमेल ठेगाना। यो फिल्ड सिर्जना पछि पढ्ने मात्र छ; परिवर्तन गर्न प्लेटफर्म प्रशासकलाई सम्पर्क गर्नुहोस्।",
        "firstName": "प्रयोगकर्ताको कानुनी पहिलो नाम जुन आधिकारिक परिचयमा देखिन्छ।",
        "lastName": "प्रयोगकर्ताको कानुनी थर जुन आधिकारिक परिचयमा देखिन्छ।",
        "password": "प्रयोगकर्ताको लागि प्रारम्भिक पासवर्ड। कम्तिमा ८ अक्षर हुनुपर्छ। प्रयोगकर्तालाई पहिलो लगइनमा परिवर्तन गर्न प्रेरित गरिनेछ।",
        "roles": "प्रयोगकर्तालाई अनुमतिहरू प्रदान गर्न एक वा बढी संस्था भूमिकाहरू तोक्नुहोस्। उपलब्ध भूमिकाहरू खोज्न भूमिका नामले खोज्नुहोस्।",
        "branch": "यो प्रयोगकर्ता तोकिएको प्राथमिक शाखा। प्रयोगकर्ताको पूर्वनिर्धारित सञ्चालन सन्दर्भ सीमित गर्छ।",
        "clientAccountId": "ग्राहक भूमिकाभएका प्रयोगकर्ताहरूका लागि, उनीहरूको पोर्टफोलियो र कारोबार प्रवेश सीमित गर्न इस प्रयोगकर्तालाई तिनीहरूको ग्राहक खातासंग जोड्नुहोस्।",
        "status": "सक्रिय प्रयोगकर्ताहरू लगइन गर्न र प्लेटफर्म प्रयोग गर्न सक्छन्। निष्क्रिय प्रयोगकर्ताहरू निलम्बित छन् र प्रमाणीकरण गर्न सक्दैनन्।"
      },
      "role": {
        "name": "यो भूमिकाको मानव-पठनीय नाम, भूमिका तोकाइ सूची र अडिट लगमा देखाइन्छ।",
        "description": "भूमिकाको उद्देश्य र जिम्मेवारीहरूको वैकल्पिक विवरण।",
        "code": "भूमिका नामबाट स्वतः उत्पन्न अपरिवर्तनीय प्रणाली पहिचानकर्ता। आन्तरिक रूपमा अनुमति समाधान र अडिट ट्रेलको लागि प्रयोग गरिन्छ। सिर्जना पछि सम्पादन गर्न सकिँदैन।",
        "status": "सक्रिय भूमिकाहरू प्रयोगकर्ताहरूलाई तोक्न सकिन्छ। निष्क्रिय भूमिकाहरू तोकिएका रहन्छन् तर नयाँ प्रयोगकर्ताहरूलाई तोक्न सकिँदैन।",
        "permissions": "यो भूमिकाले यसका धारकहरूलाई प्रदान गर्ने अनुमतिहरू चयन गर्नुहोस्। तपाईंले भएका अनुमतिहरू मात्र तोक्न सकिन्छ। अनुमति नाम वा डोमेनद्वारा खोज्नुहोस्।"
      },
      "branch": {
        "address": "यस शाखाको भौतिक ठेगाना।"
      },
      "reports": {
        "accountCode": "फिल्टर गर्न खाता कोड। सबै खातहरू समावेश गर्न खाली छोडें।",
        "dimension": "विश्लेषण गर्न विनियोजन आयाम (मुद्रा, साधन, साधन प्रकार वा क्षेत्र)।"
      },
      "positionTransfer": {
        "workflowKind": "स्थिति स्थानान्तरण कार्यप्रवाहको प्रकार",
        "id": "यो स्थिति स्थानान्तरणको अद्वितीय पहिचानकर्ता",
        "expectedVersion": "द्वन्द्व पहिचानका लागि संस्करण संख्या",
        "sourcePortfolioAccountId": "पोर्टफोलियो खाता जसबाट स्थितिहरू स्थानान्तरण हुन्छन्",
        "instrumentSymbol": "धितोपत्र संकेत पहिचानकर्ता",
        "businessReference": "यस स्थानान्तरणको बाह्य सन्दर्भ",
        "reason": "स्थानान्तरण, स्वीकृति, रद्दीकरण वा उल्ट्याउने कारण",
        "allocationPlan": "स्थानान्तरण गरिने लट र मात्रा निर्दिष्ट गर्नुहोस्"
      }
    },
    "semantic": {
      "email": "खाता पहिचान, साइन-इन र खाता वा सुरक्षा सम्बन्धी सूचनाका लागि प्रयोग हुने इमेल ठेगाना।",
      "firstName": "व्यक्तिको पहिलो नाम, एपभरि सही पहिचान गर्न प्रयोग हुन्छ।",
      "lastName": "व्यक्तिको थर, प्रयोगकर्ता र अडिट अभिलेखमा पहिलो नामसँग प्रयोग हुन्छ।",
      "fullName": "ग्राहकको पूरा कानुनी वा प्रचलित नाम, खाता, अभिलेख र रिपोर्टमा देखाइन्छ।",
      "password": "यस खाताको प्रारम्भिक साइन-इन गोप्य शब्द; प्रयोगकर्ताले परिवर्तन नगरेसम्म पहुँच सुरक्षित गर्छ।",
      "currentPassword": "सुरक्षासम्बन्धी परिवर्तनअघि तपाईंको पहिचान पुष्टि गर्न आवश्यक हालको पासवर्ड।",
      "newPassword": "यो परिवर्तन सुरक्षित गरेपछि भविष्यका साइन-इनका लागि प्रयोग हुने पासवर्ड।",
      "confirmPassword": "गलत पासवर्ड सुरक्षित नहोस् भनेर नयाँ पासवर्ड फेरि लेख्नुहोस्।",
      "roles": "यस प्रयोगकर्तालाई दिइएका भूमिका; यसले उसले के हेर्न र परिवर्तन गर्न सक्छ भन्ने निर्धारण गर्छ।",
      "role": "दिइने वा परिवर्तन गरिने भूमिका; यसले यस असाइनमेन्टबाट प्राप्त अनुमति निर्धारण गर्छ।",
      "permissions": "यस भूमिकाले दिने अनुमति; यसले भूमिका भएका प्रयोगकर्ताले गर्न सक्ने काम नियन्त्रण गर्छ।",
      "status": "यस अभिलेखको हालको अवस्था; यसले अभिलेख सञ्चालनमा प्रयोग गर्न मिल्छ कि मिल्दैन निर्धारण गर्छ।",
      "code": "सूची, आयात, एकीकरण र रिपोर्टमा अभिलेख पहिचान गर्न प्रयोग हुने छोटो स्थिर कोड।",
      "name": "एपभरि यो अभिलेख चिन्न प्रयोग हुने प्रयोगकर्ता-मुखी नाम।",
      "description": "अभिलेखको उद्देश्य स्पष्ट गर्ने छोटो विवरण, ताकि प्रयोगकर्ताले सही रूपमा छुट्याउन र प्रयोग गर्न सकून्।",
      "notes": "संरचित फिल्डमा नसमेटिएको सन्दर्भ समीक्षकलाई बुझाउन प्रयोग हुने वैकल्पिक टिप्पणी।",
      "branch": "यो अभिलेखको स्वामित्व वा प्रयोग हुने शाखा; दृश्यता र कार्यक्षेत्र सीमित गर्छ।",
      "parentBranch": "संस्थाको शाखा संरचनामा यो शाखा राख्न र सन्दर्भ उत्तराधिकार गर्न प्रयोग हुने मूल शाखा।",
      "organization": "यो अभिलेखको स्वामी संस्था; यसले अधिकार र डाटा सीमा निर्धारण गर्छ।",
      "client": "यो अभिलेख सम्बन्धित ग्राहक; होल्डिङ, गतिविधि र रिपोर्ट सही ग्राहक क्षेत्रमा राख्छ।",
      "clientAccount": "यो अभिलेखले असर गर्ने ग्राहक खाता; प्रशोधन र रिपोर्टिङमा प्रयोग हुने सही खाता निर्धारण गर्छ।",
      "portfolio": "यो अभिलेखले असर गर्ने पोर्टफोलियो; लगानी गतिविधि, होल्डिङ र प्रदर्शन कहाँ रेकर्ड हुन्छ भन्ने निर्धारण गर्छ।",
      "custodyAccount": "सम्पत्ति राख्न र खाता-विशिष्ट गतिविधि सही रूपमा रूट गर्न प्रयोग हुने कस्टडी वा पोर्टफोलियो खाता।",
      "account": "यो अभिलेखले असर गर्ने खाता; ब्यालेन्स र गतिविधि कहाँ रेकर्ड हुन्छ भन्ने निर्धारण गर्छ।",
      "accountNumber": "स्टेटमेन्ट, आयात र सञ्चालनसँग मिलान गर्न प्रयोग हुने बाह्य वा व्यावसायिक खाता पहिचान।",
      "accountType": "खाता वा ग्राहकको वर्गीकरण; लागू प्रशोधन र रिपोर्टिङ व्यवहार निर्धारण गर्छ।",
      "baseCurrency": "खाता वा पोर्टफोलियोलाई एकरूप रूपमा मूल्याङ्कन र रिपोर्ट गर्न प्रयोग हुने मुख्य मुद्रा।",
      "currency": "यो रकम वा कारोबारको मुद्रा; सही मूल्याङ्कन, रूपान्तरण र रिपोर्टिङका लागि आवश्यक हुन्छ।",
      "instrumentSymbol": "सही धितोपत्र, मूल्य, होल्डिङ र रिपोर्टसँग गतिविधि जोड्न प्रयोग हुने ट्रेडिङ पहिचान।",
      "instrument": "यस अभिलेखले असर गर्ने वित्तीय साधन; सुरक्षा मास्टर डाटा र मूल्याङ्कनसँग जोड्छ।",
      "instrumentName": "वित्तीय साधनको मुख्य प्रयोगकर्ता-मुखी नाम, लगानी कार्यप्रवाहभरि पहिचान गर्न प्रयोग हुन्छ।",
      "securityName": "स्टेटमेन्ट, सन्दर्भ डाटा र नियामक वा ग्राहक रिपोर्टमा प्रयोग हुने औपचारिक धितोपत्र नाम।",
      "instrumentType": "धितोपत्र वर्गीकरण; कुन विशेषता र प्रशोधन नियम लागू हुन्छ भन्ने निर्धारण गर्छ।",
      "sector": "साधनको आर्थिक क्षेत्र, वर्गीकरण, एक्सपोजर विश्लेषण र रिपोर्टिङमा प्रयोग हुन्छ।",
      "isin": "बाह्य डाटा स्रोतसँग धितोपत्र सही रूपमा मिलान गर्न प्रयोग हुने अन्तर्राष्ट्रिय धितोपत्र पहिचान नम्बर।",
      "exchange": "धितोपत्र सूचीबद्ध वा कारोबार हुने एक्सचेन्ज, बजार डाटा र सन्दर्भ डाटा मिलानमा प्रयोग हुन्छ।",
      "transactionType": "रेकर्ड गरिने लगानी गतिविधिको प्रकार; नगद, परिमाण, लागत र नाफा कसरी असर हुन्छ निर्धारण गर्छ।",
      "transaction": "होल्डिङ, नगद र रिपोर्टिङमा लगानी गतिविधि सही रूपमा रेकर्ड गर्न प्रयोग हुने कारोबारसम्बन्धी मान।",
      "transactionDate": "लगानी गतिविधि भएको मिति; लेखा, होल्डिङ, कर र रिपोर्टिङ अवधि निर्धारण गर्छ।",
      "settlementDate": "नगद र धितोपत्र सेटल भएको मानिने मिति; सेटलमेन्ट र नगद स्थिति प्रशोधनमा प्रयोग हुन्छ।",
      "quantity": "असर पर्ने युनिट वा अंकित परिमाण; पोजिसन परिवर्तन र मूल्याङ्कन निर्धारण गर्छ।",
      "price": "साधनमा लागू गरिएको मूल्य; कारोबार मूल्य वा बजार मूल्याङ्कन गणना गर्न प्रयोग हुन्छ।",
      "pricePerUnit": "एक युनिटको मूल्य, परिमाणसँग प्रयोग गरी कारोबार मूल्य र लागत आधार गणना गरिन्छ।",
      "marketPrice": "छानिएको मूल्य मितिमा होल्डिङ मूल्याङ्कन गर्न प्रयोग हुने अवलोकित बजार मूल्य।",
      "priceDate": "यो बजार मूल्य लागू हुने मिति; रिपोर्टिङ मितिका लागि सही मूल्य प्रयोग भएको सुनिश्चित गर्छ।",
      "valuationDate": "यो गणना वा रिपोर्टका लागि पोजिसन र मूल्य मापन गरिने मिति।",
      "commission": "कारोबारमा लाग्ने ब्रोकर कमिसन; लागू हुँदा लागत, आम्दानी र रिपोर्टिङमा समावेश हुन्छ।",
      "sebonFee": "SEBON सम्बन्धी कारोबार शुल्क; नेपाल बजारका शुल्क सही रूपमा समेट्न रेकर्ड गरिन्छ।",
      "dpCharge": "कारोबारसँग सम्बन्धित डिपोजिटरी पार्टिसिपेन्ट शुल्क; पूर्ण कारोबार लागतका लागि समेटिन्छ।",
      "fees": "यस गतिविधिसँग सम्बन्धित शुल्क; शुद्ध लागत, आम्दानी र रिपोर्टिङ सही बनाउन रेकर्ड गरिन्छ।",
      "charges": "यस गतिविधिका अन्य लागू शुल्क; वित्तीय नतिजाले पूर्ण कारोबार लागत देखाओस् भनेर समावेश गरिन्छ।",
      "externalReference": "ब्रोकर, बैंक, कस्टोडियन वा स्रोत प्रणालीको सन्दर्भ, ट्रेस र मिलान गर्न प्रयोग हुन्छ।",
      "importType": "आयात गरिने डाटाको प्रकार; सही टेम्प्लेट, प्रमाणीकरण र प्रशोधन कार्यप्रवाह छान्छ।",
      "file": "प्रशोधन गरिने डाटा भएको स्रोत फाइल; स्वीकार गरिएका पङ्क्ति कमिट गर्नुअघि प्रमाणीकरण हुन्छ।",
      "sourceSheetName": "बहु-शीट फाइलबाट पढिने वर्कशीट; आवश्यक डाटा डिफल्ट शीटमा नभए उल्लेख गर्नुहोस्।",
      "phone": "सञ्चालन वा खाता सम्बन्धी सम्पर्कका लागि प्रयोग हुने ग्राहक वा प्रयोगकर्ताको फोन नम्बर।",
      "panNumber": "कर पहिचान र लागू नियामक वा कर रिपोर्टिङका लागि प्रयोग हुने नेपाल PAN; उपलब्ध हुँदा दर्ता नम्बर दिनुहोस्।",
      "legalName": "आधिकारिक, नियामक, कर र सम्झौतासम्बन्धी अभिलेखमा प्रयोग हुने दर्ता कानुनी नाम।",
      "jurisdiction": "संस्था वा अभिलेखमा लागू कानुनी क्षेत्र; कुन नियामक सन्दर्भ लागू हुन्छ निर्धारण गर्छ।",
      "locale": "मिति, संख्या र प्रयोगकर्ता-मुखी सामग्रीका लागि भाषा र क्षेत्रीय ढाँचा प्राथमिकता।",
      "timeZone": "सञ्चालन, कटअफ र अडिट इतिहासमा स्थानीय मिति र समय एकरूप रूपमा बुझ्न प्रयोग हुने समय क्षेत्र।",
      "calendarSystem": "मिति प्रतिनिधित्व र वित्तीय अवधि गणनाका लागि प्रयोग हुने पात्रो प्रणाली।",
      "isDefault": "उही सन्दर्भमा थप विशिष्ट छनोट नभए यसलाई डिफल्ट विकल्प बनाउँछ।",
      "isActive": "इतिहास नमेटाई यो अभिलेख नयाँ सञ्चालनमा प्रयोग गर्न उपलब्ध छ कि छैन नियन्त्रण गर्छ।",
      "strategy": "पोर्टफोलियोले पालना गर्ने लगानी रणनीति वा म्यान्डेट; व्यवस्थापन र रिपोर्टिङका लागि सन्दर्भ दिन्छ।",
      "mandateStartDate": "पोर्टफोलियो म्यान्डेट लागू हुने मिति र गतिविधि म्यान्डेट अवधिभित्र मानिने सुरुवात।",
      "mandateEndDate": "म्यान्डेट समाप्त हुने वैकल्पिक मिति; त्यसपछि गतिविधि म्यान्डेटभित्र मानिनु हुँदैन।",
      "effectiveFrom": "यो नियम, दर वा कन्फिगरेसन लागू हुने पहिलो मिति; यसअघिका गणनामा अघिल्लो लागू संस्करण प्रयोग हुन्छ।",
      "effectiveTo": "यो नियम, दर वा कन्फिगरेसन लागू हुने अन्तिम मिति; हालसम्म लागू भए मात्र खुला छोड्नुहोस्।",
      "effectiveDate": "यो मान वा कन्फिगरेसन लागू भई प्रशोधन वा गणनामा असर गर्न सुरु गर्ने मिति।",
      "taxRate": "सर्त पूरा हुँदा यो कर नियमले लागू गर्ने प्रतिशत; गणना गरिएको कर रकममा प्रत्यक्ष असर गर्छ।",
      "rate": "यो नियम वा गणनामा लागू दर; लागू सन्दर्भअनुसार शुल्क, कर, प्रतिफल वा मूल्य निर्धारण गर्छ।",
      "taxType": "यो नियमले प्रतिनिधित्व गर्ने कर वर्ग; नियम कहाँ र कसरी लागू र रिपोर्ट हुन्छ निर्धारण गर्छ।",
      "holdingPeriodDays": "वास्तविक नाफा वा अन्य नियममा लागू कर उपचार छान्न प्रयोग हुने होल्डिङ अवधि सीमा।",
      "regulatoryProfileReady": "आवश्यक नियामक संस्था विवरण नियन्त्रित रिपोर्टिङका लागि पर्याप्त छन् कि छैनन् देखाउँछ।",
      "assignedModules": "संस्थाका लागि सक्षम मोड्युल; कुन लाइसेन्सयुक्त क्षमता उपलब्ध हुन्छ निर्धारण गर्छ।",
      "branchCount": "संस्थामा कन्फिगर गरिएका शाखाको संख्या, हालको सञ्चालन संरचना संक्षेपमा देखाउँछ।",
      "module": "असाइन वा कन्फिगर गरिने उत्पादन मोड्युल; छानिएको क्षेत्रमा उपलब्ध हुने क्षमता निर्धारण गर्छ।",
      "modules": "संस्था वा असाइनमेन्टका लागि छानिएका उत्पादन मोड्युल; सक्षम क्षमता सेट निर्धारण गर्छ।",
      "reason": "यस कार्यको व्यावसायिक कारण; समीक्षक, अडिट इतिहास र पछिल्लो अनुसन्धानका लागि सन्दर्भ दिन्छ।",
      "expiresAt": "यो पहुँच वा कन्फिगरेसन मान्य रहन छोड्ने मिति र समय, प्रयोग अवधि सीमित गर्छ।",
      "startDate": "अनुरोध गरिएको अवधिको सुरु; यो मिति वा पछि भएको गतिविधि मात्र समावेश हुन्छ।",
      "endDate": "अनुरोध गरिएको अवधिको अन्त्य; यो मिति वा अघि भएको गतिविधि मात्र समावेश हुन्छ।",
      "fiscalYear": "अवधि सीमा र वित्तीय वा कर रिपोर्टिङका लागि प्रयोग हुने आर्थिक वर्ष।",
      "month": "यो अनुरोधमा समावेश हुने महिना, गणना र रिपोर्टिङलाई उक्त अवधिमा सीमित गर्छ।",
      "quarter": "यो अनुरोधमा समावेश हुने त्रैमासिक, गणना र रिपोर्टिङलाई छानिएको अवधिमा समूहबद्ध गर्छ।",
      "outputFormat": "उत्पन्न नतिजा वा फाइलको ढाँचा, रिपोर्ट कसरी समीक्षा वा साझा गरिन्छ भन्ने अनुसार छानिन्छ।",
      "grouping": "नतिजाका पङ्क्ति कसरी समूहबद्ध हुन्छन्; स्रोत डाटा नबदली प्रस्तुति र समेकन बदल्छ।",
      "comparisonPeriod": "प्रवृत्ति र प्रदर्शन विश्लेषणका लागि तुलना आधार बनाइने अघिल्लो वा वैकल्पिक अवधि।",
      "instructionType": "कन्फिगर गरिने सेटलमेन्ट निर्देशनको प्रकार; आवश्यक विवरण र प्रशोधन नियम निर्धारण गर्छ।",
      "settlementMethod": "गतिविधि सेटल गर्ने विधि; नगद वा धितोपत्र डेलिभरीको सञ्चालन मार्ग निर्धारण गर्छ।",
      "bankAccount": "नगद सेटलमेन्टका लागि प्रयोग हुने बैंक खाता; नगद सही खातामा पठाउँछ।",
      "dematAccount": "धितोपत्र सेटलमेन्टका लागि प्रयोग हुने डिम्याट खाता; धितोपत्र सही डिपोजिटरी खातामा पठाउँछ।",
      "tax": "लागू कर नियम, गणना वा नियामक रिपोर्टिङमा प्रयोग हुने करसम्बन्धी मान।",
      "settlement": "सम्बन्धित नगद वा धितोपत्र सेटलमेन्ट सही रूपमा पूरा गर्न प्रयोग हुने सेटलमेन्ट मान।",
      "reportParameter": "कुन अधिकृत डाटा समावेश हुन्छ र नतिजा कसरी देखाइन्छ निर्धारण गर्ने रिपोर्ट फिल्टर वा विकल्प।",
      "delegation": "डेलिगेटेड पहुँचको अधिकृत सीमा र प्रयोग नियन्त्रण गर्ने डेलिगेसन सेटिङ।",
      "openingBalance": "पछिका रेकर्ड गरिएको गतिविधि लागू हुनुअघि सुरुवाती पोजिसन स्थापित गर्न प्रयोग हुने ओपनिङ वा कटओभर मान।",
      "date": "यो अभिलेख वा मान कहिले लागू हुन्छ भन्ने प्रशोधन, गणना वा रिपोर्टिङमा प्रयोग हुने मिति।",
      "numericValue": "यस अभिलेखको गणना, सीमा, परिमाण वा वित्तीय नतिजामा प्रयोग हुने संख्यात्मक मान।",
      "selection": "लागू विकल्प छान्नुहोस्, किनकि यसले अभिलेख कसरी वर्गीकृत वा प्रशोधन हुन्छ निर्धारण गर्छ।",
      "setting": "यो व्यवहार अभिलेखका लागि सक्षम छ कि छैन र सञ्चालनमा कसरी प्रयोग हुन्छ भन्ने नियन्त्रण गर्छ।",
      "collection": "यस अभिलेखका लागि आवश्यक संरचित पङ्क्ति थप्नुहोस्; प्रत्येक पङ्क्ति पेश गरिएको वित्तीय डाटाको भागका रूपमा प्रशोधन हुन्छ।",
      "textValue": "यो फिल्डको व्यावसायिक मान दिनुहोस्, ताकि अभिलेख सही रूपमा पहिचान र प्रशोधन गर्न सकियोस्।",
      "adminEmail": "प्रारम्भिक संस्था प्रशासकको इमेल; साइन-इन खाता बनाउन प्रयोग हुन्छ।",
      "adminPassword": "प्रारम्भिक संस्था प्रशासकको पहिलो साइन-इन पासवर्ड।",
      "roleCode": "यस प्रयोगकर्तालाई दिइएको प्लेटफर्म भूमिका; प्लेटफर्म अनुमति निर्धारण गर्छ।",
      "cancellationReason": "रद्द गर्नुको कारण; अडिट इतिहासमा सुरक्षित राखिन्छ।",
      "defaultBranchCode": "प्रारम्भिक शाखाको कोड; अभिलेख र एकीकरणमा प्रयोग हुन्छ।",
      "defaultBranchName": "प्रयोगकर्तालाई देखाइने प्रारम्भिक शाखाको नाम।",
      "targetOrganization": "यो मोड्युल असाइनमेन्ट प्राप्त गर्ने संस्था।",
      "organizationName": "यो मोड्युल असाइनमेन्टको स्वामी संस्था।",
      "replacementInstrumentSymbol": "यस कर्पोरेट कार्यपछि मूल धितोपत्रलाई प्रतिस्थापन गर्ने साधन।",
      "transactionId": "यो सेटलमेन्ट निर्देशन सम्बन्धित कारोबार।",
      "expectedQuantity": "सेटल हुने अपेक्षित धितोपत्र परिमाण।",
      "tradedDate": "यो बजार मूल्य अवलोकन वा कारोबार भएको मिति।",
      "sourceReference": "यो अभिलेख पुष्टि गर्न प्रयोग हुने स्रोत कागजात वा बाह्य सन्दर्भ।",
      "source": "यो मानको स्रोत; वंशावली र समीक्षाका लागि प्रयोग हुन्छ।",
      "freshness": "यो बजार मूल्य प्रयोगका लागि पर्याप्त नयाँ छ कि छैन देखाउँछ।",
      "sebonRegistrationNumber": "नियामक पहिचानका लागि प्रयोग हुने संस्थाको SEBON दर्ता नम्बर।",
      "graceEndsAt": "ग्रेस अवधि सकिएपछि पहुँच बन्द हुने मिति।",
      "createdAt": "यो अभिलेख सिर्जना भएको समय; अडिट इतिहासका लागि देखाइन्छ।",
      "updatedAt": "यो अभिलेख अन्तिम पटक परिवर्तन भएको समय; अडिट इतिहासका लागि देखाइन्छ।",
      "approvedAt": "यो अभिलेख स्वीकृत भएको समय; अडिट इतिहासका लागि देखाइन्छ।",
      "holdingPeriodMinimumDays": "यस कर वर्गीकरणका लागि आवश्यक न्यूनतम होल्डिङ दिन।",
      "holdingPeriodClassification": "यो कर नियम लागू हुने होल्डिङ-अवधि वर्ग।",
      "maxBranches": "यस मोड्युल असाइनमेन्टअन्तर्गत अनुमति भएका अधिकतम शाखा।",
      "maxUsers": "यस मोड्युल असाइनमेन्टअन्तर्गत अनुमति भएका अधिकतम प्रयोगकर्ता।",
      "configurationVersionId": "यस मोड्युल असाइनमेन्टमा लागू हुने कन्फिगरेसन संस्करण।",
      "transactionPeriodStart": "गतिविधि रिपोर्टमा समावेश हुने पहिलो कारोबार मिति।",
      "transactionPeriodEnd": "गतिविधि रिपोर्टमा समावेश हुने अन्तिम कारोबार मिति।",
      "periodStart": "यस रिपोर्टमा समावेश हुने पहिलो मिति।",
      "periodEnd": "यस रिपोर्टमा समावेश हुने अन्तिम मिति।",
      "reportingPeriodStart": "नियामक रिपोर्टिङ अवधिमा समावेश हुने पहिलो मिति।",
      "reportingPeriodEnd": "नियामक रिपोर्टिङ अवधिमा समावेश हुने अन्तिम मिति।",
      "asOfDate": "ब्यालेन्स वा होल्डिङ गणना गर्न प्रयोग हुने स्न्यापसट मिति।",
      "cutoffAt": "सम्पन्न स्टेटमेन्ट अवधि छान्न प्रयोग हुने कटअफ मिति।",
      "year": "यो रिपोर्ट सीमित गर्न प्रयोग हुने वर्ष।",
      "reportType": "बनाइने रिपोर्ट; आवश्यक प्यारामिटर र आउटपुट निर्धारण गर्छ।",
      "reconciliationRun": "यस रिपोर्टमा ब्रेक समावेश हुने रिकन्सिलिएसन रन।",
      "severity": "रिकन्सिलिएसन नतिजा फिल्टर गर्न प्रयोग हुने ब्रेकको गम्भीरता।",
      "transactionActivityType": "गतिविधि रिपोर्ट फिल्टर गर्न प्रयोग हुने कारोबार वर्ग।",
      "expectedCash": "सेटल हुने अपेक्षित नगद रकम।",
      "expectedSettlementDate": "सेटलमेन्ट पूरा हुने अपेक्षित मिति।",
      "externalMessageId": "ट्रेस र डुप्लिकेट पहिचानका लागि बाह्य सेटलमेन्ट सन्देश सन्दर्भ।",
      "settlementSequence": "सेटलमेन्ट पुष्टिहरू क्रमबद्ध गर्न प्रयोग हुने अनुक्रम नम्बर।",
      "settledCash": "सेटल भएको पुष्टि गरिएको नगद रकम।",
      "corporateActionType": "कर्पोरेट कार्यको प्रकार; लागू सर्त र प्रशोधन नियम निर्धारण गर्छ।",
      "recordDate": "कर्पोरेट कार्यको हकदार धितोपत्रधारी निर्धारण गर्ने मिति।",
      "exDate": "यो कर्पोरेट हक बिना धितोपत्र कारोबार सुरु हुने मिति।",
      "declarationDate": "जारीकर्ताले कर्पोरेट कार्य घोषणा गरेको मिति।",
      "bookCloseDate": "हक प्रशोधनका लागि जारीकर्ताले रजिस्टर बन्द गर्ने मिति।",
      "payDate": "नगद वा धितोपत्र वितरण गर्ने निर्धारित मिति।",
      "ratioNumerator": "कर्पोरेट कार्य अनुपातमा प्राप्त हुने हक युनिट।",
      "ratioDenominator": "कर्पोरेट कार्य अनुपातका लागि आवश्यक विद्यमान युनिट।",
      "cashRate": "यस कर्पोरेट कार्यमा योग्य प्रति युनिट तिरिने नगद रकम।",
      "rightPrice": "हकप्रद निष्कासनमा प्रति युनिट सदस्यता मूल्य।",
      "licenseAuthority": "यो इजाजत जारी गर्ने नियामक वा निकाय।",
      "licenseType": "संस्थासँग रहेको नियामक इजाजतको प्रकार।",
      "licenseNumber": "अधिकार पुष्टि गर्न प्रयोग हुने आधिकारिक इजाजत पहिचान।",
      "licenses": "संस्थाको अनुमत क्षमता र सीमा निर्धारण गर्ने इजाजत प्रविष्टिहरू।",
      "authorityTemplateVersion": "यस रिपोर्ट परिभाषामा प्रयोग हुने स्वीकृत फाइलिङ टेम्प्लेटको संस्करण।",
      "authorityEffectiveFrom": "यो फाइलिङ अधिकार वा टेम्प्लेट मान्य हुने पहिलो मिति।",
      "authorityEffectiveTo": "यो फाइलिङ अधिकार वा टेम्प्लेट मान्य हुने अन्तिम मिति।",
      "reportCode": "रिपोर्ट कन्फिगरेसन पहिचान गर्न प्रयोग हुने स्थिर रिपोर्ट कोड।",
      "reportName": "यो रिपोर्ट परिभाषा चिन्न प्रयोग हुने नाम।",
      "regulatoryBody": "यो रिपोर्ट परिभाषासँग सम्बन्धित नियामक वा निकाय।",
      "reportDefinition": "यो रिपोर्ट रन बनाउन प्रयोग हुने स्वीकृत रिपोर्ट परिभाषा।",
      "theme": "तपाईंको खाताका लागि हल्का, गाढा वा प्रणालीअनुसारको दृश्य शैली छान्न प्रयोग हुने रूपरङ्ग प्राथमिकता।",
      "language": "तपाईंको खातामा एपका लेबल, मार्गदर्शन र अन्य प्रयोगकर्ता-मुखी सामग्री देखाउने भाषा।",
      "defaultContext": "साइन-इनपछि डिफल्ट रूपमा खुल्ने कार्यक्षेत्र सन्दर्भ, ताकि तपाईं प्रायः प्रयोग गर्ने संस्था र शाखाबाट सुरु गर्न सक्नुहोस्।",
      "dateFormat": "समर्थित स्थानमा मिति AD, BS वा दुवै रूपमा देखाउने क्यालेन्डर प्रदर्शन प्राथमिकता।",
      "numberFormat": "इन्टरफेसमा समूह विभाजक, दशमलव र वित्तीय मान कसरी देखाइन्छ भन्ने संख्या ढाँचा।",
      "defaultPageSize": "समर्थित सूचीमा डिफल्ट रूपमा देखाइने पङ्क्ति संख्या, डाटा परिमाण र पढ्न सजिलोपनबीच सन्तुलन राख्छ।"
    }
  },
  "locale": {
    "en-US": "अंग्रेजी (US)",
    "ne-NP": "नेपाली (NP)"
  },
  "fiscalYears": {
    "messages": {
      "createSuccess": "आर्थिक वर्ष सफलतापूर्वक सिर्जना गरियो।",
      "generatePeriodsSuccess": "आर्थिक अवधिहरू सफलतापूर्वक उत्पन्न गरियो।"
    }
  },
  "operations.platform.integration.bootstrap-attestation.ingest.label": "रनटाइम बुटस्ट्र्याप पूरा भएको प्रमाण स्वीकार गर्नुहोस्",
  "operations.platform.integration.bootstrap-attestation.ingest.description": "इन्स्टलेसनले स्थानीय संस्था बुटस्ट्र्याप र प्रारम्भिक प्रयोग ह्यान्डसेक पूरा गरेको गोपनीयता-सीमित प्रमाण प्रमाणित र सुरक्षित गर्नुहोस्।",
  "reportsWorkspace": {
    "live": {
      "changeParameters": "मापदण्ड परिवर्तन गर्नुहोस्",
      "exportAvailable": "निर्यात उपलब्ध",
      "pageCoverage": "{{total}} मध्ये {{from}}–{{to}} पङ्क्ति देखाइँदैछ।",
      "previousPage": "अघिल्लो",
      "nextPage": "अर्को",
      "pageNumber": "पृष्ठ {{page}} / {{pages}}",
      "title": "शासित प्रत्यक्ष प्रतिवेदन",
      "description": "हालको सन्दर्भका लागि स्वीकृत प्रतिवेदन र मापदण्ड मात्र चलाउनुहोस्। नतिजाले स्रोतको ताजापन, गणना संस्करण र प्रमाण वंशावली सुरक्षित राख्छ।",
      "summary": "प्रतिवेदन सारांश",
      "lineage": "डाटा वंशावली र प्रमाण",
      "sourceAsOf": "स्रोतको मिति",
      "partialData": "यो प्रतिवेदन आंशिक छ। कुलमा भर पर्नुअघि मुद्रा, मूल्याङ्कन, मिलान वा लेजर प्रमाण समीक्षा गर्नुहोस्।",
      "empty": "चयन गरिएका मापदण्ड र स्वीकृत दायराका लागि कुनै पङ्क्ति भेटिएन।",
      "unavailable": "जोड्न नमिल्ने",
      "noReportsAvailable": "तपाईंको हालको सन्दर्भका लागि कुनै प्रत्यक्ष प्रतिवेदन उपलब्ध छैन। यो त्रुटि भएको लागेमा प्रशासकलाई सम्पर्क गर्नुहोस्।",
      "truncated": "{{returned}} मध्ये {{total}} पङ्क्तिहरू देखाइएको छ। यो प्रतिवेदन काटिएको छ।",
      "truncatedExportPrompt": "पूर्ण परिणामका लागि निर्यात प्रयोग गर्नुहोस्।",
      "openWorkspace": "प्रतिवेदन कार्यक्षेत्र खोल्नुहोस्",
      "parametersUsed": "रिपोर्ट दायरा र अवधि",
      "favorites": "मनपर्ने",
      "recent": "पछिल्ला प्रतिवेदन",
      "addFavorite": "मनपर्नेमा थप्नुहोस्",
      "removeFavorite": "मनपर्नेबाट हटाउनुहोस्",
      "savedViews": "सुरक्षित मापदण्ड दृश्यहरू",
      "savedViewsDescription": "पुनः प्रयोग गर्न मिल्ने गैर-संवेदनशील प्रतिवेदन मापदण्ड सुरक्षित गर्नुहोस्। ग्राहक, पोर्टफोलियो, खाता र अन्य दायरा पहिचान ब्राउजरमा कहिल्यै सुरक्षित हुँदैनन्।",
      "savedViewName": "दृश्यको नाम",
      "saveView": "दृश्य सुरक्षित गर्नुहोस्",
      "details": "विवरण",
      "defaultParameters": "पूर्वनिर्धारित रिपोर्ट दायरा",
      "selectedScope": "छनोट गरिएको",
      "currentData": "हालको डेटा · {{date}} सम्म",
      "rowRange": "{{from}}–{{to}} / {{total}}",
      "deleteSavedView": "सुरक्षित दृश्य हटाउनुहोस्",
      "saveCurrentView": "हालको दृश्य सुरक्षित गर्नुहोस्"
    },
    "scope": {
      "organization": "संस्था दायरा",
      "client": "ग्राहक दायरा"
    },
    "navigation": {
      "live": "प्रत्यक्ष दृश्यहरू",
      "label": "रिपोर्टिङ क्षेत्रहरू",
      "library": "रिपोर्टहरू",
      "regulatory": "नियामकीय फाइलिङ",
      "operations": "मूल्याङ्कन र नियन्त्रण"
    },
    "liveViews": {
      "title": "प्रत्यक्ष वित्तीय दृश्यहरू",
      "description": "प्रत्येक रिपोर्ट छुट्टाछुट्टै कन्फिगर नगरी पछिल्लो आधिकारिक पोर्टफोलियो, गतिविधि, लेखा र नियन्त्रण जानकारी समीक्षा गर्नुहोस्।",
      "snapshot": "स्न्यापसट",
      "latestAvailable": "पछिल्लो उपलब्ध",
      "chooseDate": "मिति छान्नुहोस्",
      "asOfDate": "मिति सम्म",
      "upperBound": "वित्तीय मितिको माथिल्लो सीमा: {{date}}",
      "authorityNote": "प्रत्येक दृश्यले चयन गरिएको वित्तीय मितिमा वा त्यसअघि उपलब्ध सम्बन्धित आधिकारिक स्रोत मिति स्वतन्त्र रूपमा समाधान गर्छ। पोर्टफोलियो, लेजर, कारोबार र मेलमिलाप स्रोतका मिति फरक हुन सक्छन्।",
      "openFullReport": "पूर्ण रिपोर्ट खोल्नुहोस्",
      "reportContext": "दृश्य: {{context}} · स्रोत {{source}} सम्म",
      "sourceNotAvailable": "उपलब्ध छैन",
      "unavailable": "यो दृश्य चयन गरिएको मिति वा अनुमति प्राप्त दायराका लागि हाल उपलब्ध छैन। अन्य प्रत्यक्ष दृश्यहरू प्रयोग गर्न सकिन्छ।",
      "partial": "यो दृश्य आंशिक छ। जम्मा रकममा निर्भर हुनुअघि स्रोत मिति र डेटा गुणस्तर विवरण समीक्षा गर्नुहोस्।",
      "empty": "यो दृश्य र मितिका लागि कुनै रिपोर्ट डेटा उपलब्ध छैन।",
      "homeAction": "प्रत्यक्ष वित्तीय विवरण हेर्नुहोस्",
      "noViewsTitle": "कुनै प्रत्यक्ष दृश्य उपलब्ध छैन",
      "noViewsDescription": "हालको पहुँच र शाखाका लागि कुनै आवश्यक प्रत्यक्ष रिपोर्ट अनुमति प्राप्त छैन।",
      "states": {
        "current": "हालको",
        "stale": "पुरानो",
        "partial": "आंशिक",
        "empty": "डेटा छैन",
        "unavailable": "उपलब्ध छैन"
      },
      "sections": {
        "portfolio": "पोर्टफोलियो",
        "activity_accounting": "गतिविधि र लेखा",
        "controls": "नियन्त्रण"
      },
      "sectionDescriptions": {
        "portfolio": "नियन्त्रित लगानी तथ्यबाट हालको स्थिति, मूल्याङ्कन र पोर्टफोलियो प्रदर्शन।",
        "activity_accounting": "सम्बन्धित वित्तीय अवधिका हालका लगानी गतिविधि र लेखा परिणाम।",
        "controls": "वित्तीय पूर्णता र सन्तुलन पुष्टि गर्न प्रयोग हुने पछिल्लो मेलमिलाप र लेजर नियन्त्रण दृश्य।"
      }
    },
    "library": {
      "title": "रिपोर्टहरू",
      "description": "सञ्चालन नियन्त्रणहरूमा नजाइकन आवश्यक वित्तीय रिपोर्ट छान्नुहोस् र चलाउनुहोस्।",
      "searchPlaceholder": "रिपोर्ट खोज्नुहोस्",
      "category": "श्रेणी",
      "allCategories": "सबै श्रेणी",
      "quickAccess": "छिटो पहुँच",
      "noResultsTitle": "मिल्ने रिपोर्ट भेटिएन",
      "noResultsDescription": "अर्को रिपोर्ट नाम, वित्तीय विषय वा श्रेणी प्रयोग गरेर खोज्नुहोस्।"
    },
    "regulatory": {
      "title": "नियामकीय फाइलिङ",
      "description": "रिपोर्ट परिभाषा व्यवस्थापन गर्नुहोस्, फाइलिङ रन सिर्जना गर्नुहोस्, नतिजा प्रमाणीकरण गर्नुहोस् र सम्पन्न आर्टिफ्याक्ट खोल्नुहोस्।",
      "noAccess": "तपाईंलाई संगठनको नियामक प्रतिवेदन हेर्ने अनुमति छैन।",
      "adminOnly": "नियामक परिभाषा, प्रतिवेदन उत्पादन, प्रमाणीकरण र पेश गर्ने कार्य संगठन प्रशासकका लागि उपलब्ध छन्।"
    },
    "regulatoryTable": {
      "report": "रिपोर्ट",
      "code": "कोड",
      "body": "नियामकीय निकाय",
      "period": "रिपोर्टिङ अवधि",
      "status": "स्थिति",
      "created": "सिर्जना मिति",
      "action": "कार्य"
    },
    "actions": {
      "more": "थप कार्यहरू",
      "openDashboard": "ड्यासबोर्ड खोल्नुहोस्",
      "newDefinition": "नयाँ परिभाषा",
      "generateRun": "प्रतिवेदन तयार गर्नुहोस्",
      "cancelRun": "रन रद्द गर्नुहोस्",
      "retryRun": "रन पुनः प्रयास गर्नुहोस्",
      "disable": "निष्क्रिय बनाउनुहोस्",
      "validate": "प्रमाणीकरण गर्नुहोस्",
      "submit": "पेश गर्नुहोस्",
      "artifact": "कलाकृति खोल्नुहोस्",
      "generate": "तयार गर्नुहोस्"
    },
    "artifact": {
      "description": "सम्पन्न फाइलिङ नतिजा समीक्षा गर्नुहोस् र अनुमति प्राप्त ढाँचामा डाउनलोड गर्नुहोस्।",
      "title": "प्रतिवेदन कलाकृति",
      "download": "कलाकृति डाउनलोड गर्नुहोस्",
      "downloadCsv": "CSV डाउनलोड गर्नुहोस्",
      "downloadJson": "JSON डाउनलोड गर्नुहोस्"
    },
    "operations": {
      "title": "मूल्याङ्कन र नियन्त्रण",
      "description": "आवश्यक मूल्याङ्कन वा वित्तीय नियन्त्रण कार्यका लागि सम्बन्धित कार्यक्षेत्र खोल्नुहोस्।",
      "open": "कार्यक्षेत्र खोल्नुहोस्",
      "emptyTitle": "कुनै सञ्चालन कार्यक्षेत्र उपलब्ध छैन",
      "emptyDescription": "हालको पहुँच र शाखाका लागि कुनै मूल्याङ्कन वा नियन्त्रण कार्यक्षेत्र अनुमति प्राप्त छैन।",
      "unavailableTitle": "कार्यक्षेत्र उपलब्ध छैन",
      "unavailableDescription": "यो कार्यक्षेत्र हालको पहुँच र शाखाका लागि उपलब्ध छैन।",
      "fixedIncome": {
        "title": "स्थिर आय मूल्याङ्कन",
        "description": "स्थिर आय उपकरणको मूल्याङ्कन गर्नुहोस् र सम्बन्धित ओभरराइड, जीवनचक्र तथा ऋण घटना कार्यहरू व्यवस्थापन गर्नुहोस्।",
        "calculateTitle": "मूल्याङ्कन गणना",
        "calculateDescription": "पोर्टफोलियो, उपकरण र वित्तीय मिति छान्नुहोस्। गणनाले नियन्त्रित बजार तथा उपकरण डेटा प्रयोग गर्छ।",
        "overridesTitle": "मूल्याङ्कन ओभरराइड",
        "overridesDescription": "अपवाद आवश्यक हुँदा मात्र अनुमति प्राप्त उपकरण-विशिष्ट मूल्याङ्कन ओभरराइड समीक्षा वा व्यवस्थापन गर्नुहोस्।",
        "overrideDisclosure": "{{effectiveFrom}} देखि {{effectiveTo}} सम्म स्वीकृत मूल्याङ्कन ओभरराइड लागू गरिएको छ।"
      },
      "valuationRuns": {
        "title": "पोर्टफोलियो मूल्याङ्कन रनहरू",
        "description": "नियन्त्रित पोर्टफोलियो मूल्याङ्कन रन सिर्जना, समीक्षा, स्वीकृति, प्रकाशन र पुनःखोल्ने कार्य गर्नुहोस्।",
        "selectedPortfolio": "छनोट गरिएको पोर्टफोलियो",
        "createTitle": "पोर्टफोलियो मूल्याङ्कन चलाउनुहोस्",
        "createDescription": "नियन्त्रित मूल्याङ्कन स्न्यापसट सिर्जना गर्न पोर्टफोलियो र मिति छान्नुहोस्।",
        "historyTitle": "मूल्याङ्कन इतिहास",
        "historyDescription": "मूल्याङ्कन स्थिति, डेटा गुणस्तर र अर्को अनुमति प्राप्त जीवनचक्र कार्य समीक्षा गर्नुहोस्।",
        "portfolio": "पोर्टफोलियो",
        "dataQuality": "डेटा गुणस्तर",
        "complete": "पूर्ण",
        "needsAttention": "ध्यान आवश्यक",
        "view": "हेर्नुहोस्",
        "reasonTitle": "कारण आवश्यक",
        "detailsTitle": "मूल्याङ्कन रन विवरण",
        "prices": "मूल्यहरू",
        "fx": "विदेशी विनिमय",
        "corporateActions": "कर्पोरेट कार्यहरू",
        "cash": "नगद",
        "evidence": "प्रमाण र वंशावली"
      },
      "cutoffControls": {
        "title": "कटअफ नियन्त्रण",
        "description": "अवधि-अन्त नियन्त्रण नतिजा, ब्रेक तथा स्रोत, सबलेजर र पोस्टिङ प्रमाण समीक्षा गर्नुहोस्।",
        "latestRun": "सबैभन्दा पछिल्लो उपलब्ध कटअफ नियन्त्रण रन",
        "breaksDescription": "स्रोत र लेजर मानबीच समीक्षा आवश्यक पर्ने अन्तरहरू।",
        "noBreaks": "यस रनका लागि कुनै ब्रेक रेकर्ड गरिएको छैन।",
        "control": "नियन्त्रण",
        "kind": "प्रकार",
        "source": "स्रोत",
        "ledger": "लेजर",
        "difference": "अन्तर",
        "reference": "सन्दर्भ",
        "dimension": "आयाम",
        "amount": "रकम",
        "journal": "जर्नल",
        "account": "खाता",
        "debit": "डेबिट",
        "credit": "क्रेडिट"
      }
    },
    "branch": "शाखा",
    "controls": {
      "title": "मूल्याङ्कन र नियन्त्रण कार्यप्रवाह",
      "description": "नियन्त्रित मूल्याङ्कन, कटअफ र समीक्षा कार्यप्रवाह चलाउनुहोस्। यी परिचालन नियन्त्रण हुन्, रिपोर्ट परिणाम होइनन्।"
    },
    "title": "प्रतिवेदन",
    "subtitle": "पोर्टफोलियो अन्तर्दृष्टि र शासित नियामक प्रतिवेदन एउटै कार्यस्थलमा।",
    "clientSubtitle": "तपाईंको ग्राहक पहिचानमा तोकिएका अभिलेखका लागि पढ्न मात्र मिल्ने प्रतिवेदन।",
    "context": "प्रतिवेदन सन्दर्भ",
    "tabs": {
      "reports": "प्रतिवेदन",
      "regulatory": "नियामक",
      "controls": "नियन्त्रण"
    },
    "search": {
      "placeholder": "शीर्षक वा विवरणद्वारा प्रतिवेदन खोज्नुहोस्"
    },
    "status": {
      "running": "चलिरहेको",
      "completed": "पूरा भयो",
      "failed": "असफल भयो",
      "submitted": "पेश भयो",
      "acknowledged": "स्वीकार गरियो"
    },
    "client": {
      "scopeNotice": "यो कार्यस्थल तपाईंका आफ्नै ग्राहक अभिलेखमा सीमित छ। संगठन-व्यापी नियामक प्रतिवेदन र प्रशासनिक कार्य उपलब्ध छैनन्।",
      "portfolioTitle": "पोर्टफोलियो अवलोकन",
      "portfolioDescription": "हालको ग्राहक-सीमित अवलोकनका लागि आफ्नो ड्यासबोर्डमा फर्कनुहोस्।",
      "deliveryTitle": "प्रतिवेदन वितरण",
      "deliveryDescription": "तपाईंको संगठनले प्रकाशित गरेपछि ग्राहक विवरण र डाउनलोडयोग्य कलाकृति यहाँ देखिनेछन्।"
    },
    "portfolio": {
      "title": "पोर्टफोलियो अन्तर्दृष्टि",
      "description": "शासित लगानी डाटा सतहबाट हालको स्थिति र मूल्याङ्कन तथ्य।",
      "partialData": "एउटा पोर्टफोलियो डाटा स्रोत उपलब्ध छैन। बाँकी अंकहरू आंशिक डाटाका रूपमा देखाइएका छन्।",
      "marketValue": "बजार मूल्य",
      "costBasis": "लागत आधार",
      "unrealized": "अप्राप्त नाफा वा घाटा",
      "positions": "स्थिति"
    },
    "feedback": {
      "definitionSaved": "प्रतिवेदन परिभाषा सुरक्षित भयो।",
      "definitionDisabled": "प्रतिवेदन परिभाषा निष्क्रिय बनाइयो।",
      "runStarted": "प्रतिवेदन उत्पादन सुरु भयो।",
      "runCancelled": "प्रतिवेदन रन रद्द गरियो।",
      "runRetried": "प्रतिवेदन रन पुनः प्रयासका लागि लाइनमा राखियो।",
      "validated": "प्रतिवेदन प्रमाणीकरण पूरा भयो।",
      "submitted": "प्रतिवेदन पेश भयो।",
      "actionFailed": "प्रतिवेदन कार्य पूरा गर्न सकिएन। प्रतिवेदन स्थिति समीक्षा गरेर पुनः प्रयास गर्नुहोस्।"
    },
    "definitions": {
      "title": "प्रतिवेदन परिभाषाहरू",
      "description": "प्रतिवेदन उत्पादन नियन्त्रण गर्ने पुनःप्रयोगयोग्य, शासित परिभाषाहरू।",
      "emptyTitle": "प्रतिवेदन परिभाषा छैन",
      "emptyDescription": "प्रतिवेदन चलाउनुअघि एउटा प्रतिवेदन परिभाषा सिर्जना गर्नुहोस्।"
    },
    "runs": {
      "title": "प्रतिवेदन चलाइहरू",
      "description": "तयार गरिएका प्रतिवेदन र तिनको प्रमाणीकरण तथा पेश गर्ने जीवनचक्र।",
      "emptyTitle": "प्रतिवेदन चलाइएको छैन",
      "emptyDescription": "जीवनचक्र सुरु गर्न सक्रिय परिभाषाबाट प्रतिवेदन तयार गर्नुहोस्।",
      "periodNotSpecified": "प्रतिवेदन अवधि निर्दिष्ट गरिएको छैन",
      "progress": "{{state}}: {{percent}}% पूरा भयो"
    },
    "definitionForm": {
      "createTitle": "प्रतिवेदन परिभाषा सिर्जना गर्नुहोस्",
      "editTitle": "प्रतिवेदन परिभाषा सम्पादन गर्नुहोस्",
      "code": "प्रतिवेदन कोड",
      "name": "प्रतिवेदन नाम",
      "type": "प्रतिवेदन प्रकार",
      "body": "नियामक निकाय",
      "types": {
        "sebonMonthly": "सेबोन मासिक कारोबार प्रतिवेदन",
        "irdCgt": "आन्तरिक राजस्व विभाग पूँजीगत लाभ अनुसूची",
        "nrbQuarterly": "नेपाल राष्ट्र बैंक त्रैमासिक प्रतिवेदन",
        "fiuAmlCtf": "वित्तीय जानकारी इकाइ सम्पत्ति शुद्धीकरण प्रतिवेदन"
      }
    },
    "runForm": {
      "title": "प्रतिवेदन तयार गर्नुहोस्",
      "definition": "प्रतिवेदन परिभाषा",
      "start": "अवधि सुरु",
      "end": "अवधि अन्त्य"
    }
  },
  "clientReporting": {
    "home": {
      "title": "तपाईंको पोर्टफोलियो",
      "subtitle": "तपाईंको व्यवस्थापन गरिएको लगानी र पछिल्लो विवरणको सरल दृश्य।",
      "asOf": "{{date}} सम्मका मूल्यहरू",
      "managedAccount": "व्यवस्थापन गरिएको खाता",
      "portfolioValue": "पोर्टफोलियो मूल्य",
      "performanceUnavailable": "यस दृश्यका लागि कार्यसम्पादन हाल उपलब्ध छैन।",
      "totalGain": "कुल नाफा {{value}}",
      "totalLoss": "कुल घाटा {{value}}",
      "investmentReturn": "लगानी प्रतिफल",
      "returnExplanation": "अन्तिम समय-भारित प्रतिफल उपलब्ध हुँदा जम्मा र निकासीको प्रभाव हटाएर प्रतिफल देखाइन्छ।",
      "returnUnavailable": "यस दायराका लागि भरपर्दो प्रतिफल उपलब्ध छैन।",
      "cash": "नगद",
      "latestStatement": "पछिल्लो पोर्टफोलियो विवरण",
      "latestStatementDescription": "लगानी, गतिविधि, शुल्क, कर र मूल्याङ्कन नोटसहित पूरा भएको विवरण हेर्नुहोस्।",
      "viewStatement": "विवरण हेर्नुहोस्",
      "investments": "तपाईंका लगानीहरू",
      "investmentsDescription": "तपाईंका सबैभन्दा ठूला हालका होल्डिङ। थप विवरणका लागि पूर्ण लगानी प्रतिवेदन खोल्नुहोस्।",
      "investment": "लगानी",
      "viewAllInvestments": "सबै लगानी हेर्नुहोस्",
      "noInvestments": "देखाउन लगानी छैन",
      "noInvestmentsDescription": "तपाईंको व्यवस्थापन गरिएको खातामा हाल प्रतिवेदनयोग्य होल्डिङ छैन।"
    },
    "reports": {
      "title": "विवरण र प्रतिवेदन",
      "subtitle": "सञ्चालन वा लेखा जटिलता बिना तपाईंको व्यवस्थापन गरिएको खाता बुझ्न आवश्यक कागजात र दृश्यहरू।",
      "statementTitle": "पोर्टफोलियो विवरण",
      "statementDescription": "लगानी, नगद, कार्यसम्पादन, गतिविधि, शुल्क, कर र महत्वपूर्ण मूल्याङ्कन नोटसहितको आवधिक पोर्टफोलियो तस्वीर।",
      "performanceTitle": "तपाईंको कार्यसम्पादन",
      "performanceDescription": "अन्तिम पोर्टफोलियो प्रतिफल विधि प्रयोग गरेर छनोट अवधिमा तपाईंका लगानीले कस्तो प्रदर्शन गरे हेर्नुहोस्।",
      "investmentsTitle": "तपाईंका लगानीहरू",
      "investmentsDescription": "तपाईंले हाल राखेका लगानी र तिनका पछिल्ला शासित मूल्यहरू हेर्नुहोस्।",
      "accountDetailsTitle": "खाता र कस्टडी विवरण",
      "accountDetailsDescription": "आवश्यक हुँदा तपाईंको व्यवस्थापन गरिएको पोर्टफोलियोसँग सम्बन्धित पहिचान र कस्टडी प्रमाण समीक्षा गर्नुहोस्।",
      "recommended": "सिफारिस गरिएको",
      "viewStatement": "विवरण हेर्नुहोस्",
      "open": "खोल्नुहोस्",
      "back": "विवरणहरूमा फर्कनुहोस्",
      "taxDocuments": "कर कागजात",
      "emptyTitle": "अहिले कुनै प्रतिवेदन उपलब्ध छैन",
      "emptyDescription": "तपाईंको खाताका प्रतिवेदन कागजात उपलब्ध भएपछि यहाँ देखिनेछन्।",
      "moreReports": "थप रिपोर्टहरू"
    },
    "statement": {
      "notAvailableTitle": "पूरा भएको विवरण उपलब्ध छैन",
      "notAvailableDescription": "यस खाता वा छनोट अवधिका लागि पूरा भएको पोर्टफोलियो विवरण अझै प्रकाशित भएको छैन।",
      "latestPeriod": "पछिल्लो पूरा भएको विवरण",
      "period": "विवरण अवधि",
      "asOf": "{{date}} सम्मका मूल्यहरू",
      "partial": "केही मूल्यमा ध्यान आवश्यक छ",
      "current": "विवरण पूरा छ",
      "portfolioValue": "पोर्टफोलियो मूल्य",
      "multipleCurrencies": "धेरै मुद्रा",
      "periodEndValue": "विवरण अवधिको अन्त्यको मूल्य",
      "investmentReturn": "लगानी प्रतिफल",
      "returnExplanation": "विवरण अवधिको अन्तिम समय-भारित प्रतिफल।",
      "returnUnavailable": "यस विवरण अवधिका लागि अन्तिम प्रतिफल उपलब्ध छैन।",
      "compositeReturnUnavailable": "यो विवरणमा धेरै पोर्टफोलियो छन् र शासित संयुक्त प्रतिफल उपलब्ध छैन, त्यसैले प्रतिफललाई औसत गरिएको छैन।",
      "findAnother": "अर्को विवरण खोज्नुहोस्",
      "printOrSavePdf": "प्रिन्ट / PDF सुरक्षित गर्नुहोस्",
      "downloadDetails": "विवरण डाउनलोड गर्नुहोस्",
      "investments": "लगानी",
      "investmentsDescription": "विवरण मितिमा तपाईंले राखेका लगानी र विवरणमा प्रयोग गरिएको पछिल्लो शासित मूल्य।",
      "investment": "लगानी",
      "allocation": "यस मुद्राको लगानी मूल्यको {{value}}",
      "quantity": "परिमाण {{value}}",
      "value": "मूल्य",
      "gainLoss": "नाफा / घाटा",
      "noInvestments": "यस विवरणमा लगानी छैन",
      "noInvestmentsDescription": "विवरण मितिमा प्रतिवेदनयोग्य स्थिति थिएन।",
      "cash": "नगद",
      "activity": "गतिविधि",
      "activityDescription": "यस विवरण अवधिमा समावेश गरिएको पछिल्लो पोस्ट गरिएको गतिविधि।",
      "feesAndTaxes": "शुल्क र कर",
      "fees": "प्रमाणित मुद्रासहितको शुल्क",
      "taxes": "कर",
      "aboutValues": "यी मूल्यहरूको बारेमा",
      "cashDescription": "स्टेटमेन्ट कटअफमा पोर्टफोलियोमा रहेको नगद।",
      "showAll": "सबै {{count}} देखाउनुहोस्",
      "showLess": "कम देखाउनुहोस्"
    }
  },
  "financialDataQuality": {
    "current": "हालको वित्तीय डाटा",
    "delayed": "वित्तीय डाटा ढिलो आएको छ। भर पर्नुअघि स्रोत समय समीक्षा गर्नुहोस्।",
    "stale": "वित्तीय डाटा पुरानो छ। मानहरूले हालको बजार, लेजर वा कस्टडी अवस्था नदेखाउन सक्छन्।",
    "partial": "वित्तीय डाटा आंशिक छ। छुटेका वा हटाइएका इनपुटलाई शून्यको रूपमा देखाइएको छैन।",
    "unavailable": "वित्तीय डाटा उपलब्ध छैन। प्रमाण नभएको स्थानमा कुनै मान देखाइएको छैन।",
    "sourceBook": "स्रोत बुक",
    "asOf": "मिति सम्म",
    "generatedAt": "तयार गरिएको समय",
    "calculationVersion": "गणना संस्करण",
    "restatement": "पुनःप्रस्तुतीकरण अवस्था",
    "lineage": "वंशावली र प्रमाण हेर्नुहोस्"
  },
  "table": {
    "export": {
      "help": "निर्यात गर्ने रेकर्ड र व्यवसायिक फिल्डहरू छान्नुहोस्। डिस्क्रिप्टरले निर्यात गर्न नमिल्ने भनेका बाहेक लुकाइएका तालिका फिल्डहरू पनि उपलब्ध हुन्छन्।",
      "visibleFields": "देखिएका फिल्डहरू",
      "scope": "निकास का व्यापक",
      "currentPage": "वर्तमान पृष्ठ",
      "selectedRows": "चुनी हुई रो",
      "allMatching": "सबै मेल खाने हुने",
      "configureSchema": "स्किमा परिभाषित गर्नुहोस्",
      "availableFields": "उपलब्ध क्षेत्रहरू",
      "schemaFields": "निर्यात स्किमा",
      "schemaHelp": "उपलब्ध सूचीबाट क्षेत्रहरूलाई निर्यात स्थानहरूमा तान्नुहोस् र स्लटहरूबीच तानेर पुन:क्रम मिलाउनुहोस्।",
      "position": "निर्यात स्तम्भ {{position}}",
      "dropField": "क्षेत्र यहाँ छोड्नुहोस्",
      "included": "समावेश गरिएको",
      "available": "उपलब्ध",
      "resetSchema": "स्किमा रिसेट गर्नुहोस्",
      "applySchema": "स्किमा लागू गर्नुहोस्",
      "selectAll": "सबै चयन गर्नुहोस्",
      "deselectAll": "सबै चयन हटाउनुहोस्",
      "fieldsSelected": "{{total}} मध्ये {{selected}} क्षेत्र चयनित"
    },
    "resizeColumn": "स्तम्भ परिवर्तन गर्नुहोस्",
    "actions": "कार्यहरू",
    "moreActions": "बहुत कार्यान्वयन",
    "selectRow": "रोइँको चुन्नाला",
    "collapseDetails": "विस्तार नपाउनाला",
    "expandDetails": "विस्तार कर्नाला",
    "showLess": "देखी जाने हुने कुर्सी कम कर्नाला",
    "showMore": "देखी जाने हुने कुर्सी बढ़ानाला",
    "globalSearch": {
      "placeholder": "खोज..."
    },
    "clearFilters": "फिल्टर साफ कर्नाला",
    "groupBy": "समूह र कुल",
    "sum": "कुल",
    "showFilterRow": "फिल्टर रोइँको दिखाउनाला",
    "hideFilterRow": "फिल्टर रोइँको छुपाउनाला",
    "showFilters": "फिल्टर दिखाउनाला",
    "hideFilters": "फिल्टर छुपाउनाला",
    "columns": "स्तम्भहरू",
    "searchColumns": "पश्चिमा खोज क्षेत्र",
    "pinnedLeft": "पश्चिमी पक्ष",
    "pinnedRight": "पश्चिमी पक्ष",
    "showAll": "सबै प्रकार",
    "hideOptional": "अनावश्यक को लुकाउनुहोस्",
    "resetLayout": "लेइट सेट करे",
    "densityLabel": "घनता",
    "density": {
      "compact": "संक्षिप्त",
      "standard": "प्रमाणित",
      "comfortable": "अनुकूल"
    },
    "refresh": "रिफ्रेस गर्नुहोस्",
    "exportLabel": "निकाल",
    "bulkActions": "मात्रा कार्य",
    "rowSelected": "रो चयनित",
    "rowsSelected": "रो चयनित",
    "savedViews": "भंडारण दृश्य",
    "saveViewAs": "दृश्य को सेवा के रूप में",
    "unsavedChanges": "अपडेट न गरिएका परिवर्तन",
    "resetFilters": "फिल्टर रीसेट कर",
    "resetAll": "सब कुछ रीसेट कर",
    "resultsCount": "{{count}} परिणाम",
    "perPage": "प्रति पृष्ठ",
    "rowsPerPage": "पृष्ठ/परिणाम",
    "pageInfo": "{{start}}-{{end}} को {{total}}",
    "pageOf": "पृष्ठ {{current}} of {{total}}",
    "firstPage": "प्रथम पृष्ठ",
    "previousPage": "पिछला पृष्ठ",
    "nextPage": "आगे का पृष्ठ",
    "lastPage": "अंतिम पृष्ठ",
    "collapseGroup": "समूह को संकुचित कर",
    "expandGroup": "समूह को विस्तारित कर",
    "aggregates": "जो: {{value}}",
    "row": "पंक्ति",
    "rows": "पृष्ठ",
    "group": {
      "nullValue": "कुनै पनि"
    },
    "loading": "ग्राहक खाताहरू लोड गर्दै…",
    "viewOptions": "दृश्य विकल्पहरू",
    "emptyState": {
      "readOnlyHint": "यो डाटा कारोबार र प्रारम्भिक मौजदाबीबाट प्राप्त हुन्छ। यसलाई भर्न कारोबार पोस्ट गर्नुहोस् वा प्रारम्भिक मौजदाबी आयात गर्नुहोस्।"
    },
    "selected": "चयनित",
    "resultsCount_one": "{{count}} परिणाम",
    "resultsCount_other": "{{count}} परिणाम"
  },
  "lotTimeline": {
    "title": "लट समयरेखा (FIFO)",
    "summary": "{{lots}} लट, {{disposals}} बिक्री उपयोग",
    "openLots": "खुला लटहरू",
    "closedLots": "बन्द लटहरू",
    "disposals": "बिक्री उपयोग र प्राप्त नाफा वा नोक्सानी",
    "acquired": "प्राप्त मिति",
    "source": "स्रोत",
    "originalQuantity": "मूल परिमाण",
    "remaining": "बाँकी",
    "costPerUnit": "प्रति एकाइ लागत",
    "totalCost": "कुल लागत",
    "status": "स्थिति",
    "disposalDate": "बिक्री उपयोग मिति",
    "lotAcquired": "लट प्राप्त मिति",
    "quantitySold": "बिक्री परिमाण",
    "salePrice": "बिक्री मूल्य",
    "holdingDays": "धारण दिन",
    "realizedGainLoss": "प्राप्त नाफा वा नोक्सानी",
    "empty": "यस कारोबारका लागि कुनै लट वा बिक्री उपयोग उपलब्ध छैन।",
    "expand": "लट समयरेखा विस्तार गर्नुहोस्",
    "collapse": "लट समयरेखा संकुचित गर्नुहोस्"
  },
  "data": {
    "marketPrices": {
      "description": "बजार-मूल्य अवलोकन समीक्षा गर्नुहोस्, छुटेको अवलोकन थप्नुहोस्, ब्याच आयात गर्नुहोस्, र प्रमाणसहित विद्यमान अवलोकन सच्याउनुहोस्।",
      "createTitle": "बजार मूल्य थप्नुहोस्",
      "createDescription": "नियन्त्रित इन्स्ट्रुमेन्टका लागि नयाँ बजार-मूल्य अवलोकन अभिलेख गर्नुहोस्। यस संस्करणमा मुद्रा इन्स्ट्रुमेन्टबाट निर्धारण हुन्छ; विद्यमान अवलोकन सच्याउनुपर्छ, माथि लेख्न मिल्दैन।",
      "editTitle": "बजार मूल्य सच्याउनुहोस्",
      "editDescription": "प्रमाणसहित संशोधन अभिलेख गर्नुहोस्। परिवर्तन भएका अवलोकन फिल्ड मात्र अद्यावधिक हुन्छन्; मूल मूल्य र अघिल्लो संस्करण अडिटयोग्य रहन्छन्।",
      "detailTitle": "बजार मूल्य विवरण",
      "detailDescription": "मूल्याङ्कन र रिपोर्टिङमा प्रयोग हुने मूल्य, स्रोत, ताजापन, संस्करण र वंशावली समीक्षा गर्नुहोस्।",
      "createSuccess": "बजार मूल्य थपियो।",
      "correctSuccess": "बजार मूल्य संशोधन अभिलेख गरियो।",
      "detail": {
        "title": "बजार डाटा विवरण"
      },
      "actions": {
        "add": "मूल्य थप्नुहोस्",
        "correct": "सच्याउनुहोस्",
        "recordCorrection": "संशोधन अभिलेख गर्नुहोस्"
      },
      "columns": {
        "instrumentSymbol": "सङ्केत",
        "instrumentName": "वित्तीय साधन",
        "tradedDate": "कारोबार मिति",
        "open": "खुला",
        "high": "उच्च",
        "low": "न्यून",
        "close": "बन्द",
        "last": "अन्तिम कारोबार",
        "volume": "परिमाण",
        "turnover": "कारोबार रकम",
        "tradeCount": "कारोबार संख्या",
        "observationKind": "अवलोकन प्रकार",
        "priceType": "मूल्याङ्कन / मेट्रिक प्रकार",
        "canonicalPrice": "आधिकारिक मूल्याङ्कन मूल्य",
        "price": "संग्रहित अवलोकन मान",
        "currency": "मुद्रा",
        "exchange": "विनिमय बजार",
        "source": "स्रोत",
        "freshness": "ताजापन",
        "asOf": "मिति अनुसार",
        "createdAt": "प्रविष्टि समय",
        "updatedAt": "पछिल्लो अद्यावधिक",
        "sourceEntity": "स्रोत इकाइ",
        "sourceRecordId": "स्रोत रेकर्ड आईडी",
        "asOfDate": "स्रोत मिति अनुसार",
        "effectiveTimestamp": "प्रभावकारी समयचिह्न",
        "restatementState": "पुनःस्थापन स्थिति",
        "lineage": "लाइनएज"
      },
      "fields": {
        "instrumentSymbol": "इन्स्ट्रुमेन्ट",
        "instrumentName": "वित्तीय साधनको नाम",
        "tradedDate": "कारोबार मिति",
        "source": "स्रोत",
        "open": "खुला",
        "high": "उच्च",
        "low": "न्यून",
        "close": "बन्द",
        "last": "अन्तिम कारोबार मूल्य",
        "volume": "परिमाण",
        "turnover": "कारोबार रकम",
        "tradeCount": "कारोबार संख्या",
        "observationKind": "अवलोकन प्रकार",
        "priceType": "मूल्य प्रकार",
        "price": "मूल्य",
        "currency": "मुद्रा",
        "exchange": "विनिमय बजार",
        "freshness": "ताजापन",
        "createdAt": "अभिलेख समय",
        "updatedAt": "पछिल्लो अद्यावधिक",
        "reason": "सच्याउने कारण",
        "expectedVersion": "अभिलेख संस्करण"
      },
      "help": {
        "instrument": "इन्स्ट्रुमेन्टको नाम वा प्रतीकबाट खोज्नुहोस्। यस संस्करणमा इन्स्ट्रुमेन्टले अवलोकन मुद्रा निर्धारण गर्छ।",
        "source": "प्रशासकले प्रविष्ट गरेको अवलोकनका लागि MANUAL प्रयोग गर्नुहोस् वा थाहा भए आधिकारिक स्रोत उल्लेख गर्नुहोस्।",
        "open": "सत्रको पहिलो कारोबार मूल्य।",
        "high": "सत्रको सबैभन्दा उच्च कारोबार मूल्य; खुला, बन्द वा अन्तिम कारोबार मूल्यभन्दा कम हुन सक्दैन।",
        "low": "सत्रको सबैभन्दा न्यून कारोबार मूल्य; खुला, बन्द वा अन्तिम कारोबार मूल्यभन्दा बढी हुन सक्दैन।",
        "close": "आधिकारिक बन्द मूल्य। दैनिक OHLCV स्न्यापसट रेकर्ड गर्दा आवश्यक हुन्छ र जारी भएपछि दैनिक मूल्याङ्कनको आधिकारिक मूल्यका रूपमा प्रयोग हुन्छ।",
        "last": "बजार स्रोतले उपलब्ध गराएको अवस्थामा सत्रको अन्तिम कारोबार मूल्य।",
        "volume": "सत्रको कुल कारोबार परिमाण। वैध कारोबार-रहित सत्रका लागि शून्य मान्य छ।",
        "turnover": "बजार स्रोतले उपलब्ध गराएको अवस्थामा सत्रको कुल कारोबार मौद्रिक मूल्य।",
        "tradeCount": "सत्रमा सम्पन्न कारोबारहरूको संख्या; पूर्ण संख्या प्रविष्ट गर्नुहोस्।",
        "priceType": "यो मानले प्रतिनिधित्व गर्ने बजार अवलोकन छान्नुहोस्।",
        "price": "इन्स्ट्रुमेन्ट मुद्रामा अवलोकित मूल्य लेख्नुहोस्।",
        "correctionPriceType": "सच्याइँदै गरेको संग्रहित स्केलर अवलोकन। OHLCV मेट्रिकहरू स्वतन्त्र रूपमा संस्करणित अवलोकन हुन्।",
        "correctionPrice": "अभिलेखित मूल्य नै सच्याउनुपर्ने अवस्थामा मात्र परिवर्तन गर्नुहोस्।",
        "correctionReason": "स्रोत प्रमाण र विद्यमान अवलोकन किन गलत छ भन्ने वर्णन गर्नुहोस्।"
      },
      "section": {
        "scope": "अवलोकन सन्दर्भ",
        "scopeDescription": "अवलोकन समूहका लागि वित्तीय साधन, व्यवसाय मिति र आधिकारिक स्रोत एकपटक छान्नुहोस्।",
        "marketSnapshot": "दैनिक बजार अवलोकन",
        "marketSnapshotDescription": "विनिमय बजारमा कारोबार हुने साधनका लागि परम्परागत OHLCV सत्र मानहरू रेकर्ड गर्नुहोस्। कुनै दैनिक बजार मेट्रिक प्रविष्ट गर्दा बन्द मूल्य आवश्यक हुन्छ; ब्याकएन्डले उच्च/न्यून सुसंगतता जाँच्छ र हरेक मेट्रिकलाई अपरिवर्तनीय स्रोतयुक्त अवलोकनको रूपमा राख्छ।",
        "valuation": "छुट्टै मूल्याङ्कन मूल्य",
        "valuationDescription": "NAV आधारित, मूल्याङ्कित वा म्यानुअल रूपमा मूल्याङ्कन हुने साधनका लागि लागू नहुने OHLCV फिल्डहरू जबरजस्ती प्रयोग नगरी एकल नियन्त्रित मूल्य प्रकार र मान रेकर्ड गर्नुहोस्।",
        "observation": "मूल्य अवलोकन",
        "observationDescription": "नियन्त्रित इन्स्ट्रुमेन्ट, अवलोकन प्रकार, मूल्य, कारोबार मिति र स्रोत छान्नुहोस्।",
        "correction": "सच्याउने प्रमाण",
        "correctionDescription": "यो अवलोकन किन बदल्नुपर्छ स्पष्ट गर्नुहोस्। संशोधन संस्करण-जाँचसहित अडिटयोग्य हुन्छ।"
      },
      "priceType": {
        "OPEN": "खुला मूल्य",
        "HIGH": "उच्च",
        "LOW": "न्यून",
        "CLOSE": "बन्द मूल्य",
        "LAST": "अन्तिम कारोबार",
        "VOLUME": "परिमाण",
        "TURNOVER": "कारोबार रकम",
        "TRADE_COUNT": "कारोबार संख्या",
        "NAV": "NAV",
        "EVALUATED": "मूल्याङ्कित मूल्य",
        "MANUAL": "म्यानुअल मूल्याङ्कन",
        "BID": "बिड",
        "OFFER": "अफर"
      }
    }
  },
  "organization": {
    "regulatoryProfile": {
      "title": "नियामक प्रोफाइल",
      "description": "संस्थाको प्रमाणित नियामक पहिचान र प्रभावकारी इजाजतपत्र व्यवस्थापन गर्नुहोस्। प्रतिवेदन मितिमा सक्रिय इजाजतपत्र र स्वीकृत प्रतिवेदन ढाँचा लागू नभएसम्म नियामक फाइलिङ उपलब्ध हुँदैन।",
      "sections": {
        "identity": "फाइलिङ पहिचान",
        "licenses": "नियामक इजाजतपत्र"
      },
      "fields": {
        "expectedVersion": "रेकर्ड संस्करण",
        "panNumber": "प्यान नम्बर",
        "sebonRegistrationNumber": "सेबोन दर्ता नम्बर",
        "licenses": "इजाजतपत्रहरू",
        "authority": "नियामक निकाय",
        "licenseType": "इजाजतपत्र प्रकार",
        "licenseNumber": "इजाजतपत्र नम्बर",
        "status": "स्थिति",
        "effectiveFrom": "लागू हुने मिति",
        "effectiveTo": "लागू हुने अन्तिम मिति",
        "sourceReference": "स्रोत सन्दर्भ"
      },
      "help": {
        "panNumber": "संस्थाको नौ अङ्कको नेपाल प्यान प्रविष्ट गर्नुहोस्।",
        "licenses": "आधिकारिक नियामक स्रोतबाट प्रमाणित इजाजतपत्र मात्र थप्नुहोस्। मिति र स्थितिले नियामक प्रतिवेदन बनाउन मिल्ने वा नमिल्ने निर्धारण गर्छ।"
      },
      "validation": {
        "panNumber": "प्यान ठीक नौ अङ्कको हुनुपर्छ।"
      },
      "licenses": {
        "add": "इजाजतपत्र थप्नुहोस्",
        "remove": "इजाजतपत्र हटाउनुहोस्",
        "empty": "कुनै नियामक इजाजतपत्र अभिलेख गरिएको छैन।",
        "item": "इजाजतपत्र"
      },
      "actions": {
        "save": "नियामक प्रोफाइल सुरक्षित गर्नुहोस्"
      },
      "messages": {
        "saved": "नियामक प्रोफाइल अद्यावधिक भयो।"
      },
      "authority": {
        "IRD": "आन्तरिक राजस्व विभाग",
        "SEBON": "नेपाल धितोपत्र बोर्ड",
        "NRB": "नेपाल राष्ट्र बैंक",
        "FIU_NEPAL": "वित्तीय जानकारी इकाई नेपाल"
      },
      "licenseType": {
        "SEBON_PORTFOLIO_MANAGER": "सेबोन पोर्टफोलियो व्यवस्थापक",
        "SEBON_MERCHANT_BANKER": "सेबोन मर्चेन्ट बैंकर",
        "SEBON_SECURITIES_BROKER": "सेबोन धितोपत्र दलाल",
        "NRB_CLASS_A_BANK": "राष्ट्र बैंक वर्ग क बैंक",
        "NRB_CLASS_B_BANK": "राष्ट्र बैंक वर्ग ख बैंक",
        "NRB_CLASS_C_FINANCE": "राष्ट्र बैंक वर्ग ग वित्त कम्पनी",
        "NRB_CLASS_D_MICROFINANCE": "राष्ट्र बैंक वर्ग घ लघुवित्त",
        "NRB_PAYMENT_SERVICE_PROVIDER": "राष्ट्र बैंक भुक्तानी सेवा प्रदायक",
        "NRB_OTHER_LICENSED_ENTITY": "अन्य राष्ट्र बैंक इजाजतप्राप्त संस्था",
        "FIU_REPORTING_ENTITY": "एफआईयू प्रतिवेदन संस्था"
      },
      "status": {
        "ACTIVE": "सक्रिय",
        "SUSPENDED": "निलम्बित",
        "REVOKED": "खारेज",
        "EXPIRED": "म्याद समाप्त"
      }
    }
  },
  "a11y.form.platformOrganization.registration": "संस्था डिप्लोयमेन्ट दर्ता गर्नुहोस्",
  "a11y.action.platformOrganization.register": "संस्था डिप्लोयमेन्ट दर्ता गर्नुहोस्",
  "form.platformOrganization.registrationTitle": "संस्था डिप्लोयमेन्ट दर्ता",
  "form.platformOrganization.registrationDescription": "प्लेटफर्मको व्यावसायिक दर्ता र इजाजत योजना बनाउनुहोस्। हस्ताक्षरित इजाजत प्रमाणित भएपछि शाखा र पहिलो संस्था प्रशासक संस्था रनटाइममै स्थानीय रूपमा सिर्जना हुन्छन्।",
  "field.organization.licenses": "प्रारम्भिक इजाजत योजना",
  "platformOnboarding.section.identity": "संस्थाको पहिचान",
  "platformOnboarding.section.licenses": "PMS इजाजत योजना",
  "platformOnboarding.section.licensesDescription": "जारी पोर्टफोलियो व्यवस्थापन क्षमता समूह पूर्ण रूपमा इजाजत प्राप्त हुनुपर्छ। क्षमता र अवधि प्लेटफर्मले लागू गर्छ र संस्था रनटाइममा प्रक्षेपण गर्छ।",
  "platformOnboarding.license.add": "इजाजत थप्नुहोस्",
  "platformOnboarding.license.remove": "इजाजत हटाउनुहोस्",
  "platformOnboarding.license.empty": "इजाजत कन्फिगर गरिएको छैन",
  "platformOnboarding.license.item": "मोड्युल इजाजत",
  "platformOnboarding.license.module": "क्षमता",
  "platformOnboarding.license.maxBranches": "अधिकतम शाखा",
  "platformOnboarding.license.maxUsers": "अधिकतम प्रयोगकर्ता",
  "platformOnboarding.license.effectiveFrom": "लागू हुने मिति",
  "platformOnboarding.license.effectiveTo": "लागू रहने अन्तिम मिति",
  "platformOnboarding.license.graceEndsAt": "ग्रेस अवधि समाप्त",
  "platformOnboarding.action.register": "डिप्लोयमेन्ट दर्ता गर्नुहोस्",
  "platformOnboarding.registration.success": "संस्था डिप्लोयमेन्ट दर्ता भयो। संस्था रनटाइम सुरु गर्नु अघि इन्स्टलेसन क्रेडेन्सियल दर्ता पूरा गर्नुहोस्।",
  "platformOnboarding.registration.error": "संस्था डिप्लोयमेन्ट दर्ता हुन सकेन। व्यावसायिक प्रोफाइल र इजाजत योजना जाँचेर पुनः प्रयास गर्नुहोस्।",
  "form.platformOrganization.runtimeCredential.title": "संस्था रनटाइम दर्ता गर्नुहोस्",
  "form.platformOrganization.runtimeCredential.description": "संस्था रनटाइमका लागि एउटै इन्स्टलेसनमा बाँधिएको कन्ट्रोल-प्लेन क्रेडेन्सियल जारी गर्नुहोस्। गोप्य मान एक पटक मात्र देखाइन्छ र तुरुन्तै डिप्लोयमेन्ट सिक्रेट प्रदायकमा सुरक्षित गर्नुपर्छ।",
  "a11y.form.platformOrganization.runtimeCredential": "संस्था रनटाइम कन्ट्रोल-प्लेन क्रेडेन्सियल दर्ता गर्नुहोस्",
  "a11y.action.platformOrganization.runtimeCredential.enroll": "संस्था रनटाइम क्रेडेन्सियल जारी गर्नुहोस्",
  "platformOnboarding.runtimeCredential.section.security": "रनटाइम क्रेडेन्सियल सुरक्षा",
  "platformOnboarding.runtimeCredential.section.securityDescription": "यो क्रेडेन्सियललाई रनटाइमका ज्ञात स्रोत ठेगाना र छोटो रोटेसन अवधिमा सीमित गर्नुहोस्। अर्को इन्स्टलेसनमा प्रयोग गर्न सकिँदैन।",
  "platformOnboarding.runtimeCredential.allowedNetworks": "अनुमति प्राप्त स्रोत IP ठेगाना",
  "platformOnboarding.runtimeCredential.allowedNetworksHelp": "यस संस्था रनटाइमले प्रयोग गर्ने ठ्याक्कै सार्वजनिक वा निजी स्रोत IP ठेगाना थप्नुहोस्। यो दर्ता प्रवाहले CIDR दायरा स्वीकार गर्दैन।",
  "platformOnboarding.runtimeCredential.network.add": "स्रोत IP थप्नुहोस्",
  "platformOnboarding.runtimeCredential.network.remove": "स्रोत IP हटाउनुहोस्",
  "platformOnboarding.runtimeCredential.network.empty": "कम्तीमा एउटा स्रोत IP ठेगाना थप्नुहोस्।",
  "platformOnboarding.runtimeCredential.network.item": "स्रोत IP",
  "platformOnboarding.runtimeCredential.network.value": "IP ठेगाना",
  "platformOnboarding.runtimeCredential.network.placeholder": "203.0.113.10",
  "platformOnboarding.runtimeCredential.expiresAt": "क्रेडेन्सियल समाप्ति मिति",
  "platformOnboarding.runtimeCredential.expiresAtHelp": "आगामी ९० दिनभित्रको मिति छान्नुहोस्। समाप्त हुनु अघि क्रेडेन्सियल रोटेट गर्नुहोस्।",
  "platformOnboarding.runtimeCredential.action.enroll": "रनटाइम दर्ता गर्नुहोस्",
  "platformOnboarding.runtimeCredential.description": "इजाजत नवीकरण, प्रयोग ट्र्याकिङ र नियन्त्रित समर्थन सञ्चारका लागि आवश्यक इन्स्टलेसन-बाँधिएको क्रेडेन्सियल सिर्जना गर्नुहोस्।",
  "platformOnboarding.runtimeCredential.secret.title": "रनटाइम क्रेडेन्सियल गोप्य मान",
  "platformOnboarding.runtimeCredential.secret.warning": "यो गोप्य मान अहिले नै प्रतिलिपि गर्नुहोस्। फेरि देखाइने छैन।",
  "platformOnboarding.runtimeCredential.secret.copied": "रनटाइम क्रेडेन्सियल प्रतिलिपि भयो। यो दृश्य बन्द गर्नु अघि संस्था डिप्लोयमेन्ट सिक्रेट प्रदायकमा सुरक्षित गर्नुहोस्।",
  "dashboardWorkspace": {
    "actions": {
      "open": "कार्यस्थल खोल्नुहोस्",
      "manage": "व्यवस्थापन गर्नुहोस्",
      "openReports": "प्रतिवेदन खोल्नुहोस्"
    },
    "platform": {
      "title": "प्लेटफर्म अवलोकन",
      "subtitle": "संगठनको लगानी अभिलेख नदेखाई प्लेटफर्म सञ्चालन गर्नुहोस्।",
      "session": "साइन इन गरिएको प्लेटफर्म पहिचान",
      "adminScope": "तपाईंको प्लेटफर्म भूमिकाले प्लेटफर्म मेटाडाटा र सहायता पहुँच व्यवस्थापन गर्न सक्छ। संगठनको व्यावसायिक डाटा अलग रहन्छ।",
      "readerScope": "तपाईंको प्लेटफर्म भूमिका पढ्न मात्र मिल्ने र प्लेटफर्म सञ्चालन जानकारीमा सीमित छ।",
      "actionsTitle": "प्लेटफर्म कार्यस्थलहरू",
      "actionsDescription": "तपाईंको भूमिकाका लागि उपलब्ध प्लेटफर्म सतहमा जानुहोस्।",
      "administration": "प्लेटफर्म प्रशासन",
      "administrationDescription": "प्लेटफर्म मोड्युल, प्रयोगकर्ता, सहायता प्रतिनिधित्व, स्वास्थ्य र सुशासन व्यवस्थापन गर्नुहोस्।",
      "account": "खाता र प्राथमिकताहरू",
      "accountDescription": "आफ्नो प्रोफाइल, प्राथमिकता, पासवर्ड र सक्रिय सत्र व्यवस्थापन गर्नुहोस्।"
    },
    "client": {
      "title": "मेरो पोर्टफोलियो अवलोकन",
      "subtitle": "तपाईंको आफ्नै लगानी सम्बन्धको निजी, पढ्न मात्र मिल्ने दृश्य।",
      "scopeNotice": "तपाईंको ग्राहक पहिचानमा तोकिएका अभिलेख मात्र यहाँ उपलब्ध छन्। संगठन-व्यापी डाटा र प्रशासनिक कार्यहरू लुकेका छन्।",
      "organization": "संगठन",
      "accessMode": "पहुँच मोड",
      "readOnly": "पढ्न मात्र",
      "ownRecordsOnly": "तपाईंलाई तोकिएका अभिलेख मात्र",
      "reports": "मेरा प्रतिवेदन",
      "reportsDescription": "तपाईंको ग्राहक पहिचानका लागि उपलब्ध प्रतिवेदन कार्यस्थल समीक्षा गर्नुहोस्।"
    },
    "organization": {
      "partialData": "केही मूल्याङ्कन स्रोत उपलब्ध छैनन्। उपलब्ध अंकहरू आंशिक डाटाका रूपमा देखाइएका छन्।",
      "positions": "खुला स्थिति",
      "asOf": "{{date}} सम्म",
      "quickActions": "काम जारी राख्नुहोस्",
      "transactions": "कारोबार",
      "transactionsDescription": "लगानी कारोबार सिर्जना, समीक्षा र अगाडि बढाउनुहोस्।",
      "data": "डाटा हब",
      "dataDescription": "उपकरण, बजार तथ्य, मिलान र शासित डाटा कार्यप्रवाह व्यवस्थापन गर्नुहोस्।",
      "imports": "आयात केन्द्र",
      "importsDescription": "कारोबार, उपकरण वा बजार-डाटा फाइल अपलोड, प्रमाणीकरण, पूर्वावलोकन र प्रतिबद्ध गर्नुहोस्।",
      "team": "संगठन प्रशासन",
      "teamDescription": "प्रयोगकर्ता, भूमिका, पहुँच, ग्राहक, पोर्टफोलियो र अडिट गतिविधि व्यवस्थापन गर्नुहोस्।"
    }
  },
  "importsWorkspace": {
    "description": "शासित CSV डाटा अपलोड गर्नुहोस्, हरेक पङ्क्ति प्रमाणीकरण गर्नुहोस्, समस्या पूर्वावलोकन गर्नुहोस् र स्वीकृत अभिलेख मात्र प्रतिबद्ध गर्नुहोस्।",
    "dialog": {
      "guidance": "मिल्ने आयात प्रकार छान्नुहोस् र टेम्प्लेटका ठीक हेडर प्रयोग गरी CSV सामग्री टाँस्नुहोस्। अभिलेख प्रतिबद्ध गर्नुअघि कार्य पूर्वावलोकन गर्नुहोस्।",
      "templates": "CSV टेम्प्लेट डाउनलोड गर्नुहोस्"
    },
    "feedback": {
      "uploaded": "आयात कार्य अपलोड भयो। प्रतिबद्ध गर्नुअघि पूर्वावलोकन गर्नुहोस्।",
      "previewed": "आयात पूर्वावलोकन पूरा भयो।",
      "committed": "मान्य आयात पङ्क्तिहरू प्रतिबद्ध भए।",
      "recovered": "आयात पुनःप्राप्ति पूरा भयो।",
      "actionFailed": "आयात कार्य पूरा गर्न सकिएन। कार्य स्थिति र पङ्क्ति त्रुटि समीक्षा गर्नुहोस्।"
    },
    "errors": {
      "unsupportedCommand": "यो आयात आदेश समर्थित छैन।",
      "unsupportedType": "कारोबार, उपकरण वा बजार डाटा छान्नुहोस्।",
      "invalidCsv": "CSV गलत संरचनामा छ। उद्धरण, हेडर र स्तम्भ संख्या जाँच गर्नुहोस्।",
      "emptyCsv": "हेडर पङ्क्ति र कम्तीमा एउटा डाटा पङ्क्ति थप्नुहोस्।"
    }
  },
  "tableExport": {
    "completed": "निर्यात डाउनलोड भयो।",
    "failed": "निर्यात पूरा हुन सकेन। फिल्टर जाँच गर्नुहोस् वा सानो नतिजा सेट प्रयास गर्नुहोस्।",
    "unavailable": "हालको तालिका र दायराका लागि यो निर्यात विकल्प उपलब्ध छैन।",
    "title": "{{resource}} निर्यात गर्नुहोस्",
    "description": "के र कुन ढाँचामा निर्यात गर्ने छनोट गर्नुहोस्।",
    "action": "निर्यात गर्नुहोस्",
    "asyncHint": "{{threshold}} भन्दा बढी पङ्क्तिका निर्यातहरू पृष्ठभूमिमा प्रशोधन हुन्छन्।",
    "records": {
      "title": "रेकर्डहरू"
    },
    "scope": {
      "all": "सबै रेकर्डहरू",
      "allCount": "सबै {{count}} रेकर्डहरू",
      "filtered": "हालको फिल्टर गरिएका परिणामहरू",
      "filteredCount": "हालको फिल्टर गरिएका परिणामहरू — {{count}}",
      "selected": "छनोट गरिएका पङ्क्तिहरू",
      "selectedCount": "छनोट गरिएका पङ्क्तिहरू — {{count}}"
    },
    "fields": {
      "title": "फिल्डहरू",
      "recommended": "सिफारिस गरिएका फिल्डहरू",
      "current": "हालका तालिका स्तम्भहरू",
      "custom": "फिल्डहरू छान्नुहोस्",
      "search": "फिल्डहरू खोज्नुहोस्…",
      "selectRecommended": "सिफारिस छान्नुहोस्",
      "selectAll": "सबै छान्नुहोस्",
      "clear": "हटाउनुहोस्",
      "selectedCount": "{{total}} मध्ये {{count}} छनोट गरिएको"
    },
    "format": {
      "title": "ढाँचा"
    }
  }
}
